/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(77);
	
	__webpack_require__(80);
	
	__webpack_require__(82);
	
	__webpack_require__(92);
	
	__webpack_require__(94);
	
	__webpack_require__(96);
	
	__webpack_require__(98);
	
	__webpack_require__(100);
	
	__webpack_require__(102);
	
	__webpack_require__(104);
	
	__webpack_require__(106);
	
	__webpack_require__(110);
	
	__webpack_require__(112);
	
	__webpack_require__(114);
	
	__webpack_require__(116);
	
	__webpack_require__(118);
	
	__webpack_require__(120);
	
	__webpack_require__(122);
	
	__webpack_require__(126);
	
	__webpack_require__(128);
	
	__webpack_require__(130);
	
	__webpack_require__(132);
	
	__webpack_require__(134);
	
	__webpack_require__(136);
	
	__webpack_require__(138);
	
	__webpack_require__(140);
	
	var _ribbon = __webpack_require__(142);
	
	var _ribbon2 = _interopRequireDefault(_ribbon);
	
	var _fsForms = __webpack_require__(143);
	
	var _fsForms2 = _interopRequireDefault(_fsForms);
	
	var _grid = __webpack_require__(144);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _grid3 = __webpack_require__(145);
	
	var _grid4 = _interopRequireDefault(_grid3);
	
	__webpack_require__(146);
	
	__webpack_require__(156);
	
	__webpack_require__(158);
	
	__webpack_require__(160);
	
	var _MetadataLogicConfigurator = __webpack_require__(162);
	
	var _MetadataLogicConfigurator2 = _interopRequireDefault(_MetadataLogicConfigurator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Form live validation
	 */
	
	
	/**
	 * Bootstrap
	 */
	
	// table head fixer
	
	// chosen
	
	// spin
	
	// drag table
	
	// migrate
	
	// ui
	$(function () {
	  // initialization components
	  $.nette.init();
	  _fsForms2.default.init();
	  _grid2.default.init();
	  _grid4.default.initAll();
	  _ribbon2.default.init();
	  _MetadataLogicConfigurator2.default.createDocumentControlsInit();
	  _MetadataLogicConfigurator2.default.singleEditDocumentControlsInit();
	  _MetadataLogicConfigurator2.default.bulkEditDocumentsControlsInit();
	
	  // check fot duplicite init
	  if (window.FSForms) {
	    console.log('%c FormFlow ERROR! Duplicite loading of JS, probably by AJAX!', 'background: red; color: white');
	  }
	
	  // set global properties
	  window.FSForms = _fsForms2.default;
	  window.FSGrid = _grid2.default;
	  window.FSGridSnippet = _grid4.default;
	
	  $(document).ajaxComplete(function () {
	    _MetadataLogicConfigurator2.default.createDocumentControlsInit();
	    _MetadataLogicConfigurator2.default.singleEditDocumentControlsInit();
	    _MetadataLogicConfigurator2.default.bulkEditDocumentsControlsInit();
	  });
	});
	
	/**
	 * Metadata Logic
	 */
	
	
	/**
	 * LESS
	 */
	
	
	/**
	 * FFS
	 */
	
	
	/**
	 * Tree
	 */
	
	
	/**
	 * Nette
	 */
	
	// daterangepicker
	
	// eonasdan bootstrap datetimepicker
	
	// file input
	
	
	/**
	 * Moment.js
	 */
	
	// checkboxes
	
	// table sorter
	/**
	 * JQuery
	 */

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(79))

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	module.exports = function(src) {
		if (typeof execScript !== "undefined")
			execScript(src);
		else
			eval.call(null, src);
	}


/***/ }),
/* 79 */
/***/ (function(module, exports) {

	module.exports = "!function(e,t){\"object\"==typeof module&&\"object\"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error(\"jQuery requires a window with a document\");return t(e)}:t(e)}(\"undefined\"!=typeof window?window:this,function(e,t){function n(e){var t=e.length,n=re.type(e);return\"function\"!==n&&!re.isWindow(e)&&(!(1!==e.nodeType||!t)||(\"array\"===n||0===t||\"number\"==typeof t&&t>0&&t-1 in e))}function r(e,t,n){if(re.isFunction(t))return re.grep(e,function(e,r){return!!t.call(e,r,e)!==n});if(t.nodeType)return re.grep(e,function(e){return e===t!==n});if(\"string\"==typeof t){if(fe.test(t))return re.filter(t,e,n);t=re.filter(t,e)}return re.grep(e,function(e){return re.inArray(e,t)>=0!==n})}function i(e,t){do{e=e[t]}while(e&&1!==e.nodeType);return e}function o(e){var t=ye[e]={};return re.each(e.match(ve)||[],function(e,n){t[n]=!0}),t}function a(){pe.addEventListener?(pe.removeEventListener(\"DOMContentLoaded\",s,!1),e.removeEventListener(\"load\",s,!1)):(pe.detachEvent(\"onreadystatechange\",s),e.detachEvent(\"onload\",s))}function s(){(pe.addEventListener||\"load\"===event.type||\"complete\"===pe.readyState)&&(a(),re.ready())}function l(e,t,n){if(void 0===n&&1===e.nodeType){var r=\"data-\"+t.replace(Ce,\"-$1\").toLowerCase();if(\"string\"==typeof(n=e.getAttribute(r))){try{n=\"true\"===n||\"false\"!==n&&(\"null\"===n?null:+n+\"\"===n?+n:Te.test(n)?re.parseJSON(n):n)}catch(e){}re.data(e,t,n)}else n=void 0}return n}function u(e){var t;for(t in e)if((\"data\"!==t||!re.isEmptyObject(e[t]))&&\"toJSON\"!==t)return!1;return!0}function c(e,t,n,r){if(re.acceptData(e)){var i,o,a=re.expando,s=e.nodeType,l=s?re.cache:e,u=s?e[a]:e[a]&&a;if(u&&l[u]&&(r||l[u].data)||void 0!==n||\"string\"!=typeof t)return u||(u=s?e[a]=J.pop()||re.guid++:a),l[u]||(l[u]=s?{}:{toJSON:re.noop}),\"object\"!=typeof t&&\"function\"!=typeof t||(r?l[u]=re.extend(l[u],t):l[u].data=re.extend(l[u].data,t)),o=l[u],r||(o.data||(o.data={}),o=o.data),void 0!==n&&(o[re.camelCase(t)]=n),\"string\"==typeof t?null==(i=o[t])&&(i=o[re.camelCase(t)]):i=o,i}}function f(e,t,n){if(re.acceptData(e)){var r,i,o=e.nodeType,a=o?re.cache:e,s=o?e[re.expando]:re.expando;if(a[s]){if(t&&(r=n?a[s]:a[s].data)){re.isArray(t)?t=t.concat(re.map(t,re.camelCase)):t in r?t=[t]:(t=re.camelCase(t),t=t in r?[t]:t.split(\" \")),i=t.length;for(;i--;)delete r[t[i]];if(n?!u(r):!re.isEmptyObject(r))return}(n||(delete a[s].data,u(a[s])))&&(o?re.cleanData([e],!0):ne.deleteExpando||a!=a.window?delete a[s]:a[s]=null)}}}function d(){return!0}function p(){return!1}function h(){try{return pe.activeElement}catch(e){}}function m(e){var t=_e.split(\"|\"),n=e.createDocumentFragment();if(n.createElement)for(;t.length;)n.createElement(t.pop());return n}function g(e,t){var n,r,i=0,o=typeof e.getElementsByTagName!==we?e.getElementsByTagName(t||\"*\"):typeof e.querySelectorAll!==we?e.querySelectorAll(t||\"*\"):void 0;if(!o)for(o=[],n=e.childNodes||e;null!=(r=n[i]);i++)!t||re.nodeName(r,t)?o.push(r):re.merge(o,g(r,t));return void 0===t||t&&re.nodeName(e,t)?re.merge([e],o):o}function v(e){Ae.test(e.type)&&(e.defaultChecked=e.checked)}function y(e,t){return re.nodeName(e,\"table\")&&re.nodeName(11!==t.nodeType?t:t.firstChild,\"tr\")?e.getElementsByTagName(\"tbody\")[0]||e.appendChild(e.ownerDocument.createElement(\"tbody\")):e}function b(e){return e.type=(null!==re.find.attr(e,\"type\"))+\"/\"+e.type,e}function x(e){var t=Xe.exec(e.type);return t?e.type=t[1]:e.removeAttribute(\"type\"),e}function w(e,t){for(var n,r=0;null!=(n=e[r]);r++)re._data(n,\"globalEval\",!t||re._data(t[r],\"globalEval\"))}function T(e,t){if(1===t.nodeType&&re.hasData(e)){var n,r,i,o=re._data(e),a=re._data(t,o),s=o.events;if(s){delete a.handle,a.events={};for(n in s)for(r=0,i=s[n].length;r<i;r++)re.event.add(t,n,s[n][r])}a.data&&(a.data=re.extend({},a.data))}}function C(e,t){var n,r,i;if(1===t.nodeType){if(n=t.nodeName.toLowerCase(),!ne.noCloneEvent&&t[re.expando]){i=re._data(t);for(r in i.events)re.removeEvent(t,r,i.handle);t.removeAttribute(re.expando)}\"script\"===n&&t.text!==e.text?(b(t).text=e.text,x(t)):\"object\"===n?(t.parentNode&&(t.outerHTML=e.outerHTML),ne.html5Clone&&e.innerHTML&&!re.trim(t.innerHTML)&&(t.innerHTML=e.innerHTML)):\"input\"===n&&Ae.test(e.type)?(t.defaultChecked=t.checked=e.checked,t.value!==e.value&&(t.value=e.value)):\"option\"===n?t.defaultSelected=t.selected=e.defaultSelected:\"input\"!==n&&\"textarea\"!==n||(t.defaultValue=e.defaultValue)}}function N(t,n){var r,i=re(n.createElement(t)).appendTo(n.body),o=e.getDefaultComputedStyle&&(r=e.getDefaultComputedStyle(i[0]))?r.display:re.css(i[0],\"display\");return i.detach(),o}function E(e){var t=pe,n=Qe[e];return n||(n=N(e,t),\"none\"!==n&&n||(Ge=(Ge||re(\"<iframe frameborder='0' width='0' height='0'/>\")).appendTo(t.documentElement),t=(Ge[0].contentWindow||Ge[0].contentDocument).document,t.write(),t.close(),n=N(e,t),Ge.detach()),Qe[e]=n),n}function k(e,t){return{get:function(){var n=e();if(null!=n)return n?void delete this.get:(this.get=t).apply(this,arguments)}}}function S(e,t){if(t in e)return t;for(var n=t.charAt(0).toUpperCase()+t.slice(1),r=t,i=ct.length;i--;)if((t=ct[i]+n)in e)return t;return r}function A(e,t){for(var n,r,i,o=[],a=0,s=e.length;a<s;a++)r=e[a],r.style&&(o[a]=re._data(r,\"olddisplay\"),n=r.style.display,t?(o[a]||\"none\"!==n||(r.style.display=\"\"),\"\"===r.style.display&&ke(r)&&(o[a]=re._data(r,\"olddisplay\",E(r.nodeName)))):(i=ke(r),(n&&\"none\"!==n||!i)&&re._data(r,\"olddisplay\",i?n:re.css(r,\"display\"))));for(a=0;a<s;a++)r=e[a],r.style&&(t&&\"none\"!==r.style.display&&\"\"!==r.style.display||(r.style.display=t?o[a]||\"\":\"none\"));return e}function D(e,t,n){var r=at.exec(t);return r?Math.max(0,r[1]-(n||0))+(r[2]||\"px\"):t}function j(e,t,n,r,i){for(var o=n===(r?\"border\":\"content\")?4:\"width\"===t?1:0,a=0;o<4;o+=2)\"margin\"===n&&(a+=re.css(e,n+Ee[o],!0,i)),r?(\"content\"===n&&(a-=re.css(e,\"padding\"+Ee[o],!0,i)),\"margin\"!==n&&(a-=re.css(e,\"border\"+Ee[o]+\"Width\",!0,i))):(a+=re.css(e,\"padding\"+Ee[o],!0,i),\"padding\"!==n&&(a+=re.css(e,\"border\"+Ee[o]+\"Width\",!0,i)));return a}function L(e,t,n){var r=!0,i=\"width\"===t?e.offsetWidth:e.offsetHeight,o=Ke(e),a=ne.boxSizing&&\"border-box\"===re.css(e,\"boxSizing\",!1,o);if(i<=0||null==i){if(i=Ze(e,t,o),(i<0||null==i)&&(i=e.style[t]),tt.test(i))return i;r=a&&(ne.boxSizingReliable()||i===e.style[t]),i=parseFloat(i)||0}return i+j(e,t,n||(a?\"border\":\"content\"),r,o)+\"px\"}function H(e,t,n,r,i){return new H.prototype.init(e,t,n,r,i)}function q(){return setTimeout(function(){ft=void 0}),ft=re.now()}function _(e,t){var n,r={height:e},i=0;for(t=t?1:0;i<4;i+=2-t)n=Ee[i],r[\"margin\"+n]=r[\"padding\"+n]=e;return t&&(r.opacity=r.width=e),r}function M(e,t,n){for(var r,i=(vt[t]||[]).concat(vt[\"*\"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function F(e,t,n){var r,i,o,a,s,l,u,c=this,f={},d=e.style,p=e.nodeType&&ke(e),h=re._data(e,\"fxshow\");n.queue||(s=re._queueHooks(e,\"fx\"),null==s.unqueued&&(s.unqueued=0,l=s.empty.fire,s.empty.fire=function(){s.unqueued||l()}),s.unqueued++,c.always(function(){c.always(function(){s.unqueued--,re.queue(e,\"fx\").length||s.empty.fire()})})),1===e.nodeType&&(\"height\"in t||\"width\"in t)&&(n.overflow=[d.overflow,d.overflowX,d.overflowY],u=re.css(e,\"display\"),\"inline\"===(\"none\"===u?re._data(e,\"olddisplay\")||E(e.nodeName):u)&&\"none\"===re.css(e,\"float\")&&(ne.inlineBlockNeedsLayout&&\"inline\"!==E(e.nodeName)?d.zoom=1:d.display=\"inline-block\")),n.overflow&&(d.overflow=\"hidden\",ne.shrinkWrapBlocks()||c.always(function(){d.overflow=n.overflow[0],d.overflowX=n.overflow[1],d.overflowY=n.overflow[2]}));for(r in t)if(i=t[r],pt.exec(i)){if(delete t[r],o=o||\"toggle\"===i,i===(p?\"hide\":\"show\")){if(\"show\"!==i||!h||void 0===h[r])continue;p=!0}f[r]=h&&h[r]||re.style(e,r)}else u=void 0;if(re.isEmptyObject(f))\"inline\"===(\"none\"===u?E(e.nodeName):u)&&(d.display=u);else{h?\"hidden\"in h&&(p=h.hidden):h=re._data(e,\"fxshow\",{}),o&&(h.hidden=!p),p?re(e).show():c.done(function(){re(e).hide()}),c.done(function(){var t;re._removeData(e,\"fxshow\");for(t in f)re.style(e,t,f[t])});for(r in f)a=M(p?h[r]:0,r,c),r in h||(h[r]=a.start,p&&(a.end=a.start,a.start=\"width\"===r||\"height\"===r?1:0))}}function O(e,t){var n,r,i,o,a;for(n in e)if(r=re.camelCase(n),i=t[r],o=e[n],re.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=re.cssHooks[r])&&\"expand\"in a){o=a.expand(o),delete e[r];for(n in o)n in e||(e[n]=o[n],t[n]=i)}else t[r]=i}function B(e,t,n){var r,i,o=0,a=gt.length,s=re.Deferred().always(function(){delete l.elem}),l=function(){if(i)return!1;for(var t=ft||q(),n=Math.max(0,u.startTime+u.duration-t),r=n/u.duration||0,o=1-r,a=0,l=u.tweens.length;a<l;a++)u.tweens[a].run(o);return s.notifyWith(e,[u,o,n]),o<1&&l?n:(s.resolveWith(e,[u]),!1)},u=s.promise({elem:e,props:re.extend({},t),opts:re.extend(!0,{specialEasing:{}},n),originalProperties:t,originalOptions:n,startTime:ft||q(),duration:n.duration,tweens:[],createTween:function(t,n){var r=re.Tween(e,u.opts,t,n,u.opts.specialEasing[t]||u.opts.easing);return u.tweens.push(r),r},stop:function(t){var n=0,r=t?u.tweens.length:0;if(i)return this;for(i=!0;n<r;n++)u.tweens[n].run(1);return t?s.resolveWith(e,[u,t]):s.rejectWith(e,[u,t]),this}}),c=u.props;for(O(c,u.opts.specialEasing);o<a;o++)if(r=gt[o].call(u,e,c,u.opts))return r;return re.map(c,M,u),re.isFunction(u.opts.start)&&u.opts.start.call(e,u),re.fx.timer(re.extend(l,{elem:e,anim:u,queue:u.opts.queue})),u.progress(u.opts.progress).done(u.opts.done,u.opts.complete).fail(u.opts.fail).always(u.opts.always)}function P(e){return function(t,n){\"string\"!=typeof t&&(n=t,t=\"*\");var r,i=0,o=t.toLowerCase().match(ve)||[];if(re.isFunction(n))for(;r=o[i++];)\"+\"===r.charAt(0)?(r=r.slice(1)||\"*\",(e[r]=e[r]||[]).unshift(n)):(e[r]=e[r]||[]).push(n)}}function R(e,t,n,r){function i(s){var l;return o[s]=!0,re.each(e[s]||[],function(e,s){var u=s(t,n,r);return\"string\"!=typeof u||a||o[u]?a?!(l=u):void 0:(t.dataTypes.unshift(u),i(u),!1)}),l}var o={},a=e===Wt;return i(t.dataTypes[0])||!o[\"*\"]&&i(\"*\")}function W(e,t){var n,r,i=re.ajaxSettings.flatOptions||{};for(r in t)void 0!==t[r]&&((i[r]?e:n||(n={}))[r]=t[r]);return n&&re.extend(!0,e,n),e}function $(e,t,n){for(var r,i,o,a,s=e.contents,l=e.dataTypes;\"*\"===l[0];)l.shift(),void 0===i&&(i=e.mimeType||t.getResponseHeader(\"Content-Type\"));if(i)for(a in s)if(s[a]&&s[a].test(i)){l.unshift(a);break}if(l[0]in n)o=l[0];else{for(a in n){if(!l[0]||e.converters[a+\" \"+l[0]]){o=a;break}r||(r=a)}o=o||r}if(o)return o!==l[0]&&l.unshift(o),n[o]}function z(e,t,n,r){var i,o,a,s,l,u={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)u[a.toLowerCase()]=e.converters[a];for(o=c.shift();o;)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!l&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),l=o,o=c.shift())if(\"*\"===o)o=l;else if(\"*\"!==l&&l!==o){if(!(a=u[l+\" \"+o]||u[\"* \"+o]))for(i in u)if(s=i.split(\" \"),s[1]===o&&(a=u[l+\" \"+s[0]]||u[\"* \"+s[0]])){!0===a?a=u[i]:!0!==u[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e.throws)t=a(t);else try{t=a(t)}catch(e){return{state:\"parsererror\",error:a?e:\"No conversion from \"+l+\" to \"+o}}}return{state:\"success\",data:t}}function I(e,t,n,r){var i;if(re.isArray(t))re.each(t,function(t,i){n||It.test(e)?r(e,i):I(e+\"[\"+(\"object\"==typeof i?t:\"\")+\"]\",i,n,r)});else if(n||\"object\"!==re.type(t))r(e,t);else for(i in t)I(e+\"[\"+i+\"]\",t[i],n,r)}function X(){try{return new e.XMLHttpRequest}catch(e){}}function U(){try{return new e.ActiveXObject(\"Microsoft.XMLHTTP\")}catch(e){}}function V(e){return re.isWindow(e)?e:9===e.nodeType&&(e.defaultView||e.parentWindow)}var J=[],Y=J.slice,G=J.concat,Q=J.push,K=J.indexOf,Z={},ee=Z.toString,te=Z.hasOwnProperty,ne={},re=function(e,t){return new re.fn.init(e,t)},ie=/^[\\s\\uFEFF\\xA0]+|[\\s\\uFEFF\\xA0]+$/g,oe=/^-ms-/,ae=/-([\\da-z])/gi,se=function(e,t){return t.toUpperCase()};re.fn=re.prototype={jquery:\"1.11.2\",constructor:re,selector:\"\",length:0,toArray:function(){return Y.call(this)},get:function(e){return null!=e?e<0?this[e+this.length]:this[e]:Y.call(this)},pushStack:function(e){var t=re.merge(this.constructor(),e);return t.prevObject=this,t.context=this.context,t},each:function(e,t){return re.each(this,e,t)},map:function(e){return this.pushStack(re.map(this,function(t,n){return e.call(t,n,t)}))},slice:function(){return this.pushStack(Y.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(n>=0&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor(null)},push:Q,sort:J.sort,splice:J.splice},re.extend=re.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,l=arguments.length,u=!1;for(\"boolean\"==typeof a&&(u=a,a=arguments[s]||{},s++),\"object\"==typeof a||re.isFunction(a)||(a={}),s===l&&(a=this,s--);s<l;s++)if(null!=(i=arguments[s]))for(r in i)e=a[r],n=i[r],a!==n&&(u&&n&&(re.isPlainObject(n)||(t=re.isArray(n)))?(t?(t=!1,o=e&&re.isArray(e)?e:[]):o=e&&re.isPlainObject(e)?e:{},a[r]=re.extend(u,o,n)):void 0!==n&&(a[r]=n));return a},re.extend({expando:\"jQuery\"+(\"1.11.2\"+Math.random()).replace(/\\D/g,\"\"),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isFunction:function(e){return\"function\"===re.type(e)},isArray:Array.isArray||function(e){return\"array\"===re.type(e)},isWindow:function(e){return null!=e&&e==e.window},isNumeric:function(e){return!re.isArray(e)&&e-parseFloat(e)+1>=0},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},isPlainObject:function(e){var t;if(!e||\"object\"!==re.type(e)||e.nodeType||re.isWindow(e))return!1;try{if(e.constructor&&!te.call(e,\"constructor\")&&!te.call(e.constructor.prototype,\"isPrototypeOf\"))return!1}catch(e){return!1}if(ne.ownLast)for(t in e)return te.call(e,t);for(t in e);return void 0===t||te.call(e,t)},type:function(e){return null==e?e+\"\":\"object\"==typeof e||\"function\"==typeof e?Z[ee.call(e)]||\"object\":typeof e},globalEval:function(t){t&&re.trim(t)&&(e.execScript||function(t){e.eval.call(e,t)})(t)},camelCase:function(e){return e.replace(oe,\"ms-\").replace(ae,se)},nodeName:function(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()},each:function(e,t,r){var i=0,o=e.length,a=n(e);if(r){if(a)for(;i<o&&!1!==t.apply(e[i],r);i++);else for(i in e)if(!1===t.apply(e[i],r))break}else if(a)for(;i<o&&!1!==t.call(e[i],i,e[i]);i++);else for(i in e)if(!1===t.call(e[i],i,e[i]))break;return e},trim:function(e){return null==e?\"\":(e+\"\").replace(ie,\"\")},makeArray:function(e,t){var r=t||[];return null!=e&&(n(Object(e))?re.merge(r,\"string\"==typeof e?[e]:e):Q.call(r,e)),r},inArray:function(e,t,n){var r;if(t){if(K)return K.call(t,e,n);for(r=t.length,n=n?n<0?Math.max(0,r+n):n:0;n<r;n++)if(n in t&&t[n]===e)return n}return-1},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;)e[i++]=t[r++];if(n!==n)for(;void 0!==t[r];)e[i++]=t[r++];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,r){var i,o=0,a=e.length,s=n(e),l=[];if(s)for(;o<a;o++)null!=(i=t(e[o],o,r))&&l.push(i);else for(o in e)null!=(i=t(e[o],o,r))&&l.push(i);return G.apply([],l)},guid:1,proxy:function(e,t){var n,r,i;if(\"string\"==typeof t&&(i=e[t],t=e,e=i),re.isFunction(e))return n=Y.call(arguments,2),r=function(){return e.apply(t||this,n.concat(Y.call(arguments)))},r.guid=e.guid=e.guid||re.guid++,r},now:function(){return+new Date},support:ne}),re.each(\"Boolean Number String Function Array Date RegExp Object Error\".split(\" \"),function(e,t){Z[\"[object \"+t+\"]\"]=t.toLowerCase()});var le=function(e){function t(e,t,n,r){var i,o,a,s,u,f,d,p,h,m;if((t?t.ownerDocument||t:B)!==j&&D(t),t=t||j,n=n||[],s=t.nodeType,\"string\"!=typeof e||!e||1!==s&&9!==s&&11!==s)return n;if(!r&&H){if(11!==s&&(i=ge.exec(e)))if(a=i[1]){if(9===s){if(!(o=t.getElementById(a))||!o.parentNode)return n;if(o.id===a)return n.push(o),n}else if(t.ownerDocument&&(o=t.ownerDocument.getElementById(a))&&F(t,o)&&o.id===a)return n.push(o),n}else{if(i[2])return G.apply(n,t.getElementsByTagName(e)),n;if((a=i[3])&&b.getElementsByClassName)return G.apply(n,t.getElementsByClassName(a)),n}if(b.qsa&&(!q||!q.test(e))){if(p=d=O,h=t,m=1!==s&&e,1===s&&\"object\"!==t.nodeName.toLowerCase()){for(f=C(e),(d=t.getAttribute(\"id\"))?p=d.replace(ye,\"\\\\$&\"):t.setAttribute(\"id\",p),p=\"[id='\"+p+\"'] \",u=f.length;u--;)f[u]=p+c(f[u]);h=ve.test(e)&&l(t.parentNode)||t,m=f.join(\",\")}if(m)try{return G.apply(n,h.querySelectorAll(m)),n}catch(e){}finally{d||t.removeAttribute(\"id\")}}}return E(e.replace(ae,\"$1\"),t,n,r)}function n(){function e(n,r){return t.push(n+\" \")>x.cacheLength&&delete e[t.shift()],e[n+\" \"]=r}var t=[];return e}function r(e){return e[O]=!0,e}function i(e){var t=j.createElement(\"div\");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function o(e,t){for(var n=e.split(\"|\"),r=e.length;r--;)x.attrHandle[n[r]]=t}function a(e,t){var n=t&&e,r=n&&1===e.nodeType&&1===t.nodeType&&(~t.sourceIndex||X)-(~e.sourceIndex||X);if(r)return r;if(n)for(;n=n.nextSibling;)if(n===t)return-1;return e?1:-1}function s(e){return r(function(t){return t=+t,r(function(n,r){for(var i,o=e([],n.length,t),a=o.length;a--;)n[i=o[a]]&&(n[i]=!(r[i]=n[i]))})})}function l(e){return e&&void 0!==e.getElementsByTagName&&e}function u(){}function c(e){for(var t=0,n=e.length,r=\"\";t<n;t++)r+=e[t].value;return r}function f(e,t,n){var r=t.dir,i=n&&\"parentNode\"===r,o=R++;return t.first?function(t,n,o){for(;t=t[r];)if(1===t.nodeType||i)return e(t,n,o)}:function(t,n,a){var s,l,u=[P,o];if(a){for(;t=t[r];)if((1===t.nodeType||i)&&e(t,n,a))return!0}else for(;t=t[r];)if(1===t.nodeType||i){if(l=t[O]||(t[O]={}),(s=l[r])&&s[0]===P&&s[1]===o)return u[2]=s[2];if(l[r]=u,u[2]=e(t,n,a))return!0}}}function d(e){return e.length>1?function(t,n,r){for(var i=e.length;i--;)if(!e[i](t,n,r))return!1;return!0}:e[0]}function p(e,n,r){for(var i=0,o=n.length;i<o;i++)t(e,n[i],r);return r}function h(e,t,n,r,i){for(var o,a=[],s=0,l=e.length,u=null!=t;s<l;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),u&&t.push(s)));return a}function m(e,t,n,i,o,a){return i&&!i[O]&&(i=m(i)),o&&!o[O]&&(o=m(o,a)),r(function(r,a,s,l){var u,c,f,d=[],m=[],g=a.length,v=r||p(t||\"*\",s.nodeType?[s]:s,[]),y=!e||!r&&t?v:h(v,d,e,s,l),b=n?o||(r?e:g||i)?[]:a:y;if(n&&n(y,b,s,l),i)for(u=h(b,m),i(u,[],s,l),c=u.length;c--;)(f=u[c])&&(b[m[c]]=!(y[m[c]]=f));if(r){if(o||e){if(o){for(u=[],c=b.length;c--;)(f=b[c])&&u.push(y[c]=f);o(null,b=[],u,l)}for(c=b.length;c--;)(f=b[c])&&(u=o?K(r,f):d[c])>-1&&(r[u]=!(a[u]=f))}}else b=h(b===a?b.splice(g,b.length):b),o?o(null,a,b,l):G.apply(a,b)})}function g(e){for(var t,n,r,i=e.length,o=x.relative[e[0].type],a=o||x.relative[\" \"],s=o?1:0,l=f(function(e){return e===t},a,!0),u=f(function(e){return K(t,e)>-1},a,!0),p=[function(e,n,r){var i=!o&&(r||n!==k)||((t=n).nodeType?l(e,n,r):u(e,n,r));return t=null,i}];s<i;s++)if(n=x.relative[e[s].type])p=[f(d(p),n)];else{if(n=x.filter[e[s].type].apply(null,e[s].matches),n[O]){for(r=++s;r<i&&!x.relative[e[r].type];r++);return m(s>1&&d(p),s>1&&c(e.slice(0,s-1).concat({value:\" \"===e[s-2].type?\"*\":\"\"})).replace(ae,\"$1\"),n,s<r&&g(e.slice(s,r)),r<i&&g(e=e.slice(r)),r<i&&c(e))}p.push(n)}return d(p)}function v(e,n){var i=n.length>0,o=e.length>0,a=function(r,a,s,l,u){var c,f,d,p=0,m=\"0\",g=r&&[],v=[],y=k,b=r||o&&x.find.TAG(\"*\",u),w=P+=null==y?1:Math.random()||.1,T=b.length;for(u&&(k=a!==j&&a);m!==T&&null!=(c=b[m]);m++){if(o&&c){for(f=0;d=e[f++];)if(d(c,a,s)){l.push(c);break}u&&(P=w)}i&&((c=!d&&c)&&p--,r&&g.push(c))}if(p+=m,i&&m!==p){for(f=0;d=n[f++];)d(g,v,a,s);if(r){if(p>0)for(;m--;)g[m]||v[m]||(v[m]=J.call(l));v=h(v)}G.apply(l,v),u&&!r&&v.length>0&&p+n.length>1&&t.uniqueSort(l)}return u&&(P=w,k=y),g};return i?r(a):a}var y,b,x,w,T,C,N,E,k,S,A,D,j,L,H,q,_,M,F,O=\"sizzle\"+1*new Date,B=e.document,P=0,R=0,W=n(),$=n(),z=n(),I=function(e,t){return e===t&&(A=!0),0},X=1<<31,U={}.hasOwnProperty,V=[],J=V.pop,Y=V.push,G=V.push,Q=V.slice,K=function(e,t){for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return-1},Z=\"checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped\",ee=\"[\\\\x20\\\\t\\\\r\\\\n\\\\f]\",te=\"(?:\\\\\\\\.|[\\\\w-]|[^\\\\x00-\\\\xa0])+\",ne=te.replace(\"w\",\"w#\"),re=\"\\\\[\"+ee+\"*(\"+te+\")(?:\"+ee+\"*([*^$|!~]?=)\"+ee+\"*(?:'((?:\\\\\\\\.|[^\\\\\\\\'])*)'|\\\"((?:\\\\\\\\.|[^\\\\\\\\\\\"])*)\\\"|(\"+ne+\"))|)\"+ee+\"*\\\\]\",ie=\":(\"+te+\")(?:\\\\((('((?:\\\\\\\\.|[^\\\\\\\\'])*)'|\\\"((?:\\\\\\\\.|[^\\\\\\\\\\\"])*)\\\")|((?:\\\\\\\\.|[^\\\\\\\\()[\\\\]]|\"+re+\")*)|.*)\\\\)|)\",oe=new RegExp(ee+\"+\",\"g\"),ae=new RegExp(\"^\"+ee+\"+|((?:^|[^\\\\\\\\])(?:\\\\\\\\.)*)\"+ee+\"+$\",\"g\"),se=new RegExp(\"^\"+ee+\"*,\"+ee+\"*\"),le=new RegExp(\"^\"+ee+\"*([>+~]|\"+ee+\")\"+ee+\"*\"),ue=new RegExp(\"=\"+ee+\"*([^\\\\]'\\\"]*?)\"+ee+\"*\\\\]\",\"g\"),ce=new RegExp(ie),fe=new RegExp(\"^\"+ne+\"$\"),de={ID:new RegExp(\"^#(\"+te+\")\"),CLASS:new RegExp(\"^\\\\.(\"+te+\")\"),TAG:new RegExp(\"^(\"+te.replace(\"w\",\"w*\")+\")\"),ATTR:new RegExp(\"^\"+re),PSEUDO:new RegExp(\"^\"+ie),CHILD:new RegExp(\"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\\\(\"+ee+\"*(even|odd|(([+-]|)(\\\\d*)n|)\"+ee+\"*(?:([+-]|)\"+ee+\"*(\\\\d+)|))\"+ee+\"*\\\\)|)\",\"i\"),bool:new RegExp(\"^(?:\"+Z+\")$\",\"i\"),needsContext:new RegExp(\"^\"+ee+\"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\\\(\"+ee+\"*((?:-\\\\d)?\\\\d*)\"+ee+\"*\\\\)|)(?=[^-]|$)\",\"i\")},pe=/^(?:input|select|textarea|button)$/i,he=/^h\\d$/i,me=/^[^{]+\\{\\s*\\[native \\w/,ge=/^(?:#([\\w-]+)|(\\w+)|\\.([\\w-]+))$/,ve=/[+~]/,ye=/'|\\\\/g,be=new RegExp(\"\\\\\\\\([\\\\da-f]{1,6}\"+ee+\"?|(\"+ee+\")|.)\",\"ig\"),xe=function(e,t,n){var r=\"0x\"+t-65536;return r!==r||n?t:r<0?String.fromCharCode(r+65536):String.fromCharCode(r>>10|55296,1023&r|56320)},we=function(){D()};try{G.apply(V=Q.call(B.childNodes),B.childNodes),V[B.childNodes.length].nodeType}catch(e){G={apply:V.length?function(e,t){Y.apply(e,Q.call(t))}:function(e,t){for(var n=e.length,r=0;e[n++]=t[r++];);e.length=n-1}}}b=t.support={},T=t.isXML=function(e){var t=e&&(e.ownerDocument||e).documentElement;return!!t&&\"HTML\"!==t.nodeName},D=t.setDocument=function(e){var t,n,r=e?e.ownerDocument||e:B;return r!==j&&9===r.nodeType&&r.documentElement?(j=r,L=r.documentElement,n=r.defaultView,n&&n!==n.top&&(n.addEventListener?n.addEventListener(\"unload\",we,!1):n.attachEvent&&n.attachEvent(\"onunload\",we)),H=!T(r),b.attributes=i(function(e){return e.className=\"i\",!e.getAttribute(\"className\")}),b.getElementsByTagName=i(function(e){return e.appendChild(r.createComment(\"\")),!e.getElementsByTagName(\"*\").length}),b.getElementsByClassName=me.test(r.getElementsByClassName),b.getById=i(function(e){return L.appendChild(e).id=O,!r.getElementsByName||!r.getElementsByName(O).length}),b.getById?(x.find.ID=function(e,t){if(void 0!==t.getElementById&&H){var n=t.getElementById(e);return n&&n.parentNode?[n]:[]}},x.filter.ID=function(e){var t=e.replace(be,xe);return function(e){return e.getAttribute(\"id\")===t}}):(delete x.find.ID,x.filter.ID=function(e){var t=e.replace(be,xe);return function(e){var n=void 0!==e.getAttributeNode&&e.getAttributeNode(\"id\");return n&&n.value===t}}),x.find.TAG=b.getElementsByTagName?function(e,t){return void 0!==t.getElementsByTagName?t.getElementsByTagName(e):b.qsa?t.querySelectorAll(e):void 0}:function(e,t){var n,r=[],i=0,o=t.getElementsByTagName(e);if(\"*\"===e){for(;n=o[i++];)1===n.nodeType&&r.push(n);return r}return o},x.find.CLASS=b.getElementsByClassName&&function(e,t){if(H)return t.getElementsByClassName(e)},_=[],q=[],(b.qsa=me.test(r.querySelectorAll))&&(i(function(e){L.appendChild(e).innerHTML=\"<a id='\"+O+\"'></a><select id='\"+O+\"-\\f]' msallowcapture=''><option selected=''></option></select>\",e.querySelectorAll(\"[msallowcapture^='']\").length&&q.push(\"[*^$]=\"+ee+\"*(?:''|\\\"\\\")\"),e.querySelectorAll(\"[selected]\").length||q.push(\"\\\\[\"+ee+\"*(?:value|\"+Z+\")\"),e.querySelectorAll(\"[id~=\"+O+\"-]\").length||q.push(\"~=\"),e.querySelectorAll(\":checked\").length||q.push(\":checked\"),e.querySelectorAll(\"a#\"+O+\"+*\").length||q.push(\".#.+[+~]\")}),i(function(e){var t=r.createElement(\"input\");t.setAttribute(\"type\",\"hidden\"),e.appendChild(t).setAttribute(\"name\",\"D\"),e.querySelectorAll(\"[name=d]\").length&&q.push(\"name\"+ee+\"*[*^$|!~]?=\"),e.querySelectorAll(\":enabled\").length||q.push(\":enabled\",\":disabled\"),e.querySelectorAll(\"*,:x\"),q.push(\",.*:\")})),(b.matchesSelector=me.test(M=L.matches||L.webkitMatchesSelector||L.mozMatchesSelector||L.oMatchesSelector||L.msMatchesSelector))&&i(function(e){b.disconnectedMatch=M.call(e,\"div\"),M.call(e,\"[s!='']:x\"),_.push(\"!=\",ie)}),q=q.length&&new RegExp(q.join(\"|\")),_=_.length&&new RegExp(_.join(\"|\")),t=me.test(L.compareDocumentPosition),F=t||me.test(L.contains)?function(e,t){var n=9===e.nodeType?e.documentElement:e,r=t&&t.parentNode;return e===r||!(!r||1!==r.nodeType||!(n.contains?n.contains(r):e.compareDocumentPosition&&16&e.compareDocumentPosition(r)))}:function(e,t){if(t)for(;t=t.parentNode;)if(t===e)return!0;return!1},I=t?function(e,t){if(e===t)return A=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(n=(e.ownerDocument||e)===(t.ownerDocument||t)?e.compareDocumentPosition(t):1,1&n||!b.sortDetached&&t.compareDocumentPosition(e)===n?e===r||e.ownerDocument===B&&F(B,e)?-1:t===r||t.ownerDocument===B&&F(B,t)?1:S?K(S,e)-K(S,t):0:4&n?-1:1)}:function(e,t){if(e===t)return A=!0,0;var n,i=0,o=e.parentNode,s=t.parentNode,l=[e],u=[t];if(!o||!s)return e===r?-1:t===r?1:o?-1:s?1:S?K(S,e)-K(S,t):0;if(o===s)return a(e,t);for(n=e;n=n.parentNode;)l.unshift(n);for(n=t;n=n.parentNode;)u.unshift(n);for(;l[i]===u[i];)i++;return i?a(l[i],u[i]):l[i]===B?-1:u[i]===B?1:0},r):j},t.matches=function(e,n){return t(e,null,null,n)},t.matchesSelector=function(e,n){if((e.ownerDocument||e)!==j&&D(e),n=n.replace(ue,\"='$1']\"),b.matchesSelector&&H&&(!_||!_.test(n))&&(!q||!q.test(n)))try{var r=M.call(e,n);if(r||b.disconnectedMatch||e.document&&11!==e.document.nodeType)return r}catch(e){}return t(n,j,null,[e]).length>0},t.contains=function(e,t){return(e.ownerDocument||e)!==j&&D(e),F(e,t)},t.attr=function(e,t){(e.ownerDocument||e)!==j&&D(e);var n=x.attrHandle[t.toLowerCase()],r=n&&U.call(x.attrHandle,t.toLowerCase())?n(e,t,!H):void 0;return void 0!==r?r:b.attributes||!H?e.getAttribute(t):(r=e.getAttributeNode(t))&&r.specified?r.value:null},t.error=function(e){throw new Error(\"Syntax error, unrecognized expression: \"+e)},t.uniqueSort=function(e){var t,n=[],r=0,i=0;if(A=!b.detectDuplicates,S=!b.sortStable&&e.slice(0),e.sort(I),A){for(;t=e[i++];)t===e[i]&&(r=n.push(i));for(;r--;)e.splice(n[r],1)}return S=null,e},w=t.getText=function(e){var t,n=\"\",r=0,i=e.nodeType;if(i){if(1===i||9===i||11===i){if(\"string\"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=w(e)}else if(3===i||4===i)return e.nodeValue}else for(;t=e[r++];)n+=w(t);return n},x=t.selectors={cacheLength:50,createPseudo:r,match:de,attrHandle:{},find:{},relative:{\">\":{dir:\"parentNode\",first:!0},\" \":{dir:\"parentNode\"},\"+\":{dir:\"previousSibling\",first:!0},\"~\":{dir:\"previousSibling\"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(be,xe),e[3]=(e[3]||e[4]||e[5]||\"\").replace(be,xe),\"~=\"===e[2]&&(e[3]=\" \"+e[3]+\" \"),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),\"nth\"===e[1].slice(0,3)?(e[3]||t.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*(\"even\"===e[3]||\"odd\"===e[3])),e[5]=+(e[7]+e[8]||\"odd\"===e[3])):e[3]&&t.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return de.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||\"\":n&&ce.test(n)&&(t=C(n,!0))&&(t=n.indexOf(\")\",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(be,xe).toLowerCase();return\"*\"===e?function(){return!0}:function(e){return e.nodeName&&e.nodeName.toLowerCase()===t}},CLASS:function(e){var t=W[e+\" \"];return t||(t=new RegExp(\"(^|\"+ee+\")\"+e+\"(\"+ee+\"|$)\"))&&W(e,function(e){return t.test(\"string\"==typeof e.className&&e.className||void 0!==e.getAttribute&&e.getAttribute(\"class\")||\"\")})},ATTR:function(e,n,r){return function(i){var o=t.attr(i,e);return null==o?\"!=\"===n:!n||(o+=\"\",\"=\"===n?o===r:\"!=\"===n?o!==r:\"^=\"===n?r&&0===o.indexOf(r):\"*=\"===n?r&&o.indexOf(r)>-1:\"$=\"===n?r&&o.slice(-r.length)===r:\"~=\"===n?(\" \"+o.replace(oe,\" \")+\" \").indexOf(r)>-1:\"|=\"===n&&(o===r||o.slice(0,r.length+1)===r+\"-\"))}},CHILD:function(e,t,n,r,i){var o=\"nth\"!==e.slice(0,3),a=\"last\"!==e.slice(-4),s=\"of-type\"===t;return 1===r&&0===i?function(e){return!!e.parentNode}:function(t,n,l){var u,c,f,d,p,h,m=o!==a?\"nextSibling\":\"previousSibling\",g=t.parentNode,v=s&&t.nodeName.toLowerCase(),y=!l&&!s;if(g){if(o){for(;m;){for(f=t;f=f[m];)if(s?f.nodeName.toLowerCase()===v:1===f.nodeType)return!1;h=m=\"only\"===e&&!h&&\"nextSibling\"}return!0}if(h=[a?g.firstChild:g.lastChild],a&&y){for(c=g[O]||(g[O]={}),u=c[e]||[],p=u[0]===P&&u[1],d=u[0]===P&&u[2],f=p&&g.childNodes[p];f=++p&&f&&f[m]||(d=p=0)||h.pop();)if(1===f.nodeType&&++d&&f===t){c[e]=[P,p,d];break}}else if(y&&(u=(t[O]||(t[O]={}))[e])&&u[0]===P)d=u[1];else for(;(f=++p&&f&&f[m]||(d=p=0)||h.pop())&&((s?f.nodeName.toLowerCase()!==v:1!==f.nodeType)||!++d||(y&&((f[O]||(f[O]={}))[e]=[P,d]),f!==t)););return(d-=i)===r||d%r==0&&d/r>=0}}},PSEUDO:function(e,n){var i,o=x.pseudos[e]||x.setFilters[e.toLowerCase()]||t.error(\"unsupported pseudo: \"+e);return o[O]?o(n):o.length>1?(i=[e,e,\"\",n],x.setFilters.hasOwnProperty(e.toLowerCase())?r(function(e,t){for(var r,i=o(e,n),a=i.length;a--;)r=K(e,i[a]),e[r]=!(t[r]=i[a])}):function(e){return o(e,0,i)}):o}},pseudos:{not:r(function(e){var t=[],n=[],i=N(e.replace(ae,\"$1\"));return i[O]?r(function(e,t,n,r){for(var o,a=i(e,null,r,[]),s=e.length;s--;)(o=a[s])&&(e[s]=!(t[s]=o))}):function(e,r,o){return t[0]=e,i(t,null,o,n),t[0]=null,!n.pop()}}),has:r(function(e){return function(n){return t(e,n).length>0}}),contains:r(function(e){return e=e.replace(be,xe),function(t){return(t.textContent||t.innerText||w(t)).indexOf(e)>-1}}),lang:r(function(e){return fe.test(e||\"\")||t.error(\"unsupported lang: \"+e),e=e.replace(be,xe).toLowerCase(),function(t){var n;do{if(n=H?t.lang:t.getAttribute(\"xml:lang\")||t.getAttribute(\"lang\"))return(n=n.toLowerCase())===e||0===n.indexOf(e+\"-\")}while((t=t.parentNode)&&1===t.nodeType);return!1}}),target:function(t){var n=e.location&&e.location.hash;return n&&n.slice(1)===t.id},root:function(e){return e===L},focus:function(e){return e===j.activeElement&&(!j.hasFocus||j.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:function(e){return!1===e.disabled},disabled:function(e){return!0===e.disabled},checked:function(e){var t=e.nodeName.toLowerCase();return\"input\"===t&&!!e.checked||\"option\"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!x.pseudos.empty(e)},header:function(e){return he.test(e.nodeName)},input:function(e){return pe.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return\"input\"===t&&\"button\"===e.type||\"button\"===t},text:function(e){var t;return\"input\"===e.nodeName.toLowerCase()&&\"text\"===e.type&&(null==(t=e.getAttribute(\"type\"))||\"text\"===t.toLowerCase())},first:s(function(){return[0]}),last:s(function(e,t){return[t-1]}),eq:s(function(e,t,n){return[n<0?n+t:n]}),even:s(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:s(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:s(function(e,t,n){for(var r=n<0?n+t:n;--r>=0;)e.push(r);return e}),gt:s(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}},x.pseudos.nth=x.pseudos.eq;for(y in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})x.pseudos[y]=function(e){return function(t){return\"input\"===t.nodeName.toLowerCase()&&t.type===e}}(y);for(y in{submit:!0,reset:!0})x.pseudos[y]=function(e){return function(t){var n=t.nodeName.toLowerCase();return(\"input\"===n||\"button\"===n)&&t.type===e}}(y);return u.prototype=x.filters=x.pseudos,x.setFilters=new u,C=t.tokenize=function(e,n){var r,i,o,a,s,l,u,c=$[e+\" \"];if(c)return n?0:c.slice(0);for(s=e,l=[],u=x.preFilter;s;){r&&!(i=se.exec(s))||(i&&(s=s.slice(i[0].length)||s),l.push(o=[])),r=!1,(i=le.exec(s))&&(r=i.shift(),o.push({value:r,type:i[0].replace(ae,\" \")}),s=s.slice(r.length));for(a in x.filter)!(i=de[a].exec(s))||u[a]&&!(i=u[a](i))||(r=i.shift(),o.push({value:r,type:a,matches:i}),s=s.slice(r.length));if(!r)break}return n?s.length:s?t.error(e):$(e,l).slice(0)},\nN=t.compile=function(e,t){var n,r=[],i=[],o=z[e+\" \"];if(!o){for(t||(t=C(e)),n=t.length;n--;)o=g(t[n]),o[O]?r.push(o):i.push(o);o=z(e,v(i,r)),o.selector=e}return o},E=t.select=function(e,t,n,r){var i,o,a,s,u,f=\"function\"==typeof e&&e,d=!r&&C(e=f.selector||e);if(n=n||[],1===d.length){if(o=d[0]=d[0].slice(0),o.length>2&&\"ID\"===(a=o[0]).type&&b.getById&&9===t.nodeType&&H&&x.relative[o[1].type]){if(!(t=(x.find.ID(a.matches[0].replace(be,xe),t)||[])[0]))return n;f&&(t=t.parentNode),e=e.slice(o.shift().value.length)}for(i=de.needsContext.test(e)?0:o.length;i--&&(a=o[i],!x.relative[s=a.type]);)if((u=x.find[s])&&(r=u(a.matches[0].replace(be,xe),ve.test(o[0].type)&&l(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&c(o)))return G.apply(n,r),n;break}}return(f||N(e,d))(r,t,!H,n,ve.test(e)&&l(t.parentNode)||t),n},b.sortStable=O.split(\"\").sort(I).join(\"\")===O,b.detectDuplicates=!!A,D(),b.sortDetached=i(function(e){return 1&e.compareDocumentPosition(j.createElement(\"div\"))}),i(function(e){return e.innerHTML=\"<a href='#'></a>\",\"#\"===e.firstChild.getAttribute(\"href\")})||o(\"type|href|height|width\",function(e,t,n){if(!n)return e.getAttribute(t,\"type\"===t.toLowerCase()?1:2)}),b.attributes&&i(function(e){return e.innerHTML=\"<input/>\",e.firstChild.setAttribute(\"value\",\"\"),\"\"===e.firstChild.getAttribute(\"value\")})||o(\"value\",function(e,t,n){if(!n&&\"input\"===e.nodeName.toLowerCase())return e.defaultValue}),i(function(e){return null==e.getAttribute(\"disabled\")})||o(Z,function(e,t,n){var r;if(!n)return!0===e[t]?t.toLowerCase():(r=e.getAttributeNode(t))&&r.specified?r.value:null}),t}(e);re.find=le,re.expr=le.selectors,re.expr[\":\"]=re.expr.pseudos,re.unique=le.uniqueSort,re.text=le.getText,re.isXMLDoc=le.isXML,re.contains=le.contains;var ue=re.expr.match.needsContext,ce=/^<(\\w+)\\s*\\/?>(?:<\\/\\1>|)$/,fe=/^.[^:#\\[\\.,]*$/;re.filter=function(e,t,n){var r=t[0];return n&&(e=\":not(\"+e+\")\"),1===t.length&&1===r.nodeType?re.find.matchesSelector(r,e)?[r]:[]:re.find.matches(e,re.grep(t,function(e){return 1===e.nodeType}))},re.fn.extend({find:function(e){var t,n=[],r=this,i=r.length;if(\"string\"!=typeof e)return this.pushStack(re(e).filter(function(){for(t=0;t<i;t++)if(re.contains(r[t],this))return!0}));for(t=0;t<i;t++)re.find(e,r[t],n);return n=this.pushStack(i>1?re.unique(n):n),n.selector=this.selector?this.selector+\" \"+e:e,n},filter:function(e){return this.pushStack(r(this,e||[],!1))},not:function(e){return this.pushStack(r(this,e||[],!0))},is:function(e){return!!r(this,\"string\"==typeof e&&ue.test(e)?re(e):e||[],!1).length}});var de,pe=e.document,he=/^(?:\\s*(<[\\w\\W]+>)[^>]*|#([\\w-]*))$/;(re.fn.init=function(e,t){var n,r;if(!e)return this;if(\"string\"==typeof e){if(!(n=\"<\"===e.charAt(0)&&\">\"===e.charAt(e.length-1)&&e.length>=3?[null,e,null]:he.exec(e))||!n[1]&&t)return!t||t.jquery?(t||de).find(e):this.constructor(t).find(e);if(n[1]){if(t=t instanceof re?t[0]:t,re.merge(this,re.parseHTML(n[1],t&&t.nodeType?t.ownerDocument||t:pe,!0)),ce.test(n[1])&&re.isPlainObject(t))for(n in t)re.isFunction(this[n])?this[n](t[n]):this.attr(n,t[n]);return this}if((r=pe.getElementById(n[2]))&&r.parentNode){if(r.id!==n[2])return de.find(e);this.length=1,this[0]=r}return this.context=pe,this.selector=e,this}return e.nodeType?(this.context=this[0]=e,this.length=1,this):re.isFunction(e)?void 0!==de.ready?de.ready(e):e(re):(void 0!==e.selector&&(this.selector=e.selector,this.context=e.context),re.makeArray(e,this))}).prototype=re.fn,de=re(pe);var me=/^(?:parents|prev(?:Until|All))/,ge={children:!0,contents:!0,next:!0,prev:!0};re.extend({dir:function(e,t,n){for(var r=[],i=e[t];i&&9!==i.nodeType&&(void 0===n||1!==i.nodeType||!re(i).is(n));)1===i.nodeType&&r.push(i),i=i[t];return r},sibling:function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n}}),re.fn.extend({has:function(e){var t,n=re(e,this),r=n.length;return this.filter(function(){for(t=0;t<r;t++)if(re.contains(this,n[t]))return!0})},closest:function(e,t){for(var n,r=0,i=this.length,o=[],a=ue.test(e)||\"string\"!=typeof e?re(e,t||this.context):0;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?a.index(n)>-1:1===n.nodeType&&re.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(o.length>1?re.unique(o):o)},index:function(e){return e?\"string\"==typeof e?re.inArray(this[0],re(e)):re.inArray(e.jquery?e[0]:e,this):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(re.unique(re.merge(this.get(),re(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),re.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return re.dir(e,\"parentNode\")},parentsUntil:function(e,t,n){return re.dir(e,\"parentNode\",n)},next:function(e){return i(e,\"nextSibling\")},prev:function(e){return i(e,\"previousSibling\")},nextAll:function(e){return re.dir(e,\"nextSibling\")},prevAll:function(e){return re.dir(e,\"previousSibling\")},nextUntil:function(e,t,n){return re.dir(e,\"nextSibling\",n)},prevUntil:function(e,t,n){return re.dir(e,\"previousSibling\",n)},siblings:function(e){return re.sibling((e.parentNode||{}).firstChild,e)},children:function(e){return re.sibling(e.firstChild)},contents:function(e){return re.nodeName(e,\"iframe\")?e.contentDocument||e.contentWindow.document:re.merge([],e.childNodes)}},function(e,t){re.fn[e]=function(n,r){var i=re.map(this,t,n);return\"Until\"!==e.slice(-5)&&(r=n),r&&\"string\"==typeof r&&(i=re.filter(r,i)),this.length>1&&(ge[e]||(i=re.unique(i)),me.test(e)&&(i=i.reverse())),this.pushStack(i)}});var ve=/\\S+/g,ye={};re.Callbacks=function(e){e=\"string\"==typeof e?ye[e]||o(e):re.extend({},e);var t,n,r,i,a,s,l=[],u=!e.once&&[],c=function(o){for(n=e.memory&&o,r=!0,a=s||0,s=0,i=l.length,t=!0;l&&a<i;a++)if(!1===l[a].apply(o[0],o[1])&&e.stopOnFalse){n=!1;break}t=!1,l&&(u?u.length&&c(u.shift()):n?l=[]:f.disable())},f={add:function(){if(l){var r=l.length;!function t(n){re.each(n,function(n,r){var i=re.type(r);\"function\"===i?e.unique&&f.has(r)||l.push(r):r&&r.length&&\"string\"!==i&&t(r)})}(arguments),t?i=l.length:n&&(s=r,c(n))}return this},remove:function(){return l&&re.each(arguments,function(e,n){for(var r;(r=re.inArray(n,l,r))>-1;)l.splice(r,1),t&&(r<=i&&i--,r<=a&&a--)}),this},has:function(e){return e?re.inArray(e,l)>-1:!(!l||!l.length)},empty:function(){return l=[],i=0,this},disable:function(){return l=u=n=void 0,this},disabled:function(){return!l},lock:function(){return u=void 0,n||f.disable(),this},locked:function(){return!u},fireWith:function(e,n){return!l||r&&!u||(n=n||[],n=[e,n.slice?n.slice():n],t?u.push(n):c(n)),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!r}};return f},re.extend({Deferred:function(e){var t=[[\"resolve\",\"done\",re.Callbacks(\"once memory\"),\"resolved\"],[\"reject\",\"fail\",re.Callbacks(\"once memory\"),\"rejected\"],[\"notify\",\"progress\",re.Callbacks(\"memory\")]],n=\"pending\",r={state:function(){return n},always:function(){return i.done(arguments).fail(arguments),this},then:function(){var e=arguments;return re.Deferred(function(n){re.each(t,function(t,o){var a=re.isFunction(e[t])&&e[t];i[o[1]](function(){var e=a&&a.apply(this,arguments);e&&re.isFunction(e.promise)?e.promise().done(n.resolve).fail(n.reject).progress(n.notify):n[o[0]+\"With\"](this===r?n.promise():this,a?[e]:arguments)})}),e=null}).promise()},promise:function(e){return null!=e?re.extend(e,r):r}},i={};return r.pipe=r.then,re.each(t,function(e,o){var a=o[2],s=o[3];r[o[1]]=a.add,s&&a.add(function(){n=s},t[1^e][2].disable,t[2][2].lock),i[o[0]]=function(){return i[o[0]+\"With\"](this===i?r:this,arguments),this},i[o[0]+\"With\"]=a.fireWith}),r.promise(i),e&&e.call(i,i),i},when:function(e){var t,n,r,i=0,o=Y.call(arguments),a=o.length,s=1!==a||e&&re.isFunction(e.promise)?a:0,l=1===s?e:re.Deferred(),u=function(e,n,r){return function(i){n[e]=this,r[e]=arguments.length>1?Y.call(arguments):i,r===t?l.notifyWith(n,r):--s||l.resolveWith(n,r)}};if(a>1)for(t=new Array(a),n=new Array(a),r=new Array(a);i<a;i++)o[i]&&re.isFunction(o[i].promise)?o[i].promise().done(u(i,r,o)).fail(l.reject).progress(u(i,n,t)):--s;return s||l.resolveWith(r,o),l.promise()}});var be;re.fn.ready=function(e){return re.ready.promise().done(e),this},re.extend({isReady:!1,readyWait:1,holdReady:function(e){e?re.readyWait++:re.ready(!0)},ready:function(e){if(!0===e?!--re.readyWait:!re.isReady){if(!pe.body)return setTimeout(re.ready);re.isReady=!0,!0!==e&&--re.readyWait>0||(be.resolveWith(pe,[re]),re.fn.triggerHandler&&(re(pe).triggerHandler(\"ready\"),re(pe).off(\"ready\")))}}}),re.ready.promise=function(t){if(!be)if(be=re.Deferred(),\"complete\"===pe.readyState)setTimeout(re.ready);else if(pe.addEventListener)pe.addEventListener(\"DOMContentLoaded\",s,!1),e.addEventListener(\"load\",s,!1);else{pe.attachEvent(\"onreadystatechange\",s),e.attachEvent(\"onload\",s);var n=!1;try{n=null==e.frameElement&&pe.documentElement}catch(e){}n&&n.doScroll&&function e(){if(!re.isReady){try{n.doScroll(\"left\")}catch(t){return setTimeout(e,50)}a(),re.ready()}}()}return be.promise(t)};var xe,we=\"undefined\";for(xe in re(ne))break;ne.ownLast=\"0\"!==xe,ne.inlineBlockNeedsLayout=!1,re(function(){var e,t,n,r;(n=pe.getElementsByTagName(\"body\")[0])&&n.style&&(t=pe.createElement(\"div\"),r=pe.createElement(\"div\"),r.style.cssText=\"position:absolute;border:0;width:0;height:0;top:0;left:-9999px\",n.appendChild(r).appendChild(t),typeof t.style.zoom!==we&&(t.style.cssText=\"display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1\",ne.inlineBlockNeedsLayout=e=3===t.offsetWidth,e&&(n.style.zoom=1)),n.removeChild(r))}),function(){var e=pe.createElement(\"div\");if(null==ne.deleteExpando){ne.deleteExpando=!0;try{delete e.test}catch(e){ne.deleteExpando=!1}}e=null}(),re.acceptData=function(e){var t=re.noData[(e.nodeName+\" \").toLowerCase()],n=+e.nodeType||1;return(1===n||9===n)&&(!t||!0!==t&&e.getAttribute(\"classid\")===t)};var Te=/^(?:\\{[\\w\\W]*\\}|\\[[\\w\\W]*\\])$/,Ce=/([A-Z])/g;re.extend({cache:{},noData:{\"applet \":!0,\"embed \":!0,\"object \":\"clsid:D27CDB6E-AE6D-11cf-96B8-444553540000\"},hasData:function(e){return!!(e=e.nodeType?re.cache[e[re.expando]]:e[re.expando])&&!u(e)},data:function(e,t,n){return c(e,t,n)},removeData:function(e,t){return f(e,t)},_data:function(e,t,n){return c(e,t,n,!0)},_removeData:function(e,t){return f(e,t,!0)}}),re.fn.extend({data:function(e,t){var n,r,i,o=this[0],a=o&&o.attributes;if(void 0===e){if(this.length&&(i=re.data(o),1===o.nodeType&&!re._data(o,\"parsedAttrs\"))){for(n=a.length;n--;)a[n]&&(r=a[n].name,0===r.indexOf(\"data-\")&&(r=re.camelCase(r.slice(5)),l(o,r,i[r])));re._data(o,\"parsedAttrs\",!0)}return i}return\"object\"==typeof e?this.each(function(){re.data(this,e)}):arguments.length>1?this.each(function(){re.data(this,e,t)}):o?l(o,e,re.data(o,e)):void 0},removeData:function(e){return this.each(function(){re.removeData(this,e)})}}),re.extend({queue:function(e,t,n){var r;if(e)return t=(t||\"fx\")+\"queue\",r=re._data(e,t),n&&(!r||re.isArray(n)?r=re._data(e,t,re.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||\"fx\";var n=re.queue(e,t),r=n.length,i=n.shift(),o=re._queueHooks(e,t),a=function(){re.dequeue(e,t)};\"inprogress\"===i&&(i=n.shift(),r--),i&&(\"fx\"===t&&n.unshift(\"inprogress\"),delete o.stop,i.call(e,a,o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+\"queueHooks\";return re._data(e,n)||re._data(e,n,{empty:re.Callbacks(\"once memory\").add(function(){re._removeData(e,t+\"queue\"),re._removeData(e,n)})})}}),re.fn.extend({queue:function(e,t){var n=2;return\"string\"!=typeof e&&(t=e,e=\"fx\",n--),arguments.length<n?re.queue(this[0],e):void 0===t?this:this.each(function(){var n=re.queue(this,e,t);re._queueHooks(this,e),\"fx\"===e&&\"inprogress\"!==n[0]&&re.dequeue(this,e)})},dequeue:function(e){return this.each(function(){re.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||\"fx\",[])},promise:function(e,t){var n,r=1,i=re.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};for(\"string\"!=typeof e&&(t=e,e=void 0),e=e||\"fx\";a--;)(n=re._data(o[a],e+\"queueHooks\"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var Ne=/[+-]?(?:\\d*\\.|)\\d+(?:[eE][+-]?\\d+|)/.source,Ee=[\"Top\",\"Right\",\"Bottom\",\"Left\"],ke=function(e,t){return e=t||e,\"none\"===re.css(e,\"display\")||!re.contains(e.ownerDocument,e)},Se=re.access=function(e,t,n,r,i,o,a){var s=0,l=e.length,u=null==n;if(\"object\"===re.type(n)){i=!0;for(s in n)re.access(e,t,s,n[s],!0,o,a)}else if(void 0!==r&&(i=!0,re.isFunction(r)||(a=!0),u&&(a?(t.call(e,r),t=null):(u=t,t=function(e,t,n){return u.call(re(e),n)})),t))for(;s<l;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:u?t.call(e):l?t(e[0],n):o},Ae=/^(?:checkbox|radio)$/i;!function(){var e=pe.createElement(\"input\"),t=pe.createElement(\"div\"),n=pe.createDocumentFragment();if(t.innerHTML=\"  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>\",ne.leadingWhitespace=3===t.firstChild.nodeType,ne.tbody=!t.getElementsByTagName(\"tbody\").length,ne.htmlSerialize=!!t.getElementsByTagName(\"link\").length,ne.html5Clone=\"<:nav></:nav>\"!==pe.createElement(\"nav\").cloneNode(!0).outerHTML,e.type=\"checkbox\",e.checked=!0,n.appendChild(e),ne.appendChecked=e.checked,t.innerHTML=\"<textarea>x</textarea>\",ne.noCloneChecked=!!t.cloneNode(!0).lastChild.defaultValue,n.appendChild(t),t.innerHTML=\"<input type='radio' checked='checked' name='t'/>\",ne.checkClone=t.cloneNode(!0).cloneNode(!0).lastChild.checked,ne.noCloneEvent=!0,t.attachEvent&&(t.attachEvent(\"onclick\",function(){ne.noCloneEvent=!1}),t.cloneNode(!0).click()),null==ne.deleteExpando){ne.deleteExpando=!0;try{delete t.test}catch(e){ne.deleteExpando=!1}}}(),function(){var t,n,r=pe.createElement(\"div\");for(t in{submit:!0,change:!0,focusin:!0})n=\"on\"+t,(ne[t+\"Bubbles\"]=n in e)||(r.setAttribute(n,\"t\"),ne[t+\"Bubbles\"]=!1===r.attributes[n].expando);r=null}();var De=/^(?:input|select|textarea)$/i,je=/^key/,Le=/^(?:mouse|pointer|contextmenu)|click/,He=/^(?:focusinfocus|focusoutblur)$/,qe=/^([^.]*)(?:\\.(.+)|)$/;re.event={global:{},add:function(e,t,n,r,i){var o,a,s,l,u,c,f,d,p,h,m,g=re._data(e);if(g){for(n.handler&&(l=n,n=l.handler,i=l.selector),n.guid||(n.guid=re.guid++),(a=g.events)||(a=g.events={}),(c=g.handle)||(c=g.handle=function(e){return typeof re===we||e&&re.event.triggered===e.type?void 0:re.event.dispatch.apply(c.elem,arguments)},c.elem=e),t=(t||\"\").match(ve)||[\"\"],s=t.length;s--;)o=qe.exec(t[s])||[],p=m=o[1],h=(o[2]||\"\").split(\".\").sort(),p&&(u=re.event.special[p]||{},p=(i?u.delegateType:u.bindType)||p,u=re.event.special[p]||{},f=re.extend({type:p,origType:m,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&re.expr.match.needsContext.test(i),namespace:h.join(\".\")},l),(d=a[p])||(d=a[p]=[],d.delegateCount=0,u.setup&&!1!==u.setup.call(e,r,h,c)||(e.addEventListener?e.addEventListener(p,c,!1):e.attachEvent&&e.attachEvent(\"on\"+p,c))),u.add&&(u.add.call(e,f),f.handler.guid||(f.handler.guid=n.guid)),i?d.splice(d.delegateCount++,0,f):d.push(f),re.event.global[p]=!0);e=null}},remove:function(e,t,n,r,i){var o,a,s,l,u,c,f,d,p,h,m,g=re.hasData(e)&&re._data(e);if(g&&(c=g.events)){for(t=(t||\"\").match(ve)||[\"\"],u=t.length;u--;)if(s=qe.exec(t[u])||[],p=m=s[1],h=(s[2]||\"\").split(\".\").sort(),p){for(f=re.event.special[p]||{},p=(r?f.delegateType:f.bindType)||p,d=c[p]||[],s=s[2]&&new RegExp(\"(^|\\\\.)\"+h.join(\"\\\\.(?:.*\\\\.|)\")+\"(\\\\.|$)\"),l=o=d.length;o--;)a=d[o],!i&&m!==a.origType||n&&n.guid!==a.guid||s&&!s.test(a.namespace)||r&&r!==a.selector&&(\"**\"!==r||!a.selector)||(d.splice(o,1),a.selector&&d.delegateCount--,f.remove&&f.remove.call(e,a));l&&!d.length&&(f.teardown&&!1!==f.teardown.call(e,h,g.handle)||re.removeEvent(e,p,g.handle),delete c[p])}else for(p in c)re.event.remove(e,p+t[u],n,r,!0);re.isEmptyObject(c)&&(delete g.handle,re._removeData(e,\"events\"))}},trigger:function(t,n,r,i){var o,a,s,l,u,c,f,d=[r||pe],p=te.call(t,\"type\")?t.type:t,h=te.call(t,\"namespace\")?t.namespace.split(\".\"):[];if(s=c=r=r||pe,3!==r.nodeType&&8!==r.nodeType&&!He.test(p+re.event.triggered)&&(p.indexOf(\".\")>=0&&(h=p.split(\".\"),p=h.shift(),h.sort()),a=p.indexOf(\":\")<0&&\"on\"+p,t=t[re.expando]?t:new re.Event(p,\"object\"==typeof t&&t),t.isTrigger=i?2:3,t.namespace=h.join(\".\"),t.namespace_re=t.namespace?new RegExp(\"(^|\\\\.)\"+h.join(\"\\\\.(?:.*\\\\.|)\")+\"(\\\\.|$)\"):null,t.result=void 0,t.target||(t.target=r),n=null==n?[t]:re.makeArray(n,[t]),u=re.event.special[p]||{},i||!u.trigger||!1!==u.trigger.apply(r,n))){if(!i&&!u.noBubble&&!re.isWindow(r)){for(l=u.delegateType||p,He.test(l+p)||(s=s.parentNode);s;s=s.parentNode)d.push(s),c=s;c===(r.ownerDocument||pe)&&d.push(c.defaultView||c.parentWindow||e)}for(f=0;(s=d[f++])&&!t.isPropagationStopped();)t.type=f>1?l:u.bindType||p,o=(re._data(s,\"events\")||{})[t.type]&&re._data(s,\"handle\"),o&&o.apply(s,n),(o=a&&s[a])&&o.apply&&re.acceptData(s)&&(t.result=o.apply(s,n),!1===t.result&&t.preventDefault());if(t.type=p,!i&&!t.isDefaultPrevented()&&(!u._default||!1===u._default.apply(d.pop(),n))&&re.acceptData(r)&&a&&r[p]&&!re.isWindow(r)){c=r[a],c&&(r[a]=null),re.event.triggered=p;try{r[p]()}catch(e){}re.event.triggered=void 0,c&&(r[a]=c)}return t.result}},dispatch:function(e){e=re.event.fix(e);var t,n,r,i,o,a=[],s=Y.call(arguments),l=(re._data(this,\"events\")||{})[e.type]||[],u=re.event.special[e.type]||{};if(s[0]=e,e.delegateTarget=this,!u.preDispatch||!1!==u.preDispatch.call(this,e)){for(a=re.event.handlers.call(this,e,l),t=0;(i=a[t++])&&!e.isPropagationStopped();)for(e.currentTarget=i.elem,o=0;(r=i.handlers[o++])&&!e.isImmediatePropagationStopped();)e.namespace_re&&!e.namespace_re.test(r.namespace)||(e.handleObj=r,e.data=r.data,void 0!==(n=((re.event.special[r.origType]||{}).handle||r.handler).apply(i.elem,s))&&!1===(e.result=n)&&(e.preventDefault(),e.stopPropagation()));return u.postDispatch&&u.postDispatch.call(this,e),e.result}},handlers:function(e,t){var n,r,i,o,a=[],s=t.delegateCount,l=e.target;if(s&&l.nodeType&&(!e.button||\"click\"!==e.type))for(;l!=this;l=l.parentNode||this)if(1===l.nodeType&&(!0!==l.disabled||\"click\"!==e.type)){for(i=[],o=0;o<s;o++)r=t[o],n=r.selector+\" \",void 0===i[n]&&(i[n]=r.needsContext?re(n,this).index(l)>=0:re.find(n,this,null,[l]).length),i[n]&&i.push(r);i.length&&a.push({elem:l,handlers:i})}return s<t.length&&a.push({elem:this,handlers:t.slice(s)}),a},fix:function(e){if(e[re.expando])return e;var t,n,r,i=e.type,o=e,a=this.fixHooks[i];for(a||(this.fixHooks[i]=a=Le.test(i)?this.mouseHooks:je.test(i)?this.keyHooks:{}),r=a.props?this.props.concat(a.props):this.props,e=new re.Event(o),t=r.length;t--;)n=r[t],e[n]=o[n];return e.target||(e.target=o.srcElement||pe),3===e.target.nodeType&&(e.target=e.target.parentNode),e.metaKey=!!e.metaKey,a.filter?a.filter(e,o):e},props:\"altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which\".split(\" \"),fixHooks:{},keyHooks:{props:\"char charCode key keyCode\".split(\" \"),filter:function(e,t){return null==e.which&&(e.which=null!=t.charCode?t.charCode:t.keyCode),e}},mouseHooks:{props:\"button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement\".split(\" \"),filter:function(e,t){var n,r,i,o=t.button,a=t.fromElement;return null==e.pageX&&null!=t.clientX&&(r=e.target.ownerDocument||pe,i=r.documentElement,n=r.body,e.pageX=t.clientX+(i&&i.scrollLeft||n&&n.scrollLeft||0)-(i&&i.clientLeft||n&&n.clientLeft||0),e.pageY=t.clientY+(i&&i.scrollTop||n&&n.scrollTop||0)-(i&&i.clientTop||n&&n.clientTop||0)),!e.relatedTarget&&a&&(e.relatedTarget=a===e.target?t.toElement:a),e.which||void 0===o||(e.which=1&o?1:2&o?3:4&o?2:0),e}},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==h()&&this.focus)try{return this.focus(),!1}catch(e){}},delegateType:\"focusin\"},blur:{trigger:function(){if(this===h()&&this.blur)return this.blur(),!1},delegateType:\"focusout\"},click:{trigger:function(){if(re.nodeName(this,\"input\")&&\"checkbox\"===this.type&&this.click)return this.click(),!1},_default:function(e){return re.nodeName(e.target,\"a\")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}},simulate:function(e,t,n,r){var i=re.extend(new re.Event,n,{type:e,isSimulated:!0,originalEvent:{}});r?re.event.trigger(i,null,t):re.event.dispatch.call(t,i),i.isDefaultPrevented()&&n.preventDefault()}},re.removeEvent=pe.removeEventListener?function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n,!1)}:function(e,t,n){var r=\"on\"+t;e.detachEvent&&(typeof e[r]===we&&(e[r]=null),e.detachEvent(r,n))},re.Event=function(e,t){if(!(this instanceof re.Event))return new re.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?d:p):this.type=e,t&&re.extend(this,t),this.timeStamp=e&&e.timeStamp||re.now(),this[re.expando]=!0},re.Event.prototype={isDefaultPrevented:p,isPropagationStopped:p,isImmediatePropagationStopped:p,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=d,e&&(e.preventDefault?e.preventDefault():e.returnValue=!1)},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=d,e&&(e.stopPropagation&&e.stopPropagation(),e.cancelBubble=!0)},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=d,e&&e.stopImmediatePropagation&&e.stopImmediatePropagation(),this.stopPropagation()}},re.each({mouseenter:\"mouseover\",mouseleave:\"mouseout\",pointerenter:\"pointerover\",pointerleave:\"pointerout\"},function(e,t){re.event.special[e]={delegateType:t,bindType:t,handle:function(e){var n,r=this,i=e.relatedTarget,o=e.handleObj;return i&&(i===r||re.contains(r,i))||(e.type=o.origType,n=o.handler.apply(this,arguments),e.type=t),n}}}),ne.submitBubbles||(re.event.special.submit={setup:function(){if(re.nodeName(this,\"form\"))return!1;re.event.add(this,\"click._submit keypress._submit\",function(e){var t=e.target,n=re.nodeName(t,\"input\")||re.nodeName(t,\"button\")?t.form:void 0;n&&!re._data(n,\"submitBubbles\")&&(re.event.add(n,\"submit._submit\",function(e){e._submit_bubble=!0}),re._data(n,\"submitBubbles\",!0))})},postDispatch:function(e){e._submit_bubble&&(delete e._submit_bubble,this.parentNode&&!e.isTrigger&&re.event.simulate(\"submit\",this.parentNode,e,!0))},teardown:function(){if(re.nodeName(this,\"form\"))return!1;re.event.remove(this,\"._submit\")}}),ne.changeBubbles||(re.event.special.change={setup:function(){if(De.test(this.nodeName))return\"checkbox\"!==this.type&&\"radio\"!==this.type||(re.event.add(this,\"propertychange._change\",function(e){\"checked\"===e.originalEvent.propertyName&&(this._just_changed=!0)}),re.event.add(this,\"click._change\",function(e){this._just_changed&&!e.isTrigger&&(this._just_changed=!1),re.event.simulate(\"change\",this,e,!0)})),!1;re.event.add(this,\"beforeactivate._change\",function(e){var t=e.target;De.test(t.nodeName)&&!re._data(t,\"changeBubbles\")&&(re.event.add(t,\"change._change\",function(e){!this.parentNode||e.isSimulated||e.isTrigger||re.event.simulate(\"change\",this.parentNode,e,!0)}),re._data(t,\"changeBubbles\",!0))})},handle:function(e){var t=e.target;if(this!==t||e.isSimulated||e.isTrigger||\"radio\"!==t.type&&\"checkbox\"!==t.type)return e.handleObj.handler.apply(this,arguments)},teardown:function(){return re.event.remove(this,\"._change\"),!De.test(this.nodeName)}}),ne.focusinBubbles||re.each({focus:\"focusin\",blur:\"focusout\"},function(e,t){var n=function(e){re.event.simulate(t,e.target,re.event.fix(e),!0)};re.event.special[t]={setup:function(){var r=this.ownerDocument||this,i=re._data(r,t);i||r.addEventListener(e,n,!0),re._data(r,t,(i||0)+1)},teardown:function(){var r=this.ownerDocument||this,i=re._data(r,t)-1;i?re._data(r,t,i):(r.removeEventListener(e,n,!0),re._removeData(r,t))}}}),re.fn.extend({on:function(e,t,n,r,i){var o,a;if(\"object\"==typeof e){\"string\"!=typeof t&&(n=n||t,t=void 0);for(o in e)this.on(o,t,n,e[o],i);return this}if(null==n&&null==r?(r=t,n=t=void 0):null==r&&(\"string\"==typeof t?(r=n,n=void 0):(r=n,n=t,t=void 0)),!1===r)r=p;else if(!r)return this;return 1===i&&(a=r,r=function(e){return re().off(e),a.apply(this,arguments)},r.guid=a.guid||(a.guid=re.guid++)),this.each(function(){re.event.add(this,e,r,n,t)})},one:function(e,t,n,r){return this.on(e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,re(e.delegateTarget).off(r.namespace?r.origType+\".\"+r.namespace:r.origType,r.selector,r.handler),this;if(\"object\"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&\"function\"!=typeof t||(n=t,t=void 0),!1===n&&(n=p),this.each(function(){re.event.remove(this,e,n,t)})},trigger:function(e,t){return this.each(function(){re.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return re.event.trigger(e,t,n,!0)}});var _e=\"abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video\",Me=/ jQuery\\d+=\"(?:null|\\d+)\"/g,Fe=new RegExp(\"<(?:\"+_e+\")[\\\\s/>]\",\"i\"),Oe=/^\\s+/,Be=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\\w:]+)[^>]*)\\/>/gi,Pe=/<([\\w:]+)/,Re=/<tbody/i,We=/<|&#?\\w+;/,$e=/<(?:script|style|link)/i,ze=/checked\\s*(?:[^=]|=\\s*.checked.)/i,Ie=/^$|\\/(?:java|ecma)script/i,Xe=/^true\\/(.*)/,Ue=/^\\s*<!(?:\\[CDATA\\[|--)|(?:\\]\\]|--)>\\s*$/g,Ve={option:[1,\"<select multiple='multiple'>\",\"</select>\"],legend:[1,\"<fieldset>\",\"</fieldset>\"],area:[1,\"<map>\",\"</map>\"],param:[1,\"<object>\",\"</object>\"],thead:[1,\"<table>\",\"</table>\"],tr:[2,\"<table><tbody>\",\"</tbody></table>\"],col:[2,\"<table><tbody></tbody><colgroup>\",\"</colgroup></table>\"],td:[3,\"<table><tbody><tr>\",\"</tr></tbody></table>\"],_default:ne.htmlSerialize?[0,\"\",\"\"]:[1,\"X<div>\",\"</div>\"]},Je=m(pe),Ye=Je.appendChild(pe.createElement(\"div\"));Ve.optgroup=Ve.option,Ve.tbody=Ve.tfoot=Ve.colgroup=Ve.caption=Ve.thead,Ve.th=Ve.td,re.extend({clone:function(e,t,n){var r,i,o,a,s,l=re.contains(e.ownerDocument,e);if(ne.html5Clone||re.isXMLDoc(e)||!Fe.test(\"<\"+e.nodeName+\">\")?o=e.cloneNode(!0):(Ye.innerHTML=e.outerHTML,Ye.removeChild(o=Ye.firstChild)),!(ne.noCloneEvent&&ne.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||re.isXMLDoc(e)))for(r=g(o),s=g(e),a=0;null!=(i=s[a]);++a)r[a]&&C(i,r[a]);if(t)if(n)for(s=s||g(e),r=r||g(o),a=0;null!=(i=s[a]);a++)T(i,r[a]);else T(e,o);return r=g(o,\"script\"),r.length>0&&w(r,!l&&g(e,\"script\")),r=s=i=null,o},buildFragment:function(e,t,n,r){for(var i,o,a,s,l,u,c,f=e.length,d=m(t),p=[],h=0;h<f;h++)if((o=e[h])||0===o)if(\"object\"===re.type(o))re.merge(p,o.nodeType?[o]:o);else if(We.test(o)){for(s=s||d.appendChild(t.createElement(\"div\")),l=(Pe.exec(o)||[\"\",\"\"])[1].toLowerCase(),c=Ve[l]||Ve._default,s.innerHTML=c[1]+o.replace(Be,\"<$1></$2>\")+c[2],i=c[0];i--;)s=s.lastChild;if(!ne.leadingWhitespace&&Oe.test(o)&&p.push(t.createTextNode(Oe.exec(o)[0])),!ne.tbody)for(o=\"table\"!==l||Re.test(o)?\"<table>\"!==c[1]||Re.test(o)?0:s:s.firstChild,i=o&&o.childNodes.length;i--;)re.nodeName(u=o.childNodes[i],\"tbody\")&&!u.childNodes.length&&o.removeChild(u);for(re.merge(p,s.childNodes),s.textContent=\"\";s.firstChild;)s.removeChild(s.firstChild);s=d.lastChild}else p.push(t.createTextNode(o));for(s&&d.removeChild(s),ne.appendChecked||re.grep(g(p,\"input\"),v),h=0;o=p[h++];)if((!r||-1===re.inArray(o,r))&&(a=re.contains(o.ownerDocument,o),s=g(d.appendChild(o),\"script\"),a&&w(s),n))for(i=0;o=s[i++];)Ie.test(o.type||\"\")&&n.push(o);return s=null,d},cleanData:function(e,t){for(var n,r,i,o,a=0,s=re.expando,l=re.cache,u=ne.deleteExpando,c=re.event.special;null!=(n=e[a]);a++)if((t||re.acceptData(n))&&(i=n[s],o=i&&l[i])){if(o.events)for(r in o.events)c[r]?re.event.remove(n,r):re.removeEvent(n,r,o.handle);l[i]&&(delete l[i],u?delete n[s]:typeof n.removeAttribute!==we?n.removeAttribute(s):n[s]=null,J.push(i))}}}),re.fn.extend({text:function(e){return Se(this,function(e){return void 0===e?re.text(this):this.empty().append((this[0]&&this[0].ownerDocument||pe).createTextNode(e))},null,e,arguments.length)},append:function(){return this.domManip(arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){y(this,e).appendChild(e)}})},prepend:function(){return this.domManip(arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=y(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return this.domManip(arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return this.domManip(arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},remove:function(e,t){for(var n,r=e?re.filter(e,this):this,i=0;null!=(n=r[i]);i++)t||1!==n.nodeType||re.cleanData(g(n)),n.parentNode&&(t&&re.contains(n.ownerDocument,n)&&w(g(n,\"script\")),n.parentNode.removeChild(n));return this},empty:function(){for(var e,t=0;null!=(e=this[t]);t++){for(1===e.nodeType&&re.cleanData(g(e,!1));e.firstChild;)e.removeChild(e.firstChild);e.options&&re.nodeName(e,\"select\")&&(e.options.length=0)}return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return re.clone(this,e,t)})},html:function(e){return Se(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e)return 1===t.nodeType?t.innerHTML.replace(Me,\"\"):void 0;if(\"string\"==typeof e&&!$e.test(e)&&(ne.htmlSerialize||!Fe.test(e))&&(ne.leadingWhitespace||!Oe.test(e))&&!Ve[(Pe.exec(e)||[\"\",\"\"])[1].toLowerCase()]){e=e.replace(Be,\"<$1></$2>\");try{for(;n<r;n++)t=this[n]||{},1===t.nodeType&&(re.cleanData(g(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var e=arguments[0];return this.domManip(arguments,function(t){e=this.parentNode,re.cleanData(g(this)),e&&e.replaceChild(t,this)}),e&&(e.length||e.nodeType)?this:this.remove()},detach:function(e){return this.remove(e,!0)},domManip:function(e,t){e=G.apply([],e);var n,r,i,o,a,s,l=0,u=this.length,c=this,f=u-1,d=e[0],p=re.isFunction(d);if(p||u>1&&\"string\"==typeof d&&!ne.checkClone&&ze.test(d))return this.each(function(n){var r=c.eq(n);p&&(e[0]=d.call(this,n,r.html())),r.domManip(e,t)});if(u&&(s=re.buildFragment(e,this[0].ownerDocument,!1,this),n=s.firstChild,1===s.childNodes.length&&(s=n),n)){for(o=re.map(g(s,\"script\"),b),i=o.length;l<u;l++)r=s,l!==f&&(r=re.clone(r,!0,!0),i&&re.merge(o,g(r,\"script\"))),t.call(this[l],r,l);if(i)for(a=o[o.length-1].ownerDocument,re.map(o,x),l=0;l<i;l++)r=o[l],Ie.test(r.type||\"\")&&!re._data(r,\"globalEval\")&&re.contains(a,r)&&(r.src?re._evalUrl&&re._evalUrl(r.src):re.globalEval((r.text||r.textContent||r.innerHTML||\"\").replace(Ue,\"\")));s=n=null}return this}}),re.each({appendTo:\"append\",prependTo:\"prepend\",insertBefore:\"before\",insertAfter:\"after\",replaceAll:\"replaceWith\"},function(e,t){re.fn[e]=function(e){for(var n,r=0,i=[],o=re(e),a=o.length-1;r<=a;r++)n=r===a?this:this.clone(!0),re(o[r])[t](n),Q.apply(i,n.get());return this.pushStack(i)}});var Ge,Qe={};!function(){var e;ne.shrinkWrapBlocks=function(){if(null!=e)return e;e=!1;var t,n,r;return(n=pe.getElementsByTagName(\"body\")[0])&&n.style?(t=pe.createElement(\"div\"),r=pe.createElement(\"div\"),r.style.cssText=\"position:absolute;border:0;width:0;height:0;top:0;left:-9999px\",n.appendChild(r).appendChild(t),typeof t.style.zoom!==we&&(t.style.cssText=\"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1\",t.appendChild(pe.createElement(\"div\")).style.width=\"5px\",e=3!==t.offsetWidth),n.removeChild(r),e):void 0}}();var Ke,Ze,et=/^margin/,tt=new RegExp(\"^(\"+Ne+\")(?!px)[a-z%]+$\",\"i\"),nt=/^(top|right|bottom|left)$/;e.getComputedStyle?(Ke=function(t){return t.ownerDocument.defaultView.opener?t.ownerDocument.defaultView.getComputedStyle(t,null):e.getComputedStyle(t,null)},Ze=function(e,t,n){var r,i,o,a,s=e.style;return n=n||Ke(e),a=n?n.getPropertyValue(t)||n[t]:void 0,n&&(\"\"!==a||re.contains(e.ownerDocument,e)||(a=re.style(e,t)),tt.test(a)&&et.test(t)&&(r=s.width,i=s.minWidth,o=s.maxWidth,s.minWidth=s.maxWidth=s.width=a,a=n.width,s.width=r,s.minWidth=i,s.maxWidth=o)),void 0===a?a:a+\"\"}):pe.documentElement.currentStyle&&(Ke=function(e){return e.currentStyle},\nZe=function(e,t,n){var r,i,o,a,s=e.style;return n=n||Ke(e),a=n?n[t]:void 0,null==a&&s&&s[t]&&(a=s[t]),tt.test(a)&&!nt.test(t)&&(r=s.left,i=e.runtimeStyle,o=i&&i.left,o&&(i.left=e.currentStyle.left),s.left=\"fontSize\"===t?\"1em\":a,a=s.pixelLeft+\"px\",s.left=r,o&&(i.left=o)),void 0===a?a:a+\"\"||\"auto\"}),function(){function t(){var t,n,r,i;(n=pe.getElementsByTagName(\"body\")[0])&&n.style&&(t=pe.createElement(\"div\"),r=pe.createElement(\"div\"),r.style.cssText=\"position:absolute;border:0;width:0;height:0;top:0;left:-9999px\",n.appendChild(r).appendChild(t),t.style.cssText=\"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute\",o=a=!1,l=!0,e.getComputedStyle&&(o=\"1%\"!==(e.getComputedStyle(t,null)||{}).top,a=\"4px\"===(e.getComputedStyle(t,null)||{width:\"4px\"}).width,i=t.appendChild(pe.createElement(\"div\")),i.style.cssText=t.style.cssText=\"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0\",i.style.marginRight=i.style.width=\"0\",t.style.width=\"1px\",l=!parseFloat((e.getComputedStyle(i,null)||{}).marginRight),t.removeChild(i)),t.innerHTML=\"<table><tr><td></td><td>t</td></tr></table>\",i=t.getElementsByTagName(\"td\"),i[0].style.cssText=\"margin:0;border:0;padding:0;display:none\",s=0===i[0].offsetHeight,s&&(i[0].style.display=\"\",i[1].style.display=\"none\",s=0===i[0].offsetHeight),n.removeChild(r))}var n,r,i,o,a,s,l;n=pe.createElement(\"div\"),n.innerHTML=\"  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>\",i=n.getElementsByTagName(\"a\")[0],(r=i&&i.style)&&(r.cssText=\"float:left;opacity:.5\",ne.opacity=\"0.5\"===r.opacity,ne.cssFloat=!!r.cssFloat,n.style.backgroundClip=\"content-box\",n.cloneNode(!0).style.backgroundClip=\"\",ne.clearCloneStyle=\"content-box\"===n.style.backgroundClip,ne.boxSizing=\"\"===r.boxSizing||\"\"===r.MozBoxSizing||\"\"===r.WebkitBoxSizing,re.extend(ne,{reliableHiddenOffsets:function(){return null==s&&t(),s},boxSizingReliable:function(){return null==a&&t(),a},pixelPosition:function(){return null==o&&t(),o},reliableMarginRight:function(){return null==l&&t(),l}}))}(),re.swap=function(e,t,n,r){var i,o,a={};for(o in t)a[o]=e.style[o],e.style[o]=t[o];i=n.apply(e,r||[]);for(o in t)e.style[o]=a[o];return i};var rt=/alpha\\([^)]*\\)/i,it=/opacity\\s*=\\s*([^)]*)/,ot=/^(none|table(?!-c[ea]).+)/,at=new RegExp(\"^(\"+Ne+\")(.*)$\",\"i\"),st=new RegExp(\"^([+-])=(\"+Ne+\")\",\"i\"),lt={position:\"absolute\",visibility:\"hidden\",display:\"block\"},ut={letterSpacing:\"0\",fontWeight:\"400\"},ct=[\"Webkit\",\"O\",\"Moz\",\"ms\"];re.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Ze(e,\"opacity\");return\"\"===n?\"1\":n}}}},cssNumber:{columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{float:ne.cssFloat?\"cssFloat\":\"styleFloat\"},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=re.camelCase(t),l=e.style;if(t=re.cssProps[s]||(re.cssProps[s]=S(l,s)),a=re.cssHooks[t]||re.cssHooks[s],void 0===n)return a&&\"get\"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];if(o=typeof n,\"string\"===o&&(i=st.exec(n))&&(n=(i[1]+1)*i[2]+parseFloat(re.css(e,t)),o=\"number\"),null!=n&&n===n&&(\"number\"!==o||re.cssNumber[s]||(n+=\"px\"),ne.clearCloneStyle||\"\"!==n||0!==t.indexOf(\"background\")||(l[t]=\"inherit\"),!(a&&\"set\"in a&&void 0===(n=a.set(e,n,r)))))try{l[t]=n}catch(e){}}},css:function(e,t,n,r){var i,o,a,s=re.camelCase(t);return t=re.cssProps[s]||(re.cssProps[s]=S(e.style,s)),a=re.cssHooks[t]||re.cssHooks[s],a&&\"get\"in a&&(o=a.get(e,!0,n)),void 0===o&&(o=Ze(e,t,r)),\"normal\"===o&&t in ut&&(o=ut[t]),\"\"===n||n?(i=parseFloat(o),!0===n||re.isNumeric(i)?i||0:o):o}}),re.each([\"height\",\"width\"],function(e,t){re.cssHooks[t]={get:function(e,n,r){if(n)return ot.test(re.css(e,\"display\"))&&0===e.offsetWidth?re.swap(e,lt,function(){return L(e,t,r)}):L(e,t,r)},set:function(e,n,r){var i=r&&Ke(e);return D(e,n,r?j(e,t,r,ne.boxSizing&&\"border-box\"===re.css(e,\"boxSizing\",!1,i),i):0)}}}),ne.opacity||(re.cssHooks.opacity={get:function(e,t){return it.test((t&&e.currentStyle?e.currentStyle.filter:e.style.filter)||\"\")?.01*parseFloat(RegExp.$1)+\"\":t?\"1\":\"\"},set:function(e,t){var n=e.style,r=e.currentStyle,i=re.isNumeric(t)?\"alpha(opacity=\"+100*t+\")\":\"\",o=r&&r.filter||n.filter||\"\";n.zoom=1,(t>=1||\"\"===t)&&\"\"===re.trim(o.replace(rt,\"\"))&&n.removeAttribute&&(n.removeAttribute(\"filter\"),\"\"===t||r&&!r.filter)||(n.filter=rt.test(o)?o.replace(rt,i):o+\" \"+i)}}),re.cssHooks.marginRight=k(ne.reliableMarginRight,function(e,t){if(t)return re.swap(e,{display:\"inline-block\"},Ze,[e,\"marginRight\"])}),re.each({margin:\"\",padding:\"\",border:\"Width\"},function(e,t){re.cssHooks[e+t]={expand:function(n){for(var r=0,i={},o=\"string\"==typeof n?n.split(\" \"):[n];r<4;r++)i[e+Ee[r]+t]=o[r]||o[r-2]||o[0];return i}},et.test(e)||(re.cssHooks[e+t].set=D)}),re.fn.extend({css:function(e,t){return Se(this,function(e,t,n){var r,i,o={},a=0;if(re.isArray(t)){for(r=Ke(e),i=t.length;a<i;a++)o[t[a]]=re.css(e,t[a],!1,r);return o}return void 0!==n?re.style(e,t,n):re.css(e,t)},e,t,arguments.length>1)},show:function(){return A(this,!0)},hide:function(){return A(this)},toggle:function(e){return\"boolean\"==typeof e?e?this.show():this.hide():this.each(function(){ke(this)?re(this).show():re(this).hide()})}}),re.Tween=H,H.prototype={constructor:H,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||\"swing\",this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(re.cssNumber[n]?\"\":\"px\")},cur:function(){var e=H.propHooks[this.prop];return e&&e.get?e.get(this):H.propHooks._default.get(this)},run:function(e){var t,n=H.propHooks[this.prop];return this.options.duration?this.pos=t=re.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):H.propHooks._default.set(this),this}},H.prototype.init.prototype=H.prototype,H.propHooks={_default:{get:function(e){var t;return null==e.elem[e.prop]||e.elem.style&&null!=e.elem.style[e.prop]?(t=re.css(e.elem,e.prop,\"\"),t&&\"auto\"!==t?t:0):e.elem[e.prop]},set:function(e){re.fx.step[e.prop]?re.fx.step[e.prop](e):e.elem.style&&(null!=e.elem.style[re.cssProps[e.prop]]||re.cssHooks[e.prop])?re.style(e.elem,e.prop,e.now+e.unit):e.elem[e.prop]=e.now}}},H.propHooks.scrollTop=H.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},re.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2}},re.fx=H.prototype.init,re.fx.step={};var ft,dt,pt=/^(?:toggle|show|hide)$/,ht=new RegExp(\"^(?:([+-])=|)(\"+Ne+\")([a-z%]*)$\",\"i\"),mt=/queueHooks$/,gt=[F],vt={\"*\":[function(e,t){var n=this.createTween(e,t),r=n.cur(),i=ht.exec(t),o=i&&i[3]||(re.cssNumber[e]?\"\":\"px\"),a=(re.cssNumber[e]||\"px\"!==o&&+r)&&ht.exec(re.css(n.elem,e)),s=1,l=20;if(a&&a[3]!==o){o=o||a[3],i=i||[],a=+r||1;do{s=s||\".5\",a/=s,re.style(n.elem,e,a+o)}while(s!==(s=n.cur()/r)&&1!==s&&--l)}return i&&(a=n.start=+a||+r||0,n.unit=o,n.end=i[1]?a+(i[1]+1)*i[2]:+i[2]),n}]};re.Animation=re.extend(B,{tweener:function(e,t){re.isFunction(e)?(t=e,e=[\"*\"]):e=e.split(\" \");for(var n,r=0,i=e.length;r<i;r++)n=e[r],vt[n]=vt[n]||[],vt[n].unshift(t)},prefilter:function(e,t){t?gt.unshift(e):gt.push(e)}}),re.speed=function(e,t,n){var r=e&&\"object\"==typeof e?re.extend({},e):{complete:n||!n&&t||re.isFunction(e)&&e,duration:e,easing:n&&t||t&&!re.isFunction(t)&&t};return r.duration=re.fx.off?0:\"number\"==typeof r.duration?r.duration:r.duration in re.fx.speeds?re.fx.speeds[r.duration]:re.fx.speeds._default,null!=r.queue&&!0!==r.queue||(r.queue=\"fx\"),r.old=r.complete,r.complete=function(){re.isFunction(r.old)&&r.old.call(this),r.queue&&re.dequeue(this,r.queue)},r},re.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ke).css(\"opacity\",0).show().end().animate({opacity:t},e,n,r)},animate:function(e,t,n,r){var i=re.isEmptyObject(e),o=re.speed(t,n,r),a=function(){var t=B(this,re.extend({},e),o);(i||re._data(this,\"finish\"))&&t.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(e,t,n){var r=function(e){var t=e.stop;delete e.stop,t(n)};return\"string\"!=typeof e&&(n=t,t=e,e=void 0),t&&!1!==e&&this.queue(e||\"fx\",[]),this.each(function(){var t=!0,i=null!=e&&e+\"queueHooks\",o=re.timers,a=re._data(this);if(i)a[i]&&a[i].stop&&r(a[i]);else for(i in a)a[i]&&a[i].stop&&mt.test(i)&&r(a[i]);for(i=o.length;i--;)o[i].elem!==this||null!=e&&o[i].queue!==e||(o[i].anim.stop(n),t=!1,o.splice(i,1));!t&&n||re.dequeue(this,e)})},finish:function(e){return!1!==e&&(e=e||\"fx\"),this.each(function(){var t,n=re._data(this),r=n[e+\"queue\"],i=n[e+\"queueHooks\"],o=re.timers,a=r?r.length:0;for(n.finish=!0,re.queue(this,e,[]),i&&i.stop&&i.stop.call(this,!0),t=o.length;t--;)o[t].elem===this&&o[t].queue===e&&(o[t].anim.stop(!0),o.splice(t,1));for(t=0;t<a;t++)r[t]&&r[t].finish&&r[t].finish.call(this);delete n.finish})}}),re.each([\"toggle\",\"show\",\"hide\"],function(e,t){var n=re.fn[t];re.fn[t]=function(e,r,i){return null==e||\"boolean\"==typeof e?n.apply(this,arguments):this.animate(_(t,!0),e,r,i)}}),re.each({slideDown:_(\"show\"),slideUp:_(\"hide\"),slideToggle:_(\"toggle\"),fadeIn:{opacity:\"show\"},fadeOut:{opacity:\"hide\"},fadeToggle:{opacity:\"toggle\"}},function(e,t){re.fn[e]=function(e,n,r){return this.animate(t,e,n,r)}}),re.timers=[],re.fx.tick=function(){var e,t=re.timers,n=0;for(ft=re.now();n<t.length;n++)(e=t[n])()||t[n]!==e||t.splice(n--,1);t.length||re.fx.stop(),ft=void 0},re.fx.timer=function(e){re.timers.push(e),e()?re.fx.start():re.timers.pop()},re.fx.interval=13,re.fx.start=function(){dt||(dt=setInterval(re.fx.tick,re.fx.interval))},re.fx.stop=function(){clearInterval(dt),dt=null},re.fx.speeds={slow:600,fast:200,_default:400},re.fn.delay=function(e,t){return e=re.fx?re.fx.speeds[e]||e:e,t=t||\"fx\",this.queue(t,function(t,n){var r=setTimeout(t,e);n.stop=function(){clearTimeout(r)}})},function(){var e,t,n,r,i;t=pe.createElement(\"div\"),t.setAttribute(\"className\",\"t\"),t.innerHTML=\"  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>\",r=t.getElementsByTagName(\"a\")[0],n=pe.createElement(\"select\"),i=n.appendChild(pe.createElement(\"option\")),e=t.getElementsByTagName(\"input\")[0],r.style.cssText=\"top:1px\",ne.getSetAttribute=\"t\"!==t.className,ne.style=/top/.test(r.getAttribute(\"style\")),ne.hrefNormalized=\"/a\"===r.getAttribute(\"href\"),ne.checkOn=!!e.value,ne.optSelected=i.selected,ne.enctype=!!pe.createElement(\"form\").enctype,n.disabled=!0,ne.optDisabled=!i.disabled,e=pe.createElement(\"input\"),e.setAttribute(\"value\",\"\"),ne.input=\"\"===e.getAttribute(\"value\"),e.value=\"t\",e.setAttribute(\"type\",\"radio\"),ne.radioValue=\"t\"===e.value}();var yt=/\\r/g;re.fn.extend({val:function(e){var t,n,r,i=this[0];{if(arguments.length)return r=re.isFunction(e),this.each(function(n){var i;1===this.nodeType&&(i=r?e.call(this,n,re(this).val()):e,null==i?i=\"\":\"number\"==typeof i?i+=\"\":re.isArray(i)&&(i=re.map(i,function(e){return null==e?\"\":e+\"\"})),(t=re.valHooks[this.type]||re.valHooks[this.nodeName.toLowerCase()])&&\"set\"in t&&void 0!==t.set(this,i,\"value\")||(this.value=i))});if(i)return(t=re.valHooks[i.type]||re.valHooks[i.nodeName.toLowerCase()])&&\"get\"in t&&void 0!==(n=t.get(i,\"value\"))?n:(n=i.value,\"string\"==typeof n?n.replace(yt,\"\"):null==n?\"\":n)}}}),re.extend({valHooks:{option:{get:function(e){var t=re.find.attr(e,\"value\");return null!=t?t:re.trim(re.text(e))}},select:{get:function(e){for(var t,n,r=e.options,i=e.selectedIndex,o=\"select-one\"===e.type||i<0,a=o?null:[],s=o?i+1:r.length,l=i<0?s:o?i:0;l<s;l++)if(n=r[l],(n.selected||l===i)&&(ne.optDisabled?!n.disabled:null===n.getAttribute(\"disabled\"))&&(!n.parentNode.disabled||!re.nodeName(n.parentNode,\"optgroup\"))){if(t=re(n).val(),o)return t;a.push(t)}return a},set:function(e,t){for(var n,r,i=e.options,o=re.makeArray(t),a=i.length;a--;)if(r=i[a],re.inArray(re.valHooks.option.get(r),o)>=0)try{r.selected=n=!0}catch(e){r.scrollHeight}else r.selected=!1;return n||(e.selectedIndex=-1),i}}}}),re.each([\"radio\",\"checkbox\"],function(){re.valHooks[this]={set:function(e,t){if(re.isArray(t))return e.checked=re.inArray(re(e).val(),t)>=0}},ne.checkOn||(re.valHooks[this].get=function(e){return null===e.getAttribute(\"value\")?\"on\":e.value})});var bt,xt,wt=re.expr.attrHandle,Tt=/^(?:checked|selected)$/i,Ct=ne.getSetAttribute,Nt=ne.input;re.fn.extend({attr:function(e,t){return Se(this,re.attr,e,t,arguments.length>1)},removeAttr:function(e){return this.each(function(){re.removeAttr(this,e)})}}),re.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(e&&3!==o&&8!==o&&2!==o)return typeof e.getAttribute===we?re.prop(e,t,n):(1===o&&re.isXMLDoc(e)||(t=t.toLowerCase(),r=re.attrHooks[t]||(re.expr.match.bool.test(t)?xt:bt)),void 0===n?r&&\"get\"in r&&null!==(i=r.get(e,t))?i:(i=re.find.attr(e,t),null==i?void 0:i):null!==n?r&&\"set\"in r&&void 0!==(i=r.set(e,n,t))?i:(e.setAttribute(t,n+\"\"),n):void re.removeAttr(e,t))},removeAttr:function(e,t){var n,r,i=0,o=t&&t.match(ve);if(o&&1===e.nodeType)for(;n=o[i++];)r=re.propFix[n]||n,re.expr.match.bool.test(n)?Nt&&Ct||!Tt.test(n)?e[r]=!1:e[re.camelCase(\"default-\"+n)]=e[r]=!1:re.attr(e,n,\"\"),e.removeAttribute(Ct?n:r)},attrHooks:{type:{set:function(e,t){if(!ne.radioValue&&\"radio\"===t&&re.nodeName(e,\"input\")){var n=e.value;return e.setAttribute(\"type\",t),n&&(e.value=n),t}}}}}),xt={set:function(e,t,n){return!1===t?re.removeAttr(e,n):Nt&&Ct||!Tt.test(n)?e.setAttribute(!Ct&&re.propFix[n]||n,n):e[re.camelCase(\"default-\"+n)]=e[n]=!0,n}},re.each(re.expr.match.bool.source.match(/\\w+/g),function(e,t){var n=wt[t]||re.find.attr;wt[t]=Nt&&Ct||!Tt.test(t)?function(e,t,r){var i,o;return r||(o=wt[t],wt[t]=i,i=null!=n(e,t,r)?t.toLowerCase():null,wt[t]=o),i}:function(e,t,n){if(!n)return e[re.camelCase(\"default-\"+t)]?t.toLowerCase():null}}),Nt&&Ct||(re.attrHooks.value={set:function(e,t,n){if(!re.nodeName(e,\"input\"))return bt&&bt.set(e,t,n);e.defaultValue=t}}),Ct||(bt={set:function(e,t,n){var r=e.getAttributeNode(n);if(r||e.setAttributeNode(r=e.ownerDocument.createAttribute(n)),r.value=t+=\"\",\"value\"===n||t===e.getAttribute(n))return t}},wt.id=wt.name=wt.coords=function(e,t,n){var r;if(!n)return(r=e.getAttributeNode(t))&&\"\"!==r.value?r.value:null},re.valHooks.button={get:function(e,t){var n=e.getAttributeNode(t);if(n&&n.specified)return n.value},set:bt.set},re.attrHooks.contenteditable={set:function(e,t,n){bt.set(e,\"\"!==t&&t,n)}},re.each([\"width\",\"height\"],function(e,t){re.attrHooks[t]={set:function(e,n){if(\"\"===n)return e.setAttribute(t,\"auto\"),n}}})),ne.style||(re.attrHooks.style={get:function(e){return e.style.cssText||void 0},set:function(e,t){return e.style.cssText=t+\"\"}});var Et=/^(?:input|select|textarea|button|object)$/i,kt=/^(?:a|area)$/i;re.fn.extend({prop:function(e,t){return Se(this,re.prop,e,t,arguments.length>1)},removeProp:function(e){return e=re.propFix[e]||e,this.each(function(){try{this[e]=void 0,delete this[e]}catch(e){}})}}),re.extend({propFix:{for:\"htmlFor\",class:\"className\"},prop:function(e,t,n){var r,i,o,a=e.nodeType;if(e&&3!==a&&8!==a&&2!==a)return o=1!==a||!re.isXMLDoc(e),o&&(t=re.propFix[t]||t,i=re.propHooks[t]),void 0!==n?i&&\"set\"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&\"get\"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=re.find.attr(e,\"tabindex\");return t?parseInt(t,10):Et.test(e.nodeName)||kt.test(e.nodeName)&&e.href?0:-1}}}}),ne.hrefNormalized||re.each([\"href\",\"src\"],function(e,t){re.propHooks[t]={get:function(e){return e.getAttribute(t,4)}}}),ne.optSelected||(re.propHooks.selected={get:function(e){var t=e.parentNode;return t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex),null}}),re.each([\"tabIndex\",\"readOnly\",\"maxLength\",\"cellSpacing\",\"cellPadding\",\"rowSpan\",\"colSpan\",\"useMap\",\"frameBorder\",\"contentEditable\"],function(){re.propFix[this.toLowerCase()]=this}),ne.enctype||(re.propFix.enctype=\"encoding\");var St=/[\\t\\r\\n\\f]/g;re.fn.extend({addClass:function(e){var t,n,r,i,o,a,s=0,l=this.length,u=\"string\"==typeof e&&e;if(re.isFunction(e))return this.each(function(t){re(this).addClass(e.call(this,t,this.className))});if(u)for(t=(e||\"\").match(ve)||[];s<l;s++)if(n=this[s],r=1===n.nodeType&&(n.className?(\" \"+n.className+\" \").replace(St,\" \"):\" \")){for(o=0;i=t[o++];)r.indexOf(\" \"+i+\" \")<0&&(r+=i+\" \");a=re.trim(r),n.className!==a&&(n.className=a)}return this},removeClass:function(e){var t,n,r,i,o,a,s=0,l=this.length,u=0===arguments.length||\"string\"==typeof e&&e;if(re.isFunction(e))return this.each(function(t){re(this).removeClass(e.call(this,t,this.className))});if(u)for(t=(e||\"\").match(ve)||[];s<l;s++)if(n=this[s],r=1===n.nodeType&&(n.className?(\" \"+n.className+\" \").replace(St,\" \"):\"\")){for(o=0;i=t[o++];)for(;r.indexOf(\" \"+i+\" \")>=0;)r=r.replace(\" \"+i+\" \",\" \");a=e?re.trim(r):\"\",n.className!==a&&(n.className=a)}return this},toggleClass:function(e,t){var n=typeof e;return\"boolean\"==typeof t&&\"string\"===n?t?this.addClass(e):this.removeClass(e):re.isFunction(e)?this.each(function(n){re(this).toggleClass(e.call(this,n,this.className,t),t)}):this.each(function(){if(\"string\"===n)for(var t,r=0,i=re(this),o=e.match(ve)||[];t=o[r++];)i.hasClass(t)?i.removeClass(t):i.addClass(t);else n!==we&&\"boolean\"!==n||(this.className&&re._data(this,\"__className__\",this.className),this.className=this.className||!1===e?\"\":re._data(this,\"__className__\")||\"\")})},hasClass:function(e){for(var t=\" \"+e+\" \",n=0,r=this.length;n<r;n++)if(1===this[n].nodeType&&(\" \"+this[n].className+\" \").replace(St,\" \").indexOf(t)>=0)return!0;return!1}}),re.each(\"blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu\".split(\" \"),function(e,t){re.fn[t]=function(e,n){return arguments.length>0?this.on(t,null,e,n):this.trigger(t)}}),re.fn.extend({hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)},bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,\"**\"):this.off(t,e||\"**\",n)}});var At=re.now(),Dt=/\\?/,jt=/(,)|(\\[|{)|(}|])|\"(?:[^\"\\\\\\r\\n]|\\\\[\"\\\\\\/bfnrt]|\\\\u[\\da-fA-F]{4})*\"\\s*:?|true|false|null|-?(?!0\\d)\\d+(?:\\.\\d+|)(?:[eE][+-]?\\d+|)/g;re.parseJSON=function(t){if(e.JSON&&e.JSON.parse)return e.JSON.parse(t+\"\");var n,r=null,i=re.trim(t+\"\");return i&&!re.trim(i.replace(jt,function(e,t,i,o){return n&&t&&(r=0),0===r?e:(n=i||t,r+=!o-!i,\"\")}))?Function(\"return \"+i)():re.error(\"Invalid JSON: \"+t)},re.parseXML=function(t){var n,r;if(!t||\"string\"!=typeof t)return null;try{e.DOMParser?(r=new DOMParser,n=r.parseFromString(t,\"text/xml\")):(n=new ActiveXObject(\"Microsoft.XMLDOM\"),n.async=\"false\",n.loadXML(t))}catch(e){n=void 0}return n&&n.documentElement&&!n.getElementsByTagName(\"parsererror\").length||re.error(\"Invalid XML: \"+t),n};var Lt,Ht,qt=/#.*$/,_t=/([?&])_=[^&]*/,Mt=/^(.*?):[ \\t]*([^\\r\\n]*)\\r?$/gm,Ft=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Ot=/^(?:GET|HEAD)$/,Bt=/^\\/\\//,Pt=/^([\\w.+-]+:)(?:\\/\\/(?:[^\\/?#]*@|)([^\\/?#:]*)(?::(\\d+)|)|)/,Rt={},Wt={},$t=\"*/\".concat(\"*\");try{Ht=location.href}catch(e){Ht=pe.createElement(\"a\"),Ht.href=\"\",Ht=Ht.href}Lt=Pt.exec(Ht.toLowerCase())||[],re.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Ht,type:\"GET\",isLocal:Ft.test(Lt[1]),global:!0,processData:!0,async:!0,contentType:\"application/x-www-form-urlencoded; charset=UTF-8\",accepts:{\"*\":$t,text:\"text/plain\",html:\"text/html\",xml:\"application/xml, text/xml\",json:\"application/json, text/javascript\"},contents:{xml:/xml/,html:/html/,json:/json/},responseFields:{xml:\"responseXML\",text:\"responseText\",json:\"responseJSON\"},converters:{\"* text\":String,\"text html\":!0,\"text json\":re.parseJSON,\"text xml\":re.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?W(W(e,re.ajaxSettings),t):W(re.ajaxSettings,e)},ajaxPrefilter:P(Rt),ajaxTransport:P(Wt),ajax:function(e,t){function n(e,t,n,r){var i,c,v,y,x,T=t;2!==b&&(b=2,s&&clearTimeout(s),u=void 0,a=r||\"\",w.readyState=e>0?4:0,i=e>=200&&e<300||304===e,n&&(y=$(f,w,n)),y=z(f,y,w,i),i?(f.ifModified&&(x=w.getResponseHeader(\"Last-Modified\"),x&&(re.lastModified[o]=x),(x=w.getResponseHeader(\"etag\"))&&(re.etag[o]=x)),204===e||\"HEAD\"===f.type?T=\"nocontent\":304===e?T=\"notmodified\":(T=y.state,c=y.data,v=y.error,i=!v)):(v=T,!e&&T||(T=\"error\",e<0&&(e=0))),w.status=e,w.statusText=(t||T)+\"\",i?h.resolveWith(d,[c,T,w]):h.rejectWith(d,[w,T,v]),w.statusCode(g),g=void 0,l&&p.trigger(i?\"ajaxSuccess\":\"ajaxError\",[w,f,i?c:v]),m.fireWith(d,[w,T]),l&&(p.trigger(\"ajaxComplete\",[w,f]),--re.active||re.event.trigger(\"ajaxStop\")))}\"object\"==typeof e&&(t=e,e=void 0),t=t||{};var r,i,o,a,s,l,u,c,f=re.ajaxSetup({},t),d=f.context||f,p=f.context&&(d.nodeType||d.jquery)?re(d):re.event,h=re.Deferred(),m=re.Callbacks(\"once memory\"),g=f.statusCode||{},v={},y={},b=0,x=\"canceled\",w={readyState:0,getResponseHeader:function(e){var t;if(2===b){if(!c)for(c={};t=Mt.exec(a);)c[t[1].toLowerCase()]=t[2];t=c[e.toLowerCase()]}return null==t?null:t},getAllResponseHeaders:function(){return 2===b?a:null},setRequestHeader:function(e,t){var n=e.toLowerCase();return b||(e=y[n]=y[n]||e,v[e]=t),this},overrideMimeType:function(e){return b||(f.mimeType=e),this},statusCode:function(e){var t;if(e)if(b<2)for(t in e)g[t]=[g[t],e[t]];else w.always(e[w.status]);return this},abort:function(e){var t=e||x;return u&&u.abort(t),n(0,t),this}};if(h.promise(w).complete=m.add,w.success=w.done,w.error=w.fail,f.url=((e||f.url||Ht)+\"\").replace(qt,\"\").replace(Bt,Lt[1]+\"//\"),f.type=t.method||t.type||f.method||f.type,f.dataTypes=re.trim(f.dataType||\"*\").toLowerCase().match(ve)||[\"\"],null==f.crossDomain&&(r=Pt.exec(f.url.toLowerCase()),f.crossDomain=!(!r||r[1]===Lt[1]&&r[2]===Lt[2]&&(r[3]||(\"http:\"===r[1]?\"80\":\"443\"))===(Lt[3]||(\"http:\"===Lt[1]?\"80\":\"443\")))),f.data&&f.processData&&\"string\"!=typeof f.data&&(f.data=re.param(f.data,f.traditional)),R(Rt,f,t,w),2===b)return w;l=re.event&&f.global,l&&0==re.active++&&re.event.trigger(\"ajaxStart\"),f.type=f.type.toUpperCase(),f.hasContent=!Ot.test(f.type),o=f.url,f.hasContent||(f.data&&(o=f.url+=(Dt.test(o)?\"&\":\"?\")+f.data,delete f.data),!1===f.cache&&(f.url=_t.test(o)?o.replace(_t,\"$1_=\"+At++):o+(Dt.test(o)?\"&\":\"?\")+\"_=\"+At++)),f.ifModified&&(re.lastModified[o]&&w.setRequestHeader(\"If-Modified-Since\",re.lastModified[o]),re.etag[o]&&w.setRequestHeader(\"If-None-Match\",re.etag[o])),(f.data&&f.hasContent&&!1!==f.contentType||t.contentType)&&w.setRequestHeader(\"Content-Type\",f.contentType),w.setRequestHeader(\"Accept\",f.dataTypes[0]&&f.accepts[f.dataTypes[0]]?f.accepts[f.dataTypes[0]]+(\"*\"!==f.dataTypes[0]?\", \"+$t+\"; q=0.01\":\"\"):f.accepts[\"*\"]);for(i in f.headers)w.setRequestHeader(i,f.headers[i]);if(f.beforeSend&&(!1===f.beforeSend.call(d,w,f)||2===b))return w.abort();x=\"abort\";for(i in{success:1,error:1,complete:1})w[i](f[i]);if(u=R(Wt,f,t,w)){w.readyState=1,l&&p.trigger(\"ajaxSend\",[w,f]),f.async&&f.timeout>0&&(s=setTimeout(function(){w.abort(\"timeout\")},f.timeout));try{b=1,u.send(v,n)}catch(e){if(!(b<2))throw e;n(-1,e)}}else n(-1,\"No Transport\");return w},getJSON:function(e,t,n){return re.get(e,t,n,\"json\")},getScript:function(e,t){return re.get(e,void 0,t,\"script\")}}),re.each([\"get\",\"post\"],function(e,t){re[t]=function(e,n,r,i){return re.isFunction(n)&&(i=i||r,r=n,n=void 0),re.ajax({url:e,type:t,dataType:i,data:n,success:r})}}),re._evalUrl=function(e){return re.ajax({url:e,type:\"GET\",dataType:\"script\",async:!1,global:!1,throws:!0})},re.fn.extend({wrapAll:function(e){if(re.isFunction(e))return this.each(function(t){re(this).wrapAll(e.call(this,t))});if(this[0]){var t=re(e,this[0].ownerDocument).eq(0).clone(!0);this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){for(var e=this;e.firstChild&&1===e.firstChild.nodeType;)e=e.firstChild;return e}).append(this)}return this},wrapInner:function(e){return re.isFunction(e)?this.each(function(t){re(this).wrapInner(e.call(this,t))}):this.each(function(){var t=re(this),n=t.contents();n.length?n.wrapAll(e):t.append(e)})},wrap:function(e){var t=re.isFunction(e);return this.each(function(n){re(this).wrapAll(t?e.call(this,n):e)})},unwrap:function(){return this.parent().each(function(){re.nodeName(this,\"body\")||re(this).replaceWith(this.childNodes)}).end()}}),re.expr.filters.hidden=function(e){return e.offsetWidth<=0&&e.offsetHeight<=0||!ne.reliableHiddenOffsets()&&\"none\"===(e.style&&e.style.display||re.css(e,\"display\"))},re.expr.filters.visible=function(e){return!re.expr.filters.hidden(e)};var zt=/%20/g,It=/\\[\\]$/,Xt=/\\r?\\n/g,Ut=/^(?:submit|button|image|reset|file)$/i,Vt=/^(?:input|select|textarea|keygen)/i;re.param=function(e,t){var n,r=[],i=function(e,t){t=re.isFunction(t)?t():null==t?\"\":t,r[r.length]=encodeURIComponent(e)+\"=\"+encodeURIComponent(t)};if(void 0===t&&(t=re.ajaxSettings&&re.ajaxSettings.traditional),re.isArray(e)||e.jquery&&!re.isPlainObject(e))re.each(e,function(){i(this.name,this.value)});else for(n in e)I(n,e[n],t,i);return r.join(\"&\").replace(zt,\"+\")},re.fn.extend({serialize:function(){return re.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=re.prop(this,\"elements\");return e?re.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!re(this).is(\":disabled\")&&Vt.test(this.nodeName)&&!Ut.test(e)&&(this.checked||!Ae.test(e))}).map(function(e,t){var n=re(this).val();return null==n?null:re.isArray(n)?re.map(n,function(e){return{name:t.name,value:e.replace(Xt,\"\\r\\n\")}}):{name:t.name,value:n.replace(Xt,\"\\r\\n\")}}).get()}}),re.ajaxSettings.xhr=void 0!==e.ActiveXObject?function(){return!this.isLocal&&/^(get|post|head|put|delete|options)$/i.test(this.type)&&X()||U()}:X;var Jt=0,Yt={},Gt=re.ajaxSettings.xhr();e.attachEvent&&e.attachEvent(\"onunload\",function(){for(var e in Yt)Yt[e](void 0,!0)}),ne.cors=!!Gt&&\"withCredentials\"in Gt,Gt=ne.ajax=!!Gt,Gt&&re.ajaxTransport(function(e){if(!e.crossDomain||ne.cors){var t;return{send:function(n,r){var i,o=e.xhr(),a=++Jt;if(o.open(e.type,e.url,e.async,e.username,e.password),e.xhrFields)for(i in e.xhrFields)o[i]=e.xhrFields[i];e.mimeType&&o.overrideMimeType&&o.overrideMimeType(e.mimeType),e.crossDomain||n[\"X-Requested-With\"]||(n[\"X-Requested-With\"]=\"XMLHttpRequest\");for(i in n)void 0!==n[i]&&o.setRequestHeader(i,n[i]+\"\");o.send(e.hasContent&&e.data||null),t=function(n,i){var s,l,u;if(t&&(i||4===o.readyState))if(delete Yt[a],t=void 0,o.onreadystatechange=re.noop,i)4!==o.readyState&&o.abort();else{u={},s=o.status,\"string\"==typeof o.responseText&&(u.text=o.responseText);try{l=o.statusText}catch(e){l=\"\"}s||!e.isLocal||e.crossDomain?1223===s&&(s=204):s=u.text?200:404}u&&r(s,l,u,o.getAllResponseHeaders())},e.async?4===o.readyState?setTimeout(t):o.onreadystatechange=Yt[a]=t:t()},abort:function(){t&&t(void 0,!0)}}}}),re.ajaxSetup({accepts:{script:\"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript\"},contents:{script:/(?:java|ecma)script/},converters:{\"text script\":function(e){return re.globalEval(e),e}}}),re.ajaxPrefilter(\"script\",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type=\"GET\",e.global=!1)}),re.ajaxTransport(\"script\",function(e){if(e.crossDomain){var t,n=pe.head||re(\"head\")[0]||pe.documentElement;return{send:function(r,i){t=pe.createElement(\"script\"),t.async=!0,e.scriptCharset&&(t.charset=e.scriptCharset),t.src=e.url,t.onload=t.onreadystatechange=function(e,n){(n||!t.readyState||/loaded|complete/.test(t.readyState))&&(t.onload=t.onreadystatechange=null,t.parentNode&&t.parentNode.removeChild(t),t=null,n||i(200,\"success\"))},n.insertBefore(t,n.firstChild)},abort:function(){t&&t.onload(void 0,!0)}}}});var Qt=[],Kt=/(=)\\?(?=&|$)|\\?\\?/;re.ajaxSetup({jsonp:\"callback\",jsonpCallback:function(){var e=Qt.pop()||re.expando+\"_\"+At++;return this[e]=!0,e}}),re.ajaxPrefilter(\"json jsonp\",function(t,n,r){var i,o,a,s=!1!==t.jsonp&&(Kt.test(t.url)?\"url\":\"string\"==typeof t.data&&!(t.contentType||\"\").indexOf(\"application/x-www-form-urlencoded\")&&Kt.test(t.data)&&\"data\");if(s||\"jsonp\"===t.dataTypes[0])return i=t.jsonpCallback=re.isFunction(t.jsonpCallback)?t.jsonpCallback():t.jsonpCallback,s?t[s]=t[s].replace(Kt,\"$1\"+i):!1!==t.jsonp&&(t.url+=(Dt.test(t.url)?\"&\":\"?\")+t.jsonp+\"=\"+i),t.converters[\"script json\"]=function(){return a||re.error(i+\" was not called\"),a[0]},t.dataTypes[0]=\"json\",o=e[i],e[i]=function(){a=arguments},r.always(function(){e[i]=o,t[i]&&(t.jsonpCallback=n.jsonpCallback,Qt.push(i)),a&&re.isFunction(o)&&o(a[0]),a=o=void 0}),\"script\"}),re.parseHTML=function(e,t,n){if(!e||\"string\"!=typeof e)return null;\"boolean\"==typeof t&&(n=t,t=!1),t=t||pe;var r=ce.exec(e),i=!n&&[];return r?[t.createElement(r[1])]:(r=re.buildFragment([e],t,i),i&&i.length&&re(i).remove(),re.merge([],r.childNodes))};var Zt=re.fn.load;re.fn.load=function(e,t,n){if(\"string\"!=typeof e&&Zt)return Zt.apply(this,arguments);var r,i,o,a=this,s=e.indexOf(\" \");return s>=0&&(r=re.trim(e.slice(s,e.length)),e=e.slice(0,s)),re.isFunction(t)?(n=t,t=void 0):t&&\"object\"==typeof t&&(o=\"POST\"),a.length>0&&re.ajax({url:e,type:o,dataType:\"html\",data:t}).done(function(e){i=arguments,a.html(r?re(\"<div>\").append(re.parseHTML(e)).find(r):e)}).complete(n&&function(e,t){a.each(n,i||[e.responseText,t,e])}),this},re.each([\"ajaxStart\",\"ajaxStop\",\"ajaxComplete\",\"ajaxError\",\"ajaxSuccess\",\"ajaxSend\"],function(e,t){re.fn[t]=function(e){return this.on(t,e)}}),re.expr.filters.animated=function(e){return re.grep(re.timers,function(t){return e===t.elem}).length};var en=e.document.documentElement;re.offset={setOffset:function(e,t,n){var r,i,o,a,s,l,u,c=re.css(e,\"position\"),f=re(e),d={};\"static\"===c&&(e.style.position=\"relative\"),s=f.offset(),o=re.css(e,\"top\"),l=re.css(e,\"left\"),u=(\"absolute\"===c||\"fixed\"===c)&&re.inArray(\"auto\",[o,l])>-1,u?(r=f.position(),a=r.top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(l)||0),re.isFunction(t)&&(t=t.call(e,n,s)),null!=t.top&&(d.top=t.top-s.top+a),null!=t.left&&(d.left=t.left-s.left+i),\"using\"in t?t.using.call(e,d):f.css(d)}},re.fn.extend({offset:function(e){if(arguments.length)return void 0===e?this:this.each(function(t){re.offset.setOffset(this,e,t)});var t,n,r={top:0,left:0},i=this[0],o=i&&i.ownerDocument;if(o)return t=o.documentElement,re.contains(t,i)?(typeof i.getBoundingClientRect!==we&&(r=i.getBoundingClientRect()),n=V(o),{top:r.top+(n.pageYOffset||t.scrollTop)-(t.clientTop||0),left:r.left+(n.pageXOffset||t.scrollLeft)-(t.clientLeft||0)}):r},position:function(){if(this[0]){var e,t,n={top:0,left:0},r=this[0];return\"fixed\"===re.css(r,\"position\")?t=r.getBoundingClientRect():(e=this.offsetParent(),t=this.offset(),re.nodeName(e[0],\"html\")||(n=e.offset()),n.top+=re.css(e[0],\"borderTopWidth\",!0),n.left+=re.css(e[0],\"borderLeftWidth\",!0)),{top:t.top-n.top-re.css(r,\"marginTop\",!0),left:t.left-n.left-re.css(r,\"marginLeft\",!0)}}},offsetParent:function(){return this.map(function(){for(var e=this.offsetParent||en;e&&!re.nodeName(e,\"html\")&&\"static\"===re.css(e,\"position\");)e=e.offsetParent;return e||en})}}),re.each({scrollLeft:\"pageXOffset\",scrollTop:\"pageYOffset\"},function(e,t){var n=/Y/.test(t);re.fn[e]=function(r){return Se(this,function(e,r,i){var o=V(e);if(void 0===i)return o?t in o?o[t]:o.document.documentElement[r]:e[r];o?o.scrollTo(n?re(o).scrollLeft():i,n?i:re(o).scrollTop()):e[r]=i},e,r,arguments.length,null)}}),re.each([\"top\",\"left\"],function(e,t){re.cssHooks[t]=k(ne.pixelPosition,function(e,n){if(n)return n=Ze(e,t),tt.test(n)?re(e).position()[t]+\"px\":n})}),re.each({Height:\"height\",Width:\"width\"},function(e,t){re.each({padding:\"inner\"+e,content:t,\"\":\"outer\"+e},function(n,r){re.fn[r]=function(r,i){var o=arguments.length&&(n||\"boolean\"!=typeof r),a=n||(!0===r||!0===i?\"margin\":\"border\");return Se(this,function(t,n,r){var i;return re.isWindow(t)?t.document.documentElement[\"client\"+e]:9===t.nodeType?(i=t.documentElement,\nMath.max(t.body[\"scroll\"+e],i[\"scroll\"+e],t.body[\"offset\"+e],i[\"offset\"+e],i[\"client\"+e])):void 0===r?re.css(t,n,a):re.style(t,n,r,a)},t,o?r:void 0,o,null)}})}),re.fn.size=function(){return this.length},re.fn.andSelf=re.fn.addBack,\"function\"==typeof define&&define.amd&&define(\"jquery\",[],function(){return re});var tn=e.jQuery,nn=e.$;return re.noConflict=function(t){return e.$===re&&(e.$=nn),t&&e.jQuery===re&&(e.jQuery=tn),re},typeof t===we&&(e.jQuery=e.$=re),re});"

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(81))

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	module.exports = "\"use strict\";\n\nvar _typeof = typeof Symbol === \"function\" && typeof Symbol.iterator === \"symbol\" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === \"function\" && obj.constructor === Symbol && obj !== Symbol.prototype ? \"symbol\" : typeof obj; };\n\n/*! jQuery UI - v1.12.1 - 2016-09-14\n* http://jqueryui.com\n* Includes: widget.js, position.js, data.js, disable-selection.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-scale.js, effects/effect-shake.js, effects/effect-size.js, effects/effect-slide.js, effects/effect-transfer.js, focusable.js, form-reset-mixin.js, jquery-1-7.js, keycode.js, labels.js, scroll-parent.js, tabbable.js, unique-id.js, widgets/accordion.js, widgets/autocomplete.js, widgets/button.js, widgets/checkboxradio.js, widgets/controlgroup.js, widgets/datepicker.js, widgets/dialog.js, widgets/draggable.js, widgets/droppable.js, widgets/menu.js, widgets/mouse.js, widgets/progressbar.js, widgets/resizable.js, widgets/selectable.js, widgets/selectmenu.js, widgets/slider.js, widgets/sortable.js, widgets/spinner.js, widgets/tabs.js, widgets/tooltip.js\n* Copyright jQuery Foundation and other contributors; Licensed MIT */\n\n(function (t) {\n  \"function\" == typeof define && define.amd ? define([\"jquery\"], t) : t(jQuery);\n})(function (t) {\n  function e(t) {\n    for (var e = t.css(\"visibility\"); \"inherit\" === e;) {\n      t = t.parent(), e = t.css(\"visibility\");\n    }return \"hidden\" !== e;\n  }function i(t) {\n    for (var e, i; t.length && t[0] !== document;) {\n      if (e = t.css(\"position\"), (\"absolute\" === e || \"relative\" === e || \"fixed\" === e) && (i = parseInt(t.css(\"zIndex\"), 10), !isNaN(i) && 0 !== i)) return i;t = t.parent();\n    }return 0;\n  }function s() {\n    this._curInst = null, this._keyEvent = !1, this._disabledInputs = [], this._datepickerShowing = !1, this._inDialog = !1, this._mainDivId = \"ui-datepicker-div\", this._inlineClass = \"ui-datepicker-inline\", this._appendClass = \"ui-datepicker-append\", this._triggerClass = \"ui-datepicker-trigger\", this._dialogClass = \"ui-datepicker-dialog\", this._disableClass = \"ui-datepicker-disabled\", this._unselectableClass = \"ui-datepicker-unselectable\", this._currentClass = \"ui-datepicker-current-day\", this._dayOverClass = \"ui-datepicker-days-cell-over\", this.regional = [], this.regional[\"\"] = { closeText: \"Done\", prevText: \"Prev\", nextText: \"Next\", currentText: \"Today\", monthNames: [\"January\", \"February\", \"March\", \"April\", \"May\", \"June\", \"July\", \"August\", \"September\", \"October\", \"November\", \"December\"], monthNamesShort: [\"Jan\", \"Feb\", \"Mar\", \"Apr\", \"May\", \"Jun\", \"Jul\", \"Aug\", \"Sep\", \"Oct\", \"Nov\", \"Dec\"], dayNames: [\"Sunday\", \"Monday\", \"Tuesday\", \"Wednesday\", \"Thursday\", \"Friday\", \"Saturday\"], dayNamesShort: [\"Sun\", \"Mon\", \"Tue\", \"Wed\", \"Thu\", \"Fri\", \"Sat\"], dayNamesMin: [\"Su\", \"Mo\", \"Tu\", \"We\", \"Th\", \"Fr\", \"Sa\"], weekHeader: \"Wk\", dateFormat: \"mm/dd/yy\", firstDay: 0, isRTL: !1, showMonthAfterYear: !1, yearSuffix: \"\" }, this._defaults = { showOn: \"focus\", showAnim: \"fadeIn\", showOptions: {}, defaultDate: null, appendText: \"\", buttonText: \"...\", buttonImage: \"\", buttonImageOnly: !1, hideIfNoPrevNext: !1, navigationAsDateFormat: !1, gotoCurrent: !1, changeMonth: !1, changeYear: !1, yearRange: \"c-10:c+10\", showOtherMonths: !1, selectOtherMonths: !1, showWeek: !1, calculateWeek: this.iso8601Week, shortYearCutoff: \"+10\", minDate: null, maxDate: null, duration: \"fast\", beforeShowDay: null, beforeShow: null, onSelect: null, onChangeMonthYear: null, onClose: null, numberOfMonths: 1, showCurrentAtPos: 0, stepMonths: 1, stepBigMonths: 12, altField: \"\", altFormat: \"\", constrainInput: !0, showButtonPanel: !1, autoSize: !1, disabled: !1 }, t.extend(this._defaults, this.regional[\"\"]), this.regional.en = t.extend(!0, {}, this.regional[\"\"]), this.regional[\"en-US\"] = t.extend(!0, {}, this.regional.en), this.dpDiv = n(t(\"<div id='\" + this._mainDivId + \"' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>\"));\n  }function n(e) {\n    var i = \"button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a\";return e.on(\"mouseout\", i, function () {\n      t(this).removeClass(\"ui-state-hover\"), -1 !== this.className.indexOf(\"ui-datepicker-prev\") && t(this).removeClass(\"ui-datepicker-prev-hover\"), -1 !== this.className.indexOf(\"ui-datepicker-next\") && t(this).removeClass(\"ui-datepicker-next-hover\");\n    }).on(\"mouseover\", i, o);\n  }function o() {\n    t.datepicker._isDisabledDatepicker(m.inline ? m.dpDiv.parent()[0] : m.input[0]) || (t(this).parents(\".ui-datepicker-calendar\").find(\"a\").removeClass(\"ui-state-hover\"), t(this).addClass(\"ui-state-hover\"), -1 !== this.className.indexOf(\"ui-datepicker-prev\") && t(this).addClass(\"ui-datepicker-prev-hover\"), -1 !== this.className.indexOf(\"ui-datepicker-next\") && t(this).addClass(\"ui-datepicker-next-hover\"));\n  }function a(e, i) {\n    t.extend(e, i);for (var s in i) {\n      null == i[s] && (e[s] = i[s]);\n    }return e;\n  }function r(t) {\n    return function () {\n      var e = this.element.val();t.apply(this, arguments), this._refresh(), e !== this.element.val() && this._trigger(\"change\");\n    };\n  }t.ui = t.ui || {}, t.ui.version = \"1.12.1\";var h = 0,\n      l = Array.prototype.slice;t.cleanData = function (e) {\n    return function (i) {\n      var s, n, o;for (o = 0; null != (n = i[o]); o++) {\n        try {\n          s = t._data(n, \"events\"), s && s.remove && t(n).triggerHandler(\"remove\");\n        } catch (a) {}\n      }e(i);\n    };\n  }(t.cleanData), t.widget = function (e, i, s) {\n    var n,\n        o,\n        a,\n        r = {},\n        h = e.split(\".\")[0];e = e.split(\".\")[1];var l = h + \"-\" + e;return s || (s = i, i = t.Widget), t.isArray(s) && (s = t.extend.apply(null, [{}].concat(s))), t.expr[\":\"][l.toLowerCase()] = function (e) {\n      return !!t.data(e, l);\n    }, t[h] = t[h] || {}, n = t[h][e], o = t[h][e] = function (t, e) {\n      return this._createWidget ? (arguments.length && this._createWidget(t, e), void 0) : new o(t, e);\n    }, t.extend(o, n, { version: s.version, _proto: t.extend({}, s), _childConstructors: [] }), a = new i(), a.options = t.widget.extend({}, a.options), t.each(s, function (e, s) {\n      return t.isFunction(s) ? (r[e] = function () {\n        function t() {\n          return i.prototype[e].apply(this, arguments);\n        }function n(t) {\n          return i.prototype[e].apply(this, t);\n        }return function () {\n          var e,\n              i = this._super,\n              o = this._superApply;return this._super = t, this._superApply = n, e = s.apply(this, arguments), this._super = i, this._superApply = o, e;\n        };\n      }(), void 0) : (r[e] = s, void 0);\n    }), o.prototype = t.widget.extend(a, { widgetEventPrefix: n ? a.widgetEventPrefix || e : e }, r, { constructor: o, namespace: h, widgetName: e, widgetFullName: l }), n ? (t.each(n._childConstructors, function (e, i) {\n      var s = i.prototype;t.widget(s.namespace + \".\" + s.widgetName, o, i._proto);\n    }), delete n._childConstructors) : i._childConstructors.push(o), t.widget.bridge(e, o), o;\n  }, t.widget.extend = function (e) {\n    for (var i, s, n = l.call(arguments, 1), o = 0, a = n.length; a > o; o++) {\n      for (i in n[o]) {\n        s = n[o][i], n[o].hasOwnProperty(i) && void 0 !== s && (e[i] = t.isPlainObject(s) ? t.isPlainObject(e[i]) ? t.widget.extend({}, e[i], s) : t.widget.extend({}, s) : s);\n      }\n    }return e;\n  }, t.widget.bridge = function (e, i) {\n    var s = i.prototype.widgetFullName || e;t.fn[e] = function (n) {\n      var o = \"string\" == typeof n,\n          a = l.call(arguments, 1),\n          r = this;return o ? this.length || \"instance\" !== n ? this.each(function () {\n        var i,\n            o = t.data(this, s);return \"instance\" === n ? (r = o, !1) : o ? t.isFunction(o[n]) && \"_\" !== n.charAt(0) ? (i = o[n].apply(o, a), i !== o && void 0 !== i ? (r = i && i.jquery ? r.pushStack(i.get()) : i, !1) : void 0) : t.error(\"no such method '\" + n + \"' for \" + e + \" widget instance\") : t.error(\"cannot call methods on \" + e + \" prior to initialization; \" + \"attempted to call method '\" + n + \"'\");\n      }) : r = void 0 : (a.length && (n = t.widget.extend.apply(null, [n].concat(a))), this.each(function () {\n        var e = t.data(this, s);e ? (e.option(n || {}), e._init && e._init()) : t.data(this, s, new i(n, this));\n      })), r;\n    };\n  }, t.Widget = function () {}, t.Widget._childConstructors = [], t.Widget.prototype = { widgetName: \"widget\", widgetEventPrefix: \"\", defaultElement: \"<div>\", options: { classes: {}, disabled: !1, create: null }, _createWidget: function _createWidget(e, i) {\n      i = t(i || this.defaultElement || this)[0], this.element = t(i), this.uuid = h++, this.eventNamespace = \".\" + this.widgetName + this.uuid, this.bindings = t(), this.hoverable = t(), this.focusable = t(), this.classesElementLookup = {}, i !== this && (t.data(i, this.widgetFullName, this), this._on(!0, this.element, { remove: function remove(t) {\n          t.target === i && this.destroy();\n        } }), this.document = t(i.style ? i.ownerDocument : i.document || i), this.window = t(this.document[0].defaultView || this.document[0].parentWindow)), this.options = t.widget.extend({}, this.options, this._getCreateOptions(), e), this._create(), this.options.disabled && this._setOptionDisabled(this.options.disabled), this._trigger(\"create\", null, this._getCreateEventData()), this._init();\n    }, _getCreateOptions: function _getCreateOptions() {\n      return {};\n    }, _getCreateEventData: t.noop, _create: t.noop, _init: t.noop, destroy: function destroy() {\n      var e = this;this._destroy(), t.each(this.classesElementLookup, function (t, i) {\n        e._removeClass(i, t);\n      }), this.element.off(this.eventNamespace).removeData(this.widgetFullName), this.widget().off(this.eventNamespace).removeAttr(\"aria-disabled\"), this.bindings.off(this.eventNamespace);\n    }, _destroy: t.noop, widget: function widget() {\n      return this.element;\n    }, option: function option(e, i) {\n      var s,\n          n,\n          o,\n          a = e;if (0 === arguments.length) return t.widget.extend({}, this.options);if (\"string\" == typeof e) if (a = {}, s = e.split(\".\"), e = s.shift(), s.length) {\n        for (n = a[e] = t.widget.extend({}, this.options[e]), o = 0; s.length - 1 > o; o++) {\n          n[s[o]] = n[s[o]] || {}, n = n[s[o]];\n        }if (e = s.pop(), 1 === arguments.length) return void 0 === n[e] ? null : n[e];n[e] = i;\n      } else {\n        if (1 === arguments.length) return void 0 === this.options[e] ? null : this.options[e];a[e] = i;\n      }return this._setOptions(a), this;\n    }, _setOptions: function _setOptions(t) {\n      var e;for (e in t) {\n        this._setOption(e, t[e]);\n      }return this;\n    }, _setOption: function _setOption(t, e) {\n      return \"classes\" === t && this._setOptionClasses(e), this.options[t] = e, \"disabled\" === t && this._setOptionDisabled(e), this;\n    }, _setOptionClasses: function _setOptionClasses(e) {\n      var i, s, n;for (i in e) {\n        n = this.classesElementLookup[i], e[i] !== this.options.classes[i] && n && n.length && (s = t(n.get()), this._removeClass(n, i), s.addClass(this._classes({ element: s, keys: i, classes: e, add: !0 })));\n      }\n    }, _setOptionDisabled: function _setOptionDisabled(t) {\n      this._toggleClass(this.widget(), this.widgetFullName + \"-disabled\", null, !!t), t && (this._removeClass(this.hoverable, null, \"ui-state-hover\"), this._removeClass(this.focusable, null, \"ui-state-focus\"));\n    }, enable: function enable() {\n      return this._setOptions({ disabled: !1 });\n    }, disable: function disable() {\n      return this._setOptions({ disabled: !0 });\n    }, _classes: function _classes(e) {\n      function i(i, o) {\n        var a, r;for (r = 0; i.length > r; r++) {\n          a = n.classesElementLookup[i[r]] || t(), a = e.add ? t(t.unique(a.get().concat(e.element.get()))) : t(a.not(e.element).get()), n.classesElementLookup[i[r]] = a, s.push(i[r]), o && e.classes[i[r]] && s.push(e.classes[i[r]]);\n        }\n      }var s = [],\n          n = this;return e = t.extend({ element: this.element, classes: this.options.classes || {} }, e), this._on(e.element, { remove: \"_untrackClassesElement\" }), e.keys && i(e.keys.match(/\\S+/g) || [], !0), e.extra && i(e.extra.match(/\\S+/g) || []), s.join(\" \");\n    }, _untrackClassesElement: function _untrackClassesElement(e) {\n      var i = this;t.each(i.classesElementLookup, function (s, n) {\n        -1 !== t.inArray(e.target, n) && (i.classesElementLookup[s] = t(n.not(e.target).get()));\n      });\n    }, _removeClass: function _removeClass(t, e, i) {\n      return this._toggleClass(t, e, i, !1);\n    }, _addClass: function _addClass(t, e, i) {\n      return this._toggleClass(t, e, i, !0);\n    }, _toggleClass: function _toggleClass(t, e, i, s) {\n      s = \"boolean\" == typeof s ? s : i;var n = \"string\" == typeof t || null === t,\n          o = { extra: n ? e : i, keys: n ? t : e, element: n ? this.element : t, add: s };return o.element.toggleClass(this._classes(o), s), this;\n    }, _on: function _on(e, i, s) {\n      var n,\n          o = this;\"boolean\" != typeof e && (s = i, i = e, e = !1), s ? (i = n = t(i), this.bindings = this.bindings.add(i)) : (s = i, i = this.element, n = this.widget()), t.each(s, function (s, a) {\n        function r() {\n          return e || o.options.disabled !== !0 && !t(this).hasClass(\"ui-state-disabled\") ? (\"string\" == typeof a ? o[a] : a).apply(o, arguments) : void 0;\n        }\"string\" != typeof a && (r.guid = a.guid = a.guid || r.guid || t.guid++);var h = s.match(/^([\\w:-]*)\\s*(.*)$/),\n            l = h[1] + o.eventNamespace,\n            c = h[2];c ? n.on(l, c, r) : i.on(l, r);\n      });\n    }, _off: function _off(e, i) {\n      i = (i || \"\").split(\" \").join(this.eventNamespace + \" \") + this.eventNamespace, e.off(i).off(i), this.bindings = t(this.bindings.not(e).get()), this.focusable = t(this.focusable.not(e).get()), this.hoverable = t(this.hoverable.not(e).get());\n    }, _delay: function _delay(t, e) {\n      function i() {\n        return (\"string\" == typeof t ? s[t] : t).apply(s, arguments);\n      }var s = this;return setTimeout(i, e || 0);\n    }, _hoverable: function _hoverable(e) {\n      this.hoverable = this.hoverable.add(e), this._on(e, { mouseenter: function mouseenter(e) {\n          this._addClass(t(e.currentTarget), null, \"ui-state-hover\");\n        }, mouseleave: function mouseleave(e) {\n          this._removeClass(t(e.currentTarget), null, \"ui-state-hover\");\n        } });\n    }, _focusable: function _focusable(e) {\n      this.focusable = this.focusable.add(e), this._on(e, { focusin: function focusin(e) {\n          this._addClass(t(e.currentTarget), null, \"ui-state-focus\");\n        }, focusout: function focusout(e) {\n          this._removeClass(t(e.currentTarget), null, \"ui-state-focus\");\n        } });\n    }, _trigger: function _trigger(e, i, s) {\n      var n,\n          o,\n          a = this.options[e];if (s = s || {}, i = t.Event(i), i.type = (e === this.widgetEventPrefix ? e : this.widgetEventPrefix + e).toLowerCase(), i.target = this.element[0], o = i.originalEvent) for (n in o) {\n        n in i || (i[n] = o[n]);\n      }return this.element.trigger(i, s), !(t.isFunction(a) && a.apply(this.element[0], [i].concat(s)) === !1 || i.isDefaultPrevented());\n    } }, t.each({ show: \"fadeIn\", hide: \"fadeOut\" }, function (e, i) {\n    t.Widget.prototype[\"_\" + e] = function (s, n, o) {\n      \"string\" == typeof n && (n = { effect: n });var a,\n          r = n ? n === !0 || \"number\" == typeof n ? i : n.effect || i : e;n = n || {}, \"number\" == typeof n && (n = { duration: n }), a = !t.isEmptyObject(n), n.complete = o, n.delay && s.delay(n.delay), a && t.effects && t.effects.effect[r] ? s[e](n) : r !== e && s[r] ? s[r](n.duration, n.easing, o) : s.queue(function (i) {\n        t(this)[e](), o && o.call(s[0]), i();\n      });\n    };\n  }), t.widget, function () {\n    function e(t, e, i) {\n      return [parseFloat(t[0]) * (u.test(t[0]) ? e / 100 : 1), parseFloat(t[1]) * (u.test(t[1]) ? i / 100 : 1)];\n    }function i(e, i) {\n      return parseInt(t.css(e, i), 10) || 0;\n    }function s(e) {\n      var i = e[0];return 9 === i.nodeType ? { width: e.width(), height: e.height(), offset: { top: 0, left: 0 } } : t.isWindow(i) ? { width: e.width(), height: e.height(), offset: { top: e.scrollTop(), left: e.scrollLeft() } } : i.preventDefault ? { width: 0, height: 0, offset: { top: i.pageY, left: i.pageX } } : { width: e.outerWidth(), height: e.outerHeight(), offset: e.offset() };\n    }var n,\n        o = Math.max,\n        a = Math.abs,\n        r = /left|center|right/,\n        h = /top|center|bottom/,\n        l = /[\\+\\-]\\d+(\\.[\\d]+)?%?/,\n        c = /^\\w+/,\n        u = /%$/,\n        d = t.fn.position;t.position = { scrollbarWidth: function scrollbarWidth() {\n        if (void 0 !== n) return n;var e,\n            i,\n            s = t(\"<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>\"),\n            o = s.children()[0];return t(\"body\").append(s), e = o.offsetWidth, s.css(\"overflow\", \"scroll\"), i = o.offsetWidth, e === i && (i = s[0].clientWidth), s.remove(), n = e - i;\n      }, getScrollInfo: function getScrollInfo(e) {\n        var i = e.isWindow || e.isDocument ? \"\" : e.element.css(\"overflow-x\"),\n            s = e.isWindow || e.isDocument ? \"\" : e.element.css(\"overflow-y\"),\n            n = \"scroll\" === i || \"auto\" === i && e.width < e.element[0].scrollWidth,\n            o = \"scroll\" === s || \"auto\" === s && e.height < e.element[0].scrollHeight;return { width: o ? t.position.scrollbarWidth() : 0, height: n ? t.position.scrollbarWidth() : 0 };\n      }, getWithinInfo: function getWithinInfo(e) {\n        var i = t(e || window),\n            s = t.isWindow(i[0]),\n            n = !!i[0] && 9 === i[0].nodeType,\n            o = !s && !n;return { element: i, isWindow: s, isDocument: n, offset: o ? t(e).offset() : { left: 0, top: 0 }, scrollLeft: i.scrollLeft(), scrollTop: i.scrollTop(), width: i.outerWidth(), height: i.outerHeight() };\n      } }, t.fn.position = function (n) {\n      if (!n || !n.of) return d.apply(this, arguments);n = t.extend({}, n);var u,\n          p,\n          f,\n          g,\n          m,\n          _,\n          v = t(n.of),\n          b = t.position.getWithinInfo(n.within),\n          y = t.position.getScrollInfo(b),\n          w = (n.collision || \"flip\").split(\" \"),\n          k = {};return _ = s(v), v[0].preventDefault && (n.at = \"left top\"), p = _.width, f = _.height, g = _.offset, m = t.extend({}, g), t.each([\"my\", \"at\"], function () {\n        var t,\n            e,\n            i = (n[this] || \"\").split(\" \");1 === i.length && (i = r.test(i[0]) ? i.concat([\"center\"]) : h.test(i[0]) ? [\"center\"].concat(i) : [\"center\", \"center\"]), i[0] = r.test(i[0]) ? i[0] : \"center\", i[1] = h.test(i[1]) ? i[1] : \"center\", t = l.exec(i[0]), e = l.exec(i[1]), k[this] = [t ? t[0] : 0, e ? e[0] : 0], n[this] = [c.exec(i[0])[0], c.exec(i[1])[0]];\n      }), 1 === w.length && (w[1] = w[0]), \"right\" === n.at[0] ? m.left += p : \"center\" === n.at[0] && (m.left += p / 2), \"bottom\" === n.at[1] ? m.top += f : \"center\" === n.at[1] && (m.top += f / 2), u = e(k.at, p, f), m.left += u[0], m.top += u[1], this.each(function () {\n        var s,\n            r,\n            h = t(this),\n            l = h.outerWidth(),\n            c = h.outerHeight(),\n            d = i(this, \"marginLeft\"),\n            _ = i(this, \"marginTop\"),\n            x = l + d + i(this, \"marginRight\") + y.width,\n            C = c + _ + i(this, \"marginBottom\") + y.height,\n            D = t.extend({}, m),\n            I = e(k.my, h.outerWidth(), h.outerHeight());\"right\" === n.my[0] ? D.left -= l : \"center\" === n.my[0] && (D.left -= l / 2), \"bottom\" === n.my[1] ? D.top -= c : \"center\" === n.my[1] && (D.top -= c / 2), D.left += I[0], D.top += I[1], s = { marginLeft: d, marginTop: _ }, t.each([\"left\", \"top\"], function (e, i) {\n          t.ui.position[w[e]] && t.ui.position[w[e]][i](D, { targetWidth: p, targetHeight: f, elemWidth: l, elemHeight: c, collisionPosition: s, collisionWidth: x, collisionHeight: C, offset: [u[0] + I[0], u[1] + I[1]], my: n.my, at: n.at, within: b, elem: h });\n        }), n.using && (r = function r(t) {\n          var e = g.left - D.left,\n              i = e + p - l,\n              s = g.top - D.top,\n              r = s + f - c,\n              u = { target: { element: v, left: g.left, top: g.top, width: p, height: f }, element: { element: h, left: D.left, top: D.top, width: l, height: c }, horizontal: 0 > i ? \"left\" : e > 0 ? \"right\" : \"center\", vertical: 0 > r ? \"top\" : s > 0 ? \"bottom\" : \"middle\" };l > p && p > a(e + i) && (u.horizontal = \"center\"), c > f && f > a(s + r) && (u.vertical = \"middle\"), u.important = o(a(e), a(i)) > o(a(s), a(r)) ? \"horizontal\" : \"vertical\", n.using.call(this, t, u);\n        }), h.offset(t.extend(D, { using: r }));\n      });\n    }, t.ui.position = { fit: { left: function left(t, e) {\n          var i,\n              s = e.within,\n              n = s.isWindow ? s.scrollLeft : s.offset.left,\n              a = s.width,\n              r = t.left - e.collisionPosition.marginLeft,\n              h = n - r,\n              l = r + e.collisionWidth - a - n;e.collisionWidth > a ? h > 0 && 0 >= l ? (i = t.left + h + e.collisionWidth - a - n, t.left += h - i) : t.left = l > 0 && 0 >= h ? n : h > l ? n + a - e.collisionWidth : n : h > 0 ? t.left += h : l > 0 ? t.left -= l : t.left = o(t.left - r, t.left);\n        }, top: function top(t, e) {\n          var i,\n              s = e.within,\n              n = s.isWindow ? s.scrollTop : s.offset.top,\n              a = e.within.height,\n              r = t.top - e.collisionPosition.marginTop,\n              h = n - r,\n              l = r + e.collisionHeight - a - n;e.collisionHeight > a ? h > 0 && 0 >= l ? (i = t.top + h + e.collisionHeight - a - n, t.top += h - i) : t.top = l > 0 && 0 >= h ? n : h > l ? n + a - e.collisionHeight : n : h > 0 ? t.top += h : l > 0 ? t.top -= l : t.top = o(t.top - r, t.top);\n        } }, flip: { left: function left(t, e) {\n          var i,\n              s,\n              n = e.within,\n              o = n.offset.left + n.scrollLeft,\n              r = n.width,\n              h = n.isWindow ? n.scrollLeft : n.offset.left,\n              l = t.left - e.collisionPosition.marginLeft,\n              c = l - h,\n              u = l + e.collisionWidth - r - h,\n              d = \"left\" === e.my[0] ? -e.elemWidth : \"right\" === e.my[0] ? e.elemWidth : 0,\n              p = \"left\" === e.at[0] ? e.targetWidth : \"right\" === e.at[0] ? -e.targetWidth : 0,\n              f = -2 * e.offset[0];0 > c ? (i = t.left + d + p + f + e.collisionWidth - r - o, (0 > i || a(c) > i) && (t.left += d + p + f)) : u > 0 && (s = t.left - e.collisionPosition.marginLeft + d + p + f - h, (s > 0 || u > a(s)) && (t.left += d + p + f));\n        }, top: function top(t, e) {\n          var i,\n              s,\n              n = e.within,\n              o = n.offset.top + n.scrollTop,\n              r = n.height,\n              h = n.isWindow ? n.scrollTop : n.offset.top,\n              l = t.top - e.collisionPosition.marginTop,\n              c = l - h,\n              u = l + e.collisionHeight - r - h,\n              d = \"top\" === e.my[1],\n              p = d ? -e.elemHeight : \"bottom\" === e.my[1] ? e.elemHeight : 0,\n              f = \"top\" === e.at[1] ? e.targetHeight : \"bottom\" === e.at[1] ? -e.targetHeight : 0,\n              g = -2 * e.offset[1];0 > c ? (s = t.top + p + f + g + e.collisionHeight - r - o, (0 > s || a(c) > s) && (t.top += p + f + g)) : u > 0 && (i = t.top - e.collisionPosition.marginTop + p + f + g - h, (i > 0 || u > a(i)) && (t.top += p + f + g));\n        } }, flipfit: { left: function left() {\n          t.ui.position.flip.left.apply(this, arguments), t.ui.position.fit.left.apply(this, arguments);\n        }, top: function top() {\n          t.ui.position.flip.top.apply(this, arguments), t.ui.position.fit.top.apply(this, arguments);\n        } } };\n  }(), t.ui.position, t.extend(t.expr[\":\"], { data: t.expr.createPseudo ? t.expr.createPseudo(function (e) {\n      return function (i) {\n        return !!t.data(i, e);\n      };\n    }) : function (e, i, s) {\n      return !!t.data(e, s[3]);\n    } }), t.fn.extend({ disableSelection: function () {\n      var t = \"onselectstart\" in document.createElement(\"div\") ? \"selectstart\" : \"mousedown\";return function () {\n        return this.on(t + \".ui-disableSelection\", function (t) {\n          t.preventDefault();\n        });\n      };\n    }(), enableSelection: function enableSelection() {\n      return this.off(\".ui-disableSelection\");\n    } });var c = \"ui-effects-\",\n      u = \"ui-effects-style\",\n      d = \"ui-effects-animated\",\n      p = t;t.effects = { effect: {} }, function (t, e) {\n    function i(t, e, i) {\n      var s = u[e.type] || {};return null == t ? i || !e.def ? null : e.def : (t = s.floor ? ~~t : parseFloat(t), isNaN(t) ? e.def : s.mod ? (t + s.mod) % s.mod : 0 > t ? 0 : t > s.max ? s.max : t);\n    }function s(i) {\n      var s = l(),\n          n = s._rgba = [];return i = i.toLowerCase(), f(h, function (t, o) {\n        var a,\n            r = o.re.exec(i),\n            h = r && o.parse(r),\n            l = o.space || \"rgba\";return h ? (a = s[l](h), s[c[l].cache] = a[c[l].cache], n = s._rgba = a._rgba, !1) : e;\n      }), n.length ? (\"0,0,0,0\" === n.join() && t.extend(n, o.transparent), s) : o[i];\n    }function n(t, e, i) {\n      return i = (i + 1) % 1, 1 > 6 * i ? t + 6 * (e - t) * i : 1 > 2 * i ? e : 2 > 3 * i ? t + 6 * (e - t) * (2 / 3 - i) : t;\n    }var o,\n        a = \"backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor\",\n        r = /^([\\-+])=\\s*(\\d+\\.?\\d*)/,\n        h = [{ re: /rgba?\\(\\s*(\\d{1,3})\\s*,\\s*(\\d{1,3})\\s*,\\s*(\\d{1,3})\\s*(?:,\\s*(\\d?(?:\\.\\d+)?)\\s*)?\\)/, parse: function parse(t) {\n        return [t[1], t[2], t[3], t[4]];\n      } }, { re: /rgba?\\(\\s*(\\d+(?:\\.\\d+)?)\\%\\s*,\\s*(\\d+(?:\\.\\d+)?)\\%\\s*,\\s*(\\d+(?:\\.\\d+)?)\\%\\s*(?:,\\s*(\\d?(?:\\.\\d+)?)\\s*)?\\)/, parse: function parse(t) {\n        return [2.55 * t[1], 2.55 * t[2], 2.55 * t[3], t[4]];\n      } }, { re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/, parse: function parse(t) {\n        return [parseInt(t[1], 16), parseInt(t[2], 16), parseInt(t[3], 16)];\n      } }, { re: /#([a-f0-9])([a-f0-9])([a-f0-9])/, parse: function parse(t) {\n        return [parseInt(t[1] + t[1], 16), parseInt(t[2] + t[2], 16), parseInt(t[3] + t[3], 16)];\n      } }, { re: /hsla?\\(\\s*(\\d+(?:\\.\\d+)?)\\s*,\\s*(\\d+(?:\\.\\d+)?)\\%\\s*,\\s*(\\d+(?:\\.\\d+)?)\\%\\s*(?:,\\s*(\\d?(?:\\.\\d+)?)\\s*)?\\)/, space: \"hsla\", parse: function parse(t) {\n        return [t[1], t[2] / 100, t[3] / 100, t[4]];\n      } }],\n        l = t.Color = function (e, i, s, n) {\n      return new t.Color.fn.parse(e, i, s, n);\n    },\n        c = { rgba: { props: { red: { idx: 0, type: \"byte\" }, green: { idx: 1, type: \"byte\" }, blue: { idx: 2, type: \"byte\" } } }, hsla: { props: { hue: { idx: 0, type: \"degrees\" }, saturation: { idx: 1, type: \"percent\" }, lightness: { idx: 2, type: \"percent\" } } } },\n        u = { \"byte\": { floor: !0, max: 255 }, percent: { max: 1 }, degrees: { mod: 360, floor: !0 } },\n        d = l.support = {},\n        p = t(\"<p>\")[0],\n        f = t.each;p.style.cssText = \"background-color:rgba(1,1,1,.5)\", d.rgba = p.style.backgroundColor.indexOf(\"rgba\") > -1, f(c, function (t, e) {\n      e.cache = \"_\" + t, e.props.alpha = { idx: 3, type: \"percent\", def: 1 };\n    }), l.fn = t.extend(l.prototype, { parse: function parse(n, a, r, h) {\n        if (n === e) return this._rgba = [null, null, null, null], this;(n.jquery || n.nodeType) && (n = t(n).css(a), a = e);var u = this,\n            d = t.type(n),\n            p = this._rgba = [];return a !== e && (n = [n, a, r, h], d = \"array\"), \"string\" === d ? this.parse(s(n) || o._default) : \"array\" === d ? (f(c.rgba.props, function (t, e) {\n          p[e.idx] = i(n[e.idx], e);\n        }), this) : \"object\" === d ? (n instanceof l ? f(c, function (t, e) {\n          n[e.cache] && (u[e.cache] = n[e.cache].slice());\n        }) : f(c, function (e, s) {\n          var o = s.cache;f(s.props, function (t, e) {\n            if (!u[o] && s.to) {\n              if (\"alpha\" === t || null == n[t]) return;u[o] = s.to(u._rgba);\n            }u[o][e.idx] = i(n[t], e, !0);\n          }), u[o] && 0 > t.inArray(null, u[o].slice(0, 3)) && (u[o][3] = 1, s.from && (u._rgba = s.from(u[o])));\n        }), this) : e;\n      }, is: function is(t) {\n        var i = l(t),\n            s = !0,\n            n = this;return f(c, function (t, o) {\n          var a,\n              r = i[o.cache];return r && (a = n[o.cache] || o.to && o.to(n._rgba) || [], f(o.props, function (t, i) {\n            return null != r[i.idx] ? s = r[i.idx] === a[i.idx] : e;\n          })), s;\n        }), s;\n      }, _space: function _space() {\n        var t = [],\n            e = this;return f(c, function (i, s) {\n          e[s.cache] && t.push(i);\n        }), t.pop();\n      }, transition: function transition(t, e) {\n        var s = l(t),\n            n = s._space(),\n            o = c[n],\n            a = 0 === this.alpha() ? l(\"transparent\") : this,\n            r = a[o.cache] || o.to(a._rgba),\n            h = r.slice();return s = s[o.cache], f(o.props, function (t, n) {\n          var o = n.idx,\n              a = r[o],\n              l = s[o],\n              c = u[n.type] || {};null !== l && (null === a ? h[o] = l : (c.mod && (l - a > c.mod / 2 ? a += c.mod : a - l > c.mod / 2 && (a -= c.mod)), h[o] = i((l - a) * e + a, n)));\n        }), this[n](h);\n      }, blend: function blend(e) {\n        if (1 === this._rgba[3]) return this;var i = this._rgba.slice(),\n            s = i.pop(),\n            n = l(e)._rgba;return l(t.map(i, function (t, e) {\n          return (1 - s) * n[e] + s * t;\n        }));\n      }, toRgbaString: function toRgbaString() {\n        var e = \"rgba(\",\n            i = t.map(this._rgba, function (t, e) {\n          return null == t ? e > 2 ? 1 : 0 : t;\n        });return 1 === i[3] && (i.pop(), e = \"rgb(\"), e + i.join() + \")\";\n      }, toHslaString: function toHslaString() {\n        var e = \"hsla(\",\n            i = t.map(this.hsla(), function (t, e) {\n          return null == t && (t = e > 2 ? 1 : 0), e && 3 > e && (t = Math.round(100 * t) + \"%\"), t;\n        });return 1 === i[3] && (i.pop(), e = \"hsl(\"), e + i.join() + \")\";\n      }, toHexString: function toHexString(e) {\n        var i = this._rgba.slice(),\n            s = i.pop();return e && i.push(~~(255 * s)), \"#\" + t.map(i, function (t) {\n          return t = (t || 0).toString(16), 1 === t.length ? \"0\" + t : t;\n        }).join(\"\");\n      }, toString: function toString() {\n        return 0 === this._rgba[3] ? \"transparent\" : this.toRgbaString();\n      } }), l.fn.parse.prototype = l.fn, c.hsla.to = function (t) {\n      if (null == t[0] || null == t[1] || null == t[2]) return [null, null, null, t[3]];var e,\n          i,\n          s = t[0] / 255,\n          n = t[1] / 255,\n          o = t[2] / 255,\n          a = t[3],\n          r = Math.max(s, n, o),\n          h = Math.min(s, n, o),\n          l = r - h,\n          c = r + h,\n          u = .5 * c;return e = h === r ? 0 : s === r ? 60 * (n - o) / l + 360 : n === r ? 60 * (o - s) / l + 120 : 60 * (s - n) / l + 240, i = 0 === l ? 0 : .5 >= u ? l / c : l / (2 - c), [Math.round(e) % 360, i, u, null == a ? 1 : a];\n    }, c.hsla.from = function (t) {\n      if (null == t[0] || null == t[1] || null == t[2]) return [null, null, null, t[3]];var e = t[0] / 360,\n          i = t[1],\n          s = t[2],\n          o = t[3],\n          a = .5 >= s ? s * (1 + i) : s + i - s * i,\n          r = 2 * s - a;return [Math.round(255 * n(r, a, e + 1 / 3)), Math.round(255 * n(r, a, e)), Math.round(255 * n(r, a, e - 1 / 3)), o];\n    }, f(c, function (s, n) {\n      var o = n.props,\n          a = n.cache,\n          h = n.to,\n          c = n.from;l.fn[s] = function (s) {\n        if (h && !this[a] && (this[a] = h(this._rgba)), s === e) return this[a].slice();var n,\n            r = t.type(s),\n            u = \"array\" === r || \"object\" === r ? s : arguments,\n            d = this[a].slice();return f(o, function (t, e) {\n          var s = u[\"object\" === r ? t : e.idx];null == s && (s = d[e.idx]), d[e.idx] = i(s, e);\n        }), c ? (n = l(c(d)), n[a] = d, n) : l(d);\n      }, f(o, function (e, i) {\n        l.fn[e] || (l.fn[e] = function (n) {\n          var o,\n              a = t.type(n),\n              h = \"alpha\" === e ? this._hsla ? \"hsla\" : \"rgba\" : s,\n              l = this[h](),\n              c = l[i.idx];return \"undefined\" === a ? c : (\"function\" === a && (n = n.call(this, c), a = t.type(n)), null == n && i.empty ? this : (\"string\" === a && (o = r.exec(n), o && (n = c + parseFloat(o[2]) * (\"+\" === o[1] ? 1 : -1))), l[i.idx] = n, this[h](l)));\n        });\n      });\n    }), l.hook = function (e) {\n      var i = e.split(\" \");f(i, function (e, i) {\n        t.cssHooks[i] = { set: function set(e, n) {\n            var o,\n                a,\n                r = \"\";if (\"transparent\" !== n && (\"string\" !== t.type(n) || (o = s(n)))) {\n              if (n = l(o || n), !d.rgba && 1 !== n._rgba[3]) {\n                for (a = \"backgroundColor\" === i ? e.parentNode : e; (\"\" === r || \"transparent\" === r) && a && a.style;) {\n                  try {\n                    r = t.css(a, \"backgroundColor\"), a = a.parentNode;\n                  } catch (h) {}\n                }n = n.blend(r && \"transparent\" !== r ? r : \"_default\");\n              }n = n.toRgbaString();\n            }try {\n              e.style[i] = n;\n            } catch (h) {}\n          } }, t.fx.step[i] = function (e) {\n          e.colorInit || (e.start = l(e.elem, i), e.end = l(e.end), e.colorInit = !0), t.cssHooks[i].set(e.elem, e.start.transition(e.end, e.pos));\n        };\n      });\n    }, l.hook(a), t.cssHooks.borderColor = { expand: function expand(t) {\n        var e = {};return f([\"Top\", \"Right\", \"Bottom\", \"Left\"], function (i, s) {\n          e[\"border\" + s + \"Color\"] = t;\n        }), e;\n      } }, o = t.Color.names = { aqua: \"#00ffff\", black: \"#000000\", blue: \"#0000ff\", fuchsia: \"#ff00ff\", gray: \"#808080\", green: \"#008000\", lime: \"#00ff00\", maroon: \"#800000\", navy: \"#000080\", olive: \"#808000\", purple: \"#800080\", red: \"#ff0000\", silver: \"#c0c0c0\", teal: \"#008080\", white: \"#ffffff\", yellow: \"#ffff00\", transparent: [null, null, null, 0], _default: \"#ffffff\" };\n  }(p), function () {\n    function e(e) {\n      var i,\n          s,\n          n = e.ownerDocument.defaultView ? e.ownerDocument.defaultView.getComputedStyle(e, null) : e.currentStyle,\n          o = {};if (n && n.length && n[0] && n[n[0]]) for (s = n.length; s--;) {\n        i = n[s], \"string\" == typeof n[i] && (o[t.camelCase(i)] = n[i]);\n      } else for (i in n) {\n        \"string\" == typeof n[i] && (o[i] = n[i]);\n      }return o;\n    }function i(e, i) {\n      var s,\n          o,\n          a = {};for (s in i) {\n        o = i[s], e[s] !== o && (n[s] || (t.fx.step[s] || !isNaN(parseFloat(o))) && (a[s] = o));\n      }return a;\n    }var s = [\"add\", \"remove\", \"toggle\"],\n        n = { border: 1, borderBottom: 1, borderColor: 1, borderLeft: 1, borderRight: 1, borderTop: 1, borderWidth: 1, margin: 1, padding: 1 };t.each([\"borderLeftStyle\", \"borderRightStyle\", \"borderBottomStyle\", \"borderTopStyle\"], function (e, i) {\n      t.fx.step[i] = function (t) {\n        (\"none\" !== t.end && !t.setAttr || 1 === t.pos && !t.setAttr) && (p.style(t.elem, i, t.end), t.setAttr = !0);\n      };\n    }), t.fn.addBack || (t.fn.addBack = function (t) {\n      return this.add(null == t ? this.prevObject : this.prevObject.filter(t));\n    }), t.effects.animateClass = function (n, o, a, r) {\n      var h = t.speed(o, a, r);return this.queue(function () {\n        var o,\n            a = t(this),\n            r = a.attr(\"class\") || \"\",\n            l = h.children ? a.find(\"*\").addBack() : a;l = l.map(function () {\n          var i = t(this);return { el: i, start: e(this) };\n        }), o = function o() {\n          t.each(s, function (t, e) {\n            n[e] && a[e + \"Class\"](n[e]);\n          });\n        }, o(), l = l.map(function () {\n          return this.end = e(this.el[0]), this.diff = i(this.start, this.end), this;\n        }), a.attr(\"class\", r), l = l.map(function () {\n          var e = this,\n              i = t.Deferred(),\n              s = t.extend({}, h, { queue: !1, complete: function complete() {\n              i.resolve(e);\n            } });return this.el.animate(this.diff, s), i.promise();\n        }), t.when.apply(t, l.get()).done(function () {\n          o(), t.each(arguments, function () {\n            var e = this.el;t.each(this.diff, function (t) {\n              e.css(t, \"\");\n            });\n          }), h.complete.call(a[0]);\n        });\n      });\n    }, t.fn.extend({ addClass: function (e) {\n        return function (i, s, n, o) {\n          return s ? t.effects.animateClass.call(this, { add: i }, s, n, o) : e.apply(this, arguments);\n        };\n      }(t.fn.addClass), removeClass: function (e) {\n        return function (i, s, n, o) {\n          return arguments.length > 1 ? t.effects.animateClass.call(this, { remove: i }, s, n, o) : e.apply(this, arguments);\n        };\n      }(t.fn.removeClass), toggleClass: function (e) {\n        return function (i, s, n, o, a) {\n          return \"boolean\" == typeof s || void 0 === s ? n ? t.effects.animateClass.call(this, s ? { add: i } : { remove: i }, n, o, a) : e.apply(this, arguments) : t.effects.animateClass.call(this, { toggle: i }, s, n, o);\n        };\n      }(t.fn.toggleClass), switchClass: function switchClass(e, i, s, n, o) {\n        return t.effects.animateClass.call(this, { add: i, remove: e }, s, n, o);\n      } });\n  }(), function () {\n    function e(e, i, s, n) {\n      return t.isPlainObject(e) && (i = e, e = e.effect), e = { effect: e }, null == i && (i = {}), t.isFunction(i) && (n = i, s = null, i = {}), (\"number\" == typeof i || t.fx.speeds[i]) && (n = s, s = i, i = {}), t.isFunction(s) && (n = s, s = null), i && t.extend(e, i), s = s || i.duration, e.duration = t.fx.off ? 0 : \"number\" == typeof s ? s : s in t.fx.speeds ? t.fx.speeds[s] : t.fx.speeds._default, e.complete = n || i.complete, e;\n    }function i(e) {\n      return !e || \"number\" == typeof e || t.fx.speeds[e] ? !0 : \"string\" != typeof e || t.effects.effect[e] ? t.isFunction(e) ? !0 : \"object\" != (typeof e === \"undefined\" ? \"undefined\" : _typeof(e)) || e.effect ? !1 : !0 : !0;\n    }function s(t, e) {\n      var i = e.outerWidth(),\n          s = e.outerHeight(),\n          n = /^rect\\((-?\\d*\\.?\\d*px|-?\\d+%|auto),?\\s*(-?\\d*\\.?\\d*px|-?\\d+%|auto),?\\s*(-?\\d*\\.?\\d*px|-?\\d+%|auto),?\\s*(-?\\d*\\.?\\d*px|-?\\d+%|auto)\\)$/,\n          o = n.exec(t) || [\"\", 0, i, s, 0];return { top: parseFloat(o[1]) || 0, right: \"auto\" === o[2] ? i : parseFloat(o[2]), bottom: \"auto\" === o[3] ? s : parseFloat(o[3]), left: parseFloat(o[4]) || 0 };\n    }t.expr && t.expr.filters && t.expr.filters.animated && (t.expr.filters.animated = function (e) {\n      return function (i) {\n        return !!t(i).data(d) || e(i);\n      };\n    }(t.expr.filters.animated)), t.uiBackCompat !== !1 && t.extend(t.effects, { save: function save(t, e) {\n        for (var i = 0, s = e.length; s > i; i++) {\n          null !== e[i] && t.data(c + e[i], t[0].style[e[i]]);\n        }\n      }, restore: function restore(t, e) {\n        for (var i, s = 0, n = e.length; n > s; s++) {\n          null !== e[s] && (i = t.data(c + e[s]), t.css(e[s], i));\n        }\n      }, setMode: function setMode(t, e) {\n        return \"toggle\" === e && (e = t.is(\":hidden\") ? \"show\" : \"hide\"), e;\n      }, createWrapper: function createWrapper(e) {\n        if (e.parent().is(\".ui-effects-wrapper\")) return e.parent();var i = { width: e.outerWidth(!0), height: e.outerHeight(!0), \"float\": e.css(\"float\") },\n            s = t(\"<div></div>\").addClass(\"ui-effects-wrapper\").css({ fontSize: \"100%\", background: \"transparent\", border: \"none\", margin: 0, padding: 0 }),\n            n = { width: e.width(), height: e.height() },\n            o = document.activeElement;try {\n          o.id;\n        } catch (a) {\n          o = document.body;\n        }return e.wrap(s), (e[0] === o || t.contains(e[0], o)) && t(o).trigger(\"focus\"), s = e.parent(), \"static\" === e.css(\"position\") ? (s.css({ position: \"relative\" }), e.css({ position: \"relative\" })) : (t.extend(i, { position: e.css(\"position\"), zIndex: e.css(\"z-index\") }), t.each([\"top\", \"left\", \"bottom\", \"right\"], function (t, s) {\n          i[s] = e.css(s), isNaN(parseInt(i[s], 10)) && (i[s] = \"auto\");\n        }), e.css({ position: \"relative\", top: 0, left: 0, right: \"auto\", bottom: \"auto\" })), e.css(n), s.css(i).show();\n      }, removeWrapper: function removeWrapper(e) {\n        var i = document.activeElement;return e.parent().is(\".ui-effects-wrapper\") && (e.parent().replaceWith(e), (e[0] === i || t.contains(e[0], i)) && t(i).trigger(\"focus\")), e;\n      } }), t.extend(t.effects, { version: \"1.12.1\", define: function define(e, i, s) {\n        return s || (s = i, i = \"effect\"), t.effects.effect[e] = s, t.effects.effect[e].mode = i, s;\n      }, scaledDimensions: function scaledDimensions(t, e, i) {\n        if (0 === e) return { height: 0, width: 0, outerHeight: 0, outerWidth: 0 };var s = \"horizontal\" !== i ? (e || 100) / 100 : 1,\n            n = \"vertical\" !== i ? (e || 100) / 100 : 1;return { height: t.height() * n, width: t.width() * s, outerHeight: t.outerHeight() * n, outerWidth: t.outerWidth() * s };\n      }, clipToBox: function clipToBox(t) {\n        return { width: t.clip.right - t.clip.left, height: t.clip.bottom - t.clip.top, left: t.clip.left, top: t.clip.top };\n      }, unshift: function unshift(t, e, i) {\n        var s = t.queue();e > 1 && s.splice.apply(s, [1, 0].concat(s.splice(e, i))), t.dequeue();\n      }, saveStyle: function saveStyle(t) {\n        t.data(u, t[0].style.cssText);\n      }, restoreStyle: function restoreStyle(t) {\n        t[0].style.cssText = t.data(u) || \"\", t.removeData(u);\n      }, mode: function mode(t, e) {\n        var i = t.is(\":hidden\");return \"toggle\" === e && (e = i ? \"show\" : \"hide\"), (i ? \"hide\" === e : \"show\" === e) && (e = \"none\"), e;\n      }, getBaseline: function getBaseline(t, e) {\n        var i, s;switch (t[0]) {case \"top\":\n            i = 0;break;case \"middle\":\n            i = .5;break;case \"bottom\":\n            i = 1;break;default:\n            i = t[0] / e.height;}switch (t[1]) {case \"left\":\n            s = 0;break;case \"center\":\n            s = .5;break;case \"right\":\n            s = 1;break;default:\n            s = t[1] / e.width;}return { x: s, y: i };\n      }, createPlaceholder: function createPlaceholder(e) {\n        var i,\n            s = e.css(\"position\"),\n            n = e.position();return e.css({ marginTop: e.css(\"marginTop\"), marginBottom: e.css(\"marginBottom\"), marginLeft: e.css(\"marginLeft\"), marginRight: e.css(\"marginRight\") }).outerWidth(e.outerWidth()).outerHeight(e.outerHeight()), /^(static|relative)/.test(s) && (s = \"absolute\", i = t(\"<\" + e[0].nodeName + \">\").insertAfter(e).css({ display: /^(inline|ruby)/.test(e.css(\"display\")) ? \"inline-block\" : \"block\", visibility: \"hidden\", marginTop: e.css(\"marginTop\"), marginBottom: e.css(\"marginBottom\"), marginLeft: e.css(\"marginLeft\"), marginRight: e.css(\"marginRight\"), \"float\": e.css(\"float\") }).outerWidth(e.outerWidth()).outerHeight(e.outerHeight()).addClass(\"ui-effects-placeholder\"), e.data(c + \"placeholder\", i)), e.css({ position: s, left: n.left, top: n.top }), i;\n      }, removePlaceholder: function removePlaceholder(t) {\n        var e = c + \"placeholder\",\n            i = t.data(e);i && (i.remove(), t.removeData(e));\n      }, cleanUp: function cleanUp(e) {\n        t.effects.restoreStyle(e), t.effects.removePlaceholder(e);\n      }, setTransition: function setTransition(e, i, s, n) {\n        return n = n || {}, t.each(i, function (t, i) {\n          var o = e.cssUnit(i);o[0] > 0 && (n[i] = o[0] * s + o[1]);\n        }), n;\n      } }), t.fn.extend({ effect: function effect() {\n        function i(e) {\n          function i() {\n            r.removeData(d), t.effects.cleanUp(r), \"hide\" === s.mode && r.hide(), a();\n          }function a() {\n            t.isFunction(h) && h.call(r[0]), t.isFunction(e) && e();\n          }var r = t(this);s.mode = c.shift(), t.uiBackCompat === !1 || o ? \"none\" === s.mode ? (r[l](), a()) : n.call(r[0], s, i) : (r.is(\":hidden\") ? \"hide\" === l : \"show\" === l) ? (r[l](), a()) : n.call(r[0], s, a);\n        }var s = e.apply(this, arguments),\n            n = t.effects.effect[s.effect],\n            o = n.mode,\n            a = s.queue,\n            r = a || \"fx\",\n            h = s.complete,\n            l = s.mode,\n            c = [],\n            u = function u(e) {\n          var i = t(this),\n              s = t.effects.mode(i, l) || o;i.data(d, !0), c.push(s), o && (\"show\" === s || s === o && \"hide\" === s) && i.show(), o && \"none\" === s || t.effects.saveStyle(i), t.isFunction(e) && e();\n        };return t.fx.off || !n ? l ? this[l](s.duration, h) : this.each(function () {\n          h && h.call(this);\n        }) : a === !1 ? this.each(u).each(i) : this.queue(r, u).queue(r, i);\n      }, show: function (t) {\n        return function (s) {\n          if (i(s)) return t.apply(this, arguments);var n = e.apply(this, arguments);return n.mode = \"show\", this.effect.call(this, n);\n        };\n      }(t.fn.show), hide: function (t) {\n        return function (s) {\n          if (i(s)) return t.apply(this, arguments);var n = e.apply(this, arguments);return n.mode = \"hide\", this.effect.call(this, n);\n        };\n      }(t.fn.hide), toggle: function (t) {\n        return function (s) {\n          if (i(s) || \"boolean\" == typeof s) return t.apply(this, arguments);var n = e.apply(this, arguments);return n.mode = \"toggle\", this.effect.call(this, n);\n        };\n      }(t.fn.toggle), cssUnit: function cssUnit(e) {\n        var i = this.css(e),\n            s = [];return t.each([\"em\", \"px\", \"%\", \"pt\"], function (t, e) {\n          i.indexOf(e) > 0 && (s = [parseFloat(i), e]);\n        }), s;\n      }, cssClip: function cssClip(t) {\n        return t ? this.css(\"clip\", \"rect(\" + t.top + \"px \" + t.right + \"px \" + t.bottom + \"px \" + t.left + \"px)\") : s(this.css(\"clip\"), this);\n      }, transfer: function transfer(e, i) {\n        var s = t(this),\n            n = t(e.to),\n            o = \"fixed\" === n.css(\"position\"),\n            a = t(\"body\"),\n            r = o ? a.scrollTop() : 0,\n            h = o ? a.scrollLeft() : 0,\n            l = n.offset(),\n            c = { top: l.top - r, left: l.left - h, height: n.innerHeight(), width: n.innerWidth() },\n            u = s.offset(),\n            d = t(\"<div class='ui-effects-transfer'></div>\").appendTo(\"body\").addClass(e.className).css({ top: u.top - r, left: u.left - h, height: s.innerHeight(), width: s.innerWidth(), position: o ? \"fixed\" : \"absolute\" }).animate(c, e.duration, e.easing, function () {\n          d.remove(), t.isFunction(i) && i();\n        });\n      } }), t.fx.step.clip = function (e) {\n      e.clipInit || (e.start = t(e.elem).cssClip(), \"string\" == typeof e.end && (e.end = s(e.end, e.elem)), e.clipInit = !0), t(e.elem).cssClip({ top: e.pos * (e.end.top - e.start.top) + e.start.top, right: e.pos * (e.end.right - e.start.right) + e.start.right, bottom: e.pos * (e.end.bottom - e.start.bottom) + e.start.bottom, left: e.pos * (e.end.left - e.start.left) + e.start.left });\n    };\n  }(), function () {\n    var e = {};t.each([\"Quad\", \"Cubic\", \"Quart\", \"Quint\", \"Expo\"], function (t, i) {\n      e[i] = function (e) {\n        return Math.pow(e, t + 2);\n      };\n    }), t.extend(e, { Sine: function Sine(t) {\n        return 1 - Math.cos(t * Math.PI / 2);\n      }, Circ: function Circ(t) {\n        return 1 - Math.sqrt(1 - t * t);\n      }, Elastic: function Elastic(t) {\n        return 0 === t || 1 === t ? t : -Math.pow(2, 8 * (t - 1)) * Math.sin((80 * (t - 1) - 7.5) * Math.PI / 15);\n      }, Back: function Back(t) {\n        return t * t * (3 * t - 2);\n      }, Bounce: function Bounce(t) {\n        for (var e, i = 4; ((e = Math.pow(2, --i)) - 1) / 11 > t;) {}return 1 / Math.pow(4, 3 - i) - 7.5625 * Math.pow((3 * e - 2) / 22 - t, 2);\n      } }), t.each(e, function (e, i) {\n      t.easing[\"easeIn\" + e] = i, t.easing[\"easeOut\" + e] = function (t) {\n        return 1 - i(1 - t);\n      }, t.easing[\"easeInOut\" + e] = function (t) {\n        return .5 > t ? i(2 * t) / 2 : 1 - i(-2 * t + 2) / 2;\n      };\n    });\n  }();var f = t.effects;t.effects.define(\"blind\", \"hide\", function (e, i) {\n    var s = { up: [\"bottom\", \"top\"], vertical: [\"bottom\", \"top\"], down: [\"top\", \"bottom\"], left: [\"right\", \"left\"], horizontal: [\"right\", \"left\"], right: [\"left\", \"right\"] },\n        n = t(this),\n        o = e.direction || \"up\",\n        a = n.cssClip(),\n        r = { clip: t.extend({}, a) },\n        h = t.effects.createPlaceholder(n);r.clip[s[o][0]] = r.clip[s[o][1]], \"show\" === e.mode && (n.cssClip(r.clip), h && h.css(t.effects.clipToBox(r)), r.clip = a), h && h.animate(t.effects.clipToBox(r), e.duration, e.easing), n.animate(r, { queue: !1, duration: e.duration, easing: e.easing, complete: i });\n  }), t.effects.define(\"bounce\", function (e, i) {\n    var s,\n        n,\n        o,\n        a = t(this),\n        r = e.mode,\n        h = \"hide\" === r,\n        l = \"show\" === r,\n        c = e.direction || \"up\",\n        u = e.distance,\n        d = e.times || 5,\n        p = 2 * d + (l || h ? 1 : 0),\n        f = e.duration / p,\n        g = e.easing,\n        m = \"up\" === c || \"down\" === c ? \"top\" : \"left\",\n        _ = \"up\" === c || \"left\" === c,\n        v = 0,\n        b = a.queue().length;for (t.effects.createPlaceholder(a), o = a.css(m), u || (u = a[\"top\" === m ? \"outerHeight\" : \"outerWidth\"]() / 3), l && (n = { opacity: 1 }, n[m] = o, a.css(\"opacity\", 0).css(m, _ ? 2 * -u : 2 * u).animate(n, f, g)), h && (u /= Math.pow(2, d - 1)), n = {}, n[m] = o; d > v; v++) {\n      s = {}, s[m] = (_ ? \"-=\" : \"+=\") + u, a.animate(s, f, g).animate(n, f, g), u = h ? 2 * u : u / 2;\n    }h && (s = { opacity: 0 }, s[m] = (_ ? \"-=\" : \"+=\") + u, a.animate(s, f, g)), a.queue(i), t.effects.unshift(a, b, p + 1);\n  }), t.effects.define(\"clip\", \"hide\", function (e, i) {\n    var s,\n        n = {},\n        o = t(this),\n        a = e.direction || \"vertical\",\n        r = \"both\" === a,\n        h = r || \"horizontal\" === a,\n        l = r || \"vertical\" === a;s = o.cssClip(), n.clip = { top: l ? (s.bottom - s.top) / 2 : s.top, right: h ? (s.right - s.left) / 2 : s.right, bottom: l ? (s.bottom - s.top) / 2 : s.bottom, left: h ? (s.right - s.left) / 2 : s.left }, t.effects.createPlaceholder(o), \"show\" === e.mode && (o.cssClip(n.clip), n.clip = s), o.animate(n, { queue: !1, duration: e.duration, easing: e.easing, complete: i });\n  }), t.effects.define(\"drop\", \"hide\", function (e, i) {\n    var s,\n        n = t(this),\n        o = e.mode,\n        a = \"show\" === o,\n        r = e.direction || \"left\",\n        h = \"up\" === r || \"down\" === r ? \"top\" : \"left\",\n        l = \"up\" === r || \"left\" === r ? \"-=\" : \"+=\",\n        c = \"+=\" === l ? \"-=\" : \"+=\",\n        u = { opacity: 0 };t.effects.createPlaceholder(n), s = e.distance || n[\"top\" === h ? \"outerHeight\" : \"outerWidth\"](!0) / 2, u[h] = l + s, a && (n.css(u), u[h] = c + s, u.opacity = 1), n.animate(u, { queue: !1, duration: e.duration, easing: e.easing, complete: i });\n  }), t.effects.define(\"explode\", \"hide\", function (e, i) {\n    function s() {\n      b.push(this), b.length === u * d && n();\n    }function n() {\n      p.css({ visibility: \"visible\" }), t(b).remove(), i();\n    }var o,\n        a,\n        r,\n        h,\n        l,\n        c,\n        u = e.pieces ? Math.round(Math.sqrt(e.pieces)) : 3,\n        d = u,\n        p = t(this),\n        f = e.mode,\n        g = \"show\" === f,\n        m = p.show().css(\"visibility\", \"hidden\").offset(),\n        _ = Math.ceil(p.outerWidth() / d),\n        v = Math.ceil(p.outerHeight() / u),\n        b = [];for (o = 0; u > o; o++) {\n      for (h = m.top + o * v, c = o - (u - 1) / 2, a = 0; d > a; a++) {\n        r = m.left + a * _, l = a - (d - 1) / 2, p.clone().appendTo(\"body\").wrap(\"<div></div>\").css({ position: \"absolute\", visibility: \"visible\", left: -a * _, top: -o * v }).parent().addClass(\"ui-effects-explode\").css({ position: \"absolute\", overflow: \"hidden\", width: _, height: v, left: r + (g ? l * _ : 0), top: h + (g ? c * v : 0), opacity: g ? 0 : 1 }).animate({ left: r + (g ? 0 : l * _), top: h + (g ? 0 : c * v), opacity: g ? 1 : 0 }, e.duration || 500, e.easing, s);\n      }\n    }\n  }), t.effects.define(\"fade\", \"toggle\", function (e, i) {\n    var s = \"show\" === e.mode;t(this).css(\"opacity\", s ? 0 : 1).animate({ opacity: s ? 1 : 0 }, { queue: !1, duration: e.duration, easing: e.easing, complete: i });\n  }), t.effects.define(\"fold\", \"hide\", function (e, i) {\n    var s = t(this),\n        n = e.mode,\n        o = \"show\" === n,\n        a = \"hide\" === n,\n        r = e.size || 15,\n        h = /([0-9]+)%/.exec(r),\n        l = !!e.horizFirst,\n        c = l ? [\"right\", \"bottom\"] : [\"bottom\", \"right\"],\n        u = e.duration / 2,\n        d = t.effects.createPlaceholder(s),\n        p = s.cssClip(),\n        f = { clip: t.extend({}, p) },\n        g = { clip: t.extend({}, p) },\n        m = [p[c[0]], p[c[1]]],\n        _ = s.queue().length;h && (r = parseInt(h[1], 10) / 100 * m[a ? 0 : 1]), f.clip[c[0]] = r, g.clip[c[0]] = r, g.clip[c[1]] = 0, o && (s.cssClip(g.clip), d && d.css(t.effects.clipToBox(g)), g.clip = p), s.queue(function (i) {\n      d && d.animate(t.effects.clipToBox(f), u, e.easing).animate(t.effects.clipToBox(g), u, e.easing), i();\n    }).animate(f, u, e.easing).animate(g, u, e.easing).queue(i), t.effects.unshift(s, _, 4);\n  }), t.effects.define(\"highlight\", \"show\", function (e, i) {\n    var s = t(this),\n        n = { backgroundColor: s.css(\"backgroundColor\") };\"hide\" === e.mode && (n.opacity = 0), t.effects.saveStyle(s), s.css({ backgroundImage: \"none\", backgroundColor: e.color || \"#ffff99\" }).animate(n, { queue: !1, duration: e.duration, easing: e.easing, complete: i });\n  }), t.effects.define(\"size\", function (e, i) {\n    var s,\n        n,\n        o,\n        a = t(this),\n        r = [\"fontSize\"],\n        h = [\"borderTopWidth\", \"borderBottomWidth\", \"paddingTop\", \"paddingBottom\"],\n        l = [\"borderLeftWidth\", \"borderRightWidth\", \"paddingLeft\", \"paddingRight\"],\n        c = e.mode,\n        u = \"effect\" !== c,\n        d = e.scale || \"both\",\n        p = e.origin || [\"middle\", \"center\"],\n        f = a.css(\"position\"),\n        g = a.position(),\n        m = t.effects.scaledDimensions(a),\n        _ = e.from || m,\n        v = e.to || t.effects.scaledDimensions(a, 0);t.effects.createPlaceholder(a), \"show\" === c && (o = _, _ = v, v = o), n = { from: { y: _.height / m.height, x: _.width / m.width }, to: { y: v.height / m.height, x: v.width / m.width } }, (\"box\" === d || \"both\" === d) && (n.from.y !== n.to.y && (_ = t.effects.setTransition(a, h, n.from.y, _), v = t.effects.setTransition(a, h, n.to.y, v)), n.from.x !== n.to.x && (_ = t.effects.setTransition(a, l, n.from.x, _), v = t.effects.setTransition(a, l, n.to.x, v))), (\"content\" === d || \"both\" === d) && n.from.y !== n.to.y && (_ = t.effects.setTransition(a, r, n.from.y, _), v = t.effects.setTransition(a, r, n.to.y, v)), p && (s = t.effects.getBaseline(p, m), _.top = (m.outerHeight - _.outerHeight) * s.y + g.top, _.left = (m.outerWidth - _.outerWidth) * s.x + g.left, v.top = (m.outerHeight - v.outerHeight) * s.y + g.top, v.left = (m.outerWidth - v.outerWidth) * s.x + g.left), a.css(_), (\"content\" === d || \"both\" === d) && (h = h.concat([\"marginTop\", \"marginBottom\"]).concat(r), l = l.concat([\"marginLeft\", \"marginRight\"]), a.find(\"*[width]\").each(function () {\n      var i = t(this),\n          s = t.effects.scaledDimensions(i),\n          o = { height: s.height * n.from.y, width: s.width * n.from.x, outerHeight: s.outerHeight * n.from.y, outerWidth: s.outerWidth * n.from.x },\n          a = { height: s.height * n.to.y, width: s.width * n.to.x, outerHeight: s.height * n.to.y, outerWidth: s.width * n.to.x };n.from.y !== n.to.y && (o = t.effects.setTransition(i, h, n.from.y, o), a = t.effects.setTransition(i, h, n.to.y, a)), n.from.x !== n.to.x && (o = t.effects.setTransition(i, l, n.from.x, o), a = t.effects.setTransition(i, l, n.to.x, a)), u && t.effects.saveStyle(i), i.css(o), i.animate(a, e.duration, e.easing, function () {\n        u && t.effects.restoreStyle(i);\n      });\n    })), a.animate(v, { queue: !1, duration: e.duration, easing: e.easing, complete: function complete() {\n        var e = a.offset();0 === v.opacity && a.css(\"opacity\", _.opacity), u || (a.css(\"position\", \"static\" === f ? \"relative\" : f).offset(e), t.effects.saveStyle(a)), i();\n      } });\n  }), t.effects.define(\"scale\", function (e, i) {\n    var s = t(this),\n        n = e.mode,\n        o = parseInt(e.percent, 10) || (0 === parseInt(e.percent, 10) ? 0 : \"effect\" !== n ? 0 : 100),\n        a = t.extend(!0, { from: t.effects.scaledDimensions(s), to: t.effects.scaledDimensions(s, o, e.direction || \"both\"), origin: e.origin || [\"middle\", \"center\"] }, e);e.fade && (a.from.opacity = 1, a.to.opacity = 0), t.effects.effect.size.call(this, a, i);\n  }), t.effects.define(\"puff\", \"hide\", function (e, i) {\n    var s = t.extend(!0, {}, e, { fade: !0, percent: parseInt(e.percent, 10) || 150 });t.effects.effect.scale.call(this, s, i);\n  }), t.effects.define(\"pulsate\", \"show\", function (e, i) {\n    var s = t(this),\n        n = e.mode,\n        o = \"show\" === n,\n        a = \"hide\" === n,\n        r = o || a,\n        h = 2 * (e.times || 5) + (r ? 1 : 0),\n        l = e.duration / h,\n        c = 0,\n        u = 1,\n        d = s.queue().length;for ((o || !s.is(\":visible\")) && (s.css(\"opacity\", 0).show(), c = 1); h > u; u++) {\n      s.animate({ opacity: c }, l, e.easing), c = 1 - c;\n    }s.animate({ opacity: c }, l, e.easing), s.queue(i), t.effects.unshift(s, d, h + 1);\n  }), t.effects.define(\"shake\", function (e, i) {\n    var s = 1,\n        n = t(this),\n        o = e.direction || \"left\",\n        a = e.distance || 20,\n        r = e.times || 3,\n        h = 2 * r + 1,\n        l = Math.round(e.duration / h),\n        c = \"up\" === o || \"down\" === o ? \"top\" : \"left\",\n        u = \"up\" === o || \"left\" === o,\n        d = {},\n        p = {},\n        f = {},\n        g = n.queue().length;for (t.effects.createPlaceholder(n), d[c] = (u ? \"-=\" : \"+=\") + a, p[c] = (u ? \"+=\" : \"-=\") + 2 * a, f[c] = (u ? \"-=\" : \"+=\") + 2 * a, n.animate(d, l, e.easing); r > s; s++) {\n      n.animate(p, l, e.easing).animate(f, l, e.easing);\n    }n.animate(p, l, e.easing).animate(d, l / 2, e.easing).queue(i), t.effects.unshift(n, g, h + 1);\n  }), t.effects.define(\"slide\", \"show\", function (e, i) {\n    var s,\n        n,\n        o = t(this),\n        a = { up: [\"bottom\", \"top\"], down: [\"top\", \"bottom\"], left: [\"right\", \"left\"], right: [\"left\", \"right\"] },\n        r = e.mode,\n        h = e.direction || \"left\",\n        l = \"up\" === h || \"down\" === h ? \"top\" : \"left\",\n        c = \"up\" === h || \"left\" === h,\n        u = e.distance || o[\"top\" === l ? \"outerHeight\" : \"outerWidth\"](!0),\n        d = {};t.effects.createPlaceholder(o), s = o.cssClip(), n = o.position()[l], d[l] = (c ? -1 : 1) * u + n, d.clip = o.cssClip(), d.clip[a[h][1]] = d.clip[a[h][0]], \"show\" === r && (o.cssClip(d.clip), o.css(l, d[l]), d.clip = s, d[l] = n), o.animate(d, { queue: !1, duration: e.duration, easing: e.easing, complete: i });\n  });var f;t.uiBackCompat !== !1 && (f = t.effects.define(\"transfer\", function (e, i) {\n    t(this).transfer(e, i);\n  })), t.ui.focusable = function (i, s) {\n    var n,\n        o,\n        a,\n        r,\n        h,\n        l = i.nodeName.toLowerCase();return \"area\" === l ? (n = i.parentNode, o = n.name, i.href && o && \"map\" === n.nodeName.toLowerCase() ? (a = t(\"img[usemap='#\" + o + \"']\"), a.length > 0 && a.is(\":visible\")) : !1) : (/^(input|select|textarea|button|object)$/.test(l) ? (r = !i.disabled, r && (h = t(i).closest(\"fieldset\")[0], h && (r = !h.disabled))) : r = \"a\" === l ? i.href || s : s, r && t(i).is(\":visible\") && e(t(i)));\n  }, t.extend(t.expr[\":\"], { focusable: function focusable(e) {\n      return t.ui.focusable(e, null != t.attr(e, \"tabindex\"));\n    } }), t.ui.focusable, t.fn.form = function () {\n    return \"string\" == typeof this[0].form ? this.closest(\"form\") : t(this[0].form);\n  }, t.ui.formResetMixin = { _formResetHandler: function _formResetHandler() {\n      var e = t(this);setTimeout(function () {\n        var i = e.data(\"ui-form-reset-instances\");t.each(i, function () {\n          this.refresh();\n        });\n      });\n    }, _bindFormResetHandler: function _bindFormResetHandler() {\n      if (this.form = this.element.form(), this.form.length) {\n        var t = this.form.data(\"ui-form-reset-instances\") || [];t.length || this.form.on(\"reset.ui-form-reset\", this._formResetHandler), t.push(this), this.form.data(\"ui-form-reset-instances\", t);\n      }\n    }, _unbindFormResetHandler: function _unbindFormResetHandler() {\n      if (this.form.length) {\n        var e = this.form.data(\"ui-form-reset-instances\");e.splice(t.inArray(this, e), 1), e.length ? this.form.data(\"ui-form-reset-instances\", e) : this.form.removeData(\"ui-form-reset-instances\").off(\"reset.ui-form-reset\");\n      }\n    } }, \"1.7\" === t.fn.jquery.substring(0, 3) && (t.each([\"Width\", \"Height\"], function (e, i) {\n    function s(e, i, s, o) {\n      return t.each(n, function () {\n        i -= parseFloat(t.css(e, \"padding\" + this)) || 0, s && (i -= parseFloat(t.css(e, \"border\" + this + \"Width\")) || 0), o && (i -= parseFloat(t.css(e, \"margin\" + this)) || 0);\n      }), i;\n    }var n = \"Width\" === i ? [\"Left\", \"Right\"] : [\"Top\", \"Bottom\"],\n        o = i.toLowerCase(),\n        a = { innerWidth: t.fn.innerWidth, innerHeight: t.fn.innerHeight, outerWidth: t.fn.outerWidth, outerHeight: t.fn.outerHeight };t.fn[\"inner\" + i] = function (e) {\n      return void 0 === e ? a[\"inner\" + i].call(this) : this.each(function () {\n        t(this).css(o, s(this, e) + \"px\");\n      });\n    }, t.fn[\"outer\" + i] = function (e, n) {\n      return \"number\" != typeof e ? a[\"outer\" + i].call(this, e) : this.each(function () {\n        t(this).css(o, s(this, e, !0, n) + \"px\");\n      });\n    };\n  }), t.fn.addBack = function (t) {\n    return this.add(null == t ? this.prevObject : this.prevObject.filter(t));\n  }), t.ui.keyCode = { BACKSPACE: 8, COMMA: 188, DELETE: 46, DOWN: 40, END: 35, ENTER: 13, ESCAPE: 27, HOME: 36, LEFT: 37, PAGE_DOWN: 34, PAGE_UP: 33, PERIOD: 190, RIGHT: 39, SPACE: 32, TAB: 9, UP: 38 }, t.ui.escapeSelector = function () {\n    var t = /([!\"#$%&'()*+,.\\/:;<=>?@[\\]^`{|}~])/g;return function (e) {\n      return e.replace(t, \"\\\\$1\");\n    };\n  }(), t.fn.labels = function () {\n    var e, i, s, n, o;return this[0].labels && this[0].labels.length ? this.pushStack(this[0].labels) : (n = this.eq(0).parents(\"label\"), s = this.attr(\"id\"), s && (e = this.eq(0).parents().last(), o = e.add(e.length ? e.siblings() : this.siblings()), i = \"label[for='\" + t.ui.escapeSelector(s) + \"']\", n = n.add(o.find(i).addBack(i))), this.pushStack(n));\n  }, t.fn.scrollParent = function (e) {\n    var i = this.css(\"position\"),\n        s = \"absolute\" === i,\n        n = e ? /(auto|scroll|hidden)/ : /(auto|scroll)/,\n        o = this.parents().filter(function () {\n      var e = t(this);return s && \"static\" === e.css(\"position\") ? !1 : n.test(e.css(\"overflow\") + e.css(\"overflow-y\") + e.css(\"overflow-x\"));\n    }).eq(0);return \"fixed\" !== i && o.length ? o : t(this[0].ownerDocument || document);\n  }, t.extend(t.expr[\":\"], { tabbable: function tabbable(e) {\n      var i = t.attr(e, \"tabindex\"),\n          s = null != i;return (!s || i >= 0) && t.ui.focusable(e, s);\n    } }), t.fn.extend({ uniqueId: function () {\n      var t = 0;return function () {\n        return this.each(function () {\n          this.id || (this.id = \"ui-id-\" + ++t);\n        });\n      };\n    }(), removeUniqueId: function removeUniqueId() {\n      return this.each(function () {\n        /^ui-id-\\d+$/.test(this.id) && t(this).removeAttr(\"id\");\n      });\n    } }), t.widget(\"ui.accordion\", { version: \"1.12.1\", options: { active: 0, animate: {}, classes: { \"ui-accordion-header\": \"ui-corner-top\", \"ui-accordion-header-collapsed\": \"ui-corner-all\", \"ui-accordion-content\": \"ui-corner-bottom\" }, collapsible: !1, event: \"click\", header: \"> li > :first-child, > :not(li):even\", heightStyle: \"auto\", icons: { activeHeader: \"ui-icon-triangle-1-s\", header: \"ui-icon-triangle-1-e\" }, activate: null, beforeActivate: null }, hideProps: { borderTopWidth: \"hide\", borderBottomWidth: \"hide\", paddingTop: \"hide\", paddingBottom: \"hide\", height: \"hide\" }, showProps: { borderTopWidth: \"show\", borderBottomWidth: \"show\", paddingTop: \"show\", paddingBottom: \"show\", height: \"show\" }, _create: function _create() {\n      var e = this.options;this.prevShow = this.prevHide = t(), this._addClass(\"ui-accordion\", \"ui-widget ui-helper-reset\"), this.element.attr(\"role\", \"tablist\"), e.collapsible || e.active !== !1 && null != e.active || (e.active = 0), this._processPanels(), 0 > e.active && (e.active += this.headers.length), this._refresh();\n    }, _getCreateEventData: function _getCreateEventData() {\n      return { header: this.active, panel: this.active.length ? this.active.next() : t() };\n    }, _createIcons: function _createIcons() {\n      var e,\n          i,\n          s = this.options.icons;s && (e = t(\"<span>\"), this._addClass(e, \"ui-accordion-header-icon\", \"ui-icon \" + s.header), e.prependTo(this.headers), i = this.active.children(\".ui-accordion-header-icon\"), this._removeClass(i, s.header)._addClass(i, null, s.activeHeader)._addClass(this.headers, \"ui-accordion-icons\"));\n    }, _destroyIcons: function _destroyIcons() {\n      this._removeClass(this.headers, \"ui-accordion-icons\"), this.headers.children(\".ui-accordion-header-icon\").remove();\n    }, _destroy: function _destroy() {\n      var t;this.element.removeAttr(\"role\"), this.headers.removeAttr(\"role aria-expanded aria-selected aria-controls tabIndex\").removeUniqueId(), this._destroyIcons(), t = this.headers.next().css(\"display\", \"\").removeAttr(\"role aria-hidden aria-labelledby\").removeUniqueId(), \"content\" !== this.options.heightStyle && t.css(\"height\", \"\");\n    }, _setOption: function _setOption(t, e) {\n      return \"active\" === t ? (this._activate(e), void 0) : (\"event\" === t && (this.options.event && this._off(this.headers, this.options.event), this._setupEvents(e)), this._super(t, e), \"collapsible\" !== t || e || this.options.active !== !1 || this._activate(0), \"icons\" === t && (this._destroyIcons(), e && this._createIcons()), void 0);\n    }, _setOptionDisabled: function _setOptionDisabled(t) {\n      this._super(t), this.element.attr(\"aria-disabled\", t), this._toggleClass(null, \"ui-state-disabled\", !!t), this._toggleClass(this.headers.add(this.headers.next()), null, \"ui-state-disabled\", !!t);\n    }, _keydown: function _keydown(e) {\n      if (!e.altKey && !e.ctrlKey) {\n        var i = t.ui.keyCode,\n            s = this.headers.length,\n            n = this.headers.index(e.target),\n            o = !1;switch (e.keyCode) {case i.RIGHT:case i.DOWN:\n            o = this.headers[(n + 1) % s];break;case i.LEFT:case i.UP:\n            o = this.headers[(n - 1 + s) % s];break;case i.SPACE:case i.ENTER:\n            this._eventHandler(e);break;case i.HOME:\n            o = this.headers[0];break;case i.END:\n            o = this.headers[s - 1];}o && (t(e.target).attr(\"tabIndex\", -1), t(o).attr(\"tabIndex\", 0), t(o).trigger(\"focus\"), e.preventDefault());\n      }\n    }, _panelKeyDown: function _panelKeyDown(e) {\n      e.keyCode === t.ui.keyCode.UP && e.ctrlKey && t(e.currentTarget).prev().trigger(\"focus\");\n    }, refresh: function refresh() {\n      var e = this.options;this._processPanels(), e.active === !1 && e.collapsible === !0 || !this.headers.length ? (e.active = !1, this.active = t()) : e.active === !1 ? this._activate(0) : this.active.length && !t.contains(this.element[0], this.active[0]) ? this.headers.length === this.headers.find(\".ui-state-disabled\").length ? (e.active = !1, this.active = t()) : this._activate(Math.max(0, e.active - 1)) : e.active = this.headers.index(this.active), this._destroyIcons(), this._refresh();\n    }, _processPanels: function _processPanels() {\n      var t = this.headers,\n          e = this.panels;this.headers = this.element.find(this.options.header), this._addClass(this.headers, \"ui-accordion-header ui-accordion-header-collapsed\", \"ui-state-default\"), this.panels = this.headers.next().filter(\":not(.ui-accordion-content-active)\").hide(), this._addClass(this.panels, \"ui-accordion-content\", \"ui-helper-reset ui-widget-content\"), e && (this._off(t.not(this.headers)), this._off(e.not(this.panels)));\n    }, _refresh: function _refresh() {\n      var e,\n          i = this.options,\n          s = i.heightStyle,\n          n = this.element.parent();this.active = this._findActive(i.active), this._addClass(this.active, \"ui-accordion-header-active\", \"ui-state-active\")._removeClass(this.active, \"ui-accordion-header-collapsed\"), this._addClass(this.active.next(), \"ui-accordion-content-active\"), this.active.next().show(), this.headers.attr(\"role\", \"tab\").each(function () {\n        var e = t(this),\n            i = e.uniqueId().attr(\"id\"),\n            s = e.next(),\n            n = s.uniqueId().attr(\"id\");e.attr(\"aria-controls\", n), s.attr(\"aria-labelledby\", i);\n      }).next().attr(\"role\", \"tabpanel\"), this.headers.not(this.active).attr({ \"aria-selected\": \"false\", \"aria-expanded\": \"false\", tabIndex: -1 }).next().attr({ \"aria-hidden\": \"true\" }).hide(), this.active.length ? this.active.attr({ \"aria-selected\": \"true\", \"aria-expanded\": \"true\", tabIndex: 0 }).next().attr({ \"aria-hidden\": \"false\" }) : this.headers.eq(0).attr(\"tabIndex\", 0), this._createIcons(), this._setupEvents(i.event), \"fill\" === s ? (e = n.height(), this.element.siblings(\":visible\").each(function () {\n        var i = t(this),\n            s = i.css(\"position\");\"absolute\" !== s && \"fixed\" !== s && (e -= i.outerHeight(!0));\n      }), this.headers.each(function () {\n        e -= t(this).outerHeight(!0);\n      }), this.headers.next().each(function () {\n        t(this).height(Math.max(0, e - t(this).innerHeight() + t(this).height()));\n      }).css(\"overflow\", \"auto\")) : \"auto\" === s && (e = 0, this.headers.next().each(function () {\n        var i = t(this).is(\":visible\");i || t(this).show(), e = Math.max(e, t(this).css(\"height\", \"\").height()), i || t(this).hide();\n      }).height(e));\n    }, _activate: function _activate(e) {\n      var i = this._findActive(e)[0];i !== this.active[0] && (i = i || this.active[0], this._eventHandler({ target: i, currentTarget: i, preventDefault: t.noop }));\n    }, _findActive: function _findActive(e) {\n      return \"number\" == typeof e ? this.headers.eq(e) : t();\n    }, _setupEvents: function _setupEvents(e) {\n      var i = { keydown: \"_keydown\" };e && t.each(e.split(\" \"), function (t, e) {\n        i[e] = \"_eventHandler\";\n      }), this._off(this.headers.add(this.headers.next())), this._on(this.headers, i), this._on(this.headers.next(), { keydown: \"_panelKeyDown\" }), this._hoverable(this.headers), this._focusable(this.headers);\n    }, _eventHandler: function _eventHandler(e) {\n      var i,\n          s,\n          n = this.options,\n          o = this.active,\n          a = t(e.currentTarget),\n          r = a[0] === o[0],\n          h = r && n.collapsible,\n          l = h ? t() : a.next(),\n          c = o.next(),\n          u = { oldHeader: o, oldPanel: c, newHeader: h ? t() : a, newPanel: l };e.preventDefault(), r && !n.collapsible || this._trigger(\"beforeActivate\", e, u) === !1 || (n.active = h ? !1 : this.headers.index(a), this.active = r ? t() : a, this._toggle(u), this._removeClass(o, \"ui-accordion-header-active\", \"ui-state-active\"), n.icons && (i = o.children(\".ui-accordion-header-icon\"), this._removeClass(i, null, n.icons.activeHeader)._addClass(i, null, n.icons.header)), r || (this._removeClass(a, \"ui-accordion-header-collapsed\")._addClass(a, \"ui-accordion-header-active\", \"ui-state-active\"), n.icons && (s = a.children(\".ui-accordion-header-icon\"), this._removeClass(s, null, n.icons.header)._addClass(s, null, n.icons.activeHeader)), this._addClass(a.next(), \"ui-accordion-content-active\")));\n    }, _toggle: function _toggle(e) {\n      var i = e.newPanel,\n          s = this.prevShow.length ? this.prevShow : e.oldPanel;this.prevShow.add(this.prevHide).stop(!0, !0), this.prevShow = i, this.prevHide = s, this.options.animate ? this._animate(i, s, e) : (s.hide(), i.show(), this._toggleComplete(e)), s.attr({ \"aria-hidden\": \"true\" }), s.prev().attr({ \"aria-selected\": \"false\", \"aria-expanded\": \"false\" }), i.length && s.length ? s.prev().attr({ tabIndex: -1, \"aria-expanded\": \"false\" }) : i.length && this.headers.filter(function () {\n        return 0 === parseInt(t(this).attr(\"tabIndex\"), 10);\n      }).attr(\"tabIndex\", -1), i.attr(\"aria-hidden\", \"false\").prev().attr({ \"aria-selected\": \"true\", \"aria-expanded\": \"true\", tabIndex: 0 });\n    }, _animate: function _animate(t, e, i) {\n      var s,\n          n,\n          o,\n          a = this,\n          r = 0,\n          h = t.css(\"box-sizing\"),\n          l = t.length && (!e.length || t.index() < e.index()),\n          c = this.options.animate || {},\n          u = l && c.down || c,\n          d = function d() {\n        a._toggleComplete(i);\n      };return \"number\" == typeof u && (o = u), \"string\" == typeof u && (n = u), n = n || u.easing || c.easing, o = o || u.duration || c.duration, e.length ? t.length ? (s = t.show().outerHeight(), e.animate(this.hideProps, { duration: o, easing: n, step: function step(t, e) {\n          e.now = Math.round(t);\n        } }), t.hide().animate(this.showProps, { duration: o, easing: n, complete: d, step: function step(t, i) {\n          i.now = Math.round(t), \"height\" !== i.prop ? \"content-box\" === h && (r += i.now) : \"content\" !== a.options.heightStyle && (i.now = Math.round(s - e.outerHeight() - r), r = 0);\n        } }), void 0) : e.animate(this.hideProps, o, n, d) : t.animate(this.showProps, o, n, d);\n    }, _toggleComplete: function _toggleComplete(t) {\n      var e = t.oldPanel,\n          i = e.prev();this._removeClass(e, \"ui-accordion-content-active\"), this._removeClass(i, \"ui-accordion-header-active\")._addClass(i, \"ui-accordion-header-collapsed\"), e.length && (e.parent()[0].className = e.parent()[0].className), this._trigger(\"activate\", null, t);\n    } }), t.ui.safeActiveElement = function (t) {\n    var e;try {\n      e = t.activeElement;\n    } catch (i) {\n      e = t.body;\n    }return e || (e = t.body), e.nodeName || (e = t.body), e;\n  }, t.widget(\"ui.menu\", { version: \"1.12.1\", defaultElement: \"<ul>\", delay: 300, options: { icons: { submenu: \"ui-icon-caret-1-e\" }, items: \"> *\", menus: \"ul\", position: { my: \"left top\", at: \"right top\" }, role: \"menu\", blur: null, focus: null, select: null }, _create: function _create() {\n      this.activeMenu = this.element, this.mouseHandled = !1, this.element.uniqueId().attr({ role: this.options.role, tabIndex: 0 }), this._addClass(\"ui-menu\", \"ui-widget ui-widget-content\"), this._on({ \"mousedown .ui-menu-item\": function mousedownUiMenuItem(t) {\n          t.preventDefault();\n        }, \"click .ui-menu-item\": function clickUiMenuItem(e) {\n          var i = t(e.target),\n              s = t(t.ui.safeActiveElement(this.document[0]));!this.mouseHandled && i.not(\".ui-state-disabled\").length && (this.select(e), e.isPropagationStopped() || (this.mouseHandled = !0), i.has(\".ui-menu\").length ? this.expand(e) : !this.element.is(\":focus\") && s.closest(\".ui-menu\").length && (this.element.trigger(\"focus\", [!0]), this.active && 1 === this.active.parents(\".ui-menu\").length && clearTimeout(this.timer)));\n        }, \"mouseenter .ui-menu-item\": function mouseenterUiMenuItem(e) {\n          if (!this.previousFilter) {\n            var i = t(e.target).closest(\".ui-menu-item\"),\n                s = t(e.currentTarget);i[0] === s[0] && (this._removeClass(s.siblings().children(\".ui-state-active\"), null, \"ui-state-active\"), this.focus(e, s));\n          }\n        }, mouseleave: \"collapseAll\", \"mouseleave .ui-menu\": \"collapseAll\", focus: function focus(t, e) {\n          var i = this.active || this.element.find(this.options.items).eq(0);e || this.focus(t, i);\n        }, blur: function blur(e) {\n          this._delay(function () {\n            var i = !t.contains(this.element[0], t.ui.safeActiveElement(this.document[0]));i && this.collapseAll(e);\n          });\n        }, keydown: \"_keydown\" }), this.refresh(), this._on(this.document, { click: function click(t) {\n          this._closeOnDocumentClick(t) && this.collapseAll(t), this.mouseHandled = !1;\n        } });\n    }, _destroy: function _destroy() {\n      var e = this.element.find(\".ui-menu-item\").removeAttr(\"role aria-disabled\"),\n          i = e.children(\".ui-menu-item-wrapper\").removeUniqueId().removeAttr(\"tabIndex role aria-haspopup\");this.element.removeAttr(\"aria-activedescendant\").find(\".ui-menu\").addBack().removeAttr(\"role aria-labelledby aria-expanded aria-hidden aria-disabled tabIndex\").removeUniqueId().show(), i.children().each(function () {\n        var e = t(this);e.data(\"ui-menu-submenu-caret\") && e.remove();\n      });\n    }, _keydown: function _keydown(e) {\n      var i,\n          s,\n          n,\n          o,\n          a = !0;switch (e.keyCode) {case t.ui.keyCode.PAGE_UP:\n          this.previousPage(e);break;case t.ui.keyCode.PAGE_DOWN:\n          this.nextPage(e);break;case t.ui.keyCode.HOME:\n          this._move(\"first\", \"first\", e);break;case t.ui.keyCode.END:\n          this._move(\"last\", \"last\", e);break;case t.ui.keyCode.UP:\n          this.previous(e);break;case t.ui.keyCode.DOWN:\n          this.next(e);break;case t.ui.keyCode.LEFT:\n          this.collapse(e);break;case t.ui.keyCode.RIGHT:\n          this.active && !this.active.is(\".ui-state-disabled\") && this.expand(e);break;case t.ui.keyCode.ENTER:case t.ui.keyCode.SPACE:\n          this._activate(e);break;case t.ui.keyCode.ESCAPE:\n          this.collapse(e);break;default:\n          a = !1, s = this.previousFilter || \"\", o = !1, n = e.keyCode >= 96 && 105 >= e.keyCode ? \"\" + (e.keyCode - 96) : String.fromCharCode(e.keyCode), clearTimeout(this.filterTimer), n === s ? o = !0 : n = s + n, i = this._filterMenuItems(n), i = o && -1 !== i.index(this.active.next()) ? this.active.nextAll(\".ui-menu-item\") : i, i.length || (n = String.fromCharCode(e.keyCode), i = this._filterMenuItems(n)), i.length ? (this.focus(e, i), this.previousFilter = n, this.filterTimer = this._delay(function () {\n            delete this.previousFilter;\n          }, 1e3)) : delete this.previousFilter;}a && e.preventDefault();\n    }, _activate: function _activate(t) {\n      this.active && !this.active.is(\".ui-state-disabled\") && (this.active.children(\"[aria-haspopup='true']\").length ? this.expand(t) : this.select(t));\n    }, refresh: function refresh() {\n      var e,\n          i,\n          s,\n          n,\n          o,\n          a = this,\n          r = this.options.icons.submenu,\n          h = this.element.find(this.options.menus);this._toggleClass(\"ui-menu-icons\", null, !!this.element.find(\".ui-icon\").length), s = h.filter(\":not(.ui-menu)\").hide().attr({ role: this.options.role, \"aria-hidden\": \"true\", \"aria-expanded\": \"false\" }).each(function () {\n        var e = t(this),\n            i = e.prev(),\n            s = t(\"<span>\").data(\"ui-menu-submenu-caret\", !0);a._addClass(s, \"ui-menu-icon\", \"ui-icon \" + r), i.attr(\"aria-haspopup\", \"true\").prepend(s), e.attr(\"aria-labelledby\", i.attr(\"id\"));\n      }), this._addClass(s, \"ui-menu\", \"ui-widget ui-widget-content ui-front\"), e = h.add(this.element), i = e.find(this.options.items), i.not(\".ui-menu-item\").each(function () {\n        var e = t(this);a._isDivider(e) && a._addClass(e, \"ui-menu-divider\", \"ui-widget-content\");\n      }), n = i.not(\".ui-menu-item, .ui-menu-divider\"), o = n.children().not(\".ui-menu\").uniqueId().attr({ tabIndex: -1, role: this._itemRole() }), this._addClass(n, \"ui-menu-item\")._addClass(o, \"ui-menu-item-wrapper\"), i.filter(\".ui-state-disabled\").attr(\"aria-disabled\", \"true\"), this.active && !t.contains(this.element[0], this.active[0]) && this.blur();\n    }, _itemRole: function _itemRole() {\n      return { menu: \"menuitem\", listbox: \"option\" }[this.options.role];\n    }, _setOption: function _setOption(t, e) {\n      if (\"icons\" === t) {\n        var i = this.element.find(\".ui-menu-icon\");this._removeClass(i, null, this.options.icons.submenu)._addClass(i, null, e.submenu);\n      }this._super(t, e);\n    }, _setOptionDisabled: function _setOptionDisabled(t) {\n      this._super(t), this.element.attr(\"aria-disabled\", t + \"\"), this._toggleClass(null, \"ui-state-disabled\", !!t);\n    }, focus: function focus(t, e) {\n      var i, s, n;this.blur(t, t && \"focus\" === t.type), this._scrollIntoView(e), this.active = e.first(), s = this.active.children(\".ui-menu-item-wrapper\"), this._addClass(s, null, \"ui-state-active\"), this.options.role && this.element.attr(\"aria-activedescendant\", s.attr(\"id\")), n = this.active.parent().closest(\".ui-menu-item\").children(\".ui-menu-item-wrapper\"), this._addClass(n, null, \"ui-state-active\"), t && \"keydown\" === t.type ? this._close() : this.timer = this._delay(function () {\n        this._close();\n      }, this.delay), i = e.children(\".ui-menu\"), i.length && t && /^mouse/.test(t.type) && this._startOpening(i), this.activeMenu = e.parent(), this._trigger(\"focus\", t, { item: e });\n    }, _scrollIntoView: function _scrollIntoView(e) {\n      var i, s, n, o, a, r;this._hasScroll() && (i = parseFloat(t.css(this.activeMenu[0], \"borderTopWidth\")) || 0, s = parseFloat(t.css(this.activeMenu[0], \"paddingTop\")) || 0, n = e.offset().top - this.activeMenu.offset().top - i - s, o = this.activeMenu.scrollTop(), a = this.activeMenu.height(), r = e.outerHeight(), 0 > n ? this.activeMenu.scrollTop(o + n) : n + r > a && this.activeMenu.scrollTop(o + n - a + r));\n    }, blur: function blur(t, e) {\n      e || clearTimeout(this.timer), this.active && (this._removeClass(this.active.children(\".ui-menu-item-wrapper\"), null, \"ui-state-active\"), this._trigger(\"blur\", t, { item: this.active }), this.active = null);\n    }, _startOpening: function _startOpening(t) {\n      clearTimeout(this.timer), \"true\" === t.attr(\"aria-hidden\") && (this.timer = this._delay(function () {\n        this._close(), this._open(t);\n      }, this.delay));\n    }, _open: function _open(e) {\n      var i = t.extend({ of: this.active }, this.options.position);clearTimeout(this.timer), this.element.find(\".ui-menu\").not(e.parents(\".ui-menu\")).hide().attr(\"aria-hidden\", \"true\"), e.show().removeAttr(\"aria-hidden\").attr(\"aria-expanded\", \"true\").position(i);\n    }, collapseAll: function collapseAll(e, i) {\n      clearTimeout(this.timer), this.timer = this._delay(function () {\n        var s = i ? this.element : t(e && e.target).closest(this.element.find(\".ui-menu\"));s.length || (s = this.element), this._close(s), this.blur(e), this._removeClass(s.find(\".ui-state-active\"), null, \"ui-state-active\"), this.activeMenu = s;\n      }, this.delay);\n    }, _close: function _close(t) {\n      t || (t = this.active ? this.active.parent() : this.element), t.find(\".ui-menu\").hide().attr(\"aria-hidden\", \"true\").attr(\"aria-expanded\", \"false\");\n    }, _closeOnDocumentClick: function _closeOnDocumentClick(e) {\n      return !t(e.target).closest(\".ui-menu\").length;\n    }, _isDivider: function _isDivider(t) {\n      return !/[^\\-\\u2014\\u2013\\s]/.test(t.text());\n    }, collapse: function collapse(t) {\n      var e = this.active && this.active.parent().closest(\".ui-menu-item\", this.element);e && e.length && (this._close(), this.focus(t, e));\n    }, expand: function expand(t) {\n      var e = this.active && this.active.children(\".ui-menu \").find(this.options.items).first();e && e.length && (this._open(e.parent()), this._delay(function () {\n        this.focus(t, e);\n      }));\n    }, next: function next(t) {\n      this._move(\"next\", \"first\", t);\n    }, previous: function previous(t) {\n      this._move(\"prev\", \"last\", t);\n    }, isFirstItem: function isFirstItem() {\n      return this.active && !this.active.prevAll(\".ui-menu-item\").length;\n    }, isLastItem: function isLastItem() {\n      return this.active && !this.active.nextAll(\".ui-menu-item\").length;\n    }, _move: function _move(t, e, i) {\n      var s;this.active && (s = \"first\" === t || \"last\" === t ? this.active[\"first\" === t ? \"prevAll\" : \"nextAll\"](\".ui-menu-item\").eq(-1) : this.active[t + \"All\"](\".ui-menu-item\").eq(0)), s && s.length && this.active || (s = this.activeMenu.find(this.options.items)[e]()), this.focus(i, s);\n    }, nextPage: function nextPage(e) {\n      var i, s, n;return this.active ? (this.isLastItem() || (this._hasScroll() ? (s = this.active.offset().top, n = this.element.height(), this.active.nextAll(\".ui-menu-item\").each(function () {\n        return i = t(this), 0 > i.offset().top - s - n;\n      }), this.focus(e, i)) : this.focus(e, this.activeMenu.find(this.options.items)[this.active ? \"last\" : \"first\"]())), void 0) : (this.next(e), void 0);\n    }, previousPage: function previousPage(e) {\n      var i, s, n;return this.active ? (this.isFirstItem() || (this._hasScroll() ? (s = this.active.offset().top, n = this.element.height(), this.active.prevAll(\".ui-menu-item\").each(function () {\n        return i = t(this), i.offset().top - s + n > 0;\n      }), this.focus(e, i)) : this.focus(e, this.activeMenu.find(this.options.items).first())), void 0) : (this.next(e), void 0);\n    }, _hasScroll: function _hasScroll() {\n      return this.element.outerHeight() < this.element.prop(\"scrollHeight\");\n    }, select: function select(e) {\n      this.active = this.active || t(e.target).closest(\".ui-menu-item\");var i = { item: this.active };this.active.has(\".ui-menu\").length || this.collapseAll(e, !0), this._trigger(\"select\", e, i);\n    }, _filterMenuItems: function _filterMenuItems(e) {\n      var i = e.replace(/[\\-\\[\\]{}()*+?.,\\\\\\^$|#\\s]/g, \"\\\\$&\"),\n          s = RegExp(\"^\" + i, \"i\");return this.activeMenu.find(this.options.items).filter(\".ui-menu-item\").filter(function () {\n        return s.test(t.trim(t(this).children(\".ui-menu-item-wrapper\").text()));\n      });\n    } }), t.widget(\"ui.autocomplete\", { version: \"1.12.1\", defaultElement: \"<input>\", options: { appendTo: null, autoFocus: !1, delay: 300, minLength: 1, position: { my: \"left top\", at: \"left bottom\", collision: \"none\" }, source: null, change: null, close: null, focus: null, open: null, response: null, search: null, select: null }, requestIndex: 0, pending: 0, _create: function _create() {\n      var e,\n          i,\n          s,\n          n = this.element[0].nodeName.toLowerCase(),\n          o = \"textarea\" === n,\n          a = \"input\" === n;\n      this.isMultiLine = o || !a && this._isContentEditable(this.element), this.valueMethod = this.element[o || a ? \"val\" : \"text\"], this.isNewMenu = !0, this._addClass(\"ui-autocomplete-input\"), this.element.attr(\"autocomplete\", \"off\"), this._on(this.element, { keydown: function keydown(n) {\n          if (this.element.prop(\"readOnly\")) return e = !0, s = !0, i = !0, void 0;e = !1, s = !1, i = !1;var o = t.ui.keyCode;switch (n.keyCode) {case o.PAGE_UP:\n              e = !0, this._move(\"previousPage\", n);break;case o.PAGE_DOWN:\n              e = !0, this._move(\"nextPage\", n);break;case o.UP:\n              e = !0, this._keyEvent(\"previous\", n);break;case o.DOWN:\n              e = !0, this._keyEvent(\"next\", n);break;case o.ENTER:\n              this.menu.active && (e = !0, n.preventDefault(), this.menu.select(n));break;case o.TAB:\n              this.menu.active && this.menu.select(n);break;case o.ESCAPE:\n              this.menu.element.is(\":visible\") && (this.isMultiLine || this._value(this.term), this.close(n), n.preventDefault());break;default:\n              i = !0, this._searchTimeout(n);}\n        }, keypress: function keypress(s) {\n          if (e) return e = !1, (!this.isMultiLine || this.menu.element.is(\":visible\")) && s.preventDefault(), void 0;if (!i) {\n            var n = t.ui.keyCode;switch (s.keyCode) {case n.PAGE_UP:\n                this._move(\"previousPage\", s);break;case n.PAGE_DOWN:\n                this._move(\"nextPage\", s);break;case n.UP:\n                this._keyEvent(\"previous\", s);break;case n.DOWN:\n                this._keyEvent(\"next\", s);}\n          }\n        }, input: function input(t) {\n          return s ? (s = !1, t.preventDefault(), void 0) : (this._searchTimeout(t), void 0);\n        }, focus: function focus() {\n          this.selectedItem = null, this.previous = this._value();\n        }, blur: function blur(t) {\n          return this.cancelBlur ? (delete this.cancelBlur, void 0) : (clearTimeout(this.searching), this.close(t), this._change(t), void 0);\n        } }), this._initSource(), this.menu = t(\"<ul>\").appendTo(this._appendTo()).menu({ role: null }).hide().menu(\"instance\"), this._addClass(this.menu.element, \"ui-autocomplete\", \"ui-front\"), this._on(this.menu.element, { mousedown: function mousedown(e) {\n          e.preventDefault(), this.cancelBlur = !0, this._delay(function () {\n            delete this.cancelBlur, this.element[0] !== t.ui.safeActiveElement(this.document[0]) && this.element.trigger(\"focus\");\n          });\n        }, menufocus: function menufocus(e, i) {\n          var s, n;return this.isNewMenu && (this.isNewMenu = !1, e.originalEvent && /^mouse/.test(e.originalEvent.type)) ? (this.menu.blur(), this.document.one(\"mousemove\", function () {\n            t(e.target).trigger(e.originalEvent);\n          }), void 0) : (n = i.item.data(\"ui-autocomplete-item\"), !1 !== this._trigger(\"focus\", e, { item: n }) && e.originalEvent && /^key/.test(e.originalEvent.type) && this._value(n.value), s = i.item.attr(\"aria-label\") || n.value, s && t.trim(s).length && (this.liveRegion.children().hide(), t(\"<div>\").text(s).appendTo(this.liveRegion)), void 0);\n        }, menuselect: function menuselect(e, i) {\n          var s = i.item.data(\"ui-autocomplete-item\"),\n              n = this.previous;this.element[0] !== t.ui.safeActiveElement(this.document[0]) && (this.element.trigger(\"focus\"), this.previous = n, this._delay(function () {\n            this.previous = n, this.selectedItem = s;\n          })), !1 !== this._trigger(\"select\", e, { item: s }) && this._value(s.value), this.term = this._value(), this.close(e), this.selectedItem = s;\n        } }), this.liveRegion = t(\"<div>\", { role: \"status\", \"aria-live\": \"assertive\", \"aria-relevant\": \"additions\" }).appendTo(this.document[0].body), this._addClass(this.liveRegion, null, \"ui-helper-hidden-accessible\"), this._on(this.window, { beforeunload: function beforeunload() {\n          this.element.removeAttr(\"autocomplete\");\n        } });\n    }, _destroy: function _destroy() {\n      clearTimeout(this.searching), this.element.removeAttr(\"autocomplete\"), this.menu.element.remove(), this.liveRegion.remove();\n    }, _setOption: function _setOption(t, e) {\n      this._super(t, e), \"source\" === t && this._initSource(), \"appendTo\" === t && this.menu.element.appendTo(this._appendTo()), \"disabled\" === t && e && this.xhr && this.xhr.abort();\n    }, _isEventTargetInWidget: function _isEventTargetInWidget(e) {\n      var i = this.menu.element[0];return e.target === this.element[0] || e.target === i || t.contains(i, e.target);\n    }, _closeOnClickOutside: function _closeOnClickOutside(t) {\n      this._isEventTargetInWidget(t) || this.close();\n    }, _appendTo: function _appendTo() {\n      var e = this.options.appendTo;return e && (e = e.jquery || e.nodeType ? t(e) : this.document.find(e).eq(0)), e && e[0] || (e = this.element.closest(\".ui-front, dialog\")), e.length || (e = this.document[0].body), e;\n    }, _initSource: function _initSource() {\n      var e,\n          i,\n          s = this;t.isArray(this.options.source) ? (e = this.options.source, this.source = function (i, s) {\n        s(t.ui.autocomplete.filter(e, i.term));\n      }) : \"string\" == typeof this.options.source ? (i = this.options.source, this.source = function (e, n) {\n        s.xhr && s.xhr.abort(), s.xhr = t.ajax({ url: i, data: e, dataType: \"json\", success: function success(t) {\n            n(t);\n          }, error: function error() {\n            n([]);\n          } });\n      }) : this.source = this.options.source;\n    }, _searchTimeout: function _searchTimeout(t) {\n      clearTimeout(this.searching), this.searching = this._delay(function () {\n        var e = this.term === this._value(),\n            i = this.menu.element.is(\":visible\"),\n            s = t.altKey || t.ctrlKey || t.metaKey || t.shiftKey;(!e || e && !i && !s) && (this.selectedItem = null, this.search(null, t));\n      }, this.options.delay);\n    }, search: function search(t, e) {\n      return t = null != t ? t : this._value(), this.term = this._value(), t.length < this.options.minLength ? this.close(e) : this._trigger(\"search\", e) !== !1 ? this._search(t) : void 0;\n    }, _search: function _search(t) {\n      this.pending++, this._addClass(\"ui-autocomplete-loading\"), this.cancelSearch = !1, this.source({ term: t }, this._response());\n    }, _response: function _response() {\n      var e = ++this.requestIndex;return t.proxy(function (t) {\n        e === this.requestIndex && this.__response(t), this.pending--, this.pending || this._removeClass(\"ui-autocomplete-loading\");\n      }, this);\n    }, __response: function __response(t) {\n      t && (t = this._normalize(t)), this._trigger(\"response\", null, { content: t }), !this.options.disabled && t && t.length && !this.cancelSearch ? (this._suggest(t), this._trigger(\"open\")) : this._close();\n    }, close: function close(t) {\n      this.cancelSearch = !0, this._close(t);\n    }, _close: function _close(t) {\n      this._off(this.document, \"mousedown\"), this.menu.element.is(\":visible\") && (this.menu.element.hide(), this.menu.blur(), this.isNewMenu = !0, this._trigger(\"close\", t));\n    }, _change: function _change(t) {\n      this.previous !== this._value() && this._trigger(\"change\", t, { item: this.selectedItem });\n    }, _normalize: function _normalize(e) {\n      return e.length && e[0].label && e[0].value ? e : t.map(e, function (e) {\n        return \"string\" == typeof e ? { label: e, value: e } : t.extend({}, e, { label: e.label || e.value, value: e.value || e.label });\n      });\n    }, _suggest: function _suggest(e) {\n      var i = this.menu.element.empty();this._renderMenu(i, e), this.isNewMenu = !0, this.menu.refresh(), i.show(), this._resizeMenu(), i.position(t.extend({ of: this.element }, this.options.position)), this.options.autoFocus && this.menu.next(), this._on(this.document, { mousedown: \"_closeOnClickOutside\" });\n    }, _resizeMenu: function _resizeMenu() {\n      var t = this.menu.element;t.outerWidth(Math.max(t.width(\"\").outerWidth() + 1, this.element.outerWidth()));\n    }, _renderMenu: function _renderMenu(e, i) {\n      var s = this;t.each(i, function (t, i) {\n        s._renderItemData(e, i);\n      });\n    }, _renderItemData: function _renderItemData(t, e) {\n      return this._renderItem(t, e).data(\"ui-autocomplete-item\", e);\n    }, _renderItem: function _renderItem(e, i) {\n      return t(\"<li>\").append(t(\"<div>\").text(i.label)).appendTo(e);\n    }, _move: function _move(t, e) {\n      return this.menu.element.is(\":visible\") ? this.menu.isFirstItem() && /^previous/.test(t) || this.menu.isLastItem() && /^next/.test(t) ? (this.isMultiLine || this._value(this.term), this.menu.blur(), void 0) : (this.menu[t](e), void 0) : (this.search(null, e), void 0);\n    }, widget: function widget() {\n      return this.menu.element;\n    }, _value: function _value() {\n      return this.valueMethod.apply(this.element, arguments);\n    }, _keyEvent: function _keyEvent(t, e) {\n      (!this.isMultiLine || this.menu.element.is(\":visible\")) && (this._move(t, e), e.preventDefault());\n    }, _isContentEditable: function _isContentEditable(t) {\n      if (!t.length) return !1;var e = t.prop(\"contentEditable\");return \"inherit\" === e ? this._isContentEditable(t.parent()) : \"true\" === e;\n    } }), t.extend(t.ui.autocomplete, { escapeRegex: function escapeRegex(t) {\n      return t.replace(/[\\-\\[\\]{}()*+?.,\\\\\\^$|#\\s]/g, \"\\\\$&\");\n    }, filter: function filter(e, i) {\n      var s = RegExp(t.ui.autocomplete.escapeRegex(i), \"i\");return t.grep(e, function (t) {\n        return s.test(t.label || t.value || t);\n      });\n    } }), t.widget(\"ui.autocomplete\", t.ui.autocomplete, { options: { messages: { noResults: \"No search results.\", results: function results(t) {\n          return t + (t > 1 ? \" results are\" : \" result is\") + \" available, use up and down arrow keys to navigate.\";\n        } } }, __response: function __response(e) {\n      var i;this._superApply(arguments), this.options.disabled || this.cancelSearch || (i = e && e.length ? this.options.messages.results(e.length) : this.options.messages.noResults, this.liveRegion.children().hide(), t(\"<div>\").text(i).appendTo(this.liveRegion));\n    } }), t.ui.autocomplete;var g = /ui-corner-([a-z]){2,6}/g;t.widget(\"ui.controlgroup\", { version: \"1.12.1\", defaultElement: \"<div>\", options: { direction: \"horizontal\", disabled: null, onlyVisible: !0, items: { button: \"input[type=button], input[type=submit], input[type=reset], button, a\", controlgroupLabel: \".ui-controlgroup-label\", checkboxradio: \"input[type='checkbox'], input[type='radio']\", selectmenu: \"select\", spinner: \".ui-spinner-input\" } }, _create: function _create() {\n      this._enhance();\n    }, _enhance: function _enhance() {\n      this.element.attr(\"role\", \"toolbar\"), this.refresh();\n    }, _destroy: function _destroy() {\n      this._callChildMethod(\"destroy\"), this.childWidgets.removeData(\"ui-controlgroup-data\"), this.element.removeAttr(\"role\"), this.options.items.controlgroupLabel && this.element.find(this.options.items.controlgroupLabel).find(\".ui-controlgroup-label-contents\").contents().unwrap();\n    }, _initWidgets: function _initWidgets() {\n      var e = this,\n          i = [];t.each(this.options.items, function (s, n) {\n        var o,\n            a = {};return n ? \"controlgroupLabel\" === s ? (o = e.element.find(n), o.each(function () {\n          var e = t(this);e.children(\".ui-controlgroup-label-contents\").length || e.contents().wrapAll(\"<span class='ui-controlgroup-label-contents'></span>\");\n        }), e._addClass(o, null, \"ui-widget ui-widget-content ui-state-default\"), i = i.concat(o.get()), void 0) : (t.fn[s] && (a = e[\"_\" + s + \"Options\"] ? e[\"_\" + s + \"Options\"](\"middle\") : { classes: {} }, e.element.find(n).each(function () {\n          var n = t(this),\n              o = n[s](\"instance\"),\n              r = t.widget.extend({}, a);if (\"button\" !== s || !n.parent(\".ui-spinner\").length) {\n            o || (o = n[s]()[s](\"instance\")), o && (r.classes = e._resolveClassesValues(r.classes, o)), n[s](r);var h = n[s](\"widget\");t.data(h[0], \"ui-controlgroup-data\", o ? o : n[s](\"instance\")), i.push(h[0]);\n          }\n        })), void 0) : void 0;\n      }), this.childWidgets = t(t.unique(i)), this._addClass(this.childWidgets, \"ui-controlgroup-item\");\n    }, _callChildMethod: function _callChildMethod(e) {\n      this.childWidgets.each(function () {\n        var i = t(this),\n            s = i.data(\"ui-controlgroup-data\");s && s[e] && s[e]();\n      });\n    }, _updateCornerClass: function _updateCornerClass(t, e) {\n      var i = \"ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all\",\n          s = this._buildSimpleOptions(e, \"label\").classes.label;this._removeClass(t, null, i), this._addClass(t, null, s);\n    }, _buildSimpleOptions: function _buildSimpleOptions(t, e) {\n      var i = \"vertical\" === this.options.direction,\n          s = { classes: {} };return s.classes[e] = { middle: \"\", first: \"ui-corner-\" + (i ? \"top\" : \"left\"), last: \"ui-corner-\" + (i ? \"bottom\" : \"right\"), only: \"ui-corner-all\" }[t], s;\n    }, _spinnerOptions: function _spinnerOptions(t) {\n      var e = this._buildSimpleOptions(t, \"ui-spinner\");return e.classes[\"ui-spinner-up\"] = \"\", e.classes[\"ui-spinner-down\"] = \"\", e;\n    }, _buttonOptions: function _buttonOptions(t) {\n      return this._buildSimpleOptions(t, \"ui-button\");\n    }, _checkboxradioOptions: function _checkboxradioOptions(t) {\n      return this._buildSimpleOptions(t, \"ui-checkboxradio-label\");\n    }, _selectmenuOptions: function _selectmenuOptions(t) {\n      var e = \"vertical\" === this.options.direction;return { width: e ? \"auto\" : !1, classes: { middle: { \"ui-selectmenu-button-open\": \"\", \"ui-selectmenu-button-closed\": \"\" }, first: { \"ui-selectmenu-button-open\": \"ui-corner-\" + (e ? \"top\" : \"tl\"), \"ui-selectmenu-button-closed\": \"ui-corner-\" + (e ? \"top\" : \"left\") }, last: { \"ui-selectmenu-button-open\": e ? \"\" : \"ui-corner-tr\", \"ui-selectmenu-button-closed\": \"ui-corner-\" + (e ? \"bottom\" : \"right\") }, only: { \"ui-selectmenu-button-open\": \"ui-corner-top\", \"ui-selectmenu-button-closed\": \"ui-corner-all\" } }[t] };\n    }, _resolveClassesValues: function _resolveClassesValues(e, i) {\n      var s = {};return t.each(e, function (n) {\n        var o = i.options.classes[n] || \"\";o = t.trim(o.replace(g, \"\")), s[n] = (o + \" \" + e[n]).replace(/\\s+/g, \" \");\n      }), s;\n    }, _setOption: function _setOption(t, e) {\n      return \"direction\" === t && this._removeClass(\"ui-controlgroup-\" + this.options.direction), this._super(t, e), \"disabled\" === t ? (this._callChildMethod(e ? \"disable\" : \"enable\"), void 0) : (this.refresh(), void 0);\n    }, refresh: function refresh() {\n      var e,\n          i = this;this._addClass(\"ui-controlgroup ui-controlgroup-\" + this.options.direction), \"horizontal\" === this.options.direction && this._addClass(null, \"ui-helper-clearfix\"), this._initWidgets(), e = this.childWidgets, this.options.onlyVisible && (e = e.filter(\":visible\")), e.length && (t.each([\"first\", \"last\"], function (t, s) {\n        var n = e[s]().data(\"ui-controlgroup-data\");if (n && i[\"_\" + n.widgetName + \"Options\"]) {\n          var o = i[\"_\" + n.widgetName + \"Options\"](1 === e.length ? \"only\" : s);o.classes = i._resolveClassesValues(o.classes, n), n.element[n.widgetName](o);\n        } else i._updateCornerClass(e[s](), s);\n      }), this._callChildMethod(\"refresh\"));\n    } }), t.widget(\"ui.checkboxradio\", [t.ui.formResetMixin, { version: \"1.12.1\", options: { disabled: null, label: null, icon: !0, classes: { \"ui-checkboxradio-label\": \"ui-corner-all\", \"ui-checkboxradio-icon\": \"ui-corner-all\" } }, _getCreateOptions: function _getCreateOptions() {\n      var e,\n          i,\n          s = this,\n          n = this._super() || {};return this._readType(), i = this.element.labels(), this.label = t(i[i.length - 1]), this.label.length || t.error(\"No label found for checkboxradio widget\"), this.originalLabel = \"\", this.label.contents().not(this.element[0]).each(function () {\n        s.originalLabel += 3 === this.nodeType ? t(this).text() : this.outerHTML;\n      }), this.originalLabel && (n.label = this.originalLabel), e = this.element[0].disabled, null != e && (n.disabled = e), n;\n    }, _create: function _create() {\n      var t = this.element[0].checked;this._bindFormResetHandler(), null == this.options.disabled && (this.options.disabled = this.element[0].disabled), this._setOption(\"disabled\", this.options.disabled), this._addClass(\"ui-checkboxradio\", \"ui-helper-hidden-accessible\"), this._addClass(this.label, \"ui-checkboxradio-label\", \"ui-button ui-widget\"), \"radio\" === this.type && this._addClass(this.label, \"ui-checkboxradio-radio-label\"), this.options.label && this.options.label !== this.originalLabel ? this._updateLabel() : this.originalLabel && (this.options.label = this.originalLabel), this._enhance(), t && (this._addClass(this.label, \"ui-checkboxradio-checked\", \"ui-state-active\"), this.icon && this._addClass(this.icon, null, \"ui-state-hover\")), this._on({ change: \"_toggleClasses\", focus: function focus() {\n          this._addClass(this.label, null, \"ui-state-focus ui-visual-focus\");\n        }, blur: function blur() {\n          this._removeClass(this.label, null, \"ui-state-focus ui-visual-focus\");\n        } });\n    }, _readType: function _readType() {\n      var e = this.element[0].nodeName.toLowerCase();this.type = this.element[0].type, \"input\" === e && /radio|checkbox/.test(this.type) || t.error(\"Can't create checkboxradio on element.nodeName=\" + e + \" and element.type=\" + this.type);\n    }, _enhance: function _enhance() {\n      this._updateIcon(this.element[0].checked);\n    }, widget: function widget() {\n      return this.label;\n    }, _getRadioGroup: function _getRadioGroup() {\n      var e,\n          i = this.element[0].name,\n          s = \"input[name='\" + t.ui.escapeSelector(i) + \"']\";return i ? (e = this.form.length ? t(this.form[0].elements).filter(s) : t(s).filter(function () {\n        return 0 === t(this).form().length;\n      }), e.not(this.element)) : t([]);\n    }, _toggleClasses: function _toggleClasses() {\n      var e = this.element[0].checked;this._toggleClass(this.label, \"ui-checkboxradio-checked\", \"ui-state-active\", e), this.options.icon && \"checkbox\" === this.type && this._toggleClass(this.icon, null, \"ui-icon-check ui-state-checked\", e)._toggleClass(this.icon, null, \"ui-icon-blank\", !e), \"radio\" === this.type && this._getRadioGroup().each(function () {\n        var e = t(this).checkboxradio(\"instance\");e && e._removeClass(e.label, \"ui-checkboxradio-checked\", \"ui-state-active\");\n      });\n    }, _destroy: function _destroy() {\n      this._unbindFormResetHandler(), this.icon && (this.icon.remove(), this.iconSpace.remove());\n    }, _setOption: function _setOption(t, e) {\n      return \"label\" !== t || e ? (this._super(t, e), \"disabled\" === t ? (this._toggleClass(this.label, null, \"ui-state-disabled\", e), this.element[0].disabled = e, void 0) : (this.refresh(), void 0)) : void 0;\n    }, _updateIcon: function _updateIcon(e) {\n      var i = \"ui-icon ui-icon-background \";this.options.icon ? (this.icon || (this.icon = t(\"<span>\"), this.iconSpace = t(\"<span> </span>\"), this._addClass(this.iconSpace, \"ui-checkboxradio-icon-space\")), \"checkbox\" === this.type ? (i += e ? \"ui-icon-check ui-state-checked\" : \"ui-icon-blank\", this._removeClass(this.icon, null, e ? \"ui-icon-blank\" : \"ui-icon-check\")) : i += \"ui-icon-blank\", this._addClass(this.icon, \"ui-checkboxradio-icon\", i), e || this._removeClass(this.icon, null, \"ui-icon-check ui-state-checked\"), this.icon.prependTo(this.label).after(this.iconSpace)) : void 0 !== this.icon && (this.icon.remove(), this.iconSpace.remove(), delete this.icon);\n    }, _updateLabel: function _updateLabel() {\n      var t = this.label.contents().not(this.element[0]);this.icon && (t = t.not(this.icon[0])), this.iconSpace && (t = t.not(this.iconSpace[0])), t.remove(), this.label.append(this.options.label);\n    }, refresh: function refresh() {\n      var t = this.element[0].checked,\n          e = this.element[0].disabled;this._updateIcon(t), this._toggleClass(this.label, \"ui-checkboxradio-checked\", \"ui-state-active\", t), null !== this.options.label && this._updateLabel(), e !== this.options.disabled && this._setOptions({ disabled: e });\n    } }]), t.ui.checkboxradio, t.widget(\"ui.button\", { version: \"1.12.1\", defaultElement: \"<button>\", options: { classes: { \"ui-button\": \"ui-corner-all\" }, disabled: null, icon: null, iconPosition: \"beginning\", label: null, showLabel: !0 }, _getCreateOptions: function _getCreateOptions() {\n      var t,\n          e = this._super() || {};return this.isInput = this.element.is(\"input\"), t = this.element[0].disabled, null != t && (e.disabled = t), this.originalLabel = this.isInput ? this.element.val() : this.element.html(), this.originalLabel && (e.label = this.originalLabel), e;\n    }, _create: function _create() {\n      !this.option.showLabel & !this.options.icon && (this.options.showLabel = !0), null == this.options.disabled && (this.options.disabled = this.element[0].disabled || !1), this.hasTitle = !!this.element.attr(\"title\"), this.options.label && this.options.label !== this.originalLabel && (this.isInput ? this.element.val(this.options.label) : this.element.html(this.options.label)), this._addClass(\"ui-button\", \"ui-widget\"), this._setOption(\"disabled\", this.options.disabled), this._enhance(), this.element.is(\"a\") && this._on({ keyup: function keyup(e) {\n          e.keyCode === t.ui.keyCode.SPACE && (e.preventDefault(), this.element[0].click ? this.element[0].click() : this.element.trigger(\"click\"));\n        } });\n    }, _enhance: function _enhance() {\n      this.element.is(\"button\") || this.element.attr(\"role\", \"button\"), this.options.icon && (this._updateIcon(\"icon\", this.options.icon), this._updateTooltip());\n    }, _updateTooltip: function _updateTooltip() {\n      this.title = this.element.attr(\"title\"), this.options.showLabel || this.title || this.element.attr(\"title\", this.options.label);\n    }, _updateIcon: function _updateIcon(e, i) {\n      var s = \"iconPosition\" !== e,\n          n = s ? this.options.iconPosition : i,\n          o = \"top\" === n || \"bottom\" === n;this.icon ? s && this._removeClass(this.icon, null, this.options.icon) : (this.icon = t(\"<span>\"), this._addClass(this.icon, \"ui-button-icon\", \"ui-icon\"), this.options.showLabel || this._addClass(\"ui-button-icon-only\")), s && this._addClass(this.icon, null, i), this._attachIcon(n), o ? (this._addClass(this.icon, null, \"ui-widget-icon-block\"), this.iconSpace && this.iconSpace.remove()) : (this.iconSpace || (this.iconSpace = t(\"<span> </span>\"), this._addClass(this.iconSpace, \"ui-button-icon-space\")), this._removeClass(this.icon, null, \"ui-wiget-icon-block\"), this._attachIconSpace(n));\n    }, _destroy: function _destroy() {\n      this.element.removeAttr(\"role\"), this.icon && this.icon.remove(), this.iconSpace && this.iconSpace.remove(), this.hasTitle || this.element.removeAttr(\"title\");\n    }, _attachIconSpace: function _attachIconSpace(t) {\n      this.icon[/^(?:end|bottom)/.test(t) ? \"before\" : \"after\"](this.iconSpace);\n    }, _attachIcon: function _attachIcon(t) {\n      this.element[/^(?:end|bottom)/.test(t) ? \"append\" : \"prepend\"](this.icon);\n    }, _setOptions: function _setOptions(t) {\n      var e = void 0 === t.showLabel ? this.options.showLabel : t.showLabel,\n          i = void 0 === t.icon ? this.options.icon : t.icon;e || i || (t.showLabel = !0), this._super(t);\n    }, _setOption: function _setOption(t, e) {\n      \"icon\" === t && (e ? this._updateIcon(t, e) : this.icon && (this.icon.remove(), this.iconSpace && this.iconSpace.remove())), \"iconPosition\" === t && this._updateIcon(t, e), \"showLabel\" === t && (this._toggleClass(\"ui-button-icon-only\", null, !e), this._updateTooltip()), \"label\" === t && (this.isInput ? this.element.val(e) : (this.element.html(e), this.icon && (this._attachIcon(this.options.iconPosition), this._attachIconSpace(this.options.iconPosition)))), this._super(t, e), \"disabled\" === t && (this._toggleClass(null, \"ui-state-disabled\", e), this.element[0].disabled = e, e && this.element.blur());\n    }, refresh: function refresh() {\n      var t = this.element.is(\"input, button\") ? this.element[0].disabled : this.element.hasClass(\"ui-button-disabled\");t !== this.options.disabled && this._setOptions({ disabled: t }), this._updateTooltip();\n    } }), t.uiBackCompat !== !1 && (t.widget(\"ui.button\", t.ui.button, { options: { text: !0, icons: { primary: null, secondary: null } }, _create: function _create() {\n      this.options.showLabel && !this.options.text && (this.options.showLabel = this.options.text), !this.options.showLabel && this.options.text && (this.options.text = this.options.showLabel), this.options.icon || !this.options.icons.primary && !this.options.icons.secondary ? this.options.icon && (this.options.icons.primary = this.options.icon) : this.options.icons.primary ? this.options.icon = this.options.icons.primary : (this.options.icon = this.options.icons.secondary, this.options.iconPosition = \"end\"), this._super();\n    }, _setOption: function _setOption(t, e) {\n      return \"text\" === t ? (this._super(\"showLabel\", e), void 0) : (\"showLabel\" === t && (this.options.text = e), \"icon\" === t && (this.options.icons.primary = e), \"icons\" === t && (e.primary ? (this._super(\"icon\", e.primary), this._super(\"iconPosition\", \"beginning\")) : e.secondary && (this._super(\"icon\", e.secondary), this._super(\"iconPosition\", \"end\"))), this._superApply(arguments), void 0);\n    } }), t.fn.button = function (e) {\n    return function () {\n      return !this.length || this.length && \"INPUT\" !== this[0].tagName || this.length && \"INPUT\" === this[0].tagName && \"checkbox\" !== this.attr(\"type\") && \"radio\" !== this.attr(\"type\") ? e.apply(this, arguments) : (t.ui.checkboxradio || t.error(\"Checkboxradio widget missing\"), 0 === arguments.length ? this.checkboxradio({ icon: !1 }) : this.checkboxradio.apply(this, arguments));\n    };\n  }(t.fn.button), t.fn.buttonset = function () {\n    return t.ui.controlgroup || t.error(\"Controlgroup widget missing\"), \"option\" === arguments[0] && \"items\" === arguments[1] && arguments[2] ? this.controlgroup.apply(this, [arguments[0], \"items.button\", arguments[2]]) : \"option\" === arguments[0] && \"items\" === arguments[1] ? this.controlgroup.apply(this, [arguments[0], \"items.button\"]) : (\"object\" == _typeof(arguments[0]) && arguments[0].items && (arguments[0].items = { button: arguments[0].items }), this.controlgroup.apply(this, arguments));\n  }), t.ui.button, t.extend(t.ui, { datepicker: { version: \"1.12.1\" } });var m;t.extend(s.prototype, { markerClassName: \"hasDatepicker\", maxRows: 4, _widgetDatepicker: function _widgetDatepicker() {\n      return this.dpDiv;\n    }, setDefaults: function setDefaults(t) {\n      return a(this._defaults, t || {}), this;\n    }, _attachDatepicker: function _attachDatepicker(e, i) {\n      var s, n, o;s = e.nodeName.toLowerCase(), n = \"div\" === s || \"span\" === s, e.id || (this.uuid += 1, e.id = \"dp\" + this.uuid), o = this._newInst(t(e), n), o.settings = t.extend({}, i || {}), \"input\" === s ? this._connectDatepicker(e, o) : n && this._inlineDatepicker(e, o);\n    }, _newInst: function _newInst(e, i) {\n      var s = e[0].id.replace(/([^A-Za-z0-9_\\-])/g, \"\\\\\\\\$1\");return { id: s, input: e, selectedDay: 0, selectedMonth: 0, selectedYear: 0, drawMonth: 0, drawYear: 0, inline: i, dpDiv: i ? n(t(\"<div class='\" + this._inlineClass + \" ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>\")) : this.dpDiv };\n    }, _connectDatepicker: function _connectDatepicker(e, i) {\n      var s = t(e);i.append = t([]), i.trigger = t([]), s.hasClass(this.markerClassName) || (this._attachments(s, i), s.addClass(this.markerClassName).on(\"keydown\", this._doKeyDown).on(\"keypress\", this._doKeyPress).on(\"keyup\", this._doKeyUp), this._autoSize(i), t.data(e, \"datepicker\", i), i.settings.disabled && this._disableDatepicker(e));\n    }, _attachments: function _attachments(e, i) {\n      var s,\n          n,\n          o,\n          a = this._get(i, \"appendText\"),\n          r = this._get(i, \"isRTL\");i.append && i.append.remove(), a && (i.append = t(\"<span class='\" + this._appendClass + \"'>\" + a + \"</span>\"), e[r ? \"before\" : \"after\"](i.append)), e.off(\"focus\", this._showDatepicker), i.trigger && i.trigger.remove(), s = this._get(i, \"showOn\"), (\"focus\" === s || \"both\" === s) && e.on(\"focus\", this._showDatepicker), (\"button\" === s || \"both\" === s) && (n = this._get(i, \"buttonText\"), o = this._get(i, \"buttonImage\"), i.trigger = t(this._get(i, \"buttonImageOnly\") ? t(\"<img/>\").addClass(this._triggerClass).attr({ src: o, alt: n, title: n }) : t(\"<button type='button'></button>\").addClass(this._triggerClass).html(o ? t(\"<img/>\").attr({ src: o, alt: n, title: n }) : n)), e[r ? \"before\" : \"after\"](i.trigger), i.trigger.on(\"click\", function () {\n        return t.datepicker._datepickerShowing && t.datepicker._lastInput === e[0] ? t.datepicker._hideDatepicker() : t.datepicker._datepickerShowing && t.datepicker._lastInput !== e[0] ? (t.datepicker._hideDatepicker(), t.datepicker._showDatepicker(e[0])) : t.datepicker._showDatepicker(e[0]), !1;\n      }));\n    }, _autoSize: function _autoSize(t) {\n      if (this._get(t, \"autoSize\") && !t.inline) {\n        var e,\n            i,\n            s,\n            n,\n            o = new Date(2009, 11, 20),\n            a = this._get(t, \"dateFormat\");a.match(/[DM]/) && (e = function e(t) {\n          for (i = 0, s = 0, n = 0; t.length > n; n++) {\n            t[n].length > i && (i = t[n].length, s = n);\n          }return s;\n        }, o.setMonth(e(this._get(t, a.match(/MM/) ? \"monthNames\" : \"monthNamesShort\"))), o.setDate(e(this._get(t, a.match(/DD/) ? \"dayNames\" : \"dayNamesShort\")) + 20 - o.getDay())), t.input.attr(\"size\", this._formatDate(t, o).length);\n      }\n    }, _inlineDatepicker: function _inlineDatepicker(e, i) {\n      var s = t(e);s.hasClass(this.markerClassName) || (s.addClass(this.markerClassName).append(i.dpDiv), t.data(e, \"datepicker\", i), this._setDate(i, this._getDefaultDate(i), !0), this._updateDatepicker(i), this._updateAlternate(i), i.settings.disabled && this._disableDatepicker(e), i.dpDiv.css(\"display\", \"block\"));\n    }, _dialogDatepicker: function _dialogDatepicker(e, i, s, n, o) {\n      var r,\n          h,\n          l,\n          c,\n          u,\n          d = this._dialogInst;return d || (this.uuid += 1, r = \"dp\" + this.uuid, this._dialogInput = t(\"<input type='text' id='\" + r + \"' style='position: absolute; top: -100px; width: 0px;'/>\"), this._dialogInput.on(\"keydown\", this._doKeyDown), t(\"body\").append(this._dialogInput), d = this._dialogInst = this._newInst(this._dialogInput, !1), d.settings = {}, t.data(this._dialogInput[0], \"datepicker\", d)), a(d.settings, n || {}), i = i && i.constructor === Date ? this._formatDate(d, i) : i, this._dialogInput.val(i), this._pos = o ? o.length ? o : [o.pageX, o.pageY] : null, this._pos || (h = document.documentElement.clientWidth, l = document.documentElement.clientHeight, c = document.documentElement.scrollLeft || document.body.scrollLeft, u = document.documentElement.scrollTop || document.body.scrollTop, this._pos = [h / 2 - 100 + c, l / 2 - 150 + u]), this._dialogInput.css(\"left\", this._pos[0] + 20 + \"px\").css(\"top\", this._pos[1] + \"px\"), d.settings.onSelect = s, this._inDialog = !0, this.dpDiv.addClass(this._dialogClass), this._showDatepicker(this._dialogInput[0]), t.blockUI && t.blockUI(this.dpDiv), t.data(this._dialogInput[0], \"datepicker\", d), this;\n    }, _destroyDatepicker: function _destroyDatepicker(e) {\n      var i,\n          s = t(e),\n          n = t.data(e, \"datepicker\");s.hasClass(this.markerClassName) && (i = e.nodeName.toLowerCase(), t.removeData(e, \"datepicker\"), \"input\" === i ? (n.append.remove(), n.trigger.remove(), s.removeClass(this.markerClassName).off(\"focus\", this._showDatepicker).off(\"keydown\", this._doKeyDown).off(\"keypress\", this._doKeyPress).off(\"keyup\", this._doKeyUp)) : (\"div\" === i || \"span\" === i) && s.removeClass(this.markerClassName).empty(), m === n && (m = null));\n    }, _enableDatepicker: function _enableDatepicker(e) {\n      var i,\n          s,\n          n = t(e),\n          o = t.data(e, \"datepicker\");n.hasClass(this.markerClassName) && (i = e.nodeName.toLowerCase(), \"input\" === i ? (e.disabled = !1, o.trigger.filter(\"button\").each(function () {\n        this.disabled = !1;\n      }).end().filter(\"img\").css({ opacity: \"1.0\", cursor: \"\" })) : (\"div\" === i || \"span\" === i) && (s = n.children(\".\" + this._inlineClass), s.children().removeClass(\"ui-state-disabled\"), s.find(\"select.ui-datepicker-month, select.ui-datepicker-year\").prop(\"disabled\", !1)), this._disabledInputs = t.map(this._disabledInputs, function (t) {\n        return t === e ? null : t;\n      }));\n    }, _disableDatepicker: function _disableDatepicker(e) {\n      var i,\n          s,\n          n = t(e),\n          o = t.data(e, \"datepicker\");n.hasClass(this.markerClassName) && (i = e.nodeName.toLowerCase(), \"input\" === i ? (e.disabled = !0, o.trigger.filter(\"button\").each(function () {\n        this.disabled = !0;\n      }).end().filter(\"img\").css({ opacity: \"0.5\", cursor: \"default\" })) : (\"div\" === i || \"span\" === i) && (s = n.children(\".\" + this._inlineClass), s.children().addClass(\"ui-state-disabled\"), s.find(\"select.ui-datepicker-month, select.ui-datepicker-year\").prop(\"disabled\", !0)), this._disabledInputs = t.map(this._disabledInputs, function (t) {\n        return t === e ? null : t;\n      }), this._disabledInputs[this._disabledInputs.length] = e);\n    }, _isDisabledDatepicker: function _isDisabledDatepicker(t) {\n      if (!t) return !1;for (var e = 0; this._disabledInputs.length > e; e++) {\n        if (this._disabledInputs[e] === t) return !0;\n      }return !1;\n    }, _getInst: function _getInst(e) {\n      try {\n        return t.data(e, \"datepicker\");\n      } catch (i) {\n        throw \"Missing instance data for this datepicker\";\n      }\n    }, _optionDatepicker: function _optionDatepicker(e, i, s) {\n      var n,\n          o,\n          r,\n          h,\n          l = this._getInst(e);return 2 === arguments.length && \"string\" == typeof i ? \"defaults\" === i ? t.extend({}, t.datepicker._defaults) : l ? \"all\" === i ? t.extend({}, l.settings) : this._get(l, i) : null : (n = i || {}, \"string\" == typeof i && (n = {}, n[i] = s), l && (this._curInst === l && this._hideDatepicker(), o = this._getDateDatepicker(e, !0), r = this._getMinMaxDate(l, \"min\"), h = this._getMinMaxDate(l, \"max\"), a(l.settings, n), null !== r && void 0 !== n.dateFormat && void 0 === n.minDate && (l.settings.minDate = this._formatDate(l, r)), null !== h && void 0 !== n.dateFormat && void 0 === n.maxDate && (l.settings.maxDate = this._formatDate(l, h)), \"disabled\" in n && (n.disabled ? this._disableDatepicker(e) : this._enableDatepicker(e)), this._attachments(t(e), l), this._autoSize(l), this._setDate(l, o), this._updateAlternate(l), this._updateDatepicker(l)), void 0);\n    }, _changeDatepicker: function _changeDatepicker(t, e, i) {\n      this._optionDatepicker(t, e, i);\n    }, _refreshDatepicker: function _refreshDatepicker(t) {\n      var e = this._getInst(t);e && this._updateDatepicker(e);\n    }, _setDateDatepicker: function _setDateDatepicker(t, e) {\n      var i = this._getInst(t);i && (this._setDate(i, e), this._updateDatepicker(i), this._updateAlternate(i));\n    }, _getDateDatepicker: function _getDateDatepicker(t, e) {\n      var i = this._getInst(t);return i && !i.inline && this._setDateFromField(i, e), i ? this._getDate(i) : null;\n    }, _doKeyDown: function _doKeyDown(e) {\n      var i,\n          s,\n          n,\n          o = t.datepicker._getInst(e.target),\n          a = !0,\n          r = o.dpDiv.is(\".ui-datepicker-rtl\");if (o._keyEvent = !0, t.datepicker._datepickerShowing) switch (e.keyCode) {case 9:\n          t.datepicker._hideDatepicker(), a = !1;break;case 13:\n          return n = t(\"td.\" + t.datepicker._dayOverClass + \":not(.\" + t.datepicker._currentClass + \")\", o.dpDiv), n[0] && t.datepicker._selectDay(e.target, o.selectedMonth, o.selectedYear, n[0]), i = t.datepicker._get(o, \"onSelect\"), i ? (s = t.datepicker._formatDate(o), i.apply(o.input ? o.input[0] : null, [s, o])) : t.datepicker._hideDatepicker(), !1;case 27:\n          t.datepicker._hideDatepicker();break;case 33:\n          t.datepicker._adjustDate(e.target, e.ctrlKey ? -t.datepicker._get(o, \"stepBigMonths\") : -t.datepicker._get(o, \"stepMonths\"), \"M\");break;case 34:\n          t.datepicker._adjustDate(e.target, e.ctrlKey ? +t.datepicker._get(o, \"stepBigMonths\") : +t.datepicker._get(o, \"stepMonths\"), \"M\");break;case 35:\n          (e.ctrlKey || e.metaKey) && t.datepicker._clearDate(e.target), a = e.ctrlKey || e.metaKey;break;case 36:\n          (e.ctrlKey || e.metaKey) && t.datepicker._gotoToday(e.target), a = e.ctrlKey || e.metaKey;break;case 37:\n          (e.ctrlKey || e.metaKey) && t.datepicker._adjustDate(e.target, r ? 1 : -1, \"D\"), a = e.ctrlKey || e.metaKey, e.originalEvent.altKey && t.datepicker._adjustDate(e.target, e.ctrlKey ? -t.datepicker._get(o, \"stepBigMonths\") : -t.datepicker._get(o, \"stepMonths\"), \"M\");break;case 38:\n          (e.ctrlKey || e.metaKey) && t.datepicker._adjustDate(e.target, -7, \"D\"), a = e.ctrlKey || e.metaKey;break;case 39:\n          (e.ctrlKey || e.metaKey) && t.datepicker._adjustDate(e.target, r ? -1 : 1, \"D\"), a = e.ctrlKey || e.metaKey, e.originalEvent.altKey && t.datepicker._adjustDate(e.target, e.ctrlKey ? +t.datepicker._get(o, \"stepBigMonths\") : +t.datepicker._get(o, \"stepMonths\"), \"M\");break;case 40:\n          (e.ctrlKey || e.metaKey) && t.datepicker._adjustDate(e.target, 7, \"D\"), a = e.ctrlKey || e.metaKey;break;default:\n          a = !1;} else 36 === e.keyCode && e.ctrlKey ? t.datepicker._showDatepicker(this) : a = !1;a && (e.preventDefault(), e.stopPropagation());\n    }, _doKeyPress: function _doKeyPress(e) {\n      var i,\n          s,\n          n = t.datepicker._getInst(e.target);return t.datepicker._get(n, \"constrainInput\") ? (i = t.datepicker._possibleChars(t.datepicker._get(n, \"dateFormat\")), s = String.fromCharCode(null == e.charCode ? e.keyCode : e.charCode), e.ctrlKey || e.metaKey || \" \" > s || !i || i.indexOf(s) > -1) : void 0;\n    }, _doKeyUp: function _doKeyUp(e) {\n      var i,\n          s = t.datepicker._getInst(e.target);if (s.input.val() !== s.lastVal) try {\n        i = t.datepicker.parseDate(t.datepicker._get(s, \"dateFormat\"), s.input ? s.input.val() : null, t.datepicker._getFormatConfig(s)), i && (t.datepicker._setDateFromField(s), t.datepicker._updateAlternate(s), t.datepicker._updateDatepicker(s));\n      } catch (n) {}return !0;\n    }, _showDatepicker: function _showDatepicker(e) {\n      if (e = e.target || e, \"input\" !== e.nodeName.toLowerCase() && (e = t(\"input\", e.parentNode)[0]), !t.datepicker._isDisabledDatepicker(e) && t.datepicker._lastInput !== e) {\n        var s, n, o, r, h, l, c;s = t.datepicker._getInst(e), t.datepicker._curInst && t.datepicker._curInst !== s && (t.datepicker._curInst.dpDiv.stop(!0, !0), s && t.datepicker._datepickerShowing && t.datepicker._hideDatepicker(t.datepicker._curInst.input[0])), n = t.datepicker._get(s, \"beforeShow\"), o = n ? n.apply(e, [e, s]) : {}, o !== !1 && (a(s.settings, o), s.lastVal = null, t.datepicker._lastInput = e, t.datepicker._setDateFromField(s), t.datepicker._inDialog && (e.value = \"\"), t.datepicker._pos || (t.datepicker._pos = t.datepicker._findPos(e), t.datepicker._pos[1] += e.offsetHeight), r = !1, t(e).parents().each(function () {\n          return r |= \"fixed\" === t(this).css(\"position\"), !r;\n        }), h = { left: t.datepicker._pos[0], top: t.datepicker._pos[1] }, t.datepicker._pos = null, s.dpDiv.empty(), s.dpDiv.css({ position: \"absolute\", display: \"block\", top: \"-1000px\" }), t.datepicker._updateDatepicker(s), h = t.datepicker._checkOffset(s, h, r), s.dpDiv.css({ position: t.datepicker._inDialog && t.blockUI ? \"static\" : r ? \"fixed\" : \"absolute\", display: \"none\", left: h.left + \"px\", top: h.top + \"px\" }), s.inline || (l = t.datepicker._get(s, \"showAnim\"), c = t.datepicker._get(s, \"duration\"), s.dpDiv.css(\"z-index\", i(t(e)) + 1), t.datepicker._datepickerShowing = !0, t.effects && t.effects.effect[l] ? s.dpDiv.show(l, t.datepicker._get(s, \"showOptions\"), c) : s.dpDiv[l || \"show\"](l ? c : null), t.datepicker._shouldFocusInput(s) && s.input.trigger(\"focus\"), t.datepicker._curInst = s));\n      }\n    }, _updateDatepicker: function _updateDatepicker(e) {\n      this.maxRows = 4, m = e, e.dpDiv.empty().append(this._generateHTML(e)), this._attachHandlers(e);var i,\n          s = this._getNumberOfMonths(e),\n          n = s[1],\n          a = 17,\n          r = e.dpDiv.find(\".\" + this._dayOverClass + \" a\");r.length > 0 && o.apply(r.get(0)), e.dpDiv.removeClass(\"ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4\").width(\"\"), n > 1 && e.dpDiv.addClass(\"ui-datepicker-multi-\" + n).css(\"width\", a * n + \"em\"), e.dpDiv[(1 !== s[0] || 1 !== s[1] ? \"add\" : \"remove\") + \"Class\"](\"ui-datepicker-multi\"), e.dpDiv[(this._get(e, \"isRTL\") ? \"add\" : \"remove\") + \"Class\"](\"ui-datepicker-rtl\"), e === t.datepicker._curInst && t.datepicker._datepickerShowing && t.datepicker._shouldFocusInput(e) && e.input.trigger(\"focus\"), e.yearshtml && (i = e.yearshtml, setTimeout(function () {\n        i === e.yearshtml && e.yearshtml && e.dpDiv.find(\"select.ui-datepicker-year:first\").replaceWith(e.yearshtml), i = e.yearshtml = null;\n      }, 0));\n    }, _shouldFocusInput: function _shouldFocusInput(t) {\n      return t.input && t.input.is(\":visible\") && !t.input.is(\":disabled\") && !t.input.is(\":focus\");\n    }, _checkOffset: function _checkOffset(e, i, s) {\n      var n = e.dpDiv.outerWidth(),\n          o = e.dpDiv.outerHeight(),\n          a = e.input ? e.input.outerWidth() : 0,\n          r = e.input ? e.input.outerHeight() : 0,\n          h = document.documentElement.clientWidth + (s ? 0 : t(document).scrollLeft()),\n          l = document.documentElement.clientHeight + (s ? 0 : t(document).scrollTop());return i.left -= this._get(e, \"isRTL\") ? n - a : 0, i.left -= s && i.left === e.input.offset().left ? t(document).scrollLeft() : 0, i.top -= s && i.top === e.input.offset().top + r ? t(document).scrollTop() : 0, i.left -= Math.min(i.left, i.left + n > h && h > n ? Math.abs(i.left + n - h) : 0), i.top -= Math.min(i.top, i.top + o > l && l > o ? Math.abs(o + r) : 0), i;\n    }, _findPos: function _findPos(e) {\n      for (var i, s = this._getInst(e), n = this._get(s, \"isRTL\"); e && (\"hidden\" === e.type || 1 !== e.nodeType || t.expr.filters.hidden(e));) {\n        e = e[n ? \"previousSibling\" : \"nextSibling\"];\n      }return i = t(e).offset(), [i.left, i.top];\n    }, _hideDatepicker: function _hideDatepicker(e) {\n      var i,\n          s,\n          n,\n          o,\n          a = this._curInst;!a || e && a !== t.data(e, \"datepicker\") || this._datepickerShowing && (i = this._get(a, \"showAnim\"), s = this._get(a, \"duration\"), n = function n() {\n        t.datepicker._tidyDialog(a);\n      }, t.effects && (t.effects.effect[i] || t.effects[i]) ? a.dpDiv.hide(i, t.datepicker._get(a, \"showOptions\"), s, n) : a.dpDiv[\"slideDown\" === i ? \"slideUp\" : \"fadeIn\" === i ? \"fadeOut\" : \"hide\"](i ? s : null, n), i || n(), this._datepickerShowing = !1, o = this._get(a, \"onClose\"), o && o.apply(a.input ? a.input[0] : null, [a.input ? a.input.val() : \"\", a]), this._lastInput = null, this._inDialog && (this._dialogInput.css({ position: \"absolute\", left: \"0\", top: \"-100px\" }), t.blockUI && (t.unblockUI(), t(\"body\").append(this.dpDiv))), this._inDialog = !1);\n    }, _tidyDialog: function _tidyDialog(t) {\n      t.dpDiv.removeClass(this._dialogClass).off(\".ui-datepicker-calendar\");\n    }, _checkExternalClick: function _checkExternalClick(e) {\n      if (t.datepicker._curInst) {\n        var i = t(e.target),\n            s = t.datepicker._getInst(i[0]);(i[0].id !== t.datepicker._mainDivId && 0 === i.parents(\"#\" + t.datepicker._mainDivId).length && !i.hasClass(t.datepicker.markerClassName) && !i.closest(\".\" + t.datepicker._triggerClass).length && t.datepicker._datepickerShowing && (!t.datepicker._inDialog || !t.blockUI) || i.hasClass(t.datepicker.markerClassName) && t.datepicker._curInst !== s) && t.datepicker._hideDatepicker();\n      }\n    }, _adjustDate: function _adjustDate(e, i, s) {\n      var n = t(e),\n          o = this._getInst(n[0]);this._isDisabledDatepicker(n[0]) || (this._adjustInstDate(o, i + (\"M\" === s ? this._get(o, \"showCurrentAtPos\") : 0), s), this._updateDatepicker(o));\n    }, _gotoToday: function _gotoToday(e) {\n      var i,\n          s = t(e),\n          n = this._getInst(s[0]);this._get(n, \"gotoCurrent\") && n.currentDay ? (n.selectedDay = n.currentDay, n.drawMonth = n.selectedMonth = n.currentMonth, n.drawYear = n.selectedYear = n.currentYear) : (i = new Date(), n.selectedDay = i.getDate(), n.drawMonth = n.selectedMonth = i.getMonth(), n.drawYear = n.selectedYear = i.getFullYear()), this._notifyChange(n), this._adjustDate(s);\n    }, _selectMonthYear: function _selectMonthYear(e, i, s) {\n      var n = t(e),\n          o = this._getInst(n[0]);o[\"selected\" + (\"M\" === s ? \"Month\" : \"Year\")] = o[\"draw\" + (\"M\" === s ? \"Month\" : \"Year\")] = parseInt(i.options[i.selectedIndex].value, 10), this._notifyChange(o), this._adjustDate(n);\n    }, _selectDay: function _selectDay(e, i, s, n) {\n      var o,\n          a = t(e);t(n).hasClass(this._unselectableClass) || this._isDisabledDatepicker(a[0]) || (o = this._getInst(a[0]), o.selectedDay = o.currentDay = t(\"a\", n).html(), o.selectedMonth = o.currentMonth = i, o.selectedYear = o.currentYear = s, this._selectDate(e, this._formatDate(o, o.currentDay, o.currentMonth, o.currentYear)));\n    }, _clearDate: function _clearDate(e) {\n      var i = t(e);this._selectDate(i, \"\");\n    }, _selectDate: function _selectDate(e, i) {\n      var s,\n          n = t(e),\n          o = this._getInst(n[0]);i = null != i ? i : this._formatDate(o), o.input && o.input.val(i), this._updateAlternate(o), s = this._get(o, \"onSelect\"), s ? s.apply(o.input ? o.input[0] : null, [i, o]) : o.input && o.input.trigger(\"change\"), o.inline ? this._updateDatepicker(o) : (this._hideDatepicker(), this._lastInput = o.input[0], \"object\" != _typeof(o.input[0]) && o.input.trigger(\"focus\"), this._lastInput = null);\n    }, _updateAlternate: function _updateAlternate(e) {\n      var i,\n          s,\n          n,\n          o = this._get(e, \"altField\");o && (i = this._get(e, \"altFormat\") || this._get(e, \"dateFormat\"), s = this._getDate(e), n = this.formatDate(i, s, this._getFormatConfig(e)), t(o).val(n));\n    }, noWeekends: function noWeekends(t) {\n      var e = t.getDay();return [e > 0 && 6 > e, \"\"];\n    }, iso8601Week: function iso8601Week(t) {\n      var e,\n          i = new Date(t.getTime());return i.setDate(i.getDate() + 4 - (i.getDay() || 7)), e = i.getTime(), i.setMonth(0), i.setDate(1), Math.floor(Math.round((e - i) / 864e5) / 7) + 1;\n    }, parseDate: function parseDate(e, i, s) {\n      if (null == e || null == i) throw \"Invalid arguments\";if (i = \"object\" == (typeof i === \"undefined\" ? \"undefined\" : _typeof(i)) ? \"\" + i : i + \"\", \"\" === i) return null;var n,\n          o,\n          a,\n          r,\n          h = 0,\n          l = (s ? s.shortYearCutoff : null) || this._defaults.shortYearCutoff,\n          c = \"string\" != typeof l ? l : new Date().getFullYear() % 100 + parseInt(l, 10),\n          u = (s ? s.dayNamesShort : null) || this._defaults.dayNamesShort,\n          d = (s ? s.dayNames : null) || this._defaults.dayNames,\n          p = (s ? s.monthNamesShort : null) || this._defaults.monthNamesShort,\n          f = (s ? s.monthNames : null) || this._defaults.monthNames,\n          g = -1,\n          m = -1,\n          _ = -1,\n          v = -1,\n          b = !1,\n          y = function y(t) {\n        var i = e.length > n + 1 && e.charAt(n + 1) === t;return i && n++, i;\n      },\n          w = function w(t) {\n        var e = y(t),\n            s = \"@\" === t ? 14 : \"!\" === t ? 20 : \"y\" === t && e ? 4 : \"o\" === t ? 3 : 2,\n            n = \"y\" === t ? s : 1,\n            o = RegExp(\"^\\\\d{\" + n + \",\" + s + \"}\"),\n            a = i.substring(h).match(o);if (!a) throw \"Missing number at position \" + h;return h += a[0].length, parseInt(a[0], 10);\n      },\n          k = function k(e, s, n) {\n        var o = -1,\n            a = t.map(y(e) ? n : s, function (t, e) {\n          return [[e, t]];\n        }).sort(function (t, e) {\n          return -(t[1].length - e[1].length);\n        });if (t.each(a, function (t, e) {\n          var s = e[1];return i.substr(h, s.length).toLowerCase() === s.toLowerCase() ? (o = e[0], h += s.length, !1) : void 0;\n        }), -1 !== o) return o + 1;throw \"Unknown name at position \" + h;\n      },\n          x = function x() {\n        if (i.charAt(h) !== e.charAt(n)) throw \"Unexpected literal at position \" + h;h++;\n      };for (n = 0; e.length > n; n++) {\n        if (b) \"'\" !== e.charAt(n) || y(\"'\") ? x() : b = !1;else switch (e.charAt(n)) {case \"d\":\n            _ = w(\"d\");break;case \"D\":\n            k(\"D\", u, d);break;case \"o\":\n            v = w(\"o\");break;case \"m\":\n            m = w(\"m\");break;case \"M\":\n            m = k(\"M\", p, f);break;case \"y\":\n            g = w(\"y\");break;case \"@\":\n            r = new Date(w(\"@\")), g = r.getFullYear(), m = r.getMonth() + 1, _ = r.getDate();break;case \"!\":\n            r = new Date((w(\"!\") - this._ticksTo1970) / 1e4), g = r.getFullYear(), m = r.getMonth() + 1, _ = r.getDate();break;case \"'\":\n            y(\"'\") ? x() : b = !0;break;default:\n            x();}\n      }if (i.length > h && (a = i.substr(h), !/^\\s+/.test(a))) throw \"Extra/unparsed characters found in date: \" + a;if (-1 === g ? g = new Date().getFullYear() : 100 > g && (g += new Date().getFullYear() - new Date().getFullYear() % 100 + (c >= g ? 0 : -100)), v > -1) for (m = 1, _ = v;;) {\n        if (o = this._getDaysInMonth(g, m - 1), o >= _) break;m++, _ -= o;\n      }if (r = this._daylightSavingAdjust(new Date(g, m - 1, _)), r.getFullYear() !== g || r.getMonth() + 1 !== m || r.getDate() !== _) throw \"Invalid date\";return r;\n    }, ATOM: \"yy-mm-dd\", COOKIE: \"D, dd M yy\", ISO_8601: \"yy-mm-dd\", RFC_822: \"D, d M y\", RFC_850: \"DD, dd-M-y\", RFC_1036: \"D, d M y\", RFC_1123: \"D, d M yy\", RFC_2822: \"D, d M yy\", RSS: \"D, d M y\", TICKS: \"!\", TIMESTAMP: \"@\", W3C: \"yy-mm-dd\", _ticksTo1970: 1e7 * 60 * 60 * 24 * (718685 + Math.floor(492.5) - Math.floor(19.7) + Math.floor(4.925)), formatDate: function formatDate(t, e, i) {\n      if (!e) return \"\";var s,\n          n = (i ? i.dayNamesShort : null) || this._defaults.dayNamesShort,\n          o = (i ? i.dayNames : null) || this._defaults.dayNames,\n          a = (i ? i.monthNamesShort : null) || this._defaults.monthNamesShort,\n          r = (i ? i.monthNames : null) || this._defaults.monthNames,\n          h = function h(e) {\n        var i = t.length > s + 1 && t.charAt(s + 1) === e;return i && s++, i;\n      },\n          l = function l(t, e, i) {\n        var s = \"\" + e;if (h(t)) for (; i > s.length;) {\n          s = \"0\" + s;\n        }return s;\n      },\n          c = function c(t, e, i, s) {\n        return h(t) ? s[e] : i[e];\n      },\n          u = \"\",\n          d = !1;if (e) for (s = 0; t.length > s; s++) {\n        if (d) \"'\" !== t.charAt(s) || h(\"'\") ? u += t.charAt(s) : d = !1;else switch (t.charAt(s)) {case \"d\":\n            u += l(\"d\", e.getDate(), 2);break;case \"D\":\n            u += c(\"D\", e.getDay(), n, o);break;case \"o\":\n            u += l(\"o\", Math.round((new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime() - new Date(e.getFullYear(), 0, 0).getTime()) / 864e5), 3);break;case \"m\":\n            u += l(\"m\", e.getMonth() + 1, 2);break;case \"M\":\n            u += c(\"M\", e.getMonth(), a, r);break;case \"y\":\n            u += h(\"y\") ? e.getFullYear() : (10 > e.getFullYear() % 100 ? \"0\" : \"\") + e.getFullYear() % 100;break;case \"@\":\n            u += e.getTime();break;case \"!\":\n            u += 1e4 * e.getTime() + this._ticksTo1970;break;case \"'\":\n            h(\"'\") ? u += \"'\" : d = !0;break;default:\n            u += t.charAt(s);}\n      }return u;\n    }, _possibleChars: function _possibleChars(t) {\n      var e,\n          i = \"\",\n          s = !1,\n          n = function n(i) {\n        var s = t.length > e + 1 && t.charAt(e + 1) === i;return s && e++, s;\n      };for (e = 0; t.length > e; e++) {\n        if (s) \"'\" !== t.charAt(e) || n(\"'\") ? i += t.charAt(e) : s = !1;else switch (t.charAt(e)) {case \"d\":case \"m\":case \"y\":case \"@\":\n            i += \"0123456789\";break;case \"D\":case \"M\":\n            return null;case \"'\":\n            n(\"'\") ? i += \"'\" : s = !0;break;default:\n            i += t.charAt(e);}\n      }return i;\n    }, _get: function _get(t, e) {\n      return void 0 !== t.settings[e] ? t.settings[e] : this._defaults[e];\n    }, _setDateFromField: function _setDateFromField(t, e) {\n      if (t.input.val() !== t.lastVal) {\n        var i = this._get(t, \"dateFormat\"),\n            s = t.lastVal = t.input ? t.input.val() : null,\n            n = this._getDefaultDate(t),\n            o = n,\n            a = this._getFormatConfig(t);try {\n          o = this.parseDate(i, s, a) || n;\n        } catch (r) {\n          s = e ? \"\" : s;\n        }t.selectedDay = o.getDate(), t.drawMonth = t.selectedMonth = o.getMonth(), t.drawYear = t.selectedYear = o.getFullYear(), t.currentDay = s ? o.getDate() : 0, t.currentMonth = s ? o.getMonth() : 0, t.currentYear = s ? o.getFullYear() : 0, this._adjustInstDate(t);\n      }\n    }, _getDefaultDate: function _getDefaultDate(t) {\n      return this._restrictMinMax(t, this._determineDate(t, this._get(t, \"defaultDate\"), new Date()));\n    }, _determineDate: function _determineDate(e, i, s) {\n      var n = function n(t) {\n        var e = new Date();return e.setDate(e.getDate() + t), e;\n      },\n          o = function o(i) {\n        try {\n          return t.datepicker.parseDate(t.datepicker._get(e, \"dateFormat\"), i, t.datepicker._getFormatConfig(e));\n        } catch (s) {}for (var n = (i.toLowerCase().match(/^c/) ? t.datepicker._getDate(e) : null) || new Date(), o = n.getFullYear(), a = n.getMonth(), r = n.getDate(), h = /([+\\-]?[0-9]+)\\s*(d|D|w|W|m|M|y|Y)?/g, l = h.exec(i); l;) {\n          switch (l[2] || \"d\") {case \"d\":case \"D\":\n              r += parseInt(l[1], 10);break;case \"w\":case \"W\":\n              r += 7 * parseInt(l[1], 10);break;case \"m\":case \"M\":\n              a += parseInt(l[1], 10), r = Math.min(r, t.datepicker._getDaysInMonth(o, a));break;case \"y\":case \"Y\":\n              o += parseInt(l[1], 10), r = Math.min(r, t.datepicker._getDaysInMonth(o, a));}l = h.exec(i);\n        }return new Date(o, a, r);\n      },\n          a = null == i || \"\" === i ? s : \"string\" == typeof i ? o(i) : \"number\" == typeof i ? isNaN(i) ? s : n(i) : new Date(i.getTime());return a = a && \"Invalid Date\" == \"\" + a ? s : a, a && (a.setHours(0), a.setMinutes(0), a.setSeconds(0), a.setMilliseconds(0)), this._daylightSavingAdjust(a);\n    }, _daylightSavingAdjust: function _daylightSavingAdjust(t) {\n      return t ? (t.setHours(t.getHours() > 12 ? t.getHours() + 2 : 0), t) : null;\n    }, _setDate: function _setDate(t, e, i) {\n      var s = !e,\n          n = t.selectedMonth,\n          o = t.selectedYear,\n          a = this._restrictMinMax(t, this._determineDate(t, e, new Date()));t.selectedDay = t.currentDay = a.getDate(), t.drawMonth = t.selectedMonth = t.currentMonth = a.getMonth(), t.drawYear = t.selectedYear = t.currentYear = a.getFullYear(), n === t.selectedMonth && o === t.selectedYear || i || this._notifyChange(t), this._adjustInstDate(t), t.input && t.input.val(s ? \"\" : this._formatDate(t));\n    }, _getDate: function _getDate(t) {\n      var e = !t.currentYear || t.input && \"\" === t.input.val() ? null : this._daylightSavingAdjust(new Date(t.currentYear, t.currentMonth, t.currentDay));return e;\n    }, _attachHandlers: function _attachHandlers(e) {\n      var i = this._get(e, \"stepMonths\"),\n          s = \"#\" + e.id.replace(/\\\\\\\\/g, \"\\\\\");e.dpDiv.find(\"[data-handler]\").map(function () {\n        var e = { prev: function prev() {\n            t.datepicker._adjustDate(s, -i, \"M\");\n          }, next: function next() {\n            t.datepicker._adjustDate(s, +i, \"M\");\n          }, hide: function hide() {\n            t.datepicker._hideDatepicker();\n          }, today: function today() {\n            t.datepicker._gotoToday(s);\n          }, selectDay: function selectDay() {\n            return t.datepicker._selectDay(s, +this.getAttribute(\"data-month\"), +this.getAttribute(\"data-year\"), this), !1;\n          }, selectMonth: function selectMonth() {\n            return t.datepicker._selectMonthYear(s, this, \"M\"), !1;\n          }, selectYear: function selectYear() {\n            return t.datepicker._selectMonthYear(s, this, \"Y\"), !1;\n          } };t(this).on(this.getAttribute(\"data-event\"), e[this.getAttribute(\"data-handler\")]);\n      });\n    }, _generateHTML: function _generateHTML(t) {\n      var e,\n          i,\n          s,\n          n,\n          o,\n          a,\n          r,\n          h,\n          l,\n          c,\n          u,\n          d,\n          p,\n          f,\n          g,\n          m,\n          _,\n          v,\n          b,\n          y,\n          w,\n          k,\n          x,\n          C,\n          D,\n          I,\n          T,\n          P,\n          M,\n          S,\n          H,\n          z,\n          O,\n          A,\n          N,\n          W,\n          E,\n          F,\n          L,\n          R = new Date(),\n          B = this._daylightSavingAdjust(new Date(R.getFullYear(), R.getMonth(), R.getDate())),\n          Y = this._get(t, \"isRTL\"),\n          j = this._get(t, \"showButtonPanel\"),\n          q = this._get(t, \"hideIfNoPrevNext\"),\n          K = this._get(t, \"navigationAsDateFormat\"),\n          U = this._getNumberOfMonths(t),\n          V = this._get(t, \"showCurrentAtPos\"),\n          $ = this._get(t, \"stepMonths\"),\n          X = 1 !== U[0] || 1 !== U[1],\n          G = this._daylightSavingAdjust(t.currentDay ? new Date(t.currentYear, t.currentMonth, t.currentDay) : new Date(9999, 9, 9)),\n          Q = this._getMinMaxDate(t, \"min\"),\n          J = this._getMinMaxDate(t, \"max\"),\n          Z = t.drawMonth - V,\n          te = t.drawYear;if (0 > Z && (Z += 12, te--), J) for (e = this._daylightSavingAdjust(new Date(J.getFullYear(), J.getMonth() - U[0] * U[1] + 1, J.getDate())), e = Q && Q > e ? Q : e; this._daylightSavingAdjust(new Date(te, Z, 1)) > e;) {\n        Z--, 0 > Z && (Z = 11, te--);\n      }for (t.drawMonth = Z, t.drawYear = te, i = this._get(t, \"prevText\"), i = K ? this.formatDate(i, this._daylightSavingAdjust(new Date(te, Z - $, 1)), this._getFormatConfig(t)) : i, s = this._canAdjustMonth(t, -1, te, Z) ? \"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='\" + i + \"'><span class='ui-icon ui-icon-circle-triangle-\" + (Y ? \"e\" : \"w\") + \"'>\" + i + \"</span></a>\" : q ? \"\" : \"<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='\" + i + \"'><span class='ui-icon ui-icon-circle-triangle-\" + (Y ? \"e\" : \"w\") + \"'>\" + i + \"</span></a>\", n = this._get(t, \"nextText\"), n = K ? this.formatDate(n, this._daylightSavingAdjust(new Date(te, Z + $, 1)), this._getFormatConfig(t)) : n, o = this._canAdjustMonth(t, 1, te, Z) ? \"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='\" + n + \"'><span class='ui-icon ui-icon-circle-triangle-\" + (Y ? \"w\" : \"e\") + \"'>\" + n + \"</span></a>\" : q ? \"\" : \"<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='\" + n + \"'><span class='ui-icon ui-icon-circle-triangle-\" + (Y ? \"w\" : \"e\") + \"'>\" + n + \"</span></a>\", a = this._get(t, \"currentText\"), r = this._get(t, \"gotoCurrent\") && t.currentDay ? G : B, a = K ? this.formatDate(a, r, this._getFormatConfig(t)) : a, h = t.inline ? \"\" : \"<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>\" + this._get(t, \"closeText\") + \"</button>\", l = j ? \"<div class='ui-datepicker-buttonpane ui-widget-content'>\" + (Y ? h : \"\") + (this._isInRange(t, r) ? \"<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>\" + a + \"</button>\" : \"\") + (Y ? \"\" : h) + \"</div>\" : \"\", c = parseInt(this._get(t, \"firstDay\"), 10), c = isNaN(c) ? 0 : c, u = this._get(t, \"showWeek\"), d = this._get(t, \"dayNames\"), p = this._get(t, \"dayNamesMin\"), f = this._get(t, \"monthNames\"), g = this._get(t, \"monthNamesShort\"), m = this._get(t, \"beforeShowDay\"), _ = this._get(t, \"showOtherMonths\"), v = this._get(t, \"selectOtherMonths\"), b = this._getDefaultDate(t), y = \"\", k = 0; U[0] > k; k++) {\n        for (x = \"\", this.maxRows = 4, C = 0; U[1] > C; C++) {\n          if (D = this._daylightSavingAdjust(new Date(te, Z, t.selectedDay)), I = \" ui-corner-all\", T = \"\", X) {\n            if (T += \"<div class='ui-datepicker-group\", U[1] > 1) switch (C) {case 0:\n                T += \" ui-datepicker-group-first\", I = \" ui-corner-\" + (Y ? \"right\" : \"left\");break;case U[1] - 1:\n                T += \" ui-datepicker-group-last\", I = \" ui-corner-\" + (Y ? \"left\" : \"right\");break;default:\n                T += \" ui-datepicker-group-middle\", I = \"\";}T += \"'>\";\n          }for (T += \"<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix\" + I + \"'>\" + (/all|left/.test(I) && 0 === k ? Y ? o : s : \"\") + (/all|right/.test(I) && 0 === k ? Y ? s : o : \"\") + this._generateMonthYearHeader(t, Z, te, Q, J, k > 0 || C > 0, f, g) + \"</div><table class='ui-datepicker-calendar'><thead>\" + \"<tr>\", P = u ? \"<th class='ui-datepicker-week-col'>\" + this._get(t, \"weekHeader\") + \"</th>\" : \"\", w = 0; 7 > w; w++) {\n            M = (w + c) % 7, P += \"<th scope='col'\" + ((w + c + 6) % 7 >= 5 ? \" class='ui-datepicker-week-end'\" : \"\") + \">\" + \"<span title='\" + d[M] + \"'>\" + p[M] + \"</span></th>\";\n          }for (T += P + \"</tr></thead><tbody>\", S = this._getDaysInMonth(te, Z), te === t.selectedYear && Z === t.selectedMonth && (t.selectedDay = Math.min(t.selectedDay, S)), H = (this._getFirstDayOfMonth(te, Z) - c + 7) % 7, z = Math.ceil((H + S) / 7), O = X ? this.maxRows > z ? this.maxRows : z : z, this.maxRows = O, A = this._daylightSavingAdjust(new Date(te, Z, 1 - H)), N = 0; O > N; N++) {\n            for (T += \"<tr>\", W = u ? \"<td class='ui-datepicker-week-col'>\" + this._get(t, \"calculateWeek\")(A) + \"</td>\" : \"\", w = 0; 7 > w; w++) {\n              E = m ? m.apply(t.input ? t.input[0] : null, [A]) : [!0, \"\"], F = A.getMonth() !== Z, L = F && !v || !E[0] || Q && Q > A || J && A > J, W += \"<td class='\" + ((w + c + 6) % 7 >= 5 ? \" ui-datepicker-week-end\" : \"\") + (F ? \" ui-datepicker-other-month\" : \"\") + (A.getTime() === D.getTime() && Z === t.selectedMonth && t._keyEvent || b.getTime() === A.getTime() && b.getTime() === D.getTime() ? \" \" + this._dayOverClass : \"\") + (L ? \" \" + this._unselectableClass + \" ui-state-disabled\" : \"\") + (F && !_ ? \"\" : \" \" + E[1] + (A.getTime() === G.getTime() ? \" \" + this._currentClass : \"\") + (A.getTime() === B.getTime() ? \" ui-datepicker-today\" : \"\")) + \"'\" + (F && !_ || !E[2] ? \"\" : \" title='\" + E[2].replace(/'/g, \"&#39;\") + \"'\") + (L ? \"\" : \" data-handler='selectDay' data-event='click' data-month='\" + A.getMonth() + \"' data-year='\" + A.getFullYear() + \"'\") + \">\" + (F && !_ ? \"&#xa0;\" : L ? \"<span class='ui-state-default'>\" + A.getDate() + \"</span>\" : \"<a class='ui-state-default\" + (A.getTime() === B.getTime() ? \" ui-state-highlight\" : \"\") + (A.getTime() === G.getTime() ? \" ui-state-active\" : \"\") + (F ? \" ui-priority-secondary\" : \"\") + \"' href='#'>\" + A.getDate() + \"</a>\") + \"</td>\", A.setDate(A.getDate() + 1), A = this._daylightSavingAdjust(A);\n            }T += W + \"</tr>\";\n          }Z++, Z > 11 && (Z = 0, te++), T += \"</tbody></table>\" + (X ? \"</div>\" + (U[0] > 0 && C === U[1] - 1 ? \"<div class='ui-datepicker-row-break'></div>\" : \"\") : \"\"), x += T;\n        }y += x;\n      }return y += l, t._keyEvent = !1, y;\n    }, _generateMonthYearHeader: function _generateMonthYearHeader(t, e, i, s, n, o, a, r) {\n      var h,\n          l,\n          c,\n          u,\n          d,\n          p,\n          f,\n          g,\n          m = this._get(t, \"changeMonth\"),\n          _ = this._get(t, \"changeYear\"),\n          v = this._get(t, \"showMonthAfterYear\"),\n          b = \"<div class='ui-datepicker-title'>\",\n          y = \"\";if (o || !m) y += \"<span class='ui-datepicker-month'>\" + a[e] + \"</span>\";else {\n        for (h = s && s.getFullYear() === i, l = n && n.getFullYear() === i, y += \"<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>\", c = 0; 12 > c; c++) {\n          (!h || c >= s.getMonth()) && (!l || n.getMonth() >= c) && (y += \"<option value='\" + c + \"'\" + (c === e ? \" selected='selected'\" : \"\") + \">\" + r[c] + \"</option>\");\n        }y += \"</select>\";\n      }if (v || (b += y + (!o && m && _ ? \"\" : \"&#xa0;\")), !t.yearshtml) if (t.yearshtml = \"\", o || !_) b += \"<span class='ui-datepicker-year'>\" + i + \"</span>\";else {\n        for (u = this._get(t, \"yearRange\").split(\":\"), d = new Date().getFullYear(), p = function p(t) {\n          var e = t.match(/c[+\\-].*/) ? i + parseInt(t.substring(1), 10) : t.match(/[+\\-].*/) ? d + parseInt(t, 10) : parseInt(t, 10);return isNaN(e) ? d : e;\n        }, f = p(u[0]), g = Math.max(f, p(u[1] || \"\")), f = s ? Math.max(f, s.getFullYear()) : f, g = n ? Math.min(g, n.getFullYear()) : g, t.yearshtml += \"<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>\"; g >= f; f++) {\n          t.yearshtml += \"<option value='\" + f + \"'\" + (f === i ? \" selected='selected'\" : \"\") + \">\" + f + \"</option>\";\n        }t.yearshtml += \"</select>\", b += t.yearshtml, t.yearshtml = null;\n      }return b += this._get(t, \"yearSuffix\"), v && (b += (!o && m && _ ? \"\" : \"&#xa0;\") + y), b += \"</div>\";\n    }, _adjustInstDate: function _adjustInstDate(t, e, i) {\n      var s = t.selectedYear + (\"Y\" === i ? e : 0),\n          n = t.selectedMonth + (\"M\" === i ? e : 0),\n          o = Math.min(t.selectedDay, this._getDaysInMonth(s, n)) + (\"D\" === i ? e : 0),\n          a = this._restrictMinMax(t, this._daylightSavingAdjust(new Date(s, n, o)));t.selectedDay = a.getDate(), t.drawMonth = t.selectedMonth = a.getMonth(), t.drawYear = t.selectedYear = a.getFullYear(), (\"M\" === i || \"Y\" === i) && this._notifyChange(t);\n    }, _restrictMinMax: function _restrictMinMax(t, e) {\n      var i = this._getMinMaxDate(t, \"min\"),\n          s = this._getMinMaxDate(t, \"max\"),\n          n = i && i > e ? i : e;return s && n > s ? s : n;\n    }, _notifyChange: function _notifyChange(t) {\n      var e = this._get(t, \"onChangeMonthYear\");e && e.apply(t.input ? t.input[0] : null, [t.selectedYear, t.selectedMonth + 1, t]);\n    }, _getNumberOfMonths: function _getNumberOfMonths(t) {\n      var e = this._get(t, \"numberOfMonths\");return null == e ? [1, 1] : \"number\" == typeof e ? [1, e] : e;\n    }, _getMinMaxDate: function _getMinMaxDate(t, e) {\n      return this._determineDate(t, this._get(t, e + \"Date\"), null);\n    }, _getDaysInMonth: function _getDaysInMonth(t, e) {\n      return 32 - this._daylightSavingAdjust(new Date(t, e, 32)).getDate();\n    }, _getFirstDayOfMonth: function _getFirstDayOfMonth(t, e) {\n      return new Date(t, e, 1).getDay();\n    }, _canAdjustMonth: function _canAdjustMonth(t, e, i, s) {\n      var n = this._getNumberOfMonths(t),\n          o = this._daylightSavingAdjust(new Date(i, s + (0 > e ? e : n[0] * n[1]), 1));return 0 > e && o.setDate(this._getDaysInMonth(o.getFullYear(), o.getMonth())), this._isInRange(t, o);\n    }, _isInRange: function _isInRange(t, e) {\n      var i,\n          s,\n          n = this._getMinMaxDate(t, \"min\"),\n          o = this._getMinMaxDate(t, \"max\"),\n          a = null,\n          r = null,\n          h = this._get(t, \"yearRange\");return h && (i = h.split(\":\"), s = new Date().getFullYear(), a = parseInt(i[0], 10), r = parseInt(i[1], 10), i[0].match(/[+\\-].*/) && (a += s), i[1].match(/[+\\-].*/) && (r += s)), (!n || e.getTime() >= n.getTime()) && (!o || e.getTime() <= o.getTime()) && (!a || e.getFullYear() >= a) && (!r || r >= e.getFullYear());\n    }, _getFormatConfig: function _getFormatConfig(t) {\n      var e = this._get(t, \"shortYearCutoff\");return e = \"string\" != typeof e ? e : new Date().getFullYear() % 100 + parseInt(e, 10), { shortYearCutoff: e, dayNamesShort: this._get(t, \"dayNamesShort\"), dayNames: this._get(t, \"dayNames\"), monthNamesShort: this._get(t, \"monthNamesShort\"), monthNames: this._get(t, \"monthNames\") };\n    }, _formatDate: function _formatDate(t, e, i, s) {\n      e || (t.currentDay = t.selectedDay, t.currentMonth = t.selectedMonth, t.currentYear = t.selectedYear);var n = e ? \"object\" == (typeof e === \"undefined\" ? \"undefined\" : _typeof(e)) ? e : this._daylightSavingAdjust(new Date(s, i, e)) : this._daylightSavingAdjust(new Date(t.currentYear, t.currentMonth, t.currentDay));return this.formatDate(this._get(t, \"dateFormat\"), n, this._getFormatConfig(t));\n    } }), t.fn.datepicker = function (e) {\n    if (!this.length) return this;t.datepicker.initialized || (t(document).on(\"mousedown\", t.datepicker._checkExternalClick), t.datepicker.initialized = !0), 0 === t(\"#\" + t.datepicker._mainDivId).length && t(\"body\").append(t.datepicker.dpDiv);var i = Array.prototype.slice.call(arguments, 1);return \"string\" != typeof e || \"isDisabled\" !== e && \"getDate\" !== e && \"widget\" !== e ? \"option\" === e && 2 === arguments.length && \"string\" == typeof arguments[1] ? t.datepicker[\"_\" + e + \"Datepicker\"].apply(t.datepicker, [this[0]].concat(i)) : this.each(function () {\n      \"string\" == typeof e ? t.datepicker[\"_\" + e + \"Datepicker\"].apply(t.datepicker, [this].concat(i)) : t.datepicker._attachDatepicker(this, e);\n    }) : t.datepicker[\"_\" + e + \"Datepicker\"].apply(t.datepicker, [this[0]].concat(i));\n  }, t.datepicker = new s(), t.datepicker.initialized = !1, t.datepicker.uuid = new Date().getTime(), t.datepicker.version = \"1.12.1\", t.datepicker, t.ui.ie = !!/msie [\\w.]+/.exec(navigator.userAgent.toLowerCase());var _ = !1;t(document).on(\"mouseup\", function () {\n    _ = !1;\n  }), t.widget(\"ui.mouse\", { version: \"1.12.1\", options: { cancel: \"input, textarea, button, select, option\", distance: 1, delay: 0 }, _mouseInit: function _mouseInit() {\n      var e = this;this.element.on(\"mousedown.\" + this.widgetName, function (t) {\n        return e._mouseDown(t);\n      }).on(\"click.\" + this.widgetName, function (i) {\n        return !0 === t.data(i.target, e.widgetName + \".preventClickEvent\") ? (t.removeData(i.target, e.widgetName + \".preventClickEvent\"), i.stopImmediatePropagation(), !1) : void 0;\n      }), this.started = !1;\n    }, _mouseDestroy: function _mouseDestroy() {\n      this.element.off(\".\" + this.widgetName), this._mouseMoveDelegate && this.document.off(\"mousemove.\" + this.widgetName, this._mouseMoveDelegate).off(\"mouseup.\" + this.widgetName, this._mouseUpDelegate);\n    }, _mouseDown: function _mouseDown(e) {\n      if (!_) {\n        this._mouseMoved = !1, this._mouseStarted && this._mouseUp(e), this._mouseDownEvent = e;var i = this,\n            s = 1 === e.which,\n            n = \"string\" == typeof this.options.cancel && e.target.nodeName ? t(e.target).closest(this.options.cancel).length : !1;return s && !n && this._mouseCapture(e) ? (this.mouseDelayMet = !this.options.delay, this.mouseDelayMet || (this._mouseDelayTimer = setTimeout(function () {\n          i.mouseDelayMet = !0;\n        }, this.options.delay)), this._mouseDistanceMet(e) && this._mouseDelayMet(e) && (this._mouseStarted = this._mouseStart(e) !== !1, !this._mouseStarted) ? (e.preventDefault(), !0) : (!0 === t.data(e.target, this.widgetName + \".preventClickEvent\") && t.removeData(e.target, this.widgetName + \".preventClickEvent\"), this._mouseMoveDelegate = function (t) {\n          return i._mouseMove(t);\n        }, this._mouseUpDelegate = function (t) {\n          return i._mouseUp(t);\n        }, this.document.on(\"mousemove.\" + this.widgetName, this._mouseMoveDelegate).on(\"mouseup.\" + this.widgetName, this._mouseUpDelegate), e.preventDefault(), _ = !0, !0)) : !0;\n      }\n    }, _mouseMove: function _mouseMove(e) {\n      if (this._mouseMoved) {\n        if (t.ui.ie && (!document.documentMode || 9 > document.documentMode) && !e.button) return this._mouseUp(e);if (!e.which) if (e.originalEvent.altKey || e.originalEvent.ctrlKey || e.originalEvent.metaKey || e.originalEvent.shiftKey) this.ignoreMissingWhich = !0;else if (!this.ignoreMissingWhich) return this._mouseUp(e);\n      }return (e.which || e.button) && (this._mouseMoved = !0), this._mouseStarted ? (this._mouseDrag(e), e.preventDefault()) : (this._mouseDistanceMet(e) && this._mouseDelayMet(e) && (this._mouseStarted = this._mouseStart(this._mouseDownEvent, e) !== !1, this._mouseStarted ? this._mouseDrag(e) : this._mouseUp(e)), !this._mouseStarted);\n    }, _mouseUp: function _mouseUp(e) {\n      this.document.off(\"mousemove.\" + this.widgetName, this._mouseMoveDelegate).off(\"mouseup.\" + this.widgetName, this._mouseUpDelegate), this._mouseStarted && (this._mouseStarted = !1, e.target === this._mouseDownEvent.target && t.data(e.target, this.widgetName + \".preventClickEvent\", !0), this._mouseStop(e)), this._mouseDelayTimer && (clearTimeout(this._mouseDelayTimer), delete this._mouseDelayTimer), this.ignoreMissingWhich = !1, _ = !1, e.preventDefault();\n    }, _mouseDistanceMet: function _mouseDistanceMet(t) {\n      return Math.max(Math.abs(this._mouseDownEvent.pageX - t.pageX), Math.abs(this._mouseDownEvent.pageY - t.pageY)) >= this.options.distance;\n    }, _mouseDelayMet: function _mouseDelayMet() {\n      return this.mouseDelayMet;\n    }, _mouseStart: function _mouseStart() {}, _mouseDrag: function _mouseDrag() {}, _mouseStop: function _mouseStop() {}, _mouseCapture: function _mouseCapture() {\n      return !0;\n    } }), t.ui.plugin = { add: function add(e, i, s) {\n      var n,\n          o = t.ui[e].prototype;for (n in s) {\n        o.plugins[n] = o.plugins[n] || [], o.plugins[n].push([i, s[n]]);\n      }\n    }, call: function call(t, e, i, s) {\n      var n,\n          o = t.plugins[e];if (o && (s || t.element[0].parentNode && 11 !== t.element[0].parentNode.nodeType)) for (n = 0; o.length > n; n++) {\n        t.options[o[n][0]] && o[n][1].apply(t.element, i);\n      }\n    } }, t.ui.safeBlur = function (e) {\n    e && \"body\" !== e.nodeName.toLowerCase() && t(e).trigger(\"blur\");\n  }, t.widget(\"ui.draggable\", t.ui.mouse, { version: \"1.12.1\", widgetEventPrefix: \"drag\", options: { addClasses: !0, appendTo: \"parent\", axis: !1, connectToSortable: !1, containment: !1, cursor: \"auto\", cursorAt: !1, grid: !1, handle: !1, helper: \"original\", iframeFix: !1, opacity: !1, refreshPositions: !1, revert: !1, revertDuration: 500, scope: \"default\", scroll: !0, scrollSensitivity: 20, scrollSpeed: 20, snap: !1, snapMode: \"both\", snapTolerance: 20, stack: !1, zIndex: !1, drag: null, start: null, stop: null }, _create: function _create() {\n      \"original\" === this.options.helper && this._setPositionRelative(), this.options.addClasses && this._addClass(\"ui-draggable\"), this._setHandleClassName(), this._mouseInit();\n    }, _setOption: function _setOption(t, e) {\n      this._super(t, e), \"handle\" === t && (this._removeHandleClassName(), this._setHandleClassName());\n    }, _destroy: function _destroy() {\n      return (this.helper || this.element).is(\".ui-draggable-dragging\") ? (this.destroyOnClear = !0, void 0) : (this._removeHandleClassName(), this._mouseDestroy(), void 0);\n    }, _mouseCapture: function _mouseCapture(e) {\n      var i = this.options;return this.helper || i.disabled || t(e.target).closest(\".ui-resizable-handle\").length > 0 ? !1 : (this.handle = this._getHandle(e), this.handle ? (this._blurActiveElement(e), this._blockFrames(i.iframeFix === !0 ? \"iframe\" : i.iframeFix), !0) : !1);\n    }, _blockFrames: function _blockFrames(e) {\n      this.iframeBlocks = this.document.find(e).map(function () {\n        var e = t(this);return t(\"<div>\").css(\"position\", \"absolute\").appendTo(e.parent()).outerWidth(e.outerWidth()).outerHeight(e.outerHeight()).offset(e.offset())[0];\n      });\n    }, _unblockFrames: function _unblockFrames() {\n      this.iframeBlocks && (this.iframeBlocks.remove(), delete this.iframeBlocks);\n    }, _blurActiveElement: function _blurActiveElement(e) {\n      var i = t.ui.safeActiveElement(this.document[0]),\n          s = t(e.target);s.closest(i).length || t.ui.safeBlur(i);\n    }, _mouseStart: function _mouseStart(e) {\n      var i = this.options;return this.helper = this._createHelper(e), this._addClass(this.helper, \"ui-draggable-dragging\"), this._cacheHelperProportions(), t.ui.ddmanager && (t.ui.ddmanager.current = this), this._cacheMargins(), this.cssPosition = this.helper.css(\"position\"), this.scrollParent = this.helper.scrollParent(!0), this.offsetParent = this.helper.offsetParent(), this.hasFixedAncestor = this.helper.parents().filter(function () {\n        return \"fixed\" === t(this).css(\"position\");\n      }).length > 0, this.positionAbs = this.element.offset(), this._refreshOffsets(e), this.originalPosition = this.position = this._generatePosition(e, !1), this.originalPageX = e.pageX, this.originalPageY = e.pageY, i.cursorAt && this._adjustOffsetFromHelper(i.cursorAt), this._setContainment(), this._trigger(\"start\", e) === !1 ? (this._clear(), !1) : (this._cacheHelperProportions(), t.ui.ddmanager && !i.dropBehaviour && t.ui.ddmanager.prepareOffsets(this, e), this._mouseDrag(e, !0), t.ui.ddmanager && t.ui.ddmanager.dragStart(this, e), !0);\n    }, _refreshOffsets: function _refreshOffsets(t) {\n      this.offset = { top: this.positionAbs.top - this.margins.top, left: this.positionAbs.left - this.margins.left, scroll: !1, parent: this._getParentOffset(), relative: this._getRelativeOffset() }, this.offset.click = { left: t.pageX - this.offset.left, top: t.pageY - this.offset.top };\n    }, _mouseDrag: function _mouseDrag(e, i) {\n      if (this.hasFixedAncestor && (this.offset.parent = this._getParentOffset()), this.position = this._generatePosition(e, !0), this.positionAbs = this._convertPositionTo(\"absolute\"), !i) {\n        var s = this._uiHash();if (this._trigger(\"drag\", e, s) === !1) return this._mouseUp(new t.Event(\"mouseup\", e)), !1;this.position = s.position;\n      }return this.helper[0].style.left = this.position.left + \"px\", this.helper[0].style.top = this.position.top + \"px\", t.ui.ddmanager && t.ui.ddmanager.drag(this, e), !1;\n    }, _mouseStop: function _mouseStop(e) {\n      var i = this,\n          s = !1;return t.ui.ddmanager && !this.options.dropBehaviour && (s = t.ui.ddmanager.drop(this, e)), this.dropped && (s = this.dropped, this.dropped = !1), \"invalid\" === this.options.revert && !s || \"valid\" === this.options.revert && s || this.options.revert === !0 || t.isFunction(this.options.revert) && this.options.revert.call(this.element, s) ? t(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function () {\n        i._trigger(\"stop\", e) !== !1 && i._clear();\n      }) : this._trigger(\"stop\", e) !== !1 && this._clear(), !1;\n    }, _mouseUp: function _mouseUp(e) {\n      return this._unblockFrames(), t.ui.ddmanager && t.ui.ddmanager.dragStop(this, e), this.handleElement.is(e.target) && this.element.trigger(\"focus\"), t.ui.mouse.prototype._mouseUp.call(this, e);\n    }, cancel: function cancel() {\n      return this.helper.is(\".ui-draggable-dragging\") ? this._mouseUp(new t.Event(\"mouseup\", { target: this.element[0] })) : this._clear(), this;\n    }, _getHandle: function _getHandle(e) {\n      return this.options.handle ? !!t(e.target).closest(this.element.find(this.options.handle)).length : !0;\n    }, _setHandleClassName: function _setHandleClassName() {\n      this.handleElement = this.options.handle ? this.element.find(this.options.handle) : this.element, this._addClass(this.handleElement, \"ui-draggable-handle\");\n    }, _removeHandleClassName: function _removeHandleClassName() {\n      this._removeClass(this.handleElement, \"ui-draggable-handle\");\n    }, _createHelper: function _createHelper(e) {\n      var i = this.options,\n          s = t.isFunction(i.helper),\n          n = s ? t(i.helper.apply(this.element[0], [e])) : \"clone\" === i.helper ? this.element.clone().removeAttr(\"id\") : this.element;return n.parents(\"body\").length || n.appendTo(\"parent\" === i.appendTo ? this.element[0].parentNode : i.appendTo), s && n[0] === this.element[0] && this._setPositionRelative(), n[0] === this.element[0] || /(fixed|absolute)/.test(n.css(\"position\")) || n.css(\"position\", \"absolute\"), n;\n    }, _setPositionRelative: function _setPositionRelative() {\n      /^(?:r|a|f)/.test(this.element.css(\"position\")) || (this.element[0].style.position = \"relative\");\n    }, _adjustOffsetFromHelper: function _adjustOffsetFromHelper(e) {\n      \"string\" == typeof e && (e = e.split(\" \")), t.isArray(e) && (e = { left: +e[0], top: +e[1] || 0 }), \"left\" in e && (this.offset.click.left = e.left + this.margins.left), \"right\" in e && (this.offset.click.left = this.helperProportions.width - e.right + this.margins.left), \"top\" in e && (this.offset.click.top = e.top + this.margins.top), \"bottom\" in e && (this.offset.click.top = this.helperProportions.height - e.bottom + this.margins.top);\n    }, _isRootNode: function _isRootNode(t) {\n      return (/(html|body)/i.test(t.tagName) || t === this.document[0]\n      );\n    }, _getParentOffset: function _getParentOffset() {\n      var e = this.offsetParent.offset(),\n          i = this.document[0];return \"absolute\" === this.cssPosition && this.scrollParent[0] !== i && t.contains(this.scrollParent[0], this.offsetParent[0]) && (e.left += this.scrollParent.scrollLeft(), e.top += this.scrollParent.scrollTop()), this._isRootNode(this.offsetParent[0]) && (e = { top: 0, left: 0 }), { top: e.top + (parseInt(this.offsetParent.css(\"borderTopWidth\"), 10) || 0), left: e.left + (parseInt(this.offsetParent.css(\"borderLeftWidth\"), 10) || 0) };\n    }, _getRelativeOffset: function _getRelativeOffset() {\n      if (\"relative\" !== this.cssPosition) return { top: 0, left: 0 };var t = this.element.position(),\n          e = this._isRootNode(this.scrollParent[0]);return { top: t.top - (parseInt(this.helper.css(\"top\"), 10) || 0) + (e ? 0 : this.scrollParent.scrollTop()), left: t.left - (parseInt(this.helper.css(\"left\"), 10) || 0) + (e ? 0 : this.scrollParent.scrollLeft()) };\n    }, _cacheMargins: function _cacheMargins() {\n      this.margins = { left: parseInt(this.element.css(\"marginLeft\"), 10) || 0, top: parseInt(this.element.css(\"marginTop\"), 10) || 0, right: parseInt(this.element.css(\"marginRight\"), 10) || 0, bottom: parseInt(this.element.css(\"marginBottom\"), 10) || 0 };\n    }, _cacheHelperProportions: function _cacheHelperProportions() {\n      this.helperProportions = { width: this.helper.outerWidth(), height: this.helper.outerHeight() };\n    }, _setContainment: function _setContainment() {\n      var e,\n          i,\n          s,\n          n = this.options,\n          o = this.document[0];return this.relativeContainer = null, n.containment ? \"window\" === n.containment ? (this.containment = [t(window).scrollLeft() - this.offset.relative.left - this.offset.parent.left, t(window).scrollTop() - this.offset.relative.top - this.offset.parent.top, t(window).scrollLeft() + t(window).width() - this.helperProportions.width - this.margins.left, t(window).scrollTop() + (t(window).height() || o.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top], void 0) : \"document\" === n.containment ? (this.containment = [0, 0, t(o).width() - this.helperProportions.width - this.margins.left, (t(o).height() || o.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top], void 0) : n.containment.constructor === Array ? (this.containment = n.containment, void 0) : (\"parent\" === n.containment && (n.containment = this.helper[0].parentNode), i = t(n.containment), s = i[0], s && (e = /(scroll|auto)/.test(i.css(\"overflow\")), this.containment = [(parseInt(i.css(\"borderLeftWidth\"), 10) || 0) + (parseInt(i.css(\"paddingLeft\"), 10) || 0), (parseInt(i.css(\"borderTopWidth\"), 10) || 0) + (parseInt(i.css(\"paddingTop\"), 10) || 0), (e ? Math.max(s.scrollWidth, s.offsetWidth) : s.offsetWidth) - (parseInt(i.css(\"borderRightWidth\"), 10) || 0) - (parseInt(i.css(\"paddingRight\"), 10) || 0) - this.helperProportions.width - this.margins.left - this.margins.right, (e ? Math.max(s.scrollHeight, s.offsetHeight) : s.offsetHeight) - (parseInt(i.css(\"borderBottomWidth\"), 10) || 0) - (parseInt(i.css(\"paddingBottom\"), 10) || 0) - this.helperProportions.height - this.margins.top - this.margins.bottom], this.relativeContainer = i), void 0) : (this.containment = null, void 0);\n    }, _convertPositionTo: function _convertPositionTo(t, e) {\n      e || (e = this.position);var i = \"absolute\" === t ? 1 : -1,\n          s = this._isRootNode(this.scrollParent[0]);return { top: e.top + this.offset.relative.top * i + this.offset.parent.top * i - (\"fixed\" === this.cssPosition ? -this.offset.scroll.top : s ? 0 : this.offset.scroll.top) * i, left: e.left + this.offset.relative.left * i + this.offset.parent.left * i - (\"fixed\" === this.cssPosition ? -this.offset.scroll.left : s ? 0 : this.offset.scroll.left) * i };\n    }, _generatePosition: function _generatePosition(t, e) {\n      var i,\n          s,\n          n,\n          o,\n          a = this.options,\n          r = this._isRootNode(this.scrollParent[0]),\n          h = t.pageX,\n          l = t.pageY;return r && this.offset.scroll || (this.offset.scroll = { top: this.scrollParent.scrollTop(), left: this.scrollParent.scrollLeft() }), e && (this.containment && (this.relativeContainer ? (s = this.relativeContainer.offset(), i = [this.containment[0] + s.left, this.containment[1] + s.top, this.containment[2] + s.left, this.containment[3] + s.top]) : i = this.containment, t.pageX - this.offset.click.left < i[0] && (h = i[0] + this.offset.click.left), t.pageY - this.offset.click.top < i[1] && (l = i[1] + this.offset.click.top), t.pageX - this.offset.click.left > i[2] && (h = i[2] + this.offset.click.left), t.pageY - this.offset.click.top > i[3] && (l = i[3] + this.offset.click.top)), a.grid && (n = a.grid[1] ? this.originalPageY + Math.round((l - this.originalPageY) / a.grid[1]) * a.grid[1] : this.originalPageY, l = i ? n - this.offset.click.top >= i[1] || n - this.offset.click.top > i[3] ? n : n - this.offset.click.top >= i[1] ? n - a.grid[1] : n + a.grid[1] : n, o = a.grid[0] ? this.originalPageX + Math.round((h - this.originalPageX) / a.grid[0]) * a.grid[0] : this.originalPageX, h = i ? o - this.offset.click.left >= i[0] || o - this.offset.click.left > i[2] ? o : o - this.offset.click.left >= i[0] ? o - a.grid[0] : o + a.grid[0] : o), \"y\" === a.axis && (h = this.originalPageX), \"x\" === a.axis && (l = this.originalPageY)), { top: l - this.offset.click.top - this.offset.relative.top - this.offset.parent.top + (\"fixed\" === this.cssPosition ? -this.offset.scroll.top : r ? 0 : this.offset.scroll.top), left: h - this.offset.click.left - this.offset.relative.left - this.offset.parent.left + (\"fixed\" === this.cssPosition ? -this.offset.scroll.left : r ? 0 : this.offset.scroll.left) };\n    }, _clear: function _clear() {\n      this._removeClass(this.helper, \"ui-draggable-dragging\"), this.helper[0] === this.element[0] || this.cancelHelperRemoval || this.helper.remove(), this.helper = null, this.cancelHelperRemoval = !1, this.destroyOnClear && this.destroy();\n    }, _trigger: function _trigger(e, i, s) {\n      return s = s || this._uiHash(), t.ui.plugin.call(this, e, [i, s, this], !0), /^(drag|start|stop)/.test(e) && (this.positionAbs = this._convertPositionTo(\"absolute\"), s.offset = this.positionAbs), t.Widget.prototype._trigger.call(this, e, i, s);\n    }, plugins: {}, _uiHash: function _uiHash() {\n      return { helper: this.helper, position: this.position, originalPosition: this.originalPosition, offset: this.positionAbs };\n    } }), t.ui.plugin.add(\"draggable\", \"connectToSortable\", { start: function start(e, i, s) {\n      var n = t.extend({}, i, { item: s.element });s.sortables = [], t(s.options.connectToSortable).each(function () {\n        var i = t(this).sortable(\"instance\");i && !i.options.disabled && (s.sortables.push(i), i.refreshPositions(), i._trigger(\"activate\", e, n));\n      });\n    }, stop: function stop(e, i, s) {\n      var n = t.extend({}, i, { item: s.element });s.cancelHelperRemoval = !1, t.each(s.sortables, function () {\n        var t = this;t.isOver ? (t.isOver = 0, s.cancelHelperRemoval = !0, t.cancelHelperRemoval = !1, t._storedCSS = { position: t.placeholder.css(\"position\"), top: t.placeholder.css(\"top\"), left: t.placeholder.css(\"left\") }, t._mouseStop(e), t.options.helper = t.options._helper) : (t.cancelHelperRemoval = !0, t._trigger(\"deactivate\", e, n));\n      });\n    }, drag: function drag(e, i, s) {\n      t.each(s.sortables, function () {\n        var n = !1,\n            o = this;o.positionAbs = s.positionAbs, o.helperProportions = s.helperProportions, o.offset.click = s.offset.click, o._intersectsWith(o.containerCache) && (n = !0, t.each(s.sortables, function () {\n          return this.positionAbs = s.positionAbs, this.helperProportions = s.helperProportions, this.offset.click = s.offset.click, this !== o && this._intersectsWith(this.containerCache) && t.contains(o.element[0], this.element[0]) && (n = !1), n;\n        })), n ? (o.isOver || (o.isOver = 1, s._parent = i.helper.parent(), o.currentItem = i.helper.appendTo(o.element).data(\"ui-sortable-item\", !0), o.options._helper = o.options.helper, o.options.helper = function () {\n          return i.helper[0];\n        }, e.target = o.currentItem[0], o._mouseCapture(e, !0), o._mouseStart(e, !0, !0), o.offset.click.top = s.offset.click.top, o.offset.click.left = s.offset.click.left, o.offset.parent.left -= s.offset.parent.left - o.offset.parent.left, o.offset.parent.top -= s.offset.parent.top - o.offset.parent.top, s._trigger(\"toSortable\", e), s.dropped = o.element, t.each(s.sortables, function () {\n          this.refreshPositions();\n        }), s.currentItem = s.element, o.fromOutside = s), o.currentItem && (o._mouseDrag(e), i.position = o.position)) : o.isOver && (o.isOver = 0, o.cancelHelperRemoval = !0, o.options._revert = o.options.revert, o.options.revert = !1, o._trigger(\"out\", e, o._uiHash(o)), o._mouseStop(e, !0), o.options.revert = o.options._revert, o.options.helper = o.options._helper, o.placeholder && o.placeholder.remove(), i.helper.appendTo(s._parent), s._refreshOffsets(e), i.position = s._generatePosition(e, !0), s._trigger(\"fromSortable\", e), s.dropped = !1, t.each(s.sortables, function () {\n          this.refreshPositions();\n        }));\n      });\n    } }), t.ui.plugin.add(\"draggable\", \"cursor\", { start: function start(e, i, s) {\n      var n = t(\"body\"),\n          o = s.options;n.css(\"cursor\") && (o._cursor = n.css(\"cursor\")), n.css(\"cursor\", o.cursor);\n    }, stop: function stop(e, i, s) {\n      var n = s.options;n._cursor && t(\"body\").css(\"cursor\", n._cursor);\n    } }), t.ui.plugin.add(\"draggable\", \"opacity\", { start: function start(e, i, s) {\n      var n = t(i.helper),\n          o = s.options;n.css(\"opacity\") && (o._opacity = n.css(\"opacity\")), n.css(\"opacity\", o.opacity);\n    }, stop: function stop(e, i, s) {\n      var n = s.options;n._opacity && t(i.helper).css(\"opacity\", n._opacity);\n    } }), t.ui.plugin.add(\"draggable\", \"scroll\", { start: function start(t, e, i) {\n      i.scrollParentNotHidden || (i.scrollParentNotHidden = i.helper.scrollParent(!1)), i.scrollParentNotHidden[0] !== i.document[0] && \"HTML\" !== i.scrollParentNotHidden[0].tagName && (i.overflowOffset = i.scrollParentNotHidden.offset());\n    }, drag: function drag(e, i, s) {\n      var n = s.options,\n          o = !1,\n          a = s.scrollParentNotHidden[0],\n          r = s.document[0];a !== r && \"HTML\" !== a.tagName ? (n.axis && \"x\" === n.axis || (s.overflowOffset.top + a.offsetHeight - e.pageY < n.scrollSensitivity ? a.scrollTop = o = a.scrollTop + n.scrollSpeed : e.pageY - s.overflowOffset.top < n.scrollSensitivity && (a.scrollTop = o = a.scrollTop - n.scrollSpeed)), n.axis && \"y\" === n.axis || (s.overflowOffset.left + a.offsetWidth - e.pageX < n.scrollSensitivity ? a.scrollLeft = o = a.scrollLeft + n.scrollSpeed : e.pageX - s.overflowOffset.left < n.scrollSensitivity && (a.scrollLeft = o = a.scrollLeft - n.scrollSpeed))) : (n.axis && \"x\" === n.axis || (e.pageY - t(r).scrollTop() < n.scrollSensitivity ? o = t(r).scrollTop(t(r).scrollTop() - n.scrollSpeed) : t(window).height() - (e.pageY - t(r).scrollTop()) < n.scrollSensitivity && (o = t(r).scrollTop(t(r).scrollTop() + n.scrollSpeed))), n.axis && \"y\" === n.axis || (e.pageX - t(r).scrollLeft() < n.scrollSensitivity ? o = t(r).scrollLeft(t(r).scrollLeft() - n.scrollSpeed) : t(window).width() - (e.pageX - t(r).scrollLeft()) < n.scrollSensitivity && (o = t(r).scrollLeft(t(r).scrollLeft() + n.scrollSpeed)))), o !== !1 && t.ui.ddmanager && !n.dropBehaviour && t.ui.ddmanager.prepareOffsets(s, e);\n    } }), t.ui.plugin.add(\"draggable\", \"snap\", { start: function start(e, i, s) {\n      var n = s.options;s.snapElements = [], t(n.snap.constructor !== String ? n.snap.items || \":data(ui-draggable)\" : n.snap).each(function () {\n        var e = t(this),\n            i = e.offset();this !== s.element[0] && s.snapElements.push({ item: this, width: e.outerWidth(), height: e.outerHeight(), top: i.top, left: i.left });\n      });\n    }, drag: function drag(e, i, s) {\n      var n,\n          o,\n          a,\n          r,\n          h,\n          l,\n          c,\n          u,\n          d,\n          p,\n          f = s.options,\n          g = f.snapTolerance,\n          m = i.offset.left,\n          _ = m + s.helperProportions.width,\n          v = i.offset.top,\n          b = v + s.helperProportions.height;for (d = s.snapElements.length - 1; d >= 0; d--) {\n        h = s.snapElements[d].left - s.margins.left, l = h + s.snapElements[d].width, c = s.snapElements[d].top - s.margins.top, u = c + s.snapElements[d].height, h - g > _ || m > l + g || c - g > b || v > u + g || !t.contains(s.snapElements[d].item.ownerDocument, s.snapElements[d].item) ? (s.snapElements[d].snapping && s.options.snap.release && s.options.snap.release.call(s.element, e, t.extend(s._uiHash(), { snapItem: s.snapElements[d].item })), s.snapElements[d].snapping = !1) : (\"inner\" !== f.snapMode && (n = g >= Math.abs(c - b), o = g >= Math.abs(u - v), a = g >= Math.abs(h - _), r = g >= Math.abs(l - m), n && (i.position.top = s._convertPositionTo(\"relative\", { top: c - s.helperProportions.height, left: 0 }).top), o && (i.position.top = s._convertPositionTo(\"relative\", { top: u, left: 0 }).top), a && (i.position.left = s._convertPositionTo(\"relative\", { top: 0, left: h - s.helperProportions.width }).left), r && (i.position.left = s._convertPositionTo(\"relative\", { top: 0, left: l }).left)), p = n || o || a || r, \"outer\" !== f.snapMode && (n = g >= Math.abs(c - v), o = g >= Math.abs(u - b), a = g >= Math.abs(h - m), r = g >= Math.abs(l - _), n && (i.position.top = s._convertPositionTo(\"relative\", { top: c, left: 0 }).top), o && (i.position.top = s._convertPositionTo(\"relative\", { top: u - s.helperProportions.height, left: 0 }).top), a && (i.position.left = s._convertPositionTo(\"relative\", { top: 0, left: h }).left), r && (i.position.left = s._convertPositionTo(\"relative\", { top: 0, left: l - s.helperProportions.width }).left)), !s.snapElements[d].snapping && (n || o || a || r || p) && s.options.snap.snap && s.options.snap.snap.call(s.element, e, t.extend(s._uiHash(), { snapItem: s.snapElements[d].item })), s.snapElements[d].snapping = n || o || a || r || p);\n      }\n    } }), t.ui.plugin.add(\"draggable\", \"stack\", { start: function start(e, i, s) {\n      var n,\n          o = s.options,\n          a = t.makeArray(t(o.stack)).sort(function (e, i) {\n        return (parseInt(t(e).css(\"zIndex\"), 10) || 0) - (parseInt(t(i).css(\"zIndex\"), 10) || 0);\n      });a.length && (n = parseInt(t(a[0]).css(\"zIndex\"), 10) || 0, t(a).each(function (e) {\n        t(this).css(\"zIndex\", n + e);\n      }), this.css(\"zIndex\", n + a.length));\n    } }), t.ui.plugin.add(\"draggable\", \"zIndex\", { start: function start(e, i, s) {\n      var n = t(i.helper),\n          o = s.options;n.css(\"zIndex\") && (o._zIndex = n.css(\"zIndex\")), n.css(\"zIndex\", o.zIndex);\n    }, stop: function stop(e, i, s) {\n      var n = s.options;n._zIndex && t(i.helper).css(\"zIndex\", n._zIndex);\n    } }), t.ui.draggable, t.widget(\"ui.resizable\", t.ui.mouse, { version: \"1.12.1\", widgetEventPrefix: \"resize\", options: { alsoResize: !1, animate: !1, animateDuration: \"slow\", animateEasing: \"swing\", aspectRatio: !1, autoHide: !1, classes: { \"ui-resizable-se\": \"ui-icon ui-icon-gripsmall-diagonal-se\" }, containment: !1, ghost: !1, grid: !1, handles: \"e,s,se\", helper: !1, maxHeight: null, maxWidth: null, minHeight: 10, minWidth: 10, zIndex: 90, resize: null, start: null, stop: null }, _num: function _num(t) {\n      return parseFloat(t) || 0;\n    }, _isNumber: function _isNumber(t) {\n      return !isNaN(parseFloat(t));\n    }, _hasScroll: function _hasScroll(e, i) {\n      if (\"hidden\" === t(e).css(\"overflow\")) return !1;var s = i && \"left\" === i ? \"scrollLeft\" : \"scrollTop\",\n          n = !1;return e[s] > 0 ? !0 : (e[s] = 1, n = e[s] > 0, e[s] = 0, n);\n    }, _create: function _create() {\n      var e,\n          i = this.options,\n          s = this;this._addClass(\"ui-resizable\"), t.extend(this, { _aspectRatio: !!i.aspectRatio, aspectRatio: i.aspectRatio, originalElement: this.element, _proportionallyResizeElements: [], _helper: i.helper || i.ghost || i.animate ? i.helper || \"ui-resizable-helper\" : null }), this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i) && (this.element.wrap(t(\"<div class='ui-wrapper' style='overflow: hidden;'></div>\").css({ position: this.element.css(\"position\"), width: this.element.outerWidth(), height: this.element.outerHeight(), top: this.element.css(\"top\"), left: this.element.css(\"left\") })), this.element = this.element.parent().data(\"ui-resizable\", this.element.resizable(\"instance\")), this.elementIsWrapper = !0, e = { marginTop: this.originalElement.css(\"marginTop\"), marginRight: this.originalElement.css(\"marginRight\"), marginBottom: this.originalElement.css(\"marginBottom\"), marginLeft: this.originalElement.css(\"marginLeft\") }, this.element.css(e), this.originalElement.css(\"margin\", 0), this.originalResizeStyle = this.originalElement.css(\"resize\"), this.originalElement.css(\"resize\", \"none\"), this._proportionallyResizeElements.push(this.originalElement.css({ position: \"static\", zoom: 1, display: \"block\" })), this.originalElement.css(e), this._proportionallyResize()), this._setupHandles(), i.autoHide && t(this.element).on(\"mouseenter\", function () {\n        i.disabled || (s._removeClass(\"ui-resizable-autohide\"), s._handles.show());\n      }).on(\"mouseleave\", function () {\n        i.disabled || s.resizing || (s._addClass(\"ui-resizable-autohide\"), s._handles.hide());\n      }), this._mouseInit();\n    }, _destroy: function _destroy() {\n      this._mouseDestroy();var e,\n          i = function i(e) {\n        t(e).removeData(\"resizable\").removeData(\"ui-resizable\").off(\".resizable\").find(\".ui-resizable-handle\").remove();\n      };return this.elementIsWrapper && (i(this.element), e = this.element, this.originalElement.css({ position: e.css(\"position\"), width: e.outerWidth(), height: e.outerHeight(), top: e.css(\"top\"), left: e.css(\"left\") }).insertAfter(e), e.remove()), this.originalElement.css(\"resize\", this.originalResizeStyle), i(this.originalElement), this;\n    }, _setOption: function _setOption(t, e) {\n      switch (this._super(t, e), t) {case \"handles\":\n          this._removeHandles(), this._setupHandles();break;default:}\n    }, _setupHandles: function _setupHandles() {\n      var e,\n          i,\n          s,\n          n,\n          o,\n          a = this.options,\n          r = this;if (this.handles = a.handles || (t(\".ui-resizable-handle\", this.element).length ? { n: \".ui-resizable-n\", e: \".ui-resizable-e\", s: \".ui-resizable-s\", w: \".ui-resizable-w\", se: \".ui-resizable-se\", sw: \".ui-resizable-sw\", ne: \".ui-resizable-ne\", nw: \".ui-resizable-nw\" } : \"e,s,se\"), this._handles = t(), this.handles.constructor === String) for (\"all\" === this.handles && (this.handles = \"n,e,s,w,se,sw,ne,nw\"), s = this.handles.split(\",\"), this.handles = {}, i = 0; s.length > i; i++) {\n        e = t.trim(s[i]), n = \"ui-resizable-\" + e, o = t(\"<div>\"), this._addClass(o, \"ui-resizable-handle \" + n), o.css({ zIndex: a.zIndex }), this.handles[e] = \".ui-resizable-\" + e, this.element.append(o);\n      }this._renderAxis = function (e) {\n        var i, s, n, o;e = e || this.element;for (i in this.handles) {\n          this.handles[i].constructor === String ? this.handles[i] = this.element.children(this.handles[i]).first().show() : (this.handles[i].jquery || this.handles[i].nodeType) && (this.handles[i] = t(this.handles[i]), this._on(this.handles[i], { mousedown: r._mouseDown })), this.elementIsWrapper && this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i) && (s = t(this.handles[i], this.element), o = /sw|ne|nw|se|n|s/.test(i) ? s.outerHeight() : s.outerWidth(), n = [\"padding\", /ne|nw|n/.test(i) ? \"Top\" : /se|sw|s/.test(i) ? \"Bottom\" : /^e$/.test(i) ? \"Right\" : \"Left\"].join(\"\"), e.css(n, o), this._proportionallyResize()), this._handles = this._handles.add(this.handles[i]);\n        }\n      }, this._renderAxis(this.element), this._handles = this._handles.add(this.element.find(\".ui-resizable-handle\")), this._handles.disableSelection(), this._handles.on(\"mouseover\", function () {\n        r.resizing || (this.className && (o = this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)), r.axis = o && o[1] ? o[1] : \"se\");\n      }), a.autoHide && (this._handles.hide(), this._addClass(\"ui-resizable-autohide\"));\n    }, _removeHandles: function _removeHandles() {\n      this._handles.remove();\n    }, _mouseCapture: function _mouseCapture(e) {\n      var i,\n          s,\n          n = !1;for (i in this.handles) {\n        s = t(this.handles[i])[0], (s === e.target || t.contains(s, e.target)) && (n = !0);\n      }return !this.options.disabled && n;\n    }, _mouseStart: function _mouseStart(e) {\n      var i,\n          s,\n          n,\n          o = this.options,\n          a = this.element;return this.resizing = !0, this._renderProxy(), i = this._num(this.helper.css(\"left\")), s = this._num(this.helper.css(\"top\")), o.containment && (i += t(o.containment).scrollLeft() || 0, s += t(o.containment).scrollTop() || 0), this.offset = this.helper.offset(), this.position = { left: i, top: s }, this.size = this._helper ? { width: this.helper.width(), height: this.helper.height() } : { width: a.width(), height: a.height() }, this.originalSize = this._helper ? { width: a.outerWidth(), height: a.outerHeight() } : { width: a.width(), height: a.height() }, this.sizeDiff = { width: a.outerWidth() - a.width(), height: a.outerHeight() - a.height() }, this.originalPosition = { left: i, top: s }, this.originalMousePosition = { left: e.pageX, top: e.pageY }, this.aspectRatio = \"number\" == typeof o.aspectRatio ? o.aspectRatio : this.originalSize.width / this.originalSize.height || 1, n = t(\".ui-resizable-\" + this.axis).css(\"cursor\"), t(\"body\").css(\"cursor\", \"auto\" === n ? this.axis + \"-resize\" : n), this._addClass(\"ui-resizable-resizing\"), this._propagate(\"start\", e), !0;\n    }, _mouseDrag: function _mouseDrag(e) {\n      var i,\n          s,\n          n = this.originalMousePosition,\n          o = this.axis,\n          a = e.pageX - n.left || 0,\n          r = e.pageY - n.top || 0,\n          h = this._change[o];return this._updatePrevProperties(), h ? (i = h.apply(this, [e, a, r]), this._updateVirtualBoundaries(e.shiftKey), (this._aspectRatio || e.shiftKey) && (i = this._updateRatio(i, e)), i = this._respectSize(i, e), this._updateCache(i), this._propagate(\"resize\", e), s = this._applyChanges(), !this._helper && this._proportionallyResizeElements.length && this._proportionallyResize(), t.isEmptyObject(s) || (this._updatePrevProperties(), this._trigger(\"resize\", e, this.ui()), this._applyChanges()), !1) : !1;\n    }, _mouseStop: function _mouseStop(e) {\n      this.resizing = !1;var i,\n          s,\n          n,\n          o,\n          a,\n          r,\n          h,\n          l = this.options,\n          c = this;return this._helper && (i = this._proportionallyResizeElements, s = i.length && /textarea/i.test(i[0].nodeName), n = s && this._hasScroll(i[0], \"left\") ? 0 : c.sizeDiff.height, o = s ? 0 : c.sizeDiff.width, a = { width: c.helper.width() - o, height: c.helper.height() - n }, r = parseFloat(c.element.css(\"left\")) + (c.position.left - c.originalPosition.left) || null, h = parseFloat(c.element.css(\"top\")) + (c.position.top - c.originalPosition.top) || null, l.animate || this.element.css(t.extend(a, { top: h, left: r })), c.helper.height(c.size.height), c.helper.width(c.size.width), this._helper && !l.animate && this._proportionallyResize()), t(\"body\").css(\"cursor\", \"auto\"), this._removeClass(\"ui-resizable-resizing\"), this._propagate(\"stop\", e), this._helper && this.helper.remove(), !1;\n    }, _updatePrevProperties: function _updatePrevProperties() {\n      this.prevPosition = { top: this.position.top, left: this.position.left }, this.prevSize = { width: this.size.width, height: this.size.height };\n    }, _applyChanges: function _applyChanges() {\n      var t = {};return this.position.top !== this.prevPosition.top && (t.top = this.position.top + \"px\"), this.position.left !== this.prevPosition.left && (t.left = this.position.left + \"px\"), this.size.width !== this.prevSize.width && (t.width = this.size.width + \"px\"), this.size.height !== this.prevSize.height && (t.height = this.size.height + \"px\"), this.helper.css(t), t;\n    }, _updateVirtualBoundaries: function _updateVirtualBoundaries(t) {\n      var e,\n          i,\n          s,\n          n,\n          o,\n          a = this.options;o = { minWidth: this._isNumber(a.minWidth) ? a.minWidth : 0, maxWidth: this._isNumber(a.maxWidth) ? a.maxWidth : 1 / 0, minHeight: this._isNumber(a.minHeight) ? a.minHeight : 0, maxHeight: this._isNumber(a.maxHeight) ? a.maxHeight : 1 / 0 }, (this._aspectRatio || t) && (e = o.minHeight * this.aspectRatio, s = o.minWidth / this.aspectRatio, i = o.maxHeight * this.aspectRatio, n = o.maxWidth / this.aspectRatio, e > o.minWidth && (o.minWidth = e), s > o.minHeight && (o.minHeight = s), o.maxWidth > i && (o.maxWidth = i), o.maxHeight > n && (o.maxHeight = n)), this._vBoundaries = o;\n    }, _updateCache: function _updateCache(t) {\n      this.offset = this.helper.offset(), this._isNumber(t.left) && (this.position.left = t.left), this._isNumber(t.top) && (this.position.top = t.top), this._isNumber(t.height) && (this.size.height = t.height), this._isNumber(t.width) && (this.size.width = t.width);\n    }, _updateRatio: function _updateRatio(t) {\n      var e = this.position,\n          i = this.size,\n          s = this.axis;return this._isNumber(t.height) ? t.width = t.height * this.aspectRatio : this._isNumber(t.width) && (t.height = t.width / this.aspectRatio), \"sw\" === s && (t.left = e.left + (i.width - t.width), t.top = null), \"nw\" === s && (t.top = e.top + (i.height - t.height), t.left = e.left + (i.width - t.width)), t;\n    }, _respectSize: function _respectSize(t) {\n      var e = this._vBoundaries,\n          i = this.axis,\n          s = this._isNumber(t.width) && e.maxWidth && e.maxWidth < t.width,\n          n = this._isNumber(t.height) && e.maxHeight && e.maxHeight < t.height,\n          o = this._isNumber(t.width) && e.minWidth && e.minWidth > t.width,\n          a = this._isNumber(t.height) && e.minHeight && e.minHeight > t.height,\n          r = this.originalPosition.left + this.originalSize.width,\n          h = this.originalPosition.top + this.originalSize.height,\n          l = /sw|nw|w/.test(i),\n          c = /nw|ne|n/.test(i);return o && (t.width = e.minWidth), a && (t.height = e.minHeight), s && (t.width = e.maxWidth), n && (t.height = e.maxHeight), o && l && (t.left = r - e.minWidth), s && l && (t.left = r - e.maxWidth), a && c && (t.top = h - e.minHeight), n && c && (t.top = h - e.maxHeight), t.width || t.height || t.left || !t.top ? t.width || t.height || t.top || !t.left || (t.left = null) : t.top = null, t;\n    }, _getPaddingPlusBorderDimensions: function _getPaddingPlusBorderDimensions(t) {\n      for (var e = 0, i = [], s = [t.css(\"borderTopWidth\"), t.css(\"borderRightWidth\"), t.css(\"borderBottomWidth\"), t.css(\"borderLeftWidth\")], n = [t.css(\"paddingTop\"), t.css(\"paddingRight\"), t.css(\"paddingBottom\"), t.css(\"paddingLeft\")]; 4 > e; e++) {\n        i[e] = parseFloat(s[e]) || 0, i[e] += parseFloat(n[e]) || 0;\n      }return { height: i[0] + i[2], width: i[1] + i[3] };\n    }, _proportionallyResize: function _proportionallyResize() {\n      if (this._proportionallyResizeElements.length) for (var t, e = 0, i = this.helper || this.element; this._proportionallyResizeElements.length > e; e++) {\n        t = this._proportionallyResizeElements[e], this.outerDimensions || (this.outerDimensions = this._getPaddingPlusBorderDimensions(t)), t.css({ height: i.height() - this.outerDimensions.height || 0, width: i.width() - this.outerDimensions.width || 0 });\n      }\n    }, _renderProxy: function _renderProxy() {\n      var e = this.element,\n          i = this.options;this.elementOffset = e.offset(), this._helper ? (this.helper = this.helper || t(\"<div style='overflow:hidden;'></div>\"), this._addClass(this.helper, this._helper), this.helper.css({ width: this.element.outerWidth(), height: this.element.outerHeight(), position: \"absolute\", left: this.elementOffset.left + \"px\", top: this.elementOffset.top + \"px\", zIndex: ++i.zIndex }), this.helper.appendTo(\"body\").disableSelection()) : this.helper = this.element;\n    }, _change: { e: function e(t, _e) {\n        return { width: this.originalSize.width + _e };\n      }, w: function w(t, e) {\n        var i = this.originalSize,\n            s = this.originalPosition;return { left: s.left + e, width: i.width - e };\n      }, n: function n(t, e, i) {\n        var s = this.originalSize,\n            n = this.originalPosition;return { top: n.top + i, height: s.height - i };\n      }, s: function s(t, e, i) {\n        return { height: this.originalSize.height + i };\n      }, se: function se(e, i, s) {\n        return t.extend(this._change.s.apply(this, arguments), this._change.e.apply(this, [e, i, s]));\n      }, sw: function sw(e, i, s) {\n        return t.extend(this._change.s.apply(this, arguments), this._change.w.apply(this, [e, i, s]));\n      }, ne: function ne(e, i, s) {\n        return t.extend(this._change.n.apply(this, arguments), this._change.e.apply(this, [e, i, s]));\n      }, nw: function nw(e, i, s) {\n        return t.extend(this._change.n.apply(this, arguments), this._change.w.apply(this, [e, i, s]));\n      } }, _propagate: function _propagate(e, i) {\n      t.ui.plugin.call(this, e, [i, this.ui()]), \"resize\" !== e && this._trigger(e, i, this.ui());\n    }, plugins: {}, ui: function ui() {\n      return { originalElement: this.originalElement, element: this.element, helper: this.helper, position: this.position, size: this.size, originalSize: this.originalSize, originalPosition: this.originalPosition };\n    } }), t.ui.plugin.add(\"resizable\", \"animate\", { stop: function stop(e) {\n      var i = t(this).resizable(\"instance\"),\n          s = i.options,\n          n = i._proportionallyResizeElements,\n          o = n.length && /textarea/i.test(n[0].nodeName),\n          a = o && i._hasScroll(n[0], \"left\") ? 0 : i.sizeDiff.height,\n          r = o ? 0 : i.sizeDiff.width,\n          h = { width: i.size.width - r, height: i.size.height - a },\n          l = parseFloat(i.element.css(\"left\")) + (i.position.left - i.originalPosition.left) || null,\n          c = parseFloat(i.element.css(\"top\")) + (i.position.top - i.originalPosition.top) || null;i.element.animate(t.extend(h, c && l ? { top: c, left: l } : {}), { duration: s.animateDuration, easing: s.animateEasing, step: function step() {\n          var s = { width: parseFloat(i.element.css(\"width\")), height: parseFloat(i.element.css(\"height\")), top: parseFloat(i.element.css(\"top\")), left: parseFloat(i.element.css(\"left\")) };n && n.length && t(n[0]).css({ width: s.width, height: s.height }), i._updateCache(s), i._propagate(\"resize\", e);\n        } });\n    } }), t.ui.plugin.add(\"resizable\", \"containment\", { start: function start() {\n      var e,\n          i,\n          s,\n          n,\n          o,\n          a,\n          r,\n          h = t(this).resizable(\"instance\"),\n          l = h.options,\n          c = h.element,\n          u = l.containment,\n          d = u instanceof t ? u.get(0) : /parent/.test(u) ? c.parent().get(0) : u;d && (h.containerElement = t(d), /document/.test(u) || u === document ? (h.containerOffset = { left: 0, top: 0 }, h.containerPosition = { left: 0, top: 0 }, h.parentData = { element: t(document), left: 0, top: 0, width: t(document).width(), height: t(document).height() || document.body.parentNode.scrollHeight }) : (e = t(d), i = [], t([\"Top\", \"Right\", \"Left\", \"Bottom\"]).each(function (t, s) {\n        i[t] = h._num(e.css(\"padding\" + s));\n      }), h.containerOffset = e.offset(), h.containerPosition = e.position(), h.containerSize = { height: e.innerHeight() - i[3], width: e.innerWidth() - i[1] }, s = h.containerOffset, n = h.containerSize.height, o = h.containerSize.width, a = h._hasScroll(d, \"left\") ? d.scrollWidth : o, r = h._hasScroll(d) ? d.scrollHeight : n, h.parentData = { element: d, left: s.left, top: s.top, width: a, height: r }));\n    }, resize: function resize(e) {\n      var i,\n          s,\n          n,\n          o,\n          a = t(this).resizable(\"instance\"),\n          r = a.options,\n          h = a.containerOffset,\n          l = a.position,\n          c = a._aspectRatio || e.shiftKey,\n          u = { top: 0, left: 0 },\n          d = a.containerElement,\n          p = !0;d[0] !== document && /static/.test(d.css(\"position\")) && (u = h), l.left < (a._helper ? h.left : 0) && (a.size.width = a.size.width + (a._helper ? a.position.left - h.left : a.position.left - u.left), c && (a.size.height = a.size.width / a.aspectRatio, p = !1), a.position.left = r.helper ? h.left : 0), l.top < (a._helper ? h.top : 0) && (a.size.height = a.size.height + (a._helper ? a.position.top - h.top : a.position.top), c && (a.size.width = a.size.height * a.aspectRatio, p = !1), a.position.top = a._helper ? h.top : 0), n = a.containerElement.get(0) === a.element.parent().get(0), o = /relative|absolute/.test(a.containerElement.css(\"position\")), n && o ? (a.offset.left = a.parentData.left + a.position.left, a.offset.top = a.parentData.top + a.position.top) : (a.offset.left = a.element.offset().left, a.offset.top = a.element.offset().top), i = Math.abs(a.sizeDiff.width + (a._helper ? a.offset.left - u.left : a.offset.left - h.left)), s = Math.abs(a.sizeDiff.height + (a._helper ? a.offset.top - u.top : a.offset.top - h.top)), i + a.size.width >= a.parentData.width && (a.size.width = a.parentData.width - i, c && (a.size.height = a.size.width / a.aspectRatio, p = !1)), s + a.size.height >= a.parentData.height && (a.size.height = a.parentData.height - s, c && (a.size.width = a.size.height * a.aspectRatio, p = !1)), p || (a.position.left = a.prevPosition.left, a.position.top = a.prevPosition.top, a.size.width = a.prevSize.width, a.size.height = a.prevSize.height);\n    }, stop: function stop() {\n      var e = t(this).resizable(\"instance\"),\n          i = e.options,\n          s = e.containerOffset,\n          n = e.containerPosition,\n          o = e.containerElement,\n          a = t(e.helper),\n          r = a.offset(),\n          h = a.outerWidth() - e.sizeDiff.width,\n          l = a.outerHeight() - e.sizeDiff.height;e._helper && !i.animate && /relative/.test(o.css(\"position\")) && t(this).css({ left: r.left - n.left - s.left, width: h, height: l }), e._helper && !i.animate && /static/.test(o.css(\"position\")) && t(this).css({ left: r.left - n.left - s.left, width: h, height: l });\n    } }), t.ui.plugin.add(\"resizable\", \"alsoResize\", { start: function start() {\n      var e = t(this).resizable(\"instance\"),\n          i = e.options;t(i.alsoResize).each(function () {\n        var e = t(this);e.data(\"ui-resizable-alsoresize\", { width: parseFloat(e.width()), height: parseFloat(e.height()), left: parseFloat(e.css(\"left\")), top: parseFloat(e.css(\"top\")) });\n      });\n    }, resize: function resize(e, i) {\n      var s = t(this).resizable(\"instance\"),\n          n = s.options,\n          o = s.originalSize,\n          a = s.originalPosition,\n          r = { height: s.size.height - o.height || 0, width: s.size.width - o.width || 0, top: s.position.top - a.top || 0, left: s.position.left - a.left || 0 };t(n.alsoResize).each(function () {\n        var e = t(this),\n            s = t(this).data(\"ui-resizable-alsoresize\"),\n            n = {},\n            o = e.parents(i.originalElement[0]).length ? [\"width\", \"height\"] : [\"width\", \"height\", \"top\", \"left\"];t.each(o, function (t, e) {\n          var i = (s[e] || 0) + (r[e] || 0);i && i >= 0 && (n[e] = i || null);\n        }), e.css(n);\n      });\n    }, stop: function stop() {\n      t(this).removeData(\"ui-resizable-alsoresize\");\n    } }), t.ui.plugin.add(\"resizable\", \"ghost\", { start: function start() {\n      var e = t(this).resizable(\"instance\"),\n          i = e.size;e.ghost = e.originalElement.clone(), e.ghost.css({ opacity: .25, display: \"block\", position: \"relative\", height: i.height, width: i.width, margin: 0, left: 0, top: 0 }), e._addClass(e.ghost, \"ui-resizable-ghost\"), t.uiBackCompat !== !1 && \"string\" == typeof e.options.ghost && e.ghost.addClass(this.options.ghost), e.ghost.appendTo(e.helper);\n    }, resize: function resize() {\n      var e = t(this).resizable(\"instance\");e.ghost && e.ghost.css({ position: \"relative\", height: e.size.height, width: e.size.width });\n    }, stop: function stop() {\n      var e = t(this).resizable(\"instance\");e.ghost && e.helper && e.helper.get(0).removeChild(e.ghost.get(0));\n    } }), t.ui.plugin.add(\"resizable\", \"grid\", { resize: function resize() {\n      var e,\n          i = t(this).resizable(\"instance\"),\n          s = i.options,\n          n = i.size,\n          o = i.originalSize,\n          a = i.originalPosition,\n          r = i.axis,\n          h = \"number\" == typeof s.grid ? [s.grid, s.grid] : s.grid,\n          l = h[0] || 1,\n          c = h[1] || 1,\n          u = Math.round((n.width - o.width) / l) * l,\n          d = Math.round((n.height - o.height) / c) * c,\n          p = o.width + u,\n          f = o.height + d,\n          g = s.maxWidth && p > s.maxWidth,\n          m = s.maxHeight && f > s.maxHeight,\n          _ = s.minWidth && s.minWidth > p,\n          v = s.minHeight && s.minHeight > f;s.grid = h, _ && (p += l), v && (f += c), g && (p -= l), m && (f -= c), /^(se|s|e)$/.test(r) ? (i.size.width = p, i.size.height = f) : /^(ne)$/.test(r) ? (i.size.width = p, i.size.height = f, i.position.top = a.top - d) : /^(sw)$/.test(r) ? (i.size.width = p, i.size.height = f, i.position.left = a.left - u) : ((0 >= f - c || 0 >= p - l) && (e = i._getPaddingPlusBorderDimensions(this)), f - c > 0 ? (i.size.height = f, i.position.top = a.top - d) : (f = c - e.height, i.size.height = f, i.position.top = a.top + o.height - f), p - l > 0 ? (i.size.width = p, i.position.left = a.left - u) : (p = l - e.width, i.size.width = p, i.position.left = a.left + o.width - p));\n    } }), t.ui.resizable, t.widget(\"ui.dialog\", { version: \"1.12.1\", options: { appendTo: \"body\", autoOpen: !0, buttons: [], classes: { \"ui-dialog\": \"ui-corner-all\", \"ui-dialog-titlebar\": \"ui-corner-all\" }, closeOnEscape: !0, closeText: \"Close\", draggable: !0, hide: null, height: \"auto\", maxHeight: null, maxWidth: null, minHeight: 150, minWidth: 150, modal: !1, position: { my: \"center\", at: \"center\", of: window, collision: \"fit\", using: function using(e) {\n          var i = t(this).css(e).offset().top;0 > i && t(this).css(\"top\", e.top - i);\n        } }, resizable: !0, show: null, title: null, width: 300, beforeClose: null, close: null, drag: null, dragStart: null, dragStop: null, focus: null, open: null, resize: null, resizeStart: null, resizeStop: null }, sizeRelatedOptions: { buttons: !0, height: !0, maxHeight: !0, maxWidth: !0, minHeight: !0, minWidth: !0, width: !0 }, resizableRelatedOptions: { maxHeight: !0, maxWidth: !0, minHeight: !0, minWidth: !0 }, _create: function _create() {\n      this.originalCss = { display: this.element[0].style.display, width: this.element[0].style.width, minHeight: this.element[0].style.minHeight, maxHeight: this.element[0].style.maxHeight, height: this.element[0].style.height }, this.originalPosition = { parent: this.element.parent(), index: this.element.parent().children().index(this.element) }, this.originalTitle = this.element.attr(\"title\"), null == this.options.title && null != this.originalTitle && (this.options.title = this.originalTitle), this.options.disabled && (this.options.disabled = !1), this._createWrapper(), this.element.show().removeAttr(\"title\").appendTo(this.uiDialog), this._addClass(\"ui-dialog-content\", \"ui-widget-content\"), this._createTitlebar(), this._createButtonPane(), this.options.draggable && t.fn.draggable && this._makeDraggable(), this.options.resizable && t.fn.resizable && this._makeResizable(), this._isOpen = !1, this._trackFocus();\n    }, _init: function _init() {\n      this.options.autoOpen && this.open();\n    }, _appendTo: function _appendTo() {\n      var e = this.options.appendTo;return e && (e.jquery || e.nodeType) ? t(e) : this.document.find(e || \"body\").eq(0);\n    }, _destroy: function _destroy() {\n      var t,\n          e = this.originalPosition;this._untrackInstance(), this._destroyOverlay(), this.element.removeUniqueId().css(this.originalCss).detach(), this.uiDialog.remove(), this.originalTitle && this.element.attr(\"title\", this.originalTitle), t = e.parent.children().eq(e.index), t.length && t[0] !== this.element[0] ? t.before(this.element) : e.parent.append(this.element);\n    }, widget: function widget() {\n      return this.uiDialog;\n    }, disable: t.noop, enable: t.noop, close: function close(e) {\n      var i = this;this._isOpen && this._trigger(\"beforeClose\", e) !== !1 && (this._isOpen = !1, this._focusedElement = null, this._destroyOverlay(), this._untrackInstance(), this.opener.filter(\":focusable\").trigger(\"focus\").length || t.ui.safeBlur(t.ui.safeActiveElement(this.document[0])), this._hide(this.uiDialog, this.options.hide, function () {\n        i._trigger(\"close\", e);\n      }));\n    }, isOpen: function isOpen() {\n      return this._isOpen;\n    }, moveToTop: function moveToTop() {\n      this._moveToTop();\n    }, _moveToTop: function _moveToTop(e, i) {\n      var s = !1,\n          n = this.uiDialog.siblings(\".ui-front:visible\").map(function () {\n        return +t(this).css(\"z-index\");\n      }).get(),\n          o = Math.max.apply(null, n);return o >= +this.uiDialog.css(\"z-index\") && (this.uiDialog.css(\"z-index\", o + 1), s = !0), s && !i && this._trigger(\"focus\", e), s;\n    }, open: function open() {\n      var e = this;return this._isOpen ? (this._moveToTop() && this._focusTabbable(), void 0) : (this._isOpen = !0, this.opener = t(t.ui.safeActiveElement(this.document[0])), this._size(), this._position(), this._createOverlay(), this._moveToTop(null, !0), this.overlay && this.overlay.css(\"z-index\", this.uiDialog.css(\"z-index\") - 1), this._show(this.uiDialog, this.options.show, function () {\n        e._focusTabbable(), e._trigger(\"focus\");\n      }), this._makeFocusTarget(), this._trigger(\"open\"), void 0);\n    }, _focusTabbable: function _focusTabbable() {\n      var t = this._focusedElement;t || (t = this.element.find(\"[autofocus]\")), t.length || (t = this.element.find(\":tabbable\")), t.length || (t = this.uiDialogButtonPane.find(\":tabbable\")), t.length || (t = this.uiDialogTitlebarClose.filter(\":tabbable\")), t.length || (t = this.uiDialog), t.eq(0).trigger(\"focus\");\n    }, _keepFocus: function _keepFocus(e) {\n      function i() {\n        var e = t.ui.safeActiveElement(this.document[0]),\n            i = this.uiDialog[0] === e || t.contains(this.uiDialog[0], e);i || this._focusTabbable();\n      }e.preventDefault(), i.call(this), this._delay(i);\n    }, _createWrapper: function _createWrapper() {\n      this.uiDialog = t(\"<div>\").hide().attr({ tabIndex: -1, role: \"dialog\" }).appendTo(this._appendTo()), this._addClass(this.uiDialog, \"ui-dialog\", \"ui-widget ui-widget-content ui-front\"), this._on(this.uiDialog, { keydown: function keydown(e) {\n          if (this.options.closeOnEscape && !e.isDefaultPrevented() && e.keyCode && e.keyCode === t.ui.keyCode.ESCAPE) return e.preventDefault(), this.close(e), void 0;if (e.keyCode === t.ui.keyCode.TAB && !e.isDefaultPrevented()) {\n            var i = this.uiDialog.find(\":tabbable\"),\n                s = i.filter(\":first\"),\n                n = i.filter(\":last\");e.target !== n[0] && e.target !== this.uiDialog[0] || e.shiftKey ? e.target !== s[0] && e.target !== this.uiDialog[0] || !e.shiftKey || (this._delay(function () {\n              n.trigger(\"focus\");\n            }), e.preventDefault()) : (this._delay(function () {\n              s.trigger(\"focus\");\n            }), e.preventDefault());\n          }\n        }, mousedown: function mousedown(t) {\n          this._moveToTop(t) && this._focusTabbable();\n        } }), this.element.find(\"[aria-describedby]\").length || this.uiDialog.attr({ \"aria-describedby\": this.element.uniqueId().attr(\"id\") });\n    }, _createTitlebar: function _createTitlebar() {\n      var e;this.uiDialogTitlebar = t(\"<div>\"), this._addClass(this.uiDialogTitlebar, \"ui-dialog-titlebar\", \"ui-widget-header ui-helper-clearfix\"), this._on(this.uiDialogTitlebar, { mousedown: function mousedown(e) {\n          t(e.target).closest(\".ui-dialog-titlebar-close\") || this.uiDialog.trigger(\"focus\");\n        } }), this.uiDialogTitlebarClose = t(\"<button type='button'></button>\").button({ label: t(\"<a>\").text(this.options.closeText).html(), icon: \"ui-icon-closethick\", showLabel: !1 }).appendTo(this.uiDialogTitlebar), this._addClass(this.uiDialogTitlebarClose, \"ui-dialog-titlebar-close\"), this._on(this.uiDialogTitlebarClose, { click: function click(t) {\n          t.preventDefault(), this.close(t);\n        } }), e = t(\"<span>\").uniqueId().prependTo(this.uiDialogTitlebar), this._addClass(e, \"ui-dialog-title\"), this._title(e), this.uiDialogTitlebar.prependTo(this.uiDialog), this.uiDialog.attr({ \"aria-labelledby\": e.attr(\"id\") });\n    }, _title: function _title(t) {\n      this.options.title ? t.text(this.options.title) : t.html(\"&#160;\");\n    }, _createButtonPane: function _createButtonPane() {\n      this.uiDialogButtonPane = t(\"<div>\"), this._addClass(this.uiDialogButtonPane, \"ui-dialog-buttonpane\", \"ui-widget-content ui-helper-clearfix\"), this.uiButtonSet = t(\"<div>\").appendTo(this.uiDialogButtonPane), this._addClass(this.uiButtonSet, \"ui-dialog-buttonset\"), this._createButtons();\n    }, _createButtons: function _createButtons() {\n      var e = this,\n          i = this.options.buttons;return this.uiDialogButtonPane.remove(), this.uiButtonSet.empty(), t.isEmptyObject(i) || t.isArray(i) && !i.length ? (this._removeClass(this.uiDialog, \"ui-dialog-buttons\"), void 0) : (t.each(i, function (i, s) {\n        var n, o;s = t.isFunction(s) ? { click: s, text: i } : s, s = t.extend({ type: \"button\" }, s), n = s.click, o = { icon: s.icon, iconPosition: s.iconPosition, showLabel: s.showLabel, icons: s.icons, text: s.text }, delete s.click, delete s.icon, delete s.iconPosition, delete s.showLabel, delete s.icons, \"boolean\" == typeof s.text && delete s.text, t(\"<button></button>\", s).button(o).appendTo(e.uiButtonSet).on(\"click\", function () {\n          n.apply(e.element[0], arguments);\n        });\n      }), this._addClass(this.uiDialog, \"ui-dialog-buttons\"), this.uiDialogButtonPane.appendTo(this.uiDialog), void 0);\n    }, _makeDraggable: function _makeDraggable() {\n      function e(t) {\n        return { position: t.position, offset: t.offset };\n      }var i = this,\n          s = this.options;this.uiDialog.draggable({ cancel: \".ui-dialog-content, .ui-dialog-titlebar-close\", handle: \".ui-dialog-titlebar\", containment: \"document\", start: function start(s, n) {\n          i._addClass(t(this), \"ui-dialog-dragging\"), i._blockFrames(), i._trigger(\"dragStart\", s, e(n));\n        }, drag: function drag(t, s) {\n          i._trigger(\"drag\", t, e(s));\n        }, stop: function stop(n, o) {\n          var a = o.offset.left - i.document.scrollLeft(),\n              r = o.offset.top - i.document.scrollTop();s.position = { my: \"left top\", at: \"left\" + (a >= 0 ? \"+\" : \"\") + a + \" \" + \"top\" + (r >= 0 ? \"+\" : \"\") + r, of: i.window }, i._removeClass(t(this), \"ui-dialog-dragging\"), i._unblockFrames(), i._trigger(\"dragStop\", n, e(o));\n        } });\n    }, _makeResizable: function _makeResizable() {\n      function e(t) {\n        return { originalPosition: t.originalPosition, originalSize: t.originalSize, position: t.position, size: t.size };\n      }var i = this,\n          s = this.options,\n          n = s.resizable,\n          o = this.uiDialog.css(\"position\"),\n          a = \"string\" == typeof n ? n : \"n,e,s,w,se,sw,ne,nw\";this.uiDialog.resizable({ cancel: \".ui-dialog-content\", containment: \"document\", alsoResize: this.element, maxWidth: s.maxWidth, maxHeight: s.maxHeight, minWidth: s.minWidth, minHeight: this._minHeight(), handles: a, start: function start(s, n) {\n          i._addClass(t(this), \"ui-dialog-resizing\"), i._blockFrames(), i._trigger(\"resizeStart\", s, e(n));\n        }, resize: function resize(t, s) {\n          i._trigger(\"resize\", t, e(s));\n        }, stop: function stop(n, o) {\n          var a = i.uiDialog.offset(),\n              r = a.left - i.document.scrollLeft(),\n              h = a.top - i.document.scrollTop();s.height = i.uiDialog.height(), s.width = i.uiDialog.width(), s.position = { my: \"left top\", at: \"left\" + (r >= 0 ? \"+\" : \"\") + r + \" \" + \"top\" + (h >= 0 ? \"+\" : \"\") + h, of: i.window }, i._removeClass(t(this), \"ui-dialog-resizing\"), i._unblockFrames(), i._trigger(\"resizeStop\", n, e(o));\n        } }).css(\"position\", o);\n    }, _trackFocus: function _trackFocus() {\n      this._on(this.widget(), { focusin: function focusin(e) {\n          this._makeFocusTarget(), this._focusedElement = t(e.target);\n        } });\n    }, _makeFocusTarget: function _makeFocusTarget() {\n      this._untrackInstance(), this._trackingInstances().unshift(this);\n    }, _untrackInstance: function _untrackInstance() {\n      var e = this._trackingInstances(),\n          i = t.inArray(this, e);-1 !== i && e.splice(i, 1);\n    }, _trackingInstances: function _trackingInstances() {\n      var t = this.document.data(\"ui-dialog-instances\");return t || (t = [], this.document.data(\"ui-dialog-instances\", t)), t;\n    }, _minHeight: function _minHeight() {\n      var t = this.options;return \"auto\" === t.height ? t.minHeight : Math.min(t.minHeight, t.height);\n    }, _position: function _position() {\n      var t = this.uiDialog.is(\":visible\");t || this.uiDialog.show(), this.uiDialog.position(this.options.position), t || this.uiDialog.hide();\n    }, _setOptions: function _setOptions(e) {\n      var i = this,\n          s = !1,\n          n = {};t.each(e, function (t, e) {\n        i._setOption(t, e), t in i.sizeRelatedOptions && (s = !0), t in i.resizableRelatedOptions && (n[t] = e);\n      }), s && (this._size(), this._position()), this.uiDialog.is(\":data(ui-resizable)\") && this.uiDialog.resizable(\"option\", n);\n    }, _setOption: function _setOption(e, i) {\n      var s,\n          n,\n          o = this.uiDialog;\"disabled\" !== e && (this._super(e, i), \"appendTo\" === e && this.uiDialog.appendTo(this._appendTo()), \"buttons\" === e && this._createButtons(), \"closeText\" === e && this.uiDialogTitlebarClose.button({ label: t(\"<a>\").text(\"\" + this.options.closeText).html() }), \"draggable\" === e && (s = o.is(\":data(ui-draggable)\"), s && !i && o.draggable(\"destroy\"), !s && i && this._makeDraggable()), \"position\" === e && this._position(), \"resizable\" === e && (n = o.is(\":data(ui-resizable)\"), n && !i && o.resizable(\"destroy\"), n && \"string\" == typeof i && o.resizable(\"option\", \"handles\", i), n || i === !1 || this._makeResizable()), \"title\" === e && this._title(this.uiDialogTitlebar.find(\".ui-dialog-title\")));\n    }, _size: function _size() {\n      var t,\n          e,\n          i,\n          s = this.options;this.element.show().css({ width: \"auto\", minHeight: 0, maxHeight: \"none\", height: 0 }), s.minWidth > s.width && (s.width = s.minWidth), t = this.uiDialog.css({ height: \"auto\", width: s.width }).outerHeight(), e = Math.max(0, s.minHeight - t), i = \"number\" == typeof s.maxHeight ? Math.max(0, s.maxHeight - t) : \"none\", \"auto\" === s.height ? this.element.css({ minHeight: e, maxHeight: i, height: \"auto\" }) : this.element.height(Math.max(0, s.height - t)), this.uiDialog.is(\":data(ui-resizable)\") && this.uiDialog.resizable(\"option\", \"minHeight\", this._minHeight());\n    }, _blockFrames: function _blockFrames() {\n      this.iframeBlocks = this.document.find(\"iframe\").map(function () {\n        var e = t(this);return t(\"<div>\").css({ position: \"absolute\", width: e.outerWidth(), height: e.outerHeight() }).appendTo(e.parent()).offset(e.offset())[0];\n      });\n    }, _unblockFrames: function _unblockFrames() {\n      this.iframeBlocks && (this.iframeBlocks.remove(), delete this.iframeBlocks);\n    }, _allowInteraction: function _allowInteraction(e) {\n      return t(e.target).closest(\".ui-dialog\").length ? !0 : !!t(e.target).closest(\".ui-datepicker\").length;\n    }, _createOverlay: function _createOverlay() {\n      if (this.options.modal) {\n        var e = !0;this._delay(function () {\n          e = !1;\n        }), this.document.data(\"ui-dialog-overlays\") || this._on(this.document, { focusin: function focusin(t) {\n            e || this._allowInteraction(t) || (t.preventDefault(), this._trackingInstances()[0]._focusTabbable());\n          } }), this.overlay = t(\"<div>\").appendTo(this._appendTo()), this._addClass(this.overlay, null, \"ui-widget-overlay ui-front\"), this._on(this.overlay, { mousedown: \"_keepFocus\" }), this.document.data(\"ui-dialog-overlays\", (this.document.data(\"ui-dialog-overlays\") || 0) + 1);\n      }\n    }, _destroyOverlay: function _destroyOverlay() {\n      if (this.options.modal && this.overlay) {\n        var t = this.document.data(\"ui-dialog-overlays\") - 1;t ? this.document.data(\"ui-dialog-overlays\", t) : (this._off(this.document, \"focusin\"), this.document.removeData(\"ui-dialog-overlays\")), this.overlay.remove(), this.overlay = null;\n      }\n    } }), t.uiBackCompat !== !1 && t.widget(\"ui.dialog\", t.ui.dialog, { options: { dialogClass: \"\" }, _createWrapper: function _createWrapper() {\n      this._super(), this.uiDialog.addClass(this.options.dialogClass);\n    }, _setOption: function _setOption(t, e) {\n      \"dialogClass\" === t && this.uiDialog.removeClass(this.options.dialogClass).addClass(e), this._superApply(arguments);\n    } }), t.ui.dialog, t.widget(\"ui.droppable\", { version: \"1.12.1\", widgetEventPrefix: \"drop\", options: { accept: \"*\", addClasses: !0, greedy: !1, scope: \"default\", tolerance: \"intersect\", activate: null, deactivate: null, drop: null, out: null, over: null }, _create: function _create() {\n      var e,\n          i = this.options,\n          s = i.accept;this.isover = !1, this.isout = !0, this.accept = t.isFunction(s) ? s : function (t) {\n        return t.is(s);\n      }, this.proportions = function () {\n        return arguments.length ? (e = arguments[0], void 0) : e ? e : e = { width: this.element[0].offsetWidth, height: this.element[0].offsetHeight };\n      }, this._addToManager(i.scope), i.addClasses && this._addClass(\"ui-droppable\");\n    }, _addToManager: function _addToManager(e) {\n      t.ui.ddmanager.droppables[e] = t.ui.ddmanager.droppables[e] || [], t.ui.ddmanager.droppables[e].push(this);\n    }, _splice: function _splice(t) {\n      for (var e = 0; t.length > e; e++) {\n        t[e] === this && t.splice(e, 1);\n      }\n    }, _destroy: function _destroy() {\n      var e = t.ui.ddmanager.droppables[this.options.scope];this._splice(e);\n    }, _setOption: function _setOption(e, i) {\n      if (\"accept\" === e) this.accept = t.isFunction(i) ? i : function (t) {\n        return t.is(i);\n      };else if (\"scope\" === e) {\n        var s = t.ui.ddmanager.droppables[this.options.scope];this._splice(s), this._addToManager(i);\n      }this._super(e, i);\n    }, _activate: function _activate(e) {\n      var i = t.ui.ddmanager.current;this._addActiveClass(), i && this._trigger(\"activate\", e, this.ui(i));\n    }, _deactivate: function _deactivate(e) {\n      var i = t.ui.ddmanager.current;this._removeActiveClass(), i && this._trigger(\"deactivate\", e, this.ui(i));\n    }, _over: function _over(e) {\n      var i = t.ui.ddmanager.current;i && (i.currentItem || i.element)[0] !== this.element[0] && this.accept.call(this.element[0], i.currentItem || i.element) && (this._addHoverClass(), this._trigger(\"over\", e, this.ui(i)));\n    }, _out: function _out(e) {\n      var i = t.ui.ddmanager.current;i && (i.currentItem || i.element)[0] !== this.element[0] && this.accept.call(this.element[0], i.currentItem || i.element) && (this._removeHoverClass(), this._trigger(\"out\", e, this.ui(i)));\n    }, _drop: function _drop(e, i) {\n      var s = i || t.ui.ddmanager.current,\n          n = !1;return s && (s.currentItem || s.element)[0] !== this.element[0] ? (this.element.find(\":data(ui-droppable)\").not(\".ui-draggable-dragging\").each(function () {\n        var i = t(this).droppable(\"instance\");return i.options.greedy && !i.options.disabled && i.options.scope === s.options.scope && i.accept.call(i.element[0], s.currentItem || s.element) && v(s, t.extend(i, { offset: i.element.offset() }), i.options.tolerance, e) ? (n = !0, !1) : void 0;\n      }), n ? !1 : this.accept.call(this.element[0], s.currentItem || s.element) ? (this._removeActiveClass(), this._removeHoverClass(), this._trigger(\"drop\", e, this.ui(s)), this.element) : !1) : !1;\n    }, ui: function ui(t) {\n      return { draggable: t.currentItem || t.element, helper: t.helper, position: t.position, offset: t.positionAbs };\n    }, _addHoverClass: function _addHoverClass() {\n      this._addClass(\"ui-droppable-hover\");\n    }, _removeHoverClass: function _removeHoverClass() {\n      this._removeClass(\"ui-droppable-hover\");\n    }, _addActiveClass: function _addActiveClass() {\n      this._addClass(\"ui-droppable-active\");\n    }, _removeActiveClass: function _removeActiveClass() {\n      this._removeClass(\"ui-droppable-active\");\n    } });var v = t.ui.intersect = function () {\n    function t(t, e, i) {\n      return t >= e && e + i > t;\n    }return function (e, i, s, n) {\n      if (!i.offset) return !1;var o = (e.positionAbs || e.position.absolute).left + e.margins.left,\n          a = (e.positionAbs || e.position.absolute).top + e.margins.top,\n          r = o + e.helperProportions.width,\n          h = a + e.helperProportions.height,\n          l = i.offset.left,\n          c = i.offset.top,\n          u = l + i.proportions().width,\n          d = c + i.proportions().height;switch (s) {case \"fit\":\n          return o >= l && u >= r && a >= c && d >= h;case \"intersect\":\n          return o + e.helperProportions.width / 2 > l && u > r - e.helperProportions.width / 2 && a + e.helperProportions.height / 2 > c && d > h - e.helperProportions.height / 2;case \"pointer\":\n          return t(n.pageY, c, i.proportions().height) && t(n.pageX, l, i.proportions().width);case \"touch\":\n          return (a >= c && d >= a || h >= c && d >= h || c > a && h > d) && (o >= l && u >= o || r >= l && u >= r || l > o && r > u);default:\n          return !1;}\n    };\n  }();t.ui.ddmanager = { current: null, droppables: { \"default\": [] }, prepareOffsets: function prepareOffsets(e, i) {\n      var s,\n          n,\n          o = t.ui.ddmanager.droppables[e.options.scope] || [],\n          a = i ? i.type : null,\n          r = (e.currentItem || e.element).find(\":data(ui-droppable)\").addBack();t: for (s = 0; o.length > s; s++) {\n        if (!(o[s].options.disabled || e && !o[s].accept.call(o[s].element[0], e.currentItem || e.element))) {\n          for (n = 0; r.length > n; n++) {\n            if (r[n] === o[s].element[0]) {\n              o[s].proportions().height = 0;continue t;\n            }\n          }o[s].visible = \"none\" !== o[s].element.css(\"display\"), o[s].visible && (\"mousedown\" === a && o[s]._activate.call(o[s], i), o[s].offset = o[s].element.offset(), o[s].proportions({ width: o[s].element[0].offsetWidth, height: o[s].element[0].offsetHeight }));\n        }\n      }\n    }, drop: function drop(e, i) {\n      var s = !1;return t.each((t.ui.ddmanager.droppables[e.options.scope] || []).slice(), function () {\n        this.options && (!this.options.disabled && this.visible && v(e, this, this.options.tolerance, i) && (s = this._drop.call(this, i) || s), !this.options.disabled && this.visible && this.accept.call(this.element[0], e.currentItem || e.element) && (this.isout = !0, this.isover = !1, this._deactivate.call(this, i)));\n      }), s;\n    }, dragStart: function dragStart(e, i) {\n      e.element.parentsUntil(\"body\").on(\"scroll.droppable\", function () {\n        e.options.refreshPositions || t.ui.ddmanager.prepareOffsets(e, i);\n      });\n    }, drag: function drag(e, i) {\n      e.options.refreshPositions && t.ui.ddmanager.prepareOffsets(e, i), t.each(t.ui.ddmanager.droppables[e.options.scope] || [], function () {\n        if (!this.options.disabled && !this.greedyChild && this.visible) {\n          var s,\n              n,\n              o,\n              a = v(e, this, this.options.tolerance, i),\n              r = !a && this.isover ? \"isout\" : a && !this.isover ? \"isover\" : null;r && (this.options.greedy && (n = this.options.scope, o = this.element.parents(\":data(ui-droppable)\").filter(function () {\n            return t(this).droppable(\"instance\").options.scope === n;\n          }), o.length && (s = t(o[0]).droppable(\"instance\"), s.greedyChild = \"isover\" === r)), s && \"isover\" === r && (s.isover = !1, s.isout = !0, s._out.call(s, i)), this[r] = !0, this[\"isout\" === r ? \"isover\" : \"isout\"] = !1, this[\"isover\" === r ? \"_over\" : \"_out\"].call(this, i), s && \"isout\" === r && (s.isout = !1, s.isover = !0, s._over.call(s, i)));\n        }\n      });\n    }, dragStop: function dragStop(e, i) {\n      e.element.parentsUntil(\"body\").off(\"scroll.droppable\"), e.options.refreshPositions || t.ui.ddmanager.prepareOffsets(e, i);\n    } }, t.uiBackCompat !== !1 && t.widget(\"ui.droppable\", t.ui.droppable, { options: { hoverClass: !1, activeClass: !1 }, _addActiveClass: function _addActiveClass() {\n      this._super(), this.options.activeClass && this.element.addClass(this.options.activeClass);\n    }, _removeActiveClass: function _removeActiveClass() {\n      this._super(), this.options.activeClass && this.element.removeClass(this.options.activeClass);\n    }, _addHoverClass: function _addHoverClass() {\n      this._super(), this.options.hoverClass && this.element.addClass(this.options.hoverClass);\n    }, _removeHoverClass: function _removeHoverClass() {\n      this._super(), this.options.hoverClass && this.element.removeClass(this.options.hoverClass);\n    } }), t.ui.droppable, t.widget(\"ui.progressbar\", { version: \"1.12.1\", options: { classes: { \"ui-progressbar\": \"ui-corner-all\", \"ui-progressbar-value\": \"ui-corner-left\", \"ui-progressbar-complete\": \"ui-corner-right\" }, max: 100, value: 0, change: null, complete: null }, min: 0, _create: function _create() {\n      this.oldValue = this.options.value = this._constrainedValue(), this.element.attr({ role: \"progressbar\", \"aria-valuemin\": this.min }), this._addClass(\"ui-progressbar\", \"ui-widget ui-widget-content\"), this.valueDiv = t(\"<div>\").appendTo(this.element), this._addClass(this.valueDiv, \"ui-progressbar-value\", \"ui-widget-header\"), this._refreshValue();\n    }, _destroy: function _destroy() {\n      this.element.removeAttr(\"role aria-valuemin aria-valuemax aria-valuenow\"), this.valueDiv.remove();\n    }, value: function value(t) {\n      return void 0 === t ? this.options.value : (this.options.value = this._constrainedValue(t), this._refreshValue(), void 0);\n    }, _constrainedValue: function _constrainedValue(t) {\n      return void 0 === t && (t = this.options.value), this.indeterminate = t === !1, \"number\" != typeof t && (t = 0), this.indeterminate ? !1 : Math.min(this.options.max, Math.max(this.min, t));\n    }, _setOptions: function _setOptions(t) {\n      var e = t.value;delete t.value, this._super(t), this.options.value = this._constrainedValue(e), this._refreshValue();\n    }, _setOption: function _setOption(t, e) {\n      \"max\" === t && (e = Math.max(this.min, e)), this._super(t, e);\n    }, _setOptionDisabled: function _setOptionDisabled(t) {\n      this._super(t), this.element.attr(\"aria-disabled\", t), this._toggleClass(null, \"ui-state-disabled\", !!t);\n    }, _percentage: function _percentage() {\n      return this.indeterminate ? 100 : 100 * (this.options.value - this.min) / (this.options.max - this.min);\n    }, _refreshValue: function _refreshValue() {\n      var e = this.options.value,\n          i = this._percentage();this.valueDiv.toggle(this.indeterminate || e > this.min).width(i.toFixed(0) + \"%\"), this._toggleClass(this.valueDiv, \"ui-progressbar-complete\", null, e === this.options.max)._toggleClass(\"ui-progressbar-indeterminate\", null, this.indeterminate), this.indeterminate ? (this.element.removeAttr(\"aria-valuenow\"), this.overlayDiv || (this.overlayDiv = t(\"<div>\").appendTo(this.valueDiv), this._addClass(this.overlayDiv, \"ui-progressbar-overlay\"))) : (this.element.attr({ \"aria-valuemax\": this.options.max, \"aria-valuenow\": e }), this.overlayDiv && (this.overlayDiv.remove(), this.overlayDiv = null)), this.oldValue !== e && (this.oldValue = e, this._trigger(\"change\")), e === this.options.max && this._trigger(\"complete\");\n    } }), t.widget(\"ui.selectable\", t.ui.mouse, { version: \"1.12.1\", options: { appendTo: \"body\", autoRefresh: !0, distance: 0, filter: \"*\", tolerance: \"touch\", selected: null, selecting: null, start: null, stop: null, unselected: null, unselecting: null }, _create: function _create() {\n      var e = this;this._addClass(\"ui-selectable\"), this.dragged = !1, this.refresh = function () {\n        e.elementPos = t(e.element[0]).offset(), e.selectees = t(e.options.filter, e.element[0]), e._addClass(e.selectees, \"ui-selectee\"), e.selectees.each(function () {\n          var i = t(this),\n              s = i.offset(),\n              n = { left: s.left - e.elementPos.left, top: s.top - e.elementPos.top };t.data(this, \"selectable-item\", { element: this, $element: i, left: n.left, top: n.top, right: n.left + i.outerWidth(), bottom: n.top + i.outerHeight(), startselected: !1, selected: i.hasClass(\"ui-selected\"), selecting: i.hasClass(\"ui-selecting\"), unselecting: i.hasClass(\"ui-unselecting\") });\n        });\n      }, this.refresh(), this._mouseInit(), this.helper = t(\"<div>\"), this._addClass(this.helper, \"ui-selectable-helper\");\n    }, _destroy: function _destroy() {\n      this.selectees.removeData(\"selectable-item\"), this._mouseDestroy();\n    }, _mouseStart: function _mouseStart(e) {\n      var i = this,\n          s = this.options;this.opos = [e.pageX, e.pageY], this.elementPos = t(this.element[0]).offset(), this.options.disabled || (this.selectees = t(s.filter, this.element[0]), this._trigger(\"start\", e), t(s.appendTo).append(this.helper), this.helper.css({ left: e.pageX, top: e.pageY, width: 0, height: 0 }), s.autoRefresh && this.refresh(), this.selectees.filter(\".ui-selected\").each(function () {\n        var s = t.data(this, \"selectable-item\");s.startselected = !0, e.metaKey || e.ctrlKey || (i._removeClass(s.$element, \"ui-selected\"), s.selected = !1, i._addClass(s.$element, \"ui-unselecting\"), s.unselecting = !0, i._trigger(\"unselecting\", e, { unselecting: s.element }));\n      }), t(e.target).parents().addBack().each(function () {\n        var s,\n            n = t.data(this, \"selectable-item\");return n ? (s = !e.metaKey && !e.ctrlKey || !n.$element.hasClass(\"ui-selected\"), i._removeClass(n.$element, s ? \"ui-unselecting\" : \"ui-selected\")._addClass(n.$element, s ? \"ui-selecting\" : \"ui-unselecting\"), n.unselecting = !s, n.selecting = s, n.selected = s, s ? i._trigger(\"selecting\", e, { selecting: n.element }) : i._trigger(\"unselecting\", e, { unselecting: n.element }), !1) : void 0;\n      }));\n    }, _mouseDrag: function _mouseDrag(e) {\n      if (this.dragged = !0, !this.options.disabled) {\n        var i,\n            s = this,\n            n = this.options,\n            o = this.opos[0],\n            a = this.opos[1],\n            r = e.pageX,\n            h = e.pageY;return o > r && (i = r, r = o, o = i), a > h && (i = h, h = a, a = i), this.helper.css({ left: o, top: a, width: r - o, height: h - a }), this.selectees.each(function () {\n          var i = t.data(this, \"selectable-item\"),\n              l = !1,\n              c = {};i && i.element !== s.element[0] && (c.left = i.left + s.elementPos.left, c.right = i.right + s.elementPos.left, c.top = i.top + s.elementPos.top, c.bottom = i.bottom + s.elementPos.top, \"touch\" === n.tolerance ? l = !(c.left > r || o > c.right || c.top > h || a > c.bottom) : \"fit\" === n.tolerance && (l = c.left > o && r > c.right && c.top > a && h > c.bottom), l ? (i.selected && (s._removeClass(i.$element, \"ui-selected\"), i.selected = !1), i.unselecting && (s._removeClass(i.$element, \"ui-unselecting\"), i.unselecting = !1), i.selecting || (s._addClass(i.$element, \"ui-selecting\"), i.selecting = !0, s._trigger(\"selecting\", e, { selecting: i.element }))) : (i.selecting && ((e.metaKey || e.ctrlKey) && i.startselected ? (s._removeClass(i.$element, \"ui-selecting\"), i.selecting = !1, s._addClass(i.$element, \"ui-selected\"), i.selected = !0) : (s._removeClass(i.$element, \"ui-selecting\"), i.selecting = !1, i.startselected && (s._addClass(i.$element, \"ui-unselecting\"), i.unselecting = !0), s._trigger(\"unselecting\", e, { unselecting: i.element }))), i.selected && (e.metaKey || e.ctrlKey || i.startselected || (s._removeClass(i.$element, \"ui-selected\"), i.selected = !1, s._addClass(i.$element, \"ui-unselecting\"), i.unselecting = !0, s._trigger(\"unselecting\", e, { unselecting: i.element })))));\n        }), !1;\n      }\n    }, _mouseStop: function _mouseStop(e) {\n      var i = this;return this.dragged = !1, t(\".ui-unselecting\", this.element[0]).each(function () {\n        var s = t.data(this, \"selectable-item\");i._removeClass(s.$element, \"ui-unselecting\"), s.unselecting = !1, s.startselected = !1, i._trigger(\"unselected\", e, { unselected: s.element });\n      }), t(\".ui-selecting\", this.element[0]).each(function () {\n        var s = t.data(this, \"selectable-item\");i._removeClass(s.$element, \"ui-selecting\")._addClass(s.$element, \"ui-selected\"), s.selecting = !1, s.selected = !0, s.startselected = !0, i._trigger(\"selected\", e, { selected: s.element });\n      }), this._trigger(\"stop\", e), this.helper.remove(), !1;\n    } }), t.widget(\"ui.selectmenu\", [t.ui.formResetMixin, { version: \"1.12.1\", defaultElement: \"<select>\", options: { appendTo: null, classes: { \"ui-selectmenu-button-open\": \"ui-corner-top\", \"ui-selectmenu-button-closed\": \"ui-corner-all\" }, disabled: null, icons: { button: \"ui-icon-triangle-1-s\" }, position: { my: \"left top\", at: \"left bottom\", collision: \"none\" }, width: !1, change: null, close: null, focus: null, open: null, select: null }, _create: function _create() {\n      var e = this.element.uniqueId().attr(\"id\");this.ids = { element: e, button: e + \"-button\", menu: e + \"-menu\" }, this._drawButton(), this._drawMenu(), this._bindFormResetHandler(), this._rendered = !1, this.menuItems = t();\n    }, _drawButton: function _drawButton() {\n      var e,\n          i = this,\n          s = this._parseOption(this.element.find(\"option:selected\"), this.element[0].selectedIndex);this.labels = this.element.labels().attr(\"for\", this.ids.button), this._on(this.labels, { click: function click(t) {\n          this.button.focus(), t.preventDefault();\n        } }), this.element.hide(), this.button = t(\"<span>\", { tabindex: this.options.disabled ? -1 : 0, id: this.ids.button, role: \"combobox\", \"aria-expanded\": \"false\", \"aria-autocomplete\": \"list\", \"aria-owns\": this.ids.menu, \"aria-haspopup\": \"true\", title: this.element.attr(\"title\") }).insertAfter(this.element), this._addClass(this.button, \"ui-selectmenu-button ui-selectmenu-button-closed\", \"ui-button ui-widget\"), e = t(\"<span>\").appendTo(this.button), this._addClass(e, \"ui-selectmenu-icon\", \"ui-icon \" + this.options.icons.button), this.buttonItem = this._renderButtonItem(s).appendTo(this.button), this.options.width !== !1 && this._resizeButton(), this._on(this.button, this._buttonEvents), this.button.one(\"focusin\", function () {\n        i._rendered || i._refreshMenu();\n      });\n    }, _drawMenu: function _drawMenu() {\n      var e = this;this.menu = t(\"<ul>\", { \"aria-hidden\": \"true\", \"aria-labelledby\": this.ids.button, id: this.ids.menu }), this.menuWrap = t(\"<div>\").append(this.menu), this._addClass(this.menuWrap, \"ui-selectmenu-menu\", \"ui-front\"), this.menuWrap.appendTo(this._appendTo()), this.menuInstance = this.menu.menu({ classes: { \"ui-menu\": \"ui-corner-bottom\" }, role: \"listbox\", select: function select(t, i) {\n          t.preventDefault(), e._setSelection(), e._select(i.item.data(\"ui-selectmenu-item\"), t);\n        }, focus: function focus(t, i) {\n          var s = i.item.data(\"ui-selectmenu-item\");null != e.focusIndex && s.index !== e.focusIndex && (e._trigger(\"focus\", t, { item: s }), e.isOpen || e._select(s, t)), e.focusIndex = s.index, e.button.attr(\"aria-activedescendant\", e.menuItems.eq(s.index).attr(\"id\"));\n        } }).menu(\"instance\"), this.menuInstance._off(this.menu, \"mouseleave\"), this.menuInstance._closeOnDocumentClick = function () {\n        return !1;\n      }, this.menuInstance._isDivider = function () {\n        return !1;\n      };\n    }, refresh: function refresh() {\n      this._refreshMenu(), this.buttonItem.replaceWith(this.buttonItem = this._renderButtonItem(this._getSelectedItem().data(\"ui-selectmenu-item\") || {})), null === this.options.width && this._resizeButton();\n    }, _refreshMenu: function _refreshMenu() {\n      var t,\n          e = this.element.find(\"option\");this.menu.empty(), this._parseOptions(e), this._renderMenu(this.menu, this.items), this.menuInstance.refresh(), this.menuItems = this.menu.find(\"li\").not(\".ui-selectmenu-optgroup\").find(\".ui-menu-item-wrapper\"), this._rendered = !0, e.length && (t = this._getSelectedItem(), this.menuInstance.focus(null, t), this._setAria(t.data(\"ui-selectmenu-item\")), this._setOption(\"disabled\", this.element.prop(\"disabled\")));\n    }, open: function open(t) {\n      this.options.disabled || (this._rendered ? (this._removeClass(this.menu.find(\".ui-state-active\"), null, \"ui-state-active\"), this.menuInstance.focus(null, this._getSelectedItem())) : this._refreshMenu(), this.menuItems.length && (this.isOpen = !0, this._toggleAttr(), this._resizeMenu(), this._position(), this._on(this.document, this._documentClick), this._trigger(\"open\", t)));\n    }, _position: function _position() {\n      this.menuWrap.position(t.extend({ of: this.button }, this.options.position));\n    }, close: function close(t) {\n      this.isOpen && (this.isOpen = !1, this._toggleAttr(), this.range = null, this._off(this.document), this._trigger(\"close\", t));\n    }, widget: function widget() {\n      return this.button;\n    }, menuWidget: function menuWidget() {\n      return this.menu;\n    }, _renderButtonItem: function _renderButtonItem(e) {\n      var i = t(\"<span>\");return this._setText(i, e.label), this._addClass(i, \"ui-selectmenu-text\"), i;\n    }, _renderMenu: function _renderMenu(e, i) {\n      var s = this,\n          n = \"\";t.each(i, function (i, o) {\n        var a;o.optgroup !== n && (a = t(\"<li>\", { text: o.optgroup }), s._addClass(a, \"ui-selectmenu-optgroup\", \"ui-menu-divider\" + (o.element.parent(\"optgroup\").prop(\"disabled\") ? \" ui-state-disabled\" : \"\")), a.appendTo(e), n = o.optgroup), s._renderItemData(e, o);\n      });\n    }, _renderItemData: function _renderItemData(t, e) {\n      return this._renderItem(t, e).data(\"ui-selectmenu-item\", e);\n    }, _renderItem: function _renderItem(e, i) {\n      var s = t(\"<li>\"),\n          n = t(\"<div>\", { title: i.element.attr(\"title\") });return i.disabled && this._addClass(s, null, \"ui-state-disabled\"), this._setText(n, i.label), s.append(n).appendTo(e);\n    }, _setText: function _setText(t, e) {\n      e ? t.text(e) : t.html(\"&#160;\");\n    }, _move: function _move(t, e) {\n      var i,\n          s,\n          n = \".ui-menu-item\";this.isOpen ? i = this.menuItems.eq(this.focusIndex).parent(\"li\") : (i = this.menuItems.eq(this.element[0].selectedIndex).parent(\"li\"), n += \":not(.ui-state-disabled)\"), s = \"first\" === t || \"last\" === t ? i[\"first\" === t ? \"prevAll\" : \"nextAll\"](n).eq(-1) : i[t + \"All\"](n).eq(0), s.length && this.menuInstance.focus(e, s);\n    }, _getSelectedItem: function _getSelectedItem() {\n      return this.menuItems.eq(this.element[0].selectedIndex).parent(\"li\");\n    }, _toggle: function _toggle(t) {\n      this[this.isOpen ? \"close\" : \"open\"](t);\n    }, _setSelection: function _setSelection() {\n      var t;this.range && (window.getSelection ? (t = window.getSelection(), t.removeAllRanges(), t.addRange(this.range)) : this.range.select(), this.button.focus());\n    }, _documentClick: { mousedown: function mousedown(e) {\n        this.isOpen && (t(e.target).closest(\".ui-selectmenu-menu, #\" + t.ui.escapeSelector(this.ids.button)).length || this.close(e));\n      } }, _buttonEvents: { mousedown: function mousedown() {\n        var t;window.getSelection ? (t = window.getSelection(), t.rangeCount && (this.range = t.getRangeAt(0))) : this.range = document.selection.createRange();\n      }, click: function click(t) {\n        this._setSelection(), this._toggle(t);\n      }, keydown: function keydown(e) {\n        var i = !0;switch (e.keyCode) {case t.ui.keyCode.TAB:case t.ui.keyCode.ESCAPE:\n            this.close(e), i = !1;break;case t.ui.keyCode.ENTER:\n            this.isOpen && this._selectFocusedItem(e);break;case t.ui.keyCode.UP:\n            e.altKey ? this._toggle(e) : this._move(\"prev\", e);break;case t.ui.keyCode.DOWN:\n            e.altKey ? this._toggle(e) : this._move(\"next\", e);break;case t.ui.keyCode.SPACE:\n            this.isOpen ? this._selectFocusedItem(e) : this._toggle(e);break;case t.ui.keyCode.LEFT:\n            this._move(\"prev\", e);break;case t.ui.keyCode.RIGHT:\n            this._move(\"next\", e);break;case t.ui.keyCode.HOME:case t.ui.keyCode.PAGE_UP:\n            this._move(\"first\", e);break;case t.ui.keyCode.END:case t.ui.keyCode.PAGE_DOWN:\n            this._move(\"last\", e);break;default:\n            this.menu.trigger(e), i = !1;}i && e.preventDefault();\n      } }, _selectFocusedItem: function _selectFocusedItem(t) {\n      var e = this.menuItems.eq(this.focusIndex).parent(\"li\");e.hasClass(\"ui-state-disabled\") || this._select(e.data(\"ui-selectmenu-item\"), t);\n    }, _select: function _select(t, e) {\n      var i = this.element[0].selectedIndex;this.element[0].selectedIndex = t.index, this.buttonItem.replaceWith(this.buttonItem = this._renderButtonItem(t)), this._setAria(t), this._trigger(\"select\", e, { item: t }), t.index !== i && this._trigger(\"change\", e, { item: t }), this.close(e);\n    }, _setAria: function _setAria(t) {\n      var e = this.menuItems.eq(t.index).attr(\"id\");this.button.attr({ \"aria-labelledby\": e, \"aria-activedescendant\": e }), this.menu.attr(\"aria-activedescendant\", e);\n    }, _setOption: function _setOption(t, e) {\n      if (\"icons\" === t) {\n        var i = this.button.find(\"span.ui-icon\");this._removeClass(i, null, this.options.icons.button)._addClass(i, null, e.button);\n      }this._super(t, e), \"appendTo\" === t && this.menuWrap.appendTo(this._appendTo()), \"width\" === t && this._resizeButton();\n    }, _setOptionDisabled: function _setOptionDisabled(t) {\n      this._super(t), this.menuInstance.option(\"disabled\", t), this.button.attr(\"aria-disabled\", t), this._toggleClass(this.button, null, \"ui-state-disabled\", t), this.element.prop(\"disabled\", t), t ? (this.button.attr(\"tabindex\", -1), this.close()) : this.button.attr(\"tabindex\", 0);\n    }, _appendTo: function _appendTo() {\n      var e = this.options.appendTo;return e && (e = e.jquery || e.nodeType ? t(e) : this.document.find(e).eq(0)), e && e[0] || (e = this.element.closest(\".ui-front, dialog\")), e.length || (e = this.document[0].body), e;\n    }, _toggleAttr: function _toggleAttr() {\n      this.button.attr(\"aria-expanded\", this.isOpen), this._removeClass(this.button, \"ui-selectmenu-button-\" + (this.isOpen ? \"closed\" : \"open\"))._addClass(this.button, \"ui-selectmenu-button-\" + (this.isOpen ? \"open\" : \"closed\"))._toggleClass(this.menuWrap, \"ui-selectmenu-open\", null, this.isOpen), this.menu.attr(\"aria-hidden\", !this.isOpen);\n    }, _resizeButton: function _resizeButton() {\n      var t = this.options.width;return t === !1 ? (this.button.css(\"width\", \"\"), void 0) : (null === t && (t = this.element.show().outerWidth(), this.element.hide()), this.button.outerWidth(t), void 0);\n    }, _resizeMenu: function _resizeMenu() {\n      this.menu.outerWidth(Math.max(this.button.outerWidth(), this.menu.width(\"\").outerWidth() + 1));\n    }, _getCreateOptions: function _getCreateOptions() {\n      var t = this._super();return t.disabled = this.element.prop(\"disabled\"), t;\n    }, _parseOptions: function _parseOptions(e) {\n      var i = this,\n          s = [];e.each(function (e, n) {\n        s.push(i._parseOption(t(n), e));\n      }), this.items = s;\n    }, _parseOption: function _parseOption(t, e) {\n      var i = t.parent(\"optgroup\");return { element: t, index: e, value: t.val(), label: t.text(), optgroup: i.attr(\"label\") || \"\", disabled: i.prop(\"disabled\") || t.prop(\"disabled\") };\n    }, _destroy: function _destroy() {\n      this._unbindFormResetHandler(), this.menuWrap.remove(), this.button.remove(), this.element.show(), this.element.removeUniqueId(), this.labels.attr(\"for\", this.ids.element);\n    } }]), t.widget(\"ui.slider\", t.ui.mouse, { version: \"1.12.1\", widgetEventPrefix: \"slide\", options: { animate: !1, classes: { \"ui-slider\": \"ui-corner-all\", \"ui-slider-handle\": \"ui-corner-all\", \"ui-slider-range\": \"ui-corner-all ui-widget-header\" }, distance: 0, max: 100, min: 0, orientation: \"horizontal\", range: !1, step: 1, value: 0, values: null, change: null, slide: null, start: null, stop: null }, numPages: 5, _create: function _create() {\n      this._keySliding = !1, this._mouseSliding = !1, this._animateOff = !0, this._handleIndex = null, this._detectOrientation(), this._mouseInit(), this._calculateNewMax(), this._addClass(\"ui-slider ui-slider-\" + this.orientation, \"ui-widget ui-widget-content\"), this._refresh(), this._animateOff = !1;\n    }, _refresh: function _refresh() {\n      this._createRange(), this._createHandles(), this._setupEvents(), this._refreshValue();\n    }, _createHandles: function _createHandles() {\n      var e,\n          i,\n          s = this.options,\n          n = this.element.find(\".ui-slider-handle\"),\n          o = \"<span tabindex='0'></span>\",\n          a = [];for (i = s.values && s.values.length || 1, n.length > i && (n.slice(i).remove(), n = n.slice(0, i)), e = n.length; i > e; e++) {\n        a.push(o);\n      }this.handles = n.add(t(a.join(\"\")).appendTo(this.element)), this._addClass(this.handles, \"ui-slider-handle\", \"ui-state-default\"), this.handle = this.handles.eq(0), this.handles.each(function (e) {\n        t(this).data(\"ui-slider-handle-index\", e).attr(\"tabIndex\", 0);\n      });\n    }, _createRange: function _createRange() {\n      var e = this.options;e.range ? (e.range === !0 && (e.values ? e.values.length && 2 !== e.values.length ? e.values = [e.values[0], e.values[0]] : t.isArray(e.values) && (e.values = e.values.slice(0)) : e.values = [this._valueMin(), this._valueMin()]), this.range && this.range.length ? (this._removeClass(this.range, \"ui-slider-range-min ui-slider-range-max\"), this.range.css({ left: \"\", bottom: \"\" })) : (this.range = t(\"<div>\").appendTo(this.element), this._addClass(this.range, \"ui-slider-range\")), (\"min\" === e.range || \"max\" === e.range) && this._addClass(this.range, \"ui-slider-range-\" + e.range)) : (this.range && this.range.remove(), this.range = null);\n    }, _setupEvents: function _setupEvents() {\n      this._off(this.handles), this._on(this.handles, this._handleEvents), this._hoverable(this.handles), this._focusable(this.handles);\n    }, _destroy: function _destroy() {\n      this.handles.remove(), this.range && this.range.remove(), this._mouseDestroy();\n    }, _mouseCapture: function _mouseCapture(e) {\n      var i,\n          s,\n          n,\n          o,\n          a,\n          r,\n          h,\n          l,\n          c = this,\n          u = this.options;return u.disabled ? !1 : (this.elementSize = { width: this.element.outerWidth(), height: this.element.outerHeight() }, this.elementOffset = this.element.offset(), i = { x: e.pageX, y: e.pageY }, s = this._normValueFromMouse(i), n = this._valueMax() - this._valueMin() + 1, this.handles.each(function (e) {\n        var i = Math.abs(s - c.values(e));(n > i || n === i && (e === c._lastChangedValue || c.values(e) === u.min)) && (n = i, o = t(this), a = e);\n      }), r = this._start(e, a), r === !1 ? !1 : (this._mouseSliding = !0, this._handleIndex = a, this._addClass(o, null, \"ui-state-active\"), o.trigger(\"focus\"), h = o.offset(), l = !t(e.target).parents().addBack().is(\".ui-slider-handle\"), this._clickOffset = l ? { left: 0, top: 0 } : { left: e.pageX - h.left - o.width() / 2, top: e.pageY - h.top - o.height() / 2 - (parseInt(o.css(\"borderTopWidth\"), 10) || 0) - (parseInt(o.css(\"borderBottomWidth\"), 10) || 0) + (parseInt(o.css(\"marginTop\"), 10) || 0) }, this.handles.hasClass(\"ui-state-hover\") || this._slide(e, a, s), this._animateOff = !0, !0));\n    }, _mouseStart: function _mouseStart() {\n      return !0;\n    }, _mouseDrag: function _mouseDrag(t) {\n      var e = { x: t.pageX, y: t.pageY },\n          i = this._normValueFromMouse(e);return this._slide(t, this._handleIndex, i), !1;\n    }, _mouseStop: function _mouseStop(t) {\n      return this._removeClass(this.handles, null, \"ui-state-active\"), this._mouseSliding = !1, this._stop(t, this._handleIndex), this._change(t, this._handleIndex), this._handleIndex = null, this._clickOffset = null, this._animateOff = !1, !1;\n    }, _detectOrientation: function _detectOrientation() {\n      this.orientation = \"vertical\" === this.options.orientation ? \"vertical\" : \"horizontal\";\n    }, _normValueFromMouse: function _normValueFromMouse(t) {\n      var e, i, s, n, o;return \"horizontal\" === this.orientation ? (e = this.elementSize.width, i = t.x - this.elementOffset.left - (this._clickOffset ? this._clickOffset.left : 0)) : (e = this.elementSize.height, i = t.y - this.elementOffset.top - (this._clickOffset ? this._clickOffset.top : 0)), s = i / e, s > 1 && (s = 1), 0 > s && (s = 0), \"vertical\" === this.orientation && (s = 1 - s), n = this._valueMax() - this._valueMin(), o = this._valueMin() + s * n, this._trimAlignValue(o);\n    }, _uiHash: function _uiHash(t, e, i) {\n      var s = { handle: this.handles[t], handleIndex: t, value: void 0 !== e ? e : this.value() };return this._hasMultipleValues() && (s.value = void 0 !== e ? e : this.values(t), s.values = i || this.values()), s;\n    }, _hasMultipleValues: function _hasMultipleValues() {\n      return this.options.values && this.options.values.length;\n    }, _start: function _start(t, e) {\n      return this._trigger(\"start\", t, this._uiHash(e));\n    }, _slide: function _slide(t, e, i) {\n      var s,\n          n,\n          o = this.value(),\n          a = this.values();this._hasMultipleValues() && (n = this.values(e ? 0 : 1), o = this.values(e), 2 === this.options.values.length && this.options.range === !0 && (i = 0 === e ? Math.min(n, i) : Math.max(n, i)), a[e] = i), i !== o && (s = this._trigger(\"slide\", t, this._uiHash(e, i, a)), s !== !1 && (this._hasMultipleValues() ? this.values(e, i) : this.value(i)));\n    }, _stop: function _stop(t, e) {\n      this._trigger(\"stop\", t, this._uiHash(e));\n    }, _change: function _change(t, e) {\n      this._keySliding || this._mouseSliding || (this._lastChangedValue = e, this._trigger(\"change\", t, this._uiHash(e)));\n    }, value: function value(t) {\n      return arguments.length ? (this.options.value = this._trimAlignValue(t), this._refreshValue(), this._change(null, 0), void 0) : this._value();\n    }, values: function values(e, i) {\n      var s, n, o;if (arguments.length > 1) return this.options.values[e] = this._trimAlignValue(i), this._refreshValue(), this._change(null, e), void 0;if (!arguments.length) return this._values();if (!t.isArray(arguments[0])) return this._hasMultipleValues() ? this._values(e) : this.value();for (s = this.options.values, n = arguments[0], o = 0; s.length > o; o += 1) {\n        s[o] = this._trimAlignValue(n[o]), this._change(null, o);\n      }this._refreshValue();\n    }, _setOption: function _setOption(e, i) {\n      var s,\n          n = 0;switch (\"range\" === e && this.options.range === !0 && (\"min\" === i ? (this.options.value = this._values(0), this.options.values = null) : \"max\" === i && (this.options.value = this._values(this.options.values.length - 1), this.options.values = null)), t.isArray(this.options.values) && (n = this.options.values.length), this._super(e, i), e) {case \"orientation\":\n          this._detectOrientation(), this._removeClass(\"ui-slider-horizontal ui-slider-vertical\")._addClass(\"ui-slider-\" + this.orientation), this._refreshValue(), this.options.range && this._refreshRange(i), this.handles.css(\"horizontal\" === i ? \"bottom\" : \"left\", \"\");break;case \"value\":\n          this._animateOff = !0, this._refreshValue(), this._change(null, 0), this._animateOff = !1;break;case \"values\":\n          for (this._animateOff = !0, this._refreshValue(), s = n - 1; s >= 0; s--) {\n            this._change(null, s);\n          }this._animateOff = !1;break;case \"step\":case \"min\":case \"max\":\n          this._animateOff = !0, this._calculateNewMax(), this._refreshValue(), this._animateOff = !1;break;case \"range\":\n          this._animateOff = !0, this._refresh(), this._animateOff = !1;}\n    }, _setOptionDisabled: function _setOptionDisabled(t) {\n      this._super(t), this._toggleClass(null, \"ui-state-disabled\", !!t);\n    }, _value: function _value() {\n      var t = this.options.value;return t = this._trimAlignValue(t);\n    }, _values: function _values(t) {\n      var e, i, s;if (arguments.length) return e = this.options.values[t], e = this._trimAlignValue(e);if (this._hasMultipleValues()) {\n        for (i = this.options.values.slice(), s = 0; i.length > s; s += 1) {\n          i[s] = this._trimAlignValue(i[s]);\n        }return i;\n      }return [];\n    }, _trimAlignValue: function _trimAlignValue(t) {\n      if (this._valueMin() >= t) return this._valueMin();if (t >= this._valueMax()) return this._valueMax();var e = this.options.step > 0 ? this.options.step : 1,\n          i = (t - this._valueMin()) % e,\n          s = t - i;return 2 * Math.abs(i) >= e && (s += i > 0 ? e : -e), parseFloat(s.toFixed(5));\n    }, _calculateNewMax: function _calculateNewMax() {\n      var t = this.options.max,\n          e = this._valueMin(),\n          i = this.options.step,\n          s = Math.round((t - e) / i) * i;t = s + e, t > this.options.max && (t -= i), this.max = parseFloat(t.toFixed(this._precision()));\n    }, _precision: function _precision() {\n      var t = this._precisionOf(this.options.step);return null !== this.options.min && (t = Math.max(t, this._precisionOf(this.options.min))), t;\n    }, _precisionOf: function _precisionOf(t) {\n      var e = \"\" + t,\n          i = e.indexOf(\".\");return -1 === i ? 0 : e.length - i - 1;\n    }, _valueMin: function _valueMin() {\n      return this.options.min;\n    }, _valueMax: function _valueMax() {\n      return this.max;\n    }, _refreshRange: function _refreshRange(t) {\n      \"vertical\" === t && this.range.css({ width: \"\", left: \"\" }), \"horizontal\" === t && this.range.css({ height: \"\", bottom: \"\" });\n    }, _refreshValue: function _refreshValue() {\n      var e,\n          i,\n          s,\n          n,\n          o,\n          a = this.options.range,\n          r = this.options,\n          h = this,\n          l = this._animateOff ? !1 : r.animate,\n          c = {};this._hasMultipleValues() ? this.handles.each(function (s) {\n        i = 100 * ((h.values(s) - h._valueMin()) / (h._valueMax() - h._valueMin())), c[\"horizontal\" === h.orientation ? \"left\" : \"bottom\"] = i + \"%\", t(this).stop(1, 1)[l ? \"animate\" : \"css\"](c, r.animate), h.options.range === !0 && (\"horizontal\" === h.orientation ? (0 === s && h.range.stop(1, 1)[l ? \"animate\" : \"css\"]({ left: i + \"%\" }, r.animate), 1 === s && h.range[l ? \"animate\" : \"css\"]({ width: i - e + \"%\" }, { queue: !1, duration: r.animate })) : (0 === s && h.range.stop(1, 1)[l ? \"animate\" : \"css\"]({ bottom: i + \"%\" }, r.animate), 1 === s && h.range[l ? \"animate\" : \"css\"]({ height: i - e + \"%\" }, { queue: !1, duration: r.animate }))), e = i;\n      }) : (s = this.value(), n = this._valueMin(), o = this._valueMax(), i = o !== n ? 100 * ((s - n) / (o - n)) : 0, c[\"horizontal\" === this.orientation ? \"left\" : \"bottom\"] = i + \"%\", this.handle.stop(1, 1)[l ? \"animate\" : \"css\"](c, r.animate), \"min\" === a && \"horizontal\" === this.orientation && this.range.stop(1, 1)[l ? \"animate\" : \"css\"]({ width: i + \"%\" }, r.animate), \"max\" === a && \"horizontal\" === this.orientation && this.range.stop(1, 1)[l ? \"animate\" : \"css\"]({ width: 100 - i + \"%\" }, r.animate), \"min\" === a && \"vertical\" === this.orientation && this.range.stop(1, 1)[l ? \"animate\" : \"css\"]({ height: i + \"%\" }, r.animate), \"max\" === a && \"vertical\" === this.orientation && this.range.stop(1, 1)[l ? \"animate\" : \"css\"]({ height: 100 - i + \"%\" }, r.animate));\n    }, _handleEvents: { keydown: function keydown(e) {\n        var i,\n            s,\n            n,\n            o,\n            a = t(e.target).data(\"ui-slider-handle-index\");switch (e.keyCode) {case t.ui.keyCode.HOME:case t.ui.keyCode.END:case t.ui.keyCode.PAGE_UP:case t.ui.keyCode.PAGE_DOWN:case t.ui.keyCode.UP:case t.ui.keyCode.RIGHT:case t.ui.keyCode.DOWN:case t.ui.keyCode.LEFT:\n            if (e.preventDefault(), !this._keySliding && (this._keySliding = !0, this._addClass(t(e.target), null, \"ui-state-active\"), i = this._start(e, a), i === !1)) return;}switch (o = this.options.step, s = n = this._hasMultipleValues() ? this.values(a) : this.value(), e.keyCode) {case t.ui.keyCode.HOME:\n            n = this._valueMin();break;case t.ui.keyCode.END:\n            n = this._valueMax();break;case t.ui.keyCode.PAGE_UP:\n            n = this._trimAlignValue(s + (this._valueMax() - this._valueMin()) / this.numPages);break;case t.ui.keyCode.PAGE_DOWN:\n            n = this._trimAlignValue(s - (this._valueMax() - this._valueMin()) / this.numPages);break;case t.ui.keyCode.UP:case t.ui.keyCode.RIGHT:\n            if (s === this._valueMax()) return;n = this._trimAlignValue(s + o);break;case t.ui.keyCode.DOWN:case t.ui.keyCode.LEFT:\n            if (s === this._valueMin()) return;n = this._trimAlignValue(s - o);}this._slide(e, a, n);\n      }, keyup: function keyup(e) {\n        var i = t(e.target).data(\"ui-slider-handle-index\");this._keySliding && (this._keySliding = !1, this._stop(e, i), this._change(e, i), this._removeClass(t(e.target), null, \"ui-state-active\"));\n      } } }), t.widget(\"ui.sortable\", t.ui.mouse, { version: \"1.12.1\", widgetEventPrefix: \"sort\", ready: !1, options: { appendTo: \"parent\", axis: !1, connectWith: !1, containment: !1, cursor: \"auto\", cursorAt: !1, dropOnEmpty: !0, forcePlaceholderSize: !1, forceHelperSize: !1, grid: !1, handle: !1, helper: \"original\", items: \"> *\", opacity: !1, placeholder: !1, revert: !1, scroll: !0, scrollSensitivity: 20, scrollSpeed: 20, scope: \"default\", tolerance: \"intersect\", zIndex: 1e3, activate: null, beforeStop: null, change: null, deactivate: null, out: null, over: null, receive: null, remove: null, sort: null, start: null, stop: null, update: null }, _isOverAxis: function _isOverAxis(t, e, i) {\n      return t >= e && e + i > t;\n    }, _isFloating: function _isFloating(t) {\n      return (/left|right/.test(t.css(\"float\")) || /inline|table-cell/.test(t.css(\"display\"))\n      );\n    }, _create: function _create() {\n      this.containerCache = {}, this._addClass(\"ui-sortable\"), this.refresh(), this.offset = this.element.offset(), this._mouseInit(), this._setHandleClassName(), this.ready = !0;\n    }, _setOption: function _setOption(t, e) {\n      this._super(t, e), \"handle\" === t && this._setHandleClassName();\n    }, _setHandleClassName: function _setHandleClassName() {\n      var e = this;this._removeClass(this.element.find(\".ui-sortable-handle\"), \"ui-sortable-handle\"), t.each(this.items, function () {\n        e._addClass(this.instance.options.handle ? this.item.find(this.instance.options.handle) : this.item, \"ui-sortable-handle\");\n      });\n    }, _destroy: function _destroy() {\n      this._mouseDestroy();for (var t = this.items.length - 1; t >= 0; t--) {\n        this.items[t].item.removeData(this.widgetName + \"-item\");\n      }return this;\n    }, _mouseCapture: function _mouseCapture(e, i) {\n      var s = null,\n          n = !1,\n          o = this;return this.reverting ? !1 : this.options.disabled || \"static\" === this.options.type ? !1 : (this._refreshItems(e), t(e.target).parents().each(function () {\n        return t.data(this, o.widgetName + \"-item\") === o ? (s = t(this), !1) : void 0;\n      }), t.data(e.target, o.widgetName + \"-item\") === o && (s = t(e.target)), s ? !this.options.handle || i || (t(this.options.handle, s).find(\"*\").addBack().each(function () {\n        this === e.target && (n = !0);\n      }), n) ? (this.currentItem = s, this._removeCurrentsFromItems(), !0) : !1 : !1);\n    }, _mouseStart: function _mouseStart(e, i, s) {\n      var n,\n          o,\n          a = this.options;if (this.currentContainer = this, this.refreshPositions(), this.helper = this._createHelper(e), this._cacheHelperProportions(), this._cacheMargins(), this.scrollParent = this.helper.scrollParent(), this.offset = this.currentItem.offset(), this.offset = { top: this.offset.top - this.margins.top, left: this.offset.left - this.margins.left }, t.extend(this.offset, { click: { left: e.pageX - this.offset.left, top: e.pageY - this.offset.top }, parent: this._getParentOffset(), relative: this._getRelativeOffset() }), this.helper.css(\"position\", \"absolute\"), this.cssPosition = this.helper.css(\"position\"), this.originalPosition = this._generatePosition(e), this.originalPageX = e.pageX, this.originalPageY = e.pageY, a.cursorAt && this._adjustOffsetFromHelper(a.cursorAt), this.domPosition = { prev: this.currentItem.prev()[0], parent: this.currentItem.parent()[0] }, this.helper[0] !== this.currentItem[0] && this.currentItem.hide(), this._createPlaceholder(), a.containment && this._setContainment(), a.cursor && \"auto\" !== a.cursor && (o = this.document.find(\"body\"), this.storedCursor = o.css(\"cursor\"), o.css(\"cursor\", a.cursor), this.storedStylesheet = t(\"<style>*{ cursor: \" + a.cursor + \" !important; }</style>\").appendTo(o)), a.opacity && (this.helper.css(\"opacity\") && (this._storedOpacity = this.helper.css(\"opacity\")), this.helper.css(\"opacity\", a.opacity)), a.zIndex && (this.helper.css(\"zIndex\") && (this._storedZIndex = this.helper.css(\"zIndex\")), this.helper.css(\"zIndex\", a.zIndex)), this.scrollParent[0] !== this.document[0] && \"HTML\" !== this.scrollParent[0].tagName && (this.overflowOffset = this.scrollParent.offset()), this._trigger(\"start\", e, this._uiHash()), this._preserveHelperProportions || this._cacheHelperProportions(), !s) for (n = this.containers.length - 1; n >= 0; n--) {\n        this.containers[n]._trigger(\"activate\", e, this._uiHash(this));\n      }return t.ui.ddmanager && (t.ui.ddmanager.current = this), t.ui.ddmanager && !a.dropBehaviour && t.ui.ddmanager.prepareOffsets(this, e), this.dragging = !0, this._addClass(this.helper, \"ui-sortable-helper\"), this._mouseDrag(e), !0;\n    }, _mouseDrag: function _mouseDrag(e) {\n      var i,\n          s,\n          n,\n          o,\n          a = this.options,\n          r = !1;for (this.position = this._generatePosition(e), this.positionAbs = this._convertPositionTo(\"absolute\"), this.lastPositionAbs || (this.lastPositionAbs = this.positionAbs), this.options.scroll && (this.scrollParent[0] !== this.document[0] && \"HTML\" !== this.scrollParent[0].tagName ? (this.overflowOffset.top + this.scrollParent[0].offsetHeight - e.pageY < a.scrollSensitivity ? this.scrollParent[0].scrollTop = r = this.scrollParent[0].scrollTop + a.scrollSpeed : e.pageY - this.overflowOffset.top < a.scrollSensitivity && (this.scrollParent[0].scrollTop = r = this.scrollParent[0].scrollTop - a.scrollSpeed), this.overflowOffset.left + this.scrollParent[0].offsetWidth - e.pageX < a.scrollSensitivity ? this.scrollParent[0].scrollLeft = r = this.scrollParent[0].scrollLeft + a.scrollSpeed : e.pageX - this.overflowOffset.left < a.scrollSensitivity && (this.scrollParent[0].scrollLeft = r = this.scrollParent[0].scrollLeft - a.scrollSpeed)) : (e.pageY - this.document.scrollTop() < a.scrollSensitivity ? r = this.document.scrollTop(this.document.scrollTop() - a.scrollSpeed) : this.window.height() - (e.pageY - this.document.scrollTop()) < a.scrollSensitivity && (r = this.document.scrollTop(this.document.scrollTop() + a.scrollSpeed)), e.pageX - this.document.scrollLeft() < a.scrollSensitivity ? r = this.document.scrollLeft(this.document.scrollLeft() - a.scrollSpeed) : this.window.width() - (e.pageX - this.document.scrollLeft()) < a.scrollSensitivity && (r = this.document.scrollLeft(this.document.scrollLeft() + a.scrollSpeed))), r !== !1 && t.ui.ddmanager && !a.dropBehaviour && t.ui.ddmanager.prepareOffsets(this, e)), this.positionAbs = this._convertPositionTo(\"absolute\"), this.options.axis && \"y\" === this.options.axis || (this.helper[0].style.left = this.position.left + \"px\"), this.options.axis && \"x\" === this.options.axis || (this.helper[0].style.top = this.position.top + \"px\"), i = this.items.length - 1; i >= 0; i--) {\n        if (s = this.items[i], n = s.item[0], o = this._intersectsWithPointer(s), o && s.instance === this.currentContainer && n !== this.currentItem[0] && this.placeholder[1 === o ? \"next\" : \"prev\"]()[0] !== n && !t.contains(this.placeholder[0], n) && (\"semi-dynamic\" === this.options.type ? !t.contains(this.element[0], n) : !0)) {\n          if (this.direction = 1 === o ? \"down\" : \"up\", \"pointer\" !== this.options.tolerance && !this._intersectsWithSides(s)) break;this._rearrange(e, s), this._trigger(\"change\", e, this._uiHash());break;\n        }\n      }return this._contactContainers(e), t.ui.ddmanager && t.ui.ddmanager.drag(this, e), this._trigger(\"sort\", e, this._uiHash()), this.lastPositionAbs = this.positionAbs, !1;\n    }, _mouseStop: function _mouseStop(e, i) {\n      if (e) {\n        if (t.ui.ddmanager && !this.options.dropBehaviour && t.ui.ddmanager.drop(this, e), this.options.revert) {\n          var s = this,\n              n = this.placeholder.offset(),\n              o = this.options.axis,\n              a = {};o && \"x\" !== o || (a.left = n.left - this.offset.parent.left - this.margins.left + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollLeft)), o && \"y\" !== o || (a.top = n.top - this.offset.parent.top - this.margins.top + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollTop)), this.reverting = !0, t(this.helper).animate(a, parseInt(this.options.revert, 10) || 500, function () {\n            s._clear(e);\n          });\n        } else this._clear(e, i);return !1;\n      }\n    }, cancel: function cancel() {\n      if (this.dragging) {\n        this._mouseUp(new t.Event(\"mouseup\", { target: null })), \"original\" === this.options.helper ? (this.currentItem.css(this._storedCSS), this._removeClass(this.currentItem, \"ui-sortable-helper\")) : this.currentItem.show();for (var e = this.containers.length - 1; e >= 0; e--) {\n          this.containers[e]._trigger(\"deactivate\", null, this._uiHash(this)), this.containers[e].containerCache.over && (this.containers[e]._trigger(\"out\", null, this._uiHash(this)), this.containers[e].containerCache.over = 0);\n        }\n      }return this.placeholder && (this.placeholder[0].parentNode && this.placeholder[0].parentNode.removeChild(this.placeholder[0]), \"original\" !== this.options.helper && this.helper && this.helper[0].parentNode && this.helper.remove(), t.extend(this, { helper: null, dragging: !1, reverting: !1, _noFinalSort: null }), this.domPosition.prev ? t(this.domPosition.prev).after(this.currentItem) : t(this.domPosition.parent).prepend(this.currentItem)), this;\n    }, serialize: function serialize(e) {\n      var i = this._getItemsAsjQuery(e && e.connected),\n          s = [];return e = e || {}, t(i).each(function () {\n        var i = (t(e.item || this).attr(e.attribute || \"id\") || \"\").match(e.expression || /(.+)[\\-=_](.+)/);i && s.push((e.key || i[1] + \"[]\") + \"=\" + (e.key && e.expression ? i[1] : i[2]));\n      }), !s.length && e.key && s.push(e.key + \"=\"), s.join(\"&\");\n    }, toArray: function toArray(e) {\n      var i = this._getItemsAsjQuery(e && e.connected),\n          s = [];return e = e || {}, i.each(function () {\n        s.push(t(e.item || this).attr(e.attribute || \"id\") || \"\");\n      }), s;\n    }, _intersectsWith: function _intersectsWith(t) {\n      var e = this.positionAbs.left,\n          i = e + this.helperProportions.width,\n          s = this.positionAbs.top,\n          n = s + this.helperProportions.height,\n          o = t.left,\n          a = o + t.width,\n          r = t.top,\n          h = r + t.height,\n          l = this.offset.click.top,\n          c = this.offset.click.left,\n          u = \"x\" === this.options.axis || s + l > r && h > s + l,\n          d = \"y\" === this.options.axis || e + c > o && a > e + c,\n          p = u && d;return \"pointer\" === this.options.tolerance || this.options.forcePointerForContainers || \"pointer\" !== this.options.tolerance && this.helperProportions[this.floating ? \"width\" : \"height\"] > t[this.floating ? \"width\" : \"height\"] ? p : e + this.helperProportions.width / 2 > o && a > i - this.helperProportions.width / 2 && s + this.helperProportions.height / 2 > r && h > n - this.helperProportions.height / 2;\n    }, _intersectsWithPointer: function _intersectsWithPointer(t) {\n      var e,\n          i,\n          s = \"x\" === this.options.axis || this._isOverAxis(this.positionAbs.top + this.offset.click.top, t.top, t.height),\n          n = \"y\" === this.options.axis || this._isOverAxis(this.positionAbs.left + this.offset.click.left, t.left, t.width),\n          o = s && n;return o ? (e = this._getDragVerticalDirection(), i = this._getDragHorizontalDirection(), this.floating ? \"right\" === i || \"down\" === e ? 2 : 1 : e && (\"down\" === e ? 2 : 1)) : !1;\n    }, _intersectsWithSides: function _intersectsWithSides(t) {\n      var e = this._isOverAxis(this.positionAbs.top + this.offset.click.top, t.top + t.height / 2, t.height),\n          i = this._isOverAxis(this.positionAbs.left + this.offset.click.left, t.left + t.width / 2, t.width),\n          s = this._getDragVerticalDirection(),\n          n = this._getDragHorizontalDirection();return this.floating && n ? \"right\" === n && i || \"left\" === n && !i : s && (\"down\" === s && e || \"up\" === s && !e);\n    }, _getDragVerticalDirection: function _getDragVerticalDirection() {\n      var t = this.positionAbs.top - this.lastPositionAbs.top;return 0 !== t && (t > 0 ? \"down\" : \"up\");\n    }, _getDragHorizontalDirection: function _getDragHorizontalDirection() {\n      var t = this.positionAbs.left - this.lastPositionAbs.left;return 0 !== t && (t > 0 ? \"right\" : \"left\");\n    }, refresh: function refresh(t) {\n      return this._refreshItems(t), this._setHandleClassName(), this.refreshPositions(), this;\n    }, _connectWith: function _connectWith() {\n      var t = this.options;return t.connectWith.constructor === String ? [t.connectWith] : t.connectWith;\n    }, _getItemsAsjQuery: function _getItemsAsjQuery(e) {\n      function i() {\n        r.push(this);\n      }var s,\n          n,\n          o,\n          a,\n          r = [],\n          h = [],\n          l = this._connectWith();if (l && e) for (s = l.length - 1; s >= 0; s--) {\n        for (o = t(l[s], this.document[0]), n = o.length - 1; n >= 0; n--) {\n          a = t.data(o[n], this.widgetFullName), a && a !== this && !a.options.disabled && h.push([t.isFunction(a.options.items) ? a.options.items.call(a.element) : t(a.options.items, a.element).not(\".ui-sortable-helper\").not(\".ui-sortable-placeholder\"), a]);\n        }\n      }for (h.push([t.isFunction(this.options.items) ? this.options.items.call(this.element, null, { options: this.options, item: this.currentItem }) : t(this.options.items, this.element).not(\".ui-sortable-helper\").not(\".ui-sortable-placeholder\"), this]), s = h.length - 1; s >= 0; s--) {\n        h[s][0].each(i);\n      }return t(r);\n    }, _removeCurrentsFromItems: function _removeCurrentsFromItems() {\n      var e = this.currentItem.find(\":data(\" + this.widgetName + \"-item)\");this.items = t.grep(this.items, function (t) {\n        for (var i = 0; e.length > i; i++) {\n          if (e[i] === t.item[0]) return !1;\n        }return !0;\n      });\n    }, _refreshItems: function _refreshItems(e) {\n      this.items = [], this.containers = [this];var i,\n          s,\n          n,\n          o,\n          a,\n          r,\n          h,\n          l,\n          c = this.items,\n          u = [[t.isFunction(this.options.items) ? this.options.items.call(this.element[0], e, { item: this.currentItem }) : t(this.options.items, this.element), this]],\n          d = this._connectWith();if (d && this.ready) for (i = d.length - 1; i >= 0; i--) {\n        for (n = t(d[i], this.document[0]), s = n.length - 1; s >= 0; s--) {\n          o = t.data(n[s], this.widgetFullName), o && o !== this && !o.options.disabled && (u.push([t.isFunction(o.options.items) ? o.options.items.call(o.element[0], e, { item: this.currentItem }) : t(o.options.items, o.element), o]), this.containers.push(o));\n        }\n      }for (i = u.length - 1; i >= 0; i--) {\n        for (a = u[i][1], r = u[i][0], s = 0, l = r.length; l > s; s++) {\n          h = t(r[s]), h.data(this.widgetName + \"-item\", a), c.push({ item: h, instance: a, width: 0, height: 0, left: 0, top: 0 });\n        }\n      }\n    }, refreshPositions: function refreshPositions(e) {\n      this.floating = this.items.length ? \"x\" === this.options.axis || this._isFloating(this.items[0].item) : !1, this.offsetParent && this.helper && (this.offset.parent = this._getParentOffset());var i, s, n, o;for (i = this.items.length - 1; i >= 0; i--) {\n        s = this.items[i], s.instance !== this.currentContainer && this.currentContainer && s.item[0] !== this.currentItem[0] || (n = this.options.toleranceElement ? t(this.options.toleranceElement, s.item) : s.item, e || (s.width = n.outerWidth(), s.height = n.outerHeight()), o = n.offset(), s.left = o.left, s.top = o.top);\n      }if (this.options.custom && this.options.custom.refreshContainers) this.options.custom.refreshContainers.call(this);else for (i = this.containers.length - 1; i >= 0; i--) {\n        o = this.containers[i].element.offset(), this.containers[i].containerCache.left = o.left, this.containers[i].containerCache.top = o.top, this.containers[i].containerCache.width = this.containers[i].element.outerWidth(), this.containers[i].containerCache.height = this.containers[i].element.outerHeight();\n      }return this;\n    }, _createPlaceholder: function _createPlaceholder(e) {\n      e = e || this;var i,\n          s = e.options;s.placeholder && s.placeholder.constructor !== String || (i = s.placeholder, s.placeholder = { element: function element() {\n          var s = e.currentItem[0].nodeName.toLowerCase(),\n              n = t(\"<\" + s + \">\", e.document[0]);return e._addClass(n, \"ui-sortable-placeholder\", i || e.currentItem[0].className)._removeClass(n, \"ui-sortable-helper\"), \"tbody\" === s ? e._createTrPlaceholder(e.currentItem.find(\"tr\").eq(0), t(\"<tr>\", e.document[0]).appendTo(n)) : \"tr\" === s ? e._createTrPlaceholder(e.currentItem, n) : \"img\" === s && n.attr(\"src\", e.currentItem.attr(\"src\")), i || n.css(\"visibility\", \"hidden\"), n;\n        }, update: function update(t, n) {\n          (!i || s.forcePlaceholderSize) && (n.height() || n.height(e.currentItem.innerHeight() - parseInt(e.currentItem.css(\"paddingTop\") || 0, 10) - parseInt(e.currentItem.css(\"paddingBottom\") || 0, 10)), n.width() || n.width(e.currentItem.innerWidth() - parseInt(e.currentItem.css(\"paddingLeft\") || 0, 10) - parseInt(e.currentItem.css(\"paddingRight\") || 0, 10)));\n        } }), e.placeholder = t(s.placeholder.element.call(e.element, e.currentItem)), e.currentItem.after(e.placeholder), s.placeholder.update(e, e.placeholder);\n    }, _createTrPlaceholder: function _createTrPlaceholder(e, i) {\n      var s = this;e.children().each(function () {\n        t(\"<td>&#160;</td>\", s.document[0]).attr(\"colspan\", t(this).attr(\"colspan\") || 1).appendTo(i);\n      });\n    }, _contactContainers: function _contactContainers(e) {\n      var i,\n          s,\n          n,\n          o,\n          a,\n          r,\n          h,\n          l,\n          c,\n          u,\n          d = null,\n          p = null;for (i = this.containers.length - 1; i >= 0; i--) {\n        if (!t.contains(this.currentItem[0], this.containers[i].element[0])) if (this._intersectsWith(this.containers[i].containerCache)) {\n          if (d && t.contains(this.containers[i].element[0], d.element[0])) continue;d = this.containers[i], p = i;\n        } else this.containers[i].containerCache.over && (this.containers[i]._trigger(\"out\", e, this._uiHash(this)), this.containers[i].containerCache.over = 0);\n      }if (d) if (1 === this.containers.length) this.containers[p].containerCache.over || (this.containers[p]._trigger(\"over\", e, this._uiHash(this)), this.containers[p].containerCache.over = 1);else {\n        for (n = 1e4, o = null, c = d.floating || this._isFloating(this.currentItem), a = c ? \"left\" : \"top\", r = c ? \"width\" : \"height\", u = c ? \"pageX\" : \"pageY\", s = this.items.length - 1; s >= 0; s--) {\n          t.contains(this.containers[p].element[0], this.items[s].item[0]) && this.items[s].item[0] !== this.currentItem[0] && (h = this.items[s].item.offset()[a], l = !1, e[u] - h > this.items[s][r] / 2 && (l = !0), n > Math.abs(e[u] - h) && (n = Math.abs(e[u] - h), o = this.items[s], this.direction = l ? \"up\" : \"down\"));\n        }if (!o && !this.options.dropOnEmpty) return;if (this.currentContainer === this.containers[p]) return this.currentContainer.containerCache.over || (this.containers[p]._trigger(\"over\", e, this._uiHash()), this.currentContainer.containerCache.over = 1), void 0;o ? this._rearrange(e, o, null, !0) : this._rearrange(e, null, this.containers[p].element, !0), this._trigger(\"change\", e, this._uiHash()), this.containers[p]._trigger(\"change\", e, this._uiHash(this)), this.currentContainer = this.containers[p], this.options.placeholder.update(this.currentContainer, this.placeholder), this.containers[p]._trigger(\"over\", e, this._uiHash(this)), this.containers[p].containerCache.over = 1;\n      }\n    }, _createHelper: function _createHelper(e) {\n      var i = this.options,\n          s = t.isFunction(i.helper) ? t(i.helper.apply(this.element[0], [e, this.currentItem])) : \"clone\" === i.helper ? this.currentItem.clone() : this.currentItem;return s.parents(\"body\").length || t(\"parent\" !== i.appendTo ? i.appendTo : this.currentItem[0].parentNode)[0].appendChild(s[0]), s[0] === this.currentItem[0] && (this._storedCSS = { width: this.currentItem[0].style.width, height: this.currentItem[0].style.height, position: this.currentItem.css(\"position\"), top: this.currentItem.css(\"top\"), left: this.currentItem.css(\"left\") }), (!s[0].style.width || i.forceHelperSize) && s.width(this.currentItem.width()), (!s[0].style.height || i.forceHelperSize) && s.height(this.currentItem.height()), s;\n    }, _adjustOffsetFromHelper: function _adjustOffsetFromHelper(e) {\n      \"string\" == typeof e && (e = e.split(\" \")), t.isArray(e) && (e = { left: +e[0], top: +e[1] || 0 }), \"left\" in e && (this.offset.click.left = e.left + this.margins.left), \"right\" in e && (this.offset.click.left = this.helperProportions.width - e.right + this.margins.left), \"top\" in e && (this.offset.click.top = e.top + this.margins.top), \"bottom\" in e && (this.offset.click.top = this.helperProportions.height - e.bottom + this.margins.top);\n    }, _getParentOffset: function _getParentOffset() {\n      this.offsetParent = this.helper.offsetParent();var e = this.offsetParent.offset();return \"absolute\" === this.cssPosition && this.scrollParent[0] !== this.document[0] && t.contains(this.scrollParent[0], this.offsetParent[0]) && (e.left += this.scrollParent.scrollLeft(), e.top += this.scrollParent.scrollTop()), (this.offsetParent[0] === this.document[0].body || this.offsetParent[0].tagName && \"html\" === this.offsetParent[0].tagName.toLowerCase() && t.ui.ie) && (e = { top: 0, left: 0 }), { top: e.top + (parseInt(this.offsetParent.css(\"borderTopWidth\"), 10) || 0), left: e.left + (parseInt(this.offsetParent.css(\"borderLeftWidth\"), 10) || 0) };\n    }, _getRelativeOffset: function _getRelativeOffset() {\n      if (\"relative\" === this.cssPosition) {\n        var t = this.currentItem.position();return { top: t.top - (parseInt(this.helper.css(\"top\"), 10) || 0) + this.scrollParent.scrollTop(), left: t.left - (parseInt(this.helper.css(\"left\"), 10) || 0) + this.scrollParent.scrollLeft() };\n      }return { top: 0, left: 0 };\n    }, _cacheMargins: function _cacheMargins() {\n      this.margins = { left: parseInt(this.currentItem.css(\"marginLeft\"), 10) || 0, top: parseInt(this.currentItem.css(\"marginTop\"), 10) || 0 };\n    }, _cacheHelperProportions: function _cacheHelperProportions() {\n      this.helperProportions = { width: this.helper.outerWidth(), height: this.helper.outerHeight() };\n    }, _setContainment: function _setContainment() {\n      var e,\n          i,\n          s,\n          n = this.options;\"parent\" === n.containment && (n.containment = this.helper[0].parentNode), (\"document\" === n.containment || \"window\" === n.containment) && (this.containment = [0 - this.offset.relative.left - this.offset.parent.left, 0 - this.offset.relative.top - this.offset.parent.top, \"document\" === n.containment ? this.document.width() : this.window.width() - this.helperProportions.width - this.margins.left, (\"document\" === n.containment ? this.document.height() || document.body.parentNode.scrollHeight : this.window.height() || this.document[0].body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top]), /^(document|window|parent)$/.test(n.containment) || (e = t(n.containment)[0], i = t(n.containment).offset(), s = \"hidden\" !== t(e).css(\"overflow\"), this.containment = [i.left + (parseInt(t(e).css(\"borderLeftWidth\"), 10) || 0) + (parseInt(t(e).css(\"paddingLeft\"), 10) || 0) - this.margins.left, i.top + (parseInt(t(e).css(\"borderTopWidth\"), 10) || 0) + (parseInt(t(e).css(\"paddingTop\"), 10) || 0) - this.margins.top, i.left + (s ? Math.max(e.scrollWidth, e.offsetWidth) : e.offsetWidth) - (parseInt(t(e).css(\"borderLeftWidth\"), 10) || 0) - (parseInt(t(e).css(\"paddingRight\"), 10) || 0) - this.helperProportions.width - this.margins.left, i.top + (s ? Math.max(e.scrollHeight, e.offsetHeight) : e.offsetHeight) - (parseInt(t(e).css(\"borderTopWidth\"), 10) || 0) - (parseInt(t(e).css(\"paddingBottom\"), 10) || 0) - this.helperProportions.height - this.margins.top]);\n    }, _convertPositionTo: function _convertPositionTo(e, i) {\n      i || (i = this.position);var s = \"absolute\" === e ? 1 : -1,\n          n = \"absolute\" !== this.cssPosition || this.scrollParent[0] !== this.document[0] && t.contains(this.scrollParent[0], this.offsetParent[0]) ? this.scrollParent : this.offsetParent,\n          o = /(html|body)/i.test(n[0].tagName);return { top: i.top + this.offset.relative.top * s + this.offset.parent.top * s - (\"fixed\" === this.cssPosition ? -this.scrollParent.scrollTop() : o ? 0 : n.scrollTop()) * s, left: i.left + this.offset.relative.left * s + this.offset.parent.left * s - (\"fixed\" === this.cssPosition ? -this.scrollParent.scrollLeft() : o ? 0 : n.scrollLeft()) * s };\n    }, _generatePosition: function _generatePosition(e) {\n      var i,\n          s,\n          n = this.options,\n          o = e.pageX,\n          a = e.pageY,\n          r = \"absolute\" !== this.cssPosition || this.scrollParent[0] !== this.document[0] && t.contains(this.scrollParent[0], this.offsetParent[0]) ? this.scrollParent : this.offsetParent,\n          h = /(html|body)/i.test(r[0].tagName);return \"relative\" !== this.cssPosition || this.scrollParent[0] !== this.document[0] && this.scrollParent[0] !== this.offsetParent[0] || (this.offset.relative = this._getRelativeOffset()), this.originalPosition && (this.containment && (e.pageX - this.offset.click.left < this.containment[0] && (o = this.containment[0] + this.offset.click.left), e.pageY - this.offset.click.top < this.containment[1] && (a = this.containment[1] + this.offset.click.top), e.pageX - this.offset.click.left > this.containment[2] && (o = this.containment[2] + this.offset.click.left), e.pageY - this.offset.click.top > this.containment[3] && (a = this.containment[3] + this.offset.click.top)), n.grid && (i = this.originalPageY + Math.round((a - this.originalPageY) / n.grid[1]) * n.grid[1], a = this.containment ? i - this.offset.click.top >= this.containment[1] && i - this.offset.click.top <= this.containment[3] ? i : i - this.offset.click.top >= this.containment[1] ? i - n.grid[1] : i + n.grid[1] : i, s = this.originalPageX + Math.round((o - this.originalPageX) / n.grid[0]) * n.grid[0], o = this.containment ? s - this.offset.click.left >= this.containment[0] && s - this.offset.click.left <= this.containment[2] ? s : s - this.offset.click.left >= this.containment[0] ? s - n.grid[0] : s + n.grid[0] : s)), { top: a - this.offset.click.top - this.offset.relative.top - this.offset.parent.top + (\"fixed\" === this.cssPosition ? -this.scrollParent.scrollTop() : h ? 0 : r.scrollTop()), left: o - this.offset.click.left - this.offset.relative.left - this.offset.parent.left + (\"fixed\" === this.cssPosition ? -this.scrollParent.scrollLeft() : h ? 0 : r.scrollLeft()) };\n    }, _rearrange: function _rearrange(t, e, i, s) {\n      i ? i[0].appendChild(this.placeholder[0]) : e.item[0].parentNode.insertBefore(this.placeholder[0], \"down\" === this.direction ? e.item[0] : e.item[0].nextSibling), this.counter = this.counter ? ++this.counter : 1;var n = this.counter;\n      this._delay(function () {\n        n === this.counter && this.refreshPositions(!s);\n      });\n    }, _clear: function _clear(t, e) {\n      function i(t, e, i) {\n        return function (s) {\n          i._trigger(t, s, e._uiHash(e));\n        };\n      }this.reverting = !1;var s,\n          n = [];if (!this._noFinalSort && this.currentItem.parent().length && this.placeholder.before(this.currentItem), this._noFinalSort = null, this.helper[0] === this.currentItem[0]) {\n        for (s in this._storedCSS) {\n          (\"auto\" === this._storedCSS[s] || \"static\" === this._storedCSS[s]) && (this._storedCSS[s] = \"\");\n        }this.currentItem.css(this._storedCSS), this._removeClass(this.currentItem, \"ui-sortable-helper\");\n      } else this.currentItem.show();for (this.fromOutside && !e && n.push(function (t) {\n        this._trigger(\"receive\", t, this._uiHash(this.fromOutside));\n      }), !this.fromOutside && this.domPosition.prev === this.currentItem.prev().not(\".ui-sortable-helper\")[0] && this.domPosition.parent === this.currentItem.parent()[0] || e || n.push(function (t) {\n        this._trigger(\"update\", t, this._uiHash());\n      }), this !== this.currentContainer && (e || (n.push(function (t) {\n        this._trigger(\"remove\", t, this._uiHash());\n      }), n.push(function (t) {\n        return function (e) {\n          t._trigger(\"receive\", e, this._uiHash(this));\n        };\n      }.call(this, this.currentContainer)), n.push(function (t) {\n        return function (e) {\n          t._trigger(\"update\", e, this._uiHash(this));\n        };\n      }.call(this, this.currentContainer)))), s = this.containers.length - 1; s >= 0; s--) {\n        e || n.push(i(\"deactivate\", this, this.containers[s])), this.containers[s].containerCache.over && (n.push(i(\"out\", this, this.containers[s])), this.containers[s].containerCache.over = 0);\n      }if (this.storedCursor && (this.document.find(\"body\").css(\"cursor\", this.storedCursor), this.storedStylesheet.remove()), this._storedOpacity && this.helper.css(\"opacity\", this._storedOpacity), this._storedZIndex && this.helper.css(\"zIndex\", \"auto\" === this._storedZIndex ? \"\" : this._storedZIndex), this.dragging = !1, e || this._trigger(\"beforeStop\", t, this._uiHash()), this.placeholder[0].parentNode.removeChild(this.placeholder[0]), this.cancelHelperRemoval || (this.helper[0] !== this.currentItem[0] && this.helper.remove(), this.helper = null), !e) {\n        for (s = 0; n.length > s; s++) {\n          n[s].call(this, t);\n        }this._trigger(\"stop\", t, this._uiHash());\n      }return this.fromOutside = !1, !this.cancelHelperRemoval;\n    }, _trigger: function _trigger() {\n      t.Widget.prototype._trigger.apply(this, arguments) === !1 && this.cancel();\n    }, _uiHash: function _uiHash(e) {\n      var i = e || this;return { helper: i.helper, placeholder: i.placeholder || t([]), position: i.position, originalPosition: i.originalPosition, offset: i.positionAbs, item: i.currentItem, sender: e ? e.element : null };\n    } }), t.widget(\"ui.spinner\", { version: \"1.12.1\", defaultElement: \"<input>\", widgetEventPrefix: \"spin\", options: { classes: { \"ui-spinner\": \"ui-corner-all\", \"ui-spinner-down\": \"ui-corner-br\", \"ui-spinner-up\": \"ui-corner-tr\" }, culture: null, icons: { down: \"ui-icon-triangle-1-s\", up: \"ui-icon-triangle-1-n\" }, incremental: !0, max: null, min: null, numberFormat: null, page: 10, step: 1, change: null, spin: null, start: null, stop: null }, _create: function _create() {\n      this._setOption(\"max\", this.options.max), this._setOption(\"min\", this.options.min), this._setOption(\"step\", this.options.step), \"\" !== this.value() && this._value(this.element.val(), !0), this._draw(), this._on(this._events), this._refresh(), this._on(this.window, { beforeunload: function beforeunload() {\n          this.element.removeAttr(\"autocomplete\");\n        } });\n    }, _getCreateOptions: function _getCreateOptions() {\n      var e = this._super(),\n          i = this.element;return t.each([\"min\", \"max\", \"step\"], function (t, s) {\n        var n = i.attr(s);null != n && n.length && (e[s] = n);\n      }), e;\n    }, _events: { keydown: function keydown(t) {\n        this._start(t) && this._keydown(t) && t.preventDefault();\n      }, keyup: \"_stop\", focus: function focus() {\n        this.previous = this.element.val();\n      }, blur: function blur(t) {\n        return this.cancelBlur ? (delete this.cancelBlur, void 0) : (this._stop(), this._refresh(), this.previous !== this.element.val() && this._trigger(\"change\", t), void 0);\n      }, mousewheel: function mousewheel(t, e) {\n        if (e) {\n          if (!this.spinning && !this._start(t)) return !1;this._spin((e > 0 ? 1 : -1) * this.options.step, t), clearTimeout(this.mousewheelTimer), this.mousewheelTimer = this._delay(function () {\n            this.spinning && this._stop(t);\n          }, 100), t.preventDefault();\n        }\n      }, \"mousedown .ui-spinner-button\": function mousedownUiSpinnerButton(e) {\n        function i() {\n          var e = this.element[0] === t.ui.safeActiveElement(this.document[0]);e || (this.element.trigger(\"focus\"), this.previous = s, this._delay(function () {\n            this.previous = s;\n          }));\n        }var s;s = this.element[0] === t.ui.safeActiveElement(this.document[0]) ? this.previous : this.element.val(), e.preventDefault(), i.call(this), this.cancelBlur = !0, this._delay(function () {\n          delete this.cancelBlur, i.call(this);\n        }), this._start(e) !== !1 && this._repeat(null, t(e.currentTarget).hasClass(\"ui-spinner-up\") ? 1 : -1, e);\n      }, \"mouseup .ui-spinner-button\": \"_stop\", \"mouseenter .ui-spinner-button\": function mouseenterUiSpinnerButton(e) {\n        return t(e.currentTarget).hasClass(\"ui-state-active\") ? this._start(e) === !1 ? !1 : (this._repeat(null, t(e.currentTarget).hasClass(\"ui-spinner-up\") ? 1 : -1, e), void 0) : void 0;\n      }, \"mouseleave .ui-spinner-button\": \"_stop\" }, _enhance: function _enhance() {\n      this.uiSpinner = this.element.attr(\"autocomplete\", \"off\").wrap(\"<span>\").parent().append(\"<a></a><a></a>\");\n    }, _draw: function _draw() {\n      this._enhance(), this._addClass(this.uiSpinner, \"ui-spinner\", \"ui-widget ui-widget-content\"), this._addClass(\"ui-spinner-input\"), this.element.attr(\"role\", \"spinbutton\"), this.buttons = this.uiSpinner.children(\"a\").attr(\"tabIndex\", -1).attr(\"aria-hidden\", !0).button({ classes: { \"ui-button\": \"\" } }), this._removeClass(this.buttons, \"ui-corner-all\"), this._addClass(this.buttons.first(), \"ui-spinner-button ui-spinner-up\"), this._addClass(this.buttons.last(), \"ui-spinner-button ui-spinner-down\"), this.buttons.first().button({ icon: this.options.icons.up, showLabel: !1 }), this.buttons.last().button({ icon: this.options.icons.down, showLabel: !1 }), this.buttons.height() > Math.ceil(.5 * this.uiSpinner.height()) && this.uiSpinner.height() > 0 && this.uiSpinner.height(this.uiSpinner.height());\n    }, _keydown: function _keydown(e) {\n      var i = this.options,\n          s = t.ui.keyCode;switch (e.keyCode) {case s.UP:\n          return this._repeat(null, 1, e), !0;case s.DOWN:\n          return this._repeat(null, -1, e), !0;case s.PAGE_UP:\n          return this._repeat(null, i.page, e), !0;case s.PAGE_DOWN:\n          return this._repeat(null, -i.page, e), !0;}return !1;\n    }, _start: function _start(t) {\n      return this.spinning || this._trigger(\"start\", t) !== !1 ? (this.counter || (this.counter = 1), this.spinning = !0, !0) : !1;\n    }, _repeat: function _repeat(t, e, i) {\n      t = t || 500, clearTimeout(this.timer), this.timer = this._delay(function () {\n        this._repeat(40, e, i);\n      }, t), this._spin(e * this.options.step, i);\n    }, _spin: function _spin(t, e) {\n      var i = this.value() || 0;this.counter || (this.counter = 1), i = this._adjustValue(i + t * this._increment(this.counter)), this.spinning && this._trigger(\"spin\", e, { value: i }) === !1 || (this._value(i), this.counter++);\n    }, _increment: function _increment(e) {\n      var i = this.options.incremental;return i ? t.isFunction(i) ? i(e) : Math.floor(e * e * e / 5e4 - e * e / 500 + 17 * e / 200 + 1) : 1;\n    }, _precision: function _precision() {\n      var t = this._precisionOf(this.options.step);return null !== this.options.min && (t = Math.max(t, this._precisionOf(this.options.min))), t;\n    }, _precisionOf: function _precisionOf(t) {\n      var e = \"\" + t,\n          i = e.indexOf(\".\");return -1 === i ? 0 : e.length - i - 1;\n    }, _adjustValue: function _adjustValue(t) {\n      var e,\n          i,\n          s = this.options;return e = null !== s.min ? s.min : 0, i = t - e, i = Math.round(i / s.step) * s.step, t = e + i, t = parseFloat(t.toFixed(this._precision())), null !== s.max && t > s.max ? s.max : null !== s.min && s.min > t ? s.min : t;\n    }, _stop: function _stop(t) {\n      this.spinning && (clearTimeout(this.timer), clearTimeout(this.mousewheelTimer), this.counter = 0, this.spinning = !1, this._trigger(\"stop\", t));\n    }, _setOption: function _setOption(t, e) {\n      var i, s, n;return \"culture\" === t || \"numberFormat\" === t ? (i = this._parse(this.element.val()), this.options[t] = e, this.element.val(this._format(i)), void 0) : ((\"max\" === t || \"min\" === t || \"step\" === t) && \"string\" == typeof e && (e = this._parse(e)), \"icons\" === t && (s = this.buttons.first().find(\".ui-icon\"), this._removeClass(s, null, this.options.icons.up), this._addClass(s, null, e.up), n = this.buttons.last().find(\".ui-icon\"), this._removeClass(n, null, this.options.icons.down), this._addClass(n, null, e.down)), this._super(t, e), void 0);\n    }, _setOptionDisabled: function _setOptionDisabled(t) {\n      this._super(t), this._toggleClass(this.uiSpinner, null, \"ui-state-disabled\", !!t), this.element.prop(\"disabled\", !!t), this.buttons.button(t ? \"disable\" : \"enable\");\n    }, _setOptions: r(function (t) {\n      this._super(t);\n    }), _parse: function _parse(t) {\n      return \"string\" == typeof t && \"\" !== t && (t = window.Globalize && this.options.numberFormat ? Globalize.parseFloat(t, 10, this.options.culture) : +t), \"\" === t || isNaN(t) ? null : t;\n    }, _format: function _format(t) {\n      return \"\" === t ? \"\" : window.Globalize && this.options.numberFormat ? Globalize.format(t, this.options.numberFormat, this.options.culture) : t;\n    }, _refresh: function _refresh() {\n      this.element.attr({ \"aria-valuemin\": this.options.min, \"aria-valuemax\": this.options.max, \"aria-valuenow\": this._parse(this.element.val()) });\n    }, isValid: function isValid() {\n      var t = this.value();return null === t ? !1 : t === this._adjustValue(t);\n    }, _value: function _value(t, e) {\n      var i;\"\" !== t && (i = this._parse(t), null !== i && (e || (i = this._adjustValue(i)), t = this._format(i))), this.element.val(t), this._refresh();\n    }, _destroy: function _destroy() {\n      this.element.prop(\"disabled\", !1).removeAttr(\"autocomplete role aria-valuemin aria-valuemax aria-valuenow\"), this.uiSpinner.replaceWith(this.element);\n    }, stepUp: r(function (t) {\n      this._stepUp(t);\n    }), _stepUp: function _stepUp(t) {\n      this._start() && (this._spin((t || 1) * this.options.step), this._stop());\n    }, stepDown: r(function (t) {\n      this._stepDown(t);\n    }), _stepDown: function _stepDown(t) {\n      this._start() && (this._spin((t || 1) * -this.options.step), this._stop());\n    }, pageUp: r(function (t) {\n      this._stepUp((t || 1) * this.options.page);\n    }), pageDown: r(function (t) {\n      this._stepDown((t || 1) * this.options.page);\n    }), value: function value(t) {\n      return arguments.length ? (r(this._value).call(this, t), void 0) : this._parse(this.element.val());\n    }, widget: function widget() {\n      return this.uiSpinner;\n    } }), t.uiBackCompat !== !1 && t.widget(\"ui.spinner\", t.ui.spinner, { _enhance: function _enhance() {\n      this.uiSpinner = this.element.attr(\"autocomplete\", \"off\").wrap(this._uiSpinnerHtml()).parent().append(this._buttonHtml());\n    }, _uiSpinnerHtml: function _uiSpinnerHtml() {\n      return \"<span>\";\n    }, _buttonHtml: function _buttonHtml() {\n      return \"<a></a><a></a>\";\n    } }), t.ui.spinner, t.widget(\"ui.tabs\", { version: \"1.12.1\", delay: 300, options: { active: null, classes: { \"ui-tabs\": \"ui-corner-all\", \"ui-tabs-nav\": \"ui-corner-all\", \"ui-tabs-panel\": \"ui-corner-bottom\", \"ui-tabs-tab\": \"ui-corner-top\" }, collapsible: !1, event: \"click\", heightStyle: \"content\", hide: null, show: null, activate: null, beforeActivate: null, beforeLoad: null, load: null }, _isLocal: function () {\n      var t = /#.*$/;return function (e) {\n        var i, s;i = e.href.replace(t, \"\"), s = location.href.replace(t, \"\");try {\n          i = decodeURIComponent(i);\n        } catch (n) {}try {\n          s = decodeURIComponent(s);\n        } catch (n) {}return e.hash.length > 1 && i === s;\n      };\n    }(), _create: function _create() {\n      var e = this,\n          i = this.options;this.running = !1, this._addClass(\"ui-tabs\", \"ui-widget ui-widget-content\"), this._toggleClass(\"ui-tabs-collapsible\", null, i.collapsible), this._processTabs(), i.active = this._initialActive(), t.isArray(i.disabled) && (i.disabled = t.unique(i.disabled.concat(t.map(this.tabs.filter(\".ui-state-disabled\"), function (t) {\n        return e.tabs.index(t);\n      }))).sort()), this.active = this.options.active !== !1 && this.anchors.length ? this._findActive(i.active) : t(), this._refresh(), this.active.length && this.load(i.active);\n    }, _initialActive: function _initialActive() {\n      var e = this.options.active,\n          i = this.options.collapsible,\n          s = location.hash.substring(1);return null === e && (s && this.tabs.each(function (i, n) {\n        return t(n).attr(\"aria-controls\") === s ? (e = i, !1) : void 0;\n      }), null === e && (e = this.tabs.index(this.tabs.filter(\".ui-tabs-active\"))), (null === e || -1 === e) && (e = this.tabs.length ? 0 : !1)), e !== !1 && (e = this.tabs.index(this.tabs.eq(e)), -1 === e && (e = i ? !1 : 0)), !i && e === !1 && this.anchors.length && (e = 0), e;\n    }, _getCreateEventData: function _getCreateEventData() {\n      return { tab: this.active, panel: this.active.length ? this._getPanelForTab(this.active) : t() };\n    }, _tabKeydown: function _tabKeydown(e) {\n      var i = t(t.ui.safeActiveElement(this.document[0])).closest(\"li\"),\n          s = this.tabs.index(i),\n          n = !0;if (!this._handlePageNav(e)) {\n        switch (e.keyCode) {case t.ui.keyCode.RIGHT:case t.ui.keyCode.DOWN:\n            s++;break;case t.ui.keyCode.UP:case t.ui.keyCode.LEFT:\n            n = !1, s--;break;case t.ui.keyCode.END:\n            s = this.anchors.length - 1;break;case t.ui.keyCode.HOME:\n            s = 0;break;case t.ui.keyCode.SPACE:\n            return e.preventDefault(), clearTimeout(this.activating), this._activate(s), void 0;case t.ui.keyCode.ENTER:\n            return e.preventDefault(), clearTimeout(this.activating), this._activate(s === this.options.active ? !1 : s), void 0;default:\n            return;}e.preventDefault(), clearTimeout(this.activating), s = this._focusNextTab(s, n), e.ctrlKey || e.metaKey || (i.attr(\"aria-selected\", \"false\"), this.tabs.eq(s).attr(\"aria-selected\", \"true\"), this.activating = this._delay(function () {\n          this.option(\"active\", s);\n        }, this.delay));\n      }\n    }, _panelKeydown: function _panelKeydown(e) {\n      this._handlePageNav(e) || e.ctrlKey && e.keyCode === t.ui.keyCode.UP && (e.preventDefault(), this.active.trigger(\"focus\"));\n    }, _handlePageNav: function _handlePageNav(e) {\n      return e.altKey && e.keyCode === t.ui.keyCode.PAGE_UP ? (this._activate(this._focusNextTab(this.options.active - 1, !1)), !0) : e.altKey && e.keyCode === t.ui.keyCode.PAGE_DOWN ? (this._activate(this._focusNextTab(this.options.active + 1, !0)), !0) : void 0;\n    }, _findNextTab: function _findNextTab(e, i) {\n      function s() {\n        return e > n && (e = 0), 0 > e && (e = n), e;\n      }for (var n = this.tabs.length - 1; -1 !== t.inArray(s(), this.options.disabled);) {\n        e = i ? e + 1 : e - 1;\n      }return e;\n    }, _focusNextTab: function _focusNextTab(t, e) {\n      return t = this._findNextTab(t, e), this.tabs.eq(t).trigger(\"focus\"), t;\n    }, _setOption: function _setOption(t, e) {\n      return \"active\" === t ? (this._activate(e), void 0) : (this._super(t, e), \"collapsible\" === t && (this._toggleClass(\"ui-tabs-collapsible\", null, e), e || this.options.active !== !1 || this._activate(0)), \"event\" === t && this._setupEvents(e), \"heightStyle\" === t && this._setupHeightStyle(e), void 0);\n    }, _sanitizeSelector: function _sanitizeSelector(t) {\n      return t ? t.replace(/[!\"$%&'()*+,.\\/:;<=>?@\\[\\]\\^`{|}~]/g, \"\\\\$&\") : \"\";\n    }, refresh: function refresh() {\n      var e = this.options,\n          i = this.tablist.children(\":has(a[href])\");e.disabled = t.map(i.filter(\".ui-state-disabled\"), function (t) {\n        return i.index(t);\n      }), this._processTabs(), e.active !== !1 && this.anchors.length ? this.active.length && !t.contains(this.tablist[0], this.active[0]) ? this.tabs.length === e.disabled.length ? (e.active = !1, this.active = t()) : this._activate(this._findNextTab(Math.max(0, e.active - 1), !1)) : e.active = this.tabs.index(this.active) : (e.active = !1, this.active = t()), this._refresh();\n    }, _refresh: function _refresh() {\n      this._setOptionDisabled(this.options.disabled), this._setupEvents(this.options.event), this._setupHeightStyle(this.options.heightStyle), this.tabs.not(this.active).attr({ \"aria-selected\": \"false\", \"aria-expanded\": \"false\", tabIndex: -1 }), this.panels.not(this._getPanelForTab(this.active)).hide().attr({ \"aria-hidden\": \"true\" }), this.active.length ? (this.active.attr({ \"aria-selected\": \"true\", \"aria-expanded\": \"true\", tabIndex: 0 }), this._addClass(this.active, \"ui-tabs-active\", \"ui-state-active\"), this._getPanelForTab(this.active).show().attr({ \"aria-hidden\": \"false\" })) : this.tabs.eq(0).attr(\"tabIndex\", 0);\n    }, _processTabs: function _processTabs() {\n      var e = this,\n          i = this.tabs,\n          s = this.anchors,\n          n = this.panels;this.tablist = this._getList().attr(\"role\", \"tablist\"), this._addClass(this.tablist, \"ui-tabs-nav\", \"ui-helper-reset ui-helper-clearfix ui-widget-header\"), this.tablist.on(\"mousedown\" + this.eventNamespace, \"> li\", function (e) {\n        t(this).is(\".ui-state-disabled\") && e.preventDefault();\n      }).on(\"focus\" + this.eventNamespace, \".ui-tabs-anchor\", function () {\n        t(this).closest(\"li\").is(\".ui-state-disabled\") && this.blur();\n      }), this.tabs = this.tablist.find(\"> li:has(a[href])\").attr({ role: \"tab\", tabIndex: -1 }), this._addClass(this.tabs, \"ui-tabs-tab\", \"ui-state-default\"), this.anchors = this.tabs.map(function () {\n        return t(\"a\", this)[0];\n      }).attr({ role: \"presentation\", tabIndex: -1 }), this._addClass(this.anchors, \"ui-tabs-anchor\"), this.panels = t(), this.anchors.each(function (i, s) {\n        var n,\n            o,\n            a,\n            r = t(s).uniqueId().attr(\"id\"),\n            h = t(s).closest(\"li\"),\n            l = h.attr(\"aria-controls\");e._isLocal(s) ? (n = s.hash, a = n.substring(1), o = e.element.find(e._sanitizeSelector(n))) : (a = h.attr(\"aria-controls\") || t({}).uniqueId()[0].id, n = \"#\" + a, o = e.element.find(n), o.length || (o = e._createPanel(a), o.insertAfter(e.panels[i - 1] || e.tablist)), o.attr(\"aria-live\", \"polite\")), o.length && (e.panels = e.panels.add(o)), l && h.data(\"ui-tabs-aria-controls\", l), h.attr({ \"aria-controls\": a, \"aria-labelledby\": r }), o.attr(\"aria-labelledby\", r);\n      }), this.panels.attr(\"role\", \"tabpanel\"), this._addClass(this.panels, \"ui-tabs-panel\", \"ui-widget-content\"), i && (this._off(i.not(this.tabs)), this._off(s.not(this.anchors)), this._off(n.not(this.panels)));\n    }, _getList: function _getList() {\n      return this.tablist || this.element.find(\"ol, ul\").eq(0);\n    }, _createPanel: function _createPanel(e) {\n      return t(\"<div>\").attr(\"id\", e).data(\"ui-tabs-destroy\", !0);\n    }, _setOptionDisabled: function _setOptionDisabled(e) {\n      var i, s, n;for (t.isArray(e) && (e.length ? e.length === this.anchors.length && (e = !0) : e = !1), n = 0; s = this.tabs[n]; n++) {\n        i = t(s), e === !0 || -1 !== t.inArray(n, e) ? (i.attr(\"aria-disabled\", \"true\"), this._addClass(i, null, \"ui-state-disabled\")) : (i.removeAttr(\"aria-disabled\"), this._removeClass(i, null, \"ui-state-disabled\"));\n      }this.options.disabled = e, this._toggleClass(this.widget(), this.widgetFullName + \"-disabled\", null, e === !0);\n    }, _setupEvents: function _setupEvents(e) {\n      var i = {};e && t.each(e.split(\" \"), function (t, e) {\n        i[e] = \"_eventHandler\";\n      }), this._off(this.anchors.add(this.tabs).add(this.panels)), this._on(!0, this.anchors, { click: function click(t) {\n          t.preventDefault();\n        } }), this._on(this.anchors, i), this._on(this.tabs, { keydown: \"_tabKeydown\" }), this._on(this.panels, { keydown: \"_panelKeydown\" }), this._focusable(this.tabs), this._hoverable(this.tabs);\n    }, _setupHeightStyle: function _setupHeightStyle(e) {\n      var i,\n          s = this.element.parent();\"fill\" === e ? (i = s.height(), i -= this.element.outerHeight() - this.element.height(), this.element.siblings(\":visible\").each(function () {\n        var e = t(this),\n            s = e.css(\"position\");\"absolute\" !== s && \"fixed\" !== s && (i -= e.outerHeight(!0));\n      }), this.element.children().not(this.panels).each(function () {\n        i -= t(this).outerHeight(!0);\n      }), this.panels.each(function () {\n        t(this).height(Math.max(0, i - t(this).innerHeight() + t(this).height()));\n      }).css(\"overflow\", \"auto\")) : \"auto\" === e && (i = 0, this.panels.each(function () {\n        i = Math.max(i, t(this).height(\"\").height());\n      }).height(i));\n    }, _eventHandler: function _eventHandler(e) {\n      var i = this.options,\n          s = this.active,\n          n = t(e.currentTarget),\n          o = n.closest(\"li\"),\n          a = o[0] === s[0],\n          r = a && i.collapsible,\n          h = r ? t() : this._getPanelForTab(o),\n          l = s.length ? this._getPanelForTab(s) : t(),\n          c = { oldTab: s, oldPanel: l, newTab: r ? t() : o, newPanel: h };e.preventDefault(), o.hasClass(\"ui-state-disabled\") || o.hasClass(\"ui-tabs-loading\") || this.running || a && !i.collapsible || this._trigger(\"beforeActivate\", e, c) === !1 || (i.active = r ? !1 : this.tabs.index(o), this.active = a ? t() : o, this.xhr && this.xhr.abort(), l.length || h.length || t.error(\"jQuery UI Tabs: Mismatching fragment identifier.\"), h.length && this.load(this.tabs.index(o), e), this._toggle(e, c));\n    }, _toggle: function _toggle(e, i) {\n      function s() {\n        o.running = !1, o._trigger(\"activate\", e, i);\n      }function n() {\n        o._addClass(i.newTab.closest(\"li\"), \"ui-tabs-active\", \"ui-state-active\"), a.length && o.options.show ? o._show(a, o.options.show, s) : (a.show(), s());\n      }var o = this,\n          a = i.newPanel,\n          r = i.oldPanel;this.running = !0, r.length && this.options.hide ? this._hide(r, this.options.hide, function () {\n        o._removeClass(i.oldTab.closest(\"li\"), \"ui-tabs-active\", \"ui-state-active\"), n();\n      }) : (this._removeClass(i.oldTab.closest(\"li\"), \"ui-tabs-active\", \"ui-state-active\"), r.hide(), n()), r.attr(\"aria-hidden\", \"true\"), i.oldTab.attr({ \"aria-selected\": \"false\", \"aria-expanded\": \"false\" }), a.length && r.length ? i.oldTab.attr(\"tabIndex\", -1) : a.length && this.tabs.filter(function () {\n        return 0 === t(this).attr(\"tabIndex\");\n      }).attr(\"tabIndex\", -1), a.attr(\"aria-hidden\", \"false\"), i.newTab.attr({ \"aria-selected\": \"true\", \"aria-expanded\": \"true\", tabIndex: 0 });\n    }, _activate: function _activate(e) {\n      var i,\n          s = this._findActive(e);s[0] !== this.active[0] && (s.length || (s = this.active), i = s.find(\".ui-tabs-anchor\")[0], this._eventHandler({ target: i, currentTarget: i, preventDefault: t.noop }));\n    }, _findActive: function _findActive(e) {\n      return e === !1 ? t() : this.tabs.eq(e);\n    }, _getIndex: function _getIndex(e) {\n      return \"string\" == typeof e && (e = this.anchors.index(this.anchors.filter(\"[href$='\" + t.ui.escapeSelector(e) + \"']\"))), e;\n    }, _destroy: function _destroy() {\n      this.xhr && this.xhr.abort(), this.tablist.removeAttr(\"role\").off(this.eventNamespace), this.anchors.removeAttr(\"role tabIndex\").removeUniqueId(), this.tabs.add(this.panels).each(function () {\n        t.data(this, \"ui-tabs-destroy\") ? t(this).remove() : t(this).removeAttr(\"role tabIndex aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded\");\n      }), this.tabs.each(function () {\n        var e = t(this),\n            i = e.data(\"ui-tabs-aria-controls\");i ? e.attr(\"aria-controls\", i).removeData(\"ui-tabs-aria-controls\") : e.removeAttr(\"aria-controls\");\n      }), this.panels.show(), \"content\" !== this.options.heightStyle && this.panels.css(\"height\", \"\");\n    }, enable: function enable(e) {\n      var i = this.options.disabled;i !== !1 && (void 0 === e ? i = !1 : (e = this._getIndex(e), i = t.isArray(i) ? t.map(i, function (t) {\n        return t !== e ? t : null;\n      }) : t.map(this.tabs, function (t, i) {\n        return i !== e ? i : null;\n      })), this._setOptionDisabled(i));\n    }, disable: function disable(e) {\n      var i = this.options.disabled;if (i !== !0) {\n        if (void 0 === e) i = !0;else {\n          if (e = this._getIndex(e), -1 !== t.inArray(e, i)) return;i = t.isArray(i) ? t.merge([e], i).sort() : [e];\n        }this._setOptionDisabled(i);\n      }\n    }, load: function load(e, i) {\n      e = this._getIndex(e);var s = this,\n          n = this.tabs.eq(e),\n          o = n.find(\".ui-tabs-anchor\"),\n          a = this._getPanelForTab(n),\n          r = { tab: n, panel: a },\n          h = function h(t, e) {\n        \"abort\" === e && s.panels.stop(!1, !0), s._removeClass(n, \"ui-tabs-loading\"), a.removeAttr(\"aria-busy\"), t === s.xhr && delete s.xhr;\n      };this._isLocal(o[0]) || (this.xhr = t.ajax(this._ajaxSettings(o, i, r)), this.xhr && \"canceled\" !== this.xhr.statusText && (this._addClass(n, \"ui-tabs-loading\"), a.attr(\"aria-busy\", \"true\"), this.xhr.done(function (t, e, n) {\n        setTimeout(function () {\n          a.html(t), s._trigger(\"load\", i, r), h(n, e);\n        }, 1);\n      }).fail(function (t, e) {\n        setTimeout(function () {\n          h(t, e);\n        }, 1);\n      })));\n    }, _ajaxSettings: function _ajaxSettings(e, i, s) {\n      var n = this;return { url: e.attr(\"href\").replace(/#.*$/, \"\"), beforeSend: function beforeSend(e, o) {\n          return n._trigger(\"beforeLoad\", i, t.extend({ jqXHR: e, ajaxSettings: o }, s));\n        } };\n    }, _getPanelForTab: function _getPanelForTab(e) {\n      var i = t(e).attr(\"aria-controls\");return this.element.find(this._sanitizeSelector(\"#\" + i));\n    } }), t.uiBackCompat !== !1 && t.widget(\"ui.tabs\", t.ui.tabs, { _processTabs: function _processTabs() {\n      this._superApply(arguments), this._addClass(this.tabs, \"ui-tab\");\n    } }), t.ui.tabs, t.widget(\"ui.tooltip\", { version: \"1.12.1\", options: { classes: { \"ui-tooltip\": \"ui-corner-all ui-widget-shadow\" }, content: function content() {\n        var e = t(this).attr(\"title\") || \"\";return t(\"<a>\").text(e).html();\n      }, hide: !0, items: \"[title]:not([disabled])\", position: { my: \"left top+15\", at: \"left bottom\", collision: \"flipfit flip\" }, show: !0, track: !1, close: null, open: null }, _addDescribedBy: function _addDescribedBy(e, i) {\n      var s = (e.attr(\"aria-describedby\") || \"\").split(/\\s+/);s.push(i), e.data(\"ui-tooltip-id\", i).attr(\"aria-describedby\", t.trim(s.join(\" \")));\n    }, _removeDescribedBy: function _removeDescribedBy(e) {\n      var i = e.data(\"ui-tooltip-id\"),\n          s = (e.attr(\"aria-describedby\") || \"\").split(/\\s+/),\n          n = t.inArray(i, s);-1 !== n && s.splice(n, 1), e.removeData(\"ui-tooltip-id\"), s = t.trim(s.join(\" \")), s ? e.attr(\"aria-describedby\", s) : e.removeAttr(\"aria-describedby\");\n    }, _create: function _create() {\n      this._on({ mouseover: \"open\", focusin: \"open\" }), this.tooltips = {}, this.parents = {}, this.liveRegion = t(\"<div>\").attr({ role: \"log\", \"aria-live\": \"assertive\", \"aria-relevant\": \"additions\" }).appendTo(this.document[0].body), this._addClass(this.liveRegion, null, \"ui-helper-hidden-accessible\"), this.disabledTitles = t([]);\n    }, _setOption: function _setOption(e, i) {\n      var s = this;this._super(e, i), \"content\" === e && t.each(this.tooltips, function (t, e) {\n        s._updateContent(e.element);\n      });\n    }, _setOptionDisabled: function _setOptionDisabled(t) {\n      this[t ? \"_disable\" : \"_enable\"]();\n    }, _disable: function _disable() {\n      var e = this;t.each(this.tooltips, function (i, s) {\n        var n = t.Event(\"blur\");n.target = n.currentTarget = s.element[0], e.close(n, !0);\n      }), this.disabledTitles = this.disabledTitles.add(this.element.find(this.options.items).addBack().filter(function () {\n        var e = t(this);return e.is(\"[title]\") ? e.data(\"ui-tooltip-title\", e.attr(\"title\")).removeAttr(\"title\") : void 0;\n      }));\n    }, _enable: function _enable() {\n      this.disabledTitles.each(function () {\n        var e = t(this);e.data(\"ui-tooltip-title\") && e.attr(\"title\", e.data(\"ui-tooltip-title\"));\n      }), this.disabledTitles = t([]);\n    }, open: function open(e) {\n      var i = this,\n          s = t(e ? e.target : this.element).closest(this.options.items);s.length && !s.data(\"ui-tooltip-id\") && (s.attr(\"title\") && s.data(\"ui-tooltip-title\", s.attr(\"title\")), s.data(\"ui-tooltip-open\", !0), e && \"mouseover\" === e.type && s.parents().each(function () {\n        var e,\n            s = t(this);s.data(\"ui-tooltip-open\") && (e = t.Event(\"blur\"), e.target = e.currentTarget = this, i.close(e, !0)), s.attr(\"title\") && (s.uniqueId(), i.parents[this.id] = { element: this, title: s.attr(\"title\") }, s.attr(\"title\", \"\"));\n      }), this._registerCloseHandlers(e, s), this._updateContent(s, e));\n    }, _updateContent: function _updateContent(t, e) {\n      var i,\n          s = this.options.content,\n          n = this,\n          o = e ? e.type : null;return \"string\" == typeof s || s.nodeType || s.jquery ? this._open(e, t, s) : (i = s.call(t[0], function (i) {\n        n._delay(function () {\n          t.data(\"ui-tooltip-open\") && (e && (e.type = o), this._open(e, t, i));\n        });\n      }), i && this._open(e, t, i), void 0);\n    }, _open: function _open(e, i, s) {\n      function n(t) {\n        l.of = t, a.is(\":hidden\") || a.position(l);\n      }var o,\n          a,\n          r,\n          h,\n          l = t.extend({}, this.options.position);if (s) {\n        if (o = this._find(i)) return o.tooltip.find(\".ui-tooltip-content\").html(s), void 0;i.is(\"[title]\") && (e && \"mouseover\" === e.type ? i.attr(\"title\", \"\") : i.removeAttr(\"title\")), o = this._tooltip(i), a = o.tooltip, this._addDescribedBy(i, a.attr(\"id\")), a.find(\".ui-tooltip-content\").html(s), this.liveRegion.children().hide(), h = t(\"<div>\").html(a.find(\".ui-tooltip-content\").html()), h.removeAttr(\"name\").find(\"[name]\").removeAttr(\"name\"), h.removeAttr(\"id\").find(\"[id]\").removeAttr(\"id\"), h.appendTo(this.liveRegion), this.options.track && e && /^mouse/.test(e.type) ? (this._on(this.document, { mousemove: n }), n(e)) : a.position(t.extend({ of: i }, this.options.position)), a.hide(), this._show(a, this.options.show), this.options.track && this.options.show && this.options.show.delay && (r = this.delayedShow = setInterval(function () {\n          a.is(\":visible\") && (n(l.of), clearInterval(r));\n        }, t.fx.interval)), this._trigger(\"open\", e, { tooltip: a });\n      }\n    }, _registerCloseHandlers: function _registerCloseHandlers(e, i) {\n      var s = { keyup: function keyup(e) {\n          if (e.keyCode === t.ui.keyCode.ESCAPE) {\n            var s = t.Event(e);s.currentTarget = i[0], this.close(s, !0);\n          }\n        } };i[0] !== this.element[0] && (s.remove = function () {\n        this._removeTooltip(this._find(i).tooltip);\n      }), e && \"mouseover\" !== e.type || (s.mouseleave = \"close\"), e && \"focusin\" !== e.type || (s.focusout = \"close\"), this._on(!0, i, s);\n    }, close: function close(e) {\n      var i,\n          s = this,\n          n = t(e ? e.currentTarget : this.element),\n          o = this._find(n);return o ? (i = o.tooltip, o.closing || (clearInterval(this.delayedShow), n.data(\"ui-tooltip-title\") && !n.attr(\"title\") && n.attr(\"title\", n.data(\"ui-tooltip-title\")), this._removeDescribedBy(n), o.hiding = !0, i.stop(!0), this._hide(i, this.options.hide, function () {\n        s._removeTooltip(t(this));\n      }), n.removeData(\"ui-tooltip-open\"), this._off(n, \"mouseleave focusout keyup\"), n[0] !== this.element[0] && this._off(n, \"remove\"), this._off(this.document, \"mousemove\"), e && \"mouseleave\" === e.type && t.each(this.parents, function (e, i) {\n        t(i.element).attr(\"title\", i.title), delete s.parents[e];\n      }), o.closing = !0, this._trigger(\"close\", e, { tooltip: i }), o.hiding || (o.closing = !1)), void 0) : (n.removeData(\"ui-tooltip-open\"), void 0);\n    }, _tooltip: function _tooltip(e) {\n      var i = t(\"<div>\").attr(\"role\", \"tooltip\"),\n          s = t(\"<div>\").appendTo(i),\n          n = i.uniqueId().attr(\"id\");return this._addClass(s, \"ui-tooltip-content\"), this._addClass(i, \"ui-tooltip\", \"ui-widget ui-widget-content\"), i.appendTo(this._appendTo(e)), this.tooltips[n] = { element: e, tooltip: i };\n    }, _find: function _find(t) {\n      var e = t.data(\"ui-tooltip-id\");return e ? this.tooltips[e] : null;\n    }, _removeTooltip: function _removeTooltip(t) {\n      t.remove(), delete this.tooltips[t.attr(\"id\")];\n    }, _appendTo: function _appendTo(t) {\n      var e = t.closest(\".ui-front, dialog\");return e.length || (e = this.document[0].body), e;\n    }, _destroy: function _destroy() {\n      var e = this;t.each(this.tooltips, function (i, s) {\n        var n = t.Event(\"blur\"),\n            o = s.element;n.target = n.currentTarget = o[0], e.close(n, !0), t(\"#\" + i).remove(), o.data(\"ui-tooltip-title\") && (o.attr(\"title\") || o.attr(\"title\", o.data(\"ui-tooltip-title\")), o.removeData(\"ui-tooltip-title\"));\n      }), this.liveRegion.remove();\n    } }), t.uiBackCompat !== !1 && t.widget(\"ui.tooltip\", t.ui.tooltip, { options: { tooltipClass: null }, _tooltip: function _tooltip() {\n      var t = this._superApply(arguments);return this.options.tooltipClass && t.tooltip.addClass(this.options.tooltipClass), t;\n    } }), t.ui.tooltip;\n});"

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(93))

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = "!function(e,t,n){function r(n){var r=t.console;i[n]||(i[n]=!0,e.migrateWarnings.push(n),r&&r.warn&&!e.migrateMute&&(r.warn(\"JQMIGRATE: \"+n),e.migrateTrace&&r.trace&&r.trace()))}function a(t,n,a,i){if(Object.defineProperty)try{return void Object.defineProperty(t,n,{configurable:!0,enumerable:!0,get:function(){return r(i),a},set:function(e){r(i),a=e}})}catch(e){}e._definePropertyBroken=!0,t[n]=a}var i={};e.migrateWarnings=[],!e.migrateMute&&t.console&&t.console.log&&t.console.log(\"JQMIGRATE: Logging is active\"),void 0===e.migrateTrace&&(e.migrateTrace=!0),e.migrateReset=function(){i={},e.migrateWarnings.length=0},\"BackCompat\"===document.compatMode&&r(\"jQuery is not compatible with Quirks Mode\");var o=e(\"<input/>\",{size:1}).attr(\"size\")&&e.attrFn,s=e.attr,u=e.attrHooks.value&&e.attrHooks.value.get||function(){return null},c=e.attrHooks.value&&e.attrHooks.value.set||function(){},d=/^(?:input|button)$/i,l=/^[238]$/,p=/^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i,f=/^(?:checked|selected)$/i;a(e,\"attrFn\",o||{},\"jQuery.attrFn is deprecated\"),e.attr=function(t,n,a,i){var u=n.toLowerCase(),c=t&&t.nodeType;return i&&(s.length<4&&r(\"jQuery.fn.attr( props, pass ) is deprecated\"),t&&!l.test(c)&&(o?n in o:e.isFunction(e.fn[n])))?e(t)[n](a):(\"type\"===n&&void 0!==a&&d.test(t.nodeName)&&t.parentNode&&r(\"Can't change the 'type' of an input or button in IE 6/7/8\"),!e.attrHooks[u]&&p.test(u)&&(e.attrHooks[u]={get:function(t,n){var r,a=e.prop(t,n);return!0===a||\"boolean\"!=typeof a&&(r=t.getAttributeNode(n))&&!1!==r.nodeValue?n.toLowerCase():void 0},set:function(t,n,r){var a;return!1===n?e.removeAttr(t,r):(a=e.propFix[r]||r,a in t&&(t[a]=!0),t.setAttribute(r,r.toLowerCase())),r}},f.test(u)&&r(\"jQuery.fn.attr('\"+u+\"') may use property instead of attribute\")),s.call(e,t,n,a))},e.attrHooks.value={get:function(e,t){var n=(e.nodeName||\"\").toLowerCase();return\"button\"===n?u.apply(this,arguments):(\"input\"!==n&&\"option\"!==n&&r(\"jQuery.fn.attr('value') no longer gets properties\"),t in e?e.value:null)},set:function(e,t){var n=(e.nodeName||\"\").toLowerCase();if(\"button\"===n)return c.apply(this,arguments);\"input\"!==n&&\"option\"!==n&&r(\"jQuery.fn.attr('value', val) no longer sets properties\"),e.value=t}};var v,h,g=e.fn.init,m=e.parseJSON,y=/^([^<]*)(<[\\w\\W]+>)([^>]*)$/;e.fn.init=function(t,n,a){var i;return t&&\"string\"==typeof t&&!e.isPlainObject(n)&&(i=y.exec(e.trim(t)))&&i[0]&&(\"<\"!==t.charAt(0)&&r(\"$(html) HTML strings must start with '<' character\"),i[3]&&r(\"$(html) HTML text after last tag is ignored\"),\"#\"===i[0].charAt(0)&&(r(\"HTML string cannot start with a '#' character\"),e.error(\"JQMIGRATE: Invalid selector string (XSS)\")),n&&n.context&&(n=n.context),e.parseHTML)?g.call(this,e.parseHTML(i[2],n,!0),n,a):g.apply(this,arguments)},e.fn.init.prototype=e.fn,e.parseJSON=function(e){return e||null===e?m.apply(this,arguments):(r(\"jQuery.parseJSON requires a valid JSON string\"),null)},e.uaMatch=function(e){e=e.toLowerCase();var t=/(chrome)[ \\/]([\\w.]+)/.exec(e)||/(webkit)[ \\/]([\\w.]+)/.exec(e)||/(opera)(?:.*version|)[ \\/]([\\w.]+)/.exec(e)||/(msie) ([\\w.]+)/.exec(e)||e.indexOf(\"compatible\")<0&&/(mozilla)(?:.*? rv:([\\w.]+)|)/.exec(e)||[];return{browser:t[1]||\"\",version:t[2]||\"0\"}},e.browser||(v=e.uaMatch(navigator.userAgent),h={},v.browser&&(h[v.browser]=!0,h.version=v.version),h.chrome?h.webkit=!0:h.webkit&&(h.safari=!0),e.browser=h),a(e,\"browser\",e.browser,\"jQuery.browser is deprecated\"),e.sub=function(){function t(e,n){return new t.fn.init(e,n)}e.extend(!0,t,this),t.superclass=this,t.fn=t.prototype=this(),t.fn.constructor=t,t.sub=this.sub,t.fn.init=function(r,a){return a&&a instanceof e&&!(a instanceof t)&&(a=t(a)),e.fn.init.call(this,r,a,n)},t.fn.init.prototype=t.fn;var n=t(document);return r(\"jQuery.sub() is deprecated\"),t},e.ajaxSetup({converters:{\"text json\":e.parseJSON}});var b=e.fn.data;e.fn.data=function(t){var n,a,i=this[0];return!i||\"events\"!==t||1!==arguments.length||(n=e.data(i,t),a=e._data(i,t),void 0!==n&&n!==a||void 0===a)?b.apply(this,arguments):(r(\"Use of jQuery.fn.data('events') is deprecated\"),a)};var w=/\\/(java|ecma)script/i,j=e.fn.andSelf||e.fn.addBack;e.fn.andSelf=function(){return r(\"jQuery.fn.andSelf() replaced by jQuery.fn.addBack()\"),j.apply(this,arguments)},e.clean||(e.clean=function(t,n,a,i){n=n||document,n=!n.nodeType&&n[0]||n,n=n.ownerDocument||n,r(\"jQuery.clean() is deprecated\");var o,s,u,c,d=[];if(e.merge(d,e.buildFragment(t,n).childNodes),a)for(u=function(e){if(!e.type||w.test(e.type))return i?i.push(e.parentNode?e.parentNode.removeChild(e):e):a.appendChild(e)},o=0;null!=(s=d[o]);o++)e.nodeName(s,\"script\")&&u(s)||(a.appendChild(s),void 0!==s.getElementsByTagName&&(c=e.grep(e.merge([],s.getElementsByTagName(\"script\")),u),d.splice.apply(d,[o+1,0].concat(c)),o+=c.length));return d});var x=e.event.add,Q=e.event.remove,k=e.event.trigger,N=e.fn.toggle,T=e.fn.live,S=e.fn.die,C=\"ajaxStart|ajaxStop|ajaxSend|ajaxComplete|ajaxError|ajaxSuccess\",M=new RegExp(\"\\\\b(?:\"+C+\")\\\\b\"),H=/(?:^|\\s)hover(\\.\\S+|)\\b/,A=function(t){return\"string\"!=typeof t||e.event.special.hover?t:(H.test(t)&&r(\"'hover' pseudo-event is deprecated, use 'mouseenter mouseleave'\"),t&&t.replace(H,\"mouseenter$1 mouseleave$1\"))};e.event.props&&\"attrChange\"!==e.event.props[0]&&e.event.props.unshift(\"attrChange\",\"attrName\",\"relatedNode\",\"srcElement\"),e.event.dispatch&&a(e.event,\"handle\",e.event.dispatch,\"jQuery.event.handle is undocumented and deprecated\"),e.event.add=function(e,t,n,a,i){e!==document&&M.test(t)&&r(\"AJAX events should be attached to document: \"+t),x.call(this,e,A(t||\"\"),n,a,i)},e.event.remove=function(e,t,n,r,a){Q.call(this,e,A(t)||\"\",n,r,a)},e.fn.error=function(){var e=Array.prototype.slice.call(arguments,0);return r(\"jQuery.fn.error() is deprecated\"),e.splice(0,0,\"error\"),arguments.length?this.bind.apply(this,e):(this.triggerHandler.apply(this,e),this)},e.fn.toggle=function(t,n){if(!e.isFunction(t)||!e.isFunction(n))return N.apply(this,arguments);r(\"jQuery.fn.toggle(handler, handler...) is deprecated\");var a=arguments,i=t.guid||e.guid++,o=0,s=function(n){var r=(e._data(this,\"lastToggle\"+t.guid)||0)%o;return e._data(this,\"lastToggle\"+t.guid,r+1),n.preventDefault(),a[r].apply(this,arguments)||!1};for(s.guid=i;o<a.length;)a[o++].guid=i;return this.click(s)},e.fn.live=function(t,n,a){return r(\"jQuery.fn.live() is deprecated\"),T?T.apply(this,arguments):(e(this.context).on(t,this.selector,n,a),this)},e.fn.die=function(t,n){return r(\"jQuery.fn.die() is deprecated\"),S?S.apply(this,arguments):(e(this.context).off(t,this.selector||\"**\",n),this)},e.event.trigger=function(e,t,n,a){return n||M.test(e)||r(\"Global events are undocumented and deprecated\"),k.call(this,e,t,n||document,a)},e.each(C.split(\"|\"),function(t,n){e.event.special[n]={setup:function(){var t=this;return t!==document&&(e.event.add(document,n+\".\"+e.guid,function(){e.event.trigger(n,null,t,!0)}),e._data(this,n,e.guid++)),!1},teardown:function(){return this!==document&&e.event.remove(document,n+\".\"+e._data(this,n)),!1}}})}(jQuery,window);"

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(95))

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	module.exports = "!function(e){\"function\"==typeof define&&define.amd?define([\"jquery\"],e):\"object\"==typeof module&&\"object\"==typeof module.exports?module.exports=e(require(\"jquery\")):e(jQuery)}(function(e){return function(t){\"use strict\";var r=t.tablesorter={version:\"2.28.14\",parsers:[],widgets:[],defaults:{theme:\"default\",widthFixed:!1,showProcessing:!1,headerTemplate:\"{content}\",onRenderTemplate:null,onRenderHeader:null,cancelSelection:!0,tabIndex:!0,dateFormat:\"mmddyyyy\",sortMultiSortKey:\"shiftKey\",sortResetKey:\"ctrlKey\",usNumberFormat:!0,delayInit:!1,serverSideSorting:!1,resort:!0,headers:{},ignoreCase:!0,sortForce:null,sortList:[],sortAppend:null,sortStable:!1,sortInitialOrder:\"asc\",sortLocaleCompare:!1,sortReset:!1,sortRestart:!1,emptyTo:\"bottom\",stringTo:\"max\",duplicateSpan:!0,textExtraction:\"basic\",textAttribute:\"data-text\",textSorter:null,numberSorter:null,initWidgets:!0,widgetClass:\"widget-{name}\",widgets:[],widgetOptions:{zebra:[\"even\",\"odd\"]},initialized:null,tableClass:\"\",cssAsc:\"\",cssDesc:\"\",cssNone:\"\",cssHeader:\"\",cssHeaderRow:\"\",cssProcessing:\"\",cssChildRow:\"tablesorter-childRow\",cssInfoBlock:\"tablesorter-infoOnly\",cssNoSort:\"tablesorter-noSort\",cssIgnoreRow:\"tablesorter-ignoreRow\",cssIcon:\"tablesorter-icon\",cssIconNone:\"\",cssIconAsc:\"\",cssIconDesc:\"\",cssIconDisabled:\"\",pointerClick:\"click\",pointerDown:\"mousedown\",pointerUp:\"mouseup\",selectorHeaders:\"> thead th, > thead td\",selectorSort:\"th, td\",selectorRemove:\".remove-me\",debug:!1,headerList:[],empties:{},strings:{},parsers:[],globalize:0,imgAttr:0},css:{table:\"tablesorter\",cssHasChild:\"tablesorter-hasChildRow\",childRow:\"tablesorter-childRow\",colgroup:\"tablesorter-colgroup\",header:\"tablesorter-header\",headerRow:\"tablesorter-headerRow\",headerIn:\"tablesorter-header-inner\",icon:\"tablesorter-icon\",processing:\"tablesorter-processing\",sortAsc:\"tablesorter-headerAsc\",sortDesc:\"tablesorter-headerDesc\",sortNone:\"tablesorter-headerUnSorted\"},language:{sortAsc:\"Ascending sort applied, \",sortDesc:\"Descending sort applied, \",sortNone:\"No sort applied, \",sortDisabled:\"sorting is disabled\",nextAsc:\"activate to apply an ascending sort\",nextDesc:\"activate to apply a descending sort\",nextNone:\"activate to remove the sort\"},regex:{templateContent:/\\{content\\}/g,templateIcon:/\\{icon\\}/g,templateName:/\\{name\\}/i,spaces:/\\s+/g,nonWord:/\\W/g,formElements:/(input|select|button|textarea)/i,chunk:/(^([+\\-]?(?:\\d*)(?:\\.\\d*)?(?:[eE][+\\-]?\\d+)?)?$|^0x[0-9a-f]+$|\\d+)/gi,chunks:/(^\\\\0|\\\\0$)/,hex:/^0x[0-9a-f]+$/i,comma:/,/g,digitNonUS:/[\\s|\\.]/g,digitNegativeTest:/^\\s*\\([.\\d]+\\)/,digitNegativeReplace:/^\\s*\\(([.\\d]+)\\)/,digitTest:/^[\\-+(]?\\d+[)]?$/,digitReplace:/[,.'\"\\s]/g},string:{max:1,min:-1,emptymin:1,emptymax:-1,zero:0,none:0,null:0,top:!0,bottom:!1},keyCodes:{enter:13},dates:{},instanceMethods:{},setup:function(e,a){if(!e||!e.tHead||0===e.tBodies.length||!0===e.hasInitialized)return void(a.debug&&(e.hasInitialized?console.warn(\"Stopping initialization. Tablesorter has already been initialized\"):console.error(\"Stopping initialization! No table, thead or tbody\",e)));var i=\"\",s=t(e),o=t.metadata;e.hasInitialized=!1,e.isProcessing=!0,e.config=a,t.data(e,\"tablesorter\",a),a.debug&&(console[console.group?\"group\":\"log\"](\"Initializing tablesorter v\"+r.version),t.data(e,\"startoveralltimer\",new Date)),a.supportsDataObject=function(e){return e[0]=parseInt(e[0],10),e[0]>1||1===e[0]&&parseInt(e[1],10)>=4}(t.fn.jquery.split(\".\")),a.emptyTo=a.emptyTo.toLowerCase(),a.stringTo=a.stringTo.toLowerCase(),a.last={sortList:[],clickedIndex:-1},/tablesorter\\-/.test(s.attr(\"class\"))||(i=\"\"!==a.theme?\" tablesorter-\"+a.theme:\"\"),a.namespace?a.namespace=\".\"+a.namespace.replace(r.regex.nonWord,\"\"):a.namespace=\".tablesorter\"+Math.random().toString(16).slice(2),a.table=e,a.$table=s.addClass(r.css.table+\" \"+a.tableClass+i+\" \"+a.namespace.slice(1)).attr(\"role\",\"grid\"),a.$headers=s.find(a.selectorHeaders),a.$table.children().children(\"tr\").attr(\"role\",\"row\"),a.$tbodies=s.children(\"tbody:not(.\"+a.cssInfoBlock+\")\").attr({\"aria-live\":\"polite\",\"aria-relevant\":\"all\"}),a.$table.children(\"caption\").length&&(i=a.$table.children(\"caption\")[0],i.id||(i.id=a.namespace.slice(1)+\"caption\"),a.$table.attr(\"aria-labelledby\",i.id)),a.widgetInit={},a.textExtraction=a.$table.attr(\"data-text-extraction\")||a.textExtraction||\"basic\",r.buildHeaders(a),r.fixColumnWidth(e),r.addWidgetFromClass(e),r.applyWidgetOptions(e),r.setupParsers(a),a.totalRows=0,r.validateOptions(a),a.delayInit||r.buildCache(a),r.bindEvents(e,a.$headers,!0),r.bindMethods(a),a.supportsDataObject&&void 0!==s.data().sortlist?a.sortList=s.data().sortlist:o&&s.metadata()&&s.metadata().sortlist&&(a.sortList=s.metadata().sortlist),r.applyWidget(e,!0),a.sortList.length>0?r.sortOn(a,a.sortList,{},!a.initWidgets):(r.setHeadersCss(a),a.initWidgets&&r.applyWidget(e,!1)),a.showProcessing&&s.unbind(\"sortBegin\"+a.namespace+\" sortEnd\"+a.namespace).bind(\"sortBegin\"+a.namespace+\" sortEnd\"+a.namespace,function(t){clearTimeout(a.timerProcessing),r.isProcessing(e),\"sortBegin\"===t.type&&(a.timerProcessing=setTimeout(function(){r.isProcessing(e,!0)},500))}),e.hasInitialized=!0,e.isProcessing=!1,a.debug&&(console.log(\"Overall initialization time:\"+r.benchmark(t.data(e,\"startoveralltimer\"))),a.debug&&console.groupEnd&&console.groupEnd()),s.triggerHandler(\"tablesorter-initialized\",e),\"function\"==typeof a.initialized&&a.initialized(e)},bindMethods:function(e){var a=e.$table,i=e.namespace,s=\"sortReset update updateRows updateAll updateHeaders addRows updateCell updateComplete sorton appendCache updateCache applyWidgetId applyWidgets refreshWidgets destroy mouseup mouseleave \".split(\" \").join(i+\" \");a.unbind(s.replace(r.regex.spaces,\" \")).bind(\"sortReset\"+i,function(e,t){e.stopPropagation(),r.sortReset(this.config,function(e){e.isApplyingWidgets?setTimeout(function(){r.applyWidget(e,\"\",t)},100):r.applyWidget(e,\"\",t)})}).bind(\"updateAll\"+i,function(e,t,a){e.stopPropagation(),r.updateAll(this.config,t,a)}).bind(\"update\"+i+\" updateRows\"+i,function(e,t,a){e.stopPropagation(),r.update(this.config,t,a)}).bind(\"updateHeaders\"+i,function(e,t){e.stopPropagation(),r.updateHeaders(this.config,t)}).bind(\"updateCell\"+i,function(e,t,a,i){e.stopPropagation(),r.updateCell(this.config,t,a,i)}).bind(\"addRows\"+i,function(e,t,a,i){e.stopPropagation(),r.addRows(this.config,t,a,i)}).bind(\"updateComplete\"+i,function(){this.isUpdating=!1}).bind(\"sorton\"+i,function(e,t,a,i){e.stopPropagation(),r.sortOn(this.config,t,a,i)}).bind(\"appendCache\"+i,function(e,a,i){e.stopPropagation(),r.appendCache(this.config,i),t.isFunction(a)&&a(this)}).bind(\"updateCache\"+i,function(e,t,a){e.stopPropagation(),r.updateCache(this.config,t,a)}).bind(\"applyWidgetId\"+i,function(e,t){e.stopPropagation(),r.applyWidgetId(this,t)}).bind(\"applyWidgets\"+i,function(e,t){e.stopPropagation(),r.applyWidget(this,t)}).bind(\"refreshWidgets\"+i,function(e,t,a){e.stopPropagation(),r.refreshWidgets(this,t,a)}).bind(\"removeWidget\"+i,function(e,t,a){e.stopPropagation(),r.removeWidget(this,t,a)}).bind(\"destroy\"+i,function(e,t,a){e.stopPropagation(),r.destroy(this,t,a)}).bind(\"resetToLoadState\"+i,function(a){a.stopPropagation(),r.removeWidget(this,!0,!1);var i=t.extend(!0,{},e.originalSettings);e=t.extend(!0,{},r.defaults,i),e.originalSettings=i,this.hasInitialized=!1,r.setup(this,e)})},bindEvents:function(e,a,i){e=t(e)[0];var s,o=e.config,n=o.namespace,l=null;!0!==i&&(a.addClass(n.slice(1)+\"_extra_headers\"),(s=t.fn.closest?a.closest(\"table\")[0]:a.parents(\"table\")[0])&&\"TABLE\"===s.nodeName&&s!==e&&t(s).addClass(n.slice(1)+\"_extra_table\")),s=(o.pointerDown+\" \"+o.pointerUp+\" \"+o.pointerClick+\" sort keyup \").replace(r.regex.spaces,\" \").split(\" \").join(n+\" \"),a.find(o.selectorSort).add(a.filter(o.selectorSort)).unbind(s).bind(s,function(e,i){var s,n,d,c=t(e.target),f=\" \"+e.type+\" \";if(!(1!==(e.which||e.button)&&!f.match(\" \"+o.pointerClick+\" | sort | keyup \")||\" keyup \"===f&&e.which!==r.keyCodes.enter||f.match(\" \"+o.pointerClick+\" \")&&void 0!==e.which||f.match(\" \"+o.pointerUp+\" \")&&l!==e.target&&!0!==i)){if(f.match(\" \"+o.pointerDown+\" \"))return l=e.target,d=c.jquery.split(\".\"),void(\"1\"===d[0]&&d[1]<4&&e.preventDefault());if(l=null,r.regex.formElements.test(e.target.nodeName)||c.hasClass(o.cssNoSort)||c.parents(\".\"+o.cssNoSort).length>0||c.parents(\"button\").length>0)return!o.cancelSelection;o.delayInit&&r.isEmptyObject(o.cache)&&r.buildCache(o),s=t.fn.closest?t(this).closest(\"th, td\"):/TH|TD/.test(this.nodeName)?t(this):t(this).parents(\"th, td\"),d=a.index(s),o.last.clickedIndex=d<0?s.attr(\"data-column\"):d,n=o.$headers[o.last.clickedIndex],n&&!n.sortDisabled&&r.initSort(o,n,e)}}),o.cancelSelection&&a.attr(\"unselectable\",\"on\").bind(\"selectstart\",!1).css({\"user-select\":\"none\",MozUserSelect:\"none\"})},buildHeaders:function(e){var a,i,s,o;for(e.headerList=[],e.headerContent=[],e.sortVars=[],e.debug&&(s=new Date),e.columns=r.computeColumnIndex(e.$table.children(\"thead, tfoot\").children(\"tr\")),i=e.cssIcon?'<i class=\"'+(e.cssIcon===r.css.icon?r.css.icon:e.cssIcon+\" \"+r.css.icon)+'\"></i>':\"\",e.$headers=t(t.map(e.$table.find(e.selectorHeaders),function(a,s){var o,n,l,d,c,f=t(a);if(!f.parent().hasClass(e.cssIgnoreRow))return o=r.getColumnData(e.table,e.headers,s,!0),e.headerContent[s]=f.html(),\"\"===e.headerTemplate||f.find(\".\"+r.css.headerIn).length||(d=e.headerTemplate.replace(r.regex.templateContent,f.html()).replace(r.regex.templateIcon,f.find(\".\"+r.css.icon).length?\"\":i),e.onRenderTemplate&&(n=e.onRenderTemplate.apply(f,[s,d]))&&\"string\"==typeof n&&(d=n),f.html('<div class=\"'+r.css.headerIn+'\">'+d+\"</div>\")),e.onRenderHeader&&e.onRenderHeader.apply(f,[s,e,e.$table]),l=parseInt(f.attr(\"data-column\"),10),a.column=l,c=r.getOrder(r.getData(f,o,\"sortInitialOrder\")||e.sortInitialOrder),e.sortVars[l]={count:-1,order:c?e.sortReset?[1,0,2]:[1,0]:e.sortReset?[0,1,2]:[0,1],lockedOrder:!1},c=r.getData(f,o,\"lockedOrder\")||!1,void 0!==c&&!1!==c&&(e.sortVars[l].lockedOrder=!0,e.sortVars[l].order=r.getOrder(c)?[1,1]:[0,0]),e.headerList[s]=a,f.addClass(r.css.header+\" \"+e.cssHeader).parent().addClass(r.css.headerRow+\" \"+e.cssHeaderRow).attr(\"role\",\"row\"),e.tabIndex&&f.attr(\"tabindex\",0),a})),e.$headerIndexed=[],o=0;o<e.columns;o++)r.isEmptyObject(e.sortVars[o])&&(e.sortVars[o]={}),a=e.$headers.filter('[data-column=\"'+o+'\"]'),e.$headerIndexed[o]=a.length?a.not(\".sorter-false\").length?a.not(\".sorter-false\").filter(\":last\"):a.filter(\":last\"):t();e.$table.find(e.selectorHeaders).attr({scope:\"col\",role:\"columnheader\"}),r.updateHeader(e),e.debug&&(console.log(\"Built headers:\"+r.benchmark(s)),console.log(e.$headers))},addInstanceMethods:function(e){t.extend(r.instanceMethods,e)},setupParsers:function(e,t){var a,i,s,o,n,l,d,c,f,u,g,p,h,m,b=e.table,y=0,v={};if(e.$tbodies=e.$table.children(\"tbody:not(.\"+e.cssInfoBlock+\")\"),h=void 0===t?e.$tbodies:t,0===(m=h.length))return e.debug?console.warn(\"Warning: *Empty table!* Not building a parser cache\"):\"\";for(e.debug&&(p=new Date,console[console.group?\"group\":\"log\"](\"Detecting parsers for each column\")),i={extractors:[],parsers:[]};y<m;){if(a=h[y].rows,a.length)for(n=0,o=e.columns,l=0;l<o;l++){if((d=e.$headerIndexed[n])&&d.length&&(c=r.getColumnData(b,e.headers,n),g=r.getParserById(r.getData(d,c,\"extractor\")),u=r.getParserById(r.getData(d,c,\"sorter\")),f=\"false\"===r.getData(d,c,\"parser\"),e.empties[n]=(r.getData(d,c,\"empty\")||e.emptyTo||(e.emptyToBottom?\"bottom\":\"top\")).toLowerCase(),e.strings[n]=(r.getData(d,c,\"string\")||e.stringTo||\"max\").toLowerCase(),f&&(u=r.getParserById(\"no-parser\")),g||(g=!1),u||(u=r.detectParserForColumn(e,a,-1,n)),e.debug&&(v[\"(\"+n+\") \"+d.text()]={parser:u.id,extractor:g?g.id:\"none\",string:e.strings[n],empty:e.empties[n]}),i.parsers[n]=u,i.extractors[n]=g,(s=d[0].colSpan-1)>0))for(n+=s,o+=s;s+1>0;)i.parsers[n-s]=u,i.extractors[n-s]=g,s--;n++}y+=i.parsers.length?m:1}e.debug&&(r.isEmptyObject(v)?console.warn(\"  No parsers detected!\"):console[console.table?\"table\":\"log\"](v),console.log(\"Completed detecting parsers\"+r.benchmark(p)),console.groupEnd&&console.groupEnd()),e.parsers=i.parsers,e.extractors=i.extractors},addParser:function(e){var t,a=r.parsers.length,i=!0;for(t=0;t<a;t++)r.parsers[t].id.toLowerCase()===e.id.toLowerCase()&&(i=!1);i&&(r.parsers[r.parsers.length]=e)},getParserById:function(e){if(\"false\"==e)return!1;var t,a=r.parsers.length;for(t=0;t<a;t++)if(r.parsers[t].id.toLowerCase()===e.toString().toLowerCase())return r.parsers[t];return!1},detectParserForColumn:function(e,a,i,s){for(var o,n,l,d=r.parsers.length,c=!1,f=\"\",u=!0;\"\"===f&&u;)i++,l=a[i],l&&i<50?l.className.indexOf(r.cssIgnoreRow)<0&&(c=a[i].cells[s],f=r.getElementText(e,c,s),n=t(c),e.debug&&console.log(\"Checking if value was empty on row \"+i+\", column: \"+s+': \"'+f+'\"')):u=!1;for(;--d>=0;)if((o=r.parsers[d])&&\"text\"!==o.id&&o.is&&o.is(f,e.table,c,n))return o;return r.getParserById(\"text\")},getElementText:function(e,a,i){if(!a)return\"\";var s,o=e.textExtraction||\"\",n=a.jquery?a:t(a);return\"string\"==typeof o?\"basic\"===o&&void 0!==(s=n.attr(e.textAttribute))?t.trim(s):t.trim(a.textContent||n.text()):\"function\"==typeof o?t.trim(o(n[0],e.table,i)):\"function\"==typeof(s=r.getColumnData(e.table,o,i))?t.trim(s(n[0],e.table,i)):t.trim(n[0].textContent||n.text())},getParsedText:function(e,t,a,i){void 0===i&&(i=r.getElementText(e,t,a));var s=\"\"+i,o=e.parsers[a],n=e.extractors[a];return o&&(n&&\"function\"==typeof n.format&&(i=n.format(i,e.table,t,a)),s=\"no-parser\"===o.id?\"\":o.format(\"\"+i,e.table,t,a),e.ignoreCase&&\"string\"==typeof s&&(s=s.toLowerCase())),s},buildCache:function(e,a,i){var s,o,n,l,d,c,f,u,g,p,h,m,b,y,v,w,x,C,_,$,S,z,F=e.table,R=e.parsers;if(e.$tbodies=e.$table.children(\"tbody:not(.\"+e.cssInfoBlock+\")\"),f=void 0===i?e.$tbodies:i,e.cache={},e.totalRows=0,!R)return e.debug?console.warn(\"Warning: *Empty table!* Not building a cache\"):\"\";for(e.debug&&(m=new Date),e.showProcessing&&r.isProcessing(F,!0),c=0;c<f.length;c++){for(w=[],s=e.cache[c]={normalized:[]},b=f[c]&&f[c].rows.length||0,l=0;l<b;++l)if(y={child:[],raw:[]},u=t(f[c].rows[l]),g=[],!u.hasClass(e.selectorRemove.slice(1)))if(u.hasClass(e.cssChildRow)&&0!==l)for(S=s.normalized.length-1,v=s.normalized[S][e.columns],v.$row=v.$row.add(u),u.prev().hasClass(e.cssChildRow)||u.prev().addClass(r.css.cssHasChild),p=u.children(\"th, td\"),S=v.child.length,v.child[S]=[],C=0,$=e.columns,d=0;d<$;d++)h=p[d],h&&(v.child[S][d]=r.getParsedText(e,h,d),(x=p[d].colSpan-1)>0&&(C+=x,$+=x)),C++;else{for(y.$row=u,y.order=l,C=0,$=e.columns,d=0;d<$;++d){if((h=u[0].cells[d])&&C<e.columns&&(_=void 0!==R[C],!_&&e.debug&&console.warn(\"No parser found for row: \"+l+\", column: \"+d+'; cell containing: \"'+t(h).text()+'\"; does it have a header?'),o=r.getElementText(e,h,C),y.raw[C]=o,n=r.getParsedText(e,h,C,o),g[C]=n,_&&\"numeric\"===(R[C].type||\"\").toLowerCase()&&(w[C]=Math.max(Math.abs(n)||0,w[C]||0)),(x=h.colSpan-1)>0)){for(z=0;z<=x;)n=e.duplicateSpan||0===z?o:\"string\"!=typeof e.textExtraction?r.getElementText(e,h,C+z)||\"\":\"\",y.raw[C+z]=n,g[C+z]=n,z++;C+=x,$+=x}C++}g[e.columns]=y,s.normalized[s.normalized.length]=g}s.colMax=w,e.totalRows+=s.normalized.length}if(e.showProcessing&&r.isProcessing(F),e.debug){for(S=Math.min(5,e.cache[0].normalized.length),console[console.group?\"group\":\"log\"](\"Building cache for \"+e.totalRows+\" rows (showing \"+S+\" rows in log) and \"+e.columns+\" columns\"+r.benchmark(m)),o={},d=0;d<e.columns;d++)for(C=0;C<S;C++)o[\"row: \"+C]||(o[\"row: \"+C]={}),o[\"row: \"+C][e.$headerIndexed[d].text()]=e.cache[0].normalized[C][d];console[console.table?\"table\":\"log\"](o),console.groupEnd&&console.groupEnd()}t.isFunction(a)&&a(F)},getColumnText:function(e,a,i,s){e=t(e)[0];var o,n,l,d,c,f,u,g,p,h,m=\"function\"==typeof i,b=\"all\"===a,y={raw:[],parsed:[],$cell:[]},v=e.config;if(!r.isEmptyObject(v)){for(c=v.$tbodies.length,o=0;o<c;o++)for(l=v.cache[o].normalized,f=l.length,n=0;n<f;n++)d=l[n],s&&!d[v.columns].$row.is(s)||(h=!0,g=b?d.slice(0,v.columns):d[a],d=d[v.columns],u=b?d.raw:d.raw[a],p=b?d.$row.children():d.$row.children().eq(a),m&&(h=i({tbodyIndex:o,rowIndex:n,parsed:g,raw:u,$row:d.$row,$cell:p})),!1!==h&&(y.parsed[y.parsed.length]=g,y.raw[y.raw.length]=u,y.$cell[y.$cell.length]=p));return y}v.debug&&console.warn(\"No cache found - aborting getColumnText function!\")},setHeadersCss:function(e){var a,i,s=e.sortList,o=s.length,n=r.css.sortNone+\" \"+e.cssNone,l=[r.css.sortAsc+\" \"+e.cssAsc,r.css.sortDesc+\" \"+e.cssDesc],d=[e.cssIconAsc,e.cssIconDesc,e.cssIconNone],c=[\"ascending\",\"descending\"],f=e.$table.find(\"tfoot tr\").children(\"td, th\").add(t(e.namespace+\"_extra_headers\")).removeClass(l.join(\" \")),u=e.$headers.add(t(\"thead \"+e.namespace+\"_extra_headers\")).removeClass(l.join(\" \")).addClass(n).attr(\"aria-sort\",\"none\").find(\".\"+r.css.icon).removeClass(d.join(\" \")).end();for(u.not(\".sorter-false\").find(\".\"+r.css.icon).addClass(d[2]),e.cssIconDisabled&&u.filter(\".sorter-false\").find(\".\"+r.css.icon).addClass(e.cssIconDisabled),a=0;a<o;a++)if(2!==s[a][1]&&(u=e.$headers.filter(function(t){for(var a=!0,i=e.$headers.eq(t),s=parseInt(i.attr(\"data-column\"),10),o=s+e.$headers[t].colSpan;s<o;s++)a=!!a&&(a||r.isValueInArray(s,e.sortList)>-1);return a}),u=u.not(\".sorter-false\").filter('[data-column=\"'+s[a][0]+'\"]'+(1===o?\":last\":\"\")),u.length)){for(i=0;i<u.length;i++)u[i].sortDisabled||u.eq(i).removeClass(n).addClass(l[s[a][1]]).attr(\"aria-sort\",c[s[a][1]]).find(\".\"+r.css.icon).removeClass(d[2]).addClass(d[s[a][1]]);f.length&&f.filter('[data-column=\"'+s[a][0]+'\"]').removeClass(n).addClass(l[s[a][1]])}for(o=e.$headers.length,a=0;a<o;a++)r.setColumnAriaLabel(e,e.$headers.eq(a))},setColumnAriaLabel:function(e,a,i){if(a.length){var s=parseInt(a.attr(\"data-column\"),10),o=e.sortVars[s],n=a.hasClass(r.css.sortAsc)?\"sortAsc\":a.hasClass(r.css.sortDesc)?\"sortDesc\":\"sortNone\",l=t.trim(a.text())+\": \"+r.language[n];a.hasClass(\"sorter-false\")||!1===i?l+=r.language.sortDisabled:(n=(o.count+1)%o.order.length,i=o.order[n],l+=r.language[0===i?\"nextAsc\":1===i?\"nextDesc\":\"nextNone\"]),a.attr(\"aria-label\",l)}},updateHeader:function(e){var t,a,i,s,o=e.table,n=e.$headers.length;for(t=0;t<n;t++)i=e.$headers.eq(t),s=r.getColumnData(o,e.headers,t,!0),a=\"false\"===r.getData(i,s,\"sorter\")||\"false\"===r.getData(i,s,\"parser\"),r.setColumnSort(e,i,a)},setColumnSort:function(e,t,r){var a=e.table.id;t[0].sortDisabled=r,t[r?\"addClass\":\"removeClass\"](\"sorter-false\").attr(\"aria-disabled\",\"\"+r),e.tabIndex&&(r?t.removeAttr(\"tabindex\"):t.attr(\"tabindex\",\"0\")),a&&(r?t.removeAttr(\"aria-controls\"):t.attr(\"aria-controls\",a))},updateHeaderSortCount:function(e,a){var i,s,o,n,l,d,c,f,u=a||e.sortList,g=u.length;for(e.sortList=[],n=0;n<g;n++)if(c=u[n],(i=parseInt(c[0],10))<e.columns){switch(e.sortVars[i].order||(f=r.getOrder(e.sortInitialOrder)?e.sortReset?[1,0,2]:[1,0]:e.sortReset?[0,1,2]:[0,1],e.sortVars[i].order=f,e.sortVars[i].count=0),f=e.sortVars[i].order,s=(\"\"+c[1]).match(/^(1|d|s|o|n)/),s=s?s[0]:\"\"){case\"1\":case\"d\":s=1;break;case\"s\":s=l||0;break;case\"o\":d=f[(l||0)%f.length],s=0===d?1:1===d?0:2;break;case\"n\":s=f[++e.sortVars[i].count%f.length];break;default:s=0}l=0===n?s:l,o=[i,parseInt(s,10)||0],e.sortList[e.sortList.length]=o,s=t.inArray(o[1],f),e.sortVars[i].count=s>=0?s:o[1]%f.length}},updateAll:function(e,t,a){var i=e.table;i.isUpdating=!0,r.refreshWidgets(i,!0,!0),r.buildHeaders(e),r.bindEvents(i,e.$headers,!0),r.bindMethods(e),r.commonUpdate(e,t,a)},update:function(e,t,a){e.table.isUpdating=!0,r.updateHeader(e),r.commonUpdate(e,t,a)},updateHeaders:function(e,t){e.table.isUpdating=!0,r.buildHeaders(e),r.bindEvents(e.table,e.$headers,!0),r.resortComplete(e,t)},updateCell:function(e,a,i,s){if(t(a).closest(\"tr\").hasClass(e.cssChildRow))return void console.warn('Tablesorter Warning! \"updateCell\" for child row content has been disabled, use \"update\" instead');if(r.isEmptyObject(e.cache))return r.updateHeader(e),void r.commonUpdate(e,i,s);e.table.isUpdating=!0,e.$table.find(e.selectorRemove).remove();var o,n,l,d,c,f,u=e.$tbodies,g=t(a),p=u.index(t.fn.closest?g.closest(\"tbody\"):g.parents(\"tbody\").filter(\":first\")),h=e.cache[p],m=t.fn.closest?g.closest(\"tr\"):g.parents(\"tr\").filter(\":first\");if(a=g[0],u.length&&p>=0){if(l=u.eq(p).find(\"tr\").not(\".\"+e.cssChildRow).index(m),c=h.normalized[l],(f=m[0].cells.length)!==e.columns)for(d=0,o=!1,n=0;n<f;n++)o||m[0].cells[n]===a?o=!0:d+=m[0].cells[n].colSpan;else d=g.index();o=r.getElementText(e,a,d),c[e.columns].raw[d]=o,o=r.getParsedText(e,a,d,o),c[d]=o,\"numeric\"===(e.parsers[d].type||\"\").toLowerCase()&&(h.colMax[d]=Math.max(Math.abs(o)||0,h.colMax[d]||0)),o=\"undefined\"!==i?i:e.resort,!1!==o?r.checkResort(e,o,s):r.resortComplete(e,s)}else e.debug&&console.error(\"updateCell aborted, tbody missing or not within the indicated table\"),e.table.isUpdating=!1},addRows:function(a,i,s,o){var n,l,d,c,f,u,g,p,h,m,b,y,v,w=\"string\"==typeof i&&1===a.$tbodies.length&&/<tr/.test(i||\"\"),x=a.table;if(w)i=t(i),a.$tbodies.append(i);else if(!(i&&i instanceof e&&(t.fn.closest?i.closest(\"table\")[0]:i.parents(\"table\")[0])===a.table))return a.debug&&console.error(\"addRows method requires (1) a jQuery selector reference to rows that have already been added to the table, or (2) row HTML string to be added to a table with only one tbody\"),!1;if(x.isUpdating=!0,r.isEmptyObject(a.cache))r.updateHeader(a),r.commonUpdate(a,s,o);else{for(f=i.filter(\"tr\").attr(\"role\",\"row\").length,d=a.$tbodies.index(i.parents(\"tbody\").filter(\":first\")),a.parsers&&a.parsers.length||r.setupParsers(a),c=0;c<f;c++){for(h=0,g=i[c].cells.length,p=a.cache[d].normalized.length,b=[],m={child:[],raw:[],$row:i.eq(c),order:p},u=0;u<g;u++)y=i[c].cells[u],n=r.getElementText(a,y,h),m.raw[h]=n,l=r.getParsedText(a,y,h,n),b[h]=l,\"numeric\"===(a.parsers[h].type||\"\").toLowerCase()&&(a.cache[d].colMax[h]=Math.max(Math.abs(l)||0,a.cache[d].colMax[h]||0)),v=y.colSpan-1,v>0&&(h+=v),h++;b[a.columns]=m,a.cache[d].normalized[p]=b}r.checkResort(a,s,o)}},updateCache:function(e,t,a){e.parsers&&e.parsers.length||r.setupParsers(e,a),r.buildCache(e,t,a)},appendCache:function(e,t){var a,i,s,o,n,l,d,c=e.table,f=e.widgetOptions,u=e.$tbodies,g=[],p=e.cache;if(r.isEmptyObject(p))return e.appender?e.appender(c,g):c.isUpdating?e.$table.triggerHandler(\"updateComplete\",c):\"\";for(e.debug&&(d=new Date),l=0;l<u.length;l++)if(s=u.eq(l),s.length){for(o=r.processTbody(c,s,!0),a=p[l].normalized,i=a.length,n=0;n<i;n++)g[g.length]=a[n][e.columns].$row,e.appender&&(!e.pager||e.pager.removeRows&&f.pager_removeRows||e.pager.ajax)||o.append(a[n][e.columns].$row);r.processTbody(c,o,!1)}e.appender&&e.appender(c,g),e.debug&&console.log(\"Rebuilt table\"+r.benchmark(d)),t||e.appender||r.applyWidget(c),c.isUpdating&&e.$table.triggerHandler(\"updateComplete\",c)},commonUpdate:function(e,t,a){e.$table.find(e.selectorRemove).remove(),r.setupParsers(e),r.buildCache(e),r.checkResort(e,t,a)},initSort:function(e,a,i){if(e.table.isUpdating)return setTimeout(function(){r.initSort(e,a,i)},50);var s,o,n,l,d,c,f,u=!i[e.sortMultiSortKey],g=e.table,p=e.$headers.length,h=parseInt(t(a).attr(\"data-column\"),10),m=e.sortVars[h].order;if(e.$table.triggerHandler(\"sortStart\",g),c=(e.sortVars[h].count+1)%m.length,e.sortVars[h].count=i[e.sortResetKey]?2:c,e.sortRestart)for(n=0;n<p;n++)f=e.$headers.eq(n),c=parseInt(f.attr(\"data-column\"),10),h!==c&&(u||f.hasClass(r.css.sortNone))&&(e.sortVars[c].count=-1);if(u){if(e.sortList=[],e.last.sortList=[],null!==e.sortForce)for(s=e.sortForce,o=0;o<s.length;o++)s[o][0]!==h&&(e.sortList[e.sortList.length]=s[o]);if((l=m[e.sortVars[h].count])<2&&(e.sortList[e.sortList.length]=[h,l],a.colSpan>1))for(o=1;o<a.colSpan;o++)e.sortList[e.sortList.length]=[h+o,l],e.sortVars[h+o].count=t.inArray(l,m)}else if(e.sortList=t.extend([],e.last.sortList),r.isValueInArray(h,e.sortList)>=0)for(o=0;o<e.sortList.length;o++)c=e.sortList[o],c[0]===h&&(c[1]=m[e.sortVars[h].count],2===c[1]&&(e.sortList.splice(o,1),e.sortVars[h].count=-1));else if((l=m[e.sortVars[h].count])<2&&(e.sortList[e.sortList.length]=[h,l],a.colSpan>1))for(o=1;o<a.colSpan;o++)e.sortList[e.sortList.length]=[h+o,l],e.sortVars[h+o].count=t.inArray(l,m);if(e.last.sortList=t.extend([],e.sortList),e.sortList.length&&e.sortAppend&&(s=t.isArray(e.sortAppend)?e.sortAppend:e.sortAppend[e.sortList[0][0]],!r.isEmptyObject(s)))for(o=0;o<s.length;o++)if(s[o][0]!==h&&r.isValueInArray(s[o][0],e.sortList)<0){if(l=s[o][1],d=(\"\"+l).match(/^(a|d|s|o|n)/))switch(c=e.sortList[0][1],d[0]){case\"d\":l=1;break;case\"s\":l=c;break;case\"o\":l=0===c?1:0;break;case\"n\":l=(c+1)%m.length;break;default:l=0}e.sortList[e.sortList.length]=[s[o][0],l]}e.$table.triggerHandler(\"sortBegin\",g),setTimeout(function(){r.setHeadersCss(e),r.multisort(e),r.appendCache(e),e.$table.triggerHandler(\"sortBeforeEnd\",g),e.$table.triggerHandler(\"sortEnd\",g)},1)},multisort:function(e){var t,a,i,s,o,n=e.table,l=[],d=0,c=e.textSorter||\"\",f=e.sortList,u=f.length,g=e.$tbodies.length;if(!e.serverSideSorting&&!r.isEmptyObject(e.cache)){if(e.debug&&(a=new Date),\"object\"==typeof c)for(i=e.columns;i--;)\"function\"==typeof(o=r.getColumnData(n,c,i))&&(l[i]=o);for(t=0;t<g;t++)i=e.cache[t].colMax,s=e.cache[t].normalized,s.sort(function(t,a){var s,o,g,p,h,m,b;for(s=0;s<u;s++){if(g=f[s][0],p=f[s][1],d=0===p,e.sortStable&&t[g]===a[g]&&1===u)return t[e.columns].order-a[e.columns].order;if(o=/n/i.test(r.getSortType(e.parsers,g)),o&&e.strings[g]?(o=\"boolean\"==typeof r.string[e.strings[g]]?(d?1:-1)*(r.string[e.strings[g]]?-1:1):e.strings[g]?r.string[e.strings[g]]||0:0,h=e.numberSorter?e.numberSorter(t[g],a[g],d,i[g],n):r[\"sortNumeric\"+(d?\"Asc\":\"Desc\")](t[g],a[g],o,i[g],g,e)):(m=d?t:a,b=d?a:t,h=\"function\"==typeof c?c(m[g],b[g],d,g,n):\"function\"==typeof l[g]?l[g](m[g],b[g],d,g,n):r[\"sortNatural\"+(d?\"Asc\":\"Desc\")](t[g],a[g],g,e)),h)return h}return t[e.columns].order-a[e.columns].order});e.debug&&console.log(\"Applying sort \"+f.toString()+r.benchmark(a))}},resortComplete:function(e,r){e.table.isUpdating&&e.$table.triggerHandler(\"updateComplete\",e.table),t.isFunction(r)&&r(e.table)},checkResort:function(e,a,i){var s=t.isArray(a)?a:e.sortList;!1===(void 0===a?e.resort:a)||e.serverSideSorting||e.table.isProcessing?(r.resortComplete(e,i),r.applyWidget(e.table,!1)):s.length?r.sortOn(e,s,function(){r.resortComplete(e,i)},!0):r.sortReset(e,function(){r.resortComplete(e,i),r.applyWidget(e.table,!1)})},sortOn:function(e,a,i,s){var o=e.table;e.$table.triggerHandler(\"sortStart\",o),r.updateHeaderSortCount(e,a),r.setHeadersCss(e),e.delayInit&&r.isEmptyObject(e.cache)&&r.buildCache(e),e.$table.triggerHandler(\"sortBegin\",o),r.multisort(e),r.appendCache(e,s),e.$table.triggerHandler(\"sortBeforeEnd\",o),e.$table.triggerHandler(\"sortEnd\",o),r.applyWidget(o),t.isFunction(i)&&i(o)},sortReset:function(e,a){e.sortList=[],r.setHeadersCss(e),r.multisort(e),r.appendCache(e);var i;for(i=0;i<e.columns;i++)e.sortVars[i].count=-1;t.isFunction(a)&&a(e.table)},getSortType:function(e,t){return e&&e[t]?e[t].type||\"\":\"\"},getOrder:function(e){return/^d/i.test(e)||1===e},sortNatural:function(e,t){if(e===t)return 0;e=e.toString(),t=t.toString();var a,i,s,o,n,l,d=r.regex;if(d.hex.test(t)){if(a=parseInt((e||\"\").match(d.hex),16),i=parseInt((t||\"\").match(d.hex),16),a<i)return-1;if(a>i)return 1}for(a=(e||\"\").replace(d.chunk,\"\\\\0$1\\\\0\").replace(d.chunks,\"\").split(\"\\\\0\"),i=(t||\"\").replace(d.chunk,\"\\\\0$1\\\\0\").replace(d.chunks,\"\").split(\"\\\\0\"),l=Math.max(a.length,i.length),n=0;n<l;n++){if(s=isNaN(a[n])?a[n]||0:parseFloat(a[n])||0,o=isNaN(i[n])?i[n]||0:parseFloat(i[n])||0,isNaN(s)!==isNaN(o))return isNaN(s)?1:-1;if(typeof s!=typeof o&&(s+=\"\",o+=\"\"),s<o)return-1;if(s>o)return 1}return 0},sortNaturalAsc:function(e,t,a,i){if(e===t)return 0;var s=r.string[i.empties[a]||i.emptyTo];return\"\"===e&&0!==s?\"boolean\"==typeof s?s?-1:1:-s||-1:\"\"===t&&0!==s?\"boolean\"==typeof s?s?1:-1:s||1:r.sortNatural(e,t)},sortNaturalDesc:function(e,t,a,i){if(e===t)return 0;var s=r.string[i.empties[a]||i.emptyTo];return\"\"===e&&0!==s?\"boolean\"==typeof s?s?-1:1:s||1:\"\"===t&&0!==s?\"boolean\"==typeof s?s?1:-1:-s||-1:r.sortNatural(t,e)},sortText:function(e,t){return e>t?1:e<t?-1:0},getTextValue:function(e,t,r){if(r){var a,i=e?e.length:0,s=r+t;for(a=0;a<i;a++)s+=e.charCodeAt(a);return t*s}return 0},sortNumericAsc:function(e,t,a,i,s,o){if(e===t)return 0;var n=r.string[o.empties[s]||o.emptyTo];return\"\"===e&&0!==n?\"boolean\"==typeof n?n?-1:1:-n||-1:\"\"===t&&0!==n?\"boolean\"==typeof n?n?1:-1:n||1:(isNaN(e)&&(e=r.getTextValue(e,a,i)),isNaN(t)&&(t=r.getTextValue(t,a,i)),e-t)},sortNumericDesc:function(e,t,a,i,s,o){if(e===t)return 0;var n=r.string[o.empties[s]||o.emptyTo];return\"\"===e&&0!==n?\"boolean\"==typeof n?n?-1:1:n||1:\"\"===t&&0!==n?\"boolean\"==typeof n?n?1:-1:-n||-1:(isNaN(e)&&(e=r.getTextValue(e,a,i)),isNaN(t)&&(t=r.getTextValue(t,a,i)),t-e)},sortNumeric:function(e,t){return e-t},addWidget:function(e){e.id&&!r.isEmptyObject(r.getWidgetById(e.id))&&console.warn('\"'+e.id+'\" widget was loaded more than once!'),r.widgets[r.widgets.length]=e},hasWidget:function(e,r){return e=t(e),e.length&&e[0].config&&e[0].config.widgetInit[r]||!1},getWidgetById:function(e){var t,a,i=r.widgets.length;for(t=0;t<i;t++)if((a=r.widgets[t])&&a.id&&a.id.toLowerCase()===e.toLowerCase())return a},applyWidgetOptions:function(e){var a,i,s,o=e.config,n=o.widgets.length;if(n)for(a=0;a<n;a++)(i=r.getWidgetById(o.widgets[a]))&&i.options&&(s=t.extend(!0,{},i.options),o.widgetOptions=t.extend(!0,s,o.widgetOptions),t.extend(!0,r.defaults.widgetOptions,i.options))},addWidgetFromClass:function(e){var t,a,i=e.config,s=\"^\"+i.widgetClass.replace(r.regex.templateName,\"(\\\\S+)+\")+\"$\",o=new RegExp(s,\"g\"),n=(e.className||\"\").split(r.regex.spaces);if(n.length)for(t=n.length,a=0;a<t;a++)n[a].match(o)&&(i.widgets[i.widgets.length]=n[a].replace(o,\"$1\"))},applyWidgetId:function(e,a,i){e=t(e)[0];var s,o,n,l=e.config,d=l.widgetOptions,c=r.getWidgetById(a);c&&(n=c.id,s=!1,t.inArray(n,l.widgets)<0&&(l.widgets[l.widgets.length]=n),l.debug&&(o=new Date),!i&&l.widgetInit[n]||(l.widgetInit[n]=!0,e.hasInitialized&&r.applyWidgetOptions(e),\"function\"==typeof c.init&&(s=!0,l.debug&&console[console.group?\"group\":\"log\"](\"Initializing \"+n+\" widget\"),c.init(e,c,l,d))),i||\"function\"!=typeof c.format||(s=!0,l.debug&&console[console.group?\"group\":\"log\"](\"Updating \"+n+\" widget\"),c.format(e,l,d,!1)),l.debug&&s&&(console.log(\"Completed \"+(i?\"initializing \":\"applying \")+n+\" widget\"+r.benchmark(o)),console.groupEnd&&console.groupEnd()))},applyWidget:function(e,a,i){e=t(e)[0];var s,o,n,l,d,c=e.config,f=[];if(!1===a||!e.hasInitialized||!e.isApplyingWidgets&&!e.isUpdating){if(c.debug&&(d=new Date),r.addWidgetFromClass(e),clearTimeout(c.timerReady),c.widgets.length){for(e.isApplyingWidgets=!0,c.widgets=t.grep(c.widgets,function(e,r){return t.inArray(e,c.widgets)===r}),n=c.widgets||[],o=n.length,s=0;s<o;s++)l=r.getWidgetById(n[s]),l&&l.id?(l.priority||(l.priority=10),f[s]=l):c.debug&&console.warn('\"'+n[s]+'\" widget code does not exist!');for(f.sort(function(e,t){return e.priority<t.priority?-1:e.priority===t.priority?0:1}),o=f.length,c.debug&&console[console.group?\"group\":\"log\"](\"Start \"+(a?\"initializing\":\"applying\")+\" widgets\"),s=0;s<o;s++)(l=f[s])&&l.id&&r.applyWidgetId(e,l.id,a);c.debug&&console.groupEnd&&console.groupEnd()}c.timerReady=setTimeout(function(){e.isApplyingWidgets=!1,t.data(e,\"lastWidgetApplication\",new Date),c.$table.triggerHandler(\"tablesorter-ready\"),a||\"function\"!=typeof i||i(e),c.debug&&(l=c.widgets.length,console.log(\"Completed \"+(!0===a?\"initializing \":\"applying \")+l+\" widget\"+(1!==l?\"s\":\"\")+r.benchmark(d)))},10)}},removeWidget:function(e,a,i){e=t(e)[0];var s,o,n,l,d=e.config;if(!0===a)for(a=[],l=r.widgets.length,n=0;n<l;n++)(o=r.widgets[n])&&o.id&&(a[a.length]=o.id);else a=(t.isArray(a)?a.join(\",\"):a||\"\").toLowerCase().split(/[\\s,]+/);for(l=a.length,s=0;s<l;s++)o=r.getWidgetById(a[s]),n=t.inArray(a[s],d.widgets),n>=0&&!0!==i&&d.widgets.splice(n,1),o&&o.remove&&(d.debug&&console.log((i?\"Refreshing\":\"Removing\")+' \"'+a[s]+'\" widget'),o.remove(e,d,d.widgetOptions,i),d.widgetInit[a[s]]=!1)},refreshWidgets:function(e,a,i){e=t(e)[0];var s,o,n=e.config,l=n.widgets,d=r.widgets,c=d.length,f=[],u=function(e){t(e).triggerHandler(\"refreshComplete\")};for(s=0;s<c;s++)(o=d[s])&&o.id&&(a||t.inArray(o.id,l)<0)&&(f[f.length]=o.id)\n;r.removeWidget(e,f.join(\",\"),!0),!0!==i?(r.applyWidget(e,a||!1,u),a&&r.applyWidget(e,!1,u)):u(e)},benchmark:function(e){return\" (\"+((new Date).getTime()-e.getTime())+\" ms)\"},log:function(){console.log(arguments)},isEmptyObject:function(e){for(var t in e)return!1;return!0},isValueInArray:function(e,t){var r,a=t&&t.length||0;for(r=0;r<a;r++)if(t[r][0]===e)return r;return-1},formatFloat:function(e,a){if(\"string\"!=typeof e||\"\"===e)return e;var i;return e=(a&&a.config?!1!==a.config.usNumberFormat:void 0===a||a)?e.replace(r.regex.comma,\"\"):e.replace(r.regex.digitNonUS,\"\").replace(r.regex.comma,\".\"),r.regex.digitNegativeTest.test(e)&&(e=e.replace(r.regex.digitNegativeReplace,\"-$1\")),i=parseFloat(e),isNaN(i)?t.trim(e):i},isDigit:function(e){return isNaN(e)?r.regex.digitTest.test(e.toString().replace(r.regex.digitReplace,\"\")):\"\"!==e},computeColumnIndex:function(e,a){var i,s,o,n,l,d,c,f,u,g,p=a&&a.columns||0,h=[],m=new Array(p);for(i=0;i<e.length;i++)for(d=e[i].cells,s=0;s<d.length;s++){for(l=d[s],c=l.parentNode.rowIndex,f=l.rowSpan||1,u=l.colSpan||1,void 0===h[c]&&(h[c]=[]),o=0;o<h[c].length+1;o++)if(void 0===h[c][o]){g=o;break}for(p&&l.cellIndex===g||(l.setAttribute?l.setAttribute(\"data-column\",g):t(l).attr(\"data-column\",g)),o=c;o<c+f;o++)for(void 0===h[o]&&(h[o]=[]),m=h[o],n=g;n<g+u;n++)m[n]=\"x\"}return r.checkColumnCount(e,h,m.length),m.length},checkColumnCount:function(e,t,r){var a,i,s=!0,o=[];for(a=0;a<t.length;a++)if(t[a]&&(i=t[a].length,t[a].length!==r)){s=!1;break}s||(e.each(function(e,t){var r=t.parentElement.nodeName;o.indexOf(r)&&o.push(r)}),console.error(\"Invalid or incorrect number of columns in the \"+o.join(\" or \")+\"; expected \"+r+\", but found \"+i+\" columns\"))},fixColumnWidth:function(e){e=t(e)[0];var a,i,s,o,n,l=e.config,d=l.$table.children(\"colgroup\");if(d.length&&d.hasClass(r.css.colgroup)&&d.remove(),l.widthFixed&&0===l.$table.children(\"colgroup\").length){for(d=t('<colgroup class=\"'+r.css.colgroup+'\">'),a=l.$table.width(),s=l.$tbodies.find(\"tr:first\").children(\":visible\"),o=s.length,n=0;n<o;n++)i=parseInt(s.eq(n).width()/a*1e3,10)/10+\"%\",d.append(t(\"<col>\").css(\"width\",i));l.$table.prepend(d)}},getData:function(e,r,a){var i,s,o=\"\",n=t(e);return n.length?(i=!!t.metadata&&n.metadata(),s=\" \"+(n.attr(\"class\")||\"\"),void 0!==n.data(a)||void 0!==n.data(a.toLowerCase())?o+=n.data(a)||n.data(a.toLowerCase()):i&&void 0!==i[a]?o+=i[a]:r&&void 0!==r[a]?o+=r[a]:\" \"!==s&&s.match(\" \"+a+\"-\")&&(o=s.match(new RegExp(\"\\\\s\"+a+\"-([\\\\w-]+)\"))[1]||\"\"),t.trim(o)):\"\"},getColumnData:function(e,r,a,i,s){if(\"object\"!=typeof r||null===r)return r;e=t(e)[0];var o,n,l=e.config,d=s||l.$headers,c=l.$headerIndexed&&l.$headerIndexed[a]||d.filter('[data-column=\"'+a+'\"]:last');if(void 0!==r[a])return i?r[a]:r[d.index(c)];for(n in r)if(\"string\"==typeof n&&(o=c.filter(n).add(c.find(n)),o.length))return r[n]},isProcessing:function(e,a,i){e=t(e);var s=e[0].config,o=i||e.find(\".\"+r.css.header);a?(void 0!==i&&s.sortList.length>0&&(o=o.filter(function(){return!this.sortDisabled&&r.isValueInArray(parseFloat(t(this).attr(\"data-column\")),s.sortList)>=0})),e.add(o).addClass(r.css.processing+\" \"+s.cssProcessing)):e.add(o).removeClass(r.css.processing+\" \"+s.cssProcessing)},processTbody:function(e,r,a){if(e=t(e)[0],a)return e.isProcessing=!0,r.before('<colgroup class=\"tablesorter-savemyplace\"/>'),t.fn.detach?r.detach():r.remove();var i=t(e).find(\"colgroup.tablesorter-savemyplace\");r.insertAfter(i),i.remove(),e.isProcessing=!1},clearTableBody:function(e){t(e)[0].config.$tbodies.children().detach()},characterEquivalents:{a:\"áàâãäąå\",A:\"ÁÀÂÃÄĄÅ\",c:\"çćč\",C:\"ÇĆČ\",e:\"éèêëěę\",E:\"ÉÈÊËĚĘ\",i:\"íìİîïı\",I:\"ÍÌİÎÏ\",o:\"óòôõöō\",O:\"ÓÒÔÕÖŌ\",ss:\"ß\",SS:\"ẞ\",u:\"úùûüů\",U:\"ÚÙÛÜŮ\"},replaceAccents:function(e){var t,a=\"[\",i=r.characterEquivalents;if(!r.characterRegex){r.characterRegexArray={};for(t in i)\"string\"==typeof t&&(a+=i[t],r.characterRegexArray[t]=new RegExp(\"[\"+i[t]+\"]\",\"g\"));r.characterRegex=new RegExp(a+\"]\")}if(r.characterRegex.test(e))for(t in i)\"string\"==typeof t&&(e=e.replace(r.characterRegexArray[t],t));return e},validateOptions:function(e){var a,i,s,o,n=\"headers sortForce sortList sortAppend widgets\".split(\" \"),l=e.originalSettings;if(l){e.debug&&(o=new Date);for(a in l)if(\"undefined\"===(s=typeof r.defaults[a]))console.warn('Tablesorter Warning! \"table.config.'+a+'\" option not recognized');else if(\"object\"===s)for(i in l[a])s=r.defaults[a]&&typeof r.defaults[a][i],t.inArray(a,n)<0&&\"undefined\"===s&&console.warn('Tablesorter Warning! \"table.config.'+a+\".\"+i+'\" option not recognized');e.debug&&console.log(\"validate options time:\"+r.benchmark(o))}},restoreHeaders:function(e){var a,i,s=t(e)[0].config,o=s.$table.find(s.selectorHeaders),n=o.length;for(a=0;a<n;a++)i=o.eq(a),i.find(\".\"+r.css.headerIn).length&&i.html(s.headerContent[a])},destroy:function(e,a,i){if(e=t(e)[0],e.hasInitialized){r.removeWidget(e,!0,!1);var s,o=t(e),n=e.config,l=n.debug,d=o.find(\"thead:first\"),c=d.find(\"tr.\"+r.css.headerRow).removeClass(r.css.headerRow+\" \"+n.cssHeaderRow),f=o.find(\"tfoot:first > tr\").children(\"th, td\");!1===a&&t.inArray(\"uitheme\",n.widgets)>=0&&(o.triggerHandler(\"applyWidgetId\",[\"uitheme\"]),o.triggerHandler(\"applyWidgetId\",[\"zebra\"])),d.find(\"tr\").not(c).remove(),s=\"sortReset update updateRows updateAll updateHeaders updateCell addRows updateComplete sorton appendCache updateCache applyWidgetId applyWidgets refreshWidgets removeWidget destroy mouseup mouseleave \"+\"keypress sortBegin sortEnd resetToLoadState \".split(\" \").join(n.namespace+\" \"),o.removeData(\"tablesorter\").unbind(s.replace(r.regex.spaces,\" \")),n.$headers.add(f).removeClass([r.css.header,n.cssHeader,n.cssAsc,n.cssDesc,r.css.sortAsc,r.css.sortDesc,r.css.sortNone].join(\" \")).removeAttr(\"data-column\").removeAttr(\"aria-label\").attr(\"aria-disabled\",\"true\"),c.find(n.selectorSort).unbind(\"mousedown mouseup keypress \".split(\" \").join(n.namespace+\" \").replace(r.regex.spaces,\" \")),r.restoreHeaders(e),o.toggleClass(r.css.table+\" \"+n.tableClass+\" tablesorter-\"+n.theme,!1===a),o.removeClass(n.namespace.slice(1)),e.hasInitialized=!1,delete e.config.cache,\"function\"==typeof i&&i(e),l&&console.log(\"tablesorter has been removed\")}}};t.fn.tablesorter=function(e){return this.each(function(){var a=this,i=t.extend(!0,{},r.defaults,e,r.instanceMethods);i.originalSettings=e,!a.hasInitialized&&r.buildTable&&\"TABLE\"!==this.nodeName?r.buildTable(a,i):r.setup(a,i)})},window.console&&window.console.log||(r.logs=[],console={},console.log=console.warn=console.error=console.table=function(){var e=arguments.length>1?arguments:arguments[0];r.logs[r.logs.length]={date:Date.now(),log:e}}),r.addParser({id:\"no-parser\",is:function(){return!1},format:function(){return\"\"},type:\"text\"}),r.addParser({id:\"text\",is:function(){return!0},format:function(e,a){var i=a.config;return e&&(e=t.trim(i.ignoreCase?e.toLocaleLowerCase():e),e=i.sortLocaleCompare?r.replaceAccents(e):e),e},type:\"text\"}),r.regex.nondigit=/[^\\w,. \\-()]/g,r.addParser({id:\"digit\",is:function(e){return r.isDigit(e)},format:function(e,a){var i=r.formatFloat((e||\"\").replace(r.regex.nondigit,\"\"),a);return e&&\"number\"==typeof i?i:e?t.trim(e&&a.config.ignoreCase?e.toLocaleLowerCase():e):e},type:\"numeric\"}),r.regex.currencyReplace=/[+\\-,. ]/g,r.regex.currencyTest=/^\\(?\\d+[\\u00a3$\\u20ac\\u00a4\\u00a5\\u00a2?.]|[\\u00a3$\\u20ac\\u00a4\\u00a5\\u00a2?.]\\d+\\)?$/,r.addParser({id:\"currency\",is:function(e){return e=(e||\"\").replace(r.regex.currencyReplace,\"\"),r.regex.currencyTest.test(e)},format:function(e,a){var i=r.formatFloat((e||\"\").replace(r.regex.nondigit,\"\"),a);return e&&\"number\"==typeof i?i:e?t.trim(e&&a.config.ignoreCase?e.toLocaleLowerCase():e):e},type:\"numeric\"}),r.regex.urlProtocolTest=/^(https?|ftp|file):\\/\\//,r.regex.urlProtocolReplace=/(https?|ftp|file):\\/\\/(www\\.)?/,r.addParser({id:\"url\",is:function(e){return r.regex.urlProtocolTest.test(e)},format:function(e){return e?t.trim(e.replace(r.regex.urlProtocolReplace,\"\")):e},type:\"text\"}),r.regex.dash=/-/g,r.regex.isoDate=/^\\d{4}[\\/\\-]\\d{1,2}[\\/\\-]\\d{1,2}/,r.addParser({id:\"isoDate\",is:function(e){return r.regex.isoDate.test(e)},format:function(e,t){var a=e?new Date(e.replace(r.regex.dash,\"/\")):e;return a instanceof Date&&isFinite(a)?a.getTime():e},type:\"numeric\"}),r.regex.percent=/%/g,r.regex.percentTest=/(\\d\\s*?%|%\\s*?\\d)/,r.addParser({id:\"percent\",is:function(e){return r.regex.percentTest.test(e)&&e.length<15},format:function(e,t){return e?r.formatFloat(e.replace(r.regex.percent,\"\"),t):e},type:\"numeric\"}),r.addParser({id:\"image\",is:function(e,t,r,a){return a.find(\"img\").length>0},format:function(e,r,a){return t(a).find(\"img\").attr(r.config.imgAttr||\"alt\")||e},parsed:!0,type:\"text\"}),r.regex.dateReplace=/(\\S)([AP]M)$/i,r.regex.usLongDateTest1=/^[A-Z]{3,10}\\.?\\s+\\d{1,2},?\\s+(\\d{4})(\\s+\\d{1,2}:\\d{2}(:\\d{2})?(\\s+[AP]M)?)?$/i,r.regex.usLongDateTest2=/^\\d{1,2}\\s+[A-Z]{3,10}\\s+\\d{4}/i,r.addParser({id:\"usLongDate\",is:function(e){return r.regex.usLongDateTest1.test(e)||r.regex.usLongDateTest2.test(e)},format:function(e,t){var a=e?new Date(e.replace(r.regex.dateReplace,\"$1 $2\")):e;return a instanceof Date&&isFinite(a)?a.getTime():e},type:\"numeric\"}),r.regex.shortDateTest=/(^\\d{1,2}[\\/\\s]\\d{1,2}[\\/\\s]\\d{4})|(^\\d{4}[\\/\\s]\\d{1,2}[\\/\\s]\\d{1,2})/,r.regex.shortDateReplace=/[\\-.,]/g,r.regex.shortDateXXY=/(\\d{1,2})[\\/\\s](\\d{1,2})[\\/\\s](\\d{4})/,r.regex.shortDateYMD=/(\\d{4})[\\/\\s](\\d{1,2})[\\/\\s](\\d{1,2})/,r.convertFormat=function(e,t){e=(e||\"\").replace(r.regex.spaces,\" \").replace(r.regex.shortDateReplace,\"/\"),\"mmddyyyy\"===t?e=e.replace(r.regex.shortDateXXY,\"$3/$1/$2\"):\"ddmmyyyy\"===t?e=e.replace(r.regex.shortDateXXY,\"$3/$2/$1\"):\"yyyymmdd\"===t&&(e=e.replace(r.regex.shortDateYMD,\"$1/$2/$3\"));var a=new Date(e);return a instanceof Date&&isFinite(a)?a.getTime():\"\"},r.addParser({id:\"shortDate\",is:function(e){return e=(e||\"\").replace(r.regex.spaces,\" \").replace(r.regex.shortDateReplace,\"/\"),r.regex.shortDateTest.test(e)},format:function(e,t,a,i){if(e){var s=t.config,o=s.$headerIndexed[i],n=o.length&&o.data(\"dateFormat\")||r.getData(o,r.getColumnData(t,s.headers,i),\"dateFormat\")||s.dateFormat;return o.length&&o.data(\"dateFormat\",n),r.convertFormat(e,n)||e}return e},type:\"numeric\"}),r.regex.timeTest=/^(0?[1-9]|1[0-2]):([0-5]\\d)(\\s[AP]M)$|^((?:[01]\\d|[2][0-4]):[0-5]\\d)$/i,r.regex.timeMatch=/(0?[1-9]|1[0-2]):([0-5]\\d)(\\s[AP]M)|((?:[01]\\d|[2][0-4]):[0-5]\\d)/i,r.addParser({id:\"time\",is:function(e){return r.regex.timeTest.test(e)},format:function(e,t){var a,i=(e||\"\").match(r.regex.timeMatch),s=new Date(e),o=e&&(null!==i?i[0]:\"00:00 AM\"),n=o?new Date(\"2000/01/01 \"+o.replace(r.regex.dateReplace,\"$1 $2\")):o;return n instanceof Date&&isFinite(n)?(a=s instanceof Date&&isFinite(s)?s.getTime():0,a?parseFloat(n.getTime()+\".\"+s.getTime()):n.getTime()):e},type:\"numeric\"}),r.addParser({id:\"metadata\",is:function(){return!1},format:function(e,r,a){var i=r.config,s=i.parserMetadataName?i.parserMetadataName:\"sortValue\";return t(a).metadata()[s]},type:\"numeric\"}),r.addWidget({id:\"zebra\",priority:90,format:function(e,r,a){var i,s,o,n,l,d,c,f=new RegExp(r.cssChildRow,\"i\"),u=r.$tbodies.add(t(r.namespace+\"_extra_table\").children(\"tbody:not(.\"+r.cssInfoBlock+\")\"));for(l=0;l<u.length;l++)for(o=0,i=u.eq(l).children(\"tr:visible\").not(r.selectorRemove),c=i.length,d=0;d<c;d++)s=i.eq(d),f.test(s[0].className)||o++,n=o%2==0,s.removeClass(a.zebra[n?1:0]).addClass(a.zebra[n?0:1])},remove:function(e,t,a,i){if(!i){var s,o,n=t.$tbodies,l=(a.zebra||[\"even\",\"odd\"]).join(\" \");for(s=0;s<n.length;s++)o=r.processTbody(e,n.eq(s),!0),o.children().removeClass(l),r.processTbody(e,o,!1)}}})}(e),function(e,t,r){\"use strict\";var a=e.tablesorter||{};e.extend(!0,a.defaults,{fixedUrl:\"\",widgetOptions:{storage_fixedUrl:\"\",storage_group:\"\",storage_page:\"\",storage_storageType:\"\",storage_tableId:\"\",storage_useSessionStorage:\"\"}}),a.storage=function(a,i,s,o){a=e(a)[0];var n,l,d,c=!1,f={},u=a.config,g=u&&u.widgetOptions,p=(o&&o.storageType||g&&g.storage_storageType).toString().charAt(0).toLowerCase(),h=p?\"\":o&&o.useSessionStorage||g&&g.storage_useSessionStorage,m=e(a),b=o&&o.id||m.attr(o&&o.group||g&&g.storage_group||\"data-table-group\")||g&&g.storage_tableId||a.id||e(\".tablesorter\").index(m),y=o&&o.url||m.attr(o&&o.page||g&&g.storage_page||\"data-table-page\")||g&&g.storage_fixedUrl||u&&u.fixedUrl||t.location.pathname;if(\"c\"!==p&&(p=\"s\"===p||h?\"sessionStorage\":\"localStorage\")in t)try{t[p].setItem(\"_tmptest\",\"temp\"),c=!0,t[p].removeItem(\"_tmptest\")}catch(e){u&&u.debug&&console.warn(p+\" is not supported in this browser\")}if(u.debug&&console.log(\"Storage widget using\",c?p:\"cookies\"),e.parseJSON&&(c?f=e.parseJSON(t[p][i]||\"null\")||{}:(l=r.cookie.split(/[;\\s|=]/),n=e.inArray(i,l)+1,f=0!==n?e.parseJSON(l[n]||\"null\")||{}:{})),void 0===s||!t.JSON||!JSON.hasOwnProperty(\"stringify\"))return f&&f[y]?f[y][b]:\"\";f[y]||(f[y]={}),f[y][b]=s,c?t[p][i]=JSON.stringify(f):(d=new Date,d.setTime(d.getTime()+31536e6),r.cookie=i+\"=\"+JSON.stringify(f).replace(/\\\"/g,'\"')+\"; expires=\"+d.toGMTString()+\"; path=/\")}}(e,window,document),function(e){\"use strict\";var t=e.tablesorter||{};t.themes={bootstrap:{table:\"table table-bordered table-striped\",caption:\"caption\",header:\"bootstrap-header\",sortNone:\"\",sortAsc:\"\",sortDesc:\"\",active:\"\",hover:\"\",icons:\"\",iconSortNone:\"bootstrap-icon-unsorted\",iconSortAsc:\"icon-chevron-up glyphicon glyphicon-chevron-up\",iconSortDesc:\"icon-chevron-down glyphicon glyphicon-chevron-down\",filterRow:\"\",footerRow:\"\",footerCells:\"\",even:\"\",odd:\"\"},jui:{table:\"ui-widget ui-widget-content ui-corner-all\",caption:\"ui-widget-content\",header:\"ui-widget-header ui-corner-all ui-state-default\",sortNone:\"\",sortAsc:\"\",sortDesc:\"\",active:\"ui-state-active\",hover:\"ui-state-hover\",icons:\"ui-icon\",iconSortNone:\"ui-icon-carat-2-n-s ui-icon-caret-2-n-s\",iconSortAsc:\"ui-icon-carat-1-n ui-icon-caret-1-n\",iconSortDesc:\"ui-icon-carat-1-s ui-icon-caret-1-s\",filterRow:\"\",footerRow:\"\",footerCells:\"\",even:\"ui-widget-content\",odd:\"ui-state-default\"}},e.extend(t.css,{wrapper:\"tablesorter-wrapper\"}),t.addWidget({id:\"uitheme\",priority:10,format:function(r,a,i){var s,o,n,l,d,c,f,u,g,p,h,m,b,y=t.themes,v=a.$table.add(e(a.namespace+\"_extra_table\")),w=a.$headers.add(e(a.namespace+\"_extra_headers\")),x=a.theme||\"jui\",C=y[x]||{},_=e.trim([C.sortNone,C.sortDesc,C.sortAsc,C.active].join(\" \")),$=e.trim([C.iconSortNone,C.iconSortDesc,C.iconSortAsc].join(\" \"));for(a.debug&&(d=new Date),v.hasClass(\"tablesorter-\"+x)&&a.theme===a.appliedTheme&&i.uitheme_applied||(i.uitheme_applied=!0,p=y[a.appliedTheme]||{},b=!e.isEmptyObject(p),h=b?[p.sortNone,p.sortDesc,p.sortAsc,p.active].join(\" \"):\"\",m=b?[p.iconSortNone,p.iconSortDesc,p.iconSortAsc].join(\" \"):\"\",b&&(i.zebra[0]=e.trim(\" \"+i.zebra[0].replace(\" \"+p.even,\"\")),i.zebra[1]=e.trim(\" \"+i.zebra[1].replace(\" \"+p.odd,\"\")),a.$tbodies.children().removeClass([p.even,p.odd].join(\" \"))),C.even&&(i.zebra[0]+=\" \"+C.even),C.odd&&(i.zebra[1]+=\" \"+C.odd),v.children(\"caption\").removeClass(p.caption||\"\").addClass(C.caption),u=v.removeClass((a.appliedTheme?\"tablesorter-\"+(a.appliedTheme||\"\"):\"\")+\" \"+(p.table||\"\")).addClass(\"tablesorter-\"+x+\" \"+(C.table||\"\")).children(\"tfoot\"),a.appliedTheme=a.theme,u.length&&u.children(\"tr\").removeClass(p.footerRow||\"\").addClass(C.footerRow).children(\"th, td\").removeClass(p.footerCells||\"\").addClass(C.footerCells),w.removeClass((b?[p.header,p.hover,h].join(\" \"):\"\")||\"\").addClass(C.header).not(\".sorter-false\").unbind(\"mouseenter.tsuitheme mouseleave.tsuitheme\").bind(\"mouseenter.tsuitheme mouseleave.tsuitheme\",function(t){e(this)[\"mouseenter\"===t.type?\"addClass\":\"removeClass\"](C.hover||\"\")}),w.each(function(){var r=e(this);r.find(\".\"+t.css.wrapper).length||r.wrapInner('<div class=\"'+t.css.wrapper+'\" style=\"position:relative;height:100%;width:100%\"></div>')}),a.cssIcon&&w.find(\".\"+t.css.icon).removeClass(b?[p.icons,m].join(\" \"):\"\").addClass(C.icons||\"\"),t.hasWidget(a.table,\"filter\")&&(o=function(){v.children(\"thead\").children(\".\"+t.css.filterRow).removeClass(b?p.filterRow||\"\":\"\").addClass(C.filterRow||\"\")},i.filter_initialized?o():v.one(\"filterInit\",function(){o()}))),s=0;s<a.columns;s++)c=a.$headers.add(e(a.namespace+\"_extra_headers\")).not(\".sorter-false\").filter('[data-column=\"'+s+'\"]'),f=t.css.icon?c.find(\".\"+t.css.icon):e(),g=w.not(\".sorter-false\").filter('[data-column=\"'+s+'\"]:last'),g.length&&(c.removeClass(_),f.removeClass($),g[0].sortDisabled?f.removeClass(C.icons||\"\"):(n=C.sortNone,l=C.iconSortNone,g.hasClass(t.css.sortAsc)?(n=[C.sortAsc,C.active].join(\" \"),l=C.iconSortAsc):g.hasClass(t.css.sortDesc)&&(n=[C.sortDesc,C.active].join(\" \"),l=C.iconSortDesc),c.addClass(n),f.addClass(l||\"\")));a.debug&&console.log(\"Applying \"+x+\" theme\"+t.benchmark(d))},remove:function(e,r,a,i){if(a.uitheme_applied){var s=r.$table,o=r.appliedTheme||\"jui\",n=t.themes[o]||t.themes.jui,l=s.children(\"thead\").children(),d=n.sortNone+\" \"+n.sortDesc+\" \"+n.sortAsc,c=n.iconSortNone+\" \"+n.iconSortDesc+\" \"+n.iconSortAsc;s.removeClass(\"tablesorter-\"+o+\" \"+n.table),a.uitheme_applied=!1,i||(s.find(t.css.header).removeClass(n.header),l.unbind(\"mouseenter.tsuitheme mouseleave.tsuitheme\").removeClass(n.hover+\" \"+d+\" \"+n.active).filter(\".\"+t.css.filterRow).removeClass(n.filterRow),l.find(\".\"+t.css.icon).removeClass(n.icons+\" \"+c))}}})}(e),function(e){\"use strict\";var t=e.tablesorter||{};t.addWidget({id:\"columns\",priority:65,options:{columns:[\"primary\",\"secondary\",\"tertiary\"]},format:function(r,a,i){var s,o,n,l,d,c,f,u,g=a.$table,p=a.$tbodies,h=a.sortList,m=h.length,b=i&&i.columns||[\"primary\",\"secondary\",\"tertiary\"],y=b.length-1;for(f=b.join(\" \"),o=0;o<p.length;o++)s=t.processTbody(r,p.eq(o),!0),n=s.children(\"tr\"),n.each(function(){if(d=e(this),\"none\"!==this.style.display&&(c=d.children().removeClass(f),h&&h[0]&&(c.eq(h[0][0]).addClass(b[0]),m>1)))for(u=1;u<m;u++)c.eq(h[u][0]).addClass(b[u]||b[y])}),t.processTbody(r,s,!1);if(l=!1!==i.columns_thead?[\"thead tr\"]:[],!1!==i.columns_tfoot&&l.push(\"tfoot tr\"),l.length&&(n=g.find(l.join(\",\")).children().removeClass(f),m))for(u=0;u<m;u++)n.filter('[data-column=\"'+h[u][0]+'\"]').addClass(b[u]||b[y])},remove:function(r,a,i){var s,o,n=a.$tbodies,l=(i.columns||[\"primary\",\"secondary\",\"tertiary\"]).join(\" \");for(a.$headers.removeClass(l),a.$table.children(\"tfoot\").children(\"tr\").children(\"th, td\").removeClass(l),s=0;s<n.length;s++)o=t.processTbody(r,n.eq(s),!0),o.children(\"tr\").each(function(){e(this).children().removeClass(l)}),t.processTbody(r,o,!1)}})}(e),function(e){\"use strict\";var t,r,a=e.tablesorter||{},i=a.css,s=a.keyCodes;e.extend(i,{filterRow:\"tablesorter-filter-row\",filter:\"tablesorter-filter\",filterDisabled:\"disabled\",filterRowHide:\"hideme\"}),e.extend(s,{backSpace:8,escape:27,space:32,left:37,down:40}),a.addWidget({id:\"filter\",priority:50,options:{filter_cellFilter:\"\",filter_childRows:!1,filter_childByColumn:!1,filter_childWithSibs:!0,filter_columnAnyMatch:!0,filter_columnFilters:!0,filter_cssFilter:\"\",filter_defaultAttrib:\"data-value\",filter_defaultFilter:{},filter_excludeFilter:{},filter_external:\"\",filter_filteredRow:\"filtered\",filter_formatter:null,filter_functions:null,filter_hideEmpty:!0,filter_hideFilters:!1,filter_ignoreCase:!0,filter_liveSearch:!0,filter_matchType:{input:\"exact\",select:\"exact\"},filter_onlyAvail:\"filter-onlyAvail\",filter_placeholder:{search:\"\",select:\"\"},filter_reset:null,filter_resetOnEsc:!0,filter_saveFilters:!1,filter_searchDelay:300,filter_searchFiltered:!0,filter_selectSource:null,filter_selectSourceSeparator:\"|\",filter_serversideFiltering:!1,filter_startsWith:!1,filter_useParsedData:!1},format:function(e,r,a){r.$table.hasClass(\"hasFilters\")||t.init(e,r,a)},remove:function(t,r,s,o){var n,l,d=r.$table,c=r.$tbodies,f=\"addRows updateCell update updateRows updateComplete appendCache filterReset filterAndSortReset filterEnd search \".split(\" \").join(r.namespace+\"filter \");if(d.removeClass(\"hasFilters\").unbind(f.replace(a.regex.spaces,\" \")).find(\".\"+i.filterRow).remove(),s.filter_initialized=!1,!o){for(n=0;n<c.length;n++)l=a.processTbody(t,c.eq(n),!0),l.children().removeClass(s.filter_filteredRow).show(),a.processTbody(t,l,!1);s.filter_reset&&e(document).undelegate(s.filter_reset,\"click\"+r.namespace+\"filter\")}}}),t=a.filter={regex:{regex:/^\\/((?:\\\\\\/|[^\\/])+)\\/([migyu]{0,5})?$/,child:/tablesorter-childRow/,filtered:/filtered/,type:/undefined|number/,exact:/(^[\\\"\\'=]+)|([\\\"\\'=]+$)/g,operators:/[<>=]/g,query:\"(q|query)\",wild01:/\\?/g,wild0More:/\\*/g,quote:/\\\"/g,isNeg1:/(>=?\\s*-\\d)/,isNeg2:/(<=?\\s*\\d)/},types:{or:function(a,i,s){if((r.orTest.test(i.iFilter)||r.orSplit.test(i.filter))&&!r.regex.test(i.filter)){var o,n,l,d,c=e.extend({},i),f=i.filter.split(r.orSplit),u=i.iFilter.split(r.orSplit),g=f.length;for(o=0;o<g;o++){c.nestedFilters=!0,c.filter=\"\"+(t.parseFilter(a,f[o],i)||\"\"),c.iFilter=\"\"+(t.parseFilter(a,u[o],i)||\"\"),l=\"(\"+(t.parseFilter(a,c.filter,i)||\"\")+\")\";try{if(d=new RegExp(i.isMatch?l:\"^\"+l+\"$\",a.widgetOptions.filter_ignoreCase?\"i\":\"\"),n=d.test(c.exact)||t.processTypes(a,c,s))return n}catch(e){return null}}return n||!1}return null},and:function(a,i,s){if(r.andTest.test(i.filter)){var o,n,l,d,c,f=e.extend({},i),u=i.filter.split(r.andSplit),g=i.iFilter.split(r.andSplit),p=u.length;for(o=0;o<p;o++){f.nestedFilters=!0,f.filter=\"\"+(t.parseFilter(a,u[o],i)||\"\"),f.iFilter=\"\"+(t.parseFilter(a,g[o],i)||\"\"),d=(\"(\"+(t.parseFilter(a,f.filter,i)||\"\")+\")\").replace(r.wild01,\"\\\\S{1}\").replace(r.wild0More,\"\\\\S*\");try{c=new RegExp(i.isMatch?d:\"^\"+d+\"$\",a.widgetOptions.filter_ignoreCase?\"i\":\"\"),l=c.test(f.exact)||t.processTypes(a,f,s),n=0===o?l:n&&l}catch(e){return null}}return n||!1}return null},regex:function(e,t){if(r.regex.test(t.filter)){var a,i=t.filter_regexCache[t.index]||r.regex.exec(t.filter),s=i instanceof RegExp;try{s||(t.filter_regexCache[t.index]=i=new RegExp(i[1],i[2])),a=i.test(t.exact)}catch(e){a=!1}return a}return null},operators:function(i,s){if(r.operTest.test(s.iFilter)&&\"\"!==s.iExact){var o,n,l,d=i.table,c=s.parsed[s.index],f=a.formatFloat(s.iFilter.replace(r.operators,\"\"),d),u=i.parsers[s.index]||{},g=f;return(c||\"numeric\"===u.type)&&(l=e.trim(\"\"+s.iFilter.replace(r.operators,\"\")),n=t.parseFilter(i,l,s,!0),f=\"number\"!=typeof n||\"\"===n||isNaN(n)?f:n),!c&&\"numeric\"!==u.type||isNaN(f)||void 0===s.cache?(l=isNaN(s.iExact)?s.iExact.replace(a.regex.nondigit,\"\"):s.iExact,o=a.formatFloat(l,d)):o=s.cache,r.gtTest.test(s.iFilter)?n=r.gteTest.test(s.iFilter)?o>=f:o>f:r.ltTest.test(s.iFilter)&&(n=r.lteTest.test(s.iFilter)?o<=f:o<f),n||\"\"!==g||(n=!0),n}return null},notMatch:function(a,i){if(r.notTest.test(i.iFilter)){var s,o=i.iFilter.replace(\"!\",\"\"),n=t.parseFilter(a,o,i)||\"\";return r.exact.test(n)?\"\"===(n=n.replace(r.exact,\"\"))||e.trim(n)!==i.iExact:(s=i.iExact.search(e.trim(n)),\"\"===n||(i.anyMatch?s<0:!(a.widgetOptions.filter_startsWith?0===s:s>=0)))}return null},exact:function(a,i){if(r.exact.test(i.iFilter)){var s=i.iFilter.replace(r.exact,\"\"),o=t.parseFilter(a,s,i)||\"\";return i.anyMatch?e.inArray(o,i.rowArray)>=0:o==i.iExact}return null},range:function(e,i){if(r.toTest.test(i.iFilter)){var s,o,n,l,d=e.table,c=i.index,f=i.parsed[c],u=i.iFilter.split(r.toSplit);return o=u[0].replace(a.regex.nondigit,\"\")||\"\",n=a.formatFloat(t.parseFilter(e,o,i),d),o=u[1].replace(a.regex.nondigit,\"\")||\"\",l=a.formatFloat(t.parseFilter(e,o,i),d),(f||\"numeric\"===e.parsers[c].type)&&(s=e.parsers[c].format(\"\"+u[0],d,e.$headers.eq(c),c),n=\"\"===s||isNaN(s)?n:s,s=e.parsers[c].format(\"\"+u[1],d,e.$headers.eq(c),c),l=\"\"===s||isNaN(s)?l:s),!f&&\"numeric\"!==e.parsers[c].type||isNaN(n)||isNaN(l)?(o=isNaN(i.iExact)?i.iExact.replace(a.regex.nondigit,\"\"):i.iExact,s=a.formatFloat(o,d)):s=i.cache,n>l&&(o=n,n=l,l=o),s>=n&&s<=l||\"\"===n||\"\"===l}return null},wild:function(e,a){if(r.wildOrTest.test(a.iFilter)){var i=\"\"+(t.parseFilter(e,a.iFilter,a)||\"\");!r.wildTest.test(i)&&a.nestedFilters&&(i=a.isMatch?i:\"^(\"+i+\")$\");try{return new RegExp(i.replace(r.wild01,\"\\\\S{1}\").replace(r.wild0More,\"\\\\S*\"),e.widgetOptions.filter_ignoreCase?\"i\":\"\").test(a.exact)}catch(e){return null}}return null},fuzzy:function(e,a){if(r.fuzzyTest.test(a.iFilter)){var i,s=0,o=a.iExact.length,n=a.iFilter.slice(1),l=t.parseFilter(e,n,a)||\"\";for(i=0;i<o;i++)a.iExact[i]===l[s]&&(s+=1);return s===l.length}return null}},init:function(s){a.language=e.extend(!0,{},{to:\"to\",or:\"or\",and:\"and\"},a.language);var o,n,l,d,c,f,u,g,p=s.config,h=p.widgetOptions;if(p.$table.addClass(\"hasFilters\"),p.lastSearch=[],h.filter_searchTimer=null,h.filter_initTimer=null,h.filter_formatterCount=0,h.filter_formatterInit=[],h.filter_anyColumnSelector='[data-column=\"all\"],[data-column=\"any\"]',h.filter_multipleColumnSelector='[data-column*=\"-\"],[data-column*=\",\"]',f=\"\\\\{\"+r.query+\"\\\\}\",e.extend(r,{child:new RegExp(p.cssChildRow),filtered:new RegExp(h.filter_filteredRow),alreadyFiltered:new RegExp(\"(\\\\s+(\"+a.language.or+\"|-|\"+a.language.to+\")\\\\s+)\",\"i\"),toTest:new RegExp(\"\\\\s+(-|\"+a.language.to+\")\\\\s+\",\"i\"),toSplit:new RegExp(\"(?:\\\\s+(?:-|\"+a.language.to+\")\\\\s+)\",\"gi\"),andTest:new RegExp(\"\\\\s+(\"+a.language.and+\"|&&)\\\\s+\",\"i\"),andSplit:new RegExp(\"(?:\\\\s+(?:\"+a.language.and+\"|&&)\\\\s+)\",\"gi\"),orTest:new RegExp(\"(\\\\||\\\\s+\"+a.language.or+\"\\\\s+)\",\"i\"),orSplit:new RegExp(\"(?:\\\\s+(?:\"+a.language.or+\")\\\\s+|\\\\|)\",\"gi\"),iQuery:new RegExp(f,\"i\"),igQuery:new RegExp(f,\"ig\"),operTest:/^[<>]=?/,gtTest:/>/,gteTest:/>=/,ltTest:/</,lteTest:/<=/,notTest:/^\\!/,wildOrTest:/[\\?\\*\\|]/,wildTest:/\\?\\*/,fuzzyTest:/^~/,exactTest:/[=\\\"\\|!]/}),f=p.$headers.filter(\".filter-false, .parser-false\").length,!1!==h.filter_columnFilters&&f!==p.$headers.length&&t.buildRow(s,p,h),l=\"addRows updateCell update updateRows updateComplete appendCache filterReset \"+\"filterAndSortReset filterResetSaved filterEnd search \".split(\" \").join(p.namespace+\"filter \"),p.$table.bind(l,function(r,o){return f=h.filter_hideEmpty&&e.isEmptyObject(p.cache)&&!(p.delayInit&&\"appendCache\"===r.type),p.$table.find(\".\"+i.filterRow).toggleClass(h.filter_filteredRow,f),/(search|filter)/.test(r.type)||(r.stopPropagation(),t.buildDefault(s,!0)),\"filterReset\"===r.type||\"filterAndSortReset\"===r.type?(p.$table.find(\".\"+i.filter).add(h.filter_$externalFilters).val(\"\"),\"filterAndSortReset\"===r.type?a.sortReset(this.config,function(){t.searching(s,[])}):t.searching(s,[])):\"filterResetSaved\"===r.type?a.storage(s,\"tablesorter-filters\",\"\"):\"filterEnd\"===r.type?t.buildDefault(s,!0):(o=\"search\"===r.type?o:\"updateComplete\"===r.type?p.$table.data(\"lastSearch\"):\"\",/(update|add)/.test(r.type)&&\"updateComplete\"!==r.type&&(p.lastCombinedFilter=null,p.lastSearch=[],setTimeout(function(){p.$table.triggerHandler(\"filterFomatterUpdate\")},100)),t.searching(s,o,!0)),!1}),h.filter_reset&&(h.filter_reset instanceof e?h.filter_reset.click(function(){p.$table.triggerHandler(\"filterReset\")}):e(h.filter_reset).length&&e(document).undelegate(h.filter_reset,\"click\"+p.namespace+\"filter\").delegate(h.filter_reset,\"click\"+p.namespace+\"filter\",function(){p.$table.triggerHandler(\"filterReset\")})),h.filter_functions)for(c=0;c<p.columns;c++)if(u=a.getColumnData(s,h.filter_functions,c))if(d=p.$headerIndexed[c].removeClass(\"filter-select\"),g=!(d.hasClass(\"filter-false\")||d.hasClass(\"parser-false\")),o=\"\",!0===u&&g)t.buildSelect(s,c);else if(\"object\"==typeof u&&g){for(n in u)\"string\"==typeof n&&(o+=\"\"===o?'<option value=\"\">'+(d.data(\"placeholder\")||d.attr(\"data-placeholder\")||h.filter_placeholder.select||\"\")+\"</option>\":\"\",f=n,l=n,n.indexOf(h.filter_selectSourceSeparator)>=0&&(f=n.split(h.filter_selectSourceSeparator),l=f[1],f=f[0]),o+=\"<option \"+(l===f?\"\":'data-function-name=\"'+n+'\" ')+'value=\"'+f+'\">'+l+\"</option>\");p.$table.find(\"thead\").find(\"select.\"+i.filter+'[data-column=\"'+c+'\"]').append(o),l=h.filter_selectSource,u=\"function\"==typeof l||a.getColumnData(s,l,c),u&&t.buildSelect(p.table,c,\"\",!0,d.hasClass(h.filter_onlyAvail))}t.buildDefault(s,!0),t.bindSearch(s,p.$table.find(\".\"+i.filter),!0),h.filter_external&&t.bindSearch(s,h.filter_external),h.filter_hideFilters&&t.hideFilters(p),p.showProcessing&&(l=\"filterStart filterEnd \".split(\" \").join(p.namespace+\"filter \"),p.$table.unbind(l.replace(a.regex.spaces,\" \")).bind(l,function(t,r){d=r?p.$table.find(\".\"+i.header).filter(\"[data-column]\").filter(function(){return\"\"!==r[e(this).data(\"column\")]}):\"\",a.isProcessing(s,\"filterStart\"===t.type,r?d:\"\")})),p.filteredRows=p.totalRows,l=\"tablesorter-initialized pagerBeforeInitialized \".split(\" \").join(p.namespace+\"filter \"),p.$table.unbind(l.replace(a.regex.spaces,\" \")).bind(l,function(){t.completeInit(this)}),p.pager&&p.pager.initialized&&!h.filter_initialized?(p.$table.triggerHandler(\"filterFomatterUpdate\"),setTimeout(function(){t.filterInitComplete(p)},100)):h.filter_initialized||t.completeInit(s)},completeInit:function(e){var r=e.config,i=r.widgetOptions,s=t.setDefaults(e,r,i)||[];s.length&&(r.delayInit&&\"\"===s.join(\"\")||a.setFilters(e,s,!0)),r.$table.triggerHandler(\"filterFomatterUpdate\"),setTimeout(function(){i.filter_initialized||t.filterInitComplete(r)},100)},formatterUpdated:function(e,t){var r=e&&e.closest(\"table\")[0].config.widgetOptions;r&&!r.filter_initialized&&(r.filter_formatterInit[t]=1)},filterInitComplete:function(r){var a,i,s=r.widgetOptions,o=0,n=function(){s.filter_initialized=!0,r.lastSearch=r.$table.data(\"lastSearch\"),r.$table.triggerHandler(\"filterInit\",r),t.findRows(r.table,r.lastSearch||[])};if(e.isEmptyObject(s.filter_formatter))n();else{for(i=s.filter_formatterInit.length,a=0;a<i;a++)1===s.filter_formatterInit[a]&&o++;clearTimeout(s.filter_initTimer),s.filter_initialized||o!==s.filter_formatterCount?s.filter_initialized||(s.filter_initTimer=setTimeout(function(){n()},500)):n()}},processFilters:function(e,t){var r,a=[],i=t?encodeURIComponent:decodeURIComponent,s=e.length;for(r=0;r<s;r++)e[r]&&(a[r]=i(e[r]));return a},setDefaults:function(r,i,s){var o,n,l,d,c,f=a.getFilters(r)||[];if(s.filter_saveFilters&&a.storage&&(n=a.storage(r,\"tablesorter-filters\")||[],(o=e.isArray(n))&&\"\"===n.join(\"\")||!o||(f=t.processFilters(n))),\"\"===f.join(\"\"))for(c=i.$headers.add(s.filter_$externalFilters).filter(\"[\"+s.filter_defaultAttrib+\"]\"),l=0;l<=i.columns;l++)d=l===i.columns?\"all\":l,f[l]=c.filter('[data-column=\"'+d+'\"]').attr(s.filter_defaultAttrib)||f[l]||\"\";return i.$table.data(\"lastSearch\",f),f},parseFilter:function(e,t,r,a){return a||r.parsed[r.index]?e.parsers[r.index].format(t,e.table,[],r.index):t},buildRow:function(r,s,o){var n,l,d,c,f,u,g,p,h,m=o.filter_cellFilter,b=s.columns,y=e.isArray(m),v='<tr role=\"row\" class=\"'+i.filterRow+\" \"+s.cssIgnoreRow+'\">';for(d=0;d<b;d++)s.$headerIndexed[d].length&&(h=s.$headerIndexed[d]&&s.$headerIndexed[d][0].colSpan||0,v+=h>1?'<td data-column=\"'+d+\"-\"+(d+h-1)+'\" colspan=\"'+h+'\"':'<td data-column=\"'+d+'\"',v+=y?m[d]?' class=\"'+m[d]+'\"':\"\":\"\"!==m?' class=\"'+m+'\"':\"\",v+=\"></td>\");for(s.$filters=e(v+=\"</tr>\").appendTo(s.$table.children(\"thead\").eq(0)).children(\"td\"),d=0;d<b;d++)u=!1,(c=s.$headerIndexed[d])&&c.length&&(n=t.getColumnElm(s,s.$filters,d),p=a.getColumnData(r,o.filter_functions,d),f=o.filter_functions&&p&&\"function\"!=typeof p||c.hasClass(\"filter-select\"),l=a.getColumnData(r,s.headers,d),u=\"false\"===a.getData(c[0],l,\"filter\")||\"false\"===a.getData(c[0],l,\"parser\"),f?v=e(\"<select>\").appendTo(n):(p=a.getColumnData(r,o.filter_formatter,d),p?(o.filter_formatterCount++,v=p(n,d),v&&0===v.length&&(v=n.children(\"input\")),v&&(0===v.parent().length||v.parent().length&&v.parent()[0]!==n[0])&&n.append(v)):v=e('<input type=\"search\">').appendTo(n),v&&(h=c.data(\"placeholder\")||c.attr(\"data-placeholder\")||o.filter_placeholder.search||\"\",v.attr(\"placeholder\",h))),v&&(g=(e.isArray(o.filter_cssFilter)?void 0!==o.filter_cssFilter[d]?o.filter_cssFilter[d]||\"\":\"\":o.filter_cssFilter)||\"\",v.addClass(i.filter+\" \"+g).attr(\"data-column\",n.attr(\"data-column\")),u&&(v.attr(\"placeholder\",\"\").addClass(i.filterDisabled)[0].disabled=!0)))},bindSearch:function(r,i,o){if(r=e(r)[0],i=e(i),i.length){var n,l=r.config,d=l.widgetOptions,c=l.namespace+\"filter\",f=d.filter_$externalFilters;!0!==o&&(n=d.filter_anyColumnSelector+\",\"+d.filter_multipleColumnSelector,d.filter_$anyMatch=i.filter(n),f&&f.length?d.filter_$externalFilters=d.filter_$externalFilters.add(i):d.filter_$externalFilters=i,a.setFilters(r,l.$table.data(\"lastSearch\")||[],!1===o)),\nn=\"keypress keyup keydown search change input \".split(\" \").join(c+\" \"),i.attr(\"data-lastSearchTime\",(new Date).getTime()).unbind(n.replace(a.regex.spaces,\" \")).bind(\"keydown\"+c,function(e){if(e.which===s.escape&&!r.config.widgetOptions.filter_resetOnEsc)return!1}).bind(\"keyup\"+c,function(i){d=r.config.widgetOptions;var o=parseInt(e(this).attr(\"data-column\"),10),n=\"boolean\"==typeof d.filter_liveSearch?d.filter_liveSearch:a.getColumnData(r,d.filter_liveSearch,o);if(void 0===n&&(n=d.filter_liveSearch.fallback||!1),e(this).attr(\"data-lastSearchTime\",(new Date).getTime()),i.which===s.escape)this.value=d.filter_resetOnEsc?\"\":l.lastSearch[o];else{if(\"\"!==this.value&&(\"number\"==typeof n&&this.value.length<n||i.which!==s.enter&&i.which!==s.backSpace&&(i.which<s.space||i.which>=s.left&&i.which<=s.down)))return;if(!1===n&&\"\"!==this.value&&i.which!==s.enter)return}t.searching(r,!0,!0,o)}).bind(\"search change keypress input blur \".split(\" \").join(c+\" \"),function(i){var o=parseInt(e(this).attr(\"data-column\"),10),n=i.type,c=\"boolean\"==typeof d.filter_liveSearch?d.filter_liveSearch:a.getColumnData(r,d.filter_liveSearch,o);!r.config.widgetOptions.filter_initialized||i.which!==s.enter&&\"search\"!==n&&\"blur\"!==n&&(\"change\"!==n&&\"input\"!==n||!0!==c&&(!0===c||\"INPUT\"===i.target.nodeName)||this.value===l.lastSearch[o])||(i.preventDefault(),e(this).attr(\"data-lastSearchTime\",(new Date).getTime()),t.searching(r,\"keypress\"!==n,!0,o))})}},searching:function(e,r,i,s){var o,n=e.config.widgetOptions;void 0===s?o=!1:void 0===(o=\"boolean\"==typeof n.filter_liveSearch?n.filter_liveSearch:a.getColumnData(e,n.filter_liveSearch,s))&&(o=n.filter_liveSearch.fallback||!1),clearTimeout(n.filter_searchTimer),void 0===r||!0===r?n.filter_searchTimer=setTimeout(function(){t.checkFilters(e,r,i)},o?n.filter_searchDelay:10):t.checkFilters(e,r,i)},equalFilters:function(t,r,a){var i,s=[],o=[],n=t.columns+1;for(r=e.isArray(r)?r:[],a=e.isArray(a)?a:[],i=0;i<n;i++)s[i]=r[i]||\"\",o[i]=a[i]||\"\";return s.join(\",\")===o.join(\",\")},checkFilters:function(r,s,o){var n=r.config,l=n.widgetOptions,d=e.isArray(s),c=d?s:a.getFilters(r,!0),f=c||[];if(e.isEmptyObject(n.cache))return void(n.delayInit&&(!n.pager||n.pager&&n.pager.initialized)&&a.updateCache(n,function(){t.checkFilters(r,!1,o)}));if(d&&(a.setFilters(r,c,!1,!0!==o),l.filter_initialized||(n.lastSearch=[],n.lastCombinedFilter=\"\")),l.filter_hideFilters&&n.$table.find(\".\"+i.filterRow).triggerHandler(t.hideFiltersCheck(n)?\"mouseleave\":\"mouseenter\"),!t.equalFilters(n,n.lastSearch,f)||!1===s){if(!1===s&&(n.lastCombinedFilter=\"\",n.lastSearch=[]),c=c||[],c=Array.prototype.map?c.map(String):c.join(\"�\").split(\"�\"),l.filter_initialized&&n.$table.triggerHandler(\"filterStart\",[c]),!n.showProcessing)return t.findRows(r,c,f),!1;setTimeout(function(){return t.findRows(r,c,f),!1},30)}},hideFiltersCheck:function(e){if(\"function\"==typeof e.widgetOptions.filter_hideFilters){var t=e.widgetOptions.filter_hideFilters(e);if(\"boolean\"==typeof t)return t}return\"\"===a.getFilters(e.$table).join(\"\")},hideFilters:function(r,a){var s;(a||r.$table).find(\".\"+i.filterRow).addClass(i.filterRowHide).bind(\"mouseenter mouseleave\",function(a){var o=a,n=e(this);clearTimeout(s),s=setTimeout(function(){/enter|over/.test(o.type)?n.removeClass(i.filterRowHide):e(document.activeElement).closest(\"tr\")[0]!==n[0]&&n.toggleClass(i.filterRowHide,t.hideFiltersCheck(r))},200)}).find(\"input, select\").bind(\"focus blur\",function(a){var o=a,n=e(this).closest(\"tr\");clearTimeout(s),s=setTimeout(function(){clearTimeout(s),n.toggleClass(i.filterRowHide,t.hideFiltersCheck(r)&&\"focus\"!==o.type)},200)})},defaultFilter:function(t,a){if(\"\"===t)return t;var i=r.iQuery,s=a.match(r.igQuery).length,o=s>1?e.trim(t).split(/\\s/):[e.trim(t)],n=o.length-1,l=0,d=a;for(n<1&&s>1&&(o[1]=o[0]);i.test(d);)d=d.replace(i,o[l++]||\"\"),i.test(d)&&l<n&&\"\"!==(o[l]||\"\")&&(d=a.replace(i,d));return d},getLatestSearch:function(t){return t?t.sort(function(t,r){return e(r).attr(\"data-lastSearchTime\")-e(t).attr(\"data-lastSearchTime\")}):t||e()},findRange:function(e,t,r){var a,i,s,o,n,l,d,c,f,u=[];if(/^[0-9]+$/.test(t))return[parseInt(t,10)];if(!r&&/-/.test(t))for(i=t.match(/(\\d+)\\s*-\\s*(\\d+)/g),f=i?i.length:0,c=0;c<f;c++){for(s=i[c].split(/\\s*-\\s*/),o=parseInt(s[0],10)||0,n=parseInt(s[1],10)||e.columns-1,o>n&&(a=o,o=n,n=a),n>=e.columns&&(n=e.columns-1);o<=n;o++)u[u.length]=o;t=t.replace(i[c],\"\")}if(!r&&/,/.test(t))for(l=t.split(/\\s*,\\s*/),f=l.length,d=0;d<f;d++)\"\"!==l[d]&&(c=parseInt(l[d],10))<e.columns&&(u[u.length]=c);if(!u.length)for(c=0;c<e.columns;c++)u[u.length]=c;return u},getColumnElm:function(r,a,i){return a.filter(function(){var a=t.findRange(r,e(this).attr(\"data-column\"));return e.inArray(i,a)>-1})},multipleColumns:function(r,a){var i=r.widgetOptions,s=i.filter_initialized||!a.filter(i.filter_anyColumnSelector).length,o=e.trim(t.getLatestSearch(a).attr(\"data-column\")||\"\");return t.findRange(r,o,!s)},processTypes:function(r,a,i){var s,o=null,n=null;for(s in t.types)e.inArray(s,i.excludeMatch)<0&&null===n&&null!==(n=t.types[s](r,a,i))&&(o=n);return o},matchType:function(e,t){var r,a=e.widgetOptions,s=e.$headerIndexed[t];return s.hasClass(\"filter-exact\")?r=!1:s.hasClass(\"filter-match\")?r=!0:(a.filter_columnFilters?s=e.$filters.find(\".\"+i.filter).add(a.filter_$externalFilters).filter('[data-column=\"'+t+'\"]'):a.filter_$externalFilters&&(s=a.filter_$externalFilters.filter('[data-column=\"'+t+'\"]')),r=!!s.length&&\"match\"===e.widgetOptions.filter_matchType[(s[0].nodeName||\"\").toLowerCase()]),r},processRow:function(i,s,o){var n,l,d,c,f,u=i.widgetOptions,g=!0,p=u.filter_$anyMatch&&u.filter_$anyMatch.length,h=u.filter_$anyMatch&&u.filter_$anyMatch.length?t.multipleColumns(i,u.filter_$anyMatch):[];if(s.$cells=s.$row.children(),s.anyMatchFlag&&h.length>1||s.anyMatchFilter&&!p){if(s.anyMatch=!0,s.isMatch=!0,s.rowArray=s.$cells.map(function(t){if(e.inArray(t,h)>-1||s.anyMatchFilter&&!p)return s.parsed[t]?f=s.cacheArray[t]:(f=s.rawArray[t],f=e.trim(u.filter_ignoreCase?f.toLowerCase():f),i.sortLocaleCompare&&(f=a.replaceAccents(f))),f}).get(),s.filter=s.anyMatchFilter,s.iFilter=s.iAnyMatchFilter,s.exact=s.rowArray.join(\" \"),s.iExact=u.filter_ignoreCase?s.exact.toLowerCase():s.exact,s.cache=s.cacheArray.slice(0,-1).join(\" \"),o.excludeMatch=o.noAnyMatch,null!==(l=t.processTypes(i,s,o)))g=l;else if(u.filter_startsWith)for(g=!1,h=Math.min(i.columns,s.rowArray.length);!g&&h>0;)h--,g=g||0===s.rowArray[h].indexOf(s.iFilter);else g=(s.iExact+s.childRowText).indexOf(s.iFilter)>=0;if(s.anyMatch=!1,s.filters.join(\"\")===s.filter)return g}for(h=0;h<i.columns;h++)s.filter=s.filters[h],s.index=h,o.excludeMatch=o.excludeFilter[h],s.filter&&(s.cache=s.cacheArray[h],n=s.parsed[h]?s.cache:s.rawArray[h]||\"\",s.exact=i.sortLocaleCompare?a.replaceAccents(n):n,s.iExact=!r.type.test(typeof s.exact)&&u.filter_ignoreCase?s.exact.toLowerCase():s.exact,s.isMatch=t.matchType(i,h),n=g,c=u.filter_columnFilters?i.$filters.add(u.filter_$externalFilters).filter('[data-column=\"'+h+'\"]').find(\"select option:selected\").attr(\"data-function-name\")||\"\":\"\",i.sortLocaleCompare&&(s.filter=a.replaceAccents(s.filter)),u.filter_defaultFilter&&r.iQuery.test(o.defaultColFilter[h])&&(s.filter=t.defaultFilter(s.filter,o.defaultColFilter[h])),s.iFilter=u.filter_ignoreCase?(s.filter||\"\").toLowerCase():s.filter,d=o.functions[h],l=null,d&&(\"function\"==typeof d?l=d(s.exact,s.cache,s.filter,h,s.$row,i,s):\"function\"==typeof d[c||s.filter]&&(f=c||s.filter,l=d[f](s.exact,s.cache,s.filter,h,s.$row,i,s))),null===l?(l=t.processTypes(i,s,o),null!==l?n=l:!0===d?n=s.isMatch?(\"\"+s.iExact).search(s.iFilter)>=0:s.filter===s.exact:(f=(s.iExact+s.childRowText).indexOf(t.parseFilter(i,s.iFilter,s)),n=!u.filter_startsWith&&f>=0||u.filter_startsWith&&0===f)):n=l,g=!!n&&g);return g},findRows:function(i,s,o){if(!t.equalFilters(i.config,i.config.lastSearch,o)&&i.config.widgetOptions.filter_initialized){var n,l,d,c,f,u,g,p,h,m,b,y,v,w,x,C,_,$,S,z,F,R,T,I=e.extend([],s),k=i.config,A=k.widgetOptions,D={anyMatch:!1,filters:s,filter_regexCache:[]},H={noAnyMatch:[\"range\",\"operators\"],functions:[],excludeFilter:[],defaultColFilter:[],defaultAnyFilter:a.getColumnData(i,A.filter_defaultFilter,k.columns,!0)||\"\"};for(D.parsed=[],h=0;h<k.columns;h++)D.parsed[h]=A.filter_useParsedData||k.parsers&&k.parsers[h]&&k.parsers[h].parsed||a.getData&&\"parsed\"===a.getData(k.$headerIndexed[h],a.getColumnData(i,k.headers,h),\"filter\")||k.$headerIndexed[h].hasClass(\"filter-parsed\"),H.functions[h]=a.getColumnData(i,A.filter_functions,h)||k.$headerIndexed[h].hasClass(\"filter-select\"),H.defaultColFilter[h]=a.getColumnData(i,A.filter_defaultFilter,h)||\"\",H.excludeFilter[h]=(a.getColumnData(i,A.filter_excludeFilter,h,!0)||\"\").split(/\\s+/);for(k.debug&&(console.log(\"Filter: Starting filter widget search\",s),w=new Date),k.filteredRows=0,k.totalRows=0,o=I||[],g=0;g<k.$tbodies.length;g++){if(p=a.processTbody(i,k.$tbodies.eq(g),!0),h=k.columns,l=k.cache[g].normalized,c=e(e.map(l,function(e){return e[h].$row.get()})),\"\"===o.join(\"\")||A.filter_serversideFiltering)c.removeClass(A.filter_filteredRow).not(\".\"+k.cssChildRow).css(\"display\",\"\");else{if(c=c.not(\".\"+k.cssChildRow),n=c.length,(A.filter_$anyMatch&&A.filter_$anyMatch.length||void 0!==s[k.columns])&&(D.anyMatchFlag=!0,D.anyMatchFilter=\"\"+(s[k.columns]||A.filter_$anyMatch&&t.getLatestSearch(A.filter_$anyMatch).val()||\"\"),A.filter_columnAnyMatch)){for(S=D.anyMatchFilter.split(r.andSplit),z=!1,C=0;C<S.length;C++)F=S[C].split(\":\"),F.length>1&&(isNaN(F[0])?e.each(k.headerContent,function(e,t){t.toLowerCase().indexOf(F[0])>-1&&(R=e,s[R]=F[1])}):R=parseInt(F[0],10)-1,R>=0&&R<k.columns&&(s[R]=F[1],S.splice(C,1),C--,z=!0));z&&(D.anyMatchFilter=S.join(\" && \"))}if($=A.filter_searchFiltered,b=k.lastSearch||k.$table.data(\"lastSearch\")||[],$)for(C=0;C<h+1;C++)x=s[C]||\"\",$||(C=h),$=$&&b.length&&0===x.indexOf(b[C]||\"\")&&!r.alreadyFiltered.test(x)&&!r.exactTest.test(x)&&!(r.isNeg1.test(x)||r.isNeg2.test(x))&&!(\"\"!==x&&k.$filters&&k.$filters.filter('[data-column=\"'+C+'\"]').find(\"select\").length&&!t.matchType(k,C));for(_=c.not(\".\"+A.filter_filteredRow).length,$&&0===_&&($=!1),k.debug&&console.log(\"Filter: Searching through \"+($&&_<n?_:\"all\")+\" rows\"),D.anyMatchFlag&&(k.sortLocaleCompare&&(D.anyMatchFilter=a.replaceAccents(D.anyMatchFilter)),A.filter_defaultFilter&&r.iQuery.test(H.defaultAnyFilter)&&(D.anyMatchFilter=t.defaultFilter(D.anyMatchFilter,H.defaultAnyFilter),$=!1),D.iAnyMatchFilter=A.filter_ignoreCase&&k.ignoreCase?D.anyMatchFilter.toLowerCase():D.anyMatchFilter),u=0;u<n;u++)if(T=c[u].className,!(u&&r.child.test(T)||$&&r.filtered.test(T))){if(D.$row=c.eq(u),D.rowIndex=u,D.cacheArray=l[u],d=D.cacheArray[k.columns],D.rawArray=d.raw,D.childRowText=\"\",!A.filter_childByColumn){for(T=\"\",m=d.child,C=0;C<m.length;C++)T+=\" \"+m[C].join(\" \")||\"\";D.childRowText=A.filter_childRows?A.filter_ignoreCase?T.toLowerCase():T:\"\"}if(y=!1,v=t.processRow(k,D,H),f=d.$row,x=!!v,m=d.$row.filter(\":gt(0)\"),A.filter_childRows&&m.length){if(A.filter_childByColumn)for(A.filter_childWithSibs||(m.addClass(A.filter_filteredRow),f=f.eq(0)),C=0;C<m.length;C++)D.$row=m.eq(C),D.cacheArray=d.child[C],D.rawArray=D.cacheArray,x=t.processRow(k,D,H),y=y||x,!A.filter_childWithSibs&&x&&m.eq(C).removeClass(A.filter_filteredRow);y=y||v}else y=x;f.toggleClass(A.filter_filteredRow,!y)[0].display=y?\"\":\"none\"}}k.filteredRows+=c.not(\".\"+A.filter_filteredRow).length,k.totalRows+=c.length,a.processTbody(i,p,!1)}k.lastCombinedFilter=I.join(\"\"),k.lastSearch=I,k.$table.data(\"lastSearch\",I),A.filter_saveFilters&&a.storage&&a.storage(i,\"tablesorter-filters\",t.processFilters(I,!0)),k.debug&&console.log(\"Completed filter widget search\"+a.benchmark(w)),A.filter_initialized&&(k.$table.triggerHandler(\"filterBeforeEnd\",k),k.$table.triggerHandler(\"filterEnd\",k)),setTimeout(function(){a.applyWidget(k.table)},0)}},getOptionSource:function(r,i,s){r=e(r)[0];var o=r.config,n=o.widgetOptions,l=!1,d=n.filter_selectSource,c=o.$table.data(\"lastSearch\")||[],f=\"function\"==typeof d||a.getColumnData(r,d,i);if(s&&\"\"!==c[i]&&(s=!1),!0===f)l=d(r,i,s);else{if(f instanceof e||\"string\"===e.type(f)&&f.indexOf(\"</option>\")>=0)return f;if(e.isArray(f))l=f;else if(\"object\"===e.type(d)&&f&&null===(l=f(r,i,s)))return null}return!1===l&&(l=t.getOptions(r,i,s)),t.processOptions(r,i,l)},processOptions:function(t,r,i){if(!e.isArray(i))return!1;t=e(t)[0];var s,o,n,l,d,c,f=t.config,u=void 0!==r&&null!==r&&r>=0&&r<f.columns,g=!!u&&f.$headerIndexed[r].hasClass(\"filter-select-sort-desc\"),p=[];if(i=e.grep(i,function(t,r){return!!t.text||e.inArray(t,i)===r}),u&&f.$headerIndexed[r].hasClass(\"filter-select-nosort\"))return i;for(l=i.length,n=0;n<l;n++)o=i[n],c=o.text?o.text:o,d=(u&&f.parsers&&f.parsers.length&&f.parsers[r].format(c,t,[],r)||c).toString(),d=f.widgetOptions.filter_ignoreCase?d.toLowerCase():d,o.text?(o.parsed=d,p[p.length]=o):p[p.length]={text:o,parsed:d};for(s=f.textSorter||\"\",p.sort(function(e,i){var o=g?i.parsed:e.parsed,n=g?e.parsed:i.parsed;return u&&\"function\"==typeof s?s(o,n,!0,r,t):u&&\"object\"==typeof s&&s.hasOwnProperty(r)?s[r](o,n,!0,r,t):!a.sortNatural||a.sortNatural(o,n)}),i=[],l=p.length,n=0;n<l;n++)i[i.length]=p[n];return i},getOptions:function(t,r,i){t=e(t)[0];var s,o,n,l,d,c,f,u,g=t.config,p=g.widgetOptions,h=[];for(o=0;o<g.$tbodies.length;o++)for(d=g.cache[o],n=g.cache[o].normalized.length,s=0;s<n;s++)if(l=d.row?d.row[s]:d.normalized[s][g.columns].$row[0],!i||!l.className.match(p.filter_filteredRow))if(p.filter_useParsedData||g.parsers[r].parsed||g.$headerIndexed[r].hasClass(\"filter-parsed\")){if(h[h.length]=\"\"+d.normalized[s][r],p.filter_childRows&&p.filter_childByColumn)for(u=d.normalized[s][g.columns].$row.length-1,c=0;c<u;c++)h[h.length]=\"\"+d.normalized[s][g.columns].child[c][r]}else if(h[h.length]=d.normalized[s][g.columns].raw[r],p.filter_childRows&&p.filter_childByColumn)for(u=d.normalized[s][g.columns].$row.length,c=1;c<u;c++)f=d.normalized[s][g.columns].$row.eq(c).children().eq(r),h[h.length]=\"\"+a.getElementText(g,f,r);return h},buildSelect:function(a,s,o,n,l){if(a=e(a)[0],s=parseInt(s,10),a.config.cache&&!e.isEmptyObject(a.config.cache)){var d,c,f,u,g,p,h,m=a.config,b=m.widgetOptions,y=m.$headerIndexed[s],v='<option value=\"\">'+(y.data(\"placeholder\")||y.attr(\"data-placeholder\")||b.filter_placeholder.select||\"\")+\"</option>\",w=m.$table.find(\"thead\").find(\"select.\"+i.filter+'[data-column=\"'+s+'\"]').val();if(void 0!==o&&\"\"!==o||null!==(o=t.getOptionSource(a,s,l))){if(e.isArray(o)){for(d=0;d<o.length;d++)if(h=o[d],h.text){h[\"data-function-name\"]=void 0===h.value?h.text:h.value,v+=\"<option\";for(c in h)h.hasOwnProperty(c)&&\"text\"!==c&&(v+=\" \"+c+'=\"'+h[c]+'\"');h.value||(v+=' value=\"'+h.text+'\"'),v+=\">\"+h.text+\"</option>\"}else\"\"+h!=\"[object Object]\"&&(f=h=(\"\"+h).replace(r.quote,\"&quot;\"),c=f,f.indexOf(b.filter_selectSourceSeparator)>=0&&(u=f.split(b.filter_selectSourceSeparator),c=u[0],f=u[1]),v+=\"\"!==h?\"<option \"+(c===f?\"\":'data-function-name=\"'+h+'\" ')+'value=\"'+c+'\">'+f+\"</option>\":\"\");o=[]}g=(m.$filters?m.$filters:m.$table.children(\"thead\")).find(\".\"+i.filter),b.filter_$externalFilters&&(g=g&&g.length?g.add(b.filter_$externalFilters):b.filter_$externalFilters),p=g.filter('select[data-column=\"'+s+'\"]'),p.length&&(p[n?\"html\":\"append\"](v),e.isArray(o)||p.append(o).val(w),p.val(w))}}},buildDefault:function(e,r){var i,s,o,n=e.config,l=n.widgetOptions,d=n.columns;for(i=0;i<d;i++)s=n.$headerIndexed[i],o=!(s.hasClass(\"filter-false\")||s.hasClass(\"parser-false\")),(s.hasClass(\"filter-select\")||!0===a.getColumnData(e,l.filter_functions,i))&&o&&t.buildSelect(e,i,\"\",r,s.hasClass(l.filter_onlyAvail))}},r=t.regex,a.getFilters=function(r,a,s,o){var n,l,d,c,f=[],u=r?e(r)[0].config:\"\",g=u?u.widgetOptions:\"\";if(!0!==a&&g&&!g.filter_columnFilters||e.isArray(s)&&t.equalFilters(u,s,u.lastSearch))return e(r).data(\"lastSearch\")||[];if(u&&(u.$filters&&(l=u.$filters.find(\".\"+i.filter)),g.filter_$externalFilters&&(l=l&&l.length?l.add(g.filter_$externalFilters):g.filter_$externalFilters),l&&l.length))for(f=s||[],n=0;n<u.columns+1;n++)c=n===u.columns?g.filter_anyColumnSelector+\",\"+g.filter_multipleColumnSelector:'[data-column=\"'+n+'\"]',d=l.filter(c),d.length&&(d=t.getLatestSearch(d),e.isArray(s)?(o&&d.length>1&&(d=d.slice(1)),n===u.columns&&(c=d.filter(g.filter_anyColumnSelector),d=c.length?c:d),d.val(s[n]).trigger(\"change\"+u.namespace)):(f[n]=d.val()||\"\",n===u.columns?d.slice(1).filter('[data-column*=\"'+d.attr(\"data-column\")+'\"]').val(f[n]):d.slice(1).val(f[n])),n===u.columns&&d.length&&(g.filter_$anyMatch=d));return f},a.setFilters=function(r,i,s,o){var n=r?e(r)[0].config:\"\",l=a.getFilters(r,!0,i,o);return void 0===s&&(s=!0),n&&s&&(n.lastCombinedFilter=null,n.lastSearch=[],t.searching(n.table,i,o),n.$table.triggerHandler(\"filterFomatterUpdate\")),0!==l.length}}(e),function(e,t){\"use strict\";function r(t,r){var a=isNaN(r.stickyHeaders_offset)?e(r.stickyHeaders_offset):[];return a.length?a.height()||0:parseInt(r.stickyHeaders_offset,10)||0}var a=e.tablesorter||{};e.extend(a.css,{sticky:\"tablesorter-stickyHeader\",stickyVis:\"tablesorter-sticky-visible\",stickyHide:\"tablesorter-sticky-hidden\",stickyWrap:\"tablesorter-sticky-wrapper\"}),a.addHeaderResizeEvent=function(t,r,a){if(t=e(t)[0],t.config){var i={timer:250},s=e.extend({},i,a),o=t.config,n=o.widgetOptions,l=function(e){var t,r,a,i,s,l,d=o.$headers.length;for(n.resize_flag=!0,r=[],t=0;t<d;t++)a=o.$headers.eq(t),i=a.data(\"savedSizes\")||[0,0],s=a[0].offsetWidth,l=a[0].offsetHeight,s===i[0]&&l===i[1]||(a.data(\"savedSizes\",[s,l]),r.push(a[0]));r.length&&!1!==e&&o.$table.triggerHandler(\"resize\",[r]),n.resize_flag=!1};if(clearInterval(n.resize_timer),r)return n.resize_flag=!1,!1;l(!1),n.resize_timer=setInterval(function(){n.resize_flag||l()},s.timer)}},a.addWidget({id:\"stickyHeaders\",priority:54,options:{stickyHeaders:\"\",stickyHeaders_appendTo:null,stickyHeaders_attachTo:null,stickyHeaders_xScroll:null,stickyHeaders_yScroll:null,stickyHeaders_offset:0,stickyHeaders_filteredToTop:!0,stickyHeaders_cloneId:\"-sticky\",stickyHeaders_addResizeEvent:!0,stickyHeaders_includeCaption:!0,stickyHeaders_zIndex:2},format:function(i,s,o){if(!(s.$table.hasClass(\"hasStickyHeaders\")||e.inArray(\"filter\",s.widgets)>=0&&!s.$table.hasClass(\"hasFilters\"))){var n,l,d,c,f=s.$table,u=e(o.stickyHeaders_attachTo),g=s.namespace+\"stickyheaders \",p=e(o.stickyHeaders_yScroll||o.stickyHeaders_attachTo||t),h=e(o.stickyHeaders_xScroll||o.stickyHeaders_attachTo||t),m=f.children(\"thead:first\"),b=m.children(\"tr\").not(\".sticky-false\").children(),y=f.children(\"tfoot\"),v=r(s,o),w=f.parent().closest(\".\"+a.css.table).hasClass(\"hasStickyHeaders\")?f.parent().closest(\"table.tablesorter\")[0].config.widgetOptions.$sticky.parent():[],x=w.length?w.height():0,C=o.$sticky=f.clone().addClass(\"containsStickyHeaders \"+a.css.sticky+\" \"+o.stickyHeaders+\" \"+s.namespace.slice(1)+\"_extra_table\").wrap('<div class=\"'+a.css.stickyWrap+'\">'),_=C.parent().addClass(a.css.stickyHide).css({position:u.length?\"absolute\":\"fixed\",padding:parseInt(C.parent().parent().css(\"padding-left\"),10),top:v+x,left:0,visibility:\"hidden\",zIndex:o.stickyHeaders_zIndex||2}),$=C.children(\"thead:first\"),S=\"\",z=function(e,r){var a,i,s,o,n,l=e.filter(\":visible\"),d=l.length;for(a=0;a<d;a++)o=r.filter(\":visible\").eq(a),n=l.eq(a),\"border-box\"===n.css(\"box-sizing\")?i=n.outerWidth():\"collapse\"===o.css(\"border-collapse\")?t.getComputedStyle?i=parseFloat(t.getComputedStyle(n[0],null).width):(s=parseFloat(n.css(\"border-width\")),i=n.outerWidth()-parseFloat(n.css(\"padding-left\"))-parseFloat(n.css(\"padding-right\"))-s):i=n.width(),o.css({width:i,\"min-width\":i,\"max-width\":i})},F=function(){_.css({left:u.length?parseInt(u.css(\"padding-left\"),10)||0:f.offset().left-parseInt(f.css(\"margin-left\"),10)-h.scrollLeft(),width:f.outerWidth()}),z(f,C),z(b,c)},R=function(t){if(f.is(\":visible\")){x=w.length?w.offset().top-p.scrollTop()+w.height():0;var i=f.offset(),n=r(s,o),l=e.isWindow(p[0]),d=e.isWindow(h[0]),c=u.length?l?p.scrollTop():p.offset().top:p.scrollTop(),g=o.stickyHeaders_includeCaption?0:f.children(\"caption\").height()||0,m=c+n+x-g,b=f.height()-(_.height()+(y.height()||0))-g,v=m>i.top&&m<i.top+b?\"visible\":\"hidden\",C={visibility:v};u.length&&(C.top=l?m-u.offset().top:u.scrollTop()),d&&(C.left=f.offset().left-parseInt(f.css(\"margin-left\"),10)-h.scrollLeft()),C.top=(C.top||0)+n+x,_.removeClass(a.css.stickyVis+\" \"+a.css.stickyHide).addClass(\"visible\"===v?a.css.stickyVis:a.css.stickyHide).css(C),(v!==S||t)&&(F(),S=v)}};if(u.length&&!u.css(\"position\")&&u.css(\"position\",\"relative\"),C.attr(\"id\")&&(C[0].id+=o.stickyHeaders_cloneId),C.find(\"thead:gt(0), tr.sticky-false\").hide(),C.find(\"tbody, tfoot\").remove(),C.find(\"caption\").toggle(o.stickyHeaders_includeCaption),c=$.children().children(),C.css({height:0,width:0,margin:0}),c.find(\".\"+a.css.resizer).remove(),f.addClass(\"hasStickyHeaders\").bind(\"pagerComplete\"+g,function(){F()}),a.bindEvents(i,$.children().children(\".\"+a.css.header)),o.stickyHeaders_appendTo?e(o.stickyHeaders_appendTo).append(_):f.after(_),s.onRenderHeader)for(d=$.children(\"tr\").children(),l=d.length,n=0;n<l;n++)s.onRenderHeader.apply(d.eq(n),[n,s,C]);h.add(p).unbind(\"scroll resize \".split(\" \").join(g).replace(/\\s+/g,\" \")).bind(\"scroll resize \".split(\" \").join(g),function(e){R(\"resize\"===e.type)}),s.$table.unbind(\"stickyHeadersUpdate\"+g).bind(\"stickyHeadersUpdate\"+g,function(){R(!0)}),o.stickyHeaders_addResizeEvent&&a.addHeaderResizeEvent(i),f.hasClass(\"hasFilters\")&&o.filter_columnFilters&&(f.bind(\"filterEnd\"+g,function(){var r=e(document.activeElement).closest(\"td\"),i=r.parent().children().index(r);_.hasClass(a.css.stickyVis)&&o.stickyHeaders_filteredToTop&&(t.scrollTo(0,f.position().top),i>=0&&s.$filters&&s.$filters.eq(i).find(\"a, select, input\").filter(\":visible\").focus())}),a.filter.bindSearch(f,c.find(\".\"+a.css.filter)),o.filter_hideFilters&&a.filter.hideFilters(s,C)),o.stickyHeaders_addResizeEvent&&f.bind(\"resize\"+s.namespace+\"stickyheaders\",function(){F()}),R(!0),f.triggerHandler(\"stickyHeadersInit\")}},remove:function(r,i,s){var o=i.namespace+\"stickyheaders \";i.$table.removeClass(\"hasStickyHeaders\").unbind(\"pagerComplete resize filterEnd stickyHeadersUpdate \".split(\" \").join(o).replace(/\\s+/g,\" \")).next(\".\"+a.css.stickyWrap).remove(),s.$sticky&&s.$sticky.length&&s.$sticky.remove(),e(t).add(s.stickyHeaders_xScroll).add(s.stickyHeaders_yScroll).add(s.stickyHeaders_attachTo).unbind(\"scroll resize \".split(\" \").join(o).replace(/\\s+/g,\" \")),a.addHeaderResizeEvent(r,!0)}})}(e,window),function(e,t){\"use strict\";var r=e.tablesorter||{};e.extend(r.css,{resizableContainer:\"tablesorter-resizable-container\",resizableHandle:\"tablesorter-resizable-handle\",resizableNoSelect:\"tablesorter-disableSelection\",resizableStorage:\"tablesorter-resizable\"}),e(function(){var t=\"<style>body.\"+r.css.resizableNoSelect+\" { -ms-user-select: none; -moz-user-select: -moz-none;-khtml-user-select: none; -webkit-user-select: none; user-select: none; }.\"+r.css.resizableContainer+\" { position: relative; height: 1px; }.\"+r.css.resizableHandle+\" { position: absolute; display: inline-block; width: 8px;top: 1px; cursor: ew-resize; z-index: 3; user-select: none; -moz-user-select: none; }</style>\";e(\"head\").append(t)}),r.resizable={init:function(t,a){if(!t.$table.hasClass(\"hasResizable\")){t.$table.addClass(\"hasResizable\");var i,s,o,n,l=t.$table,d=l.parent(),c=parseInt(l.css(\"margin-top\"),10),f=a.resizable_vars={useStorage:r.storage&&!1!==a.resizable,$wrap:d,mouseXPosition:0,$target:null,$next:null,overflow:\"auto\"===d.css(\"overflow\")||\"scroll\"===d.css(\"overflow\")||\"auto\"===d.css(\"overflow-x\")||\"scroll\"===d.css(\"overflow-x\"),storedSizes:[]};for(r.resizableReset(t.table,!0),f.tableWidth=l.width(),f.fullWidth=Math.abs(d.width()-f.tableWidth)<20,f.useStorage&&f.overflow&&(r.storage(t.table,\"tablesorter-table-original-css-width\",f.tableWidth),n=r.storage(t.table,\"tablesorter-table-resized-width\")||\"auto\",r.resizable.setWidth(l,n,!0)),a.resizable_vars.storedSizes=o=(f.useStorage?r.storage(t.table,r.css.resizableStorage):[])||[],r.resizable.setWidths(t,a,o),r.resizable.updateStoredSizes(t,a),a.$resizable_container=e('<div class=\"'+r.css.resizableContainer+'\">').css({top:c}).insertBefore(l),s=0;s<t.columns;s++)i=t.$headerIndexed[s],n=r.getColumnData(t.table,t.headers,s),\"false\"===r.getData(i,n,\"resizable\")||e('<div class=\"'+r.css.resizableHandle+'\">').appendTo(a.$resizable_container).attr({\"data-column\":s,unselectable:\"on\"}).data(\"header\",i).bind(\"selectstart\",!1);r.resizable.bindings(t,a)}},updateStoredSizes:function(e,t){var r,a,i=e.columns,s=t.resizable_vars;for(s.storedSizes=[],r=0;r<i;r++)a=e.$headerIndexed[r],s.storedSizes[r]=a.is(\":visible\")?a.width():0},setWidth:function(e,t,r){e.css({width:t,\"min-width\":r?t:\"\",\"max-width\":r?t:\"\"})},setWidths:function(t,a,i){var s,o,n=a.resizable_vars,l=e(t.namespace+\"_extra_headers\"),d=t.$table.children(\"colgroup\").children(\"col\");if(i=i||n.storedSizes||[],i.length){for(s=0;s<t.columns;s++)r.resizable.setWidth(t.$headerIndexed[s],i[s],n.overflow),l.length&&(o=l.eq(s).add(d.eq(s)),r.resizable.setWidth(o,i[s],n.overflow));o=e(t.namespace+\"_extra_table\"),o.length&&!r.hasWidget(t.table,\"scroller\")&&r.resizable.setWidth(o,t.$table.outerWidth(),n.overflow)}},setHandlePosition:function(t,a){var i,s=t.$table.height(),o=a.$resizable_container.children(),n=Math.floor(o.width()/2);r.hasWidget(t.table,\"scroller\")&&(s=0,t.$table.closest(\".\"+r.css.scrollerWrap).children().each(function(){var t=e(this);s+=t.filter('[style*=\"height\"]').length?t.height():t.children(\"table\").height()})),!a.resizable_includeFooter&&t.$table.children(\"tfoot\").length&&(s-=t.$table.children(\"tfoot\").height()),i=t.$table.position().left,o.each(function(){var r=e(this),o=parseInt(r.attr(\"data-column\"),10),l=t.columns-1,d=r.data(\"header\");d&&(d.is(\":visible\")?(o<l||o===l&&a.resizable_addLastColumn)&&r.css({display:\"inline-block\",height:s,left:d.position().left-i+d.outerWidth()-n}):r.hide())})},toggleTextSelection:function(t,a,i){var s=t.namespace+\"tsresize\";a.resizable_vars.disabled=i,e(\"body\").toggleClass(r.css.resizableNoSelect,i),i?e(\"body\").attr(\"unselectable\",\"on\").bind(\"selectstart\"+s,!1):e(\"body\").removeAttr(\"unselectable\").unbind(\"selectstart\"+s)},bindings:function(a,i){var s=a.namespace+\"tsresize\";i.$resizable_container.children().bind(\"mousedown\",function(t){var s,o=i.resizable_vars,n=e(a.namespace+\"_extra_headers\"),l=e(t.target).data(\"header\");s=parseInt(l.attr(\"data-column\"),10),o.$target=l=l.add(n.filter('[data-column=\"'+s+'\"]')),o.target=s,o.$next=t.shiftKey||i.resizable_targetLast?l.parent().children().not(\".resizable-false\").filter(\":last\"):l.nextAll(\":not(.resizable-false)\").eq(0),s=parseInt(o.$next.attr(\"data-column\"),10),o.$next=o.$next.add(n.filter('[data-column=\"'+s+'\"]')),o.next=s,o.mouseXPosition=t.pageX,r.resizable.updateStoredSizes(a,i),r.resizable.toggleTextSelection(a,i,!0)}),e(document).bind(\"mousemove\"+s,function(e){var t=i.resizable_vars;t.disabled&&0!==t.mouseXPosition&&t.$target&&(i.resizable_throttle?(clearTimeout(t.timer),t.timer=setTimeout(function(){r.resizable.mouseMove(a,i,e)},isNaN(i.resizable_throttle)?5:i.resizable_throttle)):r.resizable.mouseMove(a,i,e))}).bind(\"mouseup\"+s,function(){i.resizable_vars.disabled&&(r.resizable.toggleTextSelection(a,i,!1),r.resizable.stopResize(a,i),r.resizable.setHandlePosition(a,i))}),e(t).bind(\"resize\"+s+\" resizeEnd\"+s,function(){r.resizable.setHandlePosition(a,i)}),a.$table.bind(\"columnUpdate pagerComplete resizableUpdate \".split(\" \").join(s+\" \"),function(){r.resizable.setHandlePosition(a,i)}).bind(\"resizableReset\"+s,function(){r.resizableReset(a.table)}).find(\"thead:first\").add(e(a.namespace+\"_extra_table\").find(\"thead:first\")).bind(\"contextmenu\"+s,function(){var e=0===i.resizable_vars.storedSizes.length;return r.resizableReset(a.table),r.resizable.setHandlePosition(a,i),i.resizable_vars.storedSizes=[],e})},mouseMove:function(t,a,i){if(0!==a.resizable_vars.mouseXPosition&&a.resizable_vars.$target){var s,o=0,n=a.resizable_vars,l=n.$next,d=n.storedSizes[n.target],c=i.pageX-n.mouseXPosition;if(n.overflow){if(d+c>0){for(n.storedSizes[n.target]+=c,r.resizable.setWidth(n.$target,n.storedSizes[n.target],!0),s=0;s<t.columns;s++)o+=n.storedSizes[s];r.resizable.setWidth(t.$table.add(e(t.namespace+\"_extra_table\")),o)}l.length||(n.$wrap[0].scrollLeft=t.$table.width())}else n.fullWidth?(n.storedSizes[n.target]+=c,n.storedSizes[n.next]-=c,r.resizable.setWidths(t,a)):(n.storedSizes[n.target]+=c,r.resizable.setWidths(t,a));n.mouseXPosition=i.pageX,t.$table.triggerHandler(\"stickyHeadersUpdate\")}},stopResize:function(e,t){var a=t.resizable_vars;r.resizable.updateStoredSizes(e,t),a.useStorage&&(r.storage(e.table,r.css.resizableStorage,a.storedSizes),r.storage(e.table,\"tablesorter-table-resized-width\",e.$table.width())),a.mouseXPosition=0,a.$target=a.$next=null,e.$table.triggerHandler(\"stickyHeadersUpdate\")}},r.addWidget({id:\"resizable\",priority:40,options:{resizable:!0,resizable_addLastColumn:!1,resizable_includeFooter:!0,resizable_widths:[],resizable_throttle:!1,resizable_targetLast:!1},init:function(e,t,a,i){r.resizable.init(a,i)},format:function(e,t,a){r.resizable.setHandlePosition(t,a)},remove:function(t,a,i,s){if(i.$resizable_container){var o=a.namespace+\"tsresize\";a.$table.add(e(a.namespace+\"_extra_table\")).removeClass(\"hasResizable\").children(\"thead\").unbind(\"contextmenu\"+o),i.$resizable_container.remove(),r.resizable.toggleTextSelection(a,i,!1),r.resizableReset(t,s),e(document).unbind(\"mousemove\"+o+\" mouseup\"+o)}}}),r.resizableReset=function(t,a){e(t).each(function(){var e,i,s=this.config,o=s&&s.widgetOptions,n=o.resizable_vars;if(t&&s&&s.$headerIndexed.length){for(n.overflow&&n.tableWidth&&(r.resizable.setWidth(s.$table,n.tableWidth,!0),n.useStorage&&r.storage(t,\"tablesorter-table-resized-width\",\"auto\")),e=0;e<s.columns;e++)i=s.$headerIndexed[e],o.resizable_widths&&o.resizable_widths[e]?r.resizable.setWidth(i,o.resizable_widths[e],n.overflow):i.hasClass(\"resizable-false\")||r.resizable.setWidth(i,\"\",n.overflow);s.$table.triggerHandler(\"stickyHeadersUpdate\"),r.storage&&!a&&r.storage(this,r.css.resizableStorage,{})}})}}(e,window),function(e){\"use strict\";var t=e.tablesorter||{};t.addWidget({id:\"saveSort\",priority:20,options:{saveSort:!0},init:function(e,t,r,a){t.format(e,r,a,!0)},format:function(r,a,i,s){var o,n,l=a.$table,d=!1!==i.saveSort,c={sortList:a.sortList};a.debug&&(n=new Date),l.hasClass(\"hasSaveSort\")?d&&r.hasInitialized&&t.storage&&(t.storage(r,\"tablesorter-savesort\",c),a.debug&&console.log(\"saveSort widget: Saving last sort: \"+a.sortList+t.benchmark(n))):(l.addClass(\"hasSaveSort\"),c=\"\",t.storage&&(o=t.storage(r,\"tablesorter-savesort\"),c=o&&o.hasOwnProperty(\"sortList\")&&e.isArray(o.sortList)?o.sortList:\"\",a.debug&&console.log('saveSort: Last sort loaded: \"'+c+'\"'+t.benchmark(n)),l.bind(\"saveSortReset\",function(e){e.stopPropagation(),t.storage(r,\"tablesorter-savesort\",\"\")})),s&&c&&c.length>0?a.sortList=c:r.hasInitialized&&c&&c.length>0&&t.sortOn(a,c))},remove:function(e,r){r.$table.removeClass(\"hasSaveSort\"),t.storage&&t.storage(e,\"tablesorter-savesort\",\"\")}})}(e),e.tablesorter});"

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(97))

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	module.exports = "\"use strict\";!function(e){function t(){var t=e('<style id=\"__dragtable_disable_text_selection__\" type=\"text/css\">body { -ms-user-select:none;-moz-user-select:-moz-none;-khtml-user-select:none;-webkit-user-select:none;user-select:none; }</style>');e(document.head).append(t),e(document.body).attr(\"onselectstart\",\"return false;\").attr(\"unselectable\",\"on\"),window.getSelection?window.getSelection().removeAllRanges():document.selection.empty()}function i(){e(\"#__dragtable_disable_text_selection__\").remove(),o?e(document.body).attr(\"onselectstart\",o):e(document.body).removeAttr(\"onselectstart\"),a?e(document.body).attr(\"unselectable\",a):e(document.body).removeAttr(\"unselectable\")}function n(e,t){var i=e.parentNode,n=e.nextSibling===t?e:e.nextSibling;t.parentNode.insertBefore(e,t),i.insertBefore(t,n)}e.widget(\"akottr.dragtable\",{options:{revert:!1,dragHandle:\".table-handle\",maxMovingRows:40,excludeFooter:!1,onlyHeaderThreshold:100,dragaccept:null,persistState:null,restoreState:null,exact:!0,clickDelay:10,containment:null,cursor:\"move\",cursorAt:!1,distance:0,tolerance:\"pointer\",axis:\"x\",beforeStart:e.noop,beforeMoving:e.noop,beforeReorganize:e.noop,beforeStop:e.noop},originalTable:{el:null,selectedHandle:null,sortOrder:null,startIndex:0,endIndex:0},sortableTable:{el:e(),selectedHandle:e(),movingRow:e()},persistState:function(){var t=this;this.originalTable.el.find(\"th\").each(function(e){\"\"!==this.id&&(t.originalTable.sortOrder[this.id]=e)}),e.ajax({url:this.options.persistState,data:this.originalTable.sortOrder})},_restoreState:function(t){for(var i in t)this.originalTable.startIndex=e(\"#\"+i).closest(\"th\").prevAll().length+1,this.originalTable.endIndex=parseInt(t[i],10)+1,this._bubbleCols()},_bubbleCols:function(){var e,t,i,o,a=this.originalTable.startIndex,l=this.originalTable.endIndex,s=this.originalTable.el.children();if(this.options.excludeFooter&&(s=s.not(\"tfoot\")),a<l)for(e=a;e<l;e++)for(i=s.find(\"> tr > td:nth-child(\"+e+\")\").add(s.find(\"> tr > th:nth-child(\"+e+\")\")),o=s.find(\"> tr > td:nth-child(\"+(e+1)+\")\").add(s.find(\"> tr > th:nth-child(\"+(e+1)+\")\")),t=0;t<i.length;t++)n(i[t],o[t]);else for(e=a;e>l;e--)for(i=s.find(\"> tr > td:nth-child(\"+e+\")\").add(s.find(\"> tr > th:nth-child(\"+e+\")\")),o=s.find(\"> tr > td:nth-child(\"+(e-1)+\")\").add(s.find(\"> tr > th:nth-child(\"+(e-1)+\")\")),t=0;t<i.length;t++)n(i[t],o[t])},_rearrangeTableBackroundProcessing:function(){var t=this;return function(){t._bubbleCols(),t.options.beforeStop(t.originalTable),t.sortableTable.el.remove(),i(),null!==t.options.persistState&&(e.isFunction(t.options.persistState)?t.options.persistState(t.originalTable):t.persistState())}},_rearrangeTable:function(){var e=this;return function(){e.originalTable.selectedHandle.removeClass(\"dragtable-handle-selected\"),e.sortableTable.el.sortable(\"disable\"),e.sortableTable.el.addClass(\"dragtable-disabled\"),e.options.beforeReorganize(e.originalTable,e.sortableTable),e.originalTable.endIndex=e.sortableTable.movingRow.prevAll().length+1,setTimeout(e._rearrangeTableBackroundProcessing(),50)}},_generateSortable:function(i){!i.cancelBubble&&(i.cancelBubble=!0);for(var n=this,o=this.originalTable.el[0].attributes,a=\"\",l=0;l<o.length;l++)o[l].nodeValue&&\"id\"!=o[l].nodeName&&\"width\"!=o[l].nodeName&&(a+=o[l].nodeName+'=\"'+o[l].nodeValue+'\" ');var s=[],r=[];this.originalTable.el.find(\"tr\").slice(0,this.options.maxMovingRows).each(function(t,i){for(var n=this.attributes,o=\"\",a=0;a<n.length;a++)n[a].nodeValue&&\"id\"!=n[a].nodeName&&(o+=\" \"+n[a].nodeName+'=\"'+n[a].nodeValue+'\"');s.push(o),r.push(e(this).height())});var d=[],h=0,c=n.originalTable.el.children();if(this.options.excludeFooter&&(c=c.not(\"tfoot\")),c.find(\"> tr > th\").each(function(t,i){var n=e(this).is(\":visible\")?e(this).outerWidth():0;d.push(n),h+=n}),n.options.exact){var b=h-n.originalTable.el.outerWidth();d[0]-=b}h+=2;var u='<ul class=\"dragtable-sortable\" style=\"position:absolute; width:'+h+'px;\">';c.find(\"> tr > th\").each(function(t,i){var o=e(this).is(\":visible\")?e(this).outerWidth():0;u+='<li style=\"width:'+o+'px;\">',u+=\"<table \"+a+\">\";var l=c.find(\"> tr > th:nth-child(\"+(t+1)+\")\");n.options.maxMovingRows>1&&(l=l.add(c.find(\"> tr > td:nth-child(\"+(t+1)+\")\").slice(0,n.options.maxMovingRows-1))),l.each(function(t){var i=e(this).clone().wrap(\"<div></div>\").parent().html();0===i.toLowerCase().indexOf(\"<th\")&&(u+=\"<thead>\"),u+=\"<tr \"+s[t]+'\" style=\"height:'+r[t]+'px;\">',u+=i,0===i.toLowerCase().indexOf(\"<th\")&&(u+=\"</thead>\"),u+=\"</tr>\"}),u+=\"</table>\",u+=\"</li>\"}),u+=\"</ul>\",this.sortableTable.el=this.originalTable.el.before(u).prev(),this.sortableTable.el.find(\"> li > table\").each(function(t,i){e(this).css(\"width\",d[t]+\"px\")}),this.sortableTable.selectedHandle=this.sortableTable.el.find(\"th .dragtable-handle-selected\");var g=this.options.dragaccept?\"li:has(\"+this.options.dragaccept+\")\":\"li\";this.sortableTable.el.sortable({items:g,stop:this._rearrangeTable(),revert:this.options.revert,tolerance:this.options.tolerance,containment:this.options.containment,cursor:this.options.cursor,cursorAt:this.options.cursorAt,distance:this.options.distance,axis:this.options.axis}),this.originalTable.startIndex=e(i.target).closest(\"th\").prevAll().length+1,this.options.beforeMoving(this.originalTable,this.sortableTable),this.sortableTable.movingRow=this.sortableTable.el.find(\"> li:nth-child(\"+this.originalTable.startIndex+\")\"),t(),this.sortableTable.movingRow.trigger(e.extend(e.Event(i.type),{which:1,clientX:i.clientX,clientY:i.clientY,pageX:i.pageX,pageY:i.pageY,screenX:i.screenX,screenY:i.screenY}));var p=this.sortableTable.el.find(\".ui-sortable-placeholder\");!p.height()<=0&&p.css(\"height\",this.sortableTable.el.find(\".ui-sortable-helper\").height()),p.html('<div class=\"outer\" style=\"height:100%;\"><div class=\"inner\" style=\"height:100%;\"></div></div>')},bindTo:{},_create:function(){this.originalTable={el:this.element,selectedHandle:e(),sortOrder:{},startIndex:0,endIndex:0},this.bindTo=this.originalTable.el.find(\"th\"),this.options.dragaccept&&(this.bindTo=this.bindTo.filter(this.options.dragaccept)),this.bindTo.find(this.options.dragHandle).length>0&&(this.bindTo=this.bindTo.find(this.options.dragHandle)),null!==this.options.restoreState&&(e.isFunction(this.options.restoreState)?this.options.restoreState(this.originalTable):this._restoreState(this.options.restoreState));var t=this;this.bindTo.mousedown(function(i){1===i.which&&!1!==t.options.beforeStart(t.originalTable)&&(clearTimeout(this.downTimer),this.downTimer=setTimeout(function(){t.originalTable.selectedHandle=e(this),t.originalTable.selectedHandle.addClass(\"dragtable-handle-selected\"),t._generateSortable(i)},t.options.clickDelay))}).mouseup(function(e){clearTimeout(this.downTimer)})},redraw:function(){this.destroy(),this._create()},destroy:function(){this.bindTo.unbind(\"mousedown\"),e.Widget.prototype.destroy.apply(this,arguments)}});var o=e(document.body).attr(\"onselectstart\"),a=e(document.body).attr(\"unselectable\")}(jQuery);"

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(99))

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	module.exports = "\"use strict\";var _typeof=\"function\"==typeof Symbol&&\"symbol\"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&\"function\"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?\"symbol\":typeof e};!function(e){var t=function(e,t){this.$context=e};t.prototype.check=function(){this.$context.find(\":checkbox\").filter(\":not(:disabled)\").prop(\"checked\",!0)},t.prototype.uncheck=function(){this.$context.find(\":checkbox\").filter(\":not(:disabled)\").prop(\"checked\",!1)},t.prototype.toggle=function(){this.$context.find(\":checkbox\").filter(\":not(:disabled)\").each(function(){var t=e(this);t.prop(\"checked\",!t.is(\":checked\"))})},t.prototype.max=function(e){if(0===e)this.$context.off(\"click.checkboxes\");else if(e>0){var t=this;this.$context.on(\"click.checkboxes.max\",\":checkbox\",function(c){t.$context.find(\":checked\").length===e?t.$context.find(\":checkbox:not(:checked)\").prop(\"disabled\",!0):t.$context.find(\":checkbox:not(:checked)\").prop(\"disabled\",!1)})}},t.prototype.range=function(t){if(t){var c=this;this.$context.on(\"click.checkboxes.range\",\":checkbox\",function(t){var o=e(t.target);if(t.shiftKey&&c.$last){var n=c.$context.find(\":checkbox\"),i=n.index(c.$last),a=n.index(o),r=Math.min(i,a),h=Math.max(i,a)+1;n.slice(r,h).filter(\":not(:disabled)\").prop(\"checked\",o.prop(\"checked\")).trigger(\"change\")}c.$last=o})}else this.$context.off(\"click.checkboxes.range\")};var c=e.fn.checkboxes;e.fn.checkboxes=function(c){var o=Array.prototype.slice.call(arguments,1);return this.each(function(){var n=e(this),i=n.data(\"checkboxes\");i||n.data(\"checkboxes\",i=new t(n,\"object\"===(void 0===c?\"undefined\":_typeof(c))&&c)),\"string\"==typeof c&&i[c]&&i[c].apply(i,o)})},e.fn.checkboxes.Constructor=t,e.fn.checkboxes.noConflict=function(){return e.fn.checkboxes=c,this},e(document).on(\"click.checkboxes.data-api\",\"[data-toggle^=checkboxes]\",function(t){var c=e(t.target),o=c.attr(\"href\"),n=e(c.data(\"context\")||o&&o.replace(/.*(?=#[^\\s]+$)/,\"\")),i=c.data(\"action\");n&&i&&(c.is(\":checkbox\")||t.preventDefault(),n.checkboxes(i))}),e(document).on(\"ready.checkboxes.data-api\",function(){e(\"[data-toggle^=checkboxes]\").each(function(){var t=e(this),c=t.data();delete c.toggle;for(var o in c)t.checkboxes(o,c[o])})})}(window.jQuery);"

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(101))

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	module.exports = "!function(t,e){\"object\"==typeof module&&module.exports?module.exports=e():\"function\"==typeof define&&define.amd?define(e):t.Spinner=e()}(this,function(){\"use strict\";function t(t,e){var i,o=document.createElement(t||\"div\");for(i in e)o[i]=e[i];return o}function e(t){for(var e=1,i=arguments.length;e<i;e++)t.appendChild(arguments[e]);return t}function i(t,e,i,o){var n=[\"opacity\",e,~~(100*t),i,o].join(\"-\"),r=.01+i/o*100,s=Math.max(1-(1-t)/e*(100-r),t),a=l.substring(0,l.indexOf(\"Animation\")).toLowerCase(),d=a&&\"-\"+a+\"-\"||\"\";return p[n]||(c.insertRule(\"@\"+d+\"keyframes \"+n+\"{0%{opacity:\"+s+\"}\"+r+\"%{opacity:\"+t+\"}\"+(r+.01)+\"%{opacity:1}\"+(r+e)%100+\"%{opacity:\"+t+\"}100%{opacity:\"+s+\"}}\",c.cssRules.length),p[n]=1),n}function o(t,e){var i,o,n=t.style;if(e=e.charAt(0).toUpperCase()+e.slice(1),void 0!==n[e])return e;for(o=0;o<d.length;o++)if(i=d[o]+e,void 0!==n[i])return i}function n(t,e){for(var i in e)t.style[o(t,i)||i]=e[i];return t}function r(t){for(var e=1;e<arguments.length;e++){var i=arguments[e];for(var o in i)void 0===t[o]&&(t[o]=i[o])}return t}function s(t,e){return\"string\"==typeof t?t:t[e%t.length]}function a(t){this.opts=r(t||{},a.defaults,u)}var l,c,d=[\"webkit\",\"Moz\",\"ms\",\"O\"],p={},u={lines:12,length:7,width:5,radius:10,scale:1,corners:1,color:\"#000\",opacity:.25,rotate:0,direction:1,speed:1,trail:100,fps:20,zIndex:2e9,className:\"spinner\",top:\"50%\",left:\"50%\",shadow:!1,hwaccel:!1,position:\"absolute\"};if(a.defaults={},r(a.prototype,{spin:function(e){this.stop();var i=this,o=i.opts,r=i.el=t(null,{className:o.className});if(n(r,{position:o.position,width:0,zIndex:o.zIndex,left:o.left,top:o.top}),e&&e.insertBefore(r,e.firstChild||null),r.setAttribute(\"role\",\"progressbar\"),i.lines(r,i.opts),!l){var s,a=0,c=(o.lines-1)*(1-o.direction)/2,d=o.fps,p=d/o.speed,u=(1-o.opacity)/(p*o.trail/100),f=p/o.lines;!function t(){a++;for(var e=0;e<o.lines;e++)s=Math.max(1-(a+(o.lines-e)*f)%p*u,o.opacity),i.opacity(r,e*o.direction+c,s,o);i.timeout=i.el&&setTimeout(t,~~(1e3/d))}()}return i},stop:function(){var t=this.el;return t&&(clearTimeout(this.timeout),t.parentNode&&t.parentNode.removeChild(t),this.el=void 0),this},lines:function(o,r){function a(e,i){return n(t(),{position:\"absolute\",width:r.scale*(r.length+r.width)+\"px\",height:r.scale*r.width+\"px\",background:e,boxShadow:i,transformOrigin:\"left\",transform:\"rotate(\"+~~(360/r.lines*d+r.rotate)+\"deg) translate(\"+r.scale*r.radius+\"px,0)\",borderRadius:(r.corners*r.scale*r.width>>1)+\"px\"})}for(var c,d=0,p=(r.lines-1)*(1-r.direction)/2;d<r.lines;d++)c=n(t(),{position:\"absolute\",top:1+~(r.scale*r.width/2)+\"px\",transform:r.hwaccel?\"translate3d(0,0,0)\":\"\",opacity:r.opacity,animation:l&&i(r.opacity,r.trail,p+d*r.direction,r.lines)+\" \"+1/r.speed+\"s linear infinite\"}),r.shadow&&e(c,n(a(\"#000\",\"0 0 4px #000\"),{top:\"2px\"})),e(o,e(c,a(s(r.color,d),\"0 0 1px rgba(0,0,0,.1)\")));return o},opacity:function(t,e,i){e<t.childNodes.length&&(t.childNodes[e].style.opacity=i)}}),\"undefined\"!=typeof document){c=function(){var i=t(\"style\",{type:\"text/css\"});return e(document.getElementsByTagName(\"head\")[0],i),i.sheet||i.styleSheet}();var f=n(t(\"group\"),{behavior:\"url(#default#VML)\"});!o(f,\"transform\")&&f.adj?function(){function i(e,i){return t(\"<\"+e+' xmlns=\"urn:schemas-microsoft.com:vml\" class=\"spin-vml\">',i)}c.addRule(\".spin-vml\",\"behavior:url(#default#VML)\"),a.prototype.lines=function(t,o){function r(){return n(i(\"group\",{coordsize:d+\" \"+d,coordorigin:-c+\" \"+-c}),{width:d,height:d})}function a(t,a,l){e(u,e(n(r(),{rotation:360/o.lines*t+\"deg\",left:~~a}),e(n(i(\"roundrect\",{arcsize:o.corners}),{width:c,height:o.scale*o.width,left:o.scale*o.radius,top:-o.scale*o.width>>1,filter:l}),i(\"fill\",{color:s(o.color,t),opacity:o.opacity}),i(\"stroke\",{opacity:0}))))}var l,c=o.scale*(o.length+o.width),d=2*o.scale*c,p=-(o.width+o.length)*o.scale*2+\"px\",u=n(r(),{position:\"absolute\",top:p,left:p});if(o.shadow)for(l=1;l<=o.lines;l++)a(l,-2,\"progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)\");for(l=1;l<=o.lines;l++)a(l);return e(t,u)},a.prototype.opacity=function(t,e,i,o){var n=t.firstChild;o=o.shadow&&o.lines||0,n&&e+o<n.childNodes.length&&(n=n.childNodes[e+o],n=n&&n.firstChild,(n=n&&n.firstChild)&&(n.opacity=i))}}():l=o(f,\"animation\")}return a});"

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(103))

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	module.exports = "!function(n){if(\"object\"==typeof exports)n(require(\"jquery\"),require(\"spin.js\"));else if(\"function\"==typeof define&&define.amd)define([\"jquery\",\"spin\"],n);else{if(!window.Spinner)throw new Error(\"Spin.js not present\");n(window.jQuery,window.Spinner)}}(function(n,e){n.fn.spin=function(i,s){return this.each(function(){var r=n(this),t=r.data();t.spinner&&(t.spinner.stop(),delete t.spinner),!1!==i&&(i=n.extend({color:s||r.css(\"color\")},n.fn.spin.presets[i]||i),t.spinner=new e(i).spin(this))})},n.fn.spin.presets={tiny:{lines:8,length:2,width:2,radius:3},small:{lines:8,length:4,width:3,radius:5},large:{lines:10,length:8,width:4,radius:8}}});"

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(105))

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	module.exports = "\"use strict\";(function(){var t,e,s,i,r,o={}.hasOwnProperty,n=function(t,e){function s(){this.constructor=t}for(var i in e)o.call(e,i)&&(t[i]=e[i]);return s.prototype=e.prototype,t.prototype=new s,t.__super__=e.prototype,t};i=function(){function t(){this.options_index=0,this.parsed=[]}return t.prototype.add_node=function(t){return\"OPTGROUP\"===t.nodeName.toUpperCase()?this.add_group(t):this.add_option(t)},t.prototype.add_group=function(t){var e,s,i,r,o,n;for(e=this.parsed.length,this.parsed.push({array_index:e,group:!0,label:this.escapeExpression(t.label),title:t.title?t.title:void 0,children:0,disabled:t.disabled,classes:t.className}),o=t.childNodes,n=[],i=0,r=o.length;i<r;i++)s=o[i],n.push(this.add_option(s,e,t.disabled));return n},t.prototype.add_option=function(t,e,s){if(\"OPTION\"===t.nodeName.toUpperCase())return\"\"!==t.text?(null!=e&&(this.parsed[e].children+=1),this.parsed.push({array_index:this.parsed.length,options_index:this.options_index,value:t.value,text:t.text,html:t.innerHTML,title:t.title?t.title:void 0,selected:t.selected,disabled:!0===s?s:t.disabled,group_array_index:e,group_label:null!=e?this.parsed[e].label:null,classes:t.className,style:t.style.cssText})):this.parsed.push({array_index:this.parsed.length,options_index:this.options_index,empty:!0}),this.options_index+=1},t.prototype.escapeExpression=function(t){var e,s;return null==t||!1===t?\"\":/[\\&\\<\\>\\\"\\'\\`]/.test(t)?(e={\"<\":\"&lt;\",\">\":\"&gt;\",'\"':\"&quot;\",\"'\":\"&#x27;\",\"`\":\"&#x60;\"},s=/&(?!\\w+;)|[\\<\\>\\\"\\'\\`]/g,t.replace(s,function(t){return e[t]||\"&amp;\"})):t},t}(),i.select_to_array=function(t){var e,s,r,o,n;for(s=new i,n=t.childNodes,r=0,o=n.length;r<o;r++)e=n[r],s.add_node(e);return s.parsed},e=function(){function t(e,s){this.form_field=e,this.options=null!=s?s:{},t.browser_is_supported()&&(this.is_multiple=this.form_field.multiple,this.set_default_text(),this.set_default_values(),this.setup(),this.set_up_html(),this.register_observers(),this.on_ready())}return t.prototype.set_default_values=function(){var t=this;return this.click_test_action=function(e){return t.test_active_click(e)},this.activate_action=function(e){return t.activate_field(e)},this.active_field=!1,this.mouse_on_container=!1,this.results_showing=!1,this.result_highlighted=null,this.allow_single_deselect=null!=this.options.allow_single_deselect&&null!=this.form_field.options[0]&&\"\"===this.form_field.options[0].text&&this.options.allow_single_deselect,this.disable_search_threshold=this.options.disable_search_threshold||0,this.disable_search=this.options.disable_search||!1,this.enable_split_word_search=null==this.options.enable_split_word_search||this.options.enable_split_word_search,this.group_search=null==this.options.group_search||this.options.group_search,this.search_contains=this.options.search_contains||!1,this.single_backstroke_delete=null==this.options.single_backstroke_delete||this.options.single_backstroke_delete,this.max_selected_options=this.options.max_selected_options||1/0,this.inherit_select_classes=this.options.inherit_select_classes||!1,this.display_selected_options=null==this.options.display_selected_options||this.options.display_selected_options,this.display_disabled_options=null==this.options.display_disabled_options||this.options.display_disabled_options,this.include_group_label_in_selected=this.options.include_group_label_in_selected||!1},t.prototype.set_default_text=function(){return this.form_field.getAttribute(\"data-placeholder\")?this.default_text=this.form_field.getAttribute(\"data-placeholder\"):this.is_multiple?this.default_text=this.options.placeholder_text_multiple||this.options.placeholder_text||t.default_multiple_text:this.default_text=this.options.placeholder_text_single||this.options.placeholder_text||t.default_single_text,this.results_none_found=this.form_field.getAttribute(\"data-no_results_text\")||this.options.no_results_text||t.default_no_result_text},t.prototype.choice_label=function(t){return this.include_group_label_in_selected&&null!=t.group_label?\"<b class='group-name'>\"+t.group_label+\"</b>\"+t.html:t.html},t.prototype.mouse_enter=function(){return this.mouse_on_container=!0},t.prototype.mouse_leave=function(){return this.mouse_on_container=!1},t.prototype.input_focus=function(t){var e=this;if(this.is_multiple){if(!this.active_field)return setTimeout(function(){return e.container_mousedown()},50)}else if(!this.active_field)return this.activate_field()},t.prototype.input_blur=function(t){var e=this;if(!this.mouse_on_container)return this.active_field=!1,setTimeout(function(){return e.blur_test()},100)},t.prototype.results_option_build=function(t){var e,s,i,r,o;for(e=\"\",o=this.results_data,i=0,r=o.length;i<r;i++)s=o[i],s.group?e+=this.result_add_group(s):e+=this.result_add_option(s),(null!=t?t.first:void 0)&&(s.selected&&this.is_multiple?this.choice_build(s):s.selected&&!this.is_multiple&&this.single_set_selected_text(this.choice_label(s)));return e},t.prototype.result_add_option=function(t){var e,s;return t.search_match&&this.include_option_in_results(t)?(e=[],t.disabled||t.selected&&this.is_multiple||e.push(\"active-result\"),!t.disabled||t.selected&&this.is_multiple||e.push(\"disabled-result\"),t.selected&&e.push(\"result-selected\"),null!=t.group_array_index&&e.push(\"group-option\"),\"\"!==t.classes&&e.push(t.classes),s=document.createElement(\"li\"),s.className=e.join(\" \"),s.style.cssText=t.style,s.setAttribute(\"data-option-array-index\",t.array_index),s.innerHTML=t.search_text,t.title&&(s.title=t.title),this.outerHTML(s)):\"\"},t.prototype.result_add_group=function(t){var e,s;return(t.search_match||t.group_match)&&t.active_options>0?(e=[],e.push(\"group-result\"),t.classes&&e.push(t.classes),s=document.createElement(\"li\"),s.className=e.join(\" \"),s.innerHTML=t.search_text,t.title&&(s.title=t.title),this.outerHTML(s)):\"\"},t.prototype.results_update_field=function(){if(this.set_default_text(),this.is_multiple||this.results_reset_cleanup(),this.result_clear_highlight(),this.results_build(),this.results_showing)return this.winnow_results()},t.prototype.reset_single_select_options=function(){var t,e,s,i,r;for(i=this.results_data,r=[],e=0,s=i.length;e<s;e++)t=i[e],t.selected?r.push(t.selected=!1):r.push(void 0);return r},t.prototype.results_toggle=function(){return this.results_showing?this.results_hide():this.results_show()},t.prototype.results_search=function(t){return this.results_showing?this.winnow_results():this.results_show()},t.prototype.winnow_results=function(){var t,e,s,i,r,o,n,l,h,c,a,_;for(this.no_results_clear(),i=0,o=this.get_search_text(),t=o.replace(/[-[\\]{}()*+?.,\\\\^$|#\\s]/g,\"\\\\$&\"),h=new RegExp(t,\"i\"),s=this.get_search_regex(t),_=this.results_data,c=0,a=_.length;c<a;c++)e=_[c],e.search_match=!1,r=null,this.include_option_in_results(e)&&(e.group&&(e.group_match=!1,e.active_options=0),null!=e.group_array_index&&this.results_data[e.group_array_index]&&(r=this.results_data[e.group_array_index],0===r.active_options&&r.search_match&&(i+=1),r.active_options+=1),e.search_text=e.group?e.label:e.html,e.group&&!this.group_search||(e.search_match=this.search_string_match(e.search_text,s),e.search_match&&!e.group&&(i+=1),e.search_match?(o.length&&(n=e.search_text.search(h),l=e.search_text.substr(0,n+o.length)+\"</em>\"+e.search_text.substr(n+o.length),e.search_text=l.substr(0,n)+\"<em>\"+l.substr(n)),null!=r&&(r.group_match=!0)):null!=e.group_array_index&&this.results_data[e.group_array_index].search_match&&(e.search_match=!0)));return this.result_clear_highlight(),i<1&&o.length?(this.update_results_content(\"\"),this.no_results(o)):(this.update_results_content(this.results_option_build()),this.winnow_results_set_highlight())},t.prototype.get_search_regex=function(t){var e;return e=this.search_contains?\"\":\"^\",new RegExp(e+t,\"i\")},t.prototype.search_string_match=function(t,e){var s,i,r,o;if(e.test(t))return!0;if(this.enable_split_word_search&&(t.indexOf(\" \")>=0||0===t.indexOf(\"[\"))&&(i=t.replace(/\\[|\\]/g,\"\").split(\" \"),i.length))for(r=0,o=i.length;r<o;r++)if(s=i[r],e.test(s))return!0},t.prototype.choices_count=function(){var t,e,s,i;if(null!=this.selected_option_count)return this.selected_option_count;for(this.selected_option_count=0,i=this.form_field.options,e=0,s=i.length;e<s;e++)t=i[e],t.selected&&(this.selected_option_count+=1);return this.selected_option_count},t.prototype.choices_click=function(t){if(t.preventDefault(),!this.results_showing&&!this.is_disabled)return this.results_show()},t.prototype.keyup_checker=function(t){var e,s;switch(e=null!=(s=t.which)?s:t.keyCode,this.search_field_scale(),e){case 8:if(this.is_multiple&&this.backstroke_length<1&&this.choices_count()>0)return this.keydown_backstroke();if(!this.pending_backstroke)return this.result_clear_highlight(),this.results_search();break;case 13:if(t.preventDefault(),this.results_showing)return this.result_select(t);break;case 27:return this.results_showing&&this.results_hide(),!0;case 9:case 38:case 40:case 16:case 91:case 17:break;default:return this.results_search()}},t.prototype.clipboard_event_checker=function(t){var e=this;return setTimeout(function(){return e.results_search()},50)},t.prototype.container_width=function(){return null!=this.options.width?this.options.width:this.form_field.offsetWidth+\"px\"},t.prototype.include_option_in_results=function(t){return!(this.is_multiple&&!this.display_selected_options&&t.selected)&&(!(!this.display_disabled_options&&t.disabled)&&!t.empty)},t.prototype.search_results_touchstart=function(t){return this.touch_started=!0,this.search_results_mouseover(t)},t.prototype.search_results_touchmove=function(t){return this.touch_started=!1,this.search_results_mouseout(t)},t.prototype.search_results_touchend=function(t){if(this.touch_started)return this.search_results_mouseup(t)},t.prototype.outerHTML=function(t){var e;return t.outerHTML?t.outerHTML:(e=document.createElement(\"div\"),e.appendChild(t),e.innerHTML)},t.browser_is_supported=function(){return\"Microsoft Internet Explorer\"===window.navigator.appName?document.documentMode>=8:!/iP(od|hone)/i.test(window.navigator.userAgent)&&(!/Android/i.test(window.navigator.userAgent)||!/Mobile/i.test(window.navigator.userAgent))},t.default_multiple_text=\"Select Some Options\",t.default_single_text=\"\",t.default_no_result_text=\"No results match\",t}(),t=jQuery,t.fn.extend({chosen:function(i){return e.browser_is_supported()?this.each(function(e){var r,o;r=t(this),o=r.data(\"chosen\"),\"destroy\"===i&&o instanceof s?o.destroy():o instanceof s||r.data(\"chosen\",new s(this,i))}):this}}),s=function(e){function s(){return r=s.__super__.constructor.apply(this,arguments)}return n(s,e),s.prototype.setup=function(){return this.form_field_jq=t(this.form_field),this.current_selectedIndex=this.form_field.selectedIndex,this.is_rtl=this.form_field_jq.hasClass(\"chosen-rtl\")},s.prototype.set_up_html=function(){var e,s;return e=[\"chosen-container\"],e.push(\"chosen-container-\"+(this.is_multiple?\"multi\":\"single\")),this.inherit_select_classes&&this.form_field.className&&e.push(this.form_field.className),this.is_rtl&&e.push(\"chosen-rtl\"),s={class:e.join(\" \"),style:\"width: \"+this.container_width()+\";\",title:this.form_field.title},this.form_field.id.length&&(s.id=this.form_field.id.replace(/[^\\w]/g,\"_\")+\"_chosen\"),this.container=t(\"<div />\",s),this.is_multiple?this.container.html('<ul class=\"chosen-choices\"><li class=\"search-field\"><input type=\"text\" value=\"'+this.default_text+'\" class=\"default\" autocomplete=\"off\" style=\"width:25px;\" /></li></ul><div class=\"chosen-drop\"><ul class=\"chosen-results\"></ul></div>'):this.container.html('<a class=\"chosen-single chosen-default\" tabindex=\"-1\"><span>'+this.default_text+'</span><div><b></b></div></a><div class=\"chosen-drop\"><div class=\"chosen-search\"><input type=\"text\" autocomplete=\"off\" /></div><ul class=\"chosen-results\"></ul></div>'),this.form_field_jq.hide().after(this.container),this.dropdown=this.container.find(\"div.chosen-drop\").first(),this.search_field=this.container.find(\"input\").first(),this.search_results=this.container.find(\"ul.chosen-results\").first(),this.search_field_scale(),this.search_no_results=this.container.find(\"li.no-results\").first(),this.is_multiple?(this.search_choices=this.container.find(\"ul.chosen-choices\").first(),this.search_container=this.container.find(\"li.search-field\").first()):(this.search_container=this.container.find(\"div.chosen-search\").first(),this.selected_item=this.container.find(\".chosen-single\").first()),this.results_build(),this.set_tab_index(),this.set_label_behavior()},s.prototype.on_ready=function(){return this.form_field_jq.trigger(\"chosen:ready\",{chosen:this})},s.prototype.register_observers=function(){var t=this;return this.container.bind(\"touchstart.chosen\",function(e){return t.container_mousedown(e),e.preventDefault()}),this.container.bind(\"touchend.chosen\",function(e){return t.container_mouseup(e),e.preventDefault()}),this.container.bind(\"mousedown.chosen\",function(e){t.container_mousedown(e)}),this.container.bind(\"mouseup.chosen\",function(e){t.container_mouseup(e)}),this.container.bind(\"mouseenter.chosen\",function(e){t.mouse_enter(e)}),this.container.bind(\"mouseleave.chosen\",function(e){t.mouse_leave(e)}),this.search_results.bind(\"mouseup.chosen\",function(e){t.search_results_mouseup(e)}),this.search_results.bind(\"mouseover.chosen\",function(e){t.search_results_mouseover(e)}),this.search_results.bind(\"mouseout.chosen\",function(e){t.search_results_mouseout(e)}),this.search_results.bind(\"mousewheel.chosen DOMMouseScroll.chosen\",function(e){t.search_results_mousewheel(e)}),this.search_results.bind(\"touchstart.chosen\",function(e){t.search_results_touchstart(e)}),this.search_results.bind(\"touchmove.chosen\",function(e){t.search_results_touchmove(e)}),this.search_results.bind(\"touchend.chosen\",function(e){t.search_results_touchend(e)}),this.form_field_jq.bind(\"chosen:updated.chosen\",function(e){t.results_update_field(e)}),this.form_field_jq.bind(\"chosen:activate.chosen\",function(e){t.activate_field(e)}),this.form_field_jq.bind(\"chosen:open.chosen\",function(e){t.container_mousedown(e)}),this.form_field_jq.bind(\"chosen:close.chosen\",function(e){t.input_blur(e)}),this.search_field.bind(\"blur.chosen\",function(e){t.input_blur(e)}),this.search_field.bind(\"keyup.chosen\",function(e){t.keyup_checker(e)}),this.search_field.bind(\"keydown.chosen\",function(e){t.keydown_checker(e)}),this.search_field.bind(\"focus.chosen\",function(e){t.input_focus(e)}),this.search_field.bind(\"cut.chosen\",function(e){t.clipboard_event_checker(e)}),this.search_field.bind(\"paste.chosen\",function(e){t.clipboard_event_checker(e)}),this.is_multiple?this.search_choices.bind(\"click.chosen\",function(e){t.choices_click(e)}):this.container.bind(\"click.chosen\",function(t){t.preventDefault()})},s.prototype.destroy=function(){return t(this.container[0].ownerDocument).unbind(\"click.chosen\",this.click_test_action),this.search_field[0].tabIndex&&(this.form_field_jq[0].tabIndex=this.search_field[0].tabIndex),this.container.remove(),this.form_field_jq.removeData(\"chosen\"),this.form_field_jq.show()},s.prototype.search_field_disabled=function(){return this.is_disabled=this.form_field_jq[0].disabled,this.is_disabled?(this.container.addClass(\"chosen-disabled\"),this.search_field[0].disabled=!0,this.is_multiple||this.selected_item.unbind(\"focus.chosen\",this.activate_action),this.close_field()):(this.container.removeClass(\"chosen-disabled\"),this.search_field[0].disabled=!1,this.is_multiple?void 0:this.selected_item.bind(\"focus.chosen\",this.activate_action))},s.prototype.container_mousedown=function(e){if(!this.is_disabled&&(e&&\"mousedown\"===e.type&&!this.results_showing&&e.preventDefault(),null==e||!t(e.target).hasClass(\"search-choice-close\")))return this.active_field?this.is_multiple||!e||t(e.target)[0]!==this.selected_item[0]&&!t(e.target).parents(\"a.chosen-single\").length||(e.preventDefault(),this.results_toggle()):(this.is_multiple&&this.search_field.val(\"\"),t(this.container[0].ownerDocument).bind(\"click.chosen\",this.click_test_action),this.results_show()),this.activate_field()},s.prototype.container_mouseup=function(t){if(\"ABBR\"===t.target.nodeName&&!this.is_disabled)return this.results_reset(t)},s.prototype.search_results_mousewheel=function(t){var e;if(t.originalEvent&&(e=t.originalEvent.deltaY||-t.originalEvent.wheelDelta||t.originalEvent.detail),null!=e)return t.preventDefault(),\"DOMMouseScroll\"===t.type&&(e*=40),this.search_results.scrollTop(e+this.search_results.scrollTop())},s.prototype.blur_test=function(t){if(!this.active_field&&this.container.hasClass(\"chosen-container-active\"))return this.close_field()},s.prototype.close_field=function(){return t(this.container[0].ownerDocument).unbind(\"click.chosen\",this.click_test_action),this.active_field=!1,this.results_hide(),this.container.removeClass(\"chosen-container-active\"),this.clear_backstroke(),this.show_search_field_default(),this.search_field_scale()},s.prototype.activate_field=function(){return this.container.addClass(\"chosen-container-active\"),this.active_field=!0,this.search_field.val(this.search_field.val()),this.search_field.focus()},s.prototype.test_active_click=function(e){var s;return s=t(e.target).closest(\".chosen-container\"),s.length&&this.container[0]===s[0]?this.active_field=!0:this.close_field()},s.prototype.results_build=function(){return this.parsing=!0,this.selected_option_count=null,this.results_data=i.select_to_array(this.form_field),this.is_multiple?this.search_choices.find(\"li.search-choice\").remove():this.is_multiple||this.single_set_selected_text(),this.update_results_content(this.results_option_build({first:!0})),this.search_field_disabled(),this.show_search_field_default(),this.search_field_scale(),this.parsing=!1},s.prototype.result_do_highlight=function(t){var e,s,i,r,o;if(t.length){if(this.result_clear_highlight(),this.result_highlight=t,this.result_highlight.addClass(\"highlighted\"),i=parseInt(this.search_results.css(\"maxHeight\"),10),o=this.search_results.scrollTop(),r=i+o,s=this.result_highlight.position().top+this.search_results.scrollTop(),(e=s+this.result_highlight.outerHeight())>=r)return this.search_results.scrollTop(e-i>0?e-i:0);if(s<o)return this.search_results.scrollTop(s)}},s.prototype.result_clear_highlight=function(){return this.result_highlight&&this.result_highlight.removeClass(\"highlighted\"),this.result_highlight=null},s.prototype.results_show=function(){return this.is_multiple&&this.max_selected_options<=this.choices_count()?(this.form_field_jq.trigger(\"chosen:maxselected\",{chosen:this}),!1):(this.container.addClass(\"chosen-with-drop\"),this.results_showing=!0,this.search_field.focus(),this.search_field.val(this.search_field.val()),this.winnow_results(),this.form_field_jq.trigger(\"chosen:showing_dropdown\",{chosen:this}))},s.prototype.update_results_content=function(t){return this.search_results.html(t)},s.prototype.results_hide=function(){return this.results_showing&&(this.result_clear_highlight(),this.container.removeClass(\"chosen-with-drop\"),this.form_field_jq.trigger(\"chosen:hiding_dropdown\",{chosen:this})),this.results_showing=!1},s.prototype.set_tab_index=function(t){var e;if(this.form_field.tabIndex)return e=this.form_field.tabIndex,this.form_field.tabIndex=-1,this.search_field[0].tabIndex=e},s.prototype.set_label_behavior=function(){var e=this;if(this.form_field_label=this.form_field_jq.parents(\"label\"),!this.form_field_label.length&&this.form_field.id.length&&(this.form_field_label=t(\"label[for='\"+this.form_field.id+\"']\")),this.form_field_label.length>0)return this.form_field_label.bind(\"click.chosen\",function(t){return e.is_multiple?e.container_mousedown(t):e.activate_field()})},s.prototype.show_search_field_default=function(){return this.is_multiple&&this.choices_count()<1&&!this.active_field?(this.search_field.val(this.default_text),this.search_field.addClass(\"default\")):(this.search_field.val(\"\"),this.search_field.removeClass(\"default\"))},s.prototype.search_results_mouseup=function(e){var s;if(s=t(e.target).hasClass(\"active-result\")?t(e.target):t(e.target).parents(\".active-result\").first(),s.length)return this.result_highlight=s,this.result_select(e),this.search_field.focus()},s.prototype.search_results_mouseover=function(e){var s;if(s=t(e.target).hasClass(\"active-result\")?t(e.target):t(e.target).parents(\".active-result\").first())return this.result_do_highlight(s)},s.prototype.search_results_mouseout=function(e){if(t(e.target).hasClass(\"active-result\"))return this.result_clear_highlight()},s.prototype.choice_build=function(e){var s,i,r=this;return s=t(\"<li />\",{class:\"search-choice\"}).html(\"<span>\"+this.choice_label(e)+\"</span>\"),e.disabled?s.addClass(\"search-choice-disabled\"):(i=t(\"<a />\",{class:\"search-choice-close\",\"data-option-array-index\":e.array_index}),i.bind(\"click.chosen\",function(t){return r.choice_destroy_link_click(t)}),s.append(i)),this.search_container.before(s)},s.prototype.choice_destroy_link_click=function(e){if(e.preventDefault(),e.stopPropagation(),!this.is_disabled)return this.choice_destroy(t(e.target))},s.prototype.choice_destroy=function(t){if(this.result_deselect(t[0].getAttribute(\"data-option-array-index\")))return this.show_search_field_default(),this.is_multiple&&this.choices_count()>0&&this.search_field.val().length<1&&this.results_hide(),t.parents(\"li\").first().remove(),this.search_field_scale()},s.prototype.results_reset=function(){if(this.reset_single_select_options(),this.form_field.options[0].selected=!0,this.single_set_selected_text(),this.show_search_field_default(),this.results_reset_cleanup(),this.form_field_jq.trigger(\"change\"),this.active_field)return this.results_hide()},s.prototype.results_reset_cleanup=function(){return this.current_selectedIndex=this.form_field.selectedIndex,this.selected_item.find(\"abbr\").remove()},s.prototype.result_select=function(t){var e,s;if(this.result_highlight)return e=this.result_highlight,this.result_clear_highlight(),this.is_multiple&&this.max_selected_options<=this.choices_count()?(this.form_field_jq.trigger(\"chosen:maxselected\",{chosen:this}),!1):(this.is_multiple?e.removeClass(\"active-result\"):this.reset_single_select_options(),e.addClass(\"result-selected\"),s=this.results_data[e[0].getAttribute(\"data-option-array-index\")],s.selected=!0,this.form_field.options[s.options_index].selected=!0,this.selected_option_count=null,this.is_multiple?this.choice_build(s):this.single_set_selected_text(this.choice_label(s)),(t.metaKey||t.ctrlKey)&&this.is_multiple||this.results_hide(),this.search_field.val(\"\"),(this.is_multiple||this.form_field.selectedIndex!==this.current_selectedIndex)&&this.form_field_jq.trigger(\"change\",{selected:this.form_field.options[s.options_index].value}),this.current_selectedIndex=this.form_field.selectedIndex,t.preventDefault(),this.search_field_scale())},s.prototype.single_set_selected_text=function(t){return null==t&&(t=this.default_text),t===this.default_text?this.selected_item.addClass(\"chosen-default\"):(this.single_deselect_control_build(),this.selected_item.removeClass(\"chosen-default\")),this.selected_item.find(\"span\").html(t)},s.prototype.result_deselect=function(t){var e;return e=this.results_data[t],!this.form_field.options[e.options_index].disabled&&(e.selected=!1,this.form_field.options[e.options_index].selected=!1,this.selected_option_count=null,this.result_clear_highlight(),this.results_showing&&this.winnow_results(),this.form_field_jq.trigger(\"change\",{deselected:this.form_field.options[e.options_index].value}),this.search_field_scale(),!0)},s.prototype.single_deselect_control_build=function(){if(this.allow_single_deselect)return this.selected_item.find(\"abbr\").length||this.selected_item.find(\"span\").first().after('<abbr class=\"search-choice-close\"></abbr>'),this.selected_item.addClass(\"chosen-single-with-deselect\")},s.prototype.get_search_text=function(){return t(\"<div/>\").text(t.trim(this.search_field.val())).html()},s.prototype.winnow_results_set_highlight=function(){var t,e;if(e=this.is_multiple?[]:this.search_results.find(\".result-selected.active-result\"),null!=(t=e.length?e.first():this.search_results.find(\".active-result\").first()))return this.result_do_highlight(t)},s.prototype.no_results=function(e){var s;return s=t('<li class=\"no-results\">'+this.results_none_found+' \"<span></span>\"</li>'),s.find(\"span\").first().html(e),this.search_results.append(s),this.form_field_jq.trigger(\"chosen:no_results\",{chosen:this})},s.prototype.no_results_clear=function(){return this.search_results.find(\".no-results\").remove()},s.prototype.keydown_arrow=function(){var t;return this.results_showing&&this.result_highlight?(t=this.result_highlight.nextAll(\"li.active-result\").first())?this.result_do_highlight(t):void 0:this.results_show()},s.prototype.keyup_arrow=function(){var t;return this.results_showing||this.is_multiple?this.result_highlight?(t=this.result_highlight.prevAll(\"li.active-result\"),t.length?this.result_do_highlight(t.first()):(this.choices_count()>0&&this.results_hide(),this.result_clear_highlight())):void 0:this.results_show()},s.prototype.keydown_backstroke=function(){var t;return this.pending_backstroke?(this.choice_destroy(this.pending_backstroke.find(\"a\").first()),this.clear_backstroke()):(t=this.search_container.siblings(\"li.search-choice\").last(),t.length&&!t.hasClass(\"search-choice-disabled\")?(this.pending_backstroke=t,this.single_backstroke_delete?this.keydown_backstroke():this.pending_backstroke.addClass(\"search-choice-focus\")):void 0)},s.prototype.clear_backstroke=function(){return this.pending_backstroke&&this.pending_backstroke.removeClass(\"search-choice-focus\"),this.pending_backstroke=null},s.prototype.keydown_checker=function(t){var e,s;switch(e=null!=(s=t.which)?s:t.keyCode,this.search_field_scale(),8!==e&&this.pending_backstroke&&this.clear_backstroke(),e){case 8:this.backstroke_length=this.search_field.val().length;break;case 9:this.results_showing&&!this.is_multiple&&this.result_select(t),this.mouse_on_container=!1;break;case 13:this.results_showing&&t.preventDefault();break;case 32:this.disable_search&&t.preventDefault();break;case 38:t.preventDefault(),this.keyup_arrow();break;case 40:t.preventDefault(),this.keydown_arrow()}},s.prototype.search_field_scale=function(){var e,s,i,r,o,n,l,h;if(this.is_multiple){for(0,n=0,r=\"position:absolute; left: -1000px; top: -1000px; display:none;\",o=[\"font-size\",\"font-style\",\"font-weight\",\"font-family\",\"line-height\",\"text-transform\",\"letter-spacing\"],l=0,h=o.length;l<h;l++)i=o[l],r+=i+\":\"+this.search_field.css(i)+\";\";return e=t(\"<div />\",{style:r}),e.text(this.search_field.val()),t(\"body\").append(e),n=e.width()+25,e.remove(),s=this.container.outerWidth(),n>s-10&&(n=s-10),this.search_field.css({width:n+\"px\"})}},s}(e)}).call(void 0);"

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(111))

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	module.exports = "\"use strict\";!function(t){t.fn.tableHeadFixer=function(n){function o(){var n=t(u.table);if(u.head){if(u.left>0){var o=n.find(\"thead tr\");o.each(function(n,o){l(o,function(n){t(n).css(\"z-index\",u[\"z-index\"]+1)})})}if(u.right>0){var o=n.find(\"thead tr\");o.each(function(n,o){s(o,function(n){t(n).css(\"z-index\",u[\"z-index\"]+1)})})}}if(u.foot){if(u.left>0){var o=n.find(\"tfoot tr\");o.each(function(n,o){l(o,function(n){t(n).css(\"z-index\",u[\"z-index\"])})})}if(u.right>0){var o=n.find(\"tfoot tr\");o.each(function(n,o){s(o,function(n){t(n).css(\"z-index\",u[\"z-index\"])})})}}}function i(){var n=t(u.parent),o=t(u.table);n.append(o),n.css({\"overflow-x\":\"auto\",\"overflow-y\":\"auto\"}),n.scroll(function(){var t=n[0].scrollWidth,o=n[0].clientWidth,i=n[0].scrollHeight,r=n[0].clientHeight,e=n.scrollTop(),a=n.scrollLeft();u.head&&this.find(\"thead tr > *\").css(\"top\",e),u.foot&&this.find(\"tfoot tr > *\").css(\"bottom\",i-r-e),u.left>0&&u.leftColumns.css(\"left\",a),u.right>0&&u.rightColumns.css(\"right\",t-o-a)}.bind(o))}function r(){var n=t(u.table).find(\"thead\"),o=(n.find(\"tr\"),n.find(\"tr > *\"));f(o),o.css({position:\"relative\"})}function e(){var n=t(u.table).find(\"tfoot\"),o=(n.find(\"tr\"),n.find(\"tr > *\"));f(o),o.css({position:\"relative\"})}function a(){var n=t(u.table);u.leftColumns=t(),n.find(\"tr\").each(function(t,n){l(n,function(t){u.leftColumns=u.leftColumns.add(t)})}),u.leftColumns.each(function(n,o){var o=t(o);f(o),o.css({position:\"relative\"})})}function c(){var n=t(u.table);u.right;u.rightColumns=t(),n.find(\"tr\").each(function(t,n){s(n,function(t){u.rightColumns=u.rightColumns.add(t)})}),u.rightColumns.each(function(n,o){var o=t(o);f(o),o.css({position:\"relative\"})})}function f(n){n.each(function(n,o){var o=t(o),i=t(o).parent(),r=o.css(\"background-color\");r=\"transparent\"==r||\"rgba(0, 0, 0, 0)\"==r?null:r;var e=i.css(\"background-color\");e=\"transparent\"==e||\"rgba(0, 0, 0, 0)\"==e?null:e;var a=e||\"white\";a=r||a,o.css(\"background-color\",a)})}function l(n,o){for(var i=u.left,r=1,e=1;e<=i;e+=r){var a=r>1?e-1:e,c=t(n).find(\"> *:nth-child(\"+a+\")\"),f=c.prop(\"colspan\");c.cellPos().left<i&&o(c),r=f}}function s(n,o){for(var i=u.right,r=1,e=1;e<=i;e+=r){var a=r>1?e-1:e,c=t(n).find(\"> *:nth-last-child(\"+a+\")\"),f=c.prop(\"colspan\");o(c),r=f}}var d={head:!0,foot:!1,left:0,right:0,\"z-index\":0},u=t.extend({},d,n);return this.each(function(){u.table=this,u.parent=t(u.table).parent(),i(),1==u.head&&r(),1==u.foot&&e(),u.left>0&&a(),u.right>0&&c(),o(),t(u.parent).trigger(\"scroll\"),t(window).resize(function(){t(u.parent).trigger(\"scroll\")})})}}(jQuery),function(t){function n(n){var o=[];n.children(\"tr\").each(function(n,i){t(i).children(\"td, th\").each(function(i,r){var e,a,c=t(r),f=0|c.attr(\"colspan\"),l=0|c.attr(\"rowspan\");for(f=f||1,l=l||1;o[n]&&o[n][i];++i);for(e=i;e<i+f;++e)for(a=n;a<n+l;++a)o[a]||(o[a]=[]),o[a][e]=!0;var s={top:n,left:i};c.data(\"cellPos\",s)})})}t.fn.cellPos=function(t){var o=this.first(),i=o.data(\"cellPos\");if(!i||t){n(o.closest(\"table, thead, tbody, tfoot\"))}return i=o.data(\"cellPos\")}}(jQuery);"

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(113))

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	module.exports = "!function(e,a){\"object\"==typeof exports&&\"undefined\"!=typeof module?module.exports=a():\"function\"==typeof define&&define.amd?define(a):e.moment=a()}(this,function(){\"use strict\";function e(){return Yn.apply(null,arguments)}function a(e){return e instanceof Array||\"[object Array]\"===Object.prototype.toString.call(e)}function t(e){return null!=e&&\"[object Object]\"===Object.prototype.toString.call(e)}function s(e){var a;for(a in e)return!1;return!0}function n(e){return void 0===e}function r(e){return\"number\"==typeof e||\"[object Number]\"===Object.prototype.toString.call(e)}function d(e){return e instanceof Date||\"[object Date]\"===Object.prototype.toString.call(e)}function _(e,a){var t,s=[];for(t=0;t<e.length;++t)s.push(a(e[t],t));return s}function i(e,a){return Object.prototype.hasOwnProperty.call(e,a)}function o(e,a){for(var t in a)i(a,t)&&(e[t]=a[t]);return i(a,\"toString\")&&(e.toString=a.toString),i(a,\"valueOf\")&&(e.valueOf=a.valueOf),e}function m(e,a,t,s){return Ya(e,a,t,s,!0).utc()}function u(){return{empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1,parsedDateParts:[],meridiem:null,rfc2822:!1,weekdayMismatch:!1}}function l(e){return null==e._pf&&(e._pf=u()),e._pf}function M(e){if(null==e._isValid){var a=l(e),t=fn.call(a.parsedDateParts,function(e){return null!=e}),s=!isNaN(e._d.getTime())&&a.overflow<0&&!a.empty&&!a.invalidMonth&&!a.invalidWeekday&&!a.nullInput&&!a.invalidFormat&&!a.userInvalidated&&(!a.meridiem||a.meridiem&&t);if(e._strict&&(s=s&&0===a.charsLeftOver&&0===a.unusedTokens.length&&void 0===a.bigHour),null!=Object.isFrozen&&Object.isFrozen(e))return s;e._isValid=s}return e._isValid}function h(e){var a=m(NaN);return null!=e?o(l(a),e):l(a).userInvalidated=!0,a}function L(e,a){var t,s,r;if(n(a._isAMomentObject)||(e._isAMomentObject=a._isAMomentObject),n(a._i)||(e._i=a._i),n(a._f)||(e._f=a._f),n(a._l)||(e._l=a._l),n(a._strict)||(e._strict=a._strict),n(a._tzm)||(e._tzm=a._tzm),n(a._isUTC)||(e._isUTC=a._isUTC),n(a._offset)||(e._offset=a._offset),n(a._pf)||(e._pf=l(a)),n(a._locale)||(e._locale=a._locale),pn.length>0)for(t=0;t<pn.length;t++)s=pn[t],r=a[s],n(r)||(e[s]=r);return e}function c(a){L(this,a),this._d=new Date(null!=a._d?a._d.getTime():NaN),this.isValid()||(this._d=new Date(NaN)),!1===Dn&&(Dn=!0,e.updateOffset(this),Dn=!1)}function Y(e){return e instanceof c||null!=e&&null!=e._isAMomentObject}function y(e){return e<0?Math.ceil(e)||0:Math.floor(e)}function f(e){var a=+e,t=0;return 0!==a&&isFinite(a)&&(t=y(a)),t}function p(e,a,t){var s,n=Math.min(e.length,a.length),r=Math.abs(e.length-a.length),d=0;for(s=0;s<n;s++)(t&&e[s]!==a[s]||!t&&f(e[s])!==f(a[s]))&&d++;return d+r}function D(a){!1===e.suppressDeprecationWarnings&&\"undefined\"!=typeof console&&console.warn&&console.warn(\"Deprecation warning: \"+a)}function k(a,t){var s=!0;return o(function(){if(null!=e.deprecationHandler&&e.deprecationHandler(null,a),s){for(var n,r=[],d=0;d<arguments.length;d++){if(n=\"\",\"object\"==typeof arguments[d]){n+=\"\\n[\"+d+\"] \";for(var _ in arguments[0])n+=_+\": \"+arguments[0][_]+\", \";n=n.slice(0,-2)}else n=arguments[d];r.push(n)}D(a+\"\\nArguments: \"+Array.prototype.slice.call(r).join(\"\")+\"\\n\"+(new Error).stack),s=!1}return t.apply(this,arguments)},t)}function T(a,t){null!=e.deprecationHandler&&e.deprecationHandler(a,t),kn[a]||(D(t),kn[a]=!0)}function g(e){return e instanceof Function||\"[object Function]\"===Object.prototype.toString.call(e)}function w(e){var a,t;for(t in e)a=e[t],g(a)?this[t]=a:this[\"_\"+t]=a;this._config=e,this._dayOfMonthOrdinalParseLenient=new RegExp((this._dayOfMonthOrdinalParse.source||this._ordinalParse.source)+\"|\"+/\\d{1,2}/.source)}function v(e,a){var s,n=o({},e);for(s in a)i(a,s)&&(t(e[s])&&t(a[s])?(n[s]={},o(n[s],e[s]),o(n[s],a[s])):null!=a[s]?n[s]=a[s]:delete n[s]);for(s in e)i(e,s)&&!i(a,s)&&t(e[s])&&(n[s]=o({},n[s]));return n}function H(e){null!=e&&this.set(e)}function S(e,a,t){var s=this._calendar[e]||this._calendar.sameElse;return g(s)?s.call(a,t):s}function b(e){var a=this._longDateFormat[e],t=this._longDateFormat[e.toUpperCase()];return a||!t?a:(this._longDateFormat[e]=t.replace(/MMMM|MM|DD|dddd/g,function(e){return e.slice(1)}),this._longDateFormat[e])}function j(){return this._invalidDate}function x(e){return this._ordinal.replace(\"%d\",e)}function P(e,a,t,s){var n=this._relativeTime[t];return g(n)?n(e,a,t,s):n.replace(/%d/i,e)}function O(e,a){var t=this._relativeTime[e>0?\"future\":\"past\"];return g(t)?t(a):t.replace(/%s/i,a)}function W(e,a){var t=e.toLowerCase();jn[t]=jn[t+\"s\"]=jn[a]=e}function E(e){return\"string\"==typeof e?jn[e]||jn[e.toLowerCase()]:void 0}function A(e){var a,t,s={};for(t in e)i(e,t)&&(a=E(t))&&(s[a]=e[t]);return s}function F(e,a){xn[e]=a}function z(e){var a=[];for(var t in e)a.push({unit:t,priority:xn[t]});return a.sort(function(e,a){return e.priority-a.priority}),a}function J(a,t){return function(s){return null!=s?(N(this,a,s),e.updateOffset(this,t),this):R(this,a)}}function R(e,a){return e.isValid()?e._d[\"get\"+(e._isUTC?\"UTC\":\"\")+a]():NaN}function N(e,a,t){e.isValid()&&e._d[\"set\"+(e._isUTC?\"UTC\":\"\")+a](t)}function C(e){return e=E(e),g(this[e])?this[e]():this}function I(e,a){if(\"object\"==typeof e){e=A(e);for(var t=z(e),s=0;s<t.length;s++)this[t[s].unit](e[t[s].unit])}else if(e=E(e),g(this[e]))return this[e](a);return this}function G(e,a,t){var s=\"\"+Math.abs(e),n=a-s.length;return(e>=0?t?\"+\":\"\":\"-\")+Math.pow(10,Math.max(0,n)).toString().substr(1)+s}function U(e,a,t,s){var n=s;\"string\"==typeof s&&(n=function(){return this[s]()}),e&&(En[e]=n),a&&(En[a[0]]=function(){return G(n.apply(this,arguments),a[1],a[2])}),t&&(En[t]=function(){return this.localeData().ordinal(n.apply(this,arguments),e)})}function V(e){return e.match(/\\[[\\s\\S]/)?e.replace(/^\\[|\\]$/g,\"\"):e.replace(/\\\\/g,\"\")}function $(e){var a,t,s=e.match(Pn);for(a=0,t=s.length;a<t;a++)En[s[a]]?s[a]=En[s[a]]:s[a]=V(s[a]);return function(a){var n,r=\"\";for(n=0;n<t;n++)r+=g(s[n])?s[n].call(a,e):s[n];return r}}function K(e,a){return e.isValid()?(a=Z(a,e.localeData()),Wn[a]=Wn[a]||$(a),Wn[a](e)):e.localeData().invalidDate()}function Z(e,a){function t(e){return a.longDateFormat(e)||e}var s=5;for(On.lastIndex=0;s>=0&&On.test(e);)e=e.replace(On,t),On.lastIndex=0,s-=1;return e}function q(e,a,t){Xn[e]=g(a)?a:function(e,s){return e&&t?t:a}}function B(e,a){return i(Xn,e)?Xn[e](a._strict,a._locale):new RegExp(Q(e))}function Q(e){return X(e.replace(\"\\\\\",\"\").replace(/\\\\(\\[)|\\\\(\\])|\\[([^\\]\\[]*)\\]|\\\\(.)/g,function(e,a,t,s,n){return a||t||s||n}))}function X(e){return e.replace(/[-\\/\\\\^$*+?.()|[\\]{}]/g,\"\\\\$&\")}function ee(e,a){var t,s=a;for(\"string\"==typeof e&&(e=[e]),r(a)&&(s=function(e,t){t[a]=f(e)}),t=0;t<e.length;t++)er[e[t]]=s}function ae(e,a){ee(e,function(e,t,s,n){s._w=s._w||{},a(e,s._w,s,n)})}function te(e,a,t){null!=a&&i(er,e)&&er[e](a,t._a,t,e)}function se(e,a){return new Date(Date.UTC(e,a+1,0)).getUTCDate()}function ne(e,t){return e?a(this._months)?this._months[e.month()]:this._months[(this._months.isFormat||ur).test(t)?\"format\":\"standalone\"][e.month()]:a(this._months)?this._months:this._months.standalone}function re(e,t){return e?a(this._monthsShort)?this._monthsShort[e.month()]:this._monthsShort[ur.test(t)?\"format\":\"standalone\"][e.month()]:a(this._monthsShort)?this._monthsShort:this._monthsShort.standalone}function de(e,a,t){var s,n,r,d=e.toLocaleLowerCase();if(!this._monthsParse)for(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[],s=0;s<12;++s)r=m([2e3,s]),this._shortMonthsParse[s]=this.monthsShort(r,\"\").toLocaleLowerCase(),this._longMonthsParse[s]=this.months(r,\"\").toLocaleLowerCase();return t?\"MMM\"===a?(n=mr.call(this._shortMonthsParse,d),-1!==n?n:null):(n=mr.call(this._longMonthsParse,d),-1!==n?n:null):\"MMM\"===a?(n=mr.call(this._shortMonthsParse,d),-1!==n?n:(n=mr.call(this._longMonthsParse,d),-1!==n?n:null)):(n=mr.call(this._longMonthsParse,d),-1!==n?n:(n=mr.call(this._shortMonthsParse,d),-1!==n?n:null))}function _e(e,a,t){var s,n,r;if(this._monthsParseExact)return de.call(this,e,a,t);for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),s=0;s<12;s++){if(n=m([2e3,s]),t&&!this._longMonthsParse[s]&&(this._longMonthsParse[s]=new RegExp(\"^\"+this.months(n,\"\").replace(\".\",\"\")+\"$\",\"i\"),this._shortMonthsParse[s]=new RegExp(\"^\"+this.monthsShort(n,\"\").replace(\".\",\"\")+\"$\",\"i\")),t||this._monthsParse[s]||(r=\"^\"+this.months(n,\"\")+\"|^\"+this.monthsShort(n,\"\"),this._monthsParse[s]=new RegExp(r.replace(\".\",\"\"),\"i\")),t&&\"MMMM\"===a&&this._longMonthsParse[s].test(e))return s;if(t&&\"MMM\"===a&&this._shortMonthsParse[s].test(e))return s;if(!t&&this._monthsParse[s].test(e))return s}}function ie(e,a){var t;if(!e.isValid())return e;if(\"string\"==typeof a)if(/^\\d+$/.test(a))a=f(a);else if(a=e.localeData().monthsParse(a),!r(a))return e;return t=Math.min(e.date(),se(e.year(),a)),e._d[\"set\"+(e._isUTC?\"UTC\":\"\")+\"Month\"](a,t),e}function oe(a){return null!=a?(ie(this,a),e.updateOffset(this,!0),this):R(this,\"Month\")}function me(){return se(this.year(),this.month())}function ue(e){return this._monthsParseExact?(i(this,\"_monthsRegex\")||Me.call(this),e?this._monthsShortStrictRegex:this._monthsShortRegex):(i(this,\"_monthsShortRegex\")||(this._monthsShortRegex=hr),this._monthsShortStrictRegex&&e?this._monthsShortStrictRegex:this._monthsShortRegex)}function le(e){return this._monthsParseExact?(i(this,\"_monthsRegex\")||Me.call(this),e?this._monthsStrictRegex:this._monthsRegex):(i(this,\"_monthsRegex\")||(this._monthsRegex=Lr),this._monthsStrictRegex&&e?this._monthsStrictRegex:this._monthsRegex)}function Me(){function e(e,a){return a.length-e.length}var a,t,s=[],n=[],r=[];for(a=0;a<12;a++)t=m([2e3,a]),s.push(this.monthsShort(t,\"\")),n.push(this.months(t,\"\")),r.push(this.months(t,\"\")),r.push(this.monthsShort(t,\"\"));for(s.sort(e),n.sort(e),r.sort(e),a=0;a<12;a++)s[a]=X(s[a]),n[a]=X(n[a]);for(a=0;a<24;a++)r[a]=X(r[a]);this._monthsRegex=new RegExp(\"^(\"+r.join(\"|\")+\")\",\"i\"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp(\"^(\"+n.join(\"|\")+\")\",\"i\"),this._monthsShortStrictRegex=new RegExp(\"^(\"+s.join(\"|\")+\")\",\"i\")}function he(e){return Le(e)?366:365}function Le(e){return e%4==0&&e%100!=0||e%400==0}function ce(){return Le(this.year())}function Ye(e,a,t,s,n,r,d){var _=new Date(e,a,t,s,n,r,d);return e<100&&e>=0&&isFinite(_.getFullYear())&&_.setFullYear(e),_}function ye(e){var a=new Date(Date.UTC.apply(null,arguments));return e<100&&e>=0&&isFinite(a.getUTCFullYear())&&a.setUTCFullYear(e),a}function fe(e,a,t){var s=7+a-t;return-(7+ye(e,0,s).getUTCDay()-a)%7+s-1}function pe(e,a,t,s,n){var r,d,_=(7+t-s)%7,i=fe(e,s,n),o=1+7*(a-1)+_+i;return o<=0?(r=e-1,d=he(r)+o):o>he(e)?(r=e+1,d=o-he(e)):(r=e,d=o),{year:r,dayOfYear:d}}function De(e,a,t){var s,n,r=fe(e.year(),a,t),d=Math.floor((e.dayOfYear()-r-1)/7)+1;return d<1?(n=e.year()-1,s=d+ke(n,a,t)):d>ke(e.year(),a,t)?(s=d-ke(e.year(),a,t),n=e.year()+1):(n=e.year(),s=d),{week:s,year:n}}function ke(e,a,t){var s=fe(e,a,t),n=fe(e+1,a,t);return(he(e)-s+n)/7}function Te(e){return De(e,this._week.dow,this._week.doy).week}function ge(){return this._week.dow}function we(){return this._week.doy}function ve(e){var a=this.localeData().week(this);return null==e?a:this.add(7*(e-a),\"d\")}function He(e){var a=De(this,1,4).week;return null==e?a:this.add(7*(e-a),\"d\")}function Se(e,a){return\"string\"!=typeof e?e:isNaN(e)?(e=a.weekdaysParse(e),\"number\"==typeof e?e:null):parseInt(e,10)}function be(e,a){return\"string\"==typeof e?a.weekdaysParse(e)%7||7:isNaN(e)?null:e}function je(e,t){return e?a(this._weekdays)?this._weekdays[e.day()]:this._weekdays[this._weekdays.isFormat.test(t)?\"format\":\"standalone\"][e.day()]:a(this._weekdays)?this._weekdays:this._weekdays.standalone}function xe(e){return e?this._weekdaysShort[e.day()]:this._weekdaysShort}function Pe(e){return e?this._weekdaysMin[e.day()]:this._weekdaysMin}function Oe(e,a,t){var s,n,r,d=e.toLocaleLowerCase();if(!this._weekdaysParse)for(this._weekdaysParse=[],this._shortWeekdaysParse=[],this._minWeekdaysParse=[],s=0;s<7;++s)r=m([2e3,1]).day(s),this._minWeekdaysParse[s]=this.weekdaysMin(r,\"\").toLocaleLowerCase(),this._shortWeekdaysParse[s]=this.weekdaysShort(r,\"\").toLocaleLowerCase(),this._weekdaysParse[s]=this.weekdays(r,\"\").toLocaleLowerCase();return t?\"dddd\"===a?(n=mr.call(this._weekdaysParse,d),-1!==n?n:null):\"ddd\"===a?(n=mr.call(this._shortWeekdaysParse,d),-1!==n?n:null):(n=mr.call(this._minWeekdaysParse,d),-1!==n?n:null):\"dddd\"===a?(n=mr.call(this._weekdaysParse,d),-1!==n?n:(n=mr.call(this._shortWeekdaysParse,d),-1!==n?n:(n=mr.call(this._minWeekdaysParse,d),-1!==n?n:null))):\"ddd\"===a?(n=mr.call(this._shortWeekdaysParse,d),-1!==n?n:(n=mr.call(this._weekdaysParse,d),-1!==n?n:(n=mr.call(this._minWeekdaysParse,d),-1!==n?n:null))):(n=mr.call(this._minWeekdaysParse,d),-1!==n?n:(n=mr.call(this._weekdaysParse,d),-1!==n?n:(n=mr.call(this._shortWeekdaysParse,d),-1!==n?n:null)))}function We(e,a,t){var s,n,r;if(this._weekdaysParseExact)return Oe.call(this,e,a,t);for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),s=0;s<7;s++){if(n=m([2e3,1]).day(s),t&&!this._fullWeekdaysParse[s]&&(this._fullWeekdaysParse[s]=new RegExp(\"^\"+this.weekdays(n,\"\").replace(\".\",\".?\")+\"$\",\"i\"),this._shortWeekdaysParse[s]=new RegExp(\"^\"+this.weekdaysShort(n,\"\").replace(\".\",\".?\")+\"$\",\"i\"),this._minWeekdaysParse[s]=new RegExp(\"^\"+this.weekdaysMin(n,\"\").replace(\".\",\".?\")+\"$\",\"i\")),this._weekdaysParse[s]||(r=\"^\"+this.weekdays(n,\"\")+\"|^\"+this.weekdaysShort(n,\"\")+\"|^\"+this.weekdaysMin(n,\"\"),this._weekdaysParse[s]=new RegExp(r.replace(\".\",\"\"),\"i\")),t&&\"dddd\"===a&&this._fullWeekdaysParse[s].test(e))return s;if(t&&\"ddd\"===a&&this._shortWeekdaysParse[s].test(e))return s;if(t&&\"dd\"===a&&this._minWeekdaysParse[s].test(e))return s;if(!t&&this._weekdaysParse[s].test(e))return s}}function Ee(e){if(!this.isValid())return null!=e?this:NaN;var a=this._isUTC?this._d.getUTCDay():this._d.getDay();return null!=e?(e=Se(e,this.localeData()),this.add(e-a,\"d\")):a}function Ae(e){if(!this.isValid())return null!=e?this:NaN;var a=(this.day()+7-this.localeData()._week.dow)%7;return null==e?a:this.add(e-a,\"d\")}function Fe(e){if(!this.isValid())return null!=e?this:NaN;if(null!=e){var a=be(e,this.localeData());return this.day(this.day()%7?a:a-7)}return this.day()||7}function ze(e){return this._weekdaysParseExact?(i(this,\"_weekdaysRegex\")||Ne.call(this),e?this._weekdaysStrictRegex:this._weekdaysRegex):(i(this,\"_weekdaysRegex\")||(this._weekdaysRegex=Dr),this._weekdaysStrictRegex&&e?this._weekdaysStrictRegex:this._weekdaysRegex)}function Je(e){return this._weekdaysParseExact?(i(this,\"_weekdaysRegex\")||Ne.call(this),e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex):(i(this,\"_weekdaysShortRegex\")||(this._weekdaysShortRegex=kr),this._weekdaysShortStrictRegex&&e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex)}function Re(e){return this._weekdaysParseExact?(i(this,\"_weekdaysRegex\")||Ne.call(this),e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex):(i(this,\"_weekdaysMinRegex\")||(this._weekdaysMinRegex=Tr),this._weekdaysMinStrictRegex&&e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex)}function Ne(){function e(e,a){return a.length-e.length}var a,t,s,n,r,d=[],_=[],i=[],o=[];for(a=0;a<7;a++)t=m([2e3,1]).day(a),s=this.weekdaysMin(t,\"\"),n=this.weekdaysShort(t,\"\"),r=this.weekdays(t,\"\"),d.push(s),_.push(n),i.push(r),o.push(s),o.push(n),o.push(r);for(d.sort(e),_.sort(e),i.sort(e),o.sort(e),a=0;a<7;a++)_[a]=X(_[a]),i[a]=X(i[a]),o[a]=X(o[a]);this._weekdaysRegex=new RegExp(\"^(\"+o.join(\"|\")+\")\",\"i\"),this._weekdaysShortRegex=this._weekdaysRegex,this._weekdaysMinRegex=this._weekdaysRegex,this._weekdaysStrictRegex=new RegExp(\"^(\"+i.join(\"|\")+\")\",\"i\"),this._weekdaysShortStrictRegex=new RegExp(\"^(\"+_.join(\"|\")+\")\",\"i\"),this._weekdaysMinStrictRegex=new RegExp(\"^(\"+d.join(\"|\")+\")\",\"i\")}function Ce(){return this.hours()%12||12}function Ie(){return this.hours()||24}function Ge(e,a){U(e,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),a)})}function Ue(e,a){return a._meridiemParse}function Ve(e){return\"p\"===(e+\"\").toLowerCase().charAt(0)}function $e(e,a,t){return e>11?t?\"pm\":\"PM\":t?\"am\":\"AM\"}function Ke(e){return e?e.toLowerCase().replace(\"_\",\"-\"):e}function Ze(e){for(var a,t,s,n,r=0;r<e.length;){for(n=Ke(e[r]).split(\"-\"),a=n.length,t=Ke(e[r+1]),t=t?t.split(\"-\"):null;a>0;){if(s=qe(n.slice(0,a).join(\"-\")))return s;if(t&&t.length>=a&&p(n,t,!0)>=a-1)break;a--}r++}return null}function qe(e){var a=null;if(!Sr[e]&&\"undefined\"!=typeof module&&module&&module.exports)try{a=gr._abbr,require(\"./locale/\"+e),Be(a)}catch(e){}return Sr[e]}function Be(e,a){var t;return e&&(t=n(a)?ea(e):Qe(e,a))&&(gr=t),gr._abbr}function Qe(e,a){if(null!==a){var t=Hr;if(a.abbr=e,null!=Sr[e])T(\"defineLocaleOverride\",\"use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.\"),t=Sr[e]._config;else if(null!=a.parentLocale){if(null==Sr[a.parentLocale])return br[a.parentLocale]||(br[a.parentLocale]=[]),br[a.parentLocale].push({name:e,config:a}),null;t=Sr[a.parentLocale]._config}return Sr[e]=new H(v(t,a)),br[e]&&br[e].forEach(function(e){Qe(e.name,e.config)}),Be(e),Sr[e]}return delete Sr[e],null}function Xe(e,a){if(null!=a){var t,s=Hr;null!=Sr[e]&&(s=Sr[e]._config),a=v(s,a),t=new H(a),t.parentLocale=Sr[e],Sr[e]=t,Be(e)}else null!=Sr[e]&&(null!=Sr[e].parentLocale?Sr[e]=Sr[e].parentLocale:null!=Sr[e]&&delete Sr[e]);return Sr[e]}function ea(e){var t;if(e&&e._locale&&e._locale._abbr&&(e=e._locale._abbr),!e)return gr;if(!a(e)){if(t=qe(e))return t;e=[e]}return Ze(e)}function aa(){return wn(Sr)}function ta(e){var a,t=e._a;return t&&-2===l(e).overflow&&(a=t[tr]<0||t[tr]>11?tr:t[sr]<1||t[sr]>se(t[ar],t[tr])?sr:t[nr]<0||t[nr]>24||24===t[nr]&&(0!==t[rr]||0!==t[dr]||0!==t[_r])?nr:t[rr]<0||t[rr]>59?rr:t[dr]<0||t[dr]>59?dr:t[_r]<0||t[_r]>999?_r:-1,l(e)._overflowDayOfYear&&(a<ar||a>sr)&&(a=sr),l(e)._overflowWeeks&&-1===a&&(a=ir),l(e)._overflowWeekday&&-1===a&&(a=or),l(e).overflow=a),e}function sa(e){var a,t,s,n,r,d,_=e._i,i=jr.exec(_)||xr.exec(_);if(i){for(l(e).iso=!0,a=0,t=Or.length;a<t;a++)if(Or[a][1].exec(i[1])){n=Or[a][0],s=!1!==Or[a][2];break}if(null==n)return void(e._isValid=!1);if(i[3]){for(a=0,t=Wr.length;a<t;a++)if(Wr[a][1].exec(i[3])){r=(i[2]||\" \")+Wr[a][0];break}if(null==r)return void(e._isValid=!1)}if(!s&&null!=r)return void(e._isValid=!1);if(i[4]){if(!Pr.exec(i[4]))return void(e._isValid=!1);d=\"Z\"}e._f=n+(r||\"\")+(d||\"\"),ma(e)}else e._isValid=!1}function na(e){var a,t,s,n,r,d,_,i,o={\" GMT\":\" +0000\",\" EDT\":\" -0400\",\" EST\":\" -0500\",\" CDT\":\" -0500\",\" CST\":\" -0600\",\" MDT\":\" -0600\",\" MST\":\" -0700\",\" PDT\":\" -0700\",\" PST\":\" -0800\"};if(a=e._i.replace(/\\([^\\)]*\\)|[\\n\\t]/g,\" \").replace(/(\\s\\s+)/g,\" \").replace(/^\\s|\\s$/g,\"\"),t=Ar.exec(a)){if(s=t[1]?\"ddd\"+(5===t[1].length?\", \":\" \"):\"\",n=\"D MMM \"+(t[2].length>10?\"YYYY \":\"YY \"),r=\"HH:mm\"+(t[4]?\":ss\":\"\"),t[1]){var m=new Date(t[2]),u=[\"Sun\",\"Mon\",\"Tue\",\"Wed\",\"Thu\",\"Fri\",\"Sat\"][m.getDay()];if(t[1].substr(0,3)!==u)return l(e).weekdayMismatch=!0,void(e._isValid=!1)}switch(t[5].length){case 2:0===i?_=\" +0000\":(i=\"YXWVUTSRQPONZABCDEFGHIKLM\".indexOf(t[5][1].toUpperCase())-12,_=(i<0?\" -\":\" +\")+(\"\"+i).replace(/^-?/,\"0\").match(/..$/)[0]+\"00\");break;case 4:_=o[t[5]];break;default:_=o[\" GMT\"]}t[5]=_,e._i=t.splice(1).join(\"\"),d=\" ZZ\",e._f=s+n+r+d,ma(e),l(e).rfc2822=!0}else e._isValid=!1}function ra(a){var t=Er.exec(a._i);return null!==t?void(a._d=new Date(+t[1])):(sa(a),void(!1===a._isValid&&(delete a._isValid,na(a),!1===a._isValid&&(delete a._isValid,e.createFromInputFallback(a)))))}function da(e,a,t){return null!=e?e:null!=a?a:t}function _a(a){var t=new Date(e.now());return a._useUTC?[t.getUTCFullYear(),t.getUTCMonth(),t.getUTCDate()]:[t.getFullYear(),t.getMonth(),t.getDate()]}function ia(e){var a,t,s,n,r=[];if(!e._d){for(s=_a(e),e._w&&null==e._a[sr]&&null==e._a[tr]&&oa(e),null!=e._dayOfYear&&(n=da(e._a[ar],s[ar]),(e._dayOfYear>he(n)||0===e._dayOfYear)&&(l(e)._overflowDayOfYear=!0),t=ye(n,0,e._dayOfYear),e._a[tr]=t.getUTCMonth(),e._a[sr]=t.getUTCDate()),a=0;a<3&&null==e._a[a];++a)e._a[a]=r[a]=s[a];for(;a<7;a++)e._a[a]=r[a]=null==e._a[a]?2===a?1:0:e._a[a];24===e._a[nr]&&0===e._a[rr]&&0===e._a[dr]&&0===e._a[_r]&&(e._nextDay=!0,e._a[nr]=0),e._d=(e._useUTC?ye:Ye).apply(null,r),null!=e._tzm&&e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),e._nextDay&&(e._a[nr]=24)}}function oa(e){var a,t,s,n,r,d,_,i;if(a=e._w,null!=a.GG||null!=a.W||null!=a.E)r=1,d=4,t=da(a.GG,e._a[ar],De(ya(),1,4).year),s=da(a.W,1),((n=da(a.E,1))<1||n>7)&&(i=!0);else{r=e._locale._week.dow,d=e._locale._week.doy;var o=De(ya(),r,d);t=da(a.gg,e._a[ar],o.year),s=da(a.w,o.week),null!=a.d?((n=a.d)<0||n>6)&&(i=!0):null!=a.e?(n=a.e+r,(a.e<0||a.e>6)&&(i=!0)):n=r}s<1||s>ke(t,r,d)?l(e)._overflowWeeks=!0:null!=i?l(e)._overflowWeekday=!0:(_=pe(t,s,n,r,d),e._a[ar]=_.year,e._dayOfYear=_.dayOfYear)}function ma(a){if(a._f===e.ISO_8601)return void sa(a);if(a._f===e.RFC_2822)return void na(a);a._a=[],l(a).empty=!0;var t,s,n,r,d,_=\"\"+a._i,i=_.length,o=0;for(n=Z(a._f,a._locale).match(Pn)||[],t=0;t<n.length;t++)r=n[t],s=(_.match(B(r,a))||[])[0],s&&(d=_.substr(0,_.indexOf(s)),d.length>0&&l(a).unusedInput.push(d),_=_.slice(_.indexOf(s)+s.length),o+=s.length),En[r]?(s?l(a).empty=!1:l(a).unusedTokens.push(r),te(r,s,a)):a._strict&&!s&&l(a).unusedTokens.push(r);l(a).charsLeftOver=i-o,_.length>0&&l(a).unusedInput.push(_),a._a[nr]<=12&&!0===l(a).bigHour&&a._a[nr]>0&&(l(a).bigHour=void 0),l(a).parsedDateParts=a._a.slice(0),l(a).meridiem=a._meridiem,a._a[nr]=ua(a._locale,a._a[nr],a._meridiem),ia(a),ta(a)}function ua(e,a,t){var s;return null==t?a:null!=e.meridiemHour?e.meridiemHour(a,t):null!=e.isPM?(s=e.isPM(t),s&&a<12&&(a+=12),s||12!==a||(a=0),a):a}function la(e){var a,t,s,n,r;if(0===e._f.length)return l(e).invalidFormat=!0,void(e._d=new Date(NaN));for(n=0;n<e._f.length;n++)r=0,a=L({},e),null!=e._useUTC&&(a._useUTC=e._useUTC),a._f=e._f[n],ma(a),M(a)&&(r+=l(a).charsLeftOver,r+=10*l(a).unusedTokens.length,l(a).score=r,(null==s||r<s)&&(s=r,t=a));o(e,t||a)}function Ma(e){if(!e._d){var a=A(e._i);e._a=_([a.year,a.month,a.day||a.date,a.hour,a.minute,a.second,a.millisecond],function(e){return e&&parseInt(e,10)}),ia(e)}}function ha(e){var a=new c(ta(La(e)));return a._nextDay&&(a.add(1,\"d\"),a._nextDay=void 0),a}function La(e){var t=e._i,s=e._f;return e._locale=e._locale||ea(e._l),null===t||void 0===s&&\"\"===t?h({nullInput:!0}):(\"string\"==typeof t&&(e._i=t=e._locale.preparse(t)),Y(t)?new c(ta(t)):(d(t)?e._d=t:a(s)?la(e):s?ma(e):ca(e),M(e)||(e._d=null),e))}function ca(s){var i=s._i;n(i)?s._d=new Date(e.now()):d(i)?s._d=new Date(i.valueOf()):\"string\"==typeof i?ra(s):a(i)?(s._a=_(i.slice(0),function(e){return parseInt(e,10)}),ia(s)):t(i)?Ma(s):r(i)?s._d=new Date(i):e.createFromInputFallback(s)}function Ya(e,n,r,d,_){var i={};return!0!==r&&!1!==r||(d=r,r=void 0),(t(e)&&s(e)||a(e)&&0===e.length)&&(e=void 0),i._isAMomentObject=!0,i._useUTC=i._isUTC=_,i._l=r,i._i=e,i._f=n,i._strict=d,ha(i)}function ya(e,a,t,s){return Ya(e,a,t,s,!1)}function fa(e,t){var s,n;if(1===t.length&&a(t[0])&&(t=t[0]),!t.length)return ya();for(s=t[0],n=1;n<t.length;++n)t[n].isValid()&&!t[n][e](s)||(s=t[n]);return s}function pa(){return fa(\"isBefore\",[].slice.call(arguments,0))}function Da(){return fa(\"isAfter\",[].slice.call(arguments,0))}function ka(e){for(var a in e)if(-1===Rr.indexOf(a)||null!=e[a]&&isNaN(e[a]))return!1;for(var t=!1,s=0;s<Rr.length;++s)if(e[Rr[s]]){if(t)return!1;parseFloat(e[Rr[s]])!==f(e[Rr[s]])&&(t=!0)}return!0}function Ta(){return this._isValid}function ga(){return Ia(NaN)}function wa(e){var a=A(e),t=a.year||0,s=a.quarter||0,n=a.month||0,r=a.week||0,d=a.day||0,_=a.hour||0,i=a.minute||0,o=a.second||0,m=a.millisecond||0;this._isValid=ka(a),this._milliseconds=+m+1e3*o+6e4*i+1e3*_*60*60,this._days=+d+7*r,this._months=+n+3*s+12*t,this._data={},this._locale=ea(),this._bubble()}function va(e){return e instanceof wa}function Ha(e){return e<0?-1*Math.round(-1*e):Math.round(e)}function Sa(e,a){U(e,0,0,function(){var e=this.utcOffset(),t=\"+\";return e<0&&(e=-e,t=\"-\"),t+G(~~(e/60),2)+a+G(~~e%60,2)})}function ba(e,a){var t=(a||\"\").match(e);if(null===t)return null;var s=t[t.length-1]||[],n=(s+\"\").match(Nr)||[\"-\",0,0],r=60*n[1]+f(n[2]);return 0===r?0:\"+\"===n[0]?r:-r}function ja(a,t){var s,n;return t._isUTC?(s=t.clone(),n=(Y(a)||d(a)?a.valueOf():ya(a).valueOf())-s.valueOf(),s._d.setTime(s._d.valueOf()+n),e.updateOffset(s,!1),s):ya(a).local()}function xa(e){return 15*-Math.round(e._d.getTimezoneOffset()/15)}function Pa(a,t,s){var n,r=this._offset||0;if(!this.isValid())return null!=a?this:NaN;if(null!=a){if(\"string\"==typeof a){if(null===(a=ba(qn,a)))return this}else Math.abs(a)<16&&!s&&(a*=60);return!this._isUTC&&t&&(n=xa(this)),this._offset=a,this._isUTC=!0,null!=n&&this.add(n,\"m\"),r!==a&&(!t||this._changeInProgress?Ka(this,Ia(a-r,\"m\"),1,!1):this._changeInProgress||(this._changeInProgress=!0,e.updateOffset(this,!0),this._changeInProgress=null)),this}return this._isUTC?r:xa(this)}function Oa(e,a){return null!=e?(\"string\"!=typeof e&&(e=-e),this.utcOffset(e,a),this):-this.utcOffset()}function Wa(e){return this.utcOffset(0,e)}function Ea(e){return this._isUTC&&(this.utcOffset(0,e),this._isUTC=!1,e&&this.subtract(xa(this),\"m\")),this}function Aa(){if(null!=this._tzm)this.utcOffset(this._tzm,!1,!0);else if(\"string\"==typeof this._i){var e=ba(Zn,this._i);null!=e?this.utcOffset(e):this.utcOffset(0,!0)}return this}function Fa(e){return!!this.isValid()&&(e=e?ya(e).utcOffset():0,(this.utcOffset()-e)%60==0)}function za(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()}function Ja(){if(!n(this._isDSTShifted))return this._isDSTShifted;var e={};if(L(e,this),e=La(e),e._a){var a=e._isUTC?m(e._a):ya(e._a);this._isDSTShifted=this.isValid()&&p(e._a,a.toArray())>0}else this._isDSTShifted=!1;return this._isDSTShifted}function Ra(){return!!this.isValid()&&!this._isUTC}function Na(){return!!this.isValid()&&this._isUTC}function Ca(){return!!this.isValid()&&this._isUTC&&0===this._offset}function Ia(e,a){var t,s,n,d=e,_=null;return va(e)?d={ms:e._milliseconds,d:e._days,M:e._months}:r(e)?(d={},a?d[a]=e:d.milliseconds=e):(_=Cr.exec(e))?(t=\"-\"===_[1]?-1:1,d={y:0,d:f(_[sr])*t,h:f(_[nr])*t,m:f(_[rr])*t,s:f(_[dr])*t,ms:f(Ha(1e3*_[_r]))*t}):(_=Ir.exec(e))?(t=\"-\"===_[1]?-1:1,d={y:Ga(_[2],t),M:Ga(_[3],t),w:Ga(_[4],t),d:Ga(_[5],t),h:Ga(_[6],t),m:Ga(_[7],t),s:Ga(_[8],t)}):null==d?d={}:\"object\"==typeof d&&(\"from\"in d||\"to\"in d)&&(n=Va(ya(d.from),ya(d.to)),d={},d.ms=n.milliseconds,d.M=n.months),s=new wa(d),va(e)&&i(e,\"_locale\")&&(s._locale=e._locale),s}function Ga(e,a){var t=e&&parseFloat(e.replace(\",\",\".\"));return(isNaN(t)?0:t)*a}function Ua(e,a){var t={milliseconds:0,months:0};return t.months=a.month()-e.month()+12*(a.year()-e.year()),e.clone().add(t.months,\"M\").isAfter(a)&&--t.months,t.milliseconds=+a-+e.clone().add(t.months,\"M\"),t}function Va(e,a){var t;return e.isValid()&&a.isValid()?(a=ja(a,e),e.isBefore(a)?t=Ua(e,a):(t=Ua(a,e),t.milliseconds=-t.milliseconds,t.months=-t.months),t):{milliseconds:0,months:0}}function $a(e,a){return function(t,s){var n,r;return null===s||isNaN(+s)||(T(a,\"moment().\"+a+\"(period, number) is deprecated. Please use moment().\"+a+\"(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.\"),r=t,t=s,s=r),t=\"string\"==typeof t?+t:t,n=Ia(t,s),Ka(this,n,e),this}}function Ka(a,t,s,n){var r=t._milliseconds,d=Ha(t._days),_=Ha(t._months);a.isValid()&&(n=null==n||n,r&&a._d.setTime(a._d.valueOf()+r*s),d&&N(a,\"Date\",R(a,\"Date\")+d*s),_&&ie(a,R(a,\"Month\")+_*s),n&&e.updateOffset(a,d||_))}function Za(e,a){var t=e.diff(a,\"days\",!0);return t<-6?\"sameElse\":t<-1?\"lastWeek\":t<0?\"lastDay\":t<1?\"sameDay\":t<2?\"nextDay\":t<7?\"nextWeek\":\"sameElse\"}function qa(a,t){var s=a||ya(),n=ja(s,this).startOf(\"day\"),r=e.calendarFormat(this,n)||\"sameElse\",d=t&&(g(t[r])?t[r].call(this,s):t[r]);return this.format(d||this.localeData().calendar(r,this,ya(s)))}function Ba(){return new c(this)}function Qa(e,a){var t=Y(e)?e:ya(e);return!(!this.isValid()||!t.isValid())&&(a=E(n(a)?\"millisecond\":a),\"millisecond\"===a?this.valueOf()>t.valueOf():t.valueOf()<this.clone().startOf(a).valueOf())}function Xa(e,a){var t=Y(e)?e:ya(e);return!(!this.isValid()||!t.isValid())&&(a=E(n(a)?\"millisecond\":a),\"millisecond\"===a?this.valueOf()<t.valueOf():this.clone().endOf(a).valueOf()<t.valueOf())}function et(e,a,t,s){return s=s||\"()\",(\"(\"===s[0]?this.isAfter(e,t):!this.isBefore(e,t))&&(\")\"===s[1]?this.isBefore(a,t):!this.isAfter(a,t))}function at(e,a){var t,s=Y(e)?e:ya(e);return!(!this.isValid()||!s.isValid())&&(a=E(a||\"millisecond\"),\"millisecond\"===a?this.valueOf()===s.valueOf():(t=s.valueOf(),this.clone().startOf(a).valueOf()<=t&&t<=this.clone().endOf(a).valueOf()))}function tt(e,a){return this.isSame(e,a)||this.isAfter(e,a)}function st(e,a){return this.isSame(e,a)||this.isBefore(e,a)}function nt(e,a,t){var s,n,r,d;return this.isValid()?(s=ja(e,this),s.isValid()?(n=6e4*(s.utcOffset()-this.utcOffset()),a=E(a),\"year\"===a||\"month\"===a||\"quarter\"===a?(d=rt(this,s),\"quarter\"===a?d/=3:\"year\"===a&&(d/=12)):(r=this-s,d=\"second\"===a?r/1e3:\"minute\"===a?r/6e4:\"hour\"===a?r/36e5:\"day\"===a?(r-n)/864e5:\"week\"===a?(r-n)/6048e5:r),t?d:y(d)):NaN):NaN}function rt(e,a){var t,s,n=12*(a.year()-e.year())+(a.month()-e.month()),r=e.clone().add(n,\"months\");return a-r<0?(t=e.clone().add(n-1,\"months\"),s=(a-r)/(r-t)):(t=e.clone().add(n+1,\"months\"),s=(a-r)/(t-r)),-(n+s)||0}function dt(){return this.clone().locale(\"en\").format(\"ddd MMM DD YYYY HH:mm:ss [GMT]ZZ\")}function _t(){if(!this.isValid())return null;var e=this.clone().utc();return e.year()<0||e.year()>9999?K(e,\"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]\"):g(Date.prototype.toISOString)?this.toDate().toISOString():K(e,\"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]\")}function it(){if(!this.isValid())return\"moment.invalid(/* \"+this._i+\" */)\";var e=\"moment\",a=\"\";this.isLocal()||(e=0===this.utcOffset()?\"moment.utc\":\"moment.parseZone\",a=\"Z\");var t=\"[\"+e+'(\"]',s=0<=this.year()&&this.year()<=9999?\"YYYY\":\"YYYYYY\",n=a+'[\")]';return this.format(t+s+\"-MM-DD[T]HH:mm:ss.SSS\"+n)}function ot(a){a||(a=this.isUtc()?e.defaultFormatUtc:e.defaultFormat);var t=K(this,a);return this.localeData().postformat(t)}function mt(e,a){return this.isValid()&&(Y(e)&&e.isValid()||ya(e).isValid())?Ia({to:this,from:e}).locale(this.locale()).humanize(!a):this.localeData().invalidDate()}function ut(e){return this.from(ya(),e)}function lt(e,a){return this.isValid()&&(Y(e)&&e.isValid()||ya(e).isValid())?Ia({from:this,to:e}).locale(this.locale()).humanize(!a):this.localeData().invalidDate()}function Mt(e){return this.to(ya(),e)}function ht(e){var a;return void 0===e?this._locale._abbr:(a=ea(e),null!=a&&(this._locale=a),this)}function Lt(){return this._locale}function ct(e){switch(e=E(e)){case\"year\":this.month(0);case\"quarter\":case\"month\":this.date(1);case\"week\":case\"isoWeek\":case\"day\":case\"date\":this.hours(0);case\"hour\":this.minutes(0);case\"minute\":this.seconds(0);case\"second\":this.milliseconds(0)}return\"week\"===e&&this.weekday(0),\"isoWeek\"===e&&this.isoWeekday(1),\"quarter\"===e&&this.month(3*Math.floor(this.month()/3)),this}function Yt(e){return e=E(e),void 0===e||\"millisecond\"===e?this:(\"date\"===e&&(e=\"day\"),this.startOf(e).add(1,\"isoWeek\"===e?\"week\":e).subtract(1,\"ms\"))}function yt(){return this._d.valueOf()-6e4*(this._offset||0)}function ft(){return Math.floor(this.valueOf()/1e3)}function pt(){return new Date(this.valueOf())}function Dt(){var e=this;return[e.year(),e.month(),e.date(),e.hour(),e.minute(),e.second(),e.millisecond()]}function kt(){var e=this;return{years:e.year(),months:e.month(),date:e.date(),hours:e.hours(),minutes:e.minutes(),seconds:e.seconds(),milliseconds:e.milliseconds()}}function Tt(){return this.isValid()?this.toISOString():null}function gt(){return M(this)}function wt(){return o({},l(this))}function vt(){return l(this).overflow}\nfunction Ht(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}}function St(e,a){U(0,[e,e.length],0,a)}function bt(e){return Ot.call(this,e,this.week(),this.weekday(),this.localeData()._week.dow,this.localeData()._week.doy)}function jt(e){return Ot.call(this,e,this.isoWeek(),this.isoWeekday(),1,4)}function xt(){return ke(this.year(),1,4)}function Pt(){var e=this.localeData()._week;return ke(this.year(),e.dow,e.doy)}function Ot(e,a,t,s,n){var r;return null==e?De(this,s,n).year:(r=ke(e,s,n),a>r&&(a=r),Wt.call(this,e,a,t,s,n))}function Wt(e,a,t,s,n){var r=pe(e,a,t,s,n),d=ye(r.year,0,r.dayOfYear);return this.year(d.getUTCFullYear()),this.month(d.getUTCMonth()),this.date(d.getUTCDate()),this}function Et(e){return null==e?Math.ceil((this.month()+1)/3):this.month(3*(e-1)+this.month()%3)}function At(e){var a=Math.round((this.clone().startOf(\"day\")-this.clone().startOf(\"year\"))/864e5)+1;return null==e?a:this.add(e-a,\"d\")}function Ft(e,a){a[_r]=f(1e3*(\"0.\"+e))}function zt(){return this._isUTC?\"UTC\":\"\"}function Jt(){return this._isUTC?\"Coordinated Universal Time\":\"\"}function Rt(e){return ya(1e3*e)}function Nt(){return ya.apply(null,arguments).parseZone()}function Ct(e){return e}function It(e,a,t,s){var n=ea(),r=m().set(s,a);return n[t](r,e)}function Gt(e,a,t){if(r(e)&&(a=e,e=void 0),e=e||\"\",null!=a)return It(e,a,t,\"month\");var s,n=[];for(s=0;s<12;s++)n[s]=It(e,s,t,\"month\");return n}function Ut(e,a,t,s){\"boolean\"==typeof e?(r(a)&&(t=a,a=void 0),a=a||\"\"):(a=e,t=a,e=!1,r(a)&&(t=a,a=void 0),a=a||\"\");var n=ea(),d=e?n._week.dow:0;if(null!=t)return It(a,(t+d)%7,s,\"day\");var _,i=[];for(_=0;_<7;_++)i[_]=It(a,(_+d)%7,s,\"day\");return i}function Vt(e,a){return Gt(e,a,\"months\")}function $t(e,a){return Gt(e,a,\"monthsShort\")}function Kt(e,a,t){return Ut(e,a,t,\"weekdays\")}function Zt(e,a,t){return Ut(e,a,t,\"weekdaysShort\")}function qt(e,a,t){return Ut(e,a,t,\"weekdaysMin\")}function Bt(){var e=this._data;return this._milliseconds=ed(this._milliseconds),this._days=ed(this._days),this._months=ed(this._months),e.milliseconds=ed(e.milliseconds),e.seconds=ed(e.seconds),e.minutes=ed(e.minutes),e.hours=ed(e.hours),e.months=ed(e.months),e.years=ed(e.years),this}function Qt(e,a,t,s){var n=Ia(a,t);return e._milliseconds+=s*n._milliseconds,e._days+=s*n._days,e._months+=s*n._months,e._bubble()}function Xt(e,a){return Qt(this,e,a,1)}function es(e,a){return Qt(this,e,a,-1)}function as(e){return e<0?Math.floor(e):Math.ceil(e)}function ts(){var e,a,t,s,n,r=this._milliseconds,d=this._days,_=this._months,i=this._data;return r>=0&&d>=0&&_>=0||r<=0&&d<=0&&_<=0||(r+=864e5*as(ns(_)+d),d=0,_=0),i.milliseconds=r%1e3,e=y(r/1e3),i.seconds=e%60,a=y(e/60),i.minutes=a%60,t=y(a/60),i.hours=t%24,d+=y(t/24),n=y(ss(d)),_+=n,d-=as(ns(n)),s=y(_/12),_%=12,i.days=d,i.months=_,i.years=s,this}function ss(e){return 4800*e/146097}function ns(e){return 146097*e/4800}function rs(e){if(!this.isValid())return NaN;var a,t,s=this._milliseconds;if(\"month\"===(e=E(e))||\"year\"===e)return a=this._days+s/864e5,t=this._months+ss(a),\"month\"===e?t:t/12;switch(a=this._days+Math.round(ns(this._months)),e){case\"week\":return a/7+s/6048e5;case\"day\":return a+s/864e5;case\"hour\":return 24*a+s/36e5;case\"minute\":return 1440*a+s/6e4;case\"second\":return 86400*a+s/1e3;case\"millisecond\":return Math.floor(864e5*a)+s;default:throw new Error(\"Unknown unit \"+e)}}function ds(){return this.isValid()?this._milliseconds+864e5*this._days+this._months%12*2592e6+31536e6*f(this._months/12):NaN}function _s(e){return function(){return this.as(e)}}function is(e){return e=E(e),this.isValid()?this[e+\"s\"]():NaN}function os(e){return function(){return this.isValid()?this._data[e]:NaN}}function ms(){return y(this.days()/7)}function us(e,a,t,s,n){return n.relativeTime(a||1,!!t,e,s)}function ls(e,a,t){var s=Ia(e).abs(),n=cd(s.as(\"s\")),r=cd(s.as(\"m\")),d=cd(s.as(\"h\")),_=cd(s.as(\"d\")),i=cd(s.as(\"M\")),o=cd(s.as(\"y\")),m=n<=Yd.ss&&[\"s\",n]||n<Yd.s&&[\"ss\",n]||r<=1&&[\"m\"]||r<Yd.m&&[\"mm\",r]||d<=1&&[\"h\"]||d<Yd.h&&[\"hh\",d]||_<=1&&[\"d\"]||_<Yd.d&&[\"dd\",_]||i<=1&&[\"M\"]||i<Yd.M&&[\"MM\",i]||o<=1&&[\"y\"]||[\"yy\",o];return m[2]=a,m[3]=+e>0,m[4]=t,us.apply(null,m)}function Ms(e){return void 0===e?cd:\"function\"==typeof e&&(cd=e,!0)}function hs(e,a){return void 0!==Yd[e]&&(void 0===a?Yd[e]:(Yd[e]=a,\"s\"===e&&(Yd.ss=a-1),!0))}function Ls(e){if(!this.isValid())return this.localeData().invalidDate();var a=this.localeData(),t=ls(this,!e,a);return e&&(t=a.pastFuture(+this,t)),a.postformat(t)}function cs(){if(!this.isValid())return this.localeData().invalidDate();var e,a,t,s=yd(this._milliseconds)/1e3,n=yd(this._days),r=yd(this._months);e=y(s/60),a=y(e/60),s%=60,e%=60,t=y(r/12),r%=12;var d=t,_=r,i=n,o=a,m=e,u=s,l=this.asSeconds();return l?(l<0?\"-\":\"\")+\"P\"+(d?d+\"Y\":\"\")+(_?_+\"M\":\"\")+(i?i+\"D\":\"\")+(o||m||u?\"T\":\"\")+(o?o+\"H\":\"\")+(m?m+\"M\":\"\")+(u?u+\"S\":\"\"):\"P0D\"}function Ys(e,a){var t=e.split(\"_\");return a%10==1&&a%100!=11?t[0]:a%10>=2&&a%10<=4&&(a%100<10||a%100>=20)?t[1]:t[2]}function ys(e,a,t){var s={mm:a?\"хвіліна_хвіліны_хвілін\":\"хвіліну_хвіліны_хвілін\",hh:a?\"гадзіна_гадзіны_гадзін\":\"гадзіну_гадзіны_гадзін\",dd:\"дзень_дні_дзён\",MM:\"месяц_месяцы_месяцаў\",yy:\"год_гады_гадоў\"};return\"m\"===t?a?\"хвіліна\":\"хвіліну\":\"h\"===t?a?\"гадзіна\":\"гадзіну\":e+\" \"+Ys(s[t],+e)}function fs(e,a,t){return e+\" \"+ks({mm:\"munutenn\",MM:\"miz\",dd:\"devezh\"}[t],e)}function ps(e){switch(Ds(e)){case 1:case 3:case 4:case 5:case 9:return e+\" bloaz\";default:return e+\" vloaz\"}}function Ds(e){return e>9?Ds(e%10):e}function ks(e,a){return 2===a?Ts(e):e}function Ts(e){var a={m:\"v\",b:\"v\",d:\"z\"};return void 0===a[e.charAt(0)]?e:a[e.charAt(0)]+e.substring(1)}function gs(e,a,t){var s=e+\" \";switch(t){case\"m\":return a?\"jedna minuta\":\"jedne minute\";case\"mm\":return s+=1===e?\"minuta\":2===e||3===e||4===e?\"minute\":\"minuta\";case\"h\":return a?\"jedan sat\":\"jednog sata\";case\"hh\":return s+=1===e?\"sat\":2===e||3===e||4===e?\"sata\":\"sati\";case\"dd\":return s+=1===e?\"dan\":\"dana\";case\"MM\":return s+=1===e?\"mjesec\":2===e||3===e||4===e?\"mjeseca\":\"mjeseci\";case\"yy\":return s+=1===e?\"godina\":2===e||3===e||4===e?\"godine\":\"godina\"}}function ws(e){return e>1&&e<5&&1!=~~(e/10)}function vs(e,a,t,s){var n=e+\" \";switch(t){case\"s\":return a||s?\"pár sekund\":\"pár sekundami\";case\"m\":return a?\"minuta\":s?\"minutu\":\"minutou\";case\"mm\":return a||s?n+(ws(e)?\"minuty\":\"minut\"):n+\"minutami\";case\"h\":return a?\"hodina\":s?\"hodinu\":\"hodinou\";case\"hh\":return a||s?n+(ws(e)?\"hodiny\":\"hodin\"):n+\"hodinami\";case\"d\":return a||s?\"den\":\"dnem\";case\"dd\":return a||s?n+(ws(e)?\"dny\":\"dní\"):n+\"dny\";case\"M\":return a||s?\"měsíc\":\"měsícem\";case\"MM\":return a||s?n+(ws(e)?\"měsíce\":\"měsíců\"):n+\"měsíci\";case\"y\":return a||s?\"rok\":\"rokem\";case\"yy\":return a||s?n+(ws(e)?\"roky\":\"let\"):n+\"lety\"}}function Hs(e,a,t,s){var n={m:[\"eine Minute\",\"einer Minute\"],h:[\"eine Stunde\",\"einer Stunde\"],d:[\"ein Tag\",\"einem Tag\"],dd:[e+\" Tage\",e+\" Tagen\"],M:[\"ein Monat\",\"einem Monat\"],MM:[e+\" Monate\",e+\" Monaten\"],y:[\"ein Jahr\",\"einem Jahr\"],yy:[e+\" Jahre\",e+\" Jahren\"]};return a?n[t][0]:n[t][1]}function Ss(e,a,t,s){var n={m:[\"eine Minute\",\"einer Minute\"],h:[\"eine Stunde\",\"einer Stunde\"],d:[\"ein Tag\",\"einem Tag\"],dd:[e+\" Tage\",e+\" Tagen\"],M:[\"ein Monat\",\"einem Monat\"],MM:[e+\" Monate\",e+\" Monaten\"],y:[\"ein Jahr\",\"einem Jahr\"],yy:[e+\" Jahre\",e+\" Jahren\"]};return a?n[t][0]:n[t][1]}function bs(e,a,t,s){var n={m:[\"eine Minute\",\"einer Minute\"],h:[\"eine Stunde\",\"einer Stunde\"],d:[\"ein Tag\",\"einem Tag\"],dd:[e+\" Tage\",e+\" Tagen\"],M:[\"ein Monat\",\"einem Monat\"],MM:[e+\" Monate\",e+\" Monaten\"],y:[\"ein Jahr\",\"einem Jahr\"],yy:[e+\" Jahre\",e+\" Jahren\"]};return a?n[t][0]:n[t][1]}function js(e,a,t,s){var n={s:[\"mõne sekundi\",\"mõni sekund\",\"paar sekundit\"],m:[\"ühe minuti\",\"üks minut\"],mm:[e+\" minuti\",e+\" minutit\"],h:[\"ühe tunni\",\"tund aega\",\"üks tund\"],hh:[e+\" tunni\",e+\" tundi\"],d:[\"ühe päeva\",\"üks päev\"],M:[\"kuu aja\",\"kuu aega\",\"üks kuu\"],MM:[e+\" kuu\",e+\" kuud\"],y:[\"ühe aasta\",\"aasta\",\"üks aasta\"],yy:[e+\" aasta\",e+\" aastat\"]};return a?n[t][2]?n[t][2]:n[t][1]:s?n[t][0]:n[t][1]}function xs(e,a,t,s){var n=\"\";switch(t){case\"s\":return s?\"muutaman sekunnin\":\"muutama sekunti\";case\"m\":return s?\"minuutin\":\"minuutti\";case\"mm\":n=s?\"minuutin\":\"minuuttia\";break;case\"h\":return s?\"tunnin\":\"tunti\";case\"hh\":n=s?\"tunnin\":\"tuntia\";break;case\"d\":return s?\"päivän\":\"päivä\";case\"dd\":n=s?\"päivän\":\"päivää\";break;case\"M\":return s?\"kuukauden\":\"kuukausi\";case\"MM\":n=s?\"kuukauden\":\"kuukautta\";break;case\"y\":return s?\"vuoden\":\"vuosi\";case\"yy\":n=s?\"vuoden\":\"vuotta\"}return n=Ps(e,s)+\" \"+n}function Ps(e,a){return e<10?a?Zd[e]:Kd[e]:e}function Os(e,a,t,s){var n={s:[\"thodde secondanim\",\"thodde second\"],m:[\"eka mintan\",\"ek minute\"],mm:[e+\" mintanim\",e+\" mintam\"],h:[\"eka horan\",\"ek hor\"],hh:[e+\" horanim\",e+\" hor\"],d:[\"eka disan\",\"ek dis\"],dd:[e+\" disanim\",e+\" dis\"],M:[\"eka mhoinean\",\"ek mhoino\"],MM:[e+\" mhoineanim\",e+\" mhoine\"],y:[\"eka vorsan\",\"ek voros\"],yy:[e+\" vorsanim\",e+\" vorsam\"]};return a?n[t][0]:n[t][1]}function Ws(e,a,t){var s=e+\" \";switch(t){case\"m\":return a?\"jedna minuta\":\"jedne minute\";case\"mm\":return s+=1===e?\"minuta\":2===e||3===e||4===e?\"minute\":\"minuta\";case\"h\":return a?\"jedan sat\":\"jednog sata\";case\"hh\":return s+=1===e?\"sat\":2===e||3===e||4===e?\"sata\":\"sati\";case\"dd\":return s+=1===e?\"dan\":\"dana\";case\"MM\":return s+=1===e?\"mjesec\":2===e||3===e||4===e?\"mjeseca\":\"mjeseci\";case\"yy\":return s+=1===e?\"godina\":2===e||3===e||4===e?\"godine\":\"godina\"}}function Es(e,a,t,s){var n=e;switch(t){case\"s\":return s||a?\"néhány másodperc\":\"néhány másodperce\";case\"m\":return\"egy\"+(s||a?\" perc\":\" perce\");case\"mm\":return n+(s||a?\" perc\":\" perce\");case\"h\":return\"egy\"+(s||a?\" óra\":\" órája\");case\"hh\":return n+(s||a?\" óra\":\" órája\");case\"d\":return\"egy\"+(s||a?\" nap\":\" napja\");case\"dd\":return n+(s||a?\" nap\":\" napja\");case\"M\":return\"egy\"+(s||a?\" hónap\":\" hónapja\");case\"MM\":return n+(s||a?\" hónap\":\" hónapja\");case\"y\":return\"egy\"+(s||a?\" év\":\" éve\");case\"yy\":return n+(s||a?\" év\":\" éve\")}return\"\"}function As(e){return(e?\"\":\"[múlt] \")+\"[\"+r_[this.day()]+\"] LT[-kor]\"}function Fs(e){return e%100==11||e%10!=1}function zs(e,a,t,s){var n=e+\" \";switch(t){case\"s\":return a||s?\"nokkrar sekúndur\":\"nokkrum sekúndum\";case\"m\":return a?\"mínúta\":\"mínútu\";case\"mm\":return Fs(e)?n+(a||s?\"mínútur\":\"mínútum\"):a?n+\"mínúta\":n+\"mínútu\";case\"hh\":return Fs(e)?n+(a||s?\"klukkustundir\":\"klukkustundum\"):n+\"klukkustund\";case\"d\":return a?\"dagur\":s?\"dag\":\"degi\";case\"dd\":return Fs(e)?a?n+\"dagar\":n+(s?\"daga\":\"dögum\"):a?n+\"dagur\":n+(s?\"dag\":\"degi\");case\"M\":return a?\"mánuður\":s?\"mánuð\":\"mánuði\";case\"MM\":return Fs(e)?a?n+\"mánuðir\":n+(s?\"mánuði\":\"mánuðum\"):a?n+\"mánuður\":n+(s?\"mánuð\":\"mánuði\");case\"y\":return a||s?\"ár\":\"ári\";case\"yy\":return Fs(e)?n+(a||s?\"ár\":\"árum\"):n+(a||s?\"ár\":\"ári\")}}function Js(e,a,t,s){var n={m:[\"eng Minutt\",\"enger Minutt\"],h:[\"eng Stonn\",\"enger Stonn\"],d:[\"een Dag\",\"engem Dag\"],M:[\"ee Mount\",\"engem Mount\"],y:[\"ee Joer\",\"engem Joer\"]};return a?n[t][0]:n[t][1]}function Rs(e){return Cs(e.substr(0,e.indexOf(\" \")))?\"a \"+e:\"an \"+e}function Ns(e){return Cs(e.substr(0,e.indexOf(\" \")))?\"viru \"+e:\"virun \"+e}function Cs(e){if(e=parseInt(e,10),isNaN(e))return!1;if(e<0)return!0;if(e<10)return 4<=e&&e<=7;if(e<100){var a=e%10,t=e/10;return Cs(0===a?t:a)}if(e<1e4){for(;e>=10;)e/=10;return Cs(e)}return e/=1e3,Cs(e)}function Is(e,a,t,s){return a?\"kelios sekundės\":s?\"kelių sekundžių\":\"kelias sekundes\"}function Gs(e,a,t,s){return a?Vs(t)[0]:s?Vs(t)[1]:Vs(t)[2]}function Us(e){return e%10==0||e>10&&e<20}function Vs(e){return m_[e].split(\"_\")}function $s(e,a,t,s){var n=e+\" \";return 1===e?n+Gs(e,a,t[0],s):a?n+(Us(e)?Vs(t)[1]:Vs(t)[0]):s?n+Vs(t)[1]:n+(Us(e)?Vs(t)[1]:Vs(t)[2])}function Ks(e,a,t){return t?a%10==1&&a%100!=11?e[2]:e[3]:a%10==1&&a%100!=11?e[0]:e[1]}function Zs(e,a,t){return e+\" \"+Ks(u_[t],e,a)}function qs(e,a,t){return Ks(u_[t],e,a)}function Bs(e,a){return a?\"dažas sekundes\":\"dažām sekundēm\"}function Qs(e,a,t,s){var n=\"\";if(a)switch(t){case\"s\":n=\"काही सेकंद\";break;case\"m\":n=\"एक मिनिट\";break;case\"mm\":n=\"%d मिनिटे\";break;case\"h\":n=\"एक तास\";break;case\"hh\":n=\"%d तास\";break;case\"d\":n=\"एक दिवस\";break;case\"dd\":n=\"%d दिवस\";break;case\"M\":n=\"एक महिना\";break;case\"MM\":n=\"%d महिने\";break;case\"y\":n=\"एक वर्ष\";break;case\"yy\":n=\"%d वर्षे\"}else switch(t){case\"s\":n=\"काही सेकंदां\";break;case\"m\":n=\"एका मिनिटा\";break;case\"mm\":n=\"%d मिनिटां\";break;case\"h\":n=\"एका तासा\";break;case\"hh\":n=\"%d तासां\";break;case\"d\":n=\"एका दिवसा\";break;case\"dd\":n=\"%d दिवसां\";break;case\"M\":n=\"एका महिन्या\";break;case\"MM\":n=\"%d महिन्यां\";break;case\"y\":n=\"एका वर्षा\";break;case\"yy\":n=\"%d वर्षां\"}return n.replace(/%d/i,e)}function Xs(e){return e%10<5&&e%10>1&&~~(e/10)%10!=1}function en(e,a,t){var s=e+\" \";switch(t){case\"m\":return a?\"minuta\":\"minutę\";case\"mm\":return s+(Xs(e)?\"minuty\":\"minut\");case\"h\":return a?\"godzina\":\"godzinę\";case\"hh\":return s+(Xs(e)?\"godziny\":\"godzin\");case\"MM\":return s+(Xs(e)?\"miesiące\":\"miesięcy\");case\"yy\":return s+(Xs(e)?\"lata\":\"lat\")}}function an(e,a,t){var s={mm:\"minute\",hh:\"ore\",dd:\"zile\",MM:\"luni\",yy:\"ani\"},n=\" \";return(e%100>=20||e>=100&&e%100==0)&&(n=\" de \"),e+n+s[t]}function tn(e,a){var t=e.split(\"_\");return a%10==1&&a%100!=11?t[0]:a%10>=2&&a%10<=4&&(a%100<10||a%100>=20)?t[1]:t[2]}function sn(e,a,t){var s={mm:a?\"минута_минуты_минут\":\"минуту_минуты_минут\",hh:\"час_часа_часов\",dd:\"день_дня_дней\",MM:\"месяц_месяца_месяцев\",yy:\"год_года_лет\"};return\"m\"===t?a?\"минута\":\"минуту\":e+\" \"+tn(s[t],+e)}function nn(e){return e>1&&e<5}function rn(e,a,t,s){var n=e+\" \";switch(t){case\"s\":return a||s?\"pár sekúnd\":\"pár sekundami\";case\"m\":return a?\"minúta\":s?\"minútu\":\"minútou\";case\"mm\":return a||s?n+(nn(e)?\"minúty\":\"minút\"):n+\"minútami\";case\"h\":return a?\"hodina\":s?\"hodinu\":\"hodinou\";case\"hh\":return a||s?n+(nn(e)?\"hodiny\":\"hodín\"):n+\"hodinami\";case\"d\":return a||s?\"deň\":\"dňom\";case\"dd\":return a||s?n+(nn(e)?\"dni\":\"dní\"):n+\"dňami\";case\"M\":return a||s?\"mesiac\":\"mesiacom\";case\"MM\":return a||s?n+(nn(e)?\"mesiace\":\"mesiacov\"):n+\"mesiacmi\";case\"y\":return a||s?\"rok\":\"rokom\";case\"yy\":return a||s?n+(nn(e)?\"roky\":\"rokov\"):n+\"rokmi\"}}function dn(e,a,t,s){var n=e+\" \";switch(t){case\"s\":return a||s?\"nekaj sekund\":\"nekaj sekundami\";case\"m\":return a?\"ena minuta\":\"eno minuto\";case\"mm\":return n+=1===e?a?\"minuta\":\"minuto\":2===e?a||s?\"minuti\":\"minutama\":e<5?a||s?\"minute\":\"minutami\":a||s?\"minut\":\"minutami\";case\"h\":return a?\"ena ura\":\"eno uro\";case\"hh\":return n+=1===e?a?\"ura\":\"uro\":2===e?a||s?\"uri\":\"urama\":e<5?a||s?\"ure\":\"urami\":a||s?\"ur\":\"urami\";case\"d\":return a||s?\"en dan\":\"enim dnem\";case\"dd\":return n+=1===e?a||s?\"dan\":\"dnem\":2===e?a||s?\"dni\":\"dnevoma\":a||s?\"dni\":\"dnevi\";case\"M\":return a||s?\"en mesec\":\"enim mesecem\";case\"MM\":return n+=1===e?a||s?\"mesec\":\"mesecem\":2===e?a||s?\"meseca\":\"mesecema\":e<5?a||s?\"mesece\":\"meseci\":a||s?\"mesecev\":\"meseci\";case\"y\":return a||s?\"eno leto\":\"enim letom\";case\"yy\":return n+=1===e?a||s?\"leto\":\"letom\":2===e?a||s?\"leti\":\"letoma\":e<5?a||s?\"leta\":\"leti\":a||s?\"let\":\"leti\"}}function _n(e){var a=e;return a=-1!==e.indexOf(\"jaj\")?a.slice(0,-3)+\"leS\":-1!==e.indexOf(\"jar\")?a.slice(0,-3)+\"waQ\":-1!==e.indexOf(\"DIS\")?a.slice(0,-3)+\"nem\":a+\" pIq\"}function on(e){var a=e;return a=-1!==e.indexOf(\"jaj\")?a.slice(0,-3)+\"Hu’\":-1!==e.indexOf(\"jar\")?a.slice(0,-3)+\"wen\":-1!==e.indexOf(\"DIS\")?a.slice(0,-3)+\"ben\":a+\" ret\"}function mn(e,a,t,s){var n=un(e);switch(t){case\"mm\":return n+\" tup\";case\"hh\":return n+\" rep\";case\"dd\":return n+\" jaj\";case\"MM\":return n+\" jar\";case\"yy\":return n+\" DIS\"}}function un(e){var a=Math.floor(e%1e3/100),t=Math.floor(e%100/10),s=e%10,n=\"\";return a>0&&(n+=R_[a]+\"vatlh\"),t>0&&(n+=(\"\"!==n?\" \":\"\")+R_[t]+\"maH\"),s>0&&(n+=(\"\"!==n?\" \":\"\")+R_[s]),\"\"===n?\"pagh\":n}function ln(e,a,t,s){var n={s:[\"viensas secunds\",\"'iensas secunds\"],m:[\"'n míut\",\"'iens míut\"],mm:[e+\" míuts\",e+\" míuts\"],h:[\"'n þora\",\"'iensa þora\"],hh:[e+\" þoras\",e+\" þoras\"],d:[\"'n ziua\",\"'iensa ziua\"],dd:[e+\" ziuas\",e+\" ziuas\"],M:[\"'n mes\",\"'iens mes\"],MM:[e+\" mesen\",e+\" mesen\"],y:[\"'n ar\",\"'iens ar\"],yy:[e+\" ars\",e+\" ars\"]};return s?n[t][0]:a?n[t][0]:n[t][1]}function Mn(e,a){var t=e.split(\"_\");return a%10==1&&a%100!=11?t[0]:a%10>=2&&a%10<=4&&(a%100<10||a%100>=20)?t[1]:t[2]}function hn(e,a,t){var s={mm:a?\"хвилина_хвилини_хвилин\":\"хвилину_хвилини_хвилин\",hh:a?\"година_години_годин\":\"годину_години_годин\",dd:\"день_дні_днів\",MM:\"місяць_місяці_місяців\",yy:\"рік_роки_років\"};return\"m\"===t?a?\"хвилина\":\"хвилину\":\"h\"===t?a?\"година\":\"годину\":e+\" \"+Mn(s[t],+e)}function Ln(e,a){var t={nominative:\"неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота\".split(\"_\"),accusative:\"неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу\".split(\"_\"),genitive:\"неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи\".split(\"_\")};return e?t[/(\\[[ВвУу]\\]) ?dddd/.test(a)?\"accusative\":/\\[?(?:минулої|наступної)? ?\\] ?dddd/.test(a)?\"genitive\":\"nominative\"][e.day()]:t.nominative}function cn(e){return function(){return e+\"о\"+(11===this.hours()?\"б\":\"\")+\"] LT\"}}var Yn,yn;yn=Array.prototype.some?Array.prototype.some:function(e){for(var a=Object(this),t=a.length>>>0,s=0;s<t;s++)if(s in a&&e.call(this,a[s],s,a))return!0;return!1};var fn=yn,pn=e.momentProperties=[],Dn=!1,kn={};e.suppressDeprecationWarnings=!1,e.deprecationHandler=null;var Tn;Tn=Object.keys?Object.keys:function(e){var a,t=[];for(a in e)i(e,a)&&t.push(a);return t};var gn,wn=Tn,vn={sameDay:\"[Today at] LT\",nextDay:\"[Tomorrow at] LT\",nextWeek:\"dddd [at] LT\",lastDay:\"[Yesterday at] LT\",lastWeek:\"[Last] dddd [at] LT\",sameElse:\"L\"},Hn={LTS:\"h:mm:ss A\",LT:\"h:mm A\",L:\"MM/DD/YYYY\",LL:\"MMMM D, YYYY\",LLL:\"MMMM D, YYYY h:mm A\",LLLL:\"dddd, MMMM D, YYYY h:mm A\"},Sn=/\\d{1,2}/,bn={future:\"in %s\",past:\"%s ago\",s:\"a few seconds\",ss:\"%d seconds\",m:\"a minute\",mm:\"%d minutes\",h:\"an hour\",hh:\"%d hours\",d:\"a day\",dd:\"%d days\",M:\"a month\",MM:\"%d months\",y:\"a year\",yy:\"%d years\"},jn={},xn={},Pn=/(\\[[^\\[]*\\])|(\\\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,On=/(\\[[^\\[]*\\])|(\\\\)?(LTS|LT|LL?L?L?|l{1,4})/g,Wn={},En={},An=/\\d/,Fn=/\\d\\d/,zn=/\\d{3}/,Jn=/\\d{4}/,Rn=/[+-]?\\d{6}/,Nn=/\\d\\d?/,Cn=/\\d\\d\\d\\d?/,In=/\\d\\d\\d\\d\\d\\d?/,Gn=/\\d{1,3}/,Un=/\\d{1,4}/,Vn=/[+-]?\\d{1,6}/,$n=/\\d+/,Kn=/[+-]?\\d+/,Zn=/Z|[+-]\\d\\d:?\\d\\d/gi,qn=/Z|[+-]\\d\\d(?::?\\d\\d)?/gi,Bn=/[+-]?\\d+(\\.\\d{1,3})?/,Qn=/[0-9]*['a-z\\u00A0-\\u05FF\\u0700-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]+|[\\u0600-\\u06FF\\/]+(\\s*?[\\u0600-\\u06FF]+){1,2}/i,Xn={},er={},ar=0,tr=1,sr=2,nr=3,rr=4,dr=5,_r=6,ir=7,or=8;gn=Array.prototype.indexOf?Array.prototype.indexOf:function(e){var a;for(a=0;a<this.length;++a)if(this[a]===e)return a;return-1};var mr=gn;U(\"M\",[\"MM\",2],\"Mo\",function(){return this.month()+1}),U(\"MMM\",0,0,function(e){return this.localeData().monthsShort(this,e)}),U(\"MMMM\",0,0,function(e){return this.localeData().months(this,e)}),W(\"month\",\"M\"),F(\"month\",8),q(\"M\",Nn),q(\"MM\",Nn,Fn),q(\"MMM\",function(e,a){return a.monthsShortRegex(e)}),q(\"MMMM\",function(e,a){return a.monthsRegex(e)}),ee([\"M\",\"MM\"],function(e,a){a[tr]=f(e)-1}),ee([\"MMM\",\"MMMM\"],function(e,a,t,s){var n=t._locale.monthsParse(e,s,t._strict);null!=n?a[tr]=n:l(t).invalidMonth=e});var ur=/D[oD]?(\\[[^\\[\\]]*\\]|\\s)+MMMM?/,lr=\"January_February_March_April_May_June_July_August_September_October_November_December\".split(\"_\"),Mr=\"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec\".split(\"_\"),hr=Qn,Lr=Qn;U(\"Y\",0,0,function(){var e=this.year();return e<=9999?\"\"+e:\"+\"+e}),U(0,[\"YY\",2],0,function(){return this.year()%100}),U(0,[\"YYYY\",4],0,\"year\"),U(0,[\"YYYYY\",5],0,\"year\"),U(0,[\"YYYYYY\",6,!0],0,\"year\"),W(\"year\",\"y\"),F(\"year\",1),q(\"Y\",Kn),q(\"YY\",Nn,Fn),q(\"YYYY\",Un,Jn),q(\"YYYYY\",Vn,Rn),q(\"YYYYYY\",Vn,Rn),ee([\"YYYYY\",\"YYYYYY\"],ar),ee(\"YYYY\",function(a,t){t[ar]=2===a.length?e.parseTwoDigitYear(a):f(a)}),ee(\"YY\",function(a,t){t[ar]=e.parseTwoDigitYear(a)}),ee(\"Y\",function(e,a){a[ar]=parseInt(e,10)}),e.parseTwoDigitYear=function(e){return f(e)+(f(e)>68?1900:2e3)};var cr=J(\"FullYear\",!0);U(\"w\",[\"ww\",2],\"wo\",\"week\"),U(\"W\",[\"WW\",2],\"Wo\",\"isoWeek\"),W(\"week\",\"w\"),W(\"isoWeek\",\"W\"),F(\"week\",5),F(\"isoWeek\",5),q(\"w\",Nn),q(\"ww\",Nn,Fn),q(\"W\",Nn),q(\"WW\",Nn,Fn),ae([\"w\",\"ww\",\"W\",\"WW\"],function(e,a,t,s){a[s.substr(0,1)]=f(e)});var Yr={dow:0,doy:6};U(\"d\",0,\"do\",\"day\"),U(\"dd\",0,0,function(e){return this.localeData().weekdaysMin(this,e)}),U(\"ddd\",0,0,function(e){return this.localeData().weekdaysShort(this,e)}),U(\"dddd\",0,0,function(e){return this.localeData().weekdays(this,e)}),U(\"e\",0,0,\"weekday\"),U(\"E\",0,0,\"isoWeekday\"),W(\"day\",\"d\"),W(\"weekday\",\"e\"),W(\"isoWeekday\",\"E\"),F(\"day\",11),F(\"weekday\",11),F(\"isoWeekday\",11),q(\"d\",Nn),q(\"e\",Nn),q(\"E\",Nn),q(\"dd\",function(e,a){return a.weekdaysMinRegex(e)}),q(\"ddd\",function(e,a){return a.weekdaysShortRegex(e)}),q(\"dddd\",function(e,a){return a.weekdaysRegex(e)}),ae([\"dd\",\"ddd\",\"dddd\"],function(e,a,t,s){var n=t._locale.weekdaysParse(e,s,t._strict);null!=n?a.d=n:l(t).invalidWeekday=e}),ae([\"d\",\"e\",\"E\"],function(e,a,t,s){a[s]=f(e)});var yr=\"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday\".split(\"_\"),fr=\"Sun_Mon_Tue_Wed_Thu_Fri_Sat\".split(\"_\"),pr=\"Su_Mo_Tu_We_Th_Fr_Sa\".split(\"_\"),Dr=Qn,kr=Qn,Tr=Qn;U(\"H\",[\"HH\",2],0,\"hour\"),U(\"h\",[\"hh\",2],0,Ce),U(\"k\",[\"kk\",2],0,Ie),U(\"hmm\",0,0,function(){return\"\"+Ce.apply(this)+G(this.minutes(),2)}),U(\"hmmss\",0,0,function(){return\"\"+Ce.apply(this)+G(this.minutes(),2)+G(this.seconds(),2)}),U(\"Hmm\",0,0,function(){return\"\"+this.hours()+G(this.minutes(),2)}),U(\"Hmmss\",0,0,function(){return\"\"+this.hours()+G(this.minutes(),2)+G(this.seconds(),2)}),Ge(\"a\",!0),Ge(\"A\",!1),W(\"hour\",\"h\"),F(\"hour\",13),q(\"a\",Ue),q(\"A\",Ue),q(\"H\",Nn),q(\"h\",Nn),q(\"k\",Nn),q(\"HH\",Nn,Fn),q(\"hh\",Nn,Fn),q(\"kk\",Nn,Fn),q(\"hmm\",Cn),q(\"hmmss\",In),q(\"Hmm\",Cn),q(\"Hmmss\",In),ee([\"H\",\"HH\"],nr),ee([\"k\",\"kk\"],function(e,a,t){var s=f(e);a[nr]=24===s?0:s}),ee([\"a\",\"A\"],function(e,a,t){t._isPm=t._locale.isPM(e),t._meridiem=e}),ee([\"h\",\"hh\"],function(e,a,t){a[nr]=f(e),l(t).bigHour=!0}),ee(\"hmm\",function(e,a,t){var s=e.length-2;a[nr]=f(e.substr(0,s)),a[rr]=f(e.substr(s)),l(t).bigHour=!0}),ee(\"hmmss\",function(e,a,t){var s=e.length-4,n=e.length-2;a[nr]=f(e.substr(0,s)),a[rr]=f(e.substr(s,2)),a[dr]=f(e.substr(n)),l(t).bigHour=!0}),ee(\"Hmm\",function(e,a,t){var s=e.length-2;a[nr]=f(e.substr(0,s)),a[rr]=f(e.substr(s))}),ee(\"Hmmss\",function(e,a,t){var s=e.length-4,n=e.length-2;a[nr]=f(e.substr(0,s)),a[rr]=f(e.substr(s,2)),a[dr]=f(e.substr(n))});var gr,wr=/[ap]\\.?m?\\.?/i,vr=J(\"Hours\",!0),Hr={calendar:vn,longDateFormat:Hn,invalidDate:\"Invalid date\",ordinal:\"%d\",dayOfMonthOrdinalParse:Sn,relativeTime:bn,months:lr,monthsShort:Mr,week:Yr,weekdays:yr,weekdaysMin:pr,weekdaysShort:fr,meridiemParse:wr},Sr={},br={},jr=/^\\s*((?:[+-]\\d{6}|\\d{4})-(?:\\d\\d-\\d\\d|W\\d\\d-\\d|W\\d\\d|\\d\\d\\d|\\d\\d))(?:(T| )(\\d\\d(?::\\d\\d(?::\\d\\d(?:[.,]\\d+)?)?)?)([\\+\\-]\\d\\d(?::?\\d\\d)?|\\s*Z)?)?$/,xr=/^\\s*((?:[+-]\\d{6}|\\d{4})(?:\\d\\d\\d\\d|W\\d\\d\\d|W\\d\\d|\\d\\d\\d|\\d\\d))(?:(T| )(\\d\\d(?:\\d\\d(?:\\d\\d(?:[.,]\\d+)?)?)?)([\\+\\-]\\d\\d(?::?\\d\\d)?|\\s*Z)?)?$/,Pr=/Z|[+-]\\d\\d(?::?\\d\\d)?/,Or=[[\"YYYYYY-MM-DD\",/[+-]\\d{6}-\\d\\d-\\d\\d/],[\"YYYY-MM-DD\",/\\d{4}-\\d\\d-\\d\\d/],[\"GGGG-[W]WW-E\",/\\d{4}-W\\d\\d-\\d/],[\"GGGG-[W]WW\",/\\d{4}-W\\d\\d/,!1],[\"YYYY-DDD\",/\\d{4}-\\d{3}/],[\"YYYY-MM\",/\\d{4}-\\d\\d/,!1],[\"YYYYYYMMDD\",/[+-]\\d{10}/],[\"YYYYMMDD\",/\\d{8}/],[\"GGGG[W]WWE\",/\\d{4}W\\d{3}/],[\"GGGG[W]WW\",/\\d{4}W\\d{2}/,!1],[\"YYYYDDD\",/\\d{7}/]],Wr=[[\"HH:mm:ss.SSSS\",/\\d\\d:\\d\\d:\\d\\d\\.\\d+/],[\"HH:mm:ss,SSSS\",/\\d\\d:\\d\\d:\\d\\d,\\d+/],[\"HH:mm:ss\",/\\d\\d:\\d\\d:\\d\\d/],[\"HH:mm\",/\\d\\d:\\d\\d/],[\"HHmmss.SSSS\",/\\d\\d\\d\\d\\d\\d\\.\\d+/],[\"HHmmss,SSSS\",/\\d\\d\\d\\d\\d\\d,\\d+/],[\"HHmmss\",/\\d\\d\\d\\d\\d\\d/],[\"HHmm\",/\\d\\d\\d\\d/],[\"HH\",/\\d\\d/]],Er=/^\\/?Date\\((\\-?\\d+)/i,Ar=/^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\\s)?(\\d?\\d\\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\\s(?:\\d\\d)?\\d\\d\\s)(\\d\\d:\\d\\d)(\\:\\d\\d)?(\\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\\d{4}))$/;e.createFromInputFallback=k(\"value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.\",function(e){e._d=new Date(e._i+(e._useUTC?\" UTC\":\"\"))}),e.ISO_8601=function(){},e.RFC_2822=function(){};var Fr=k(\"moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/\",function(){var e=ya.apply(null,arguments);return this.isValid()&&e.isValid()?e<this?this:e:h()}),zr=k(\"moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/\",function(){var e=ya.apply(null,arguments);return this.isValid()&&e.isValid()?e>this?this:e:h()}),Jr=function(){return Date.now?Date.now():+new Date},Rr=[\"year\",\"quarter\",\"month\",\"week\",\"day\",\"hour\",\"minute\",\"second\",\"millisecond\"];Sa(\"Z\",\":\"),Sa(\"ZZ\",\"\"),q(\"Z\",qn),q(\"ZZ\",qn),ee([\"Z\",\"ZZ\"],function(e,a,t){t._useUTC=!0,t._tzm=ba(qn,e)});var Nr=/([\\+\\-]|\\d\\d)/gi;e.updateOffset=function(){};var Cr=/^(\\-)?(?:(\\d*)[. ])?(\\d+)\\:(\\d+)(?:\\:(\\d+)(\\.\\d*)?)?$/,Ir=/^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;Ia.fn=wa.prototype,Ia.invalid=ga;var Gr=$a(1,\"add\"),Ur=$a(-1,\"subtract\");e.defaultFormat=\"YYYY-MM-DDTHH:mm:ssZ\",e.defaultFormatUtc=\"YYYY-MM-DDTHH:mm:ss[Z]\";var Vr=k(\"moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.\",function(e){return void 0===e?this.localeData():this.locale(e)});U(0,[\"gg\",2],0,function(){return this.weekYear()%100}),U(0,[\"GG\",2],0,function(){return this.isoWeekYear()%100}),St(\"gggg\",\"weekYear\"),St(\"ggggg\",\"weekYear\"),St(\"GGGG\",\"isoWeekYear\"),St(\"GGGGG\",\"isoWeekYear\"),W(\"weekYear\",\"gg\"),W(\"isoWeekYear\",\"GG\"),F(\"weekYear\",1),F(\"isoWeekYear\",1),q(\"G\",Kn),q(\"g\",Kn),q(\"GG\",Nn,Fn),q(\"gg\",Nn,Fn),q(\"GGGG\",Un,Jn),q(\"gggg\",Un,Jn),q(\"GGGGG\",Vn,Rn),q(\"ggggg\",Vn,Rn),ae([\"gggg\",\"ggggg\",\"GGGG\",\"GGGGG\"],function(e,a,t,s){a[s.substr(0,2)]=f(e)}),ae([\"gg\",\"GG\"],function(a,t,s,n){t[n]=e.parseTwoDigitYear(a)}),U(\"Q\",0,\"Qo\",\"quarter\"),W(\"quarter\",\"Q\"),F(\"quarter\",7),q(\"Q\",An),ee(\"Q\",function(e,a){a[tr]=3*(f(e)-1)}),U(\"D\",[\"DD\",2],\"Do\",\"date\"),W(\"date\",\"D\"),F(\"date\",9),q(\"D\",Nn),q(\"DD\",Nn,Fn),q(\"Do\",function(e,a){return e?a._dayOfMonthOrdinalParse||a._ordinalParse:a._dayOfMonthOrdinalParseLenient}),ee([\"D\",\"DD\"],sr),ee(\"Do\",function(e,a){a[sr]=f(e.match(Nn)[0],10)});var $r=J(\"Date\",!0);U(\"DDD\",[\"DDDD\",3],\"DDDo\",\"dayOfYear\"),W(\"dayOfYear\",\"DDD\"),F(\"dayOfYear\",4),q(\"DDD\",Gn),q(\"DDDD\",zn),ee([\"DDD\",\"DDDD\"],function(e,a,t){t._dayOfYear=f(e)}),U(\"m\",[\"mm\",2],0,\"minute\"),W(\"minute\",\"m\"),F(\"minute\",14),q(\"m\",Nn),q(\"mm\",Nn,Fn),ee([\"m\",\"mm\"],rr);var Kr=J(\"Minutes\",!1);U(\"s\",[\"ss\",2],0,\"second\"),W(\"second\",\"s\"),F(\"second\",15),q(\"s\",Nn),q(\"ss\",Nn,Fn),ee([\"s\",\"ss\"],dr);var Zr=J(\"Seconds\",!1);U(\"S\",0,0,function(){return~~(this.millisecond()/100)}),U(0,[\"SS\",2],0,function(){return~~(this.millisecond()/10)}),U(0,[\"SSS\",3],0,\"millisecond\"),U(0,[\"SSSS\",4],0,function(){return 10*this.millisecond()}),U(0,[\"SSSSS\",5],0,function(){return 100*this.millisecond()}),U(0,[\"SSSSSS\",6],0,function(){return 1e3*this.millisecond()}),U(0,[\"SSSSSSS\",7],0,function(){return 1e4*this.millisecond()}),U(0,[\"SSSSSSSS\",8],0,function(){return 1e5*this.millisecond()}),U(0,[\"SSSSSSSSS\",9],0,function(){return 1e6*this.millisecond()}),W(\"millisecond\",\"ms\"),F(\"millisecond\",16),q(\"S\",Gn,An),q(\"SS\",Gn,Fn),q(\"SSS\",Gn,zn);var qr;for(qr=\"SSSS\";qr.length<=9;qr+=\"S\")q(qr,$n);for(qr=\"S\";qr.length<=9;qr+=\"S\")ee(qr,Ft);var Br=J(\"Milliseconds\",!1);U(\"z\",0,0,\"zoneAbbr\"),U(\"zz\",0,0,\"zoneName\");var Qr=c.prototype;Qr.add=Gr,Qr.calendar=qa,Qr.clone=Ba,Qr.diff=nt,Qr.endOf=Yt,Qr.format=ot,Qr.from=mt,Qr.fromNow=ut,Qr.to=lt,Qr.toNow=Mt,Qr.get=C,Qr.invalidAt=vt,Qr.isAfter=Qa,Qr.isBefore=Xa,Qr.isBetween=et,Qr.isSame=at,Qr.isSameOrAfter=tt,Qr.isSameOrBefore=st,Qr.isValid=gt,Qr.lang=Vr,Qr.locale=ht,Qr.localeData=Lt,Qr.max=zr,Qr.min=Fr,Qr.parsingFlags=wt,Qr.set=I,Qr.startOf=ct,Qr.subtract=Ur,Qr.toArray=Dt,Qr.toObject=kt,Qr.toDate=pt,Qr.toISOString=_t,Qr.inspect=it,Qr.toJSON=Tt,Qr.toString=dt,Qr.unix=ft,Qr.valueOf=yt,Qr.creationData=Ht,Qr.year=cr,Qr.isLeapYear=ce,Qr.weekYear=bt,Qr.isoWeekYear=jt,Qr.quarter=Qr.quarters=Et,Qr.month=oe,Qr.daysInMonth=me,Qr.week=Qr.weeks=ve,Qr.isoWeek=Qr.isoWeeks=He,Qr.weeksInYear=Pt,Qr.isoWeeksInYear=xt,Qr.date=$r,Qr.day=Qr.days=Ee,Qr.weekday=Ae,Qr.isoWeekday=Fe,Qr.dayOfYear=At,Qr.hour=Qr.hours=vr,Qr.minute=Qr.minutes=Kr,Qr.second=Qr.seconds=Zr,Qr.millisecond=Qr.milliseconds=Br,Qr.utcOffset=Pa,Qr.utc=Wa,Qr.local=Ea,Qr.parseZone=Aa,Qr.hasAlignedHourOffset=Fa,Qr.isDST=za,Qr.isLocal=Ra,Qr.isUtcOffset=Na,Qr.isUtc=Ca,Qr.isUTC=Ca,Qr.zoneAbbr=zt,Qr.zoneName=Jt,Qr.dates=k(\"dates accessor is deprecated. Use date instead.\",$r),Qr.months=k(\"months accessor is deprecated. Use month instead\",oe),Qr.years=k(\"years accessor is deprecated. Use year instead\",cr),Qr.zone=k(\"moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/\",Oa),Qr.isDSTShifted=k(\"isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information\",Ja);var Xr=H.prototype;Xr.calendar=S,Xr.longDateFormat=b,Xr.invalidDate=j,Xr.ordinal=x,Xr.preparse=Ct,Xr.postformat=Ct,Xr.relativeTime=P,Xr.pastFuture=O,Xr.set=w,Xr.months=ne,Xr.monthsShort=re,Xr.monthsParse=_e,Xr.monthsRegex=le,Xr.monthsShortRegex=ue,Xr.week=Te,Xr.firstDayOfYear=we,Xr.firstDayOfWeek=ge,Xr.weekdays=je,Xr.weekdaysMin=Pe,Xr.weekdaysShort=xe,Xr.weekdaysParse=We,Xr.weekdaysRegex=ze,Xr.weekdaysShortRegex=Je,Xr.weekdaysMinRegex=Re,Xr.isPM=Ve,Xr.meridiem=$e,Be(\"en\",{dayOfMonthOrdinalParse:/\\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var a=e%10;return e+(1===f(e%100/10)?\"th\":1===a?\"st\":2===a?\"nd\":3===a?\"rd\":\"th\")}}),e.lang=k(\"moment.lang is deprecated. Use moment.locale instead.\",Be),e.langData=k(\"moment.langData is deprecated. Use moment.localeData instead.\",ea);var ed=Math.abs,ad=_s(\"ms\"),td=_s(\"s\"),sd=_s(\"m\"),nd=_s(\"h\"),rd=_s(\"d\"),dd=_s(\"w\"),_d=_s(\"M\"),id=_s(\"y\"),od=os(\"milliseconds\"),md=os(\"seconds\"),ud=os(\"minutes\"),ld=os(\"hours\"),Md=os(\"days\"),hd=os(\"months\"),Ld=os(\"years\"),cd=Math.round,Yd={ss:44,s:45,m:45,h:22,d:26,M:11},yd=Math.abs,fd=wa.prototype;fd.isValid=Ta,fd.abs=Bt,fd.add=Xt,fd.subtract=es,fd.as=rs,fd.asMilliseconds=ad,fd.asSeconds=td,fd.asMinutes=sd,fd.asHours=nd,fd.asDays=rd,fd.asWeeks=dd,fd.asMonths=_d,fd.asYears=id,fd.valueOf=ds,fd._bubble=ts,fd.get=is,fd.milliseconds=od,fd.seconds=md,fd.minutes=ud,fd.hours=ld,fd.days=Md,fd.weeks=ms,fd.months=hd,fd.years=Ld,fd.humanize=Ls,fd.toISOString=cs,fd.toString=cs,fd.toJSON=cs,fd.locale=ht,fd.localeData=Lt,fd.toIsoString=k(\"toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)\",cs),fd.lang=Vr,U(\"X\",0,0,\"unix\"),U(\"x\",0,0,\"valueOf\"),q(\"x\",Kn),q(\"X\",Bn),ee(\"X\",function(e,a,t){t._d=new Date(1e3*parseFloat(e,10))}),ee(\"x\",function(e,a,t){t._d=new Date(f(e))}),e.version=\"2.18.1\",function(e){Yn=e}(ya),e.fn=Qr,e.min=pa,e.max=Da,e.now=Jr,e.utc=m,e.unix=Rt,e.months=Vt,e.isDate=d,e.locale=Be,e.invalid=h,e.duration=Ia,e.isMoment=Y,e.weekdays=Kt,e.parseZone=Nt,e.localeData=ea,e.isDuration=va,e.monthsShort=$t,e.weekdaysMin=qt,e.defineLocale=Qe,e.updateLocale=Xe,e.locales=aa,e.weekdaysShort=Zt,e.normalizeUnits=E,e.relativeTimeRounding=Ms,e.relativeTimeThreshold=hs,e.calendarFormat=Za,e.prototype=Qr,e.defineLocale(\"af\",{months:\"Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember\".split(\"_\"),monthsShort:\"Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des\".split(\"_\"),weekdays:\"Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag\".split(\"_\"),weekdaysShort:\"Son_Maa_Din_Woe_Don_Vry_Sat\".split(\"_\"),weekdaysMin:\"So_Ma_Di_Wo_Do_Vr_Sa\".split(\"_\"),meridiemParse:/vm|nm/i,isPM:function(e){return/^nm$/i.test(e)},meridiem:function(e,a,t){return e<12?t?\"vm\":\"VM\":t?\"nm\":\"NM\"},longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Vandag om] LT\",nextDay:\"[Môre om] LT\",nextWeek:\"dddd [om] LT\",lastDay:\"[Gister om] LT\",lastWeek:\"[Laas] dddd [om] LT\",sameElse:\"L\"},relativeTime:{future:\"oor %s\",past:\"%s gelede\",s:\"'n paar sekondes\",m:\"'n minuut\",\nmm:\"%d minute\",h:\"'n uur\",hh:\"%d ure\",d:\"'n dag\",dd:\"%d dae\",M:\"'n maand\",MM:\"%d maande\",y:\"'n jaar\",yy:\"%d jaar\"},dayOfMonthOrdinalParse:/\\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?\"ste\":\"de\")},week:{dow:1,doy:4}}),e.defineLocale(\"ar-dz\",{months:\"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر\".split(\"_\"),monthsShort:\"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر\".split(\"_\"),weekdays:\"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت\".split(\"_\"),weekdaysShort:\"احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت\".split(\"_\"),weekdaysMin:\"أح_إث_ثلا_أر_خم_جم_سب\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[اليوم على الساعة] LT\",nextDay:\"[غدا على الساعة] LT\",nextWeek:\"dddd [على الساعة] LT\",lastDay:\"[أمس على الساعة] LT\",lastWeek:\"dddd [على الساعة] LT\",sameElse:\"L\"},relativeTime:{future:\"في %s\",past:\"منذ %s\",s:\"ثوان\",m:\"دقيقة\",mm:\"%d دقائق\",h:\"ساعة\",hh:\"%d ساعات\",d:\"يوم\",dd:\"%d أيام\",M:\"شهر\",MM:\"%d أشهر\",y:\"سنة\",yy:\"%d سنوات\"},week:{dow:0,doy:4}}),e.defineLocale(\"ar-kw\",{months:\"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر\".split(\"_\"),monthsShort:\"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر\".split(\"_\"),weekdays:\"الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت\".split(\"_\"),weekdaysShort:\"احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت\".split(\"_\"),weekdaysMin:\"ح_ن_ث_ر_خ_ج_س\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[اليوم على الساعة] LT\",nextDay:\"[غدا على الساعة] LT\",nextWeek:\"dddd [على الساعة] LT\",lastDay:\"[أمس على الساعة] LT\",lastWeek:\"dddd [على الساعة] LT\",sameElse:\"L\"},relativeTime:{future:\"في %s\",past:\"منذ %s\",s:\"ثوان\",m:\"دقيقة\",mm:\"%d دقائق\",h:\"ساعة\",hh:\"%d ساعات\",d:\"يوم\",dd:\"%d أيام\",M:\"شهر\",MM:\"%d أشهر\",y:\"سنة\",yy:\"%d سنوات\"},week:{dow:0,doy:12}});var pd={1:\"1\",2:\"2\",3:\"3\",4:\"4\",5:\"5\",6:\"6\",7:\"7\",8:\"8\",9:\"9\",0:\"0\"},Dd=function(e){return 0===e?0:1===e?1:2===e?2:e%100>=3&&e%100<=10?3:e%100>=11?4:5},kd={s:[\"أقل من ثانية\",\"ثانية واحدة\",[\"ثانيتان\",\"ثانيتين\"],\"%d ثوان\",\"%d ثانية\",\"%d ثانية\"],m:[\"أقل من دقيقة\",\"دقيقة واحدة\",[\"دقيقتان\",\"دقيقتين\"],\"%d دقائق\",\"%d دقيقة\",\"%d دقيقة\"],h:[\"أقل من ساعة\",\"ساعة واحدة\",[\"ساعتان\",\"ساعتين\"],\"%d ساعات\",\"%d ساعة\",\"%d ساعة\"],d:[\"أقل من يوم\",\"يوم واحد\",[\"يومان\",\"يومين\"],\"%d أيام\",\"%d يومًا\",\"%d يوم\"],M:[\"أقل من شهر\",\"شهر واحد\",[\"شهران\",\"شهرين\"],\"%d أشهر\",\"%d شهرا\",\"%d شهر\"],y:[\"أقل من عام\",\"عام واحد\",[\"عامان\",\"عامين\"],\"%d أعوام\",\"%d عامًا\",\"%d عام\"]},Td=function(e){return function(a,t,s,n){var r=Dd(a),d=kd[e][Dd(a)];return 2===r&&(d=d[t?0:1]),d.replace(/%d/i,a)}},gd=[\"يناير\",\"فبراير\",\"مارس\",\"أبريل\",\"مايو\",\"يونيو\",\"يوليو\",\"أغسطس\",\"سبتمبر\",\"أكتوبر\",\"نوفمبر\",\"ديسمبر\"];e.defineLocale(\"ar-ly\",{months:gd,monthsShort:gd,weekdays:\"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت\".split(\"_\"),weekdaysShort:\"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت\".split(\"_\"),weekdaysMin:\"ح_ن_ث_ر_خ_ج_س\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"D/‏M/‏YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},meridiemParse:/ص|م/,isPM:function(e){return\"م\"===e},meridiem:function(e,a,t){return e<12?\"ص\":\"م\"},calendar:{sameDay:\"[اليوم عند الساعة] LT\",nextDay:\"[غدًا عند الساعة] LT\",nextWeek:\"dddd [عند الساعة] LT\",lastDay:\"[أمس عند الساعة] LT\",lastWeek:\"dddd [عند الساعة] LT\",sameElse:\"L\"},relativeTime:{future:\"بعد %s\",past:\"منذ %s\",s:Td(\"s\"),m:Td(\"m\"),mm:Td(\"m\"),h:Td(\"h\"),hh:Td(\"h\"),d:Td(\"d\"),dd:Td(\"d\"),M:Td(\"M\"),MM:Td(\"M\"),y:Td(\"y\"),yy:Td(\"y\")},preparse:function(e){return e.replace(/\\u200f/g,\"\").replace(/،/g,\",\")},postformat:function(e){return e.replace(/\\d/g,function(e){return pd[e]}).replace(/,/g,\"،\")},week:{dow:6,doy:12}}),e.defineLocale(\"ar-ma\",{months:\"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر\".split(\"_\"),monthsShort:\"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر\".split(\"_\"),weekdays:\"الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت\".split(\"_\"),weekdaysShort:\"احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت\".split(\"_\"),weekdaysMin:\"ح_ن_ث_ر_خ_ج_س\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[اليوم على الساعة] LT\",nextDay:\"[غدا على الساعة] LT\",nextWeek:\"dddd [على الساعة] LT\",lastDay:\"[أمس على الساعة] LT\",lastWeek:\"dddd [على الساعة] LT\",sameElse:\"L\"},relativeTime:{future:\"في %s\",past:\"منذ %s\",s:\"ثوان\",m:\"دقيقة\",mm:\"%d دقائق\",h:\"ساعة\",hh:\"%d ساعات\",d:\"يوم\",dd:\"%d أيام\",M:\"شهر\",MM:\"%d أشهر\",y:\"سنة\",yy:\"%d سنوات\"},week:{dow:6,doy:12}});var wd={1:\"١\",2:\"٢\",3:\"٣\",4:\"٤\",5:\"٥\",6:\"٦\",7:\"٧\",8:\"٨\",9:\"٩\",0:\"٠\"},vd={\"١\":\"1\",\"٢\":\"2\",\"٣\":\"3\",\"٤\":\"4\",\"٥\":\"5\",\"٦\":\"6\",\"٧\":\"7\",\"٨\":\"8\",\"٩\":\"9\",\"٠\":\"0\"};e.defineLocale(\"ar-sa\",{months:\"يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر\".split(\"_\"),monthsShort:\"يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر\".split(\"_\"),weekdays:\"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت\".split(\"_\"),weekdaysShort:\"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت\".split(\"_\"),weekdaysMin:\"ح_ن_ث_ر_خ_ج_س\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},meridiemParse:/ص|م/,isPM:function(e){return\"م\"===e},meridiem:function(e,a,t){return e<12?\"ص\":\"م\"},calendar:{sameDay:\"[اليوم على الساعة] LT\",nextDay:\"[غدا على الساعة] LT\",nextWeek:\"dddd [على الساعة] LT\",lastDay:\"[أمس على الساعة] LT\",lastWeek:\"dddd [على الساعة] LT\",sameElse:\"L\"},relativeTime:{future:\"في %s\",past:\"منذ %s\",s:\"ثوان\",m:\"دقيقة\",mm:\"%d دقائق\",h:\"ساعة\",hh:\"%d ساعات\",d:\"يوم\",dd:\"%d أيام\",M:\"شهر\",MM:\"%d أشهر\",y:\"سنة\",yy:\"%d سنوات\"},preparse:function(e){return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g,function(e){return vd[e]}).replace(/،/g,\",\")},postformat:function(e){return e.replace(/\\d/g,function(e){return wd[e]}).replace(/,/g,\"،\")},week:{dow:0,doy:6}}),e.defineLocale(\"ar-tn\",{months:\"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر\".split(\"_\"),monthsShort:\"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر\".split(\"_\"),weekdays:\"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت\".split(\"_\"),weekdaysShort:\"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت\".split(\"_\"),weekdaysMin:\"ح_ن_ث_ر_خ_ج_س\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[اليوم على الساعة] LT\",nextDay:\"[غدا على الساعة] LT\",nextWeek:\"dddd [على الساعة] LT\",lastDay:\"[أمس على الساعة] LT\",lastWeek:\"dddd [على الساعة] LT\",sameElse:\"L\"},relativeTime:{future:\"في %s\",past:\"منذ %s\",s:\"ثوان\",m:\"دقيقة\",mm:\"%d دقائق\",h:\"ساعة\",hh:\"%d ساعات\",d:\"يوم\",dd:\"%d أيام\",M:\"شهر\",MM:\"%d أشهر\",y:\"سنة\",yy:\"%d سنوات\"},week:{dow:1,doy:4}});var Hd={1:\"١\",2:\"٢\",3:\"٣\",4:\"٤\",5:\"٥\",6:\"٦\",7:\"٧\",8:\"٨\",9:\"٩\",0:\"٠\"},Sd={\"١\":\"1\",\"٢\":\"2\",\"٣\":\"3\",\"٤\":\"4\",\"٥\":\"5\",\"٦\":\"6\",\"٧\":\"7\",\"٨\":\"8\",\"٩\":\"9\",\"٠\":\"0\"},bd=function(e){return 0===e?0:1===e?1:2===e?2:e%100>=3&&e%100<=10?3:e%100>=11?4:5},jd={s:[\"أقل من ثانية\",\"ثانية واحدة\",[\"ثانيتان\",\"ثانيتين\"],\"%d ثوان\",\"%d ثانية\",\"%d ثانية\"],m:[\"أقل من دقيقة\",\"دقيقة واحدة\",[\"دقيقتان\",\"دقيقتين\"],\"%d دقائق\",\"%d دقيقة\",\"%d دقيقة\"],h:[\"أقل من ساعة\",\"ساعة واحدة\",[\"ساعتان\",\"ساعتين\"],\"%d ساعات\",\"%d ساعة\",\"%d ساعة\"],d:[\"أقل من يوم\",\"يوم واحد\",[\"يومان\",\"يومين\"],\"%d أيام\",\"%d يومًا\",\"%d يوم\"],M:[\"أقل من شهر\",\"شهر واحد\",[\"شهران\",\"شهرين\"],\"%d أشهر\",\"%d شهرا\",\"%d شهر\"],y:[\"أقل من عام\",\"عام واحد\",[\"عامان\",\"عامين\"],\"%d أعوام\",\"%d عامًا\",\"%d عام\"]},xd=function(e){return function(a,t,s,n){var r=bd(a),d=jd[e][bd(a)];return 2===r&&(d=d[t?0:1]),d.replace(/%d/i,a)}},Pd=[\"كانون الثاني يناير\",\"شباط فبراير\",\"آذار مارس\",\"نيسان أبريل\",\"أيار مايو\",\"حزيران يونيو\",\"تموز يوليو\",\"آب أغسطس\",\"أيلول سبتمبر\",\"تشرين الأول أكتوبر\",\"تشرين الثاني نوفمبر\",\"كانون الأول ديسمبر\"];e.defineLocale(\"ar\",{months:Pd,monthsShort:Pd,weekdays:\"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت\".split(\"_\"),weekdaysShort:\"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت\".split(\"_\"),weekdaysMin:\"ح_ن_ث_ر_خ_ج_س\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"D/‏M/‏YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},meridiemParse:/ص|م/,isPM:function(e){return\"م\"===e},meridiem:function(e,a,t){return e<12?\"ص\":\"م\"},calendar:{sameDay:\"[اليوم عند الساعة] LT\",nextDay:\"[غدًا عند الساعة] LT\",nextWeek:\"dddd [عند الساعة] LT\",lastDay:\"[أمس عند الساعة] LT\",lastWeek:\"dddd [عند الساعة] LT\",sameElse:\"L\"},relativeTime:{future:\"بعد %s\",past:\"منذ %s\",s:xd(\"s\"),m:xd(\"m\"),mm:xd(\"m\"),h:xd(\"h\"),hh:xd(\"h\"),d:xd(\"d\"),dd:xd(\"d\"),M:xd(\"M\"),MM:xd(\"M\"),y:xd(\"y\"),yy:xd(\"y\")},preparse:function(e){return e.replace(/\\u200f/g,\"\").replace(/[١٢٣٤٥٦٧٨٩٠]/g,function(e){return Sd[e]}).replace(/،/g,\",\")},postformat:function(e){return e.replace(/\\d/g,function(e){return Hd[e]}).replace(/,/g,\"،\")},week:{dow:6,doy:12}});var Od={1:\"-inci\",5:\"-inci\",8:\"-inci\",70:\"-inci\",80:\"-inci\",2:\"-nci\",7:\"-nci\",20:\"-nci\",50:\"-nci\",3:\"-üncü\",4:\"-üncü\",100:\"-üncü\",6:\"-ncı\",9:\"-uncu\",10:\"-uncu\",30:\"-uncu\",60:\"-ıncı\",90:\"-ıncı\"};e.defineLocale(\"az\",{months:\"yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr\".split(\"_\"),monthsShort:\"yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek\".split(\"_\"),weekdays:\"Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə\".split(\"_\"),weekdaysShort:\"Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən\".split(\"_\"),weekdaysMin:\"Bz_BE_ÇA_Çə_CA_Cü_Şə\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[bugün saat] LT\",nextDay:\"[sabah saat] LT\",nextWeek:\"[gələn həftə] dddd [saat] LT\",lastDay:\"[dünən] LT\",lastWeek:\"[keçən həftə] dddd [saat] LT\",sameElse:\"L\"},relativeTime:{future:\"%s sonra\",past:\"%s əvvəl\",s:\"birneçə saniyyə\",m:\"bir dəqiqə\",mm:\"%d dəqiqə\",h:\"bir saat\",hh:\"%d saat\",d:\"bir gün\",dd:\"%d gün\",M:\"bir ay\",MM:\"%d ay\",y:\"bir il\",yy:\"%d il\"},meridiemParse:/gecə|səhər|gündüz|axşam/,isPM:function(e){return/^(gündüz|axşam)$/.test(e)},meridiem:function(e,a,t){return e<4?\"gecə\":e<12?\"səhər\":e<17?\"gündüz\":\"axşam\"},dayOfMonthOrdinalParse:/\\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,ordinal:function(e){if(0===e)return e+\"-ıncı\";var a=e%10,t=e%100-a,s=e>=100?100:null;return e+(Od[a]||Od[t]||Od[s])},week:{dow:1,doy:7}}),e.defineLocale(\"be\",{months:{format:\"студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня\".split(\"_\"),standalone:\"студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань\".split(\"_\")},monthsShort:\"студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж\".split(\"_\"),weekdays:{format:\"нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу\".split(\"_\"),standalone:\"нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота\".split(\"_\"),isFormat:/\\[ ?[Вв] ?(?:мінулую|наступную)? ?\\] ?dddd/},weekdaysShort:\"нд_пн_ат_ср_чц_пт_сб\".split(\"_\"),weekdaysMin:\"нд_пн_ат_ср_чц_пт_сб\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY г.\",LLL:\"D MMMM YYYY г., HH:mm\",LLLL:\"dddd, D MMMM YYYY г., HH:mm\"},calendar:{sameDay:\"[Сёння ў] LT\",nextDay:\"[Заўтра ў] LT\",lastDay:\"[Учора ў] LT\",nextWeek:function(){return\"[У] dddd [ў] LT\"},lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return\"[У мінулую] dddd [ў] LT\";case 1:case 2:case 4:return\"[У мінулы] dddd [ў] LT\"}},sameElse:\"L\"},relativeTime:{future:\"праз %s\",past:\"%s таму\",s:\"некалькі секунд\",m:ys,mm:ys,h:ys,hh:ys,d:\"дзень\",dd:ys,M:\"месяц\",MM:ys,y:\"год\",yy:ys},meridiemParse:/ночы|раніцы|дня|вечара/,isPM:function(e){return/^(дня|вечара)$/.test(e)},meridiem:function(e,a,t){return e<4?\"ночы\":e<12?\"раніцы\":e<17?\"дня\":\"вечара\"},dayOfMonthOrdinalParse:/\\d{1,2}-(і|ы|га)/,ordinal:function(e,a){switch(a){case\"M\":case\"d\":case\"DDD\":case\"w\":case\"W\":return e%10!=2&&e%10!=3||e%100==12||e%100==13?e+\"-ы\":e+\"-і\";case\"D\":return e+\"-га\";default:return e}},week:{dow:1,doy:7}}),e.defineLocale(\"bg\",{months:\"януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември\".split(\"_\"),monthsShort:\"янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек\".split(\"_\"),weekdays:\"неделя_понеделник_вторник_сряда_четвъртък_петък_събота\".split(\"_\"),weekdaysShort:\"нед_пон_вто_сря_чет_пет_съб\".split(\"_\"),weekdaysMin:\"нд_пн_вт_ср_чт_пт_сб\".split(\"_\"),longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"D.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY H:mm\",LLLL:\"dddd, D MMMM YYYY H:mm\"},calendar:{sameDay:\"[Днес в] LT\",nextDay:\"[Утре в] LT\",nextWeek:\"dddd [в] LT\",lastDay:\"[Вчера в] LT\",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return\"[В изминалата] dddd [в] LT\";case 1:case 2:case 4:case 5:return\"[В изминалия] dddd [в] LT\"}},sameElse:\"L\"},relativeTime:{future:\"след %s\",past:\"преди %s\",s:\"няколко секунди\",m:\"минута\",mm:\"%d минути\",h:\"час\",hh:\"%d часа\",d:\"ден\",dd:\"%d дни\",M:\"месец\",MM:\"%d месеца\",y:\"година\",yy:\"%d години\"},dayOfMonthOrdinalParse:/\\d{1,2}-(ев|ен|ти|ви|ри|ми)/,ordinal:function(e){var a=e%10,t=e%100;return 0===e?e+\"-ев\":0===t?e+\"-ен\":t>10&&t<20?e+\"-ти\":1===a?e+\"-ви\":2===a?e+\"-ри\":7===a||8===a?e+\"-ми\":e+\"-ти\"},week:{dow:1,doy:7}});var Wd={1:\"১\",2:\"২\",3:\"৩\",4:\"৪\",5:\"৫\",6:\"৬\",7:\"৭\",8:\"৮\",9:\"৯\",0:\"০\"},Ed={\"১\":\"1\",\"২\":\"2\",\"৩\":\"3\",\"৪\":\"4\",\"৫\":\"5\",\"৬\":\"6\",\"৭\":\"7\",\"৮\":\"8\",\"৯\":\"9\",\"০\":\"0\"};e.defineLocale(\"bn\",{months:\"জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর\".split(\"_\"),monthsShort:\"জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে\".split(\"_\"),weekdays:\"রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার\".split(\"_\"),weekdaysShort:\"রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি\".split(\"_\"),weekdaysMin:\"রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি\".split(\"_\"),longDateFormat:{LT:\"A h:mm সময়\",LTS:\"A h:mm:ss সময়\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, A h:mm সময়\",LLLL:\"dddd, D MMMM YYYY, A h:mm সময়\"},calendar:{sameDay:\"[আজ] LT\",nextDay:\"[আগামীকাল] LT\",nextWeek:\"dddd, LT\",lastDay:\"[গতকাল] LT\",lastWeek:\"[গত] dddd, LT\",sameElse:\"L\"},relativeTime:{future:\"%s পরে\",past:\"%s আগে\",s:\"কয়েক সেকেন্ড\",m:\"এক মিনিট\",mm:\"%d মিনিট\",h:\"এক ঘন্টা\",hh:\"%d ঘন্টা\",d:\"এক দিন\",dd:\"%d দিন\",M:\"এক মাস\",MM:\"%d মাস\",y:\"এক বছর\",yy:\"%d বছর\"},preparse:function(e){return e.replace(/[১২৩৪৫৬৭৮৯০]/g,function(e){return Ed[e]})},postformat:function(e){return e.replace(/\\d/g,function(e){return Wd[e]})},meridiemParse:/রাত|সকাল|দুপুর|বিকাল|রাত/,meridiemHour:function(e,a){return 12===e&&(e=0),\"রাত\"===a&&e>=4||\"দুপুর\"===a&&e<5||\"বিকাল\"===a?e+12:e},meridiem:function(e,a,t){return e<4?\"রাত\":e<10?\"সকাল\":e<17?\"দুপুর\":e<20?\"বিকাল\":\"রাত\"},week:{dow:0,doy:6}});var Ad={1:\"༡\",2:\"༢\",3:\"༣\",4:\"༤\",5:\"༥\",6:\"༦\",7:\"༧\",8:\"༨\",9:\"༩\",0:\"༠\"},Fd={\"༡\":\"1\",\"༢\":\"2\",\"༣\":\"3\",\"༤\":\"4\",\"༥\":\"5\",\"༦\":\"6\",\"༧\":\"7\",\"༨\":\"8\",\"༩\":\"9\",\"༠\":\"0\"};e.defineLocale(\"bo\",{months:\"ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ\".split(\"_\"),monthsShort:\"ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ\".split(\"_\"),weekdays:\"གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་\".split(\"_\"),weekdaysShort:\"ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་\".split(\"_\"),weekdaysMin:\"ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་\".split(\"_\"),longDateFormat:{LT:\"A h:mm\",LTS:\"A h:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, A h:mm\",LLLL:\"dddd, D MMMM YYYY, A h:mm\"},calendar:{sameDay:\"[དི་རིང] LT\",nextDay:\"[སང་ཉིན] LT\",nextWeek:\"[བདུན་ཕྲག་རྗེས་མ], LT\",lastDay:\"[ཁ་སང] LT\",lastWeek:\"[བདུན་ཕྲག་མཐའ་མ] dddd, LT\",sameElse:\"L\"},relativeTime:{future:\"%s ལ་\",past:\"%s སྔན་ལ\",s:\"ལམ་སང\",m:\"སྐར་མ་གཅིག\",mm:\"%d སྐར་མ\",h:\"ཆུ་ཚོད་གཅིག\",hh:\"%d ཆུ་ཚོད\",d:\"ཉིན་གཅིག\",dd:\"%d ཉིན་\",M:\"ཟླ་བ་གཅིག\",MM:\"%d ཟླ་བ\",y:\"ལོ་གཅིག\",yy:\"%d ལོ\"},preparse:function(e){return e.replace(/[༡༢༣༤༥༦༧༨༩༠]/g,function(e){return Fd[e]})},postformat:function(e){return e.replace(/\\d/g,function(e){return Ad[e]})},meridiemParse:/མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,meridiemHour:function(e,a){return 12===e&&(e=0),\"མཚན་མོ\"===a&&e>=4||\"ཉིན་གུང\"===a&&e<5||\"དགོང་དག\"===a?e+12:e},meridiem:function(e,a,t){return e<4?\"མཚན་མོ\":e<10?\"ཞོགས་ཀས\":e<17?\"ཉིན་གུང\":e<20?\"དགོང་དག\":\"མཚན་མོ\"},week:{dow:0,doy:6}}),e.defineLocale(\"br\",{months:\"Genver_C'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu\".split(\"_\"),monthsShort:\"Gen_C'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker\".split(\"_\"),weekdays:\"Sul_Lun_Meurzh_Merc'her_Yaou_Gwener_Sadorn\".split(\"_\"),weekdaysShort:\"Sul_Lun_Meu_Mer_Yao_Gwe_Sad\".split(\"_\"),weekdaysMin:\"Su_Lu_Me_Mer_Ya_Gw_Sa\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"h[e]mm A\",LTS:\"h[e]mm:ss A\",L:\"DD/MM/YYYY\",LL:\"D [a viz] MMMM YYYY\",LLL:\"D [a viz] MMMM YYYY h[e]mm A\",LLLL:\"dddd, D [a viz] MMMM YYYY h[e]mm A\"},calendar:{sameDay:\"[Hiziv da] LT\",nextDay:\"[Warc'hoazh da] LT\",nextWeek:\"dddd [da] LT\",lastDay:\"[Dec'h da] LT\",lastWeek:\"dddd [paset da] LT\",sameElse:\"L\"},relativeTime:{future:\"a-benn %s\",past:\"%s 'zo\",s:\"un nebeud segondennoù\",m:\"ur vunutenn\",mm:fs,h:\"un eur\",hh:\"%d eur\",d:\"un devezh\",dd:fs,M:\"ur miz\",MM:fs,y:\"ur bloaz\",yy:ps},dayOfMonthOrdinalParse:/\\d{1,2}(añ|vet)/,ordinal:function(e){return e+(1===e?\"añ\":\"vet\")},week:{dow:1,doy:4}}),e.defineLocale(\"bs\",{months:\"januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar\".split(\"_\"),monthsShort:\"jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.\".split(\"_\"),monthsParseExact:!0,weekdays:\"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota\".split(\"_\"),weekdaysShort:\"ned._pon._uto._sri._čet._pet._sub.\".split(\"_\"),weekdaysMin:\"ne_po_ut_sr_če_pe_su\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm\",LLLL:\"dddd, D. MMMM YYYY H:mm\"},calendar:{sameDay:\"[danas u] LT\",nextDay:\"[sutra u] LT\",nextWeek:function(){switch(this.day()){case 0:return\"[u] [nedjelju] [u] LT\";case 3:return\"[u] [srijedu] [u] LT\";case 6:return\"[u] [subotu] [u] LT\";case 1:case 2:case 4:case 5:return\"[u] dddd [u] LT\"}},lastDay:\"[jučer u] LT\",lastWeek:function(){switch(this.day()){case 0:case 3:return\"[prošlu] dddd [u] LT\";case 6:return\"[prošle] [subote] [u] LT\";case 1:case 2:case 4:case 5:return\"[prošli] dddd [u] LT\"}},sameElse:\"L\"},relativeTime:{future:\"za %s\",past:\"prije %s\",s:\"par sekundi\",m:gs,mm:gs,h:gs,hh:gs,d:\"dan\",dd:gs,M:\"mjesec\",MM:gs,y:\"godinu\",yy:gs},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:7}}),e.defineLocale(\"ca\",{months:{standalone:\"gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre\".split(\"_\"),format:\"de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre\".split(\"_\"),isFormat:/D[oD]?(\\s)+MMMM/},monthsShort:\"gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.\".split(\"_\"),monthsParseExact:!0,weekdays:\"diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte\".split(\"_\"),weekdaysShort:\"dg._dl._dt._dc._dj._dv._ds.\".split(\"_\"),weekdaysMin:\"Dg_Dl_Dt_Dc_Dj_Dv_Ds\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD/MM/YYYY\",LL:\"[el] D MMMM [de] YYYY\",ll:\"D MMM YYYY\",LLL:\"[el] D MMMM [de] YYYY [a les] H:mm\",lll:\"D MMM YYYY, H:mm\",LLLL:\"[el] dddd D MMMM [de] YYYY [a les] H:mm\",llll:\"ddd D MMM YYYY, H:mm\"},calendar:{sameDay:function(){return\"[avui a \"+(1!==this.hours()?\"les\":\"la\")+\"] LT\"},nextDay:function(){return\"[demà a \"+(1!==this.hours()?\"les\":\"la\")+\"] LT\"},nextWeek:function(){return\"dddd [a \"+(1!==this.hours()?\"les\":\"la\")+\"] LT\"},lastDay:function(){return\"[ahir a \"+(1!==this.hours()?\"les\":\"la\")+\"] LT\"},lastWeek:function(){return\"[el] dddd [passat a \"+(1!==this.hours()?\"les\":\"la\")+\"] LT\"},sameElse:\"L\"},relativeTime:{future:\"d'aquí %s\",past:\"fa %s\",s:\"uns segons\",m:\"un minut\",mm:\"%d minuts\",h:\"una hora\",hh:\"%d hores\",d:\"un dia\",dd:\"%d dies\",M:\"un mes\",MM:\"%d mesos\",y:\"un any\",yy:\"%d anys\"},dayOfMonthOrdinalParse:/\\d{1,2}(r|n|t|è|a)/,ordinal:function(e,a){var t=1===e?\"r\":2===e?\"n\":3===e?\"r\":4===e?\"t\":\"è\";return\"w\"!==a&&\"W\"!==a||(t=\"a\"),e+t},week:{dow:1,doy:4}});var zd=\"leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec\".split(\"_\"),Jd=\"led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro\".split(\"_\");e.defineLocale(\"cs\",{months:zd,monthsShort:Jd,monthsParse:function(e,a){var t,s=[];for(t=0;t<12;t++)s[t]=new RegExp(\"^\"+e[t]+\"$|^\"+a[t]+\"$\",\"i\");return s}(zd,Jd),shortMonthsParse:function(e){var a,t=[];for(a=0;a<12;a++)t[a]=new RegExp(\"^\"+e[a]+\"$\",\"i\");return t}(Jd),longMonthsParse:function(e){var a,t=[];for(a=0;a<12;a++)t[a]=new RegExp(\"^\"+e[a]+\"$\",\"i\");return t}(zd),weekdays:\"neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota\".split(\"_\"),weekdaysShort:\"ne_po_út_st_čt_pá_so\".split(\"_\"),weekdaysMin:\"ne_po_út_st_čt_pá_so\".split(\"_\"),longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm\",LLLL:\"dddd D. MMMM YYYY H:mm\",l:\"D. M. YYYY\"},calendar:{sameDay:\"[dnes v] LT\",nextDay:\"[zítra v] LT\",nextWeek:function(){switch(this.day()){case 0:return\"[v neděli v] LT\";case 1:case 2:return\"[v] dddd [v] LT\";case 3:return\"[ve středu v] LT\";case 4:return\"[ve čtvrtek v] LT\";case 5:return\"[v pátek v] LT\";case 6:return\"[v sobotu v] LT\"}},lastDay:\"[včera v] LT\",lastWeek:function(){switch(this.day()){case 0:return\"[minulou neděli v] LT\";case 1:case 2:return\"[minulé] dddd [v] LT\";case 3:return\"[minulou středu v] LT\";case 4:case 5:return\"[minulý] dddd [v] LT\";case 6:return\"[minulou sobotu v] LT\"}},sameElse:\"L\"},relativeTime:{future:\"za %s\",past:\"před %s\",s:vs,m:vs,mm:vs,h:vs,hh:vs,d:vs,dd:vs,M:vs,MM:vs,y:vs,yy:vs},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}}),e.defineLocale(\"cv\",{months:\"кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав\".split(\"_\"),monthsShort:\"кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш\".split(\"_\"),weekdays:\"вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун\".split(\"_\"),weekdaysShort:\"выр_тун_ытл_юн_кӗҫ_эрн_шӑм\".split(\"_\"),weekdaysMin:\"вр_тн_ыт_юн_кҫ_эр_шм\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD-MM-YYYY\",LL:\"YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]\",LLL:\"YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm\",LLLL:\"dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm\"},calendar:{sameDay:\"[Паян] LT [сехетре]\",nextDay:\"[Ыран] LT [сехетре]\",lastDay:\"[Ӗнер] LT [сехетре]\",nextWeek:\"[Ҫитес] dddd LT [сехетре]\",lastWeek:\"[Иртнӗ] dddd LT [сехетре]\",sameElse:\"L\"},relativeTime:{future:function(e){return e+(/сехет$/i.exec(e)?\"рен\":/ҫул$/i.exec(e)?\"тан\":\"ран\")},past:\"%s каялла\",s:\"пӗр-ик ҫеккунт\",m:\"пӗр минут\",mm:\"%d минут\",h:\"пӗр сехет\",hh:\"%d сехет\",d:\"пӗр кун\",dd:\"%d кун\",M:\"пӗр уйӑх\",MM:\"%d уйӑх\",y:\"пӗр ҫул\",yy:\"%d ҫул\"},dayOfMonthOrdinalParse:/\\d{1,2}-мӗш/,ordinal:\"%d-мӗш\",week:{dow:1,doy:7}}),e.defineLocale(\"cy\",{months:\"Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr\".split(\"_\"),monthsShort:\"Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag\".split(\"_\"),weekdays:\"Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn\".split(\"_\"),weekdaysShort:\"Sul_Llun_Maw_Mer_Iau_Gwe_Sad\".split(\"_\"),weekdaysMin:\"Su_Ll_Ma_Me_Ia_Gw_Sa\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Heddiw am] LT\",nextDay:\"[Yfory am] LT\",nextWeek:\"dddd [am] LT\",lastDay:\"[Ddoe am] LT\",lastWeek:\"dddd [diwethaf am] LT\",sameElse:\"L\"},relativeTime:{future:\"mewn %s\",past:\"%s yn ôl\",s:\"ychydig eiliadau\",m:\"munud\",mm:\"%d munud\",h:\"awr\",hh:\"%d awr\",d:\"diwrnod\",dd:\"%d diwrnod\",M:\"mis\",MM:\"%d mis\",y:\"blwyddyn\",yy:\"%d flynedd\"},dayOfMonthOrdinalParse:/\\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,ordinal:function(e){var a=e,t=\"\",s=[\"\",\"af\",\"il\",\"ydd\",\"ydd\",\"ed\",\"ed\",\"ed\",\"fed\",\"fed\",\"fed\",\"eg\",\"fed\",\"eg\",\"eg\",\"fed\",\"eg\",\"eg\",\"fed\",\"eg\",\"fed\"];return a>20?t=40===a||50===a||60===a||80===a||100===a?\"fed\":\"ain\":a>0&&(t=s[a]),e+t},week:{dow:1,doy:4}}),e.defineLocale(\"da\",{months:\"januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december\".split(\"_\"),monthsShort:\"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec\".split(\"_\"),weekdays:\"søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag\".split(\"_\"),weekdaysShort:\"søn_man_tir_ons_tor_fre_lør\".split(\"_\"),weekdaysMin:\"sø_ma_ti_on_to_fr_lø\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY HH:mm\",LLLL:\"dddd [d.] D. MMMM YYYY [kl.] HH:mm\"},calendar:{sameDay:\"[i dag kl.] LT\",nextDay:\"[i morgen kl.] LT\",nextWeek:\"på dddd [kl.] LT\",lastDay:\"[i går kl.] LT\",lastWeek:\"[i] dddd[s kl.] LT\",sameElse:\"L\"},relativeTime:{future:\"om %s\",past:\"%s siden\",s:\"få sekunder\",m:\"et minut\",mm:\"%d minutter\",h:\"en time\",hh:\"%d timer\",d:\"en dag\",dd:\"%d dage\",M:\"en måned\",MM:\"%d måneder\",y:\"et år\",yy:\"%d år\"},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}}),e.defineLocale(\"de-at\",{months:\"Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember\".split(\"_\"),monthsShort:\"Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.\".split(\"_\"),monthsParseExact:!0,weekdays:\"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag\".split(\"_\"),weekdaysShort:\"So._Mo._Di._Mi._Do._Fr._Sa.\".split(\"_\"),weekdaysMin:\"So_Mo_Di_Mi_Do_Fr_Sa\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY HH:mm\",LLLL:\"dddd, D. MMMM YYYY HH:mm\"},calendar:{sameDay:\"[heute um] LT [Uhr]\",sameElse:\"L\",nextDay:\"[morgen um] LT [Uhr]\",nextWeek:\"dddd [um] LT [Uhr]\",lastDay:\"[gestern um] LT [Uhr]\",lastWeek:\"[letzten] dddd [um] LT [Uhr]\"},relativeTime:{future:\"in %s\",past:\"vor %s\",s:\"ein paar Sekunden\",m:Hs,mm:\"%d Minuten\",h:Hs,hh:\"%d Stunden\",d:Hs,dd:Hs,M:Hs,MM:Hs,y:Hs,yy:Hs},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}}),e.defineLocale(\"de-ch\",{months:\"Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember\".split(\"_\"),monthsShort:\"Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.\".split(\"_\"),monthsParseExact:!0,weekdays:\"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag\".split(\"_\"),weekdaysShort:\"So_Mo_Di_Mi_Do_Fr_Sa\".split(\"_\"),weekdaysMin:\"So_Mo_Di_Mi_Do_Fr_Sa\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH.mm\",LTS:\"HH.mm.ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY HH.mm\",LLLL:\"dddd, D. MMMM YYYY HH.mm\"},calendar:{sameDay:\"[heute um] LT [Uhr]\",sameElse:\"L\",nextDay:\"[morgen um] LT [Uhr]\",nextWeek:\"dddd [um] LT [Uhr]\",lastDay:\"[gestern um] LT [Uhr]\",lastWeek:\"[letzten] dddd [um] LT [Uhr]\"},relativeTime:{future:\"in %s\",past:\"vor %s\",s:\"ein paar Sekunden\",m:Ss,mm:\"%d Minuten\",h:Ss,hh:\"%d Stunden\",d:Ss,dd:Ss,M:Ss,MM:Ss,y:Ss,yy:Ss},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}}),e.defineLocale(\"de\",{months:\"Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember\".split(\"_\"),monthsShort:\"Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.\".split(\"_\"),monthsParseExact:!0,weekdays:\"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag\".split(\"_\"),weekdaysShort:\"So._Mo._Di._Mi._Do._Fr._Sa.\".split(\"_\"),weekdaysMin:\"So_Mo_Di_Mi_Do_Fr_Sa\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY HH:mm\",LLLL:\"dddd, D. MMMM YYYY HH:mm\"},calendar:{sameDay:\"[heute um] LT [Uhr]\",sameElse:\"L\",nextDay:\"[morgen um] LT [Uhr]\",nextWeek:\"dddd [um] LT [Uhr]\",lastDay:\"[gestern um] LT [Uhr]\",lastWeek:\"[letzten] dddd [um] LT [Uhr]\"},relativeTime:{future:\"in %s\",past:\"vor %s\",s:\"ein paar Sekunden\",m:bs,mm:\"%d Minuten\",h:bs,hh:\"%d Stunden\",d:bs,dd:bs,M:bs,MM:bs,y:bs,yy:bs},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});var Rd=[\"ޖެނުއަރީ\",\"ފެބްރުއަރީ\",\"މާރިޗު\",\"އޭޕްރީލު\",\"މޭ\",\"ޖޫން\",\"ޖުލައި\",\"އޯގަސްޓު\",\"ސެޕްޓެމްބަރު\",\"އޮކްޓޯބަރު\",\"ނޮވެމްބަރު\",\"ޑިސެމްބަރު\"],Nd=[\"އާދިއްތަ\",\"ހޯމަ\",\"އަންގާރަ\",\"ބުދަ\",\"ބުރާސްފަތި\",\"ހުކުރު\",\"ހޮނިހިރު\"];e.defineLocale(\"dv\",{months:Rd,monthsShort:Rd,weekdays:Nd,weekdaysShort:Nd,weekdaysMin:\"އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"D/M/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},meridiemParse:/މކ|މފ/,isPM:function(e){return\"މފ\"===e},meridiem:function(e,a,t){return e<12?\"މކ\":\"މފ\"},calendar:{sameDay:\"[މިއަދު] LT\",nextDay:\"[މާދަމާ] LT\",nextWeek:\"dddd LT\",lastDay:\"[އިއްޔެ] LT\",lastWeek:\"[ފާއިތުވި] dddd LT\",sameElse:\"L\"},relativeTime:{future:\"ތެރޭގައި %s\",past:\"ކުރިން %s\",s:\"ސިކުންތުކޮޅެއް\",m:\"މިނިޓެއް\",mm:\"މިނިޓު %d\",h:\"ގަޑިއިރެއް\",hh:\"ގަޑިއިރު %d\",d:\"ދުވަހެއް\",dd:\"ދުވަސް %d\",M:\"މަހެއް\",MM:\"މަސް %d\",y:\"އަހަރެއް\",yy:\"އަހަރު %d\"},preparse:function(e){return e.replace(/،/g,\",\")},postformat:function(e){return e.replace(/,/g,\"،\")},week:{dow:7,doy:12}}),e.defineLocale(\"el\",{monthsNominativeEl:\"Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος\".split(\"_\"),monthsGenitiveEl:\"Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου\".split(\"_\"),months:function(e,a){return e?/D/.test(a.substring(0,a.indexOf(\"MMMM\")))?this._monthsGenitiveEl[e.month()]:this._monthsNominativeEl[e.month()]:this._monthsNominativeEl},monthsShort:\"Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ\".split(\"_\"),weekdays:\"Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο\".split(\"_\"),weekdaysShort:\"Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ\".split(\"_\"),weekdaysMin:\"Κυ_Δε_Τρ_Τε_Πε_Πα_Σα\".split(\"_\"),meridiem:function(e,a,t){return e>11?t?\"μμ\":\"ΜΜ\":t?\"πμ\":\"ΠΜ\"},isPM:function(e){return\"μ\"===(e+\"\").toLowerCase()[0]},meridiemParse:/[ΠΜ]\\.?Μ?\\.?/i,longDateFormat:{LT:\"h:mm A\",LTS:\"h:mm:ss A\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY h:mm A\",LLLL:\"dddd, D MMMM YYYY h:mm A\"},calendarEl:{sameDay:\"[Σήμερα {}] LT\",nextDay:\"[Αύριο {}] LT\",nextWeek:\"dddd [{}] LT\",lastDay:\"[Χθες {}] LT\",lastWeek:function(){switch(this.day()){case 6:return\"[το προηγούμενο] dddd [{}] LT\";default:return\"[την προηγούμενη] dddd [{}] LT\"}},sameElse:\"L\"},calendar:function(e,a){var t=this._calendarEl[e],s=a&&a.hours();return g(t)&&(t=t.apply(a)),t.replace(\"{}\",s%12==1?\"στη\":\"στις\")},relativeTime:{future:\"σε %s\",past:\"%s πριν\",s:\"λίγα δευτερόλεπτα\",m:\"ένα λεπτό\",mm:\"%d λεπτά\",h:\"μία ώρα\",hh:\"%d ώρες\",d:\"μία μέρα\",dd:\"%d μέρες\",M:\"ένας μήνας\",MM:\"%d μήνες\",y:\"ένας χρόνος\",yy:\"%d χρόνια\"},dayOfMonthOrdinalParse:/\\d{1,2}η/,ordinal:\"%dη\",week:{dow:1,doy:4}}),e.defineLocale(\"en-au\",{months:\"January_February_March_April_May_June_July_August_September_October_November_December\".split(\"_\"),monthsShort:\"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec\".split(\"_\"),weekdays:\"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday\".split(\"_\"),weekdaysShort:\"Sun_Mon_Tue_Wed_Thu_Fri_Sat\".split(\"_\"),weekdaysMin:\"Su_Mo_Tu_We_Th_Fr_Sa\".split(\"_\"),longDateFormat:{LT:\"h:mm A\",LTS:\"h:mm:ss A\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY h:mm A\",LLLL:\"dddd, D MMMM YYYY h:mm A\"},calendar:{sameDay:\"[Today at] LT\",nextDay:\"[Tomorrow at] LT\",nextWeek:\"dddd [at] LT\",lastDay:\"[Yesterday at] LT\",lastWeek:\"[Last] dddd [at] LT\",sameElse:\"L\"},relativeTime:{future:\"in %s\",past:\"%s ago\",s:\"a few seconds\",m:\"a minute\",mm:\"%d minutes\",h:\"an hour\",hh:\"%d hours\",d:\"a day\",dd:\"%d days\",M:\"a month\",MM:\"%d months\",y:\"a year\",yy:\"%d years\"},dayOfMonthOrdinalParse:/\\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?\"th\":1===a?\"st\":2===a?\"nd\":3===a?\"rd\":\"th\")},week:{dow:1,doy:4}}),e.defineLocale(\"en-ca\",{\nmonths:\"January_February_March_April_May_June_July_August_September_October_November_December\".split(\"_\"),monthsShort:\"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec\".split(\"_\"),weekdays:\"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday\".split(\"_\"),weekdaysShort:\"Sun_Mon_Tue_Wed_Thu_Fri_Sat\".split(\"_\"),weekdaysMin:\"Su_Mo_Tu_We_Th_Fr_Sa\".split(\"_\"),longDateFormat:{LT:\"h:mm A\",LTS:\"h:mm:ss A\",L:\"YYYY-MM-DD\",LL:\"MMMM D, YYYY\",LLL:\"MMMM D, YYYY h:mm A\",LLLL:\"dddd, MMMM D, YYYY h:mm A\"},calendar:{sameDay:\"[Today at] LT\",nextDay:\"[Tomorrow at] LT\",nextWeek:\"dddd [at] LT\",lastDay:\"[Yesterday at] LT\",lastWeek:\"[Last] dddd [at] LT\",sameElse:\"L\"},relativeTime:{future:\"in %s\",past:\"%s ago\",s:\"a few seconds\",m:\"a minute\",mm:\"%d minutes\",h:\"an hour\",hh:\"%d hours\",d:\"a day\",dd:\"%d days\",M:\"a month\",MM:\"%d months\",y:\"a year\",yy:\"%d years\"},dayOfMonthOrdinalParse:/\\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?\"th\":1===a?\"st\":2===a?\"nd\":3===a?\"rd\":\"th\")}}),e.defineLocale(\"en-gb\",{months:\"January_February_March_April_May_June_July_August_September_October_November_December\".split(\"_\"),monthsShort:\"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec\".split(\"_\"),weekdays:\"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday\".split(\"_\"),weekdaysShort:\"Sun_Mon_Tue_Wed_Thu_Fri_Sat\".split(\"_\"),weekdaysMin:\"Su_Mo_Tu_We_Th_Fr_Sa\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Today at] LT\",nextDay:\"[Tomorrow at] LT\",nextWeek:\"dddd [at] LT\",lastDay:\"[Yesterday at] LT\",lastWeek:\"[Last] dddd [at] LT\",sameElse:\"L\"},relativeTime:{future:\"in %s\",past:\"%s ago\",s:\"a few seconds\",m:\"a minute\",mm:\"%d minutes\",h:\"an hour\",hh:\"%d hours\",d:\"a day\",dd:\"%d days\",M:\"a month\",MM:\"%d months\",y:\"a year\",yy:\"%d years\"},dayOfMonthOrdinalParse:/\\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?\"th\":1===a?\"st\":2===a?\"nd\":3===a?\"rd\":\"th\")},week:{dow:1,doy:4}}),e.defineLocale(\"en-ie\",{months:\"January_February_March_April_May_June_July_August_September_October_November_December\".split(\"_\"),monthsShort:\"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec\".split(\"_\"),weekdays:\"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday\".split(\"_\"),weekdaysShort:\"Sun_Mon_Tue_Wed_Thu_Fri_Sat\".split(\"_\"),weekdaysMin:\"Su_Mo_Tu_We_Th_Fr_Sa\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD-MM-YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Today at] LT\",nextDay:\"[Tomorrow at] LT\",nextWeek:\"dddd [at] LT\",lastDay:\"[Yesterday at] LT\",lastWeek:\"[Last] dddd [at] LT\",sameElse:\"L\"},relativeTime:{future:\"in %s\",past:\"%s ago\",s:\"a few seconds\",m:\"a minute\",mm:\"%d minutes\",h:\"an hour\",hh:\"%d hours\",d:\"a day\",dd:\"%d days\",M:\"a month\",MM:\"%d months\",y:\"a year\",yy:\"%d years\"},dayOfMonthOrdinalParse:/\\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?\"th\":1===a?\"st\":2===a?\"nd\":3===a?\"rd\":\"th\")},week:{dow:1,doy:4}}),e.defineLocale(\"en-nz\",{months:\"January_February_March_April_May_June_July_August_September_October_November_December\".split(\"_\"),monthsShort:\"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec\".split(\"_\"),weekdays:\"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday\".split(\"_\"),weekdaysShort:\"Sun_Mon_Tue_Wed_Thu_Fri_Sat\".split(\"_\"),weekdaysMin:\"Su_Mo_Tu_We_Th_Fr_Sa\".split(\"_\"),longDateFormat:{LT:\"h:mm A\",LTS:\"h:mm:ss A\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY h:mm A\",LLLL:\"dddd, D MMMM YYYY h:mm A\"},calendar:{sameDay:\"[Today at] LT\",nextDay:\"[Tomorrow at] LT\",nextWeek:\"dddd [at] LT\",lastDay:\"[Yesterday at] LT\",lastWeek:\"[Last] dddd [at] LT\",sameElse:\"L\"},relativeTime:{future:\"in %s\",past:\"%s ago\",s:\"a few seconds\",m:\"a minute\",mm:\"%d minutes\",h:\"an hour\",hh:\"%d hours\",d:\"a day\",dd:\"%d days\",M:\"a month\",MM:\"%d months\",y:\"a year\",yy:\"%d years\"},dayOfMonthOrdinalParse:/\\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?\"th\":1===a?\"st\":2===a?\"nd\":3===a?\"rd\":\"th\")},week:{dow:1,doy:4}}),e.defineLocale(\"eo\",{months:\"januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro\".split(\"_\"),monthsShort:\"jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec\".split(\"_\"),weekdays:\"dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato\".split(\"_\"),weekdaysShort:\"dim_lun_mard_merk_ĵaŭ_ven_sab\".split(\"_\"),weekdaysMin:\"di_lu_ma_me_ĵa_ve_sa\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"YYYY-MM-DD\",LL:\"D[-a de] MMMM, YYYY\",LLL:\"D[-a de] MMMM, YYYY HH:mm\",LLLL:\"dddd, [la] D[-a de] MMMM, YYYY HH:mm\"},meridiemParse:/[ap]\\.t\\.m/i,isPM:function(e){return\"p\"===e.charAt(0).toLowerCase()},meridiem:function(e,a,t){return e>11?t?\"p.t.m.\":\"P.T.M.\":t?\"a.t.m.\":\"A.T.M.\"},calendar:{sameDay:\"[Hodiaŭ je] LT\",nextDay:\"[Morgaŭ je] LT\",nextWeek:\"dddd [je] LT\",lastDay:\"[Hieraŭ je] LT\",lastWeek:\"[pasinta] dddd [je] LT\",sameElse:\"L\"},relativeTime:{future:\"post %s\",past:\"antaŭ %s\",s:\"sekundoj\",m:\"minuto\",mm:\"%d minutoj\",h:\"horo\",hh:\"%d horoj\",d:\"tago\",dd:\"%d tagoj\",M:\"monato\",MM:\"%d monatoj\",y:\"jaro\",yy:\"%d jaroj\"},dayOfMonthOrdinalParse:/\\d{1,2}a/,ordinal:\"%da\",week:{dow:1,doy:7}});var Cd=\"ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.\".split(\"_\"),Id=\"ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic\".split(\"_\");e.defineLocale(\"es-do\",{months:\"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre\".split(\"_\"),monthsShort:function(e,a){return e?/-MMM-/.test(a)?Id[e.month()]:Cd[e.month()]:Cd},monthsParseExact:!0,weekdays:\"domingo_lunes_martes_miércoles_jueves_viernes_sábado\".split(\"_\"),weekdaysShort:\"dom._lun._mar._mié._jue._vie._sáb.\".split(\"_\"),weekdaysMin:\"do_lu_ma_mi_ju_vi_sá\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"h:mm A\",LTS:\"h:mm:ss A\",L:\"DD/MM/YYYY\",LL:\"D [de] MMMM [de] YYYY\",LLL:\"D [de] MMMM [de] YYYY h:mm A\",LLLL:\"dddd, D [de] MMMM [de] YYYY h:mm A\"},calendar:{sameDay:function(){return\"[hoy a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},nextDay:function(){return\"[mañana a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},nextWeek:function(){return\"dddd [a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},lastDay:function(){return\"[ayer a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},lastWeek:function(){return\"[el] dddd [pasado a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},sameElse:\"L\"},relativeTime:{future:\"en %s\",past:\"hace %s\",s:\"unos segundos\",m:\"un minuto\",mm:\"%d minutos\",h:\"una hora\",hh:\"%d horas\",d:\"un día\",dd:\"%d días\",M:\"un mes\",MM:\"%d meses\",y:\"un año\",yy:\"%d años\"},dayOfMonthOrdinalParse:/\\d{1,2}º/,ordinal:\"%dº\",week:{dow:1,doy:4}});var Gd=\"ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.\".split(\"_\"),Ud=\"ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic\".split(\"_\");e.defineLocale(\"es\",{months:\"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre\".split(\"_\"),monthsShort:function(e,a){return e?/-MMM-/.test(a)?Ud[e.month()]:Gd[e.month()]:Gd},monthsParseExact:!0,weekdays:\"domingo_lunes_martes_miércoles_jueves_viernes_sábado\".split(\"_\"),weekdaysShort:\"dom._lun._mar._mié._jue._vie._sáb.\".split(\"_\"),weekdaysMin:\"do_lu_ma_mi_ju_vi_sá\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D [de] MMMM [de] YYYY\",LLL:\"D [de] MMMM [de] YYYY H:mm\",LLLL:\"dddd, D [de] MMMM [de] YYYY H:mm\"},calendar:{sameDay:function(){return\"[hoy a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},nextDay:function(){return\"[mañana a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},nextWeek:function(){return\"dddd [a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},lastDay:function(){return\"[ayer a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},lastWeek:function(){return\"[el] dddd [pasado a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},sameElse:\"L\"},relativeTime:{future:\"en %s\",past:\"hace %s\",s:\"unos segundos\",m:\"un minuto\",mm:\"%d minutos\",h:\"una hora\",hh:\"%d horas\",d:\"un día\",dd:\"%d días\",M:\"un mes\",MM:\"%d meses\",y:\"un año\",yy:\"%d años\"},dayOfMonthOrdinalParse:/\\d{1,2}º/,ordinal:\"%dº\",week:{dow:1,doy:4}}),e.defineLocale(\"et\",{months:\"jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember\".split(\"_\"),monthsShort:\"jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets\".split(\"_\"),weekdays:\"pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev\".split(\"_\"),weekdaysShort:\"P_E_T_K_N_R_L\".split(\"_\"),weekdaysMin:\"P_E_T_K_N_R_L\".split(\"_\"),longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm\",LLLL:\"dddd, D. MMMM YYYY H:mm\"},calendar:{sameDay:\"[Täna,] LT\",nextDay:\"[Homme,] LT\",nextWeek:\"[Järgmine] dddd LT\",lastDay:\"[Eile,] LT\",lastWeek:\"[Eelmine] dddd LT\",sameElse:\"L\"},relativeTime:{future:\"%s pärast\",past:\"%s tagasi\",s:js,m:js,mm:js,h:js,hh:js,d:js,dd:\"%d päeva\",M:js,MM:js,y:js,yy:js},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}}),e.defineLocale(\"eu\",{months:\"urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua\".split(\"_\"),monthsShort:\"urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.\".split(\"_\"),monthsParseExact:!0,weekdays:\"igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata\".split(\"_\"),weekdaysShort:\"ig._al._ar._az._og._ol._lr.\".split(\"_\"),weekdaysMin:\"ig_al_ar_az_og_ol_lr\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"YYYY-MM-DD\",LL:\"YYYY[ko] MMMM[ren] D[a]\",LLL:\"YYYY[ko] MMMM[ren] D[a] HH:mm\",LLLL:\"dddd, YYYY[ko] MMMM[ren] D[a] HH:mm\",l:\"YYYY-M-D\",ll:\"YYYY[ko] MMM D[a]\",lll:\"YYYY[ko] MMM D[a] HH:mm\",llll:\"ddd, YYYY[ko] MMM D[a] HH:mm\"},calendar:{sameDay:\"[gaur] LT[etan]\",nextDay:\"[bihar] LT[etan]\",nextWeek:\"dddd LT[etan]\",lastDay:\"[atzo] LT[etan]\",lastWeek:\"[aurreko] dddd LT[etan]\",sameElse:\"L\"},relativeTime:{future:\"%s barru\",past:\"duela %s\",s:\"segundo batzuk\",m:\"minutu bat\",mm:\"%d minutu\",h:\"ordu bat\",hh:\"%d ordu\",d:\"egun bat\",dd:\"%d egun\",M:\"hilabete bat\",MM:\"%d hilabete\",y:\"urte bat\",yy:\"%d urte\"},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:7}});var Vd={1:\"۱\",2:\"۲\",3:\"۳\",4:\"۴\",5:\"۵\",6:\"۶\",7:\"۷\",8:\"۸\",9:\"۹\",0:\"۰\"},$d={\"۱\":\"1\",\"۲\":\"2\",\"۳\":\"3\",\"۴\":\"4\",\"۵\":\"5\",\"۶\":\"6\",\"۷\":\"7\",\"۸\":\"8\",\"۹\":\"9\",\"۰\":\"0\"};e.defineLocale(\"fa\",{months:\"ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر\".split(\"_\"),monthsShort:\"ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر\".split(\"_\"),weekdays:\"یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه\".split(\"_\"),weekdaysShort:\"یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه\".split(\"_\"),weekdaysMin:\"ی_د_س_چ_پ_ج_ش\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},meridiemParse:/قبل از ظهر|بعد از ظهر/,isPM:function(e){return/بعد از ظهر/.test(e)},meridiem:function(e,a,t){return e<12?\"قبل از ظهر\":\"بعد از ظهر\"},calendar:{sameDay:\"[امروز ساعت] LT\",nextDay:\"[فردا ساعت] LT\",nextWeek:\"dddd [ساعت] LT\",lastDay:\"[دیروز ساعت] LT\",lastWeek:\"dddd [پیش] [ساعت] LT\",sameElse:\"L\"},relativeTime:{future:\"در %s\",past:\"%s پیش\",s:\"چند ثانیه\",m:\"یک دقیقه\",mm:\"%d دقیقه\",h:\"یک ساعت\",hh:\"%d ساعت\",d:\"یک روز\",dd:\"%d روز\",M:\"یک ماه\",MM:\"%d ماه\",y:\"یک سال\",yy:\"%d سال\"},preparse:function(e){return e.replace(/[۰-۹]/g,function(e){return $d[e]}).replace(/،/g,\",\")},postformat:function(e){return e.replace(/\\d/g,function(e){return Vd[e]}).replace(/,/g,\"،\")},dayOfMonthOrdinalParse:/\\d{1,2}م/,ordinal:\"%dم\",week:{dow:6,doy:12}});var Kd=\"nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän\".split(\" \"),Zd=[\"nolla\",\"yhden\",\"kahden\",\"kolmen\",\"neljän\",\"viiden\",\"kuuden\",Kd[7],Kd[8],Kd[9]];e.defineLocale(\"fi\",{months:\"tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu\".split(\"_\"),monthsShort:\"tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu\".split(\"_\"),weekdays:\"sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai\".split(\"_\"),weekdaysShort:\"su_ma_ti_ke_to_pe_la\".split(\"_\"),weekdaysMin:\"su_ma_ti_ke_to_pe_la\".split(\"_\"),longDateFormat:{LT:\"HH.mm\",LTS:\"HH.mm.ss\",L:\"DD.MM.YYYY\",LL:\"Do MMMM[ta] YYYY\",LLL:\"Do MMMM[ta] YYYY, [klo] HH.mm\",LLLL:\"dddd, Do MMMM[ta] YYYY, [klo] HH.mm\",l:\"D.M.YYYY\",ll:\"Do MMM YYYY\",lll:\"Do MMM YYYY, [klo] HH.mm\",llll:\"ddd, Do MMM YYYY, [klo] HH.mm\"},calendar:{sameDay:\"[tänään] [klo] LT\",nextDay:\"[huomenna] [klo] LT\",nextWeek:\"dddd [klo] LT\",lastDay:\"[eilen] [klo] LT\",lastWeek:\"[viime] dddd[na] [klo] LT\",sameElse:\"L\"},relativeTime:{future:\"%s päästä\",past:\"%s sitten\",s:xs,m:xs,mm:xs,h:xs,hh:xs,d:xs,dd:xs,M:xs,MM:xs,y:xs,yy:xs},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}}),e.defineLocale(\"fo\",{months:\"januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember\".split(\"_\"),monthsShort:\"jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des\".split(\"_\"),weekdays:\"sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur\".split(\"_\"),weekdaysShort:\"sun_mán_týs_mik_hós_frí_ley\".split(\"_\"),weekdaysMin:\"su_má_tý_mi_hó_fr_le\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D. MMMM, YYYY HH:mm\"},calendar:{sameDay:\"[Í dag kl.] LT\",nextDay:\"[Í morgin kl.] LT\",nextWeek:\"dddd [kl.] LT\",lastDay:\"[Í gjár kl.] LT\",lastWeek:\"[síðstu] dddd [kl] LT\",sameElse:\"L\"},relativeTime:{future:\"um %s\",past:\"%s síðani\",s:\"fá sekund\",m:\"ein minutt\",mm:\"%d minuttir\",h:\"ein tími\",hh:\"%d tímar\",d:\"ein dagur\",dd:\"%d dagar\",M:\"ein mánaði\",MM:\"%d mánaðir\",y:\"eitt ár\",yy:\"%d ár\"},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}}),e.defineLocale(\"fr-ca\",{months:\"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre\".split(\"_\"),monthsShort:\"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.\".split(\"_\"),monthsParseExact:!0,weekdays:\"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi\".split(\"_\"),weekdaysShort:\"dim._lun._mar._mer._jeu._ven._sam.\".split(\"_\"),weekdaysMin:\"Di_Lu_Ma_Me_Je_Ve_Sa\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"YYYY-MM-DD\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Aujourd’hui à] LT\",nextDay:\"[Demain à] LT\",nextWeek:\"dddd [à] LT\",lastDay:\"[Hier à] LT\",lastWeek:\"dddd [dernier à] LT\",sameElse:\"L\"},relativeTime:{future:\"dans %s\",past:\"il y a %s\",s:\"quelques secondes\",m:\"une minute\",mm:\"%d minutes\",h:\"une heure\",hh:\"%d heures\",d:\"un jour\",dd:\"%d jours\",M:\"un mois\",MM:\"%d mois\",y:\"un an\",yy:\"%d ans\"},dayOfMonthOrdinalParse:/\\d{1,2}(er|e)/,ordinal:function(e,a){switch(a){default:case\"M\":case\"Q\":case\"D\":case\"DDD\":case\"d\":return e+(1===e?\"er\":\"e\");case\"w\":case\"W\":return e+(1===e?\"re\":\"e\")}}}),e.defineLocale(\"fr-ch\",{months:\"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre\".split(\"_\"),monthsShort:\"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.\".split(\"_\"),monthsParseExact:!0,weekdays:\"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi\".split(\"_\"),weekdaysShort:\"dim._lun._mar._mer._jeu._ven._sam.\".split(\"_\"),weekdaysMin:\"Di_Lu_Ma_Me_Je_Ve_Sa\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Aujourd’hui à] LT\",nextDay:\"[Demain à] LT\",nextWeek:\"dddd [à] LT\",lastDay:\"[Hier à] LT\",lastWeek:\"dddd [dernier à] LT\",sameElse:\"L\"},relativeTime:{future:\"dans %s\",past:\"il y a %s\",s:\"quelques secondes\",m:\"une minute\",mm:\"%d minutes\",h:\"une heure\",hh:\"%d heures\",d:\"un jour\",dd:\"%d jours\",M:\"un mois\",MM:\"%d mois\",y:\"un an\",yy:\"%d ans\"},dayOfMonthOrdinalParse:/\\d{1,2}(er|e)/,ordinal:function(e,a){switch(a){default:case\"M\":case\"Q\":case\"D\":case\"DDD\":case\"d\":return e+(1===e?\"er\":\"e\");case\"w\":case\"W\":return e+(1===e?\"re\":\"e\")}},week:{dow:1,doy:4}}),e.defineLocale(\"fr\",{months:\"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre\".split(\"_\"),monthsShort:\"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.\".split(\"_\"),monthsParseExact:!0,weekdays:\"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi\".split(\"_\"),weekdaysShort:\"dim._lun._mar._mer._jeu._ven._sam.\".split(\"_\"),weekdaysMin:\"Di_Lu_Ma_Me_Je_Ve_Sa\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Aujourd’hui à] LT\",nextDay:\"[Demain à] LT\",nextWeek:\"dddd [à] LT\",lastDay:\"[Hier à] LT\",lastWeek:\"dddd [dernier à] LT\",sameElse:\"L\"},relativeTime:{future:\"dans %s\",past:\"il y a %s\",s:\"quelques secondes\",m:\"une minute\",mm:\"%d minutes\",h:\"une heure\",hh:\"%d heures\",d:\"un jour\",dd:\"%d jours\",M:\"un mois\",MM:\"%d mois\",y:\"un an\",yy:\"%d ans\"},dayOfMonthOrdinalParse:/\\d{1,2}(er|)/,ordinal:function(e,a){switch(a){case\"D\":return e+(1===e?\"er\":\"\");default:case\"M\":case\"Q\":case\"DDD\":case\"d\":return e+(1===e?\"er\":\"e\");case\"w\":case\"W\":return e+(1===e?\"re\":\"e\")}},week:{dow:1,doy:4}});var qd=\"jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.\".split(\"_\"),Bd=\"jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des\".split(\"_\");e.defineLocale(\"fy\",{months:\"jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber\".split(\"_\"),monthsShort:function(e,a){return e?/-MMM-/.test(a)?Bd[e.month()]:qd[e.month()]:qd},monthsParseExact:!0,weekdays:\"snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon\".split(\"_\"),weekdaysShort:\"si._mo._ti._wo._to._fr._so.\".split(\"_\"),weekdaysMin:\"Si_Mo_Ti_Wo_To_Fr_So\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD-MM-YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[hjoed om] LT\",nextDay:\"[moarn om] LT\",nextWeek:\"dddd [om] LT\",lastDay:\"[juster om] LT\",lastWeek:\"[ôfrûne] dddd [om] LT\",sameElse:\"L\"},relativeTime:{future:\"oer %s\",past:\"%s lyn\",s:\"in pear sekonden\",m:\"ien minút\",mm:\"%d minuten\",h:\"ien oere\",hh:\"%d oeren\",d:\"ien dei\",dd:\"%d dagen\",M:\"ien moanne\",MM:\"%d moannen\",y:\"ien jier\",yy:\"%d jierren\"},dayOfMonthOrdinalParse:/\\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?\"ste\":\"de\")},week:{dow:1,doy:4}});var Qd=[\"Am Faoilleach\",\"An Gearran\",\"Am Màrt\",\"An Giblean\",\"An Cèitean\",\"An t-Ògmhios\",\"An t-Iuchar\",\"An Lùnastal\",\"An t-Sultain\",\"An Dàmhair\",\"An t-Samhain\",\"An Dùbhlachd\"],Xd=[\"Faoi\",\"Gear\",\"Màrt\",\"Gibl\",\"Cèit\",\"Ògmh\",\"Iuch\",\"Lùn\",\"Sult\",\"Dàmh\",\"Samh\",\"Dùbh\"],e_=[\"Didòmhnaich\",\"Diluain\",\"Dimàirt\",\"Diciadain\",\"Diardaoin\",\"Dihaoine\",\"Disathairne\"],a_=[\"Did\",\"Dil\",\"Dim\",\"Dic\",\"Dia\",\"Dih\",\"Dis\"],t_=[\"Dò\",\"Lu\",\"Mà\",\"Ci\",\"Ar\",\"Ha\",\"Sa\"];e.defineLocale(\"gd\",{months:Qd,monthsShort:Xd,monthsParseExact:!0,weekdays:e_,weekdaysShort:a_,weekdaysMin:t_,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[An-diugh aig] LT\",nextDay:\"[A-màireach aig] LT\",nextWeek:\"dddd [aig] LT\",lastDay:\"[An-dè aig] LT\",lastWeek:\"dddd [seo chaidh] [aig] LT\",sameElse:\"L\"},relativeTime:{future:\"ann an %s\",past:\"bho chionn %s\",s:\"beagan diogan\",m:\"mionaid\",mm:\"%d mionaidean\",h:\"uair\",hh:\"%d uairean\",d:\"latha\",dd:\"%d latha\",M:\"mìos\",MM:\"%d mìosan\",y:\"bliadhna\",yy:\"%d bliadhna\"},dayOfMonthOrdinalParse:/\\d{1,2}(d|na|mh)/,ordinal:function(e){return e+(1===e?\"d\":e%10==2?\"na\":\"mh\")},week:{dow:1,doy:4}}),e.defineLocale(\"gl\",{months:\"xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro\".split(\"_\"),monthsShort:\"xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.\".split(\"_\"),monthsParseExact:!0,weekdays:\"domingo_luns_martes_mércores_xoves_venres_sábado\".split(\"_\"),weekdaysShort:\"dom._lun._mar._mér._xov._ven._sáb.\".split(\"_\"),weekdaysMin:\"do_lu_ma_mé_xo_ve_sá\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D [de] MMMM [de] YYYY\",LLL:\"D [de] MMMM [de] YYYY H:mm\",LLLL:\"dddd, D [de] MMMM [de] YYYY H:mm\"},calendar:{sameDay:function(){return\"[hoxe \"+(1!==this.hours()?\"ás\":\"á\")+\"] LT\"},nextDay:function(){return\"[mañá \"+(1!==this.hours()?\"ás\":\"á\")+\"] LT\"},nextWeek:function(){return\"dddd [\"+(1!==this.hours()?\"ás\":\"a\")+\"] LT\"},lastDay:function(){return\"[onte \"+(1!==this.hours()?\"á\":\"a\")+\"] LT\"},lastWeek:function(){return\"[o] dddd [pasado \"+(1!==this.hours()?\"ás\":\"a\")+\"] LT\"},sameElse:\"L\"},relativeTime:{future:function(e){return 0===e.indexOf(\"un\")?\"n\"+e:\"en \"+e},past:\"hai %s\",s:\"uns segundos\",m:\"un minuto\",mm:\"%d minutos\",h:\"unha hora\",hh:\"%d horas\",d:\"un día\",dd:\"%d días\",M:\"un mes\",MM:\"%d meses\",y:\"un ano\",yy:\"%d anos\"},dayOfMonthOrdinalParse:/\\d{1,2}º/,ordinal:\"%dº\",week:{dow:1,doy:4}}),e.defineLocale(\"gom-latn\",{months:\"Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr\".split(\"_\"),monthsShort:\"Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.\".split(\"_\"),monthsParseExact:!0,weekdays:\"Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son'var\".split(\"_\"),weekdaysShort:\"Ait._Som._Mon._Bud._Bre._Suk._Son.\".split(\"_\"),weekdaysMin:\"Ai_Sm_Mo_Bu_Br_Su_Sn\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"A h:mm [vazta]\",LTS:\"A h:mm:ss [vazta]\",L:\"DD-MM-YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY A h:mm [vazta]\",LLLL:\"dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]\",llll:\"ddd, D MMM YYYY, A h:mm [vazta]\"},calendar:{sameDay:\"[Aiz] LT\",nextDay:\"[Faleam] LT\",nextWeek:\"[Ieta to] dddd[,] LT\",lastDay:\"[Kal] LT\",lastWeek:\"[Fatlo] dddd[,] LT\",sameElse:\"L\"},relativeTime:{future:\"%s\",past:\"%s adim\",s:Os,m:Os,mm:Os,h:Os,hh:Os,d:Os,dd:Os,M:Os,MM:Os,y:Os,yy:Os},dayOfMonthOrdinalParse:/\\d{1,2}(er)/,ordinal:function(e,a){switch(a){case\"D\":return e+\"er\";default:case\"M\":case\"Q\":case\"DDD\":case\"d\":case\"w\":case\"W\":return e}},week:{dow:1,doy:4},meridiemParse:/rati|sokalli|donparam|sanje/,meridiemHour:function(e,a){return 12===e&&(e=0),\"rati\"===a?e<4?e:e+12:\"sokalli\"===a?e:\"donparam\"===a?e>12?e:e+12:\"sanje\"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?\"rati\":e<12?\"sokalli\":e<16?\"donparam\":e<20?\"sanje\":\"rati\"}}),e.defineLocale(\"he\",{months:\"ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר\".split(\"_\"),monthsShort:\"ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳\".split(\"_\"),weekdays:\"ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת\".split(\"_\"),weekdaysShort:\"א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳\".split(\"_\"),weekdaysMin:\"א_ב_ג_ד_ה_ו_ש\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D [ב]MMMM YYYY\",LLL:\"D [ב]MMMM YYYY HH:mm\",LLLL:\"dddd, D [ב]MMMM YYYY HH:mm\",l:\"D/M/YYYY\",ll:\"D MMM YYYY\",lll:\"D MMM YYYY HH:mm\",llll:\"ddd, D MMM YYYY HH:mm\"},calendar:{sameDay:\"[היום ב־]LT\",nextDay:\"[מחר ב־]LT\",nextWeek:\"dddd [בשעה] LT\",lastDay:\"[אתמול ב־]LT\",lastWeek:\"[ביום] dddd [האחרון בשעה] LT\",sameElse:\"L\"},relativeTime:{future:\"בעוד %s\",past:\"לפני %s\",s:\"מספר שניות\",m:\"דקה\",mm:\"%d דקות\",h:\"שעה\",hh:function(e){return 2===e?\"שעתיים\":e+\" שעות\"},d:\"יום\",dd:function(e){return 2===e?\"יומיים\":e+\" ימים\"},M:\"חודש\",MM:function(e){return 2===e?\"חודשיים\":e+\" חודשים\"},y:\"שנה\",yy:function(e){return 2===e?\"שנתיים\":e%10==0&&10!==e?e+\" שנה\":e+\" שנים\"}},meridiemParse:/אחה\"צ|לפנה\"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,isPM:function(e){return/^(אחה\"צ|אחרי הצהריים|בערב)$/.test(e)},meridiem:function(e,a,t){return e<5?\"לפנות בוקר\":e<10?\"בבוקר\":e<12?t?'לפנה\"צ':\"לפני הצהריים\":e<18?t?'אחה\"צ':\"אחרי הצהריים\":\"בערב\"}});var s_={1:\"१\",2:\"२\",3:\"३\",4:\"४\",5:\"५\",6:\"६\",7:\"७\",8:\"८\",9:\"९\",0:\"०\"},n_={\"१\":\"1\",\"२\":\"2\",\"३\":\"3\",\"४\":\"4\",\"५\":\"5\",\"६\":\"6\",\"७\":\"7\",\"८\":\"8\",\"९\":\"9\",\"०\":\"0\"};e.defineLocale(\"hi\",{months:\"जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर\".split(\"_\"),monthsShort:\"जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.\".split(\"_\"),monthsParseExact:!0,weekdays:\"रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार\".split(\"_\"),weekdaysShort:\"रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि\".split(\"_\"),weekdaysMin:\"र_सो_मं_बु_गु_शु_श\".split(\"_\"),longDateFormat:{LT:\"A h:mm बजे\",LTS:\"A h:mm:ss बजे\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, A h:mm बजे\",LLLL:\"dddd, D MMMM YYYY, A h:mm बजे\"},calendar:{sameDay:\"[आज] LT\",nextDay:\"[कल] LT\",nextWeek:\"dddd, LT\",lastDay:\"[कल] LT\",lastWeek:\"[पिछले] dddd, LT\",sameElse:\"L\"},relativeTime:{future:\"%s में\",past:\"%s पहले\",s:\"कुछ ही क्षण\",m:\"एक मिनट\",mm:\"%d मिनट\",h:\"एक घंटा\",hh:\"%d घंटे\",d:\"एक दिन\",dd:\"%d दिन\",M:\"एक महीने\",MM:\"%d महीने\",y:\"एक वर्ष\",yy:\"%d वर्ष\"},preparse:function(e){return e.replace(/[१२३४५६७८९०]/g,function(e){return n_[e]})},postformat:function(e){return e.replace(/\\d/g,function(e){return s_[e]})},meridiemParse:/रात|सुबह|दोपहर|शाम/,meridiemHour:function(e,a){return 12===e&&(e=0),\"रात\"===a?e<4?e:e+12:\"सुबह\"===a?e:\"दोपहर\"===a?e>=10?e:e+12:\"शाम\"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?\"रात\":e<10?\"सुबह\":e<17?\"दोपहर\":e<20?\"शाम\":\"रात\"},week:{dow:0,doy:6}}),e.defineLocale(\"hr\",{months:{format:\"siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca\".split(\"_\"),standalone:\"siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac\".split(\"_\")},monthsShort:\"sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.\".split(\"_\"),monthsParseExact:!0,weekdays:\"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota\".split(\"_\"),weekdaysShort:\"ned._pon._uto._sri._čet._pet._sub.\".split(\"_\"),weekdaysMin:\"ne_po_ut_sr_če_pe_su\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm\",LLLL:\"dddd, D. MMMM YYYY H:mm\"},calendar:{sameDay:\"[danas u] LT\",nextDay:\"[sutra u] LT\",nextWeek:function(){switch(this.day()){case 0:return\"[u] [nedjelju] [u] LT\";case 3:return\"[u] [srijedu] [u] LT\";case 6:return\"[u] [subotu] [u] LT\";case 1:case 2:case 4:case 5:return\"[u] dddd [u] LT\"}},lastDay:\"[jučer u] LT\",lastWeek:function(){switch(this.day()){case 0:case 3:return\"[prošlu] dddd [u] LT\";case 6:return\"[prošle] [subote] [u] LT\";case 1:case 2:case 4:case 5:return\"[prošli] dddd [u] LT\"}},sameElse:\"L\"},relativeTime:{future:\"za %s\",past:\"prije %s\",s:\"par sekundi\",m:Ws,mm:Ws,h:Ws,hh:Ws,d:\"dan\",dd:Ws,M:\"mjesec\",MM:Ws,y:\"godinu\",yy:Ws},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:7}});var r_=\"vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton\".split(\" \");e.defineLocale(\"hu\",{months:\"január_február_március_április_május_június_július_augusztus_szeptember_október_november_december\".split(\"_\"),monthsShort:\"jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec\".split(\"_\"),weekdays:\"vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat\".split(\"_\"),weekdaysShort:\"vas_hét_kedd_sze_csüt_pén_szo\".split(\"_\"),weekdaysMin:\"v_h_k_sze_cs_p_szo\".split(\"_\"),longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"YYYY.MM.DD.\",LL:\"YYYY. MMMM D.\",LLL:\"YYYY. MMMM D. H:mm\",LLLL:\"YYYY. MMMM D., dddd H:mm\"},meridiemParse:/de|du/i,isPM:function(e){return\"u\"===e.charAt(1).toLowerCase()},meridiem:function(e,a,t){return e<12?!0===t?\"de\":\"DE\":!0===t?\"du\":\"DU\"},calendar:{sameDay:\"[ma] LT[-kor]\",nextDay:\"[holnap] LT[-kor]\",nextWeek:function(){return As.call(this,!0)},lastDay:\"[tegnap] LT[-kor]\",lastWeek:function(){return As.call(this,!1)},sameElse:\"L\"},relativeTime:{future:\"%s múlva\",past:\"%s\",s:Es,m:Es,mm:Es,h:Es,hh:Es,d:Es,dd:Es,M:Es,MM:Es,y:Es,yy:Es},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}}),e.defineLocale(\"hy-am\",{months:{format:\"հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի\".split(\"_\"),standalone:\"հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր\".split(\"_\")},monthsShort:\"հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ\".split(\"_\"),weekdays:\"կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ\".split(\"_\"),weekdaysShort:\"կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ\".split(\"_\"),weekdaysMin:\"կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY թ.\",LLL:\"D MMMM YYYY թ., HH:mm\",LLLL:\"dddd, D MMMM YYYY թ., HH:mm\"},calendar:{sameDay:\"[այսօր] LT\",nextDay:\"[վաղը] LT\",lastDay:\"[երեկ] LT\",nextWeek:function(){return\"dddd [օրը ժամը] LT\"},lastWeek:function(){return\"[անցած] dddd [օրը ժամը] LT\"},sameElse:\"L\"},relativeTime:{future:\"%s հետո\",past:\"%s առաջ\",s:\"մի քանի վայրկյան\",m:\"րոպե\",mm:\"%d րոպե\",h:\"ժամ\",hh:\"%d ժամ\",d:\"օր\",dd:\"%d օր\",M:\"ամիս\",MM:\"%d ամիս\",y:\"տարի\",yy:\"%d տարի\"},meridiemParse:/գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,isPM:function(e){return/^(ցերեկվա|երեկոյան)$/.test(e)},meridiem:function(e){return e<4?\"գիշերվա\":e<12?\"առավոտվա\":e<17?\"ցերեկվա\":\"երեկոյան\"},dayOfMonthOrdinalParse:/\\d{1,2}|\\d{1,2}-(ին|րդ)/,ordinal:function(e,a){switch(a){case\"DDD\":case\"w\":case\"W\":case\"DDDo\":return 1===e?e+\"-ին\":e+\"-րդ\";default:return e}},week:{dow:1,doy:7}}),e.defineLocale(\"id\",{months:\"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember\".split(\"_\"),monthsShort:\"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des\".split(\"_\"),weekdays:\"Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu\".split(\"_\"),weekdaysShort:\"Min_Sen_Sel_Rab_Kam_Jum_Sab\".split(\"_\"),weekdaysMin:\"Mg_Sn_Sl_Rb_Km_Jm_Sb\".split(\"_\"),longDateFormat:{LT:\"HH.mm\",LTS:\"HH.mm.ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY [pukul] HH.mm\",LLLL:\"dddd, D MMMM YYYY [pukul] HH.mm\"},meridiemParse:/pagi|siang|sore|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),\"pagi\"===a?e:\"siang\"===a?e>=11?e:e+12:\"sore\"===a||\"malam\"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?\"pagi\":e<15?\"siang\":e<19?\"sore\":\"malam\"},calendar:{sameDay:\"[Hari ini pukul] LT\",nextDay:\"[Besok pukul] LT\",nextWeek:\"dddd [pukul] LT\",lastDay:\"[Kemarin pukul] LT\",lastWeek:\"dddd [lalu pukul] LT\",sameElse:\"L\"},relativeTime:{future:\"dalam %s\",past:\"%s yang lalu\",s:\"beberapa detik\",m:\"semenit\",mm:\"%d menit\",h:\"sejam\",hh:\"%d jam\",d:\"sehari\",dd:\"%d hari\",M:\"sebulan\",MM:\"%d bulan\",y:\"setahun\",yy:\"%d tahun\"},week:{dow:1,doy:7}}),e.defineLocale(\"is\",{months:\"janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember\".split(\"_\"),monthsShort:\"jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des\".split(\"_\"),weekdays:\"sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur\".split(\"_\"),weekdaysShort:\"sun_mán_þri_mið_fim_fös_lau\".split(\"_\"),weekdaysMin:\"Su_Má_Þr_Mi_Fi_Fö_La\".split(\"_\"),longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY [kl.] H:mm\",LLLL:\"dddd, D. MMMM YYYY [kl.] H:mm\"},calendar:{sameDay:\"[í dag kl.] LT\",nextDay:\"[á morgun kl.] LT\",nextWeek:\"dddd [kl.] LT\",lastDay:\"[í gær kl.] LT\",lastWeek:\"[síðasta] dddd [kl.] LT\",sameElse:\"L\"},relativeTime:{future:\"eftir %s\",past:\"fyrir %s síðan\",s:zs,m:zs,mm:zs,h:\"klukkustund\",hh:zs,d:zs,dd:zs,M:zs,MM:zs,y:zs,yy:zs},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}}),e.defineLocale(\"it\",{months:\"gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre\".split(\"_\"),monthsShort:\"gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic\".split(\"_\"),weekdays:\"domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato\".split(\"_\"),weekdaysShort:\"dom_lun_mar_mer_gio_ven_sab\".split(\"_\"),weekdaysMin:\"do_lu_ma_me_gi_ve_sa\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Oggi alle] LT\",nextDay:\"[Domani alle] LT\",nextWeek:\"dddd [alle] LT\",lastDay:\"[Ieri alle] LT\",lastWeek:function(){switch(this.day()){case 0:return\"[la scorsa] dddd [alle] LT\";default:return\"[lo scorso] dddd [alle] LT\"}},sameElse:\"L\"},relativeTime:{future:function(e){return(/^[0-9].+$/.test(e)?\"tra\":\"in\")+\" \"+e},past:\"%s fa\",s:\"alcuni secondi\",m:\"un minuto\",mm:\"%d minuti\",h:\"un'ora\",hh:\"%d ore\",d:\"un giorno\",dd:\"%d giorni\",M:\"un mese\",MM:\"%d mesi\",y:\"un anno\",yy:\"%d anni\"},dayOfMonthOrdinalParse:/\\d{1,2}º/,ordinal:\"%dº\",week:{dow:1,doy:4}}),e.defineLocale(\"ja\",{months:\"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月\".split(\"_\"),\nmonthsShort:\"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月\".split(\"_\"),weekdays:\"日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日\".split(\"_\"),weekdaysShort:\"日_月_火_水_木_金_土\".split(\"_\"),weekdaysMin:\"日_月_火_水_木_金_土\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"YYYY/MM/DD\",LL:\"YYYY年M月D日\",LLL:\"YYYY年M月D日 HH:mm\",LLLL:\"YYYY年M月D日 HH:mm dddd\",l:\"YYYY/MM/DD\",ll:\"YYYY年M月D日\",lll:\"YYYY年M月D日 HH:mm\",llll:\"YYYY年M月D日 HH:mm dddd\"},meridiemParse:/午前|午後/i,isPM:function(e){return\"午後\"===e},meridiem:function(e,a,t){return e<12?\"午前\":\"午後\"},calendar:{sameDay:\"[今日] LT\",nextDay:\"[明日] LT\",nextWeek:\"[来週]dddd LT\",lastDay:\"[昨日] LT\",lastWeek:\"[前週]dddd LT\",sameElse:\"L\"},dayOfMonthOrdinalParse:/\\d{1,2}日/,ordinal:function(e,a){switch(a){case\"d\":case\"D\":case\"DDD\":return e+\"日\";default:return e}},relativeTime:{future:\"%s後\",past:\"%s前\",s:\"数秒\",m:\"1分\",mm:\"%d分\",h:\"1時間\",hh:\"%d時間\",d:\"1日\",dd:\"%d日\",M:\"1ヶ月\",MM:\"%dヶ月\",y:\"1年\",yy:\"%d年\"}}),e.defineLocale(\"jv\",{months:\"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember\".split(\"_\"),monthsShort:\"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des\".split(\"_\"),weekdays:\"Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu\".split(\"_\"),weekdaysShort:\"Min_Sen_Sel_Reb_Kem_Jem_Sep\".split(\"_\"),weekdaysMin:\"Mg_Sn_Sl_Rb_Km_Jm_Sp\".split(\"_\"),longDateFormat:{LT:\"HH.mm\",LTS:\"HH.mm.ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY [pukul] HH.mm\",LLLL:\"dddd, D MMMM YYYY [pukul] HH.mm\"},meridiemParse:/enjing|siyang|sonten|ndalu/,meridiemHour:function(e,a){return 12===e&&(e=0),\"enjing\"===a?e:\"siyang\"===a?e>=11?e:e+12:\"sonten\"===a||\"ndalu\"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?\"enjing\":e<15?\"siyang\":e<19?\"sonten\":\"ndalu\"},calendar:{sameDay:\"[Dinten puniko pukul] LT\",nextDay:\"[Mbenjang pukul] LT\",nextWeek:\"dddd [pukul] LT\",lastDay:\"[Kala wingi pukul] LT\",lastWeek:\"dddd [kepengker pukul] LT\",sameElse:\"L\"},relativeTime:{future:\"wonten ing %s\",past:\"%s ingkang kepengker\",s:\"sawetawis detik\",m:\"setunggal menit\",mm:\"%d menit\",h:\"setunggal jam\",hh:\"%d jam\",d:\"sedinten\",dd:\"%d dinten\",M:\"sewulan\",MM:\"%d wulan\",y:\"setaun\",yy:\"%d taun\"},week:{dow:1,doy:7}}),e.defineLocale(\"ka\",{months:{standalone:\"იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი\".split(\"_\"),format:\"იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს\".split(\"_\")},monthsShort:\"იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ\".split(\"_\"),weekdays:{standalone:\"კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი\".split(\"_\"),format:\"კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს\".split(\"_\"),isFormat:/(წინა|შემდეგ)/},weekdaysShort:\"კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ\".split(\"_\"),weekdaysMin:\"კვ_ორ_სა_ოთ_ხუ_პა_შა\".split(\"_\"),longDateFormat:{LT:\"h:mm A\",LTS:\"h:mm:ss A\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY h:mm A\",LLLL:\"dddd, D MMMM YYYY h:mm A\"},calendar:{sameDay:\"[დღეს] LT[-ზე]\",nextDay:\"[ხვალ] LT[-ზე]\",lastDay:\"[გუშინ] LT[-ზე]\",nextWeek:\"[შემდეგ] dddd LT[-ზე]\",lastWeek:\"[წინა] dddd LT-ზე\",sameElse:\"L\"},relativeTime:{future:function(e){return/(წამი|წუთი|საათი|წელი)/.test(e)?e.replace(/ი$/,\"ში\"):e+\"ში\"},past:function(e){return/(წამი|წუთი|საათი|დღე|თვე)/.test(e)?e.replace(/(ი|ე)$/,\"ის უკან\"):/წელი/.test(e)?e.replace(/წელი$/,\"წლის უკან\"):void 0},s:\"რამდენიმე წამი\",m:\"წუთი\",mm:\"%d წუთი\",h:\"საათი\",hh:\"%d საათი\",d:\"დღე\",dd:\"%d დღე\",M:\"თვე\",MM:\"%d თვე\",y:\"წელი\",yy:\"%d წელი\"},dayOfMonthOrdinalParse:/0|1-ლი|მე-\\d{1,2}|\\d{1,2}-ე/,ordinal:function(e){return 0===e?e:1===e?e+\"-ლი\":e<20||e<=100&&e%20==0||e%100==0?\"მე-\"+e:e+\"-ე\"},week:{dow:1,doy:7}});var d_={0:\"-ші\",1:\"-ші\",2:\"-ші\",3:\"-ші\",4:\"-ші\",5:\"-ші\",6:\"-шы\",7:\"-ші\",8:\"-ші\",9:\"-шы\",10:\"-шы\",20:\"-шы\",30:\"-шы\",40:\"-шы\",50:\"-ші\",60:\"-шы\",70:\"-ші\",80:\"-ші\",90:\"-шы\",100:\"-ші\"};e.defineLocale(\"kk\",{months:\"қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан\".split(\"_\"),monthsShort:\"қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел\".split(\"_\"),weekdays:\"жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі\".split(\"_\"),weekdaysShort:\"жек_дүй_сей_сәр_бей_жұм_сен\".split(\"_\"),weekdaysMin:\"жк_дй_сй_ср_бй_жм_сн\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Бүгін сағат] LT\",nextDay:\"[Ертең сағат] LT\",nextWeek:\"dddd [сағат] LT\",lastDay:\"[Кеше сағат] LT\",lastWeek:\"[Өткен аптаның] dddd [сағат] LT\",sameElse:\"L\"},relativeTime:{future:\"%s ішінде\",past:\"%s бұрын\",s:\"бірнеше секунд\",m:\"бір минут\",mm:\"%d минут\",h:\"бір сағат\",hh:\"%d сағат\",d:\"бір күн\",dd:\"%d күн\",M:\"бір ай\",MM:\"%d ай\",y:\"бір жыл\",yy:\"%d жыл\"},dayOfMonthOrdinalParse:/\\d{1,2}-(ші|шы)/,ordinal:function(e){var a=e%10,t=e>=100?100:null;return e+(d_[e]||d_[a]||d_[t])},week:{dow:1,doy:7}}),e.defineLocale(\"km\",{months:\"មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ\".split(\"_\"),monthsShort:\"មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ\".split(\"_\"),weekdays:\"អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍\".split(\"_\"),weekdaysShort:\"អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍\".split(\"_\"),weekdaysMin:\"អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[ថ្ងៃនេះ ម៉ោង] LT\",nextDay:\"[ស្អែក ម៉ោង] LT\",nextWeek:\"dddd [ម៉ោង] LT\",lastDay:\"[ម្សិលមិញ ម៉ោង] LT\",lastWeek:\"dddd [សប្តាហ៍មុន] [ម៉ោង] LT\",sameElse:\"L\"},relativeTime:{future:\"%sទៀត\",past:\"%sមុន\",s:\"ប៉ុន្មានវិនាទី\",m:\"មួយនាទី\",mm:\"%d នាទី\",h:\"មួយម៉ោង\",hh:\"%d ម៉ោង\",d:\"មួយថ្ងៃ\",dd:\"%d ថ្ងៃ\",M:\"មួយខែ\",MM:\"%d ខែ\",y:\"មួយឆ្នាំ\",yy:\"%d ឆ្នាំ\"},week:{dow:1,doy:4}});var __={1:\"೧\",2:\"೨\",3:\"೩\",4:\"೪\",5:\"೫\",6:\"೬\",7:\"೭\",8:\"೮\",9:\"೯\",0:\"೦\"},i_={\"೧\":\"1\",\"೨\":\"2\",\"೩\":\"3\",\"೪\":\"4\",\"೫\":\"5\",\"೬\":\"6\",\"೭\":\"7\",\"೮\":\"8\",\"೯\":\"9\",\"೦\":\"0\"};e.defineLocale(\"kn\",{months:\"ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್\".split(\"_\"),monthsShort:\"ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ\".split(\"_\"),monthsParseExact:!0,weekdays:\"ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ\".split(\"_\"),weekdaysShort:\"ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ\".split(\"_\"),weekdaysMin:\"ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ\".split(\"_\"),longDateFormat:{LT:\"A h:mm\",LTS:\"A h:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, A h:mm\",LLLL:\"dddd, D MMMM YYYY, A h:mm\"},calendar:{sameDay:\"[ಇಂದು] LT\",nextDay:\"[ನಾಳೆ] LT\",nextWeek:\"dddd, LT\",lastDay:\"[ನಿನ್ನೆ] LT\",lastWeek:\"[ಕೊನೆಯ] dddd, LT\",sameElse:\"L\"},relativeTime:{future:\"%s ನಂತರ\",past:\"%s ಹಿಂದೆ\",s:\"ಕೆಲವು ಕ್ಷಣಗಳು\",m:\"ಒಂದು ನಿಮಿಷ\",mm:\"%d ನಿಮಿಷ\",h:\"ಒಂದು ಗಂಟೆ\",hh:\"%d ಗಂಟೆ\",d:\"ಒಂದು ದಿನ\",dd:\"%d ದಿನ\",M:\"ಒಂದು ತಿಂಗಳು\",MM:\"%d ತಿಂಗಳು\",y:\"ಒಂದು ವರ್ಷ\",yy:\"%d ವರ್ಷ\"},preparse:function(e){return e.replace(/[೧೨೩೪೫೬೭೮೯೦]/g,function(e){return i_[e]})},postformat:function(e){return e.replace(/\\d/g,function(e){return __[e]})},meridiemParse:/ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,meridiemHour:function(e,a){return 12===e&&(e=0),\"ರಾತ್ರಿ\"===a?e<4?e:e+12:\"ಬೆಳಿಗ್ಗೆ\"===a?e:\"ಮಧ್ಯಾಹ್ನ\"===a?e>=10?e:e+12:\"ಸಂಜೆ\"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?\"ರಾತ್ರಿ\":e<10?\"ಬೆಳಿಗ್ಗೆ\":e<17?\"ಮಧ್ಯಾಹ್ನ\":e<20?\"ಸಂಜೆ\":\"ರಾತ್ರಿ\"},dayOfMonthOrdinalParse:/\\d{1,2}(ನೇ)/,ordinal:function(e){return e+\"ನೇ\"},week:{dow:0,doy:6}}),e.defineLocale(\"ko\",{months:\"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월\".split(\"_\"),monthsShort:\"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월\".split(\"_\"),weekdays:\"일요일_월요일_화요일_수요일_목요일_금요일_토요일\".split(\"_\"),weekdaysShort:\"일_월_화_수_목_금_토\".split(\"_\"),weekdaysMin:\"일_월_화_수_목_금_토\".split(\"_\"),longDateFormat:{LT:\"A h:mm\",LTS:\"A h:mm:ss\",L:\"YYYY.MM.DD\",LL:\"YYYY년 MMMM D일\",LLL:\"YYYY년 MMMM D일 A h:mm\",LLLL:\"YYYY년 MMMM D일 dddd A h:mm\",l:\"YYYY.MM.DD\",ll:\"YYYY년 MMMM D일\",lll:\"YYYY년 MMMM D일 A h:mm\",llll:\"YYYY년 MMMM D일 dddd A h:mm\"},calendar:{sameDay:\"오늘 LT\",nextDay:\"내일 LT\",nextWeek:\"dddd LT\",lastDay:\"어제 LT\",lastWeek:\"지난주 dddd LT\",sameElse:\"L\"},relativeTime:{future:\"%s 후\",past:\"%s 전\",s:\"몇 초\",ss:\"%d초\",m:\"1분\",mm:\"%d분\",h:\"한 시간\",hh:\"%d시간\",d:\"하루\",dd:\"%d일\",M:\"한 달\",MM:\"%d달\",y:\"일 년\",yy:\"%d년\"},dayOfMonthOrdinalParse:/\\d{1,2}일/,ordinal:\"%d일\",meridiemParse:/오전|오후/,isPM:function(e){return\"오후\"===e},meridiem:function(e,a,t){return e<12?\"오전\":\"오후\"}});var o_={0:\"-чү\",1:\"-чи\",2:\"-чи\",3:\"-чү\",4:\"-чү\",5:\"-чи\",6:\"-чы\",7:\"-чи\",8:\"-чи\",9:\"-чу\",10:\"-чу\",20:\"-чы\",30:\"-чу\",40:\"-чы\",50:\"-чү\",60:\"-чы\",70:\"-чи\",80:\"-чи\",90:\"-чу\",100:\"-чү\"};e.defineLocale(\"ky\",{months:\"январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь\".split(\"_\"),monthsShort:\"янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек\".split(\"_\"),weekdays:\"Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби\".split(\"_\"),weekdaysShort:\"Жек_Дүй_Шей_Шар_Бей_Жум_Ише\".split(\"_\"),weekdaysMin:\"Жк_Дй_Шй_Шр_Бй_Жм_Иш\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Бүгүн саат] LT\",nextDay:\"[Эртең саат] LT\",nextWeek:\"dddd [саат] LT\",lastDay:\"[Кече саат] LT\",lastWeek:\"[Өткен аптанын] dddd [күнү] [саат] LT\",sameElse:\"L\"},relativeTime:{future:\"%s ичинде\",past:\"%s мурун\",s:\"бирнече секунд\",m:\"бир мүнөт\",mm:\"%d мүнөт\",h:\"бир саат\",hh:\"%d саат\",d:\"бир күн\",dd:\"%d күн\",M:\"бир ай\",MM:\"%d ай\",y:\"бир жыл\",yy:\"%d жыл\"},dayOfMonthOrdinalParse:/\\d{1,2}-(чи|чы|чү|чу)/,ordinal:function(e){var a=e%10,t=e>=100?100:null;return e+(o_[e]||o_[a]||o_[t])},week:{dow:1,doy:7}}),e.defineLocale(\"lb\",{months:\"Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember\".split(\"_\"),monthsShort:\"Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.\".split(\"_\"),monthsParseExact:!0,weekdays:\"Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg\".split(\"_\"),weekdaysShort:\"So._Mé._Dë._Më._Do._Fr._Sa.\".split(\"_\"),weekdaysMin:\"So_Mé_Dë_Më_Do_Fr_Sa\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm [Auer]\",LTS:\"H:mm:ss [Auer]\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm [Auer]\",LLLL:\"dddd, D. MMMM YYYY H:mm [Auer]\"},calendar:{sameDay:\"[Haut um] LT\",sameElse:\"L\",nextDay:\"[Muer um] LT\",nextWeek:\"dddd [um] LT\",lastDay:\"[Gëschter um] LT\",lastWeek:function(){switch(this.day()){case 2:case 4:return\"[Leschten] dddd [um] LT\";default:return\"[Leschte] dddd [um] LT\"}}},relativeTime:{future:Rs,past:Ns,s:\"e puer Sekonnen\",m:Js,mm:\"%d Minutten\",h:Js,hh:\"%d Stonnen\",d:Js,dd:\"%d Deeg\",M:Js,MM:\"%d Méint\",y:Js,yy:\"%d Joer\"},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}}),e.defineLocale(\"lo\",{months:\"ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ\".split(\"_\"),monthsShort:\"ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ\".split(\"_\"),weekdays:\"ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ\".split(\"_\"),weekdaysShort:\"ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ\".split(\"_\"),weekdaysMin:\"ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"ວັນdddd D MMMM YYYY HH:mm\"},meridiemParse:/ຕອນເຊົ້າ|ຕອນແລງ/,isPM:function(e){return\"ຕອນແລງ\"===e},meridiem:function(e,a,t){return e<12?\"ຕອນເຊົ້າ\":\"ຕອນແລງ\"},calendar:{sameDay:\"[ມື້ນີ້ເວລາ] LT\",nextDay:\"[ມື້ອື່ນເວລາ] LT\",nextWeek:\"[ວັນ]dddd[ໜ້າເວລາ] LT\",lastDay:\"[ມື້ວານນີ້ເວລາ] LT\",lastWeek:\"[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT\",sameElse:\"L\"},relativeTime:{future:\"ອີກ %s\",past:\"%sຜ່ານມາ\",s:\"ບໍ່ເທົ່າໃດວິນາທີ\",m:\"1 ນາທີ\",mm:\"%d ນາທີ\",h:\"1 ຊົ່ວໂມງ\",hh:\"%d ຊົ່ວໂມງ\",d:\"1 ມື້\",dd:\"%d ມື້\",M:\"1 ເດືອນ\",MM:\"%d ເດືອນ\",y:\"1 ປີ\",yy:\"%d ປີ\"},dayOfMonthOrdinalParse:/(ທີ່)\\d{1,2}/,ordinal:function(e){return\"ທີ່\"+e}});var m_={m:\"minutė_minutės_minutę\",mm:\"minutės_minučių_minutes\",h:\"valanda_valandos_valandą\",hh:\"valandos_valandų_valandas\",d:\"diena_dienos_dieną\",dd:\"dienos_dienų_dienas\",M:\"mėnuo_mėnesio_mėnesį\",MM:\"mėnesiai_mėnesių_mėnesius\",y:\"metai_metų_metus\",yy:\"metai_metų_metus\"};e.defineLocale(\"lt\",{months:{format:\"sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio\".split(\"_\"),standalone:\"sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis\".split(\"_\"),isFormat:/D[oD]?(\\[[^\\[\\]]*\\]|\\s)+MMMM?|MMMM?(\\[[^\\[\\]]*\\]|\\s)+D[oD]?/},monthsShort:\"sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd\".split(\"_\"),weekdays:{format:\"sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį\".split(\"_\"),standalone:\"sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis\".split(\"_\"),isFormat:/dddd HH:mm/},weekdaysShort:\"Sek_Pir_Ant_Tre_Ket_Pen_Šeš\".split(\"_\"),weekdaysMin:\"S_P_A_T_K_Pn_Š\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"YYYY-MM-DD\",LL:\"YYYY [m.] MMMM D [d.]\",LLL:\"YYYY [m.] MMMM D [d.], HH:mm [val.]\",LLLL:\"YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]\",l:\"YYYY-MM-DD\",ll:\"YYYY [m.] MMMM D [d.]\",lll:\"YYYY [m.] MMMM D [d.], HH:mm [val.]\",llll:\"YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]\"},calendar:{sameDay:\"[Šiandien] LT\",nextDay:\"[Rytoj] LT\",nextWeek:\"dddd LT\",lastDay:\"[Vakar] LT\",lastWeek:\"[Praėjusį] dddd LT\",sameElse:\"L\"},relativeTime:{future:\"po %s\",past:\"prieš %s\",s:Is,m:Gs,mm:$s,h:Gs,hh:$s,d:Gs,dd:$s,M:Gs,MM:$s,y:Gs,yy:$s},dayOfMonthOrdinalParse:/\\d{1,2}-oji/,ordinal:function(e){return e+\"-oji\"},week:{dow:1,doy:4}});var u_={m:\"minūtes_minūtēm_minūte_minūtes\".split(\"_\"),mm:\"minūtes_minūtēm_minūte_minūtes\".split(\"_\"),h:\"stundas_stundām_stunda_stundas\".split(\"_\"),hh:\"stundas_stundām_stunda_stundas\".split(\"_\"),d:\"dienas_dienām_diena_dienas\".split(\"_\"),dd:\"dienas_dienām_diena_dienas\".split(\"_\"),M:\"mēneša_mēnešiem_mēnesis_mēneši\".split(\"_\"),MM:\"mēneša_mēnešiem_mēnesis_mēneši\".split(\"_\"),y:\"gada_gadiem_gads_gadi\".split(\"_\"),yy:\"gada_gadiem_gads_gadi\".split(\"_\")};e.defineLocale(\"lv\",{months:\"janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris\".split(\"_\"),monthsShort:\"jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec\".split(\"_\"),weekdays:\"svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena\".split(\"_\"),weekdaysShort:\"Sv_P_O_T_C_Pk_S\".split(\"_\"),weekdaysMin:\"Sv_P_O_T_C_Pk_S\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY.\",LL:\"YYYY. [gada] D. MMMM\",LLL:\"YYYY. [gada] D. MMMM, HH:mm\",LLLL:\"YYYY. [gada] D. MMMM, dddd, HH:mm\"},calendar:{sameDay:\"[Šodien pulksten] LT\",nextDay:\"[Rīt pulksten] LT\",nextWeek:\"dddd [pulksten] LT\",lastDay:\"[Vakar pulksten] LT\",lastWeek:\"[Pagājušā] dddd [pulksten] LT\",sameElse:\"L\"},relativeTime:{future:\"pēc %s\",past:\"pirms %s\",s:Bs,m:qs,mm:Zs,h:qs,hh:Zs,d:qs,dd:Zs,M:qs,MM:Zs,y:qs,yy:Zs},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});var l_={words:{m:[\"jedan minut\",\"jednog minuta\"],mm:[\"minut\",\"minuta\",\"minuta\"],h:[\"jedan sat\",\"jednog sata\"],hh:[\"sat\",\"sata\",\"sati\"],dd:[\"dan\",\"dana\",\"dana\"],MM:[\"mjesec\",\"mjeseca\",\"mjeseci\"],yy:[\"godina\",\"godine\",\"godina\"]},correctGrammaticalCase:function(e,a){return 1===e?a[0]:e>=2&&e<=4?a[1]:a[2]},translate:function(e,a,t){var s=l_.words[t];return 1===t.length?a?s[0]:s[1]:e+\" \"+l_.correctGrammaticalCase(e,s)}};e.defineLocale(\"me\",{months:\"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar\".split(\"_\"),monthsShort:\"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.\".split(\"_\"),monthsParseExact:!0,weekdays:\"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota\".split(\"_\"),weekdaysShort:\"ned._pon._uto._sri._čet._pet._sub.\".split(\"_\"),weekdaysMin:\"ne_po_ut_sr_če_pe_su\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm\",LLLL:\"dddd, D. MMMM YYYY H:mm\"},calendar:{sameDay:\"[danas u] LT\",nextDay:\"[sjutra u] LT\",nextWeek:function(){switch(this.day()){case 0:return\"[u] [nedjelju] [u] LT\";case 3:return\"[u] [srijedu] [u] LT\";case 6:return\"[u] [subotu] [u] LT\";case 1:case 2:case 4:case 5:return\"[u] dddd [u] LT\"}},lastDay:\"[juče u] LT\",lastWeek:function(){return[\"[prošle] [nedjelje] [u] LT\",\"[prošlog] [ponedjeljka] [u] LT\",\"[prošlog] [utorka] [u] LT\",\"[prošle] [srijede] [u] LT\",\"[prošlog] [četvrtka] [u] LT\",\"[prošlog] [petka] [u] LT\",\"[prošle] [subote] [u] LT\"][this.day()]},sameElse:\"L\"},relativeTime:{future:\"za %s\",past:\"prije %s\",s:\"nekoliko sekundi\",m:l_.translate,mm:l_.translate,h:l_.translate,hh:l_.translate,d:\"dan\",dd:l_.translate,M:\"mjesec\",MM:l_.translate,y:\"godinu\",yy:l_.translate},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:7}}),e.defineLocale(\"mi\",{months:\"Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea\".split(\"_\"),monthsShort:\"Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki\".split(\"_\"),monthsRegex:/(?:['a-z\\u0101\\u014D\\u016B]+\\-?){1,3}/i,monthsStrictRegex:/(?:['a-z\\u0101\\u014D\\u016B]+\\-?){1,3}/i,monthsShortRegex:/(?:['a-z\\u0101\\u014D\\u016B]+\\-?){1,3}/i,monthsShortStrictRegex:/(?:['a-z\\u0101\\u014D\\u016B]+\\-?){1,2}/i,weekdays:\"Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei\".split(\"_\"),weekdaysShort:\"Ta_Ma_Tū_We_Tāi_Pa_Hā\".split(\"_\"),weekdaysMin:\"Ta_Ma_Tū_We_Tāi_Pa_Hā\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY [i] HH:mm\",LLLL:\"dddd, D MMMM YYYY [i] HH:mm\"},calendar:{sameDay:\"[i teie mahana, i] LT\",nextDay:\"[apopo i] LT\",nextWeek:\"dddd [i] LT\",lastDay:\"[inanahi i] LT\",lastWeek:\"dddd [whakamutunga i] LT\",sameElse:\"L\"},relativeTime:{future:\"i roto i %s\",past:\"%s i mua\",s:\"te hēkona ruarua\",m:\"he meneti\",mm:\"%d meneti\",h:\"te haora\",hh:\"%d haora\",d:\"he ra\",dd:\"%d ra\",M:\"he marama\",MM:\"%d marama\",y:\"he tau\",yy:\"%d tau\"},dayOfMonthOrdinalParse:/\\d{1,2}º/,ordinal:\"%dº\",week:{dow:1,doy:4}}),e.defineLocale(\"mk\",{months:\"јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември\".split(\"_\"),monthsShort:\"јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек\".split(\"_\"),weekdays:\"недела_понеделник_вторник_среда_четврток_петок_сабота\".split(\"_\"),weekdaysShort:\"нед_пон_вто_сре_чет_пет_саб\".split(\"_\"),weekdaysMin:\"нe_пo_вт_ср_че_пе_сa\".split(\"_\"),longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"D.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY H:mm\",LLLL:\"dddd, D MMMM YYYY H:mm\"},calendar:{sameDay:\"[Денес во] LT\",nextDay:\"[Утре во] LT\",nextWeek:\"[Во] dddd [во] LT\",lastDay:\"[Вчера во] LT\",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return\"[Изминатата] dddd [во] LT\";case 1:case 2:case 4:case 5:return\"[Изминатиот] dddd [во] LT\"}},sameElse:\"L\"},relativeTime:{future:\"после %s\",past:\"пред %s\",s:\"неколку секунди\",m:\"минута\",mm:\"%d минути\",h:\"час\",hh:\"%d часа\",d:\"ден\",dd:\"%d дена\",M:\"месец\",MM:\"%d месеци\",y:\"година\",yy:\"%d години\"},dayOfMonthOrdinalParse:/\\d{1,2}-(ев|ен|ти|ви|ри|ми)/,ordinal:function(e){var a=e%10,t=e%100;return 0===e?e+\"-ев\":0===t?e+\"-ен\":t>10&&t<20?e+\"-ти\":1===a?e+\"-ви\":2===a?e+\"-ри\":7===a||8===a?e+\"-ми\":e+\"-ти\"},week:{dow:1,doy:7}}),e.defineLocale(\"ml\",{months:\"ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ\".split(\"_\"),monthsShort:\"ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.\".split(\"_\"),monthsParseExact:!0,weekdays:\"ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച\".split(\"_\"),weekdaysShort:\"ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി\".split(\"_\"),weekdaysMin:\"ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ\".split(\"_\"),longDateFormat:{LT:\"A h:mm -നു\",LTS:\"A h:mm:ss -നു\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, A h:mm -നു\",LLLL:\"dddd, D MMMM YYYY, A h:mm -നു\"},calendar:{sameDay:\"[ഇന്ന്] LT\",nextDay:\"[നാളെ] LT\",nextWeek:\"dddd, LT\",lastDay:\"[ഇന്നലെ] LT\",lastWeek:\"[കഴിഞ്ഞ] dddd, LT\",sameElse:\"L\"},relativeTime:{future:\"%s കഴിഞ്ഞ്\",past:\"%s മുൻപ്\",s:\"അൽപ നിമിഷങ്ങൾ\",m:\"ഒരു മിനിറ്റ്\",mm:\"%d മിനിറ്റ്\",h:\"ഒരു മണിക്കൂർ\",hh:\"%d മണിക്കൂർ\",d:\"ഒരു ദിവസം\",dd:\"%d ദിവസം\",M:\"ഒരു മാസം\",MM:\"%d മാസം\",y:\"ഒരു വർഷം\",yy:\"%d വർഷം\"},meridiemParse:/രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,meridiemHour:function(e,a){return 12===e&&(e=0),\"രാത്രി\"===a&&e>=4||\"ഉച്ച കഴിഞ്ഞ്\"===a||\"വൈകുന്നേരം\"===a?e+12:e},meridiem:function(e,a,t){return e<4?\"രാത്രി\":e<12?\"രാവിലെ\":e<17?\"ഉച്ച കഴിഞ്ഞ്\":e<20?\"വൈകുന്നേരം\":\"രാത്രി\"}});var M_={1:\"१\",2:\"२\",3:\"३\",4:\"४\",5:\"५\",6:\"६\",7:\"७\",8:\"८\",9:\"९\",0:\"०\"},h_={\"१\":\"1\",\"२\":\"2\",\"३\":\"3\",\"४\":\"4\",\"५\":\"5\",\"६\":\"6\",\"७\":\"7\",\"८\":\"8\",\"९\":\"9\",\"०\":\"0\"};e.defineLocale(\"mr\",{months:\"जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर\".split(\"_\"),monthsShort:\"जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.\".split(\"_\"),monthsParseExact:!0,weekdays:\"रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार\".split(\"_\"),weekdaysShort:\"रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि\".split(\"_\"),weekdaysMin:\"र_सो_मं_बु_गु_शु_श\".split(\"_\"),longDateFormat:{LT:\"A h:mm वाजता\",LTS:\"A h:mm:ss वाजता\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, A h:mm वाजता\",LLLL:\"dddd, D MMMM YYYY, A h:mm वाजता\"},calendar:{sameDay:\"[आज] LT\",nextDay:\"[उद्या] LT\",nextWeek:\"dddd, LT\",lastDay:\"[काल] LT\",lastWeek:\"[मागील] dddd, LT\",sameElse:\"L\"},relativeTime:{future:\"%sमध्ये\",past:\"%sपूर्वी\",s:Qs,m:Qs,mm:Qs,h:Qs,hh:Qs,d:Qs,dd:Qs,M:Qs,MM:Qs,y:Qs,yy:Qs},preparse:function(e){return e.replace(/[१२३४५६७८९०]/g,function(e){return h_[e]})},postformat:function(e){return e.replace(/\\d/g,function(e){return M_[e]})},meridiemParse:/रात्री|सकाळी|दुपारी|सायंकाळी/,meridiemHour:function(e,a){return 12===e&&(e=0),\"रात्री\"===a?e<4?e:e+12:\"सकाळी\"===a?e:\"दुपारी\"===a?e>=10?e:e+12:\"सायंकाळी\"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?\"रात्री\":e<10?\"सकाळी\":e<17?\"दुपारी\":e<20?\"सायंकाळी\":\"रात्री\"},week:{dow:0,doy:6}}),e.defineLocale(\"ms-my\",{months:\"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember\".split(\"_\"),monthsShort:\"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis\".split(\"_\"),weekdays:\"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu\".split(\"_\"),weekdaysShort:\"Ahd_Isn_Sel_Rab_Kha_Jum_Sab\".split(\"_\"),weekdaysMin:\"Ah_Is_Sl_Rb_Km_Jm_Sb\".split(\"_\"),longDateFormat:{LT:\"HH.mm\",LTS:\"HH.mm.ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY [pukul] HH.mm\",LLLL:\"dddd, D MMMM YYYY [pukul] HH.mm\"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),\"pagi\"===a?e:\"tengahari\"===a?e>=11?e:e+12:\"petang\"===a||\"malam\"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?\"pagi\":e<15?\"tengahari\":e<19?\"petang\":\"malam\"},calendar:{sameDay:\"[Hari ini pukul] LT\",nextDay:\"[Esok pukul] LT\",nextWeek:\"dddd [pukul] LT\",lastDay:\"[Kelmarin pukul] LT\",lastWeek:\"dddd [lepas pukul] LT\",sameElse:\"L\"},relativeTime:{future:\"dalam %s\",past:\"%s yang lepas\",s:\"beberapa saat\",m:\"seminit\",mm:\"%d minit\",h:\"sejam\",hh:\"%d jam\",d:\"sehari\",dd:\"%d hari\",M:\"sebulan\",MM:\"%d bulan\",y:\"setahun\",yy:\"%d tahun\"},week:{dow:1,doy:7}}),e.defineLocale(\"ms\",{months:\"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember\".split(\"_\"),monthsShort:\"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis\".split(\"_\"),weekdays:\"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu\".split(\"_\"),weekdaysShort:\"Ahd_Isn_Sel_Rab_Kha_Jum_Sab\".split(\"_\"),weekdaysMin:\"Ah_Is_Sl_Rb_Km_Jm_Sb\".split(\"_\"),longDateFormat:{LT:\"HH.mm\",LTS:\"HH.mm.ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY [pukul] HH.mm\",LLLL:\"dddd, D MMMM YYYY [pukul] HH.mm\"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),\"pagi\"===a?e:\"tengahari\"===a?e>=11?e:e+12:\"petang\"===a||\"malam\"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?\"pagi\":e<15?\"tengahari\":e<19?\"petang\":\"malam\"},calendar:{sameDay:\"[Hari ini pukul] LT\",nextDay:\"[Esok pukul] LT\",nextWeek:\"dddd [pukul] LT\",lastDay:\"[Kelmarin pukul] LT\",lastWeek:\"dddd [lepas pukul] LT\",sameElse:\"L\"},relativeTime:{future:\"dalam %s\",past:\"%s yang lepas\",s:\"beberapa saat\",m:\"seminit\",mm:\"%d minit\",h:\"sejam\",hh:\"%d jam\",d:\"sehari\",dd:\"%d hari\",M:\"sebulan\",MM:\"%d bulan\",y:\"setahun\",yy:\"%d tahun\"},week:{dow:1,doy:7}});var L_={1:\"၁\",2:\"၂\",3:\"၃\",4:\"၄\",5:\"၅\",6:\"၆\",7:\"၇\",8:\"၈\",9:\"၉\",0:\"၀\"},c_={\"၁\":\"1\",\"၂\":\"2\",\"၃\":\"3\",\"၄\":\"4\",\"၅\":\"5\",\"၆\":\"6\",\"၇\":\"7\",\"၈\":\"8\",\"၉\":\"9\",\"၀\":\"0\"};e.defineLocale(\"my\",{months:\"ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ\".split(\"_\"),monthsShort:\"ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ\".split(\"_\"),weekdays:\"တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ\".split(\"_\"),weekdaysShort:\"နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ\".split(\"_\"),weekdaysMin:\"နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[ယနေ.] LT [မှာ]\",nextDay:\"[မနက်ဖြန်] LT [မှာ]\",nextWeek:\"dddd LT [မှာ]\",lastDay:\"[မနေ.က] LT [မှာ]\",lastWeek:\"[ပြီးခဲ့သော] dddd LT [မှာ]\",sameElse:\"L\"},relativeTime:{future:\"လာမည့် %s မှာ\",past:\"လွန်ခဲ့သော %s က\",s:\"စက္ကန်.အနည်းငယ်\",m:\"တစ်မိနစ်\",mm:\"%d မိနစ်\",h:\"တစ်နာရီ\",hh:\"%d နာရီ\",d:\"တစ်ရက်\",dd:\"%d ရက်\",M:\"တစ်လ\",MM:\"%d လ\",y:\"တစ်နှစ်\",yy:\"%d နှစ်\"},preparse:function(e){return e.replace(/[၁၂၃၄၅၆၇၈၉၀]/g,function(e){return c_[e]})},postformat:function(e){return e.replace(/\\d/g,function(e){return L_[e]})},week:{dow:1,doy:4}}),e.defineLocale(\"nb\",{months:\"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember\".split(\"_\"),monthsShort:\"jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.\".split(\"_\"),monthsParseExact:!0,weekdays:\"søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag\".split(\"_\"),weekdaysShort:\"sø._ma._ti._on._to._fr._lø.\".split(\"_\"),weekdaysMin:\"sø_ma_ti_on_to_fr_lø\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY [kl.] HH:mm\",LLLL:\"dddd D. MMMM YYYY [kl.] HH:mm\"},calendar:{sameDay:\"[i dag kl.] LT\",nextDay:\"[i morgen kl.] LT\",nextWeek:\"dddd [kl.] LT\",lastDay:\"[i går kl.] LT\",lastWeek:\"[forrige] dddd [kl.] LT\",sameElse:\"L\"},relativeTime:{future:\"om %s\",past:\"%s siden\",s:\"noen sekunder\",m:\"ett minutt\",mm:\"%d minutter\",h:\"en time\",hh:\"%d timer\",d:\"en dag\",dd:\"%d dager\",M:\"en måned\",MM:\"%d måneder\",y:\"ett år\",yy:\"%d år\"},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});var Y_={1:\"१\",2:\"२\",3:\"३\",4:\"४\",5:\"५\",6:\"६\",7:\"७\",8:\"८\",9:\"९\",0:\"०\"},y_={\"१\":\"1\",\"२\":\"2\",\"३\":\"3\",\"४\":\"4\",\"५\":\"5\",\"६\":\"6\",\"७\":\"7\",\"८\":\"8\",\"९\":\"9\",\"०\":\"0\"};e.defineLocale(\"ne\",{months:\"जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर\".split(\"_\"),monthsShort:\"जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.\".split(\"_\"),monthsParseExact:!0,weekdays:\"आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार\".split(\"_\"),weekdaysShort:\"आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.\".split(\"_\"),weekdaysMin:\"आ._सो._मं._बु._बि._शु._श.\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"Aको h:mm बजे\",LTS:\"Aको h:mm:ss बजे\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, Aको h:mm बजे\",LLLL:\"dddd, D MMMM YYYY, Aको h:mm बजे\"},preparse:function(e){return e.replace(/[१२३४५६७८९०]/g,function(e){return y_[e]})},postformat:function(e){return e.replace(/\\d/g,function(e){return Y_[e]})},meridiemParse:/राति|बिहान|दिउँसो|साँझ/,meridiemHour:function(e,a){return 12===e&&(e=0),\"राति\"===a?e<4?e:e+12:\"बिहान\"===a?e:\"दिउँसो\"===a?e>=10?e:e+12:\"साँझ\"===a?e+12:void 0},meridiem:function(e,a,t){return e<3?\"राति\":e<12?\"बिहान\":e<16?\"दिउँसो\":e<20?\"साँझ\":\"राति\"},calendar:{sameDay:\"[आज] LT\",nextDay:\"[भोलि] LT\",nextWeek:\"[आउँदो] dddd[,] LT\",lastDay:\"[हिजो] LT\",lastWeek:\"[गएको] dddd[,] LT\",sameElse:\"L\"},relativeTime:{future:\"%sमा\",past:\"%s अगाडि\",s:\"केही क्षण\",m:\"एक मिनेट\",mm:\"%d मिनेट\",h:\"एक घण्टा\",hh:\"%d घण्टा\",d:\"एक दिन\",dd:\"%d दिन\",M:\"एक महिना\",MM:\"%d महिना\",y:\"एक बर्ष\",yy:\"%d बर्ष\"},week:{dow:0,doy:6}});var f_=\"jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.\".split(\"_\"),p_=\"jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec\".split(\"_\"),D_=[/^jan/i,/^feb/i,/^maart|mrt.?$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],k_=/^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\\.?|feb\\.?|mrt\\.?|apr\\.?|ju[nl]\\.?|aug\\.?|sep\\.?|okt\\.?|nov\\.?|dec\\.?)/i;e.defineLocale(\"nl-be\",{months:\"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december\".split(\"_\"),monthsShort:function(e,a){return e?/-MMM-/.test(a)?p_[e.month()]:f_[e.month()]:f_},monthsRegex:k_,monthsShortRegex:k_,monthsStrictRegex:/^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\\.?|feb\\.?|mrt\\.?|apr\\.?|mei|ju[nl]\\.?|aug\\.?|sep\\.?|okt\\.?|nov\\.?|dec\\.?)/i,monthsParse:D_,longMonthsParse:D_,shortMonthsParse:D_,weekdays:\"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag\".split(\"_\"),weekdaysShort:\"zo._ma._di._wo._do._vr._za.\".split(\"_\"),weekdaysMin:\"Zo_Ma_Di_Wo_Do_Vr_Za\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[vandaag om] LT\",nextDay:\"[morgen om] LT\",nextWeek:\"dddd [om] LT\",lastDay:\"[gisteren om] LT\",lastWeek:\"[afgelopen] dddd [om] LT\",sameElse:\"L\"},relativeTime:{future:\"over %s\",past:\"%s geleden\",s:\"een paar seconden\",m:\"één minuut\",mm:\"%d minuten\",h:\"één uur\",hh:\"%d uur\",d:\"één dag\",dd:\"%d dagen\",M:\"één maand\",MM:\"%d maanden\",y:\"één jaar\",yy:\"%d jaar\"},dayOfMonthOrdinalParse:/\\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?\"ste\":\"de\")},week:{dow:1,doy:4}});var T_=\"jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.\".split(\"_\"),g_=\"jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec\".split(\"_\"),w_=[/^jan/i,/^feb/i,/^maart|mrt.?$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],v_=/^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\\.?|feb\\.?|mrt\\.?|apr\\.?|ju[nl]\\.?|aug\\.?|sep\\.?|okt\\.?|nov\\.?|dec\\.?)/i;e.defineLocale(\"nl\",{months:\"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december\".split(\"_\"),monthsShort:function(e,a){return e?/-MMM-/.test(a)?g_[e.month()]:T_[e.month()]:T_},monthsRegex:v_,monthsShortRegex:v_,monthsStrictRegex:/^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\\.?|feb\\.?|mrt\\.?|apr\\.?|mei|ju[nl]\\.?|aug\\.?|sep\\.?|okt\\.?|nov\\.?|dec\\.?)/i,monthsParse:w_,longMonthsParse:w_,shortMonthsParse:w_,weekdays:\"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag\".split(\"_\"),weekdaysShort:\"zo._ma._di._wo._do._vr._za.\".split(\"_\"),weekdaysMin:\"Zo_Ma_Di_Wo_Do_Vr_Za\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD-MM-YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[vandaag om] LT\",nextDay:\"[morgen om] LT\",nextWeek:\"dddd [om] LT\",lastDay:\"[gisteren om] LT\",lastWeek:\"[afgelopen] dddd [om] LT\",sameElse:\"L\"},relativeTime:{future:\"over %s\",past:\"%s geleden\",s:\"een paar seconden\",m:\"één minuut\",mm:\"%d minuten\",h:\"één uur\",hh:\"%d uur\",d:\"één dag\",dd:\"%d dagen\",M:\"één maand\",MM:\"%d maanden\",y:\"één jaar\",yy:\"%d jaar\"},dayOfMonthOrdinalParse:/\\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?\"ste\":\"de\")},week:{dow:1,doy:4}}),e.defineLocale(\"nn\",{months:\"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember\".split(\"_\"),monthsShort:\"jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des\".split(\"_\"),weekdays:\"sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag\".split(\"_\"),weekdaysShort:\"sun_mån_tys_ons_tor_fre_lau\".split(\"_\"),weekdaysMin:\"su_må_ty_on_to_fr_lø\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY [kl.] H:mm\",LLLL:\"dddd D. MMMM YYYY [kl.] HH:mm\"},calendar:{sameDay:\"[I dag klokka] LT\",nextDay:\"[I morgon klokka] LT\",nextWeek:\"dddd [klokka] LT\",lastDay:\"[I går klokka] LT\",lastWeek:\"[Føregåande] dddd [klokka] LT\",sameElse:\"L\"},relativeTime:{future:\"om %s\",past:\"%s sidan\",s:\"nokre sekund\",m:\"eit minutt\",\nmm:\"%d minutt\",h:\"ein time\",hh:\"%d timar\",d:\"ein dag\",dd:\"%d dagar\",M:\"ein månad\",MM:\"%d månader\",y:\"eit år\",yy:\"%d år\"},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});var H_={1:\"੧\",2:\"੨\",3:\"੩\",4:\"੪\",5:\"੫\",6:\"੬\",7:\"੭\",8:\"੮\",9:\"੯\",0:\"੦\"},S_={\"੧\":\"1\",\"੨\":\"2\",\"੩\":\"3\",\"੪\":\"4\",\"੫\":\"5\",\"੬\":\"6\",\"੭\":\"7\",\"੮\":\"8\",\"੯\":\"9\",\"੦\":\"0\"};e.defineLocale(\"pa-in\",{months:\"ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ\".split(\"_\"),monthsShort:\"ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ\".split(\"_\"),weekdays:\"ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ\".split(\"_\"),weekdaysShort:\"ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ\".split(\"_\"),weekdaysMin:\"ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ\".split(\"_\"),longDateFormat:{LT:\"A h:mm ਵਜੇ\",LTS:\"A h:mm:ss ਵਜੇ\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, A h:mm ਵਜੇ\",LLLL:\"dddd, D MMMM YYYY, A h:mm ਵਜੇ\"},calendar:{sameDay:\"[ਅਜ] LT\",nextDay:\"[ਕਲ] LT\",nextWeek:\"dddd, LT\",lastDay:\"[ਕਲ] LT\",lastWeek:\"[ਪਿਛਲੇ] dddd, LT\",sameElse:\"L\"},relativeTime:{future:\"%s ਵਿੱਚ\",past:\"%s ਪਿਛਲੇ\",s:\"ਕੁਝ ਸਕਿੰਟ\",m:\"ਇਕ ਮਿੰਟ\",mm:\"%d ਮਿੰਟ\",h:\"ਇੱਕ ਘੰਟਾ\",hh:\"%d ਘੰਟੇ\",d:\"ਇੱਕ ਦਿਨ\",dd:\"%d ਦਿਨ\",M:\"ਇੱਕ ਮਹੀਨਾ\",MM:\"%d ਮਹੀਨੇ\",y:\"ਇੱਕ ਸਾਲ\",yy:\"%d ਸਾਲ\"},preparse:function(e){return e.replace(/[੧੨੩੪੫੬੭੮੯੦]/g,function(e){return S_[e]})},postformat:function(e){return e.replace(/\\d/g,function(e){return H_[e]})},meridiemParse:/ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,meridiemHour:function(e,a){return 12===e&&(e=0),\"ਰਾਤ\"===a?e<4?e:e+12:\"ਸਵੇਰ\"===a?e:\"ਦੁਪਹਿਰ\"===a?e>=10?e:e+12:\"ਸ਼ਾਮ\"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?\"ਰਾਤ\":e<10?\"ਸਵੇਰ\":e<17?\"ਦੁਪਹਿਰ\":e<20?\"ਸ਼ਾਮ\":\"ਰਾਤ\"},week:{dow:0,doy:6}});var b_=\"styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień\".split(\"_\"),j_=\"stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia\".split(\"_\");e.defineLocale(\"pl\",{months:function(e,a){return e?\"\"===a?\"(\"+j_[e.month()]+\"|\"+b_[e.month()]+\")\":/D MMMM/.test(a)?j_[e.month()]:b_[e.month()]:b_},monthsShort:\"sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru\".split(\"_\"),weekdays:\"niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota\".split(\"_\"),weekdaysShort:\"ndz_pon_wt_śr_czw_pt_sob\".split(\"_\"),weekdaysMin:\"Nd_Pn_Wt_Śr_Cz_Pt_So\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Dziś o] LT\",nextDay:\"[Jutro o] LT\",nextWeek:\"[W] dddd [o] LT\",lastDay:\"[Wczoraj o] LT\",lastWeek:function(){switch(this.day()){case 0:return\"[W zeszłą niedzielę o] LT\";case 3:return\"[W zeszłą środę o] LT\";case 6:return\"[W zeszłą sobotę o] LT\";default:return\"[W zeszły] dddd [o] LT\"}},sameElse:\"L\"},relativeTime:{future:\"za %s\",past:\"%s temu\",s:\"kilka sekund\",m:en,mm:en,h:en,hh:en,d:\"1 dzień\",dd:\"%d dni\",M:\"miesiąc\",MM:en,y:\"rok\",yy:en},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}}),e.defineLocale(\"pt-br\",{months:\"Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro\".split(\"_\"),monthsShort:\"Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez\".split(\"_\"),weekdays:\"Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado\".split(\"_\"),weekdaysShort:\"Dom_Seg_Ter_Qua_Qui_Sex_Sáb\".split(\"_\"),weekdaysMin:\"Do_2ª_3ª_4ª_5ª_6ª_Sá\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D [de] MMMM [de] YYYY\",LLL:\"D [de] MMMM [de] YYYY [às] HH:mm\",LLLL:\"dddd, D [de] MMMM [de] YYYY [às] HH:mm\"},calendar:{sameDay:\"[Hoje às] LT\",nextDay:\"[Amanhã às] LT\",nextWeek:\"dddd [às] LT\",lastDay:\"[Ontem às] LT\",lastWeek:function(){return 0===this.day()||6===this.day()?\"[Último] dddd [às] LT\":\"[Última] dddd [às] LT\"},sameElse:\"L\"},relativeTime:{future:\"em %s\",past:\"%s atrás\",s:\"poucos segundos\",m:\"um minuto\",mm:\"%d minutos\",h:\"uma hora\",hh:\"%d horas\",d:\"um dia\",dd:\"%d dias\",M:\"um mês\",MM:\"%d meses\",y:\"um ano\",yy:\"%d anos\"},dayOfMonthOrdinalParse:/\\d{1,2}º/,ordinal:\"%dº\"}),e.defineLocale(\"pt\",{months:\"Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro\".split(\"_\"),monthsShort:\"Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez\".split(\"_\"),weekdays:\"Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado\".split(\"_\"),weekdaysShort:\"Dom_Seg_Ter_Qua_Qui_Sex_Sáb\".split(\"_\"),weekdaysMin:\"Do_2ª_3ª_4ª_5ª_6ª_Sá\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D [de] MMMM [de] YYYY\",LLL:\"D [de] MMMM [de] YYYY HH:mm\",LLLL:\"dddd, D [de] MMMM [de] YYYY HH:mm\"},calendar:{sameDay:\"[Hoje às] LT\",nextDay:\"[Amanhã às] LT\",nextWeek:\"dddd [às] LT\",lastDay:\"[Ontem às] LT\",lastWeek:function(){return 0===this.day()||6===this.day()?\"[Último] dddd [às] LT\":\"[Última] dddd [às] LT\"},sameElse:\"L\"},relativeTime:{future:\"em %s\",past:\"há %s\",s:\"segundos\",m:\"um minuto\",mm:\"%d minutos\",h:\"uma hora\",hh:\"%d horas\",d:\"um dia\",dd:\"%d dias\",M:\"um mês\",MM:\"%d meses\",y:\"um ano\",yy:\"%d anos\"},dayOfMonthOrdinalParse:/\\d{1,2}º/,ordinal:\"%dº\",week:{dow:1,doy:4}}),e.defineLocale(\"ro\",{months:\"ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie\".split(\"_\"),monthsShort:\"ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.\".split(\"_\"),monthsParseExact:!0,weekdays:\"duminică_luni_marți_miercuri_joi_vineri_sâmbătă\".split(\"_\"),weekdaysShort:\"Dum_Lun_Mar_Mie_Joi_Vin_Sâm\".split(\"_\"),weekdaysMin:\"Du_Lu_Ma_Mi_Jo_Vi_Sâ\".split(\"_\"),longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY H:mm\",LLLL:\"dddd, D MMMM YYYY H:mm\"},calendar:{sameDay:\"[azi la] LT\",nextDay:\"[mâine la] LT\",nextWeek:\"dddd [la] LT\",lastDay:\"[ieri la] LT\",lastWeek:\"[fosta] dddd [la] LT\",sameElse:\"L\"},relativeTime:{future:\"peste %s\",past:\"%s în urmă\",s:\"câteva secunde\",m:\"un minut\",mm:an,h:\"o oră\",hh:an,d:\"o zi\",dd:an,M:\"o lună\",MM:an,y:\"un an\",yy:an},week:{dow:1,doy:7}});var x_=[/^янв/i,/^фев/i,/^мар/i,/^апр/i,/^ма[йя]/i,/^июн/i,/^июл/i,/^авг/i,/^сен/i,/^окт/i,/^ноя/i,/^дек/i];e.defineLocale(\"ru\",{months:{format:\"января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря\".split(\"_\"),standalone:\"январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь\".split(\"_\")},monthsShort:{format:\"янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.\".split(\"_\"),standalone:\"янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.\".split(\"_\")},weekdays:{standalone:\"воскресенье_понедельник_вторник_среда_четверг_пятница_суббота\".split(\"_\"),format:\"воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу\".split(\"_\"),isFormat:/\\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\\] ?dddd/},weekdaysShort:\"вс_пн_вт_ср_чт_пт_сб\".split(\"_\"),weekdaysMin:\"вс_пн_вт_ср_чт_пт_сб\".split(\"_\"),monthsParse:x_,longMonthsParse:x_,shortMonthsParse:x_,monthsRegex:/^(январ[ья]|янв\\.?|феврал[ья]|февр?\\.?|марта?|мар\\.?|апрел[ья]|апр\\.?|ма[йя]|июн[ья]|июн\\.?|июл[ья]|июл\\.?|августа?|авг\\.?|сентябр[ья]|сент?\\.?|октябр[ья]|окт\\.?|ноябр[ья]|нояб?\\.?|декабр[ья]|дек\\.?)/i,monthsShortRegex:/^(январ[ья]|янв\\.?|феврал[ья]|февр?\\.?|марта?|мар\\.?|апрел[ья]|апр\\.?|ма[йя]|июн[ья]|июн\\.?|июл[ья]|июл\\.?|августа?|авг\\.?|сентябр[ья]|сент?\\.?|октябр[ья]|окт\\.?|ноябр[ья]|нояб?\\.?|декабр[ья]|дек\\.?)/i,monthsStrictRegex:/^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,monthsShortStrictRegex:/^(янв\\.|февр?\\.|мар[т.]|апр\\.|ма[яй]|июн[ья.]|июл[ья.]|авг\\.|сент?\\.|окт\\.|нояб?\\.|дек\\.)/i,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY г.\",LLL:\"D MMMM YYYY г., HH:mm\",LLLL:\"dddd, D MMMM YYYY г., HH:mm\"},calendar:{sameDay:\"[Сегодня в] LT\",nextDay:\"[Завтра в] LT\",lastDay:\"[Вчера в] LT\",nextWeek:function(e){if(e.week()===this.week())return 2===this.day()?\"[Во] dddd [в] LT\":\"[В] dddd [в] LT\";switch(this.day()){case 0:return\"[В следующее] dddd [в] LT\";case 1:case 2:case 4:return\"[В следующий] dddd [в] LT\";case 3:case 5:case 6:return\"[В следующую] dddd [в] LT\"}},lastWeek:function(e){if(e.week()===this.week())return 2===this.day()?\"[Во] dddd [в] LT\":\"[В] dddd [в] LT\";switch(this.day()){case 0:return\"[В прошлое] dddd [в] LT\";case 1:case 2:case 4:return\"[В прошлый] dddd [в] LT\";case 3:case 5:case 6:return\"[В прошлую] dddd [в] LT\"}},sameElse:\"L\"},relativeTime:{future:\"через %s\",past:\"%s назад\",s:\"несколько секунд\",m:sn,mm:sn,h:\"час\",hh:sn,d:\"день\",dd:sn,M:\"месяц\",MM:sn,y:\"год\",yy:sn},meridiemParse:/ночи|утра|дня|вечера/i,isPM:function(e){return/^(дня|вечера)$/.test(e)},meridiem:function(e,a,t){return e<4?\"ночи\":e<12?\"утра\":e<17?\"дня\":\"вечера\"},dayOfMonthOrdinalParse:/\\d{1,2}-(й|го|я)/,ordinal:function(e,a){switch(a){case\"M\":case\"d\":case\"DDD\":return e+\"-й\";case\"D\":return e+\"-го\";case\"w\":case\"W\":return e+\"-я\";default:return e}},week:{dow:1,doy:7}});var P_=[\"جنوري\",\"فيبروري\",\"مارچ\",\"اپريل\",\"مئي\",\"جون\",\"جولاءِ\",\"آگسٽ\",\"سيپٽمبر\",\"آڪٽوبر\",\"نومبر\",\"ڊسمبر\"],O_=[\"آچر\",\"سومر\",\"اڱارو\",\"اربع\",\"خميس\",\"جمع\",\"ڇنڇر\"];e.defineLocale(\"sd\",{months:P_,monthsShort:P_,weekdays:O_,weekdaysShort:O_,weekdaysMin:O_,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd، D MMMM YYYY HH:mm\"},meridiemParse:/صبح|شام/,isPM:function(e){return\"شام\"===e},meridiem:function(e,a,t){return e<12?\"صبح\":\"شام\"},calendar:{sameDay:\"[اڄ] LT\",nextDay:\"[سڀاڻي] LT\",nextWeek:\"dddd [اڳين هفتي تي] LT\",lastDay:\"[ڪالهه] LT\",lastWeek:\"[گزريل هفتي] dddd [تي] LT\",sameElse:\"L\"},relativeTime:{future:\"%s پوء\",past:\"%s اڳ\",s:\"چند سيڪنڊ\",m:\"هڪ منٽ\",mm:\"%d منٽ\",h:\"هڪ ڪلاڪ\",hh:\"%d ڪلاڪ\",d:\"هڪ ڏينهن\",dd:\"%d ڏينهن\",M:\"هڪ مهينو\",MM:\"%d مهينا\",y:\"هڪ سال\",yy:\"%d سال\"},preparse:function(e){return e.replace(/،/g,\",\")},postformat:function(e){return e.replace(/,/g,\"،\")},week:{dow:1,doy:4}}),e.defineLocale(\"se\",{months:\"ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu\".split(\"_\"),monthsShort:\"ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov\".split(\"_\"),weekdays:\"sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat\".split(\"_\"),weekdaysShort:\"sotn_vuos_maŋ_gask_duor_bear_láv\".split(\"_\"),weekdaysMin:\"s_v_m_g_d_b_L\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"MMMM D. [b.] YYYY\",LLL:\"MMMM D. [b.] YYYY [ti.] HH:mm\",LLLL:\"dddd, MMMM D. [b.] YYYY [ti.] HH:mm\"},calendar:{sameDay:\"[otne ti] LT\",nextDay:\"[ihttin ti] LT\",nextWeek:\"dddd [ti] LT\",lastDay:\"[ikte ti] LT\",lastWeek:\"[ovddit] dddd [ti] LT\",sameElse:\"L\"},relativeTime:{future:\"%s geažes\",past:\"maŋit %s\",s:\"moadde sekunddat\",m:\"okta minuhta\",mm:\"%d minuhtat\",h:\"okta diimmu\",hh:\"%d diimmut\",d:\"okta beaivi\",dd:\"%d beaivvit\",M:\"okta mánnu\",MM:\"%d mánut\",y:\"okta jahki\",yy:\"%d jagit\"},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}}),e.defineLocale(\"si\",{months:\"ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්\".split(\"_\"),monthsShort:\"ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ\".split(\"_\"),weekdays:\"ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා\".split(\"_\"),weekdaysShort:\"ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන\".split(\"_\"),weekdaysMin:\"ඉ_ස_අ_බ_බ්‍ර_සි_සෙ\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"a h:mm\",LTS:\"a h:mm:ss\",L:\"YYYY/MM/DD\",LL:\"YYYY MMMM D\",LLL:\"YYYY MMMM D, a h:mm\",LLLL:\"YYYY MMMM D [වැනි] dddd, a h:mm:ss\"},calendar:{sameDay:\"[අද] LT[ට]\",nextDay:\"[හෙට] LT[ට]\",nextWeek:\"dddd LT[ට]\",lastDay:\"[ඊයේ] LT[ට]\",lastWeek:\"[පසුගිය] dddd LT[ට]\",sameElse:\"L\"},relativeTime:{future:\"%sකින්\",past:\"%sකට පෙර\",s:\"තත්පර කිහිපය\",m:\"මිනිත්තුව\",mm:\"මිනිත්තු %d\",h:\"පැය\",hh:\"පැය %d\",d:\"දිනය\",dd:\"දින %d\",M:\"මාසය\",MM:\"මාස %d\",y:\"වසර\",yy:\"වසර %d\"},dayOfMonthOrdinalParse:/\\d{1,2} වැනි/,ordinal:function(e){return e+\" වැනි\"},meridiemParse:/පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,isPM:function(e){return\"ප.ව.\"===e||\"පස් වරු\"===e},meridiem:function(e,a,t){return e>11?t?\"ප.ව.\":\"පස් වරු\":t?\"පෙ.ව.\":\"පෙර වරු\"}});var W_=\"január_február_marec_apríl_máj_jún_júl_august_september_október_november_december\".split(\"_\"),E_=\"jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec\".split(\"_\");e.defineLocale(\"sk\",{months:W_,monthsShort:E_,weekdays:\"nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota\".split(\"_\"),weekdaysShort:\"ne_po_ut_st_št_pi_so\".split(\"_\"),weekdaysMin:\"ne_po_ut_st_št_pi_so\".split(\"_\"),longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm\",LLLL:\"dddd D. MMMM YYYY H:mm\"},calendar:{sameDay:\"[dnes o] LT\",nextDay:\"[zajtra o] LT\",nextWeek:function(){switch(this.day()){case 0:return\"[v nedeľu o] LT\";case 1:case 2:return\"[v] dddd [o] LT\";case 3:return\"[v stredu o] LT\";case 4:return\"[vo štvrtok o] LT\";case 5:return\"[v piatok o] LT\";case 6:return\"[v sobotu o] LT\"}},lastDay:\"[včera o] LT\",lastWeek:function(){switch(this.day()){case 0:return\"[minulú nedeľu o] LT\";case 1:case 2:return\"[minulý] dddd [o] LT\";case 3:return\"[minulú stredu o] LT\";case 4:case 5:return\"[minulý] dddd [o] LT\";case 6:return\"[minulú sobotu o] LT\"}},sameElse:\"L\"},relativeTime:{future:\"za %s\",past:\"pred %s\",s:rn,m:rn,mm:rn,h:rn,hh:rn,d:rn,dd:rn,M:rn,MM:rn,y:rn,yy:rn},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}}),e.defineLocale(\"sl\",{months:\"januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december\".split(\"_\"),monthsShort:\"jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.\".split(\"_\"),monthsParseExact:!0,weekdays:\"nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota\".split(\"_\"),weekdaysShort:\"ned._pon._tor._sre._čet._pet._sob.\".split(\"_\"),weekdaysMin:\"ne_po_to_sr_če_pe_so\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm\",LLLL:\"dddd, D. MMMM YYYY H:mm\"},calendar:{sameDay:\"[danes ob] LT\",nextDay:\"[jutri ob] LT\",nextWeek:function(){switch(this.day()){case 0:return\"[v] [nedeljo] [ob] LT\";case 3:return\"[v] [sredo] [ob] LT\";case 6:return\"[v] [soboto] [ob] LT\";case 1:case 2:case 4:case 5:return\"[v] dddd [ob] LT\"}},lastDay:\"[včeraj ob] LT\",lastWeek:function(){switch(this.day()){case 0:return\"[prejšnjo] [nedeljo] [ob] LT\";case 3:return\"[prejšnjo] [sredo] [ob] LT\";case 6:return\"[prejšnjo] [soboto] [ob] LT\";case 1:case 2:case 4:case 5:return\"[prejšnji] dddd [ob] LT\"}},sameElse:\"L\"},relativeTime:{future:\"čez %s\",past:\"pred %s\",s:dn,m:dn,mm:dn,h:dn,hh:dn,d:dn,dd:dn,M:dn,MM:dn,y:dn,yy:dn},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:7}}),e.defineLocale(\"sq\",{months:\"Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor\".split(\"_\"),monthsShort:\"Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj\".split(\"_\"),weekdays:\"E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë\".split(\"_\"),weekdaysShort:\"Die_Hën_Mar_Mër_Enj_Pre_Sht\".split(\"_\"),weekdaysMin:\"D_H_Ma_Më_E_P_Sh\".split(\"_\"),weekdaysParseExact:!0,meridiemParse:/PD|MD/,isPM:function(e){return\"M\"===e.charAt(0)},meridiem:function(e,a,t){return e<12?\"PD\":\"MD\"},longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Sot në] LT\",nextDay:\"[Nesër në] LT\",nextWeek:\"dddd [në] LT\",lastDay:\"[Dje në] LT\",lastWeek:\"dddd [e kaluar në] LT\",sameElse:\"L\"},relativeTime:{future:\"në %s\",past:\"%s më parë\",s:\"disa sekonda\",m:\"një minutë\",mm:\"%d minuta\",h:\"një orë\",hh:\"%d orë\",d:\"një ditë\",dd:\"%d ditë\",M:\"një muaj\",MM:\"%d muaj\",y:\"një vit\",yy:\"%d vite\"},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});var A_={words:{m:[\"један минут\",\"једне минуте\"],mm:[\"минут\",\"минуте\",\"минута\"],h:[\"један сат\",\"једног сата\"],hh:[\"сат\",\"сата\",\"сати\"],dd:[\"дан\",\"дана\",\"дана\"],MM:[\"месец\",\"месеца\",\"месеци\"],yy:[\"година\",\"године\",\"година\"]},correctGrammaticalCase:function(e,a){return 1===e?a[0]:e>=2&&e<=4?a[1]:a[2]},translate:function(e,a,t){var s=A_.words[t];return 1===t.length?a?s[0]:s[1]:e+\" \"+A_.correctGrammaticalCase(e,s)}};e.defineLocale(\"sr-cyrl\",{months:\"јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар\".split(\"_\"),monthsShort:\"јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.\".split(\"_\"),monthsParseExact:!0,weekdays:\"недеља_понедељак_уторак_среда_четвртак_петак_субота\".split(\"_\"),weekdaysShort:\"нед._пон._уто._сре._чет._пет._суб.\".split(\"_\"),weekdaysMin:\"не_по_ут_ср_че_пе_су\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm\",LLLL:\"dddd, D. MMMM YYYY H:mm\"},calendar:{sameDay:\"[данас у] LT\",nextDay:\"[сутра у] LT\",nextWeek:function(){switch(this.day()){case 0:return\"[у] [недељу] [у] LT\";case 3:return\"[у] [среду] [у] LT\";case 6:return\"[у] [суботу] [у] LT\";case 1:case 2:case 4:case 5:return\"[у] dddd [у] LT\"}},lastDay:\"[јуче у] LT\",lastWeek:function(){return[\"[прошле] [недеље] [у] LT\",\"[прошлог] [понедељка] [у] LT\",\"[прошлог] [уторка] [у] LT\",\"[прошле] [среде] [у] LT\",\"[прошлог] [четвртка] [у] LT\",\"[прошлог] [петка] [у] LT\",\"[прошле] [суботе] [у] LT\"][this.day()]},sameElse:\"L\"},relativeTime:{future:\"за %s\",past:\"пре %s\",s:\"неколико секунди\",m:A_.translate,mm:A_.translate,h:A_.translate,hh:A_.translate,d:\"дан\",dd:A_.translate,M:\"месец\",MM:A_.translate,y:\"годину\",yy:A_.translate},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:7}});var F_={words:{m:[\"jedan minut\",\"jedne minute\"],mm:[\"minut\",\"minute\",\"minuta\"],h:[\"jedan sat\",\"jednog sata\"],hh:[\"sat\",\"sata\",\"sati\"],dd:[\"dan\",\"dana\",\"dana\"],MM:[\"mesec\",\"meseca\",\"meseci\"],yy:[\"godina\",\"godine\",\"godina\"]},correctGrammaticalCase:function(e,a){return 1===e?a[0]:e>=2&&e<=4?a[1]:a[2]},translate:function(e,a,t){var s=F_.words[t];return 1===t.length?a?s[0]:s[1]:e+\" \"+F_.correctGrammaticalCase(e,s)}};e.defineLocale(\"sr\",{months:\"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar\".split(\"_\"),monthsShort:\"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.\".split(\"_\"),monthsParseExact:!0,weekdays:\"nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota\".split(\"_\"),weekdaysShort:\"ned._pon._uto._sre._čet._pet._sub.\".split(\"_\"),weekdaysMin:\"ne_po_ut_sr_če_pe_su\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm\",LLLL:\"dddd, D. MMMM YYYY H:mm\"},calendar:{sameDay:\"[danas u] LT\",nextDay:\"[sutra u] LT\",nextWeek:function(){switch(this.day()){case 0:return\"[u] [nedelju] [u] LT\";case 3:return\"[u] [sredu] [u] LT\";case 6:return\"[u] [subotu] [u] LT\";case 1:case 2:case 4:case 5:return\"[u] dddd [u] LT\"}},lastDay:\"[juče u] LT\",lastWeek:function(){return[\"[prošle] [nedelje] [u] LT\",\"[prošlog] [ponedeljka] [u] LT\",\"[prošlog] [utorka] [u] LT\",\"[prošle] [srede] [u] LT\",\"[prošlog] [četvrtka] [u] LT\",\"[prošlog] [petka] [u] LT\",\"[prošle] [subote] [u] LT\"][this.day()]},sameElse:\"L\"},relativeTime:{future:\"za %s\",past:\"pre %s\",s:\"nekoliko sekundi\",m:F_.translate,mm:F_.translate,h:F_.translate,hh:F_.translate,d:\"dan\",dd:F_.translate,M:\"mesec\",MM:F_.translate,y:\"godinu\",yy:F_.translate},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:7}}),e.defineLocale(\"ss\",{months:\"Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni\".split(\"_\"),monthsShort:\"Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo\".split(\"_\"),weekdays:\"Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo\".split(\"_\"),weekdaysShort:\"Lis_Umb_Lsb_Les_Lsi_Lsh_Umg\".split(\"_\"),weekdaysMin:\"Li_Us_Lb_Lt_Ls_Lh_Ug\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"h:mm A\",LTS:\"h:mm:ss A\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY h:mm A\",LLLL:\"dddd, D MMMM YYYY h:mm A\"},calendar:{sameDay:\"[Namuhla nga] LT\",nextDay:\"[Kusasa nga] LT\",nextWeek:\"dddd [nga] LT\",lastDay:\"[Itolo nga] LT\",lastWeek:\"dddd [leliphelile] [nga] LT\",sameElse:\"L\"},relativeTime:{future:\"nga %s\",past:\"wenteka nga %s\",s:\"emizuzwana lomcane\",m:\"umzuzu\",mm:\"%d emizuzu\",h:\"lihora\",hh:\"%d emahora\",d:\"lilanga\",dd:\"%d emalanga\",M:\"inyanga\",MM:\"%d tinyanga\",y:\"umnyaka\",yy:\"%d iminyaka\"},meridiemParse:/ekuseni|emini|entsambama|ebusuku/,meridiem:function(e,a,t){return e<11?\"ekuseni\":e<15?\"emini\":e<19?\"entsambama\":\"ebusuku\"},meridiemHour:function(e,a){return 12===e&&(e=0),\"ekuseni\"===a?e:\"emini\"===a?e>=11?e:e+12:\"entsambama\"===a||\"ebusuku\"===a?0===e?0:e+12:void 0},dayOfMonthOrdinalParse:/\\d{1,2}/,ordinal:\"%d\",week:{dow:1,doy:4}}),e.defineLocale(\"sv\",{months:\"januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december\".split(\"_\"),monthsShort:\"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec\".split(\"_\"),weekdays:\"söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag\".split(\"_\"),weekdaysShort:\"sön_mån_tis_ons_tor_fre_lör\".split(\"_\"),weekdaysMin:\"sö_må_ti_on_to_fr_lö\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"YYYY-MM-DD\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY [kl.] HH:mm\",LLLL:\"dddd D MMMM YYYY [kl.] HH:mm\",lll:\"D MMM YYYY HH:mm\",llll:\"ddd D MMM YYYY HH:mm\"},calendar:{sameDay:\"[Idag] LT\",nextDay:\"[Imorgon] LT\",lastDay:\"[Igår] LT\",nextWeek:\"[På] dddd LT\",lastWeek:\"[I] dddd[s] LT\",sameElse:\"L\"},relativeTime:{future:\"om %s\",past:\"för %s sedan\",s:\"några sekunder\",m:\"en minut\",mm:\"%d minuter\",h:\"en timme\",hh:\"%d timmar\",d:\"en dag\",dd:\"%d dagar\",M:\"en månad\",MM:\"%d månader\",y:\"ett år\",yy:\"%d år\"},dayOfMonthOrdinalParse:/\\d{1,2}(e|a)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?\"e\":1===a?\"a\":2===a?\"a\":\"e\")},week:{dow:1,doy:4}}),e.defineLocale(\"sw\",{months:\"Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba\".split(\"_\"),monthsShort:\"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des\".split(\"_\"),weekdays:\"Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi\".split(\"_\"),weekdaysShort:\"Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos\".split(\"_\"),weekdaysMin:\"J2_J3_J4_J5_Al_Ij_J1\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[leo saa] LT\",nextDay:\"[kesho saa] LT\",nextWeek:\"[wiki ijayo] dddd [saat] LT\",lastDay:\"[jana] LT\",lastWeek:\"[wiki iliyopita] dddd [saat] LT\",sameElse:\"L\"},relativeTime:{future:\"%s baadaye\",past:\"tokea %s\",s:\"hivi punde\",m:\"dakika moja\",mm:\"dakika %d\",h:\"saa limoja\",hh:\"masaa %d\",d:\"siku moja\",dd:\"masiku %d\",M:\"mwezi mmoja\",MM:\"miezi %d\",y:\"mwaka mmoja\",yy:\"miaka %d\"},week:{dow:1,doy:7}});var z_={1:\"௧\",2:\"௨\",3:\"௩\",4:\"௪\",5:\"௫\",6:\"௬\",7:\"௭\",8:\"௮\",9:\"௯\",0:\"௦\"},J_={\"௧\":\"1\",\"௨\":\"2\",\"௩\":\"3\",\"௪\":\"4\",\"௫\":\"5\",\"௬\":\"6\",\"௭\":\"7\",\"௮\":\"8\",\"௯\":\"9\",\"௦\":\"0\"};e.defineLocale(\"ta\",{months:\"ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்\".split(\"_\"),monthsShort:\"ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்\".split(\"_\"),weekdays:\"ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை\".split(\"_\"),weekdaysShort:\"ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி\".split(\"_\"),weekdaysMin:\"ஞா_தி_செ_பு_வி_வெ_ச\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, HH:mm\",LLLL:\"dddd, D MMMM YYYY, HH:mm\"},calendar:{sameDay:\"[இன்று] LT\",nextDay:\"[நாளை] LT\",nextWeek:\"dddd, LT\",lastDay:\"[நேற்று] LT\",lastWeek:\"[கடந்த வாரம்] dddd, LT\",sameElse:\"L\"},relativeTime:{future:\"%s இல்\",past:\"%s முன்\",s:\"ஒரு சில விநாடிகள்\",m:\"ஒரு நிமிடம்\",mm:\"%d நிமிடங்கள்\",h:\"ஒரு மணி நேரம்\",hh:\"%d மணி நேரம்\",d:\"ஒரு நாள்\",dd:\"%d நாட்கள்\",M:\"ஒரு மாதம்\",MM:\"%d மாதங்கள்\",y:\"ஒரு வருடம்\",yy:\"%d ஆண்டுகள்\"},dayOfMonthOrdinalParse:/\\d{1,2}வது/,ordinal:function(e){return e+\"வது\"},preparse:function(e){return e.replace(/[௧௨௩௪௫௬௭௮௯௦]/g,function(e){return J_[e]})},postformat:function(e){return e.replace(/\\d/g,function(e){return z_[e]})},meridiemParse:/யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,meridiem:function(e,a,t){return e<2?\" யாமம்\":e<6?\" வைகறை\":e<10?\" காலை\":e<14?\" நண்பகல்\":e<18?\" எற்பாடு\":e<22?\" மாலை\":\" யாமம்\"},meridiemHour:function(e,a){return 12===e&&(e=0),\"யாமம்\"===a?e<2?e:e+12:\"வைகறை\"===a||\"காலை\"===a?e:\"நண்பகல்\"===a&&e>=10?e:e+12},week:{dow:0,doy:6}}),e.defineLocale(\"te\",{months:\"జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్\".split(\"_\"),monthsShort:\"జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.\".split(\"_\"),monthsParseExact:!0,weekdays:\"ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం\".split(\"_\"),weekdaysShort:\"ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని\".split(\"_\"),weekdaysMin:\"ఆ_సో_మం_బు_గు_శు_శ\".split(\"_\"),longDateFormat:{LT:\"A h:mm\",LTS:\"A h:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, A h:mm\",LLLL:\"dddd, D MMMM YYYY, A h:mm\"},calendar:{sameDay:\"[నేడు] LT\",nextDay:\"[రేపు] LT\",nextWeek:\"dddd, LT\",lastDay:\"[నిన్న] LT\",lastWeek:\"[గత] dddd, LT\",sameElse:\"L\"},relativeTime:{future:\"%s లో\",past:\"%s క్రితం\",s:\"కొన్ని క్షణాలు\",m:\"ఒక నిమిషం\",mm:\"%d నిమిషాలు\",h:\"ఒక గంట\",hh:\"%d గంటలు\",d:\"ఒక రోజు\",dd:\"%d రోజులు\",M:\"ఒక నెల\",MM:\"%d నెలలు\",y:\"ఒక సంవత్సరం\",yy:\"%d సంవత్సరాలు\"},dayOfMonthOrdinalParse:/\\d{1,2}వ/,ordinal:\"%dవ\",meridiemParse:/రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,meridiemHour:function(e,a){return 12===e&&(e=0),\"రాత్రి\"===a?e<4?e:e+12:\"ఉదయం\"===a?e:\"మధ్యాహ్నం\"===a?e>=10?e:e+12:\"సాయంత్రం\"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?\"రాత్రి\":e<10?\"ఉదయం\":e<17?\"మధ్యాహ్నం\":e<20?\"సాయంత్రం\":\"రాత్రి\"},week:{dow:0,doy:6}}),e.defineLocale(\"tet\",{months:\"Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru\".split(\"_\"),monthsShort:\"Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez\".split(\"_\"),weekdays:\"Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu\".split(\"_\"),weekdaysShort:\"Dom_Seg_Ters_Kua_Kint_Sext_Sab\".split(\"_\"),weekdaysMin:\"Do_Seg_Te_Ku_Ki_Sex_Sa\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Ohin iha] LT\",nextDay:\"[Aban iha] LT\",nextWeek:\"dddd [iha] LT\",lastDay:\"[Horiseik iha] LT\",lastWeek:\"dddd [semana kotuk] [iha] LT\",sameElse:\"L\"},relativeTime:{future:\"iha %s\",past:\"%s liuba\",s:\"minutu balun\",m:\"minutu ida\",mm:\"minutus %d\",h:\"horas ida\",hh:\"horas %d\",d:\"loron ida\",dd:\"loron %d\",M:\"fulan ida\",MM:\"fulan %d\",y:\"tinan ida\",yy:\"tinan %d\"},dayOfMonthOrdinalParse:/\\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?\"th\":1===a?\"st\":2===a?\"nd\":3===a?\"rd\":\"th\")},week:{dow:1,doy:4}}),e.defineLocale(\"th\",{months:\"มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม\".split(\"_\"),monthsShort:\"ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.\".split(\"_\"),monthsParseExact:!0,weekdays:\"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์\".split(\"_\"),weekdaysShort:\"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์\".split(\"_\"),weekdaysMin:\"อา._จ._อ._พ._พฤ._ศ._ส.\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY เวลา H:mm\",LLLL:\"วันddddที่ D MMMM YYYY เวลา H:mm\"},meridiemParse:/ก่อนเที่ยง|หลังเที่ยง/,isPM:function(e){return\"หลังเที่ยง\"===e},meridiem:function(e,a,t){return e<12?\"ก่อนเที่ยง\":\"หลังเที่ยง\"},calendar:{sameDay:\"[วันนี้ เวลา] LT\",nextDay:\"[พรุ่งนี้ เวลา] LT\",nextWeek:\"dddd[หน้า เวลา] LT\",lastDay:\"[เมื่อวานนี้ เวลา] LT\",lastWeek:\"[วัน]dddd[ที่แล้ว เวลา] LT\",sameElse:\"L\"},relativeTime:{future:\"อีก %s\",past:\"%sที่แล้ว\",s:\"ไม่กี่วินาที\",m:\"1 นาที\",mm:\"%d นาที\",h:\"1 ชั่วโมง\",hh:\"%d ชั่วโมง\",d:\"1 วัน\",dd:\"%d วัน\",M:\"1 เดือน\",MM:\"%d เดือน\",y:\"1 ปี\",yy:\"%d ปี\"}}),e.defineLocale(\"tl-ph\",{months:\"Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre\".split(\"_\"),monthsShort:\"Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis\".split(\"_\"),weekdays:\"Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado\".split(\"_\"),weekdaysShort:\"Lin_Lun_Mar_Miy_Huw_Biy_Sab\".split(\"_\"),weekdaysMin:\"Li_Lu_Ma_Mi_Hu_Bi_Sab\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"MM/D/YYYY\",LL:\"MMMM D, YYYY\",LLL:\"MMMM D, YYYY HH:mm\",LLLL:\"dddd, MMMM DD, YYYY HH:mm\"},calendar:{sameDay:\"LT [ngayong araw]\",nextDay:\"[Bukas ng] LT\",nextWeek:\"LT [sa susunod na] dddd\",lastDay:\"LT [kahapon]\",lastWeek:\"LT [noong nakaraang] dddd\",sameElse:\"L\"},relativeTime:{future:\"sa loob ng %s\",past:\"%s ang nakalipas\",s:\"ilang segundo\",m:\"isang minuto\",mm:\"%d minuto\",h:\"isang oras\",hh:\"%d oras\",d:\"isang araw\",dd:\"%d araw\",M:\"isang buwan\",MM:\"%d buwan\",y:\"isang taon\",yy:\"%d taon\"},dayOfMonthOrdinalParse:/\\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}});var R_=\"pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut\".split(\"_\");e.defineLocale(\"tlh\",{months:\"tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’\".split(\"_\"),monthsShort:\"jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’\".split(\"_\"),monthsParseExact:!0,weekdays:\"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj\".split(\"_\"),weekdaysShort:\"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj\".split(\"_\"),weekdaysMin:\"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[DaHjaj] LT\",nextDay:\"[wa’leS] LT\",nextWeek:\"LLL\",lastDay:\"[wa’Hu’] LT\",lastWeek:\"LLL\",sameElse:\"L\"},relativeTime:{future:_n,past:on,s:\"puS lup\",m:\"wa’ tup\",mm:mn,h:\"wa’ rep\",hh:mn,d:\"wa’ jaj\",dd:mn,M:\"wa’ jar\",MM:mn,y:\"wa’ DIS\",yy:mn},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});var N_={1:\"'inci\",5:\"'inci\",8:\"'inci\",70:\"'inci\",80:\"'inci\",2:\"'nci\",7:\"'nci\",20:\"'nci\",50:\"'nci\",3:\"'üncü\",4:\"'üncü\",100:\"'üncü\",6:\"'ncı\",9:\"'uncu\",10:\"'uncu\",30:\"'uncu\",60:\"'ıncı\",90:\"'ıncı\"};e.defineLocale(\"tr\",{months:\"Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık\".split(\"_\"),monthsShort:\"Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara\".split(\"_\"),weekdays:\"Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi\".split(\"_\"),weekdaysShort:\"Paz_Pts_Sal_Çar_Per_Cum_Cts\".split(\"_\"),weekdaysMin:\"Pz_Pt_Sa_Ça_Pe_Cu_Ct\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[bugün saat] LT\",nextDay:\"[yarın saat] LT\",nextWeek:\"[haftaya] dddd [saat] LT\",lastDay:\"[dün] LT\",lastWeek:\"[geçen hafta] dddd [saat] LT\",sameElse:\"L\"},relativeTime:{future:\"%s sonra\",past:\"%s önce\",s:\"birkaç saniye\",m:\"bir dakika\",mm:\"%d dakika\",h:\"bir saat\",hh:\"%d saat\",d:\"bir gün\",dd:\"%d gün\",M:\"bir ay\",MM:\"%d ay\",y:\"bir yıl\",yy:\"%d yıl\"},dayOfMonthOrdinalParse:/\\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,ordinal:function(e){if(0===e)return e+\"'ıncı\";var a=e%10,t=e%100-a,s=e>=100?100:null;return e+(N_[a]||N_[t]||N_[s])},week:{dow:1,doy:7}}),e.defineLocale(\"tzl\",{months:\"Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar\".split(\"_\"),monthsShort:\"Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec\".split(\"_\"),weekdays:\"Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi\".split(\"_\"),weekdaysShort:\"Súl_Lún_Mai_Már_Xhú_Vié_Sát\".split(\"_\"),weekdaysMin:\"Sú_Lú_Ma_Má_Xh_Vi_Sá\".split(\"_\"),longDateFormat:{LT:\"HH.mm\",LTS:\"HH.mm.ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM [dallas] YYYY\",LLL:\"D. MMMM [dallas] YYYY HH.mm\",LLLL:\"dddd, [li] D. MMMM [dallas] YYYY HH.mm\"},meridiemParse:/d\\'o|d\\'a/i,isPM:function(e){return\"d'o\"===e.toLowerCase()},meridiem:function(e,a,t){return e>11?t?\"d'o\":\"D'O\":t?\"d'a\":\"D'A\"},calendar:{sameDay:\"[oxhi à] LT\",nextDay:\"[demà à] LT\",nextWeek:\"dddd [à] LT\",lastDay:\"[ieiri à] LT\",lastWeek:\"[sür el] dddd [lasteu à] LT\",sameElse:\"L\"},relativeTime:{future:\"osprei %s\",past:\"ja%s\",s:ln,m:ln,mm:ln,h:ln,hh:ln,d:ln,dd:ln,M:ln,MM:ln,y:ln,yy:ln},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}}),e.defineLocale(\"tzm-latn\",{\nmonths:\"innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir\".split(\"_\"),monthsShort:\"innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir\".split(\"_\"),weekdays:\"asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas\".split(\"_\"),weekdaysShort:\"asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas\".split(\"_\"),weekdaysMin:\"asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[asdkh g] LT\",nextDay:\"[aska g] LT\",nextWeek:\"dddd [g] LT\",lastDay:\"[assant g] LT\",lastWeek:\"dddd [g] LT\",sameElse:\"L\"},relativeTime:{future:\"dadkh s yan %s\",past:\"yan %s\",s:\"imik\",m:\"minuḍ\",mm:\"%d minuḍ\",h:\"saɛa\",hh:\"%d tassaɛin\",d:\"ass\",dd:\"%d ossan\",M:\"ayowr\",MM:\"%d iyyirn\",y:\"asgas\",yy:\"%d isgasn\"},week:{dow:6,doy:12}}),e.defineLocale(\"tzm\",{months:\"ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ\".split(\"_\"),monthsShort:\"ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ\".split(\"_\"),weekdays:\"ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ\".split(\"_\"),weekdaysShort:\"ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ\".split(\"_\"),weekdaysMin:\"ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[ⴰⵙⴷⵅ ⴴ] LT\",nextDay:\"[ⴰⵙⴽⴰ ⴴ] LT\",nextWeek:\"dddd [ⴴ] LT\",lastDay:\"[ⴰⵚⴰⵏⵜ ⴴ] LT\",lastWeek:\"dddd [ⴴ] LT\",sameElse:\"L\"},relativeTime:{future:\"ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s\",past:\"ⵢⴰⵏ %s\",s:\"ⵉⵎⵉⴽ\",m:\"ⵎⵉⵏⵓⴺ\",mm:\"%d ⵎⵉⵏⵓⴺ\",h:\"ⵙⴰⵄⴰ\",hh:\"%d ⵜⴰⵙⵙⴰⵄⵉⵏ\",d:\"ⴰⵙⵙ\",dd:\"%d oⵙⵙⴰⵏ\",M:\"ⴰⵢoⵓⵔ\",MM:\"%d ⵉⵢⵢⵉⵔⵏ\",y:\"ⴰⵙⴳⴰⵙ\",yy:\"%d ⵉⵙⴳⴰⵙⵏ\"},week:{dow:6,doy:12}}),e.defineLocale(\"uk\",{months:{format:\"січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня\".split(\"_\"),standalone:\"січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень\".split(\"_\")},monthsShort:\"січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд\".split(\"_\"),weekdays:Ln,weekdaysShort:\"нд_пн_вт_ср_чт_пт_сб\".split(\"_\"),weekdaysMin:\"нд_пн_вт_ср_чт_пт_сб\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY р.\",LLL:\"D MMMM YYYY р., HH:mm\",LLLL:\"dddd, D MMMM YYYY р., HH:mm\"},calendar:{sameDay:cn(\"[Сьогодні \"),nextDay:cn(\"[Завтра \"),lastDay:cn(\"[Вчора \"),nextWeek:cn(\"[У] dddd [\"),lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return cn(\"[Минулої] dddd [\").call(this);case 1:case 2:case 4:return cn(\"[Минулого] dddd [\").call(this)}},sameElse:\"L\"},relativeTime:{future:\"за %s\",past:\"%s тому\",s:\"декілька секунд\",m:hn,mm:hn,h:\"годину\",hh:hn,d:\"день\",dd:hn,M:\"місяць\",MM:hn,y:\"рік\",yy:hn},meridiemParse:/ночі|ранку|дня|вечора/,isPM:function(e){return/^(дня|вечора)$/.test(e)},meridiem:function(e,a,t){return e<4?\"ночі\":e<12?\"ранку\":e<17?\"дня\":\"вечора\"},dayOfMonthOrdinalParse:/\\d{1,2}-(й|го)/,ordinal:function(e,a){switch(a){case\"M\":case\"d\":case\"DDD\":case\"w\":case\"W\":return e+\"-й\";case\"D\":return e+\"-го\";default:return e}},week:{dow:1,doy:7}});var C_=[\"جنوری\",\"فروری\",\"مارچ\",\"اپریل\",\"مئی\",\"جون\",\"جولائی\",\"اگست\",\"ستمبر\",\"اکتوبر\",\"نومبر\",\"دسمبر\"],I_=[\"اتوار\",\"پیر\",\"منگل\",\"بدھ\",\"جمعرات\",\"جمعہ\",\"ہفتہ\"];return e.defineLocale(\"ur\",{months:C_,monthsShort:C_,weekdays:I_,weekdaysShort:I_,weekdaysMin:I_,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd، D MMMM YYYY HH:mm\"},meridiemParse:/صبح|شام/,isPM:function(e){return\"شام\"===e},meridiem:function(e,a,t){return e<12?\"صبح\":\"شام\"},calendar:{sameDay:\"[آج بوقت] LT\",nextDay:\"[کل بوقت] LT\",nextWeek:\"dddd [بوقت] LT\",lastDay:\"[گذشتہ روز بوقت] LT\",lastWeek:\"[گذشتہ] dddd [بوقت] LT\",sameElse:\"L\"},relativeTime:{future:\"%s بعد\",past:\"%s قبل\",s:\"چند سیکنڈ\",m:\"ایک منٹ\",mm:\"%d منٹ\",h:\"ایک گھنٹہ\",hh:\"%d گھنٹے\",d:\"ایک دن\",dd:\"%d دن\",M:\"ایک ماہ\",MM:\"%d ماہ\",y:\"ایک سال\",yy:\"%d سال\"},preparse:function(e){return e.replace(/،/g,\",\")},postformat:function(e){return e.replace(/,/g,\"،\")},week:{dow:1,doy:4}}),e.defineLocale(\"uz-latn\",{months:\"Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr\".split(\"_\"),monthsShort:\"Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek\".split(\"_\"),weekdays:\"Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba\".split(\"_\"),weekdaysShort:\"Yak_Dush_Sesh_Chor_Pay_Jum_Shan\".split(\"_\"),weekdaysMin:\"Ya_Du_Se_Cho_Pa_Ju_Sha\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"D MMMM YYYY, dddd HH:mm\"},calendar:{sameDay:\"[Bugun soat] LT [da]\",nextDay:\"[Ertaga] LT [da]\",nextWeek:\"dddd [kuni soat] LT [da]\",lastDay:\"[Kecha soat] LT [da]\",lastWeek:\"[O'tgan] dddd [kuni soat] LT [da]\",sameElse:\"L\"},relativeTime:{future:\"Yaqin %s ichida\",past:\"Bir necha %s oldin\",s:\"soniya\",m:\"bir daqiqa\",mm:\"%d daqiqa\",h:\"bir soat\",hh:\"%d soat\",d:\"bir kun\",dd:\"%d kun\",M:\"bir oy\",MM:\"%d oy\",y:\"bir yil\",yy:\"%d yil\"},week:{dow:1,doy:7}}),e.defineLocale(\"uz\",{months:\"январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр\".split(\"_\"),monthsShort:\"янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек\".split(\"_\"),weekdays:\"Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба\".split(\"_\"),weekdaysShort:\"Якш_Душ_Сеш_Чор_Пай_Жум_Шан\".split(\"_\"),weekdaysMin:\"Як_Ду_Се_Чо_Па_Жу_Ша\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"D MMMM YYYY, dddd HH:mm\"},calendar:{sameDay:\"[Бугун соат] LT [да]\",nextDay:\"[Эртага] LT [да]\",nextWeek:\"dddd [куни соат] LT [да]\",lastDay:\"[Кеча соат] LT [да]\",lastWeek:\"[Утган] dddd [куни соат] LT [да]\",sameElse:\"L\"},relativeTime:{future:\"Якин %s ичида\",past:\"Бир неча %s олдин\",s:\"фурсат\",m:\"бир дакика\",mm:\"%d дакика\",h:\"бир соат\",hh:\"%d соат\",d:\"бир кун\",dd:\"%d кун\",M:\"бир ой\",MM:\"%d ой\",y:\"бир йил\",yy:\"%d йил\"},week:{dow:1,doy:7}}),e.defineLocale(\"vi\",{months:\"tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12\".split(\"_\"),monthsShort:\"Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12\".split(\"_\"),monthsParseExact:!0,weekdays:\"chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy\".split(\"_\"),weekdaysShort:\"CN_T2_T3_T4_T5_T6_T7\".split(\"_\"),weekdaysMin:\"CN_T2_T3_T4_T5_T6_T7\".split(\"_\"),weekdaysParseExact:!0,meridiemParse:/sa|ch/i,isPM:function(e){return/^ch$/i.test(e)},meridiem:function(e,a,t){return e<12?t?\"sa\":\"SA\":t?\"ch\":\"CH\"},longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM [năm] YYYY\",LLL:\"D MMMM [năm] YYYY HH:mm\",LLLL:\"dddd, D MMMM [năm] YYYY HH:mm\",l:\"DD/M/YYYY\",ll:\"D MMM YYYY\",lll:\"D MMM YYYY HH:mm\",llll:\"ddd, D MMM YYYY HH:mm\"},calendar:{sameDay:\"[Hôm nay lúc] LT\",nextDay:\"[Ngày mai lúc] LT\",nextWeek:\"dddd [tuần tới lúc] LT\",lastDay:\"[Hôm qua lúc] LT\",lastWeek:\"dddd [tuần rồi lúc] LT\",sameElse:\"L\"},relativeTime:{future:\"%s tới\",past:\"%s trước\",s:\"vài giây\",m:\"một phút\",mm:\"%d phút\",h:\"một giờ\",hh:\"%d giờ\",d:\"một ngày\",dd:\"%d ngày\",M:\"một tháng\",MM:\"%d tháng\",y:\"một năm\",yy:\"%d năm\"},dayOfMonthOrdinalParse:/\\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}}),e.defineLocale(\"x-pseudo\",{months:\"J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér\".split(\"_\"),monthsShort:\"J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc\".split(\"_\"),monthsParseExact:!0,weekdays:\"S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý\".split(\"_\"),weekdaysShort:\"S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát\".split(\"_\"),weekdaysMin:\"S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[T~ódá~ý át] LT\",nextDay:\"[T~ómó~rró~w át] LT\",nextWeek:\"dddd [át] LT\",lastDay:\"[Ý~ést~érdá~ý át] LT\",lastWeek:\"[L~ást] dddd [át] LT\",sameElse:\"L\"},relativeTime:{future:\"í~ñ %s\",past:\"%s á~gó\",s:\"á ~féw ~sécó~ñds\",m:\"á ~míñ~úté\",mm:\"%d m~íñú~tés\",h:\"á~ñ hó~úr\",hh:\"%d h~óúrs\",d:\"á ~dáý\",dd:\"%d d~áýs\",M:\"á ~móñ~th\",MM:\"%d m~óñt~hs\",y:\"á ~ýéár\",yy:\"%d ý~éárs\"},dayOfMonthOrdinalParse:/\\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?\"th\":1===a?\"st\":2===a?\"nd\":3===a?\"rd\":\"th\")},week:{dow:1,doy:4}}),e.defineLocale(\"yo\",{months:\"Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀\".split(\"_\"),monthsShort:\"Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀\".split(\"_\"),weekdays:\"Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta\".split(\"_\"),weekdaysShort:\"Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá\".split(\"_\"),weekdaysMin:\"Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb\".split(\"_\"),longDateFormat:{LT:\"h:mm A\",LTS:\"h:mm:ss A\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY h:mm A\",LLLL:\"dddd, D MMMM YYYY h:mm A\"},calendar:{sameDay:\"[Ònì ni] LT\",nextDay:\"[Ọ̀la ni] LT\",nextWeek:\"dddd [Ọsẹ̀ tón'bọ] [ni] LT\",lastDay:\"[Àna ni] LT\",lastWeek:\"dddd [Ọsẹ̀ tólọ́] [ni] LT\",sameElse:\"L\"},relativeTime:{future:\"ní %s\",past:\"%s kọjá\",s:\"ìsẹjú aayá die\",m:\"ìsẹjú kan\",mm:\"ìsẹjú %d\",h:\"wákati kan\",hh:\"wákati %d\",d:\"ọjọ́ kan\",dd:\"ọjọ́ %d\",M:\"osù kan\",MM:\"osù %d\",y:\"ọdún kan\",yy:\"ọdún %d\"},dayOfMonthOrdinalParse:/ọjọ́\\s\\d{1,2}/,ordinal:\"ọjọ́ %d\",week:{dow:1,doy:4}}),e.defineLocale(\"zh-cn\",{months:\"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月\".split(\"_\"),monthsShort:\"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月\".split(\"_\"),weekdays:\"星期日_星期一_星期二_星期三_星期四_星期五_星期六\".split(\"_\"),weekdaysShort:\"周日_周一_周二_周三_周四_周五_周六\".split(\"_\"),weekdaysMin:\"日_一_二_三_四_五_六\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"YYYY年MMMD日\",LL:\"YYYY年MMMD日\",LLL:\"YYYY年MMMD日Ah点mm分\",LLLL:\"YYYY年MMMD日ddddAh点mm分\",l:\"YYYY年MMMD日\",ll:\"YYYY年MMMD日\",lll:\"YYYY年MMMD日 HH:mm\",llll:\"YYYY年MMMD日dddd HH:mm\"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,a){return 12===e&&(e=0),\"凌晨\"===a||\"早上\"===a||\"上午\"===a?e:\"下午\"===a||\"晚上\"===a?e+12:e>=11?e:e+12},meridiem:function(e,a,t){var s=100*e+a;return s<600?\"凌晨\":s<900?\"早上\":s<1130?\"上午\":s<1230?\"中午\":s<1800?\"下午\":\"晚上\"},calendar:{sameDay:\"[今天]LT\",nextDay:\"[明天]LT\",nextWeek:\"[下]ddddLT\",lastDay:\"[昨天]LT\",lastWeek:\"[上]ddddLT\",sameElse:\"L\"},dayOfMonthOrdinalParse:/\\d{1,2}(日|月|周)/,ordinal:function(e,a){switch(a){case\"d\":case\"D\":case\"DDD\":return e+\"日\";case\"M\":return e+\"月\";case\"w\":case\"W\":return e+\"周\";default:return e}},relativeTime:{future:\"%s内\",past:\"%s前\",s:\"几秒\",m:\"1 分钟\",mm:\"%d 分钟\",h:\"1 小时\",hh:\"%d 小时\",d:\"1 天\",dd:\"%d 天\",M:\"1 个月\",MM:\"%d 个月\",y:\"1 年\",yy:\"%d 年\"},week:{dow:1,doy:4}}),e.defineLocale(\"zh-hk\",{months:\"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月\".split(\"_\"),monthsShort:\"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月\".split(\"_\"),weekdays:\"星期日_星期一_星期二_星期三_星期四_星期五_星期六\".split(\"_\"),weekdaysShort:\"週日_週一_週二_週三_週四_週五_週六\".split(\"_\"),weekdaysMin:\"日_一_二_三_四_五_六\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"YYYY年MMMD日\",LL:\"YYYY年MMMD日\",LLL:\"YYYY年MMMD日 HH:mm\",LLLL:\"YYYY年MMMD日dddd HH:mm\",l:\"YYYY年MMMD日\",ll:\"YYYY年MMMD日\",lll:\"YYYY年MMMD日 HH:mm\",llll:\"YYYY年MMMD日dddd HH:mm\"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,a){return 12===e&&(e=0),\"凌晨\"===a||\"早上\"===a||\"上午\"===a?e:\"中午\"===a?e>=11?e:e+12:\"下午\"===a||\"晚上\"===a?e+12:void 0},meridiem:function(e,a,t){var s=100*e+a;return s<600?\"凌晨\":s<900?\"早上\":s<1130?\"上午\":s<1230?\"中午\":s<1800?\"下午\":\"晚上\"},calendar:{sameDay:\"[今天]LT\",nextDay:\"[明天]LT\",nextWeek:\"[下]ddddLT\",lastDay:\"[昨天]LT\",lastWeek:\"[上]ddddLT\",sameElse:\"L\"},dayOfMonthOrdinalParse:/\\d{1,2}(日|月|週)/,ordinal:function(e,a){switch(a){case\"d\":case\"D\":case\"DDD\":return e+\"日\";case\"M\":return e+\"月\";case\"w\":case\"W\":return e+\"週\";default:return e}},relativeTime:{future:\"%s內\",past:\"%s前\",s:\"幾秒\",m:\"1 分鐘\",mm:\"%d 分鐘\",h:\"1 小時\",hh:\"%d 小時\",d:\"1 天\",dd:\"%d 天\",M:\"1 個月\",MM:\"%d 個月\",y:\"1 年\",yy:\"%d 年\"}}),e.defineLocale(\"zh-tw\",{months:\"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月\".split(\"_\"),monthsShort:\"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月\".split(\"_\"),weekdays:\"星期日_星期一_星期二_星期三_星期四_星期五_星期六\".split(\"_\"),weekdaysShort:\"週日_週一_週二_週三_週四_週五_週六\".split(\"_\"),weekdaysMin:\"日_一_二_三_四_五_六\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"YYYY年MMMD日\",LL:\"YYYY年MMMD日\",LLL:\"YYYY年MMMD日 HH:mm\",LLLL:\"YYYY年MMMD日dddd HH:mm\",l:\"YYYY年MMMD日\",ll:\"YYYY年MMMD日\",lll:\"YYYY年MMMD日 HH:mm\",llll:\"YYYY年MMMD日dddd HH:mm\"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,a){return 12===e&&(e=0),\"凌晨\"===a||\"早上\"===a||\"上午\"===a?e:\"中午\"===a?e>=11?e:e+12:\"下午\"===a||\"晚上\"===a?e+12:void 0},meridiem:function(e,a,t){var s=100*e+a;return s<600?\"凌晨\":s<900?\"早上\":s<1130?\"上午\":s<1230?\"中午\":s<1800?\"下午\":\"晚上\"},calendar:{sameDay:\"[今天]LT\",nextDay:\"[明天]LT\",nextWeek:\"[下]ddddLT\",lastDay:\"[昨天]LT\",lastWeek:\"[上]ddddLT\",sameElse:\"L\"},dayOfMonthOrdinalParse:/\\d{1,2}(日|月|週)/,ordinal:function(e,a){switch(a){case\"d\":case\"D\":case\"DDD\":return e+\"日\";case\"M\":return e+\"月\";case\"w\":case\"W\":return e+\"週\";default:return e}},relativeTime:{future:\"%s內\",past:\"%s前\",s:\"幾秒\",m:\"1 分鐘\",mm:\"%d 分鐘\",h:\"1 小時\",hh:\"%d 小時\",d:\"1 天\",dd:\"%d 天\",M:\"1 個月\",MM:\"%d 個月\",y:\"1 年\",yy:\"%d 年\"}}),e.locale(\"en\"),e});"

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(115))

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	module.exports = "if(\"undefined\"==typeof jQuery)throw new Error(\"Bootstrap's JavaScript requires jQuery\");+function(t){\"use strict\";var e=t.fn.jquery.split(\" \")[0].split(\".\");if(e[0]<2&&e[1]<9||1==e[0]&&9==e[1]&&e[2]<1||e[0]>3)throw new Error(\"Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4\")}(jQuery),function(t){\"use strict\";function e(){var t=document.createElement(\"bootstrap\"),e={WebkitTransition:\"webkitTransitionEnd\",MozTransition:\"transitionend\",OTransition:\"oTransitionEnd otransitionend\",transition:\"transitionend\"};for(var i in e)if(void 0!==t.style[i])return{end:e[i]};return!1}t.fn.emulateTransitionEnd=function(e){var i=!1,o=this;t(this).one(\"bsTransitionEnd\",function(){i=!0});var n=function(){i||t(o).trigger(t.support.transition.end)};return setTimeout(n,e),this},t(function(){t.support.transition=e(),t.support.transition&&(t.event.special.bsTransitionEnd={bindType:t.support.transition.end,delegateType:t.support.transition.end,handle:function(e){if(t(e.target).is(this))return e.handleObj.handler.apply(this,arguments)}})})}(jQuery),function(t){\"use strict\";function e(e){return this.each(function(){var i=t(this),n=i.data(\"bs.alert\");n||i.data(\"bs.alert\",n=new o(this)),\"string\"==typeof e&&n[e].call(i)})}var i='[data-dismiss=\"alert\"]',o=function(e){t(e).on(\"click\",i,this.close)};o.VERSION=\"3.3.7\",o.TRANSITION_DURATION=150,o.prototype.close=function(e){function i(){a.detach().trigger(\"closed.bs.alert\").remove()}var n=t(this),s=n.attr(\"data-target\");s||(s=n.attr(\"href\"),s=s&&s.replace(/.*(?=#[^\\s]*$)/,\"\"));var a=t(\"#\"===s?[]:s);e&&e.preventDefault(),a.length||(a=n.closest(\".alert\")),a.trigger(e=t.Event(\"close.bs.alert\")),e.isDefaultPrevented()||(a.removeClass(\"in\"),t.support.transition&&a.hasClass(\"fade\")?a.one(\"bsTransitionEnd\",i).emulateTransitionEnd(o.TRANSITION_DURATION):i())};var n=t.fn.alert;t.fn.alert=e,t.fn.alert.Constructor=o,t.fn.alert.noConflict=function(){return t.fn.alert=n,this},t(document).on(\"click.bs.alert.data-api\",i,o.prototype.close)}(jQuery),function(t){\"use strict\";function e(e){return this.each(function(){var o=t(this),n=o.data(\"bs.button\"),s=\"object\"==typeof e&&e;n||o.data(\"bs.button\",n=new i(this,s)),\"toggle\"==e?n.toggle():e&&n.setState(e)})}var i=function(e,o){this.$element=t(e),this.options=t.extend({},i.DEFAULTS,o),this.isLoading=!1};i.VERSION=\"3.3.7\",i.DEFAULTS={loadingText:\"loading...\"},i.prototype.setState=function(e){var i=\"disabled\",o=this.$element,n=o.is(\"input\")?\"val\":\"html\",s=o.data();e+=\"Text\",null==s.resetText&&o.data(\"resetText\",o[n]()),setTimeout(t.proxy(function(){o[n](null==s[e]?this.options[e]:s[e]),\"loadingText\"==e?(this.isLoading=!0,o.addClass(i).attr(i,i).prop(i,!0)):this.isLoading&&(this.isLoading=!1,o.removeClass(i).removeAttr(i).prop(i,!1))},this),0)},i.prototype.toggle=function(){var t=!0,e=this.$element.closest('[data-toggle=\"buttons\"]');if(e.length){var i=this.$element.find(\"input\");\"radio\"==i.prop(\"type\")?(i.prop(\"checked\")&&(t=!1),e.find(\".active\").removeClass(\"active\"),this.$element.addClass(\"active\")):\"checkbox\"==i.prop(\"type\")&&(i.prop(\"checked\")!==this.$element.hasClass(\"active\")&&(t=!1),this.$element.toggleClass(\"active\")),i.prop(\"checked\",this.$element.hasClass(\"active\")),t&&i.trigger(\"change\")}else this.$element.attr(\"aria-pressed\",!this.$element.hasClass(\"active\")),this.$element.toggleClass(\"active\")};var o=t.fn.button;t.fn.button=e,t.fn.button.Constructor=i,t.fn.button.noConflict=function(){return t.fn.button=o,this},t(document).on(\"click.bs.button.data-api\",'[data-toggle^=\"button\"]',function(i){var o=t(i.target).closest(\".btn\");e.call(o,\"toggle\"),t(i.target).is('input[type=\"radio\"], input[type=\"checkbox\"]')||(i.preventDefault(),o.is(\"input,button\")?o.trigger(\"focus\"):o.find(\"input:visible,button:visible\").first().trigger(\"focus\"))}).on(\"focus.bs.button.data-api blur.bs.button.data-api\",'[data-toggle^=\"button\"]',function(e){t(e.target).closest(\".btn\").toggleClass(\"focus\",/^focus(in)?$/.test(e.type))})}(jQuery),function(t){\"use strict\";function e(e){return this.each(function(){var o=t(this),n=o.data(\"bs.carousel\"),s=t.extend({},i.DEFAULTS,o.data(),\"object\"==typeof e&&e),a=\"string\"==typeof e?e:s.slide;n||o.data(\"bs.carousel\",n=new i(this,s)),\"number\"==typeof e?n.to(e):a?n[a]():s.interval&&n.pause().cycle()})}var i=function(e,i){this.$element=t(e),this.$indicators=this.$element.find(\".carousel-indicators\"),this.options=i,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on(\"keydown.bs.carousel\",t.proxy(this.keydown,this)),\"hover\"==this.options.pause&&!(\"ontouchstart\"in document.documentElement)&&this.$element.on(\"mouseenter.bs.carousel\",t.proxy(this.pause,this)).on(\"mouseleave.bs.carousel\",t.proxy(this.cycle,this))};i.VERSION=\"3.3.7\",i.TRANSITION_DURATION=600,i.DEFAULTS={interval:5e3,pause:\"hover\",wrap:!0,keyboard:!0},i.prototype.keydown=function(t){if(!/input|textarea/i.test(t.target.tagName)){switch(t.which){case 37:this.prev();break;case 39:this.next();break;default:return}t.preventDefault()}},i.prototype.cycle=function(e){return e||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(t.proxy(this.next,this),this.options.interval)),this},i.prototype.getItemIndex=function(t){return this.$items=t.parent().children(\".item\"),this.$items.index(t||this.$active)},i.prototype.getItemForDirection=function(t,e){var i=this.getItemIndex(e);if((\"prev\"==t&&0===i||\"next\"==t&&i==this.$items.length-1)&&!this.options.wrap)return e;var o=\"prev\"==t?-1:1,n=(i+o)%this.$items.length;return this.$items.eq(n)},i.prototype.to=function(t){var e=this,i=this.getItemIndex(this.$active=this.$element.find(\".item.active\"));if(!(t>this.$items.length-1||t<0))return this.sliding?this.$element.one(\"slid.bs.carousel\",function(){e.to(t)}):i==t?this.pause().cycle():this.slide(t>i?\"next\":\"prev\",this.$items.eq(t))},i.prototype.pause=function(e){return e||(this.paused=!0),this.$element.find(\".next, .prev\").length&&t.support.transition&&(this.$element.trigger(t.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},i.prototype.next=function(){if(!this.sliding)return this.slide(\"next\")},i.prototype.prev=function(){if(!this.sliding)return this.slide(\"prev\")},i.prototype.slide=function(e,o){var n=this.$element.find(\".item.active\"),s=o||this.getItemForDirection(e,n),a=this.interval,r=\"next\"==e?\"left\":\"right\",l=this;if(s.hasClass(\"active\"))return this.sliding=!1;var h=s[0],d=t.Event(\"slide.bs.carousel\",{relatedTarget:h,direction:r});if(this.$element.trigger(d),!d.isDefaultPrevented()){if(this.sliding=!0,a&&this.pause(),this.$indicators.length){this.$indicators.find(\".active\").removeClass(\"active\");var p=t(this.$indicators.children()[this.getItemIndex(s)]);p&&p.addClass(\"active\")}var c=t.Event(\"slid.bs.carousel\",{relatedTarget:h,direction:r});return t.support.transition&&this.$element.hasClass(\"slide\")?(s.addClass(e),s[0].offsetWidth,n.addClass(r),s.addClass(r),n.one(\"bsTransitionEnd\",function(){s.removeClass([e,r].join(\" \")).addClass(\"active\"),n.removeClass([\"active\",r].join(\" \")),l.sliding=!1,setTimeout(function(){l.$element.trigger(c)},0)}).emulateTransitionEnd(i.TRANSITION_DURATION)):(n.removeClass(\"active\"),s.addClass(\"active\"),this.sliding=!1,this.$element.trigger(c)),a&&this.cycle(),this}};var o=t.fn.carousel;t.fn.carousel=e,t.fn.carousel.Constructor=i,t.fn.carousel.noConflict=function(){return t.fn.carousel=o,this};var n=function(i){var o,n=t(this),s=t(n.attr(\"data-target\")||(o=n.attr(\"href\"))&&o.replace(/.*(?=#[^\\s]+$)/,\"\"));if(s.hasClass(\"carousel\")){var a=t.extend({},s.data(),n.data()),r=n.attr(\"data-slide-to\");r&&(a.interval=!1),e.call(s,a),r&&s.data(\"bs.carousel\").to(r),i.preventDefault()}};t(document).on(\"click.bs.carousel.data-api\",\"[data-slide]\",n).on(\"click.bs.carousel.data-api\",\"[data-slide-to]\",n),t(window).on(\"load\",function(){t('[data-ride=\"carousel\"]').each(function(){var i=t(this);e.call(i,i.data())})})}(jQuery),function(t){\"use strict\";function e(e){var i,o=e.attr(\"data-target\")||(i=e.attr(\"href\"))&&i.replace(/.*(?=#[^\\s]+$)/,\"\");return t(o)}function i(e){return this.each(function(){var i=t(this),n=i.data(\"bs.collapse\"),s=t.extend({},o.DEFAULTS,i.data(),\"object\"==typeof e&&e);!n&&s.toggle&&/show|hide/.test(e)&&(s.toggle=!1),n||i.data(\"bs.collapse\",n=new o(this,s)),\"string\"==typeof e&&n[e]()})}var o=function(e,i){this.$element=t(e),this.options=t.extend({},o.DEFAULTS,i),this.$trigger=t('[data-toggle=\"collapse\"][href=\"#'+e.id+'\"],[data-toggle=\"collapse\"][data-target=\"#'+e.id+'\"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};o.VERSION=\"3.3.7\",o.TRANSITION_DURATION=350,o.DEFAULTS={toggle:!0},o.prototype.dimension=function(){return this.$element.hasClass(\"width\")?\"width\":\"height\"},o.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass(\"in\")){var e,n=this.$parent&&this.$parent.children(\".panel\").children(\".in, .collapsing\");if(!(n&&n.length&&(e=n.data(\"bs.collapse\"))&&e.transitioning)){var s=t.Event(\"show.bs.collapse\");if(this.$element.trigger(s),!s.isDefaultPrevented()){n&&n.length&&(i.call(n,\"hide\"),e||n.data(\"bs.collapse\",null));var a=this.dimension();this.$element.removeClass(\"collapse\").addClass(\"collapsing\")[a](0).attr(\"aria-expanded\",!0),this.$trigger.removeClass(\"collapsed\").attr(\"aria-expanded\",!0),this.transitioning=1;var r=function(){this.$element.removeClass(\"collapsing\").addClass(\"collapse in\")[a](\"\"),this.transitioning=0,this.$element.trigger(\"shown.bs.collapse\")};if(!t.support.transition)return r.call(this);var l=t.camelCase([\"scroll\",a].join(\"-\"));this.$element.one(\"bsTransitionEnd\",t.proxy(r,this)).emulateTransitionEnd(o.TRANSITION_DURATION)[a](this.$element[0][l])}}}},o.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass(\"in\")){var e=t.Event(\"hide.bs.collapse\");if(this.$element.trigger(e),!e.isDefaultPrevented()){var i=this.dimension();this.$element[i](this.$element[i]())[0].offsetHeight,this.$element.addClass(\"collapsing\").removeClass(\"collapse in\").attr(\"aria-expanded\",!1),this.$trigger.addClass(\"collapsed\").attr(\"aria-expanded\",!1),this.transitioning=1;var n=function(){this.transitioning=0,this.$element.removeClass(\"collapsing\").addClass(\"collapse\").trigger(\"hidden.bs.collapse\")};if(!t.support.transition)return n.call(this);this.$element[i](0).one(\"bsTransitionEnd\",t.proxy(n,this)).emulateTransitionEnd(o.TRANSITION_DURATION)}}},o.prototype.toggle=function(){this[this.$element.hasClass(\"in\")?\"hide\":\"show\"]()},o.prototype.getParent=function(){return t(this.options.parent).find('[data-toggle=\"collapse\"][data-parent=\"'+this.options.parent+'\"]').each(t.proxy(function(i,o){var n=t(o);this.addAriaAndCollapsedClass(e(n),n)},this)).end()},o.prototype.addAriaAndCollapsedClass=function(t,e){var i=t.hasClass(\"in\");t.attr(\"aria-expanded\",i),e.toggleClass(\"collapsed\",!i).attr(\"aria-expanded\",i)};var n=t.fn.collapse;t.fn.collapse=i,t.fn.collapse.Constructor=o,t.fn.collapse.noConflict=function(){return t.fn.collapse=n,this},t(document).on(\"click.bs.collapse.data-api\",'[data-toggle=\"collapse\"]',function(o){var n=t(this);n.attr(\"data-target\")||o.preventDefault();var s=e(n),a=s.data(\"bs.collapse\"),r=a?\"toggle\":n.data();i.call(s,r)})}(jQuery),function(t){\"use strict\";function e(e){var i=e.attr(\"data-target\");i||(i=e.attr(\"href\"),i=i&&/#[A-Za-z]/.test(i)&&i.replace(/.*(?=#[^\\s]*$)/,\"\"));var o=i&&t(i);return o&&o.length?o:e.parent()}function i(i){i&&3===i.which||(t(n).remove(),t(s).each(function(){var o=t(this),n=e(o),s={relatedTarget:this};n.hasClass(\"open\")&&(i&&\"click\"==i.type&&/input|textarea/i.test(i.target.tagName)&&t.contains(n[0],i.target)||(n.trigger(i=t.Event(\"hide.bs.dropdown\",s)),i.isDefaultPrevented()||(o.attr(\"aria-expanded\",\"false\"),n.removeClass(\"open\").trigger(t.Event(\"hidden.bs.dropdown\",s)))))}))}function o(e){return this.each(function(){var i=t(this),o=i.data(\"bs.dropdown\");o||i.data(\"bs.dropdown\",o=new a(this)),\"string\"==typeof e&&o[e].call(i)})}var n=\".dropdown-backdrop\",s='[data-toggle=\"dropdown\"]',a=function(e){t(e).on(\"click.bs.dropdown\",this.toggle)};a.VERSION=\"3.3.7\",a.prototype.toggle=function(o){var n=t(this);if(!n.is(\".disabled, :disabled\")){var s=e(n),a=s.hasClass(\"open\");if(i(),!a){\"ontouchstart\"in document.documentElement&&!s.closest(\".navbar-nav\").length&&t(document.createElement(\"div\")).addClass(\"dropdown-backdrop\").insertAfter(t(this)).on(\"click\",i);var r={relatedTarget:this};if(s.trigger(o=t.Event(\"show.bs.dropdown\",r)),o.isDefaultPrevented())return;n.trigger(\"focus\").attr(\"aria-expanded\",\"true\"),s.toggleClass(\"open\").trigger(t.Event(\"shown.bs.dropdown\",r))}return!1}},a.prototype.keydown=function(i){if(/(38|40|27|32)/.test(i.which)&&!/input|textarea/i.test(i.target.tagName)){var o=t(this);if(i.preventDefault(),i.stopPropagation(),!o.is(\".disabled, :disabled\")){var n=e(o),a=n.hasClass(\"open\");if(!a&&27!=i.which||a&&27==i.which)return 27==i.which&&n.find(s).trigger(\"focus\"),o.trigger(\"click\");var r=n.find(\".dropdown-menu li:not(.disabled):visible a\");if(r.length){var l=r.index(i.target);38==i.which&&l>0&&l--,40==i.which&&l<r.length-1&&l++,~l||(l=0),r.eq(l).trigger(\"focus\")}}}};var r=t.fn.dropdown;t.fn.dropdown=o,t.fn.dropdown.Constructor=a,t.fn.dropdown.noConflict=function(){return t.fn.dropdown=r,this},t(document).on(\"click.bs.dropdown.data-api\",i).on(\"click.bs.dropdown.data-api\",\".dropdown form\",function(t){t.stopPropagation()}).on(\"click.bs.dropdown.data-api\",s,a.prototype.toggle).on(\"keydown.bs.dropdown.data-api\",s,a.prototype.keydown).on(\"keydown.bs.dropdown.data-api\",\".dropdown-menu\",a.prototype.keydown)}(jQuery),function(t){\"use strict\";function e(e,o){return this.each(function(){var n=t(this),s=n.data(\"bs.modal\"),a=t.extend({},i.DEFAULTS,n.data(),\"object\"==typeof e&&e);s||n.data(\"bs.modal\",s=new i(this,a)),\"string\"==typeof e?s[e](o):a.show&&s.show(o)})}var i=function(e,i){this.options=i,this.$body=t(document.body),this.$element=t(e),this.$dialog=this.$element.find(\".modal-dialog\"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.options.remote&&this.$element.find(\".modal-content\").load(this.options.remote,t.proxy(function(){this.$element.trigger(\"loaded.bs.modal\")},this))};i.VERSION=\"3.3.7\",i.TRANSITION_DURATION=300,i.BACKDROP_TRANSITION_DURATION=150,i.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},i.prototype.toggle=function(t){return this.isShown?this.hide():this.show(t)},i.prototype.show=function(e){var o=this,n=t.Event(\"show.bs.modal\",{relatedTarget:e});this.$element.trigger(n),this.isShown||n.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass(\"modal-open\"),this.escape(),this.resize(),this.$element.on(\"click.dismiss.bs.modal\",'[data-dismiss=\"modal\"]',t.proxy(this.hide,this)),this.$dialog.on(\"mousedown.dismiss.bs.modal\",function(){o.$element.one(\"mouseup.dismiss.bs.modal\",function(e){t(e.target).is(o.$element)&&(o.ignoreBackdropClick=!0)})}),this.backdrop(function(){var n=t.support.transition&&o.$element.hasClass(\"fade\");o.$element.parent().length||o.$element.appendTo(o.$body),o.$element.show().scrollTop(0),o.adjustDialog(),n&&o.$element[0].offsetWidth,o.$element.addClass(\"in\"),o.enforceFocus();var s=t.Event(\"shown.bs.modal\",{relatedTarget:e});n?o.$dialog.one(\"bsTransitionEnd\",function(){o.$element.trigger(\"focus\").trigger(s)}).emulateTransitionEnd(i.TRANSITION_DURATION):o.$element.trigger(\"focus\").trigger(s)}))},i.prototype.hide=function(e){e&&e.preventDefault(),e=t.Event(\"hide.bs.modal\"),this.$element.trigger(e),this.isShown&&!e.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),t(document).off(\"focusin.bs.modal\"),this.$element.removeClass(\"in\").off(\"click.dismiss.bs.modal\").off(\"mouseup.dismiss.bs.modal\"),this.$dialog.off(\"mousedown.dismiss.bs.modal\"),t.support.transition&&this.$element.hasClass(\"fade\")?this.$element.one(\"bsTransitionEnd\",t.proxy(this.hideModal,this)).emulateTransitionEnd(i.TRANSITION_DURATION):this.hideModal())},i.prototype.enforceFocus=function(){t(document).off(\"focusin.bs.modal\").on(\"focusin.bs.modal\",t.proxy(function(t){document===t.target||this.$element[0]===t.target||this.$element.has(t.target).length||this.$element.trigger(\"focus\")},this))},i.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on(\"keydown.dismiss.bs.modal\",t.proxy(function(t){27==t.which&&this.hide()},this)):this.isShown||this.$element.off(\"keydown.dismiss.bs.modal\")},i.prototype.resize=function(){this.isShown?t(window).on(\"resize.bs.modal\",t.proxy(this.handleUpdate,this)):t(window).off(\"resize.bs.modal\")},i.prototype.hideModal=function(){var t=this;this.$element.hide(),this.backdrop(function(){t.$body.removeClass(\"modal-open\"),t.resetAdjustments(),t.resetScrollbar(),t.$element.trigger(\"hidden.bs.modal\")})},i.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},i.prototype.backdrop=function(e){var o=this,n=this.$element.hasClass(\"fade\")?\"fade\":\"\";if(this.isShown&&this.options.backdrop){var s=t.support.transition&&n;if(this.$backdrop=t(document.createElement(\"div\")).addClass(\"modal-backdrop \"+n).appendTo(this.$body),this.$element.on(\"click.dismiss.bs.modal\",t.proxy(function(t){if(this.ignoreBackdropClick)return void(this.ignoreBackdropClick=!1);t.target===t.currentTarget&&(\"static\"==this.options.backdrop?this.$element[0].focus():this.hide())},this)),s&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass(\"in\"),!e)return;s?this.$backdrop.one(\"bsTransitionEnd\",e).emulateTransitionEnd(i.BACKDROP_TRANSITION_DURATION):e()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass(\"in\");var a=function(){o.removeBackdrop(),e&&e()};t.support.transition&&this.$element.hasClass(\"fade\")?this.$backdrop.one(\"bsTransitionEnd\",a).emulateTransitionEnd(i.BACKDROP_TRANSITION_DURATION):a()}else e&&e()},i.prototype.handleUpdate=function(){this.adjustDialog()},i.prototype.adjustDialog=function(){var t=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&t?this.scrollbarWidth:\"\",paddingRight:this.bodyIsOverflowing&&!t?this.scrollbarWidth:\"\"})},i.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:\"\",paddingRight:\"\"})},i.prototype.checkScrollbar=function(){var t=window.innerWidth;if(!t){var e=document.documentElement.getBoundingClientRect();t=e.right-Math.abs(e.left)}this.bodyIsOverflowing=document.body.clientWidth<t,this.scrollbarWidth=this.measureScrollbar()},i.prototype.setScrollbar=function(){var t=parseInt(this.$body.css(\"padding-right\")||0,10);this.originalBodyPad=document.body.style.paddingRight||\"\",this.bodyIsOverflowing&&this.$body.css(\"padding-right\",t+this.scrollbarWidth)},i.prototype.resetScrollbar=function(){this.$body.css(\"padding-right\",this.originalBodyPad)},i.prototype.measureScrollbar=function(){var t=document.createElement(\"div\");t.className=\"modal-scrollbar-measure\",this.$body.append(t);var e=t.offsetWidth-t.clientWidth;return this.$body[0].removeChild(t),e};var o=t.fn.modal;t.fn.modal=e,t.fn.modal.Constructor=i,t.fn.modal.noConflict=function(){return t.fn.modal=o,this},t(document).on(\"click.bs.modal.data-api\",'[data-toggle=\"modal\"]',function(i){var o=t(this),n=o.attr(\"href\"),s=t(o.attr(\"data-target\")||n&&n.replace(/.*(?=#[^\\s]+$)/,\"\")),a=s.data(\"bs.modal\")?\"toggle\":t.extend({remote:!/#/.test(n)&&n},s.data(),o.data());o.is(\"a\")&&i.preventDefault(),s.one(\"show.bs.modal\",function(t){t.isDefaultPrevented()||s.one(\"hidden.bs.modal\",function(){o.is(\":visible\")&&o.trigger(\"focus\")})}),e.call(s,a,this)})}(jQuery),function(t){\"use strict\";function e(e){return this.each(function(){var o=t(this),n=o.data(\"bs.tooltip\"),s=\"object\"==typeof e&&e;!n&&/destroy|hide/.test(e)||(n||o.data(\"bs.tooltip\",n=new i(this,s)),\"string\"==typeof e&&n[e]())})}var i=function(t,e){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.inState=null,this.init(\"tooltip\",t,e)};i.VERSION=\"3.3.7\",i.TRANSITION_DURATION=150,i.DEFAULTS={animation:!0,placement:\"top\",selector:!1,template:'<div class=\"tooltip\" role=\"tooltip\"><div class=\"tooltip-arrow\"></div><div class=\"tooltip-inner\"></div></div>',trigger:\"hover focus\",title:\"\",delay:0,html:!1,container:!1,viewport:{selector:\"body\",padding:0}},i.prototype.init=function(e,i,o){if(this.enabled=!0,this.type=e,this.$element=t(i),this.options=this.getOptions(o),this.$viewport=this.options.viewport&&t(t.isFunction(this.options.viewport)?this.options.viewport.call(this,this.$element):this.options.viewport.selector||this.options.viewport),this.inState={click:!1,hover:!1,focus:!1},this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error(\"`selector` option must be specified when initializing \"+this.type+\" on the window.document object!\");for(var n=this.options.trigger.split(\" \"),s=n.length;s--;){var a=n[s];if(\"click\"==a)this.$element.on(\"click.\"+this.type,this.options.selector,t.proxy(this.toggle,this));else if(\"manual\"!=a){var r=\"hover\"==a?\"mouseenter\":\"focusin\",l=\"hover\"==a?\"mouseleave\":\"focusout\";this.$element.on(r+\".\"+this.type,this.options.selector,t.proxy(this.enter,this)),this.$element.on(l+\".\"+this.type,this.options.selector,t.proxy(this.leave,this))}}this.options.selector?this._options=t.extend({},this.options,{trigger:\"manual\",selector:\"\"}):this.fixTitle()},i.prototype.getDefaults=function(){return i.DEFAULTS},i.prototype.getOptions=function(e){return e=t.extend({},this.getDefaults(),this.$element.data(),e),e.delay&&\"number\"==typeof e.delay&&(e.delay={show:e.delay,hide:e.delay}),e},i.prototype.getDelegateOptions=function(){var e={},i=this.getDefaults();return this._options&&t.each(this._options,function(t,o){i[t]!=o&&(e[t]=o)}),e},i.prototype.enter=function(e){var i=e instanceof this.constructor?e:t(e.currentTarget).data(\"bs.\"+this.type);return i||(i=new this.constructor(e.currentTarget,this.getDelegateOptions()),t(e.currentTarget).data(\"bs.\"+this.type,i)),e instanceof t.Event&&(i.inState[\"focusin\"==e.type?\"focus\":\"hover\"]=!0),i.tip().hasClass(\"in\")||\"in\"==i.hoverState?void(i.hoverState=\"in\"):(clearTimeout(i.timeout),i.hoverState=\"in\",i.options.delay&&i.options.delay.show?void(i.timeout=setTimeout(function(){\"in\"==i.hoverState&&i.show()},i.options.delay.show)):i.show())},i.prototype.isInStateTrue=function(){for(var t in this.inState)if(this.inState[t])return!0;return!1},i.prototype.leave=function(e){var i=e instanceof this.constructor?e:t(e.currentTarget).data(\"bs.\"+this.type);if(i||(i=new this.constructor(e.currentTarget,this.getDelegateOptions()),t(e.currentTarget).data(\"bs.\"+this.type,i)),e instanceof t.Event&&(i.inState[\"focusout\"==e.type?\"focus\":\"hover\"]=!1),!i.isInStateTrue()){if(clearTimeout(i.timeout),i.hoverState=\"out\",!i.options.delay||!i.options.delay.hide)return i.hide();i.timeout=setTimeout(function(){\"out\"==i.hoverState&&i.hide()},i.options.delay.hide)}},i.prototype.show=function(){var e=t.Event(\"show.bs.\"+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(e);var o=t.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(e.isDefaultPrevented()||!o)return;var n=this,s=this.tip(),a=this.getUID(this.type);this.setContent(),s.attr(\"id\",a),this.$element.attr(\"aria-describedby\",a),this.options.animation&&s.addClass(\"fade\");var r=\"function\"==typeof this.options.placement?this.options.placement.call(this,s[0],this.$element[0]):this.options.placement,l=/\\s?auto?\\s?/i,h=l.test(r);h&&(r=r.replace(l,\"\")||\"top\"),s.detach().css({top:0,left:0,display:\"block\"}).addClass(r).data(\"bs.\"+this.type,this),this.options.container?s.appendTo(this.options.container):s.insertAfter(this.$element),this.$element.trigger(\"inserted.bs.\"+this.type);var d=this.getPosition(),p=s[0].offsetWidth,c=s[0].offsetHeight;if(h){var f=r,u=this.getPosition(this.$viewport);r=\"bottom\"==r&&d.bottom+c>u.bottom?\"top\":\"top\"==r&&d.top-c<u.top?\"bottom\":\"right\"==r&&d.right+p>u.width?\"left\":\"left\"==r&&d.left-p<u.left?\"right\":r,s.removeClass(f).addClass(r)}var g=this.getCalculatedOffset(r,d,p,c);this.applyPlacement(g,r);var m=function(){var t=n.hoverState;n.$element.trigger(\"shown.bs.\"+n.type),n.hoverState=null,\"out\"==t&&n.leave(n)};t.support.transition&&this.$tip.hasClass(\"fade\")?s.one(\"bsTransitionEnd\",m).emulateTransitionEnd(i.TRANSITION_DURATION):m()}},i.prototype.applyPlacement=function(e,i){var o=this.tip(),n=o[0].offsetWidth,s=o[0].offsetHeight,a=parseInt(o.css(\"margin-top\"),10),r=parseInt(o.css(\"margin-left\"),10);isNaN(a)&&(a=0),isNaN(r)&&(r=0),e.top+=a,e.left+=r,t.offset.setOffset(o[0],t.extend({using:function(t){o.css({top:Math.round(t.top),left:Math.round(t.left)})}},e),0),o.addClass(\"in\");var l=o[0].offsetWidth,h=o[0].offsetHeight;\"top\"==i&&h!=s&&(e.top=e.top+s-h);var d=this.getViewportAdjustedDelta(i,e,l,h);d.left?e.left+=d.left:e.top+=d.top;var p=/top|bottom/.test(i),c=p?2*d.left-n+l:2*d.top-s+h,f=p?\"offsetWidth\":\"offsetHeight\";o.offset(e),this.replaceArrow(c,o[0][f],p)},i.prototype.replaceArrow=function(t,e,i){this.arrow().css(i?\"left\":\"top\",50*(1-t/e)+\"%\").css(i?\"top\":\"left\",\"\")},i.prototype.setContent=function(){var t=this.tip(),e=this.getTitle();t.find(\".tooltip-inner\")[this.options.html?\"html\":\"text\"](e),t.removeClass(\"fade in top bottom left right\")},i.prototype.hide=function(e){function o(){\"in\"!=n.hoverState&&s.detach(),n.$element&&n.$element.removeAttr(\"aria-describedby\").trigger(\"hidden.bs.\"+n.type),e&&e()}var n=this,s=t(this.$tip),a=t.Event(\"hide.bs.\"+this.type);if(this.$element.trigger(a),!a.isDefaultPrevented())return s.removeClass(\"in\"),t.support.transition&&s.hasClass(\"fade\")?s.one(\"bsTransitionEnd\",o).emulateTransitionEnd(i.TRANSITION_DURATION):o(),this.hoverState=null,this},i.prototype.fixTitle=function(){var t=this.$element;(t.attr(\"title\")||\"string\"!=typeof t.attr(\"data-original-title\"))&&t.attr(\"data-original-title\",t.attr(\"title\")||\"\").attr(\"title\",\"\")},i.prototype.hasContent=function(){return this.getTitle()},i.prototype.getPosition=function(e){e=e||this.$element;var i=e[0],o=\"BODY\"==i.tagName,n=i.getBoundingClientRect();null==n.width&&(n=t.extend({},n,{width:n.right-n.left,height:n.bottom-n.top}));var s=window.SVGElement&&i instanceof window.SVGElement,a=o?{top:0,left:0}:s?null:e.offset(),r={scroll:o?document.documentElement.scrollTop||document.body.scrollTop:e.scrollTop()},l=o?{width:t(window).width(),height:t(window).height()}:null;return t.extend({},n,r,l,a)},i.prototype.getCalculatedOffset=function(t,e,i,o){return\"bottom\"==t?{top:e.top+e.height,left:e.left+e.width/2-i/2}:\"top\"==t?{top:e.top-o,left:e.left+e.width/2-i/2}:\"left\"==t?{top:e.top+e.height/2-o/2,left:e.left-i}:{top:e.top+e.height/2-o/2,left:e.left+e.width}},i.prototype.getViewportAdjustedDelta=function(t,e,i,o){var n={top:0,left:0};if(!this.$viewport)return n;var s=this.options.viewport&&this.options.viewport.padding||0,a=this.getPosition(this.$viewport);if(/right|left/.test(t)){var r=e.top-s-a.scroll,l=e.top+s-a.scroll+o;r<a.top?n.top=a.top-r:l>a.top+a.height&&(n.top=a.top+a.height-l)}else{var h=e.left-s,d=e.left+s+i;h<a.left?n.left=a.left-h:d>a.right&&(n.left=a.left+a.width-d)}return n},i.prototype.getTitle=function(){var t=this.$element,e=this.options;return t.attr(\"data-original-title\")||(\"function\"==typeof e.title?e.title.call(t[0]):e.title)},i.prototype.getUID=function(t){do{t+=~~(1e6*Math.random())}while(document.getElementById(t));return t},i.prototype.tip=function(){if(!this.$tip&&(this.$tip=t(this.options.template),1!=this.$tip.length))throw new Error(this.type+\" `template` option must consist of exactly 1 top-level element!\");return this.$tip},i.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(\".tooltip-arrow\")},i.prototype.enable=function(){this.enabled=!0},i.prototype.disable=function(){this.enabled=!1},i.prototype.toggleEnabled=function(){this.enabled=!this.enabled},i.prototype.toggle=function(e){var i=this;e&&((i=t(e.currentTarget).data(\"bs.\"+this.type))||(i=new this.constructor(e.currentTarget,this.getDelegateOptions()),t(e.currentTarget).data(\"bs.\"+this.type,i))),e?(i.inState.click=!i.inState.click,i.isInStateTrue()?i.enter(i):i.leave(i)):i.tip().hasClass(\"in\")?i.leave(i):i.enter(i)},i.prototype.destroy=function(){var t=this;clearTimeout(this.timeout),this.hide(function(){t.$element.off(\".\"+t.type).removeData(\"bs.\"+t.type),t.$tip&&t.$tip.detach(),t.$tip=null,t.$arrow=null,t.$viewport=null,t.$element=null})};var o=t.fn.tooltip;t.fn.tooltip=e,t.fn.tooltip.Constructor=i,t.fn.tooltip.noConflict=function(){return t.fn.tooltip=o,this}}(jQuery),function(t){\"use strict\";function e(e){return this.each(function(){var o=t(this),n=o.data(\"bs.popover\"),s=\"object\"==typeof e&&e;!n&&/destroy|hide/.test(e)||(n||o.data(\"bs.popover\",n=new i(this,s)),\"string\"==typeof e&&n[e]())})}var i=function(t,e){this.init(\"popover\",t,e)};if(!t.fn.tooltip)throw new Error(\"Popover requires tooltip.js\");i.VERSION=\"3.3.7\",i.DEFAULTS=t.extend({},t.fn.tooltip.Constructor.DEFAULTS,{placement:\"right\",trigger:\"click\",content:\"\",template:'<div class=\"popover\" role=\"tooltip\"><div class=\"arrow\"></div><h3 class=\"popover-title\"></h3><div class=\"popover-content\"></div></div>'}),i.prototype=t.extend({},t.fn.tooltip.Constructor.prototype),i.prototype.constructor=i,i.prototype.getDefaults=function(){return i.DEFAULTS},i.prototype.setContent=function(){var t=this.tip(),e=this.getTitle(),i=this.getContent();t.find(\".popover-title\")[this.options.html?\"html\":\"text\"](e),t.find(\".popover-content\").children().detach().end()[this.options.html?\"string\"==typeof i?\"html\":\"append\":\"text\"](i),t.removeClass(\"fade top bottom left right in\"),t.find(\".popover-title\").html()||t.find(\".popover-title\").hide()},i.prototype.hasContent=function(){return this.getTitle()||this.getContent()},i.prototype.getContent=function(){var t=this.$element,e=this.options;return t.attr(\"data-content\")||(\"function\"==typeof e.content?e.content.call(t[0]):e.content)},i.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(\".arrow\")};var o=t.fn.popover;t.fn.popover=e,t.fn.popover.Constructor=i,t.fn.popover.noConflict=function(){return t.fn.popover=o,this}}(jQuery),function(t){\"use strict\";function e(i,o){this.$body=t(document.body),this.$scrollElement=t(t(i).is(document.body)?window:i),this.options=t.extend({},e.DEFAULTS,o),this.selector=(this.options.target||\"\")+\" .nav li > a\",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on(\"scroll.bs.scrollspy\",t.proxy(this.process,this)),this.refresh(),this.process()}function i(i){return this.each(function(){var o=t(this),n=o.data(\"bs.scrollspy\"),s=\"object\"==typeof i&&i;n||o.data(\"bs.scrollspy\",n=new e(this,s)),\"string\"==typeof i&&n[i]()})}e.VERSION=\"3.3.7\",e.DEFAULTS={offset:10},e.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},e.prototype.refresh=function(){var e=this,i=\"offset\",o=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),t.isWindow(this.$scrollElement[0])||(i=\"position\",o=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var e=t(this),n=e.data(\"target\")||e.attr(\"href\"),s=/^#./.test(n)&&t(n);return s&&s.length&&s.is(\":visible\")&&[[s[i]().top+o,n]]||null}).sort(function(t,e){return t[0]-e[0]}).each(function(){e.offsets.push(this[0]),e.targets.push(this[1])})},e.prototype.process=function(){var t,e=this.$scrollElement.scrollTop()+this.options.offset,i=this.getScrollHeight(),o=this.options.offset+i-this.$scrollElement.height(),n=this.offsets,s=this.targets,a=this.activeTarget;if(this.scrollHeight!=i&&this.refresh(),e>=o)return a!=(t=s[s.length-1])&&this.activate(t);if(a&&e<n[0])return this.activeTarget=null,this.clear();for(t=n.length;t--;)a!=s[t]&&e>=n[t]&&(void 0===n[t+1]||e<n[t+1])&&this.activate(s[t])},e.prototype.activate=function(e){\nthis.activeTarget=e,this.clear();var i=this.selector+'[data-target=\"'+e+'\"],'+this.selector+'[href=\"'+e+'\"]',o=t(i).parents(\"li\").addClass(\"active\");o.parent(\".dropdown-menu\").length&&(o=o.closest(\"li.dropdown\").addClass(\"active\")),o.trigger(\"activate.bs.scrollspy\")},e.prototype.clear=function(){t(this.selector).parentsUntil(this.options.target,\".active\").removeClass(\"active\")};var o=t.fn.scrollspy;t.fn.scrollspy=i,t.fn.scrollspy.Constructor=e,t.fn.scrollspy.noConflict=function(){return t.fn.scrollspy=o,this},t(window).on(\"load.bs.scrollspy.data-api\",function(){t('[data-spy=\"scroll\"]').each(function(){var e=t(this);i.call(e,e.data())})})}(jQuery),function(t){\"use strict\";function e(e){return this.each(function(){var o=t(this),n=o.data(\"bs.tab\");n||o.data(\"bs.tab\",n=new i(this)),\"string\"==typeof e&&n[e]()})}var i=function(e){this.element=t(e)};i.VERSION=\"3.3.7\",i.TRANSITION_DURATION=150,i.prototype.show=function(){var e=this.element,i=e.closest(\"ul:not(.dropdown-menu)\"),o=e.data(\"target\");if(o||(o=e.attr(\"href\"),o=o&&o.replace(/.*(?=#[^\\s]*$)/,\"\")),!e.parent(\"li\").hasClass(\"active\")){var n=i.find(\".active:last a\"),s=t.Event(\"hide.bs.tab\",{relatedTarget:e[0]}),a=t.Event(\"show.bs.tab\",{relatedTarget:n[0]});if(n.trigger(s),e.trigger(a),!a.isDefaultPrevented()&&!s.isDefaultPrevented()){var r=t(o);this.activate(e.closest(\"li\"),i),this.activate(r,r.parent(),function(){n.trigger({type:\"hidden.bs.tab\",relatedTarget:e[0]}),e.trigger({type:\"shown.bs.tab\",relatedTarget:n[0]})})}}},i.prototype.activate=function(e,o,n){function s(){a.removeClass(\"active\").find(\"> .dropdown-menu > .active\").removeClass(\"active\").end().find('[data-toggle=\"tab\"]').attr(\"aria-expanded\",!1),e.addClass(\"active\").find('[data-toggle=\"tab\"]').attr(\"aria-expanded\",!0),r?(e[0].offsetWidth,e.addClass(\"in\")):e.removeClass(\"fade\"),e.parent(\".dropdown-menu\").length&&e.closest(\"li.dropdown\").addClass(\"active\").end().find('[data-toggle=\"tab\"]').attr(\"aria-expanded\",!0),n&&n()}var a=o.find(\"> .active\"),r=n&&t.support.transition&&(a.length&&a.hasClass(\"fade\")||!!o.find(\"> .fade\").length);a.length&&r?a.one(\"bsTransitionEnd\",s).emulateTransitionEnd(i.TRANSITION_DURATION):s(),a.removeClass(\"in\")};var o=t.fn.tab;t.fn.tab=e,t.fn.tab.Constructor=i,t.fn.tab.noConflict=function(){return t.fn.tab=o,this};var n=function(i){i.preventDefault(),e.call(t(this),\"show\")};t(document).on(\"click.bs.tab.data-api\",'[data-toggle=\"tab\"]',n).on(\"click.bs.tab.data-api\",'[data-toggle=\"pill\"]',n)}(jQuery),function(t){\"use strict\";function e(e){return this.each(function(){var o=t(this),n=o.data(\"bs.affix\"),s=\"object\"==typeof e&&e;n||o.data(\"bs.affix\",n=new i(this,s)),\"string\"==typeof e&&n[e]()})}var i=function(e,o){this.options=t.extend({},i.DEFAULTS,o),this.$target=t(this.options.target).on(\"scroll.bs.affix.data-api\",t.proxy(this.checkPosition,this)).on(\"click.bs.affix.data-api\",t.proxy(this.checkPositionWithEventLoop,this)),this.$element=t(e),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};i.VERSION=\"3.3.7\",i.RESET=\"affix affix-top affix-bottom\",i.DEFAULTS={offset:0,target:window},i.prototype.getState=function(t,e,i,o){var n=this.$target.scrollTop(),s=this.$element.offset(),a=this.$target.height();if(null!=i&&\"top\"==this.affixed)return n<i&&\"top\";if(\"bottom\"==this.affixed)return null!=i?!(n+this.unpin<=s.top)&&\"bottom\":!(n+a<=t-o)&&\"bottom\";var r=null==this.affixed,l=r?n:s.top,h=r?a:e;return null!=i&&n<=i?\"top\":null!=o&&l+h>=t-o&&\"bottom\"},i.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(i.RESET).addClass(\"affix\");var t=this.$target.scrollTop(),e=this.$element.offset();return this.pinnedOffset=e.top-t},i.prototype.checkPositionWithEventLoop=function(){setTimeout(t.proxy(this.checkPosition,this),1)},i.prototype.checkPosition=function(){if(this.$element.is(\":visible\")){var e=this.$element.height(),o=this.options.offset,n=o.top,s=o.bottom,a=Math.max(t(document).height(),t(document.body).height());\"object\"!=typeof o&&(s=n=o),\"function\"==typeof n&&(n=o.top(this.$element)),\"function\"==typeof s&&(s=o.bottom(this.$element));var r=this.getState(a,e,n,s);if(this.affixed!=r){null!=this.unpin&&this.$element.css(\"top\",\"\");var l=\"affix\"+(r?\"-\"+r:\"\"),h=t.Event(l+\".bs.affix\");if(this.$element.trigger(h),h.isDefaultPrevented())return;this.affixed=r,this.unpin=\"bottom\"==r?this.getPinnedOffset():null,this.$element.removeClass(i.RESET).addClass(l).trigger(l.replace(\"affix\",\"affixed\")+\".bs.affix\")}\"bottom\"==r&&this.$element.offset({top:a-e-s})}};var o=t.fn.affix;t.fn.affix=e,t.fn.affix.Constructor=i,t.fn.affix.noConflict=function(){return t.fn.affix=o,this},t(window).on(\"load\",function(){t('[data-spy=\"affix\"]').each(function(){var i=t(this),o=i.data();o.offset=o.offset||{},null!=o.offsetBottom&&(o.offset.bottom=o.offsetBottom),null!=o.offsetTop&&(o.offset.top=o.offsetTop),e.call(i,o)})})}(jQuery);"

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(117))

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	module.exports = "!function(e){\"use strict\";\"function\"==typeof define&&define.amd?define([\"jquery\"],e):\"object\"==typeof module&&module.exports?module.exports=e(require(\"jquery\")):e(window.jQuery)}(function(e){\"use strict\";e.fn.fileinputLocales={},e.fn.fileinputThemes={},String.prototype.setTokens=function(e){var i,t,a=this.toString();for(i in e)e.hasOwnProperty(i)&&(t=new RegExp(\"{\"+i+\"}\",\"g\"),a=a.replace(t,e[i]));return a};var i,t;i={FRAMES:\".kv-preview-thumb\",SORT_CSS:\"file-sortable\",STYLE_SETTING:'style=\"width:{width};height:{height};\"',OBJECT_PARAMS:'<param name=\"controller\" value=\"true\" />\\n<param name=\"allowFullScreen\" value=\"true\" />\\n<param name=\"allowScriptAccess\" value=\"always\" />\\n<param name=\"autoPlay\" value=\"false\" />\\n<param name=\"autoStart\" value=\"false\" />\\n<param name=\"quality\" value=\"high\" />\\n',DEFAULT_PREVIEW:'<div class=\"file-preview-other\">\\n<span class=\"{previewFileIconClass}\">{previewFileIcon}</span>\\n</div>',MODAL_ID:\"kvFileinputModal\",MODAL_EVENTS:[\"show\",\"shown\",\"hide\",\"hidden\",\"loaded\"],objUrl:window.URL||window.webkitURL,compare:function(e,i,t){return void 0!==e&&(t?e===i:e.match(i))},isIE:function(e){if(\"Microsoft Internet Explorer\"!==navigator.appName)return!1;if(10===e)return new RegExp(\"msie\\\\s\"+e,\"i\").test(navigator.userAgent);var i,t=document.createElement(\"div\");return t.innerHTML=\"\\x3c!--[if IE \"+e+\"]> <i></i> <![endif]--\\x3e\",i=t.getElementsByTagName(\"i\").length,document.body.appendChild(t),t.parentNode.removeChild(t),i},initModal:function(i){var t=e(\"body\");t.length&&i.appendTo(t)},isEmpty:function(i,t){return void 0===i||null===i||0===i.length||t&&\"\"===e.trim(i)},isArray:function(e){return Array.isArray(e)||\"[object Array]\"===Object.prototype.toString.call(e)},ifSet:function(e,i,t){return t=t||\"\",i&&\"object\"==typeof i&&e in i?i[e]:t},cleanArray:function(e){return e instanceof Array||(e=[]),e.filter(function(e){return void 0!==e&&null!==e})},spliceArray:function(e,i){var t,a=0,n=[];if(!(e instanceof Array))return[];for(t=0;t<e.length;t++)t!==i&&(n[a]=e[t],a++);return n},getNum:function(e,i){return i=i||0,\"number\"==typeof e?e:(\"string\"==typeof e&&(e=parseFloat(e)),isNaN(e)?i:e)},hasFileAPISupport:function(){return!(!window.File||!window.FileReader)},hasDragDropSupport:function(){var e=document.createElement(\"div\");return!i.isIE(9)&&(void 0!==e.draggable||void 0!==e.ondragstart&&void 0!==e.ondrop)},hasFileUploadSupport:function(){return i.hasFileAPISupport()&&window.FormData},hasBlobSupport:function(){try{return!!window.Blob&&Boolean(new Blob)}catch(e){return!1}},hasArrayBufferViewSupport:function(){try{return 100===new Blob([new Uint8Array(100)]).size}catch(e){return!1}},dataURI2Blob:function(e){var t,a,n,r,o,l,s=window.BlobBuilder||window.WebKitBlobBuilder||window.MozBlobBuilder||window.MSBlobBuilder,d=i.hasBlobSupport();if(!((d||s)&&window.atob&&window.ArrayBuffer&&window.Uint8Array))return null;for(t=e.split(\",\")[0].indexOf(\"base64\")>=0?atob(e.split(\",\")[1]):decodeURIComponent(e.split(\",\")[1]),a=new ArrayBuffer(t.length),n=new Uint8Array(a),r=0;r<t.length;r+=1)n[r]=t.charCodeAt(r);return o=e.split(\",\")[0].split(\":\")[1].split(\";\")[0],d?new Blob([i.hasArrayBufferViewSupport()?n:a],{type:o}):(l=new s,l.append(a),l.getBlob(o))},addCss:function(e,i){e.removeClass(i).addClass(i)},getElement:function(t,a,n){return i.isEmpty(t)||i.isEmpty(t[a])?n:e(t[a])},uniqId:function(){return Math.round((new Date).getTime()+100*Math.random())},htmlEncode:function(e){return e.replace(/&/g,\"&amp;\").replace(/</g,\"&lt;\").replace(/>/g,\"&gt;\").replace(/\"/g,\"&quot;\").replace(/'/g,\"&apos;\")},replaceTags:function(i,t){var a=i;return t?(e.each(t,function(e,i){\"function\"==typeof i&&(i=i()),a=a.split(e).join(i)}),a):a},cleanMemory:function(e){var t=e.is(\"img\")?e.attr(\"src\"):e.find(\"source\").attr(\"src\");i.objUrl.revokeObjectURL(t)},findFileName:function(e){var i=e.lastIndexOf(\"/\");return-1===i&&(i=e.lastIndexOf(\"\\\\\")),e.split(e.substring(i,i+1)).pop()},checkFullScreen:function(){return document.fullscreenElement||document.mozFullScreenElement||document.webkitFullscreenElement||document.msFullscreenElement},toggleFullScreen:function(e){var t=document,a=t.documentElement;a&&e&&!i.checkFullScreen()?a.requestFullscreen?a.requestFullscreen():a.msRequestFullscreen?a.msRequestFullscreen():a.mozRequestFullScreen?a.mozRequestFullScreen():a.webkitRequestFullscreen&&a.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT):t.exitFullscreen?t.exitFullscreen():t.msExitFullscreen?t.msExitFullscreen():t.mozCancelFullScreen?t.mozCancelFullScreen():t.webkitExitFullscreen&&t.webkitExitFullscreen()},moveArray:function(e,i,t){if(t>=e.length)for(var a=t-e.length;1+a--;)e.push(void 0);return e.splice(t,0,e.splice(i,1)[0]),e},cleanZoomCache:function(e){var i=e.closest(\".kv-zoom-cache-theme\");i.length||(i=e.closest(\".kv-zoom-cache\")),i.remove()},setOrientation:function(e,i){var t,a,n,r=new DataView(e),o=0,l=1;if(!(65496!==r.getUint16(o)||e.length<2)){for(o+=2,t=r.byteLength;o<t-2;)switch(a=r.getUint16(o),o+=2,a){case 65505:n=r.getUint16(o),t=n-o,o+=2;break;case 274:l=r.getUint16(o+6,!1),t=0}i&&i(l)}},validateOrientation:function(e,t){if(window.FileReader&&window.DataView){var a,n=new FileReader;n.onloadend=function(){a=n.result,i.setOrientation(a,t)},n.readAsArrayBuffer(e)}},adjustOrientedImage:function(e,i){var t,a,n;if(e.hasClass(\"is-portrait-gt4\")){if(i)return void e.css({width:e.parent().height()});e.css({height:\"auto\",width:e.height()}),t=e.parent().offset().top,a=e.offset().top,n=t-a,e.css(\"margin-top\",n)}}},t=function(t,a){var n=this;n.$element=e(t),n._validate()&&(n.isPreviewable=i.hasFileAPISupport(),n.isIE9=i.isIE(9),n.isIE10=i.isIE(10),n.isPreviewable||n.isIE9?(n._init(a),n._listen()):n.$element.removeClass(\"file-loading\"))},t.prototype={constructor:t,_cleanup:function(){var e=this;e.reader=null,e.formdata={},e.uploadCount=0,e.uploadStatus={},e.uploadLog=[],e.uploadAsyncCount=0,e.loadedImages=[],e.totalImagesCount=0,e.ajaxRequests=[],e.clearStack(),e.fileInputCleared=!1,e.fileBatchCompleted=!0,e.isPreviewable||(e.showPreview=!1),e.isError=!1,e.ajaxAborted=!1,e.cancelling=!1},_init:function(t){var a,n,r,o=this,l=o.$element;o.options=t,e.each(t,function(e,t){switch(e){case\"minFileCount\":case\"maxFileCount\":case\"minFileSize\":case\"maxFileSize\":case\"maxFilePreviewSize\":case\"resizeImageQuality\":case\"resizeIfSizeMoreThan\":case\"progressUploadThreshold\":case\"initialPreviewCount\":case\"zoomModalHeight\":case\"minImageHeight\":case\"maxImageHeight\":case\"minImageWidth\":case\"maxImageWidth\":o[e]=i.getNum(t);break;default:o[e]=t}}),o.rtl&&(r=o.previewZoomButtonIcons.prev,o.previewZoomButtonIcons.prev=o.previewZoomButtonIcons.next,o.previewZoomButtonIcons.next=r),o._cleanup(),o.$form=l.closest(\"form\"),o._initTemplateDefaults(),o.uploadFileAttr=i.isEmpty(l.attr(\"name\"))?\"file_data\":l.attr(\"name\"),n=o._getLayoutTemplate(\"progress\"),o.progressTemplate=n.replace(\"{class}\",o.progressClass),o.progressCompleteTemplate=n.replace(\"{class}\",o.progressCompleteClass),o.progressErrorTemplate=n.replace(\"{class}\",o.progressErrorClass),o.dropZoneEnabled=i.hasDragDropSupport()&&o.dropZoneEnabled,o.isDisabled=l.attr(\"disabled\")||l.attr(\"readonly\"),o.isDisabled&&l.attr(\"disabled\",!0),o.isUploadable=i.hasFileUploadSupport()&&!i.isEmpty(o.uploadUrl),o.isClickable=o.browseOnZoneClick&&o.showPreview&&(o.isUploadable&&o.dropZoneEnabled||!i.isEmpty(o.defaultPreviewContent)),o.slug=\"function\"==typeof t.slugCallback?t.slugCallback:o._slugDefault,o.mainTemplate=o.showCaption?o._getLayoutTemplate(\"main1\"):o._getLayoutTemplate(\"main2\"),o.captionTemplate=o._getLayoutTemplate(\"caption\"),o.previewGenericTemplate=o._getPreviewTemplate(\"generic\"),o.resizeImage&&(o.maxImageWidth||o.maxImageHeight)&&(o.imageCanvas=document.createElement(\"canvas\"),o.imageCanvasContext=o.imageCanvas.getContext(\"2d\")),i.isEmpty(l.attr(\"id\"))&&l.attr(\"id\",i.uniqId()),o.namespace=\".fileinput_\"+l.attr(\"id\").replace(/-/g,\"_\"),void 0===o.$container?o.$container=o._createContainer():o._refreshContainer(),a=o.$container,o.$dropZone=a.find(\".file-drop-zone\"),o.$progress=a.find(\".kv-upload-progress\"),o.$btnUpload=a.find(\".fileinput-upload\"),o.$captionContainer=i.getElement(t,\"elCaptionContainer\",a.find(\".file-caption\")),o.$caption=i.getElement(t,\"elCaptionText\",a.find(\".file-caption-name\")),o.$previewContainer=i.getElement(t,\"elPreviewContainer\",a.find(\".file-preview\")),o.$preview=i.getElement(t,\"elPreviewImage\",a.find(\".file-preview-thumbnails\")),o.$previewStatus=i.getElement(t,\"elPreviewStatus\",a.find(\".file-preview-status\")),o.$errorContainer=i.getElement(t,\"elErrorContainer\",o.$previewContainer.find(\".kv-fileinput-error\")),i.isEmpty(o.msgErrorClass)||i.addCss(o.$errorContainer,o.msgErrorClass),o.$errorContainer.hide(),o.previewInitId=\"preview-\"+i.uniqId(),o._initPreviewCache(),o._initPreview(!0),o._initPreviewActions(),o._setFileDropZoneTitle(),l.removeClass(\"file-loading\"),l.attr(\"disabled\")&&o.disable(),o._initZoom(),o.hideThumbnailContent&&i.addCss(o.$preview,\"hide-content\")},_initTemplateDefaults:function(){var t,a,n,r,o,l,s,d,c,u,p,f,m,h,v,g,w,_,b,C,y,T,E,x,F,S,I,k,P,z,A,$,D,U,B,j,L=this;t='{preview}\\n<div class=\"kv-upload-progress hide\"></div>\\n<div class=\"input-group {class}\">\\n   {caption}\\n   <div class=\"input-group-btn\">\\n       {remove}\\n       {cancel}\\n       {upload}\\n       {browse}\\n   </div>\\n</div>',a='{preview}\\n<div class=\"kv-upload-progress hide\"></div>\\n{remove}\\n{cancel}\\n{upload}\\n{browse}\\n',n='<div class=\"file-preview {class}\">\\n    {close}    <div class=\"{dropClass}\">\\n    <div class=\"file-preview-thumbnails\">\\n    </div>\\n    <div class=\"clearfix\"></div>    <div class=\"file-preview-status text-center text-success\"></div>\\n    <div class=\"kv-fileinput-error\"></div>\\n    </div>\\n</div>',o='<div class=\"close fileinput-remove\">&times;</div>\\n',r='<i class=\"glyphicon glyphicon-file kv-caption-icon\"></i>',l='<div tabindex=\"500\" class=\"form-control file-caption {class}\">\\n   <div class=\"file-caption-name\"></div>\\n</div>\\n',s='<button type=\"{type}\" tabindex=\"500\" title=\"{title}\" class=\"{css}\" {status}>{icon} {label}</button>',d='<a href=\"{href}\" tabindex=\"500\" title=\"{title}\" class=\"{css}\" {status}>{icon} {label}</a>',c='<div tabindex=\"500\" class=\"{css}\" {status}>{icon} {label}</div>',u='<div id=\"'+i.MODAL_ID+'\" class=\"file-zoom-dialog modal fade\" tabindex=\"-1\" aria-labelledby=\"'+i.MODAL_ID+'Label\"></div>',p='<div class=\"modal-dialog modal-lg{rtl}\" role=\"document\">\\n  <div class=\"modal-content\">\\n    <div class=\"modal-header\">\\n      <div class=\"kv-zoom-actions pull-right\">{toggleheader}{fullscreen}{borderless}{close}</div>\\n      <h3 class=\"modal-title\">{heading} <small><span class=\"kv-zoom-title\"></span></small></h3>\\n    </div>\\n    <div class=\"modal-body\">\\n      <div class=\"floating-buttons\"></div>\\n      <div class=\"kv-zoom-body file-zoom-content {zoomFrameClass}\"></div>\\n{prev} {next}\\n    </div>\\n  </div>\\n</div>\\n',f='<div class=\"progress\">\\n    <div class=\"{class}\" role=\"progressbar\" aria-valuenow=\"{percent}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width:{percent}%;\">\\n        {status}\\n     </div>\\n</div>',m=\" <samp>({sizeText})</samp>\",h='<div class=\"file-thumbnail-footer\">\\n    <div class=\"file-footer-caption\" title=\"{caption}\">{caption}<br>{size}</div>\\n    {progress} {indicator} {actions}\\n</div>',v='{drag}\\n<div class=\"file-actions\">\\n    <div class=\"file-footer-buttons\">\\n        {upload} {delete} {zoom} {other}    </div>\\n    <div class=\"clearfix\"></div>\\n</div>',g='<button type=\"button\" class=\"kv-file-remove {removeClass}\" title=\"{removeTitle}\" {dataUrl}{dataKey}>{removeIcon}</button>\\n',w='<button type=\"button\" class=\"kv-file-upload {uploadClass}\" title=\"{uploadTitle}\">{uploadIcon}</button>',_='<button type=\"button\" class=\"kv-file-zoom {zoomClass}\" title=\"{zoomTitle}\">{zoomIcon}</button>',b='<span class=\"file-drag-handle {dragClass}\" title=\"{dragTitle}\">{dragIcon}</span>',C='<div class=\"file-upload-indicator\" title=\"{indicatorTitle}\">{indicator}</div>',y='<div class=\"file-preview-frame {frameClass}\" id=\"{previewId}\" data-fileindex=\"{fileindex}\" data-template=\"{template}\"',T=y+'><div class=\"kv-file-content\">\\n',E=y+' title=\"{caption}\"><div class=\"kv-file-content\">\\n',x=\"</div>{footer}\\n</div>\\n\",F=\"{content}\\n\",S='<div class=\"kv-preview-data file-preview-html\" title=\"{caption}\" '+i.STYLE_SETTING+\">{data}</div>\\n\",I='<img src=\"{data}\" class=\"file-preview-image kv-preview-data\" title=\"{caption}\" alt=\"{caption}\" '+i.STYLE_SETTING+\">\\n\",k='<textarea class=\"kv-preview-data file-preview-text\" title=\"{caption}\" readonly '+i.STYLE_SETTING+\">{data}</textarea>\\n\",P='<video class=\"kv-preview-data file-preview-video\" width=\"{width}\" height=\"{height}\" controls>\\n<source src=\"{data}\" type=\"{type}\">\\n'+i.DEFAULT_PREVIEW+\"\\n</video>\\n\",z='<div class=\"file-preview-audio\"><audio class=\"kv-preview-data\" controls>\\n<source src=\"{data}\" type=\"{type}\">\\n'+i.DEFAULT_PREVIEW+\"\\n</audio></div>\\n\",A='<object class=\"kv-preview-data file-object\" type=\"application/x-shockwave-flash\" width=\"{width}\" height=\"{height}\" data=\"{data}\">\\n'+i.OBJECT_PARAMS+\" \"+i.DEFAULT_PREVIEW+\"\\n</object>\\n\",$='<object class=\"kv-preview-data file-object {typeCss}\" data=\"{data}\" type=\"{type}\" width=\"{width}\" height=\"{height}\">\\n<param name=\"movie\" value=\"{caption}\" />\\n'+i.OBJECT_PARAMS+\" \"+i.DEFAULT_PREVIEW+\"\\n</object>\\n\",D='<embed class=\"kv-preview-data\" src=\"{data}\" width=\"{width}\" height=\"{height}\" type=\"application/pdf\">\\n',U='<div class=\"kv-preview-data file-preview-other-frame\">\\n'+i.DEFAULT_PREVIEW+\"\\n</div>\\n\",B='<div class=\"kv-zoom-cache\" style=\"display:none\">{zoomContent}</div>',j={width:\"100%\",height:\"100%\",\"min-height\":\"480px\"},L.defaults={layoutTemplates:{main1:t,main2:a,preview:n,close:o,fileIcon:r,caption:l,modalMain:u,modal:p,progress:f,size:m,footer:h,indicator:C,actions:v,actionDelete:g,actionUpload:w,actionZoom:_,actionDrag:b,btnDefault:s,btnLink:d,btnBrowse:c,zoomCache:B},previewMarkupTags:{tagBefore1:T,tagBefore2:E,tagAfter:x},previewContentTemplates:{generic:F,html:S,image:I,text:k,video:P,audio:z,flash:A,object:$,pdf:D,other:U},allowedPreviewTypes:[\"image\",\"html\",\"text\",\"video\",\"audio\",\"flash\",\"pdf\",\"object\"],previewTemplates:{},previewSettings:{image:{width:\"auto\",height:\"160px\"},html:{width:\"213px\",height:\"160px\"},text:{width:\"213px\",height:\"160px\"},video:{width:\"auto\",height:\"100%\",\"max-width\":\"100%\"},audio:{width:\"100%\",height:\"30px\"},flash:{width:\"auto\",height:\"100%\",\"max-width\":\"100%\"},object:{height:\"100%\"},pdf:{width:\"160px\",height:\"160px\"},other:{width:\"160px\",height:\"160px\"}},previewZoomSettings:{image:{width:\"auto\",height:\"auto\",\"max-width\":\"100%\",\"max-height\":\"100%\"},html:j,text:j,video:{width:\"auto\",height:\"100%\",\"max-width\":\"100%\"},audio:{width:\"100%\",height:\"30px\"},flash:{width:\"auto\",height:\"480px\"},object:{width:\"auto\",height:\"100%\",\"max-width\":\"100%\",\"min-height\":\"480px\"},pdf:j,other:{width:\"auto\",height:\"100%\",\"min-height\":\"480px\"}},fileTypeSettings:{image:function(e,t){return i.compare(e,\"image.*\")||i.compare(t,/\\.(gif|png|jpe?g)$/i)},html:function(e,t){return i.compare(e,\"text/html\")||i.compare(t,/\\.(htm|html)$/i)},text:function(e,t){return i.compare(e,\"text.*\")||i.compare(t,/\\.(xml|javascript)$/i)||i.compare(t,/\\.(txt|md|csv|nfo|ini|json|php|js|css)$/i)},video:function(e,t){return i.compare(e,\"video.*\")&&(i.compare(e,/(ogg|mp4|mp?g|mov|webm|3gp)$/i)||i.compare(t,/\\.(og?|mp4|webm|mp?g|mov|3gp)$/i))},audio:function(e,t){return i.compare(e,\"audio.*\")&&(i.compare(t,/(ogg|mp3|mp?g|wav)$/i)||i.compare(t,/\\.(og?|mp3|mp?g|wav)$/i))},flash:function(e,t){return i.compare(e,\"application/x-shockwave-flash\",!0)||i.compare(t,/\\.(swf)$/i)},pdf:function(e,t){return i.compare(e,\"application/pdf\",!0)||i.compare(t,/\\.(pdf)$/i)},object:function(){return!0},other:function(){return!0}},fileActionSettings:{showRemove:!0,showUpload:!0,showZoom:!0,showDrag:!0,removeIcon:'<i class=\"glyphicon glyphicon-trash text-danger\"></i>',removeClass:\"btn btn-xs btn-default\",removeTitle:\"Remove file\",uploadIcon:'<i class=\"glyphicon glyphicon-upload text-info\"></i>',uploadClass:\"btn btn-xs btn-default\",uploadTitle:\"Upload file\",zoomIcon:'<i class=\"glyphicon glyphicon-zoom-in\"></i>',zoomClass:\"btn btn-xs btn-default\",zoomTitle:\"View Details\",dragIcon:'<i class=\"glyphicon glyphicon-menu-hamburger\"></i>',dragClass:\"text-info\",dragTitle:\"Move / Rearrange\",dragSettings:{},indicatorNew:'<i class=\"glyphicon glyphicon-hand-down text-warning\"></i>',indicatorSuccess:'<i class=\"glyphicon glyphicon-ok-sign text-success\"></i>',indicatorError:'<i class=\"glyphicon glyphicon-exclamation-sign text-danger\"></i>',indicatorLoading:'<i class=\"glyphicon glyphicon-hand-up text-muted\"></i>',indicatorNewTitle:\"Not uploaded yet\",indicatorSuccessTitle:\"Uploaded\",indicatorErrorTitle:\"Upload Error\",indicatorLoadingTitle:\"Uploading ...\"}},e.each(L.defaults,function(i,t){if(\"allowedPreviewTypes\"===i)return void(void 0===L.allowedPreviewTypes&&(L.allowedPreviewTypes=t));L[i]=e.extend(!0,{},t,L[i])}),L._initPreviewTemplates()},_initPreviewTemplates:function(){var t,a=this,n=a.defaults,r=a.previewMarkupTags,o=r.tagAfter;e.each(n.previewContentTemplates,function(e,n){i.isEmpty(a.previewTemplates[e])&&(t=r.tagBefore2,\"generic\"!==e&&\"image\"!==e&&\"html\"!==e&&\"text\"!==e||(t=r.tagBefore1),a.previewTemplates[e]=t+n+o)})},_initPreviewCache:function(){var t=this;t.previewCache={data:{},init:function(){var e=t.initialPreview;e.length>0&&!i.isArray(e)&&(e=e.split(t.initialPreviewDelimiter)),t.previewCache.data={content:e,config:t.initialPreviewConfig,tags:t.initialPreviewThumbTags}},fetch:function(){return t.previewCache.data.content.filter(function(e){return null!==e})},count:function(e){return t.previewCache.data&&t.previewCache.data.content?e?t.previewCache.data.content.length:t.previewCache.fetch().length:0},get:function(a,n){var r,o,l,s,d,c,u,p=\"init_\"+a,f=t.previewCache.data,m=f.config[a],h=f.content[a],v=t.previewInitId+\"-\"+p,g=i.ifSet(\"previewAsData\",m,t.initialPreviewAsData),w=function(e,a,n,r,o,l,s,d,c){return d=\" file-preview-initial \"+i.SORT_CSS+(d?\" \"+d:\"\"),t._generatePreviewTemplate(e,a,n,r,o,!1,null,d,l,s,c)};return h?(n=void 0===n||n,l=i.ifSet(\"type\",m,t.initialPreviewFileType||\"generic\"),d=i.ifSet(\"filename\",m,i.ifSet(\"caption\",m)),c=i.ifSet(\"filetype\",m,l),s=t.previewCache.footer(a,n,m&&m.size||null),u=i.ifSet(\"frameClass\",m),r=g?w(l,h,d,c,v,s,p,u):w(\"generic\",h,d,c,v,s,p,u,l).setTokens({content:f.content[a]}),f.tags.length&&f.tags[a]&&(r=i.replaceTags(r,f.tags[a])),i.isEmpty(m)||i.isEmpty(m.frameAttr)||(o=e(document.createElement(\"div\")).html(r),o.find(\".file-preview-initial\").attr(m.frameAttr),r=o.html(),o.remove()),r):\"\"},add:function(e,a,n,r){var o,l=t.previewCache.data;return i.isArray(e)||(e=e.split(t.initialPreviewDelimiter)),r?(o=l.content.push(e)-1,l.config[o]=a,l.tags[o]=n):(o=e.length-1,l.content=e,l.config=a,l.tags=n),t.previewCache.data=l,o},set:function(e,a,n,r){var o,l,s=t.previewCache.data;if(e&&e.length&&(i.isArray(e)||(e=e.split(t.initialPreviewDelimiter)),l=e.filter(function(e){return null!==e}),l.length)){if(void 0===s.content&&(s.content=[]),void 0===s.config&&(s.config=[]),void 0===s.tags&&(s.tags=[]),r){for(o=0;o<e.length;o++)e[o]&&s.content.push(e[o]);for(o=0;o<a.length;o++)a[o]&&s.config.push(a[o]);for(o=0;o<n.length;o++)n[o]&&s.tags.push(n[o])}else s.content=e,s.config=a,s.tags=n;t.previewCache.data=s}},unset:function(e){var i=t.previewCache.count();if(i){if(1===i)return t.previewCache.data.content=[],t.previewCache.data.config=[],t.previewCache.data.tags=[],t.initialPreview=[],t.initialPreviewConfig=[],void(t.initialPreviewThumbTags=[]);t.previewCache.data.content[e]=null,t.previewCache.data.config[e]=null,t.previewCache.data.tags[e]=null}},out:function(){var e,i,a=\"\",n=t.previewCache.count(!0);if(0===n)return{content:\"\",caption:\"\"};for(i=0;i<n;i++)a+=t.previewCache.get(i);return e=t._getMsgSelected(t.previewCache.count()),{content:a,caption:e}},footer:function(e,a,n){var r=t.previewCache.data;if(!r||!r.config||0===r.config.length||i.isEmpty(r.config[e]))return\"\";a=void 0===a||a;var o,l=r.config[e],s=i.ifSet(\"caption\",l),d=i.ifSet(\"width\",l,\"auto\"),c=i.ifSet(\"url\",l,!1),u=i.ifSet(\"key\",l,null),p=t.fileActionSettings,f=t.initialPreviewShowDelete||!1,m=i.ifSet(\"showDelete\",l,i.ifSet(\"showDelete\",p,f)),h=i.ifSet(\"showZoom\",l,i.ifSet(\"showZoom\",p,!0)),v=i.ifSet(\"showDrag\",l,i.ifSet(\"showDrag\",p,!0)),g=!1===c&&a;return o=t._renderFileActions(!1,m,h,v,g,c,u,!0),t._getLayoutTemplate(\"footer\").setTokens({progress:t._renderThumbProgress(),actions:o,caption:s,size:t._getSize(n),width:d,indicator:\"\"})}},t.previewCache.init()},_handler:function(e,i,t){var a=this,n=a.namespace,r=i.split(\" \").join(n+\" \")+n;e&&e.length&&e.off(r).on(r,t)},_log:function(e){var i=this,t=i.$element.attr(\"id\");t&&(e='\"'+t+'\": '+e),void 0!==window.console.log?window.console.log(e):window.alert(e)},_validate:function(){var e=this,i=\"file\"===e.$element.attr(\"type\");return i||e._log('The input \"type\" must be set to \"file\" for initializing the \"bootstrap-fileinput\" plugin.'),i},_errorsExist:function(){var i,t=this;return!!t.$errorContainer.find(\"li\").length||(i=e(document.createElement(\"div\")).html(t.$errorContainer.html()),i.find(\"span.kv-error-close\").remove(),i.find(\"ul\").remove(),!!e.trim(i.text()).length)},_errorHandler:function(e,i){var t=this,a=e.target.error,n=function(e){t._showError(e.replace(\"{name}\",i))};n(a.code===a.NOT_FOUND_ERR?t.msgFileNotFound:a.code===a.SECURITY_ERR?t.msgFileSecured:a.code===a.NOT_READABLE_ERR?t.msgFileNotReadable:a.code===a.ABORT_ERR?t.msgFilePreviewAborted:t.msgFilePreviewError)},_addError:function(e){var i=this,t=i.$errorContainer;e&&t.length&&(t.html(i.errorCloseButton+e),i._handler(t.find(\".kv-error-close\"),\"click\",function(){t.fadeOut(\"slow\")}))},_resetErrors:function(e){var i=this,t=i.$errorContainer;i.isError=!1,i.$container.removeClass(\"has-error\"),t.html(\"\"),e?t.fadeOut(\"slow\"):t.hide()},_showFolderError:function(e){var t,a=this,n=a.$errorContainer;e&&(t=a.msgFoldersNotAllowed.replace(\"{n}\",e),a._addError(t),i.addCss(a.$container,\"has-error\"),n.fadeIn(800),a._raise(\"filefoldererror\",[e,t]))},_showUploadError:function(e,t,a){var n=this,r=n.$errorContainer,o=a||\"fileuploaderror\",l=t&&t.id?'<li data-file-id=\"'+t.id+'\">'+e+\"</li>\":\"<li>\"+e+\"</li>\";return 0===r.find(\"ul\").length?n._addError(\"<ul>\"+l+\"</ul>\"):r.find(\"ul\").append(l),r.fadeIn(800),n._raise(o,[t,e]),n.$container.removeClass(\"file-input-new\"),i.addCss(n.$container,\"has-error\"),!0},_showError:function(e,t,a){var n=this,r=n.$errorContainer,o=a||\"fileerror\";return t=t||{},t.reader=n.reader,n._addError(e),r.fadeIn(800),n._raise(o,[t,e]),n.isUploadable||n._clearFileInput(),n.$container.removeClass(\"file-input-new\"),i.addCss(n.$container,\"has-error\"),n.$btnUpload.attr(\"disabled\",!0),!0},_noFilesError:function(e){var t=this,a=t.minFileCount>1?t.filePlural:t.fileSingle,n=t.msgFilesTooLess.replace(\"{n}\",t.minFileCount).replace(\"{files}\",a),r=t.$errorContainer;t._addError(n),t.isError=!0,t._updateFileDetails(0),r.fadeIn(800),t._raise(\"fileerror\",[e,n]),t._clearFileInput(),i.addCss(t.$container,\"has-error\")},_parseError:function(i,t,a,n){var r=this,o=e.trim(a+\"\"),l=\".\"===o.slice(-1)?\"\":\".\",s=void 0!==t.responseJSON&&void 0!==t.responseJSON.error?t.responseJSON.error:t.responseText;return r.cancelling&&r.msgUploadAborted&&(o=r.msgUploadAborted),r.showAjaxErrorDetails&&s?(s=e.trim(s.replace(/\\n\\s*\\n/g,\"\\n\")),s=s.length>0?\"<pre>\"+s+\"</pre>\":\"\",o+=l+s):o+=l,o===l&&(o=r.msgAjaxError.replace(\"{operation}\",i)),r.cancelling=!1,n?\"<b>\"+n+\": </b>\"+o:o},_parseFileType:function(e){var t,a,n,r,o=this,l=o.allowedPreviewTypes||[];for(r=0;r<l.length;r++)if(n=l[r],t=o.fileTypeSettings[n],a=t(e.type,e.name)?n:\"\",!i.isEmpty(a))return a;return\"other\"},_getPreviewIcon:function(i){var t,a=this,n=null;return i&&i.indexOf(\".\")>-1&&(t=i.split(\".\").pop(),a.previewFileIconSettings&&(n=a.previewFileIconSettings[t]||a.previewFileIconSettings[t.toLowerCase()]||null),a.previewFileExtSettings&&e.each(a.previewFileExtSettings,function(e,i){if(a.previewFileIconSettings[e]&&i(t))return void(n=a.previewFileIconSettings[e])})),n},_parseFilePreviewIcon:function(e,i){var t=this,a=t._getPreviewIcon(i)||t.previewFileIcon,n=e;return n.indexOf(\"{previewFileIcon}\")>-1&&(n=n.setTokens({previewFileIconClass:t.previewFileIconClass,previewFileIcon:a})),n},_raise:function(i,t){var a=this,n=e.Event(i);if(void 0!==t?a.$element.trigger(n,t):a.$element.trigger(n),n.isDefaultPrevented()||!1===n.result)return!1;switch(i){case\"filebatchuploadcomplete\":case\"filebatchuploadsuccess\":case\"fileuploaded\":case\"fileclear\":case\"filecleared\":case\"filereset\":case\"fileerror\":case\"filefoldererror\":case\"fileuploaderror\":case\"filebatchuploaderror\":case\"filedeleteerror\":case\"filecustomerror\":case\"filesuccessremove\":break;default:a.ajaxAborted||(a.ajaxAborted=n.result)}return!0},_listenFullScreen:function(e){var i,t,a=this,n=a.$modal;n&&n.length&&(i=n&&n.find(\".btn-fullscreen\"),t=n&&n.find(\".btn-borderless\"),i.length&&t.length&&(i.removeClass(\"active\").attr(\"aria-pressed\",\"false\"),t.removeClass(\"active\").attr(\"aria-pressed\",\"false\"),e?i.addClass(\"active\").attr(\"aria-pressed\",\"true\"):t.addClass(\"active\").attr(\"aria-pressed\",\"true\"),n.hasClass(\"file-zoom-fullscreen\")?a._maximizeZoomDialog():e?a._maximizeZoomDialog():t.removeClass(\"active\").attr(\"aria-pressed\",\"false\")))},_listen:function(){var t,a=this,n=a.$element,r=a.$form,o=a.$container;a._handler(n,\"change\",e.proxy(a._change,a)),a.showBrowse&&a._handler(a.$btnFile,\"click\",e.proxy(a._browse,a)),a._handler(o.find(\".fileinput-remove:not([disabled])\"),\"click\",e.proxy(a.clear,a)),a._handler(o.find(\".fileinput-cancel\"),\"click\",e.proxy(a.cancel,a)),a._initDragDrop(),a._handler(r,\"reset\",e.proxy(a.reset,a)),a.isUploadable||a._handler(r,\"submit\",e.proxy(a._submitForm,a)),a._handler(a.$container.find(\".fileinput-upload\"),\"click\",e.proxy(a._uploadClick,a)),a._handler(e(window),\"resize\",function(){a._listenFullScreen(screen.width===window.innerWidth&&screen.height===window.innerHeight)}),t=\"webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange\",a._handler(e(document),t,function(){a._listenFullScreen(i.checkFullScreen())}),a._initClickable()},_initClickable:function(){var t,a=this;a.isClickable&&(t=a.isUploadable?a.$dropZone:a.$preview.find(\".file-default-preview\"),i.addCss(t,\"clickable\"),t.attr(\"tabindex\",-1),a._handler(t,\"click\",function(i){var n=e(i.target);n.parents(\".file-preview-thumbnails\").length&&!n.parents(\".file-default-preview\").length||(a.$element.trigger(\"click\"),t.blur())}))},_initDragDrop:function(){var i=this,t=i.$dropZone;i.isUploadable&&i.dropZoneEnabled&&i.showPreview&&(i._handler(t,\"dragenter dragover\",e.proxy(i._zoneDragEnter,i)),i._handler(t,\"dragleave\",e.proxy(i._zoneDragLeave,i)),i._handler(t,\"drop\",e.proxy(i._zoneDrop,i)),i._handler(e(document),\"dragenter dragover drop\",i._zoneDragDropInit))},_zoneDragDropInit:function(e){e.stopPropagation(),e.preventDefault()},_zoneDragEnter:function(t){var a=this,n=e.inArray(\"Files\",t.originalEvent.dataTransfer.types)>-1;if(a._zoneDragDropInit(t),a.isDisabled||!n)return t.originalEvent.dataTransfer.effectAllowed=\"none\",void(t.originalEvent.dataTransfer.dropEffect=\"none\");i.addCss(a.$dropZone,\"file-highlighted\")},_zoneDragLeave:function(e){var i=this;i._zoneDragDropInit(e),i.isDisabled||i.$dropZone.removeClass(\"file-highlighted\")},_zoneDrop:function(e){var t=this;e.preventDefault(),t.isDisabled||i.isEmpty(e.originalEvent.dataTransfer.files)||(t._change(e,\"dragdrop\"),t.$dropZone.removeClass(\"file-highlighted\"))},_uploadClick:function(e){var t,a=this,n=a.$container.find(\".fileinput-upload\"),r=!n.hasClass(\"disabled\")&&i.isEmpty(n.attr(\"disabled\"));if(!e||!e.isDefaultPrevented()){if(!a.isUploadable)return void(r&&\"submit\"!==n.attr(\"type\")&&(t=n.closest(\"form\"),t.length&&t.trigger(\"submit\"),e.preventDefault()));e.preventDefault(),r&&a.upload()}},_submitForm:function(){var e=this;return e._isFileSelectionValid()&&!e._abort({})},_clearPreview:function(){var t=this,a=t.$preview;(t.showUploadedThumbs?t.getFrames(\":not(.file-preview-success)\"):t.getFrames()).each(function(){var t=e(this);t.remove(),i.cleanZoomCache(a.find(\"#zoom-\"+t.attr(\"id\")))}),t.getFrames().length&&t.showPreview||t._resetUpload(),t._validateDefaultPreview()},_initSortable:function(){var t,a=this,n=a.$preview,r=\".\"+i.SORT_CSS;window.KvSortable&&0!==n.find(r).length&&(t={handle:\".drag-handle-init\",dataIdAttr:\"data-preview-id\",scroll:!1,draggable:r,onSort:function(t){var n,r,o=t.oldIndex,l=t.newIndex;a.initialPreview=i.moveArray(a.initialPreview,o,l),a.initialPreviewConfig=i.moveArray(a.initialPreviewConfig,o,l),a.previewCache.init();for(var s=0;s<a.initialPreviewConfig.length;s++)null!==a.initialPreviewConfig[s]&&(n=a.initialPreviewConfig[s].key,r=e(\".kv-file-remove[data-key='\"+n+\"']\").closest(i.FRAMES),r.attr(\"data-fileindex\",\"init_\"+s).attr(\"data-fileindex\",\"init_\"+s));a._raise(\"filesorted\",{previewId:e(t.item).attr(\"id\"),oldIndex:o,newIndex:l,stack:a.initialPreviewConfig})}},n.data(\"kvsortable\")&&n.kvsortable(\"destroy\"),e.extend(!0,t,a.fileActionSettings.dragSettings),n.kvsortable(t))},_initPreview:function(e){var t,a=this,n=a.initialCaption||\"\";if(!a.previewCache.count())return a._clearPreview(),void(e?a._setCaption(n):a._initCaption());t=a.previewCache.out(),n=e&&a.initialCaption?a.initialCaption:t.caption,a.$preview.html(t.content),a._setInitThumbAttr(),a._setCaption(n),a._initSortable(),i.isEmpty(t.content)||a.$container.removeClass(\"file-input-new\")},_getZoomButton:function(e){var i=this,t=i.previewZoomButtonIcons[e],a=i.previewZoomButtonClasses[e],n=' title=\"'+(i.previewZoomButtonTitles[e]||\"\")+'\" ',r=n+(\"close\"===e?' data-dismiss=\"modal\" aria-hidden=\"true\"':\"\");return\"fullscreen\"!==e&&\"borderless\"!==e&&\"toggleheader\"!==e||(r+=' data-toggle=\"button\" aria-pressed=\"false\" autocomplete=\"off\"'),'<button type=\"button\" class=\"'+a+\" btn-\"+e+'\"'+r+\">\"+t+\"</button>\"},_getModalContent:function(){var e=this;return e._getLayoutTemplate(\"modal\").setTokens({rtl:e.rtl?\" kv-rtl\":\"\",zoomFrameClass:e.frameClass,heading:e.msgZoomModalHeading,prev:e._getZoomButton(\"prev\"),next:e._getZoomButton(\"next\"),toggleheader:e._getZoomButton(\"toggleheader\"),fullscreen:e._getZoomButton(\"fullscreen\"),borderless:e._getZoomButton(\"borderless\"),close:e._getZoomButton(\"close\")})},_listenModalEvent:function(e){var t=this,a=t.$modal,n=function(e){return{sourceEvent:e,previewId:a.data(\"previewId\"),modal:a}};a.on(e+\".bs.modal\",function(r){var o=a.find(\".btn-fullscreen\"),l=a.find(\".btn-borderless\");t._raise(\"filezoom\"+e,n(r)),\"shown\"===e&&(l.removeClass(\"active\").attr(\"aria-pressed\",\"false\"),o.removeClass(\"active\").attr(\"aria-pressed\",\"false\"),a.hasClass(\"file-zoom-fullscreen\")&&(t._maximizeZoomDialog(),i.checkFullScreen()?o.addClass(\"active\").attr(\"aria-pressed\",\"true\"):l.addClass(\"active\").attr(\"aria-pressed\",\"true\")))})},_initZoom:function(){var t,a=this,n=a._getLayoutTemplate(\"modalMain\"),r=\"#\"+i.MODAL_ID;a.showPreview&&(a.$modal=e(r),a.$modal&&a.$modal.length||(t=e(document.createElement(\"div\")).html(n).insertAfter(a.$container),a.$modal=e(r).insertBefore(t),t.remove()),i.initModal(a.$modal),a.$modal.html(a._getModalContent()),e.each(i.MODAL_EVENTS,function(e,i){a._listenModalEvent(i)}))},_initZoomButtons:function(){var i,t,a=this,n=a.$modal.data(\"previewId\")||\"\",r=a.getFrames().toArray(),o=r.length,l=a.$modal.find(\".btn-prev\"),s=a.$modal.find(\".btn-next\");if(r.length<2)return l.hide(),void s.hide();l.show(),s.show(),o&&(i=e(r[0]),t=e(r[o-1]),l.removeAttr(\"disabled\"),s.removeAttr(\"disabled\"),i.length&&i.attr(\"id\")===n&&l.attr(\"disabled\",!0),t.length&&t.attr(\"id\")===n&&s.attr(\"disabled\",!0))},_maximizeZoomDialog:function(){var i=this,t=i.$modal,a=t.find(\".modal-header:visible\"),n=t.find(\".modal-footer:visible\"),r=t.find(\".modal-body\"),o=e(window).height(),l=0;t.addClass(\"file-zoom-fullscreen\"),a&&a.length&&(o-=a.outerHeight(!0)),n&&n.length&&(o-=n.outerHeight(!0)),r&&r.length&&(l=r.outerHeight(!0)-r.height(),o-=l),t.find(\".kv-zoom-body\").height(o)},_resizeZoomDialog:function(e){var t=this,a=t.$modal,n=a.find(\".btn-fullscreen\"),r=a.find(\".btn-borderless\")\n;if(a.hasClass(\"file-zoom-fullscreen\"))i.toggleFullScreen(!1),e?n.hasClass(\"active\")||(a.removeClass(\"file-zoom-fullscreen\"),t._resizeZoomDialog(!0),r.hasClass(\"active\")&&r.removeClass(\"active\").attr(\"aria-pressed\",\"false\")):n.hasClass(\"active\")?n.removeClass(\"active\").attr(\"aria-pressed\",\"false\"):(a.removeClass(\"file-zoom-fullscreen\"),t.$modal.find(\".kv-zoom-body\").css(\"height\",t.zoomModalHeight));else{if(!e)return void t._maximizeZoomDialog();i.toggleFullScreen(!0)}a.focus()},_setZoomContent:function(t,a){var n,r,o,l,s,d,c,u,p,f,m=this,h=t.attr(\"id\"),v=m.$modal,g=v.find(\".btn-prev\"),w=v.find(\".btn-next\"),_=v.find(\".btn-fullscreen\"),b=v.find(\".btn-borderless\"),C=v.find(\".btn-toggleheader\"),y=m.$preview.find(\"#zoom-\"+h);r=y.attr(\"data-template\")||\"generic\",n=y.find(\".kv-file-content\"),o=n.length?n.html():\"\",p=t.data(\"caption\")||\"\",f=t.data(\"size\")||\"\",l=p+\" \"+f,v.find(\".kv-zoom-title\").html(l),s=v.find(\".kv-zoom-body\"),v.removeClass(\"kv-single-content\"),a?(u=s.addClass(\"file-thumb-loading\").clone().insertAfter(s),s.html(o).hide(),u.fadeOut(\"fast\",function(){s.fadeIn(\"fast\",function(){s.removeClass(\"file-thumb-loading\")}),u.remove()})):s.html(o),c=m.previewZoomSettings[r],c&&(d=s.find(\".kv-preview-data\"),i.addCss(d,\"file-zoom-detail\"),e.each(c,function(e,i){d.css(e,i),(d.attr(\"width\")&&\"width\"===e||d.attr(\"height\")&&\"height\"===e)&&d.removeAttr(e)})),v.data(\"previewId\",h);var T=s.find(\"img\");T.length&&i.adjustOrientedImage(T,!0),m._handler(g,\"click\",function(){m._zoomSlideShow(\"prev\",h)}),m._handler(w,\"click\",function(){m._zoomSlideShow(\"next\",h)}),m._handler(_,\"click\",function(){m._resizeZoomDialog(!0)}),m._handler(b,\"click\",function(){m._resizeZoomDialog(!1)}),m._handler(C,\"click\",function(){var e,i=v.find(\".modal-header\"),t=v.find(\".modal-body .floating-buttons\"),a=i.find(\".kv-zoom-actions\"),n=function(e){var t=m.$modal.find(\".kv-zoom-body\"),a=m.zoomModalHeight;v.hasClass(\"file-zoom-fullscreen\")&&(a=t.outerHeight(!0),e||(a-=i.outerHeight(!0))),t.css(\"height\",e?a+e:a)};i.is(\":visible\")?(e=i.outerHeight(!0),i.slideUp(\"slow\",function(){a.find(\".btn\").appendTo(t),n(e)})):(t.find(\".btn\").appendTo(a),i.slideDown(\"slow\",function(){n()})),v.focus()}),m._handler(v,\"keydown\",function(e){var i=e.which||e.keyCode;37!==i||g.attr(\"disabled\")||m._zoomSlideShow(\"prev\",h),39!==i||w.attr(\"disabled\")||m._zoomSlideShow(\"next\",h)})},_zoomPreview:function(e){var t,a=this,n=a.$modal;if(!e.length)throw\"Cannot zoom to detailed preview!\";i.initModal(n),n.html(a._getModalContent()),t=e.closest(i.FRAMES),a._setZoomContent(t),n.modal(\"show\"),a._initZoomButtons()},_zoomSlideShow:function(i,t){var a,n,r,o=this,l=o.$modal.find(\".kv-zoom-actions .btn-\"+i),s=o.getFrames().toArray(),d=s.length;if(!l.attr(\"disabled\")){for(n=0;n<d;n++)if(e(s[n]).attr(\"id\")===t){r=\"prev\"===i?n-1:n+1;break}r<0||r>=d||!s[r]||(a=e(s[r]),a.length&&o._setZoomContent(a,!0),o._initZoomButtons(),o._raise(\"filezoom\"+i,{previewId:t,modal:o.$modal}))}},_initZoomButton:function(){var i=this;i.$preview.find(\".kv-file-zoom\").each(function(){var t=e(this);i._handler(t,\"click\",function(){i._zoomPreview(t)})})},_clearObjects:function(i){i.find(\"video audio\").each(function(){this.pause(),e(this).remove()}),i.find(\"img object div\").each(function(){e(this).remove()})},_clearFileInput:function(){var t,a,n,r=this,o=r.$element;r.fileInputCleared=!0,i.isEmpty(o.val())||(r.isIE9||r.isIE10?(t=o.closest(\"form\"),a=e(document.createElement(\"form\")),n=e(document.createElement(\"div\")),o.before(n),t.length?t.after(a):n.after(a),a.append(o).trigger(\"reset\"),n.before(o).remove(),a.remove()):o.val(\"\"))},_resetUpload:function(){var e=this;e.uploadCache={content:[],config:[],tags:[],append:!0},e.uploadCount=0,e.uploadStatus={},e.uploadLog=[],e.uploadAsyncCount=0,e.loadedImages=[],e.totalImagesCount=0,e.$btnUpload.removeAttr(\"disabled\"),e._setProgress(0),i.addCss(e.$progress,\"hide\"),e._resetErrors(!1),e.ajaxAborted=!1,e.ajaxRequests=[],e._resetCanvas(),e.cacheInitialPreview={},e.overwriteInitial&&(e.initialPreview=[],e.initialPreviewConfig=[],e.initialPreviewThumbTags=[],e.previewCache.data={content:[],config:[],tags:[]})},_resetCanvas:function(){var e=this;e.canvas&&e.imageCanvasContext&&e.imageCanvasContext.clearRect(0,0,e.canvas.width,e.canvas.height)},_hasInitialPreview:function(){var e=this;return!e.overwriteInitial&&e.previewCache.count()},_resetPreview:function(){var e,i,t=this;t.previewCache.count()?(e=t.previewCache.out(),t.$preview.html(e.content),t._setInitThumbAttr(),i=t.initialCaption?t.initialCaption:e.caption,t._setCaption(i)):(t._clearPreview(),t._initCaption()),t.showPreview&&(t._initZoom(),t._initSortable())},_clearDefaultPreview:function(){this.$preview.find(\".file-default-preview\").remove()},_validateDefaultPreview:function(){var e=this;e.showPreview&&!i.isEmpty(e.defaultPreviewContent)&&(e.$preview.html('<div class=\"file-default-preview\">'+e.defaultPreviewContent+\"</div>\"),e.$container.removeClass(\"file-input-new\"),e._initClickable())},_resetPreviewThumbs:function(e){var i,t=this;if(e)return t._clearPreview(),void t.clearStack();t._hasInitialPreview()?(i=t.previewCache.out(),t.$preview.html(i.content),t._setInitThumbAttr(),t._setCaption(i.caption),t._initPreviewActions()):t._clearPreview()},_getLayoutTemplate:function(e){var t=this,a=t.layoutTemplates[e];return i.isEmpty(t.customLayoutTags)?a:i.replaceTags(a,t.customLayoutTags)},_getPreviewTemplate:function(e){var t=this,a=t.previewTemplates[e];return i.isEmpty(t.customPreviewTags)?a:i.replaceTags(a,t.customPreviewTags)},_getOutData:function(e,i,t){var a=this;return e=e||{},i=i||{},t=t||a.filestack.slice(0)||{},{form:a.formdata,files:t,filenames:a.filenames,filescount:a.getFilesCount(),extra:a._getExtraData(),response:i,reader:a.reader,jqXHR:e}},_getMsgSelected:function(e){var i=this,t=1===e?i.fileSingle:i.filePlural;return e>0?i.msgSelected.replace(\"{n}\",e).replace(\"{files}\",t):i.msgNoFilesSelected},_getFrame:function(i){var t=this,a=e(\"#\"+i);return a.length?a:(t._log('Invalid thumb frame with id: \"'+i+'\".'),null)},_getThumbs:function(e){return e=e||\"\",this.getFrames(\":not(.file-preview-initial)\"+e)},_getExtraData:function(e,i){var t=this,a=t.uploadExtraData;return\"function\"==typeof t.uploadExtraData&&(a=t.uploadExtraData(e,i)),a},_initXhr:function(e,i,t){var a=this;return e.upload&&e.upload.addEventListener(\"progress\",function(e){var n=0,r=e.total,o=e.loaded||e.position;e.lengthComputable&&(n=Math.floor(o/r*100)),i?a._setAsyncUploadStatus(i,n,t):a._setProgress(n)},!1),e},_ajaxSubmit:function(i,t,a,n,r,o){var l,s=this;s._raise(\"filepreajax\",[r,o])&&(s._uploadExtra(r,o),l=e.extend(!0,{},{xhr:function(){var i=e.ajaxSettings.xhr();return s._initXhr(i,r,s.getFileStack().length)},url:s.uploadUrl,type:\"POST\",dataType:\"json\",data:s.formdata,cache:!1,processData:!1,contentType:!1,beforeSend:i,success:t,complete:a,error:n},s.ajaxSettings),s.ajaxRequests.push(e.ajax(l)))},_mergeArray:function(e,t){var a=this,n=i.cleanArray(a[e]),r=i.cleanArray(t);a[e]=n.concat(r)},_initUploadSuccess:function(t,a,n){var r,o,l,s,d,c,u,p,f,m=this;m.showPreview&&\"object\"==typeof t&&!e.isEmptyObject(t)&&void 0!==t.initialPreview&&t.initialPreview.length>0&&(m.hasInitData=!0,c=t.initialPreview||[],u=t.initialPreviewConfig||[],p=t.initialPreviewThumbTags||[],r=!(void 0!==t.append&&!t.append),c.length>0&&!i.isArray(c)&&(c=c.split(m.initialPreviewDelimiter)),m._mergeArray(\"initialPreview\",c),m._mergeArray(\"initialPreviewConfig\",u),m._mergeArray(\"initialPreviewThumbTags\",p),void 0!==a?n?(f=a.attr(\"data-fileindex\"),m.uploadCache.content[f]=c[0],m.uploadCache.config[f]=u[0]||[],m.uploadCache.tags[f]=p[0]||[],m.uploadCache.append=r):(l=m.previewCache.add(c,u[0],p[0],r),o=m.previewCache.get(l,!1),s=e(document.createElement(\"div\")).html(o).hide().insertAfter(a),d=s.find(\".kv-zoom-cache\"),d&&d.length&&d.insertAfter(a),a.fadeOut(\"slow\",function(){var e=s.find(\".file-preview-frame\");e&&e.length&&e.insertBefore(a).fadeIn(\"slow\").css(\"display:inline-block\"),m._initPreviewActions(),m._clearFileInput(),i.cleanZoomCache(m.$preview.find(\"#zoom-\"+a.attr(\"id\"))),a.remove(),s.remove(),m._initSortable()})):(m.previewCache.set(c,u,p,r),m._initPreview(),m._initPreviewActions()))},_initSuccessThumbs:function(){var t=this;t.showPreview&&t._getThumbs(i.FRAMES+\".file-preview-success\").each(function(){var a=e(this),n=t.$preview,r=a.find(\".kv-file-remove\");r.removeAttr(\"disabled\"),t._handler(r,\"click\",function(){var e=a.attr(\"id\"),r=t._raise(\"filesuccessremove\",[e,a.attr(\"data-fileindex\")]);i.cleanMemory(a),!1!==r&&a.fadeOut(\"slow\",function(){i.cleanZoomCache(n.find(\"#zoom-\"+e)),a.remove(),t.getFrames().length||t.reset()})})})},_checkAsyncComplete:function(){var i,t,a=this;for(t=0;t<a.filestack.length;t++)if(a.filestack[t]&&(i=a.previewInitId+\"-\"+t,-1===e.inArray(i,a.uploadLog)))return!1;return a.uploadAsyncCount===a.uploadLog.length},_uploadExtra:function(i,t){var a=this,n=a._getExtraData(i,t);0!==n.length&&e.each(n,function(e,i){a.formdata.append(e,i)})},_uploadSingle:function(t,a,n){var r,o,l,s,d,c,u,p,f,m,h,v=this,g=v.getFileStack().length,w=new FormData,_=v.previewInitId+\"-\"+t,b=v.filestack.length>0||!e.isEmptyObject(v.uploadExtraData),C=e(\"#\"+_).find(\".file-thumb-progress\"),y={id:_,index:t},T=!i.isEmpty(v.$element.attr(\"multiple\"));v.formdata=w,v.showPreview&&(o=e(\"#\"+_+\":not(.file-preview-initial)\"),s=o.find(\".kv-file-upload\"),d=o.find(\".kv-file-remove\"),C.removeClass(\"hide\")),0===g||!b||s&&s.hasClass(\"disabled\")||v._abort(y)||(m=function(e,i){!T&&h||v.updateStack(e,void 0),v.uploadLog.push(i),v._checkAsyncComplete()&&(v.fileBatchCompleted=!0)},l=function(){var e,t,a,n=v.uploadCache,r=0,o=v.cacheInitialPreview;v.fileBatchCompleted&&(o&&o.content&&(r=o.content.length),setTimeout(function(){var l=T||!h;if(v.showPreview){if(v.previewCache.set(n.content,n.config,n.tags,n.append),r){for(t=0;t<n.content.length;t++)a=t+r,o.content[a]=n.content[t],o.config.length&&(o.config[a]=n.config[t]),o.tags.length&&(o.tags[a]=n.tags[t]);v.initialPreview=i.cleanArray(o.content),v.initialPreviewConfig=i.cleanArray(o.config),v.initialPreviewThumbTags=i.cleanArray(o.tags)}else v.initialPreview=n.content,v.initialPreviewConfig=n.config,v.initialPreviewThumbTags=n.tags;v.cacheInitialPreview={},v.hasInitData&&(v._initPreview(),v._initPreviewActions())}v.unlock(l),l&&v._clearFileInput(),e=v.$preview.find(\".file-preview-initial\"),v.uploadAsync&&e.length&&(i.addCss(e,i.SORT_CSS),v._initSortable()),v._raise(\"filebatchuploadcomplete\",[v.filestack,v._getExtraData()]),v.uploadCount=0,v.uploadStatus={},v.uploadLog=[],v._setProgress(101)},100))},c=function(a){r=v._getOutData(a),v.fileBatchCompleted=!1,v.showPreview&&(o.hasClass(\"file-preview-success\")||(v._setThumbStatus(o,\"Loading\"),i.addCss(o,\"file-uploading\")),s.attr(\"disabled\",!0),d.attr(\"disabled\",!0)),n||v.lock(),v._raise(\"filepreupload\",[r,_,t]),e.extend(!0,y,r),v._abort(y)&&(a.abort(),v._setProgressCancelled())},u=function(a,l,d){var c=v.showPreview&&o.attr(\"id\")?o.attr(\"id\"):_;r=v._getOutData(d,a),e.extend(!0,y,r),setTimeout(function(){i.isEmpty(a)||i.isEmpty(a.error)?(v.showPreview&&(v._setThumbStatus(o,\"Success\"),s.hide(),v._initUploadSuccess(a,o,n),v._setProgress(101,C)),v._raise(\"fileuploaded\",[r,c,t]),n?m(t,c):v.updateStack(t,void 0)):(h=!0,v._showUploadError(a.error,y),v._setPreviewError(o,t,T?null:v.filestack[t]),n&&m(t,c))},100)},p=function(){setTimeout(function(){v.showPreview&&(s.removeAttr(\"disabled\"),d.removeAttr(\"disabled\"),o.removeClass(\"file-uploading\")),n?l():(v.unlock(!1),v._clearFileInput()),v._initSuccessThumbs()},100)},f=function(i,r,l){var s=v.ajaxOperations.uploadThumb,d=v._parseError(s,i,l,n?a[t].name:null);h=!0,setTimeout(function(){n&&m(t,_),v.uploadStatus[_]=100,v._setPreviewError(o,t,T?null:v.filestack[t]),e.extend(!0,y,v._getOutData(i)),v._setProgress(101,C,v.msgAjaxProgressError.replace(\"{operation}\",s)),v._showUploadError(d,y)},100)},w.append(v.uploadFileAttr,a[t],v.filenames[t]),w.append(\"file_id\",t),v._ajaxSubmit(c,u,p,f,_,t))},_uploadBatch:function(){var t,a,n,r,o,l=this,s=l.filestack,d=s.length,c={},u=l.filestack.length>0||!e.isEmptyObject(l.uploadExtraData);l.formdata=new FormData,0!==d&&u&&!l._abort(c)&&(o=function(){e.each(s,function(e){l.updateStack(e,void 0)}),l._clearFileInput()},t=function(t){l.lock();var a=l._getOutData(t);l.showPreview&&l._getThumbs().each(function(){var t=e(this),a=t.find(\".kv-file-upload\"),n=t.find(\".kv-file-remove\");t.hasClass(\"file-preview-success\")||(l._setThumbStatus(t,\"Loading\"),i.addCss(t,\"file-uploading\")),a.attr(\"disabled\",!0),n.attr(\"disabled\",!0)}),l._raise(\"filebatchpreupload\",[a]),l._abort(a)&&(t.abort(),l._setProgressCancelled())},a=function(t,a,n){var r=l._getOutData(n,t),s=l._getThumbs(\":not(.file-preview-error)\"),d=0,c=i.isEmpty(t)||i.isEmpty(t.errorkeys)?[]:t.errorkeys;i.isEmpty(t)||i.isEmpty(t.error)?(l._raise(\"filebatchuploadsuccess\",[r]),o(),l.showPreview?(s.each(function(){var i=e(this),t=i.find(\".kv-file-upload\");i.find(\".kv-file-upload\").hide(),l._setThumbStatus(i,\"Success\"),i.removeClass(\"file-uploading\"),t.removeAttr(\"disabled\")}),l._initUploadSuccess(t)):l.reset(),l._setProgress(101)):(l.showPreview&&(s.each(function(){var i=e(this),t=i.find(\".kv-file-remove\"),a=i.find(\".kv-file-upload\");if(i.removeClass(\"file-uploading\"),a.removeAttr(\"disabled\"),t.removeAttr(\"disabled\"),0===c.length)return void l._setPreviewError(i);-1!==e.inArray(d,c)?l._setPreviewError(i):(i.find(\".kv-file-upload\").hide(),l._setThumbStatus(i,\"Success\"),l.updateStack(d,void 0)),d++}),l._initUploadSuccess(t)),l._showUploadError(t.error,r,\"filebatchuploaderror\"))},r=function(){l.unlock(),l._initSuccessThumbs(),l._clearFileInput(),l._raise(\"filebatchuploadcomplete\",[l.filestack,l._getExtraData()])},n=function(i,t,a){var n=l._getOutData(i),r=l.ajaxOperations.uploadBatch,o=l._parseError(r,i,a);l._showUploadError(o,n,\"filebatchuploaderror\"),l.uploadFileCount=d-1,l.showPreview&&(l._getThumbs().each(function(){var i=e(this),t=i.attr(\"data-fileindex\");i.removeClass(\"file-uploading\"),void 0!==l.filestack[t]&&l._setPreviewError(i)}),l._getThumbs().removeClass(\"file-uploading\"),l._getThumbs(\" .kv-file-upload\").removeAttr(\"disabled\"),l._getThumbs(\" .kv-file-delete\").removeAttr(\"disabled\"),l._setProgress(101,l.$progress,l.msgAjaxProgressError.replace(\"{operation}\",r)))},e.each(s,function(e,t){i.isEmpty(s[e])||l.formdata.append(l.uploadFileAttr,t,l.filenames[e])}),l._ajaxSubmit(t,a,r,n))},_uploadExtraOnly:function(){var e,t,a,n,r=this,o={};r.formdata=new FormData,r._abort(o)||(e=function(e){r.lock();var i=r._getOutData(e);r._raise(\"filebatchpreupload\",[i]),r._setProgress(50),o.data=i,o.xhr=e,r._abort(o)&&(e.abort(),r._setProgressCancelled())},t=function(e,t,a){var n=r._getOutData(a,e);i.isEmpty(e)||i.isEmpty(e.error)?(r._raise(\"filebatchuploadsuccess\",[n]),r._clearFileInput(),r._initUploadSuccess(e),r._setProgress(101)):r._showUploadError(e.error,n,\"filebatchuploaderror\")},a=function(){r.unlock(),r._clearFileInput(),r._raise(\"filebatchuploadcomplete\",[r.filestack,r._getExtraData()])},n=function(e,i,t){var a=r._getOutData(e),n=r.ajaxOperations.uploadExtra,l=r._parseError(n,e,t);o.data=a,r._showUploadError(l,a,\"filebatchuploaderror\"),r._setProgress(101,r.$progress,r.msgAjaxProgressError.replace(\"{operation}\",n))},r._ajaxSubmit(e,t,a,n))},_deleteFileIndex:function(t){var a=this,n=t.attr(\"data-fileindex\");\"init_\"===n.substring(0,5)&&(n=parseInt(n.replace(\"init_\",\"\")),a.initialPreview=i.spliceArray(a.initialPreview,n),a.initialPreviewConfig=i.spliceArray(a.initialPreviewConfig,n),a.initialPreviewThumbTags=i.spliceArray(a.initialPreviewThumbTags,n),a.getFrames().each(function(){var i=e(this),t=i.attr(\"data-fileindex\");\"init_\"===t.substring(0,5)&&(t=parseInt(t.replace(\"init_\",\"\")))>n&&(t--,i.attr(\"data-fileindex\",\"init_\"+t))}),a.uploadAsync&&(a.cacheInitialPreview=a.getPreview()))},_initFileActions:function(){var t=this,a=t.$preview;t.showPreview&&(t._initZoomButton(),t.getFrames(\" .kv-file-remove\").each(function(){var n,r,o,l,s=e(this),d=s.closest(i.FRAMES),c=d.attr(\"id\"),u=d.attr(\"data-fileindex\");t._handler(s,\"click\",function(){if(!1===(l=t._raise(\"filepreremove\",[c,u]))||!t._validateMinCount())return!1;n=d.hasClass(\"file-preview-error\"),i.cleanMemory(d),d.fadeOut(\"slow\",function(){i.cleanZoomCache(a.find(\"#zoom-\"+c)),t.updateStack(u,void 0),t._clearObjects(d),d.remove(),c&&n&&t.$errorContainer.find('li[data-file-id=\"'+c+'\"]').fadeOut(\"fast\",function(){e(this).remove(),t._errorsExist()||t._resetErrors()}),t._clearFileInput();var l=t.getFileStack(!0),s=t.previewCache.count(),p=l.length,f=t.showPreview&&t.getFrames().length;0!==p||0!==s||f?(r=s+p,o=r>1?t._getMsgSelected(r):l[0]?t._getFileNames()[0]:\"\",t._setCaption(o)):t.reset(),t._raise(\"fileremoved\",[c,u])})})}),t.getFrames(\" .kv-file-upload\").each(function(){var a=e(this);t._handler(a,\"click\",function(){var e=a.closest(i.FRAMES),n=e.attr(\"data-fileindex\");e.hasClass(\"file-preview-error\")||t._uploadSingle(n,t.filestack,!1)})}))},_initPreviewActions:function(){var t=this,a=t.$preview,n=t.deleteExtraData||{},r=i.FRAMES+\" .kv-file-remove\",o=function(){var e=t.isUploadable?t.previewCache.count():t.$element.get(0).files.length;0!==a.find(r).length||e||(t.reset(),t.initialCaption=\"\")};t._initZoomButton(),a.find(r).each(function(){var r=e(this),l=r.data(\"url\")||t.deleteUrl,s=r.data(\"key\");if(!i.isEmpty(l)&&void 0!==s){var d,c,u,p,f=r.closest(i.FRAMES),m=t.previewCache.data,h=f.attr(\"data-fileindex\");h=parseInt(h.replace(\"init_\",\"\")),u=i.isEmpty(m.config)&&i.isEmpty(m.config[h])?null:m.config[h],p=i.isEmpty(u)||i.isEmpty(u.extra)?n:u.extra,\"function\"==typeof p&&(p=p()),c={id:r.attr(\"id\"),key:s,extra:p},d=e.extend(!0,{},{url:l,type:\"POST\",dataType:\"json\",data:e.extend(!0,{},{key:s},p),beforeSend:function(e){t.ajaxAborted=!1,t._raise(\"filepredelete\",[s,e,p]),t.ajaxAborted?e.abort():(i.addCss(f,\"file-uploading\"),i.addCss(r,\"disabled\"))},success:function(e,n,l){var d,u;if(!i.isEmpty(e)&&!i.isEmpty(e.error))return c.jqXHR=l,c.response=e,t._showError(e.error,c,\"filedeleteerror\"),f.removeClass(\"file-uploading\"),r.removeClass(\"disabled\"),void o();h=parseInt(f.attr(\"data-fileindex\").replace(\"init_\",\"\")),t.previewCache.unset(h),d=t.previewCache.count(),u=d>0?t._getMsgSelected(d):\"\",t._deleteFileIndex(f),t._setCaption(u),t._raise(\"filedeleted\",[s,l,p]),f.removeClass(\"file-uploading\").addClass(\"file-deleted\"),f.fadeOut(\"slow\",function(){i.cleanZoomCache(a.find(\"#zoom-\"+f.attr(\"id\"))),t._clearObjects(f),f.remove(),o(),d||0!==t.getFileStack().length||(t._setCaption(\"\"),t.reset())})},error:function(e,i,a){var n=t.ajaxOperations.deleteThumb,r=t._parseError(n,e,a);c.jqXHR=e,c.response={},t._showError(r,c,\"filedeleteerror\"),f.removeClass(\"file-uploading\"),o()}},t.ajaxDeleteSettings),t._handler(r,\"click\",function(){if(!t._validateMinCount())return!1;e.ajax(d)})}})},_hideFileIcon:function(){this.overwriteInitial&&this.$captionContainer.find(\".kv-caption-icon\").hide()},_showFileIcon:function(){this.$captionContainer.find(\".kv-caption-icon\").show()},_getSize:function(i){var t,a,n,r=this,o=parseFloat(i),l=r.fileSizeGetter;return e.isNumeric(i)&&e.isNumeric(o)?(\"function\"==typeof l?n=l(o):0===o?n=\"0.00 B\":(t=Math.floor(Math.log(o)/Math.log(1024)),a=[\"B\",\"KB\",\"MB\",\"GB\",\"TB\",\"PB\",\"EB\",\"ZB\",\"YB\"],n=1*(o/Math.pow(1024,t)).toFixed(2)+\" \"+a[t]),r._getLayoutTemplate(\"size\").replace(\"{sizeText}\",n)):\"\"},_generatePreviewTemplate:function(t,a,n,r,o,l,s,d,c,u,p){var f=this,m=f.slug(n),h=\"\",v=f.previewSettings[t]||f.defaults.previewSettings[t],g=v&&v.width?v.width:\"\",w=v&&v.height?v.height:\"\",_=c||f._renderFileFooter(m,s,i.isEmpty(g)?\"auto\":g,l),b=f._getPreviewIcon(n),C=\"type-default\",y=b&&f.preferIconicPreview,T=b&&f.preferIconicZoomPreview,E=function(a,l,s,c){var h=s?\"zoom-\"+o:o,v=f._getPreviewTemplate(a),b=(d||\"\")+\" \"+c;return f.frameClass&&(b=f.frameClass+\" \"+b),s&&(b=b.replace(\" \"+i.SORT_CSS,\"\")),v=f._parseFilePreviewIcon(v,n),\"text\"===a&&(l=i.htmlEncode(l)),\"object\"!==t||r||e.each(f.defaults.fileTypeSettings,function(e,i){\"object\"!==e&&\"other\"!==e&&i(n,r)&&(C=\"type-\"+e)}),v.setTokens({previewId:h,caption:m,frameClass:b,type:r,fileindex:u,width:g,height:w,typeCss:C,footer:_,data:l,template:p||t})};return u=u||o.slice(o.lastIndexOf(\"-\")+1),f.fileActionSettings.showZoom&&(h=E(T?\"other\":t,a,!0,\"kv-zoom-thumb\")),h=\"\\n\"+f._getLayoutTemplate(\"zoomCache\").replace(\"{zoomContent}\",h),E(y?\"other\":t,a,!1,\"kv-preview-thumb\")+h},_previewDefault:function(t,a,n){var r=this,o=r.$preview;if(r.showPreview){var l,s=t?t.name:\"\",d=t?t.type:\"\",c=t.size||0,u=r.slug(s),p=!0===n&&!r.isUploadable,f=i.objUrl.createObjectURL(t);r._clearDefaultPreview(),l=r._generatePreviewTemplate(\"other\",f,s,d,a,p,c),o.append(\"\\n\"+l),r._setThumbAttr(a,u,c),!0===n&&r.isUploadable&&r._setThumbStatus(e(\"#\"+a),\"Error\")}},_previewFile:function(e,t,a,n,r){if(this.showPreview){var o,l=this,s=l._parseFileType(t),d=t?t.name:\"\",c=l.slug(d),u=l.allowedPreviewTypes,p=l.allowedPreviewMimeTypes,f=l.$preview,m=u&&u.indexOf(s)>=0,h=t.size||0,v=t.type,g=\"text\"===s||\"html\"===s||\"image\"===s?a.target.result:r,w=p&&-1!==p.indexOf(v);if(\"html\"===s&&l.purifyHtml&&window.DOMPurify&&(g=window.DOMPurify.sanitize(g)),m||w){o=l._generatePreviewTemplate(s,g,d,v,n,!1,h),l._clearDefaultPreview(),f.append(\"\\n\"+o);var _=f.find(\"#\"+n+\" img\");_.length&&l.autoOrientImage?i.validateOrientation(t,function(e){if(e){var a=f.find(\"#zoom-\"+n+\" img\"),r=\"rotate-\"+e;e>4&&(r+=_.width()>_.height()?\" is-portrait-gt4\":\" is-landscape-gt4\"),i.addCss(_,r),i.addCss(a,r),l._raise(\"fileimageoriented\",{$img:_,file:t})}l._validateImage(n,c,v,h,g),i.adjustOrientedImage(_)}):l._validateImage(n,c,v,h,g)}else l._previewDefault(t,n);l._setThumbAttr(n,c,h),l._initSortable()}},_setThumbAttr:function(i,t,a){var n=this,r=e(\"#\"+i);r.length&&(a=a&&a>0?n._getSize(a):\"\",r.data({caption:t,size:a}))},_setInitThumbAttr:function(){var e,t,a,n,r=this,o=r.previewCache.data,l=r.previewCache.count(!0);if(0!==l)for(var s=0;s<l;s++)e=o.config[s],n=r.previewInitId+\"-init_\"+s,t=i.ifSet(\"caption\",e,i.ifSet(\"filename\",e)),a=i.ifSet(\"size\",e),r._setThumbAttr(n,t,a)},_slugDefault:function(e){return i.isEmpty(e)?\"\":String(e).replace(/[\\-\\[\\]\\/\\{}:;#%=\\(\\)\\*\\+\\?\\\\\\^\\$\\|<>&\"']/g,\"_\")},_readFiles:function(t){this.reader=new FileReader;var a,n=this,r=n.$element,o=n.$preview,l=n.reader,s=n.$previewContainer,d=n.$previewStatus,c=n.msgLoading,u=n.msgProgress,p=n.previewInitId,f=t.length,m=n.fileTypeSettings,h=n.filestack.length,v=n.allowedFileTypes,g=v?v.length:0,w=n.allowedFileExtensions,_=i.isEmpty(w)?\"\":w.join(\", \"),b=n.maxFilePreviewSize&&parseFloat(n.maxFilePreviewSize),C=o.length&&(!b||isNaN(b)),y=function(i,r,o,l){var s=e.extend(!0,{},n._getOutData({},{},t),{id:o,index:l}),d={id:o,index:l,file:r,files:t};return n._previewDefault(r,o,!0),n.isUploadable&&(n.addToStack(void 0),setTimeout(function(){a(l+1)},100)),n._initFileActions(),n.removeFromPreviewOnError&&e(\"#\"+o).remove(),n.isUploadable?n._showUploadError(i,s):n._showError(i,d)};n.loadedImages=[],n.totalImagesCount=0,e.each(t,function(e,i){var t=n.fileTypeSettings.image;t&&t(i.type)&&n.totalImagesCount++}),a=function(e){if(i.isEmpty(r.attr(\"multiple\"))&&(f=1),e>=f)return n.isUploadable&&n.filestack.length>0?n._raise(\"filebatchselected\",[n.getFileStack()]):n._raise(\"filebatchselected\",[t]),s.removeClass(\"file-thumb-loading\"),void d.html(\"\");var T,E,x,F,S,I,k,P,z,A,$=h+e,D=p+\"-\"+$,U=t[e],B=U.name?n.slug(U.name):\"\",j=(U.size||0)/1e3,L=\"\",O=i.objUrl.createObjectURL(U),R=0,Z=\"\";if(g>0)for(F=0;F<g;F++)P=v[F],z=n.msgFileTypes[P]||P,Z+=0===F?z:\", \"+z;if(!1===B)return void a(e+1);if(0===B.length)return S=n.msgInvalidFileName.replace(\"{name}\",i.htmlEncode(U.name)),void(n.isError=y(S,U,D,e));if(i.isEmpty(w)||(L=new RegExp(\"\\\\.(\"+w.join(\"|\")+\")$\",\"i\")),x=j.toFixed(2),n.maxFileSize>0&&j>n.maxFileSize)return S=n.msgSizeTooLarge.setTokens({name:B,size:x,maxSize:n.maxFileSize}),void(n.isError=y(S,U,D,e));if(null!==n.minFileSize&&j<=i.getNum(n.minFileSize))return S=n.msgSizeTooSmall.setTokens({name:B,size:x,minSize:n.minFileSize}),void(n.isError=y(S,U,D,e));if(!i.isEmpty(v)&&i.isArray(v)){for(F=0;F<v.length;F+=1)I=v[F],A=m[I],R+=A&&\"function\"==typeof A&&A(U.type,U.name)?1:0;if(0===R)return S=n.msgInvalidFileType.setTokens({name:B,types:Z}),void(n.isError=y(S,U,D,e))}return 0!==R||i.isEmpty(w)||!i.isArray(w)||i.isEmpty(L)||(k=i.compare(B,L),0!==(R+=i.isEmpty(k)?0:k.length))?n.showPreview?!C&&j>b?(n.addToStack(U),s.addClass(\"file-thumb-loading\"),n._previewDefault(U,D),n._initFileActions(),n._updateFileDetails(f),void a(e+1)):(o.length&&void 0!==FileReader?(d.html(c.replace(\"{index}\",e+1).replace(\"{files}\",f)),s.addClass(\"file-thumb-loading\"),l.onerror=function(e){n._errorHandler(e,B)},l.onload=function(i){n._previewFile(e,U,i,D,O),n._initFileActions()},l.onloadend=function(){S=u.setTokens({index:e+1,files:f,percent:50,name:B}),setTimeout(function(){d.html(S),n._updateFileDetails(f),a(e+1)},100),n._raise(\"fileloaded\",[U,D,e,l])},l.onprogress=function(i){if(i.lengthComputable){var t=i.loaded/i.total*100,a=Math.ceil(t);S=u.setTokens({index:e+1,files:f,percent:a,name:B}),setTimeout(function(){d.html(S)},100)}},T=m.text,E=m.image,T(U.type,B)?l.readAsText(U,n.textEncoding):E(U.type,B)?l.readAsDataURL(U):l.readAsArrayBuffer(U)):(n._previewDefault(U,D),setTimeout(function(){a(e+1),n._updateFileDetails(f)},100),n._raise(\"fileloaded\",[U,D,e,l])),void n.addToStack(U)):(n.isUploadable&&n.addToStack(U),setTimeout(function(){a(e+1),n._updateFileDetails(f)},100),void n._raise(\"fileloaded\",[U,D,e,l])):(S=n.msgInvalidFileExtension.setTokens({name:B,extensions:_}),void(n.isError=y(S,U,D,e)))},a(0),n._updateFileDetails(f,!1)},_updateFileDetails:function(e){var t=this,a=t.$element,n=t.getFileStack(),r=i.isIE(9)&&i.findFileName(a.val())||a[0].files[0]&&a[0].files[0].name||n.length&&n[0].name||\"\",o=t.slug(r),l=t.isUploadable?n.length:e,s=t.previewCache.count()+l,d=l>1?t._getMsgSelected(s):o;t.isError?(t.$previewContainer.removeClass(\"file-thumb-loading\"),t.$previewStatus.html(\"\"),t.$captionContainer.find(\".kv-caption-icon\").hide()):t._showFileIcon(),t._setCaption(d,t.isError),t.$container.removeClass(\"file-input-new file-input-ajax-new\"),1===arguments.length&&t._raise(\"fileselect\",[e,o]),t.previewCache.count()&&t._initPreviewActions()},_setThumbStatus:function(e,i){var t=this;if(t.showPreview){var a=\"indicator\"+i,n=a+\"Title\",r=\"file-preview-\"+i.toLowerCase(),o=e.find(\".file-upload-indicator\"),l=t.fileActionSettings;e.removeClass(\"file-preview-success file-preview-error file-preview-loading\"),\"Error\"===i&&e.find(\".kv-file-upload\").attr(\"disabled\",!0),\"Success\"===i&&(e.find(\".file-drag-handle\").remove(),o.css(\"margin-left\",0)),o.html(l[a]),o.attr(\"title\",l[n]),e.addClass(r)}},_setProgressCancelled:function(){var e=this;e._setProgress(101,e.$progress,e.msgCancelled)},_setProgress:function(e,t,a){var n,r=this,o=Math.min(e,100),l=r.progressUploadThreshold,s=e<=100?r.progressTemplate:r.progressCompleteTemplate,d=o<100?r.progressTemplate:a?r.progressErrorTemplate:s;t=t||r.$progress,i.isEmpty(d)||(n=l&&o>l&&e<=100?d.setTokens({percent:l,status:r.msgUploadThreshold}):d.setTokens({percent:o,status:e>100?r.msgUploadEnd:o+\"%\"}),t.html(n),a&&t.find('[role=\"progressbar\"]').html(a))},_setFileDropZoneTitle:function(){var e,t=this,a=t.$container.find(\".file-drop-zone\"),n=t.dropZoneTitle;t.isClickable&&(e=i.isEmpty(t.$element.attr(\"multiple\"))?t.fileSingle:t.filePlural,n+=t.dropZoneClickTitle.replace(\"{files}\",e)),a.find(\".\"+t.dropZoneTitleClass).remove(),t.isUploadable&&t.showPreview&&0!==a.length&&!(t.getFileStack().length>0)&&t.dropZoneEnabled&&(0===a.find(i.FRAMES).length&&i.isEmpty(t.defaultPreviewContent)&&a.prepend('<div class=\"'+t.dropZoneTitleClass+'\">'+n+\"</div>\"),t.$container.removeClass(\"file-input-new\"),i.addCss(t.$container,\"file-input-ajax-new\"))},_setAsyncUploadStatus:function(i,t,a){var n=this,r=0;n._setProgress(t,e(\"#\"+i).find(\".file-thumb-progress\")),n.uploadStatus[i]=t,e.each(n.uploadStatus,function(e,i){r+=i}),n._setProgress(Math.floor(r/a))},_validateMinCount:function(){var e=this,i=e.isUploadable?e.getFileStack().length:e.$element.get(0).files.length;return!(e.validateInitialCount&&e.minFileCount>0&&e._getFileCount(i-1)<e.minFileCount)||(e._noFilesError({}),!1)},_getFileCount:function(e){var i=this,t=0;return i.validateInitialCount&&!i.overwriteInitial&&(t=i.previewCache.count(),e+=t),e},_getFileId:function(e){var i,t=this,a=t.generateFileId;return\"function\"==typeof a?a(e,event):e?(i=e.webkitRelativePath||e.fileName||e.name||null,i?e.size+\"-\"+i.replace(/[^0-9a-zA-Z_-]/gim,\"\"):null):null},_getFileName:function(e){return e&&e.name?this.slug(e.name):void 0},_getFileIds:function(e){return this.fileids.filter(function(i){return e?void 0!==i:void 0!==i&&null!==i})},_getFileNames:function(e){return this.filenames.filter(function(i){return e?void 0!==i:void 0!==i&&null!==i})},_setPreviewError:function(e,i,t){var a=this;void 0!==i&&a.updateStack(i,t),a.removeFromPreviewOnError?e.remove():a._setThumbStatus(e,\"Error\")},_checkDimensions:function(e,t,a,n,r,o,l){var s,d,c,u=this,p=\"Small\"===t?\"min\":\"max\",f=u[p+\"Image\"+o];!i.isEmpty(f)&&a.length&&(c=a[0],d=\"Width\"===o?c.naturalWidth||c.width:c.naturalHeight||c.height,(\"Small\"===t?d>=f:d<=f)||(s=u[\"msgImage\"+o+t].setTokens({name:r,size:f}),u._showUploadError(s,l),u._setPreviewError(n,e,null)))},_validateImage:function(i,t,a,n,r){var o,l,s,d,c=this,u=c.$preview,p=u.find(\"#\"+i),f=p.attr(\"data-fileindex\"),m=p.find(\"img\");t=t||\"Untitled\",m.one(\"load\",function(){l=p.width(),s=u.width(),l>s&&m.css(\"width\",\"100%\"),o={ind:f,id:i},c._checkDimensions(f,\"Small\",m,p,t,\"Width\",o),c._checkDimensions(f,\"Small\",m,p,t,\"Height\",o),c.resizeImage||(c._checkDimensions(f,\"Large\",m,p,t,\"Width\",o),c._checkDimensions(f,\"Large\",m,p,t,\"Height\",o)),c._raise(\"fileimageloaded\",[i]),d=window.piexif?window.piexif.load(r):null,c.loadedImages.push({ind:f,img:m,thumb:p,pid:i,typ:a,siz:n,validated:!1,imgData:r,exifObj:d}),p.data(\"exif\",d),c._validateAllImages()}).one(\"error\",function(){c._raise(\"fileimageloaderror\",[i])}).each(function(){this.complete?e(this).trigger(\"load\"):this.error&&e(this).trigger(\"error\")})},_validateAllImages:function(){var e,i,t,a=this,n={val:0},r=a.loadedImages.length,o=a.resizeIfSizeMoreThan;if(r===a.totalImagesCount&&(a._raise(\"fileimagesloaded\"),a.resizeImage))for(e=0;e<a.loadedImages.length;e++)i=a.loadedImages[e],i.validated||(t=i.siz,t&&t>1e3*o&&a._getResizedImage(i,n,r),a.loadedImages[e].validated=!0)},_getResizedImage:function(t,a,n){var r,o,l,s,d,c,u,p=this,f=e(t.img)[0],m=f.naturalWidth,h=f.naturalHeight,v=1,g=p.maxImageWidth||m,w=p.maxImageHeight||h,_=!(!m||!h),b=p.imageCanvas,C=p.imageCanvasContext,y=t.typ,T=t.pid,E=t.ind,x=t.thumb,F=t.exifObj;if(d=function(e,i,t){p.isUploadable?p._showUploadError(e,i,t):p._showError(e,i,t),p._setPreviewError(x,E)},(!p.filestack[E]||!_||m<=g&&h<=w)&&(_&&p.filestack[E]&&p._raise(\"fileimageresized\",[T,E]),a.val++,a.val===n&&p._raise(\"fileimagesresized\"),!_))return void d(p.msgImageResizeError,{id:T,index:E},\"fileimageresizeerror\");y=y||p.resizeDefaultImageType,o=m>g,l=h>w,v=\"width\"===p.resizePreference?o?g/m:l?w/h:1:l?w/h:o?g/m:1,p._resetCanvas(),m*=v,h*=v,b.width=m,b.height=h;try{C.drawImage(f,0,0,m,h),s=b.toDataURL(y,p.resizeQuality),F&&(u=window.piexif.dump(F),s=window.piexif.insert(u,s)),r=i.dataURI2Blob(s),p.filestack[E]=r,p._raise(\"fileimageresized\",[T,E]),a.val++,a.val===n&&p._raise(\"fileimagesresized\",[void 0,void 0]),r instanceof Blob||d(p.msgImageResizeError,{id:T,index:E},\"fileimageresizeerror\")}catch(e){a.val++,a.val===n&&p._raise(\"fileimagesresized\",[void 0,void 0]),c=p.msgImageResizeException.replace(\"{errors}\",e.message),d(c,{id:T,index:E},\"fileimageresizeexception\")}},_initBrowse:function(e){var i=this;i.showBrowse?(i.$btnFile=e.find(\".btn-file\"),i.$btnFile.append(i.$element)):i.$element.hide()},_initCaption:function(){var e=this,t=e.initialCaption||\"\";return e.overwriteInitial||i.isEmpty(t)?(e.$caption.html(\"\"),!1):(e._setCaption(t),!0)},_setCaption:function(t,a){var n,r,o,l,s=this,d=s.getFileStack();if(s.$caption.length){if(a)n=e(\"<div>\"+s.msgValidationError+\"</div>\").text(),o=d.length,\nl=o?1===o&&d[0]?s._getFileNames()[0]:s._getMsgSelected(o):s._getMsgSelected(s.msgNo),r='<span class=\"'+s.msgValidationErrorClass+'\">'+s.msgValidationErrorIcon+(i.isEmpty(t)?l:t)+\"</span>\";else{if(i.isEmpty(t))return;n=e(\"<div>\"+t+\"</div>\").text(),r=s._getLayoutTemplate(\"fileIcon\")+n}s.$caption.html(r),s.$caption.attr(\"title\",n),s.$captionContainer.find(\".file-caption-ellipsis\").attr(\"title\",n)}},_createContainer:function(){var i=this,t={class:\"file-input file-input-new\"+(i.rtl?\" kv-rtl\":\"\")},a=e(document.createElement(\"div\")).attr(t).html(i._renderMain());return i.$element.before(a),i._initBrowse(a),i.theme&&a.addClass(\"theme-\"+i.theme),a},_refreshContainer:function(){var e=this,i=e.$container;i.before(e.$element),i.html(e._renderMain()),e._initBrowse(i)},_renderMain:function(){var e=this,i=e.isUploadable&&e.dropZoneEnabled?\" file-drop-zone\":\"file-drop-disabled\",t=e.showClose?e._getLayoutTemplate(\"close\"):\"\",a=e.showPreview?e._getLayoutTemplate(\"preview\").setTokens({class:e.previewClass,dropClass:i}):\"\",n=e.isDisabled?e.captionClass+\" file-caption-disabled\":e.captionClass,r=e.captionTemplate.setTokens({class:n+\" kv-fileinput-caption\"});return e.mainTemplate.setTokens({class:e.mainClass+(!e.showBrowse&&e.showCaption?\" no-browse\":\"\"),preview:a,close:t,caption:r,upload:e._renderButton(\"upload\"),remove:e._renderButton(\"remove\"),cancel:e._renderButton(\"cancel\"),browse:e._renderButton(\"browse\")})},_renderButton:function(e){var t=this,a=t._getLayoutTemplate(\"btnDefault\"),n=t[e+\"Class\"],r=t[e+\"Title\"],o=t[e+\"Icon\"],l=t[e+\"Label\"],s=t.isDisabled?\" disabled\":\"\",d=\"button\";switch(e){case\"remove\":if(!t.showRemove)return\"\";break;case\"cancel\":if(!t.showCancel)return\"\";n+=\" hide\";break;case\"upload\":if(!t.showUpload)return\"\";t.isUploadable&&!t.isDisabled?a=t._getLayoutTemplate(\"btnLink\").replace(\"{href}\",t.uploadUrl):d=\"submit\";break;case\"browse\":if(!t.showBrowse)return\"\";a=t._getLayoutTemplate(\"btnBrowse\");break;default:return\"\"}return n+=\"browse\"===e?\" btn-file\":\" fileinput-\"+e+\" fileinput-\"+e+\"-button\",i.isEmpty(l)||(l=' <span class=\"'+t.buttonLabelClass+'\">'+l+\"</span>\"),a.setTokens({type:d,css:n,title:r,status:s,icon:o,label:l})},_renderThumbProgress:function(){var e=this;return'<div class=\"file-thumb-progress hide\">'+e.progressTemplate.setTokens({percent:\"0\",status:e.msgUploadBegin})+\"</div>\"},_renderFileFooter:function(e,t,a,n){var r,o=this,l=o.fileActionSettings,s=l.showRemove,d=l.showDrag,c=l.showUpload,u=l.showZoom,p=o._getLayoutTemplate(\"footer\"),f=n?l.indicatorError:l.indicatorNew,m=o._getLayoutTemplate(\"indicator\"),h=n?l.indicatorErrorTitle:l.indicatorNewTitle,v=m.setTokens({indicator:f,indicatorTitle:h});return t=o._getSize(t),r=o.isUploadable?p.setTokens({actions:o._renderFileActions(c,s,u,d,!1,!1,!1),caption:e,size:t,width:a,progress:o._renderThumbProgress(),indicator:v}):p.setTokens({actions:o._renderFileActions(!1,!1,u,d,!1,!1,!1),caption:e,size:t,width:a,progress:\"\",indicator:v}),r=i.replaceTags(r,o.previewThumbTags)},_renderFileActions:function(e,i,t,a,n,r,o,l){if(!(e||i||t||a))return\"\";var s,d=this,c=!1===r?\"\":' data-url=\"'+r+'\"',u=!1===o?\"\":' data-key=\"'+o+'\"',p=\"\",f=\"\",m=\"\",h=\"\",v=d._getLayoutTemplate(\"actions\"),g=d.fileActionSettings,w=d.otherActionButtons.setTokens({dataKey:u}),_=n?g.removeClass+\" disabled\":g.removeClass;return i&&(p=d._getLayoutTemplate(\"actionDelete\").setTokens({removeClass:_,removeIcon:g.removeIcon,removeTitle:g.removeTitle,dataUrl:c,dataKey:u})),e&&(f=d._getLayoutTemplate(\"actionUpload\").setTokens({uploadClass:g.uploadClass,uploadIcon:g.uploadIcon,uploadTitle:g.uploadTitle})),t&&(m=d._getLayoutTemplate(\"actionZoom\").setTokens({zoomClass:g.zoomClass,zoomIcon:g.zoomIcon,zoomTitle:g.zoomTitle})),a&&l&&(s=\"drag-handle-init \"+g.dragClass,h=d._getLayoutTemplate(\"actionDrag\").setTokens({dragClass:s,dragTitle:g.dragTitle,dragIcon:g.dragIcon})),v.setTokens({delete:p,upload:f,zoom:m,drag:h,other:w})},_browse:function(e){var i=this;i._raise(\"filebrowse\"),e&&e.isDefaultPrevented()||(i.isError&&!i.isUploadable&&i.clear(),i.$captionContainer.focus())},_filterDuplicate:function(e,i,t){var a=this,n=a._getFileId(e);n&&t&&t.indexOf(n)>-1||(t||(t=[]),i.push(e),t.push(n))},_change:function(t){var a=this,n=a.$element;if(!a.isUploadable&&i.isEmpty(n.val())&&a.fileInputCleared)return void(a.fileInputCleared=!1);a.fileInputCleared=!1;var r,o,l,s,d=[],c=arguments.length>1,u=a.isUploadable,p=c?t.originalEvent.dataTransfer.files:n.get(0).files,f=a.filestack.length,m=i.isEmpty(n.attr(\"multiple\")),h=m&&f>0,v=0,g=a._getFileIds();if(a.reader=null,a._resetUpload(),a._hideFileIcon(),a.isUploadable&&a.$container.find(\".file-drop-zone .\"+a.dropZoneTitleClass).remove(),c?e.each(p,function(e,i){i&&!i.type&&void 0!==i.size&&i.size%4096==0?v++:a._filterDuplicate(i,d,g)}):(p=t.target&&void 0===t.target.files?t.target.value?[{name:t.target.value.replace(/^.+\\\\/,\"\")}]:[]:t.target.files||{},u?e.each(p,function(e,i){a._filterDuplicate(i,d,g)}):d=p),i.isEmpty(d)||0===d.length)return u||a.clear(),a._showFolderError(v),void a._raise(\"fileselectnone\");if(a._resetErrors(),s=d.length,o=a._getFileCount(a.isUploadable?a.getFileStack().length+s:s),a.maxFileCount>0&&o>a.maxFileCount){if(!a.autoReplace||s>a.maxFileCount)return l=a.autoReplace&&s>a.maxFileCount?s:o,r=a.msgFilesTooMany.replace(\"{m}\",a.maxFileCount).replace(\"{n}\",l),a.isError=function(i,t,n,r){var o=e.extend(!0,{},a._getOutData({},{},p),{id:n,index:r}),l={id:n,index:r,file:t,files:p};return a.isUploadable?a._showUploadError(i,o):a._showError(i,l)}(r,null,null,null),a.$captionContainer.find(\".kv-caption-icon\").hide(),a._setCaption(\"\",!0),void a.$container.removeClass(\"file-input-new file-input-ajax-new\");o>a.maxFileCount&&a._resetPreviewThumbs(u)}else!u||h?(a._resetPreviewThumbs(!1),h&&a.clearStack()):!u||0!==f||a.previewCache.count()&&!a.overwriteInitial||a._resetPreviewThumbs(!0);a.isPreviewable?a._readFiles(d):a._updateFileDetails(1),a._showFolderError(v)},_abort:function(i){var t,a=this;return!(!a.ajaxAborted||\"object\"!=typeof a.ajaxAborted||void 0===a.ajaxAborted.message)&&(t=e.extend(!0,{},a._getOutData(),i),t.abortData=a.ajaxAborted.data||{},t.abortMessage=a.ajaxAborted.message,a._setProgress(101,a.$progress,a.msgCancelled),a._showUploadError(a.ajaxAborted.message,t,\"filecustomerror\"),a.cancel(),!0)},_resetFileStack:function(){var t=this,a=0,n=[],r=[],o=[];t._getThumbs().each(function(){var l,s=e(this),d=s.attr(\"data-fileindex\"),c=t.filestack[d],u=s.attr(\"id\");\"-1\"!==d&&-1!==d&&(void 0!==c?(n[a]=c,r[a]=t._getFileName(c),o[a]=t._getFileId(c),s.attr({id:t.previewInitId+\"-\"+a,\"data-fileindex\":a}),a++):(l=\"uploaded-\"+i.uniqId(),s.attr({id:l,\"data-fileindex\":\"-1\"}),t.$preview.find(\"#zoom-\"+u).attr(\"id\",\"zoom-\"+l)))}),t.filestack=n,t.filenames=r,t.fileids=o},_isFileSelectionValid:function(e){var i=this;return e=e||0,i.required&&!i.getFilesCount()?(i.$errorContainer.html(\"\"),i._showUploadError(i.msgFileRequired),!1):!(i.minFileCount>0&&i._getFileCount(e)<i.minFileCount)||(i._noFilesError({}),!1)},clearStack:function(){var e=this;return e.filestack=[],e.filenames=[],e.fileids=[],e.$element},updateStack:function(e,i){var t=this;return t.filestack[e]=i,t.filenames[e]=t._getFileName(i),t.fileids[e]=i&&t._getFileId(i)||null,t.$element},addToStack:function(e){var i=this;return i.filestack.push(e),i.filenames.push(i._getFileName(e)),i.fileids.push(i._getFileId(e)),i.$element},getFileStack:function(e){return this.filestack.filter(function(i){return e?void 0!==i:void 0!==i&&null!==i})},getFilesCount:function(){var e=this,i=e.isUploadable?e.getFileStack().length:e.$element.get(0).files.length;return e._getFileCount(i)},lock:function(){var e=this;return e._resetErrors(),e.disable(),e.showRemove&&i.addCss(e.$container.find(\".fileinput-remove\"),\"hide\"),e.showCancel&&e.$container.find(\".fileinput-cancel\").removeClass(\"hide\"),e._raise(\"filelock\",[e.filestack,e._getExtraData()]),e.$element},unlock:function(e){var t=this;return void 0===e&&(e=!0),t.enable(),t.showCancel&&i.addCss(t.$container.find(\".fileinput-cancel\"),\"hide\"),t.showRemove&&t.$container.find(\".fileinput-remove\").removeClass(\"hide\"),e&&t._resetFileStack(),t._raise(\"fileunlock\",[t.filestack,t._getExtraData()]),t.$element},cancel:function(){var i,t=this,a=t.ajaxRequests,n=a.length;if(n>0)for(i=0;i<n;i+=1)t.cancelling=!0,a[i].abort();return t._setProgressCancelled(),t._getThumbs().each(function(){var i=e(this),a=i.attr(\"data-fileindex\");i.removeClass(\"file-uploading\"),void 0!==t.filestack[a]&&(i.find(\".kv-file-upload\").removeClass(\"disabled\").removeAttr(\"disabled\"),i.find(\".kv-file-remove\").removeClass(\"disabled\").removeAttr(\"disabled\")),t.unlock()}),t.$element},clear:function(){var t,a=this;if(a._raise(\"fileclear\"))return a.$btnUpload.removeAttr(\"disabled\"),a._getThumbs().find(\"video,audio,img\").each(function(){i.cleanMemory(e(this))}),a._resetUpload(),a.clearStack(),a._clearFileInput(),a._resetErrors(!0),a._hasInitialPreview()?(a._showFileIcon(),a._resetPreview(),a._initPreviewActions(),a.$container.removeClass(\"file-input-new\")):(a._getThumbs().each(function(){a._clearObjects(e(this))}),a.isUploadable&&(a.previewCache.data={}),a.$preview.html(\"\"),t=!a.overwriteInitial&&a.initialCaption.length>0?a.initialCaption:\"\",a.$caption.html(t),a.$caption.attr(\"title\",\"\"),i.addCss(a.$container,\"file-input-new\"),a._validateDefaultPreview()),0===a.$container.find(i.FRAMES).length&&(a._initCaption()||a.$captionContainer.find(\".kv-caption-icon\").hide()),a._hideFileIcon(),a._raise(\"filecleared\"),a.$captionContainer.focus(),a._setFileDropZoneTitle(),a.$element},reset:function(){var e=this;if(e._raise(\"filereset\"))return e._resetPreview(),e.$container.find(\".fileinput-filename\").text(\"\"),i.addCss(e.$container,\"file-input-new\"),(e.getFrames().length||e.isUploadable&&e.dropZoneEnabled)&&e.$container.removeClass(\"file-input-new\"),e._setFileDropZoneTitle(),e.clearStack(),e.formdata={},e.$element},disable:function(){var e=this;return e.isDisabled=!0,e._raise(\"filedisabled\"),e.$element.attr(\"disabled\",\"disabled\"),e.$container.find(\".kv-fileinput-caption\").addClass(\"file-caption-disabled\"),e.$container.find(\".btn-file, .fileinput-remove, .fileinput-upload, .file-preview-frame button\").attr(\"disabled\",!0),e._initDragDrop(),e.$element},enable:function(){var e=this;return e.isDisabled=!1,e._raise(\"fileenabled\"),e.$element.removeAttr(\"disabled\"),e.$container.find(\".kv-fileinput-caption\").removeClass(\"file-caption-disabled\"),e.$container.find(\".btn-file, .fileinput-remove, .fileinput-upload, .file-preview-frame button\").removeAttr(\"disabled\"),e._initDragDrop(),e.$element},upload:function(){var t,a,n,r=this,o=r.getFileStack().length,l=!e.isEmptyObject(r._getExtraData());if(r.isUploadable&&!r.isDisabled&&r._isFileSelectionValid(o)){if(r._resetUpload(),0===o&&!l)return void r._showUploadError(r.msgUploadEmpty);if(r.$progress.removeClass(\"hide\"),r.uploadCount=0,r.uploadStatus={},r.uploadLog=[],r.lock(),r._setProgress(2),0===o&&l)return void r._uploadExtraOnly();if(n=r.filestack.length,r.hasInitData=!1,!r.uploadAsync)return r._uploadBatch(),r.$element;for(a=r._getOutData(),r._raise(\"filebatchpreupload\",[a]),r.fileBatchCompleted=!1,r.uploadCache={content:[],config:[],tags:[],append:!0},r.uploadAsyncCount=r.getFileStack().length,t=0;t<n;t++)r.uploadCache.content[t]=null,r.uploadCache.config[t]=null,r.uploadCache.tags[t]=null;for(r.$preview.find(\".file-preview-initial\").removeClass(i.SORT_CSS),r._initSortable(),r.cacheInitialPreview=r.getPreview(),t=0;t<n;t++)void 0!==r.filestack[t]&&r._uploadSingle(t,r.filestack,!0)}},destroy:function(){var i=this,t=i.$form,a=i.$container,n=i.$element,r=i.namespace;return e(document).off(r),e(window).off(r),t&&t.length&&t.off(r),i.isUploadable&&i._clearFileInput(),i._cleanup(),i._initPreviewCache(),n.insertBefore(a).off(r).removeData(),a.off().remove(),n},refresh:function(i){var t=this,a=t.$element;return i=i?e.extend(!0,{},t.options,i):t.options,t.destroy(),a.fileinput(i),t=a.data(\"fileinput\"),t.isUploadable&&t._clearFileInput(),a.val()&&a.trigger(\"change.fileinput\"),a},zoom:function(e){var t=this,a=t._getFrame(e),n=t.$modal;a&&(i.initModal(n),n.html(t._getModalContent()),t._setZoomContent(a),n.modal(\"show\"),t._initZoomButtons())},getExif:function(e){var i=this,t=i._getFrame(e);return t&&t.data(\"exif\")||null},getFrames:function(e){var t=this;return e=e||\"\",t.$preview.find(i.FRAMES+e)},getPreview:function(){var e=this;return{content:e.initialPreview,config:e.initialPreviewConfig,tags:e.initialPreviewThumbTags}}},e.fn.fileinput=function(a){if(i.hasFileAPISupport()||i.isIE(9)){var n=Array.apply(null,arguments),r=[];switch(n.shift(),this.each(function(){var o,l=e(this),s=l.data(\"fileinput\"),d=\"object\"==typeof a&&a,c=d.theme||l.data(\"theme\"),u={},p={},f=d.language||l.data(\"language\")||e.fn.fileinput.defaults.language||\"en\";s||(c&&(p=e.fn.fileinputThemes[c]||{}),\"en\"===f||i.isEmpty(e.fn.fileinputLocales[f])||(u=e.fn.fileinputLocales[f]||{}),o=e.extend(!0,{},e.fn.fileinput.defaults,p,e.fn.fileinputLocales.en,u,d,l.data()),s=new t(this,o),l.data(\"fileinput\",s)),\"string\"==typeof a&&r.push(s[a].apply(s,n))}),r.length){case 0:return this;case 1:return r[0];default:return r}}},e.fn.fileinput.defaults={language:\"en\",showCaption:!0,showBrowse:!0,showPreview:!0,showRemove:!0,showUpload:!0,showCancel:!0,showClose:!0,showUploadedThumbs:!0,browseOnZoneClick:!1,autoReplace:!1,autoOrientImage:!0,required:!1,rtl:!1,hideThumbnailContent:!1,generateFileId:null,previewClass:\"\",captionClass:\"\",frameClass:\"krajee-default\",mainClass:\"file-caption-main\",mainTemplate:null,purifyHtml:!0,fileSizeGetter:null,initialCaption:\"\",initialPreview:[],initialPreviewDelimiter:\"*$$*\",initialPreviewAsData:!1,initialPreviewFileType:\"image\",initialPreviewConfig:[],initialPreviewThumbTags:[],previewThumbTags:{},initialPreviewShowDelete:!0,removeFromPreviewOnError:!1,deleteUrl:\"\",deleteExtraData:{},overwriteInitial:!0,previewZoomButtonIcons:{prev:'<i class=\"glyphicon glyphicon-triangle-left\"></i>',next:'<i class=\"glyphicon glyphicon-triangle-right\"></i>',toggleheader:'<i class=\"glyphicon glyphicon-resize-vertical\"></i>',fullscreen:'<i class=\"glyphicon glyphicon-fullscreen\"></i>',borderless:'<i class=\"glyphicon glyphicon-resize-full\"></i>',close:'<i class=\"glyphicon glyphicon-remove\"></i>'},previewZoomButtonClasses:{prev:\"btn btn-navigate\",next:\"btn btn-navigate\",toggleheader:\"btn btn-default btn-header-toggle\",fullscreen:\"btn btn-default\",borderless:\"btn btn-default\",close:\"btn btn-default\"},preferIconicPreview:!1,preferIconicZoomPreview:!1,allowedPreviewTypes:void 0,allowedPreviewMimeTypes:null,allowedFileTypes:null,allowedFileExtensions:null,defaultPreviewContent:null,customLayoutTags:{},customPreviewTags:{},previewFileIcon:'<i class=\"glyphicon glyphicon-file\"></i>',previewFileIconClass:\"file-other-icon\",previewFileIconSettings:{},previewFileExtSettings:{},buttonLabelClass:\"hidden-xs\",browseIcon:'<i class=\"glyphicon glyphicon-folder-open\"></i>&nbsp;',browseClass:\"btn btn-primary\",removeIcon:'<i class=\"glyphicon glyphicon-trash\"></i>',removeClass:\"btn btn-default\",cancelIcon:'<i class=\"glyphicon glyphicon-ban-circle\"></i>',cancelClass:\"btn btn-default\",uploadIcon:'<i class=\"glyphicon glyphicon-upload\"></i>',uploadClass:\"btn btn-default\",uploadUrl:null,uploadAsync:!0,uploadExtraData:{},zoomModalHeight:480,minImageWidth:null,minImageHeight:null,maxImageWidth:null,maxImageHeight:null,resizeImage:!1,resizePreference:\"width\",resizeQuality:.92,resizeDefaultImageType:\"image/jpeg\",resizeIfSizeMoreThan:0,minFileSize:0,maxFileSize:0,maxFilePreviewSize:25600,minFileCount:0,maxFileCount:0,validateInitialCount:!1,msgValidationErrorClass:\"text-danger\",msgValidationErrorIcon:'<i class=\"glyphicon glyphicon-exclamation-sign\"></i> ',msgErrorClass:\"file-error-message\",progressThumbClass:\"progress-bar progress-bar-success progress-bar-striped active\",progressClass:\"progress-bar progress-bar-success progress-bar-striped active\",progressCompleteClass:\"progress-bar progress-bar-success\",progressErrorClass:\"progress-bar progress-bar-danger\",progressUploadThreshold:99,previewFileType:\"image\",elCaptionContainer:null,elCaptionText:null,elPreviewContainer:null,elPreviewImage:null,elPreviewStatus:null,elErrorContainer:null,errorCloseButton:'<span class=\"close kv-error-close\">&times;</span>',slugCallback:null,dropZoneEnabled:!0,dropZoneTitleClass:\"file-drop-zone-title\",fileActionSettings:{},otherActionButtons:\"\",textEncoding:\"UTF-8\",ajaxSettings:{},ajaxDeleteSettings:{},showAjaxErrorDetails:!0},e.fn.fileinputLocales.en={fileSingle:\"file\",filePlural:\"files\",browseLabel:\"Browse &hellip;\",removeLabel:\"Remove\",removeTitle:\"Clear selected files\",cancelLabel:\"Cancel\",cancelTitle:\"Abort ongoing upload\",uploadLabel:\"Upload\",uploadTitle:\"Upload selected files\",msgNo:\"No\",msgNoFilesSelected:\"No files selected\",msgCancelled:\"Cancelled\",msgZoomModalHeading:\"Detailed Preview\",msgFileRequired:\"You must select a file to upload.\",msgSizeTooSmall:'File \"{name}\" (<b>{size} KB</b>) is too small and must be larger than <b>{minSize} KB</b>.',msgSizeTooLarge:'File \"{name}\" (<b>{size} KB</b>) exceeds maximum allowed upload size of <b>{maxSize} KB</b>.',msgFilesTooLess:\"You must select at least <b>{n}</b> {files} to upload.\",msgFilesTooMany:\"Number of files selected for upload <b>({n})</b> exceeds maximum allowed limit of <b>{m}</b>.\",msgFileNotFound:'File \"{name}\" not found!',msgFileSecured:'Security restrictions prevent reading the file \"{name}\".',msgFileNotReadable:'File \"{name}\" is not readable.',msgFilePreviewAborted:'File preview aborted for \"{name}\".',msgFilePreviewError:'An error occurred while reading the file \"{name}\".',msgInvalidFileName:'Invalid or unsupported characters in file name \"{name}\".',msgInvalidFileType:'Invalid type for file \"{name}\". Only \"{types}\" files are supported.',msgInvalidFileExtension:'Invalid extension for file \"{name}\". Only \"{extensions}\" files are supported.',msgFileTypes:{image:\"image\",html:\"HTML\",text:\"text\",video:\"video\",audio:\"audio\",flash:\"flash\",pdf:\"PDF\",object:\"object\"},msgUploadAborted:\"The file upload was aborted\",msgUploadThreshold:\"Processing...\",msgUploadBegin:\"Initializing...\",msgUploadEnd:\"Done\",msgUploadEmpty:\"No valid data available for upload.\",msgValidationError:\"Validation Error\",msgLoading:\"Loading file {index} of {files} &hellip;\",msgProgress:\"Loading file {index} of {files} - {name} - {percent}% completed.\",msgSelected:\"{n} {files} selected\",msgFoldersNotAllowed:\"Drag & drop files only! {n} folder(s) dropped were skipped.\",msgImageWidthSmall:'Width of image file \"{name}\" must be at least {size} px.',msgImageHeightSmall:'Height of image file \"{name}\" must be at least {size} px.',msgImageWidthLarge:'Width of image file \"{name}\" cannot exceed {size} px.',msgImageHeightLarge:'Height of image file \"{name}\" cannot exceed {size} px.',msgImageResizeError:\"Could not get the image dimensions to resize.\",msgImageResizeException:\"Error while resizing the image.<pre>{errors}</pre>\",msgAjaxError:\"Something went wrong with the {operation} operation. Please try again later!\",msgAjaxProgressError:\"{operation} failed\",ajaxOperations:{deleteThumb:\"file delete\",uploadThumb:\"file upload\",uploadBatch:\"batch file upload\",uploadExtra:\"form data upload\"},dropZoneTitle:\"Drag & drop files here &hellip;\",dropZoneClickTitle:\"<br>(or click to select {files})\",previewZoomButtonTitles:{prev:\"View previous file\",next:\"View next file\",toggleheader:\"Toggle header\",fullscreen:\"Toggle full screen\",borderless:\"Toggle borderless mode\",close:\"Close detailed preview\"}},e.fn.fileinput.Constructor=t,e(document).ready(function(){var i=e(\"input.file[type=file]\");i.length&&i.fileinput()})});"

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(119))

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	module.exports = "!function(e){\"use strict\";e.fn.fileinputLocales.cz={fileSingle:\"soubor\",filePlural:\"soubory\",browseLabel:\"Vybrat &hellip;\",removeLabel:\"Odstranit\",removeTitle:\"Vyčistit vybrané soubory\",cancelLabel:\"Storno\",cancelTitle:\"Přerušit  nahrávání\",uploadLabel:\"Nahrát\",uploadTitle:\"Nahrát vybrané soubory\",msgNo:\"Ne\",msgNoFilesSelected:\"Nevybrány žádné soubory\",msgCancelled:\"Zrušeno\",msgZoomModalHeading:\"Detailní náhled\",msgFileRequired:\"You must select a file to upload.\",msgSizeTooSmall:'Soubor \"{name}\" (<b>{size} KB</b>) je příliš malý, musí mít velikost nejméně <b>{minSize} KB</b>.',msgSizeTooLarge:'Soubor \"{name}\" (<b>{size} KB</b>): je příliš velký - maximální povolená velikost <b>{maxSize} KB</b>.',msgFilesTooLess:\"Musíte vybrat nejméně <b>{n}</b> {files} souborů.\",msgFilesTooMany:\"Počet vybraných souborů <b>({n})</b> překročil maximální povolený limit <b>{m}</b>.\",msgFileNotFound:'Soubor \"{name}\" nebyl nalezen!',msgFileSecured:'Zabezpečení souboru znemožnilo číst soubor \"{name}\".',msgFileNotReadable:'Soubor \"{name}\" není čitelný.',msgFilePreviewAborted:'Náhled souboru byl přerušen pro \"{name}\".',msgFilePreviewError:'Nastala chyba při načtení souboru \"{name}\".',msgInvalidFileName:'Neplatné nebo nepovolené znaky ve jménu souboru \"{name}\".',msgInvalidFileType:'Neplatný typ souboru \"{name}\". Pouze \"{types}\" souborů jsou podporovány.',msgInvalidFileExtension:'Neplatná extenze souboru \"{name}\". Pouze \"{extensions}\" souborů jsou podporovány.',msgUploadAborted:\"Nahrávání souboru bylo přerušeno\",msgUploadThreshold:\"Zpracovávám...\",msgUploadBegin:\"Initializing...\",msgUploadEnd:\"Done\",msgUploadEmpty:\"No valid data available for upload.\",msgValidationError:\"Chyba ověření\",msgLoading:\"Nahrávání souboru {index} z {files} &hellip;\",msgProgress:\"Nahrávání souboru {index} z {files} - {name} - {percent}% dokončeno.\",msgSelected:\"{n} {files} vybráno\",msgFoldersNotAllowed:\"Táhni a pusť pouze soubory! Vynechané {n} pustěné složk(y).\",msgImageWidthSmall:'Šířka obrázku \"{name}\", musí být alespoň {size} px.',msgImageHeightSmall:'Výška obrázku \"{name}\", musí být alespoň {size} px.',msgImageWidthLarge:'Šířka obrázku \"{name}\" nesmí být větší než {size} px.',msgImageHeightLarge:'Výška obrázku \"{name}\" nesmí být větší než {size} px.',msgImageResizeError:\"Nelze získat rozměry obrázku pro změnu velikosti.\",msgImageResizeException:\"Chyba při změně velikosti obrázku.<pre>{errors}</pre>\",msgAjaxError:\"Something went wrong with the {operation} operation. Please try again later!\",msgAjaxProgressError:\"{operation} failed\",ajaxOperations:{deleteThumb:\"file delete\",uploadThumb:\"file upload\",uploadBatch:\"batch file upload\",uploadExtra:\"form data upload\"},dropZoneTitle:\"Přetáhni soubory sem &hellip;\",dropZoneClickTitle:\"<br>(nebo klikni sem a vyber je)\",fileActionSettings:{removeTitle:\"Odstranit soubor\",uploadTitle:\"nahrát soubor\",zoomTitle:\"zobrazit podrobnosti\",dragTitle:\"Posunout / Přeskládat\",indicatorNewTitle:\"Ještě nenahrál\",indicatorSuccessTitle:\"Nahraný\",indicatorErrorTitle:\"Chyba nahrávání\",indicatorLoadingTitle:\"Nahrávání ...\"},previewZoomButtonTitles:{prev:\"Zobrazit předchozí soubor\",next:\"Zobrazit následující soubor\",toggleheader:\"Přepnout záhlaví\",fullscreen:\"Přepnout celoobrazovkové zobrazení\",borderless:\"Přepnout bezrámečkové zobrazení\",close:\"Zavřít detailní náhled\"}}}(window.jQuery);"

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(121))

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	module.exports = "!function(e){\"use strict\";e.fn.fileinputLocales.sk={fileSingle:\"súbor\",filePlural:\"súbory\",browseLabel:\"Vybrať &hellip;\",removeLabel:\"Odstrániť\",removeTitle:\"Vyčistiť vybraté súbory\",cancelLabel:\"Storno\",cancelTitle:\"Prerušiť  nahrávanie\",uploadLabel:\"Nahrať\",uploadTitle:\"Nahrať vybraté súbory\",msgNo:\"Nie\",msgNoFilesSelected:\"\",msgCancelled:\"Zrušené\",msgZoomModalHeading:\"Detailný náhľad\",msgFileRequired:\"You must select a file to upload.\",msgSizeTooSmall:'File \"{name}\" (<b>{size} KB</b>) is too small and must be larger than <b>{minSize} KB</b>.',msgSizeTooLarge:'Súbor \"{name}\" (<b>{size} KB</b>): prekročenie - maximálna povolená veľkosť <b>{maxSize} KB</b>.',msgFilesTooLess:\"Musíte vybrať najmenej <b>{n}</b> {files} pre nahranie.\",msgFilesTooMany:\"Počet vybratých súborov pre nahranie <b>({n})</b>: prekročenie - maximálny povolený limit <b>{m}</b>.\",msgFileNotFound:'Súbor \"{name}\" nebol nájdený!',msgFileSecured:'Zabezpečenie súboru znemožnilo čítať súbor \"{name}\".',msgFileNotReadable:'Súbor \"{name}\" nie je čitateľný.',msgFilePreviewAborted:'Náhľad súboru bol prerušený pre \"{name}\".',msgFilePreviewError:'Nastala chyba pri načítaní súboru \"{name}\".',msgInvalidFileName:'Invalid or unsupported characters in file name \"{name}\".',msgInvalidFileType:'Neplatný typ súboru \"{name}\". Iba \"{types}\" súborov sú podporované.',msgInvalidFileExtension:'Neplatná extenzia súboru \"{name}\". Iba \"{extensions}\" súborov sú podporované.',msgFileTypes:{image:\"image\",html:\"HTML\",text:\"text\",video:\"video\",audio:\"audio\",flash:\"flash\",pdf:\"PDF\",object:\"object\"},msgUploadAborted:\"Súbor nahrávania bol prerušený\",msgUploadThreshold:\"Processing...\",msgUploadBegin:\"Initializing...\",msgUploadEnd:\"Done\",msgUploadEmpty:\"No valid data available for upload.\",msgValidationError:\"Chyba overenia\",msgLoading:\"Nahrávanie súboru {index} z {files} &hellip;\",msgProgress:\"Nahrávanie súboru {index} z {files} - {name} - {percent}% dokončené.\",msgSelected:\"{n} {files} vybraté\",msgFoldersNotAllowed:\"Tiahni a pusť iba súbory! Vynechané {n} pustené prečinok(y).\",msgImageWidthSmall:'Šírka image súboru \"{name}\", musí byť minimálne {size} px.',msgImageHeightSmall:'Výška image súboru \"{name}\", musí byť minimálne {size} px.',msgImageWidthLarge:'Šírka image súboru \"{name}\" nemôže presiahnuť {size} px.',msgImageHeightLarge:'Výška súboru obrazu \"{name}\" nesmie presiahnuť {size} px.',msgImageResizeError:\"Nemožno získať rozmery obrázku zmeniť veľkosť.\",msgImageResizeException:\"Chyba pri zmene veľkosti obrázka.<pre>{errors}</pre>\",msgAjaxError:\"Something went wrong with the {operation} operation. Please try again later!\",msgAjaxProgressError:\"{operation} failed\",ajaxOperations:{deleteThumb:\"file delete\",uploadThumb:\"file upload\",uploadBatch:\"batch file upload\",uploadExtra:\"form data upload\"},dropZoneTitle:\"Tiahni a pusť súbory tu &hellip;\",dropZoneClickTitle:\"<br>(or click to select {files})\",fileActionSettings:{removeTitle:\"odstrániť súbor\",uploadTitle:\"nahrať súbor\",zoomTitle:\"Zobraziť podrobnosti\",dragTitle:\"Move / Rearrange\",indicatorNewTitle:\"Ešte nenahral\",indicatorSuccessTitle:\"nahral\",indicatorErrorTitle:\"nahrať Chyba\",indicatorLoadingTitle:\"nahrávanie ...\"},previewZoomButtonTitles:{prev:\"View previous file\",next:\"View next file\",toggleheader:\"Toggle header\",fullscreen:\"Toggle full screen\",borderless:\"Toggle borderless mode\",close:\"Close detailed preview\"}}}(window.jQuery);"

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(127))

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	module.exports = "!function(e){\"use strict\";if(\"function\"==typeof define&&define.amd)define([\"jquery\",\"moment\"],e);else if(\"object\"==typeof exports)module.exports=e(require(\"jquery\"),require(\"moment\"));else{if(\"undefined\"==typeof jQuery)throw\"bootstrap-datetimepicker requires jQuery to be loaded first\";if(\"undefined\"==typeof moment)throw\"bootstrap-datetimepicker requires Moment.js to be loaded first\";e(jQuery,moment)}}(function(e,t){\"use strict\";if(!t)throw new Error(\"bootstrap-datetimepicker requires Moment.js to be loaded first\");var n=function(n,a){var r,i,o,s,d,l,p,c={},u=!0,f=!1,h=!1,m=0,y=[{clsName:\"days\",navFnc:\"M\",navStep:1},{clsName:\"months\",navFnc:\"y\",navStep:1},{clsName:\"years\",navFnc:\"y\",navStep:10},{clsName:\"decades\",navFnc:\"y\",navStep:100}],g=[\"days\",\"months\",\"years\",\"decades\"],b=[\"top\",\"bottom\",\"auto\"],w=[\"left\",\"right\",\"auto\"],v=[\"default\",\"top\",\"bottom\"],k={up:38,38:\"up\",down:40,40:\"down\",left:37,37:\"left\",right:39,39:\"right\",tab:9,9:\"tab\",escape:27,27:\"escape\",enter:13,13:\"enter\",pageUp:33,33:\"pageUp\",pageDown:34,34:\"pageDown\",shift:16,16:\"shift\",control:17,17:\"control\",space:32,32:\"space\",t:84,84:\"t\",delete:46,46:\"delete\"},D={},C=function(){return void 0!==t.tz&&void 0!==a.timeZone&&null!==a.timeZone&&\"\"!==a.timeZone},x=function(e){var n;return n=void 0===e||null===e?t():t.isDate(e)||t.isMoment(e)?t(e):C()?t.tz(e,l,a.useStrict,a.timeZone):t(e,l,a.useStrict),C()&&n.tz(a.timeZone),n},T=function(e){if(\"string\"!=typeof e||e.length>1)throw new TypeError(\"isEnabled expects a single character string parameter\");switch(e){case\"y\":return-1!==d.indexOf(\"Y\");case\"M\":return-1!==d.indexOf(\"M\");case\"d\":return-1!==d.toLowerCase().indexOf(\"d\");case\"h\":case\"H\":return-1!==d.toLowerCase().indexOf(\"h\");case\"m\":return-1!==d.indexOf(\"m\");case\"s\":return-1!==d.indexOf(\"s\");default:return!1}},M=function(){return T(\"h\")||T(\"m\")||T(\"s\")},S=function(){return T(\"y\")||T(\"M\")||T(\"d\")},O=function(){var t=e(\"<thead>\").append(e(\"<tr>\").append(e(\"<th>\").addClass(\"prev\").attr(\"data-action\",\"previous\").append(e(\"<span>\").addClass(a.icons.previous))).append(e(\"<th>\").addClass(\"picker-switch\").attr(\"data-action\",\"pickerSwitch\").attr(\"colspan\",a.calendarWeeks?\"6\":\"5\")).append(e(\"<th>\").addClass(\"next\").attr(\"data-action\",\"next\").append(e(\"<span>\").addClass(a.icons.next)))),n=e(\"<tbody>\").append(e(\"<tr>\").append(e(\"<td>\").attr(\"colspan\",a.calendarWeeks?\"8\":\"7\")));return[e(\"<div>\").addClass(\"datepicker-days\").append(e(\"<table>\").addClass(\"table-condensed\").append(t).append(e(\"<tbody>\"))),e(\"<div>\").addClass(\"datepicker-months\").append(e(\"<table>\").addClass(\"table-condensed\").append(t.clone()).append(n.clone())),e(\"<div>\").addClass(\"datepicker-years\").append(e(\"<table>\").addClass(\"table-condensed\").append(t.clone()).append(n.clone())),e(\"<div>\").addClass(\"datepicker-decades\").append(e(\"<table>\").addClass(\"table-condensed\").append(t.clone()).append(n.clone()))]},P=function(){var t=e(\"<tr>\"),n=e(\"<tr>\"),r=e(\"<tr>\");return T(\"h\")&&(t.append(e(\"<td>\").append(e(\"<a>\").attr({href:\"#\",tabindex:\"-1\",title:a.tooltips.incrementHour}).addClass(\"btn\").attr(\"data-action\",\"incrementHours\").append(e(\"<span>\").addClass(a.icons.up)))),n.append(e(\"<td>\").append(e(\"<span>\").addClass(\"timepicker-hour\").attr({\"data-time-component\":\"hours\",title:a.tooltips.pickHour}).attr(\"data-action\",\"showHours\"))),r.append(e(\"<td>\").append(e(\"<a>\").attr({href:\"#\",tabindex:\"-1\",title:a.tooltips.decrementHour}).addClass(\"btn\").attr(\"data-action\",\"decrementHours\").append(e(\"<span>\").addClass(a.icons.down))))),T(\"m\")&&(T(\"h\")&&(t.append(e(\"<td>\").addClass(\"separator\")),n.append(e(\"<td>\").addClass(\"separator\").html(\":\")),r.append(e(\"<td>\").addClass(\"separator\"))),t.append(e(\"<td>\").append(e(\"<a>\").attr({href:\"#\",tabindex:\"-1\",title:a.tooltips.incrementMinute}).addClass(\"btn\").attr(\"data-action\",\"incrementMinutes\").append(e(\"<span>\").addClass(a.icons.up)))),n.append(e(\"<td>\").append(e(\"<span>\").addClass(\"timepicker-minute\").attr({\"data-time-component\":\"minutes\",title:a.tooltips.pickMinute}).attr(\"data-action\",\"showMinutes\"))),r.append(e(\"<td>\").append(e(\"<a>\").attr({href:\"#\",tabindex:\"-1\",title:a.tooltips.decrementMinute}).addClass(\"btn\").attr(\"data-action\",\"decrementMinutes\").append(e(\"<span>\").addClass(a.icons.down))))),T(\"s\")&&(T(\"m\")&&(t.append(e(\"<td>\").addClass(\"separator\")),n.append(e(\"<td>\").addClass(\"separator\").html(\":\")),r.append(e(\"<td>\").addClass(\"separator\"))),t.append(e(\"<td>\").append(e(\"<a>\").attr({href:\"#\",tabindex:\"-1\",title:a.tooltips.incrementSecond}).addClass(\"btn\").attr(\"data-action\",\"incrementSeconds\").append(e(\"<span>\").addClass(a.icons.up)))),n.append(e(\"<td>\").append(e(\"<span>\").addClass(\"timepicker-second\").attr({\"data-time-component\":\"seconds\",title:a.tooltips.pickSecond}).attr(\"data-action\",\"showSeconds\"))),r.append(e(\"<td>\").append(e(\"<a>\").attr({href:\"#\",tabindex:\"-1\",title:a.tooltips.decrementSecond}).addClass(\"btn\").attr(\"data-action\",\"decrementSeconds\").append(e(\"<span>\").addClass(a.icons.down))))),s||(t.append(e(\"<td>\").addClass(\"separator\")),n.append(e(\"<td>\").append(e(\"<button>\").addClass(\"btn btn-primary\").attr({\"data-action\":\"togglePeriod\",tabindex:\"-1\",title:a.tooltips.togglePeriod}))),r.append(e(\"<td>\").addClass(\"separator\"))),e(\"<div>\").addClass(\"timepicker-picker\").append(e(\"<table>\").addClass(\"table-condensed\").append([t,n,r]))},E=function(){var t=e(\"<div>\").addClass(\"timepicker-hours\").append(e(\"<table>\").addClass(\"table-condensed\")),n=e(\"<div>\").addClass(\"timepicker-minutes\").append(e(\"<table>\").addClass(\"table-condensed\")),a=e(\"<div>\").addClass(\"timepicker-seconds\").append(e(\"<table>\").addClass(\"table-condensed\")),r=[P()];return T(\"h\")&&r.push(t),T(\"m\")&&r.push(n),T(\"s\")&&r.push(a),r},H=function(){var t=[];return a.showTodayButton&&t.push(e(\"<td>\").append(e(\"<a>\").attr({\"data-action\":\"today\",title:a.tooltips.today}).append(e(\"<span>\").addClass(a.icons.today)))),!a.sideBySide&&S()&&M()&&t.push(e(\"<td>\").append(e(\"<a>\").attr({\"data-action\":\"togglePicker\",title:a.tooltips.selectTime}).append(e(\"<span>\").addClass(a.icons.time)))),a.showClear&&t.push(e(\"<td>\").append(e(\"<a>\").attr({\"data-action\":\"clear\",title:a.tooltips.clear}).append(e(\"<span>\").addClass(a.icons.clear)))),a.showClose&&t.push(e(\"<td>\").append(e(\"<a>\").attr({\"data-action\":\"close\",title:a.tooltips.close}).append(e(\"<span>\").addClass(a.icons.close)))),e(\"<table>\").addClass(\"table-condensed\").append(e(\"<tbody>\").append(e(\"<tr>\").append(t)))},I=function(){var t=e(\"<div>\").addClass(\"bootstrap-datetimepicker-widget dropdown-menu\"),n=e(\"<div>\").addClass(\"datepicker\").append(O()),r=e(\"<div>\").addClass(\"timepicker\").append(E()),i=e(\"<ul>\").addClass(\"list-unstyled\"),o=e(\"<li>\").addClass(\"picker-switch\"+(a.collapse?\" accordion-toggle\":\"\")).append(H());return a.inline&&t.removeClass(\"dropdown-menu\"),s&&t.addClass(\"usetwentyfour\"),T(\"s\")&&!s&&t.addClass(\"wider\"),a.sideBySide&&S()&&M()?(t.addClass(\"timepicker-sbs\"),\"top\"===a.toolbarPlacement&&t.append(o),t.append(e(\"<div>\").addClass(\"row\").append(n.addClass(\"col-md-6\")).append(r.addClass(\"col-md-6\"))),\"bottom\"===a.toolbarPlacement&&t.append(o),t):(\"top\"===a.toolbarPlacement&&i.append(o),S()&&i.append(e(\"<li>\").addClass(a.collapse&&M()?\"collapse in\":\"\").append(n)),\"default\"===a.toolbarPlacement&&i.append(o),M()&&i.append(e(\"<li>\").addClass(a.collapse&&S()?\"collapse\":\"\").append(r)),\"bottom\"===a.toolbarPlacement&&i.append(o),t.append(i))},Y=function(){var t,r=(f||n).position(),i=(f||n).offset(),o=a.widgetPositioning.vertical,s=a.widgetPositioning.horizontal;if(a.widgetParent)t=a.widgetParent.append(h);else if(n.is(\"input\"))t=n.after(h).parent();else{if(a.inline)return void(t=n.append(h));t=n,n.children().first().after(h)}if(\"auto\"===o&&(o=i.top+1.5*h.height()>=e(window).height()+e(window).scrollTop()&&h.height()+n.outerHeight()<i.top?\"top\":\"bottom\"),\"auto\"===s&&(s=t.width()<i.left+h.outerWidth()/2&&i.left+h.outerWidth()>e(window).width()?\"right\":\"left\"),\"top\"===o?h.addClass(\"top\").removeClass(\"bottom\"):h.addClass(\"bottom\").removeClass(\"top\"),\"right\"===s?h.addClass(\"pull-right\"):h.removeClass(\"pull-right\"),\"static\"===t.css(\"position\")&&(t=t.parents().filter(function(){return\"static\"!==e(this).css(\"position\")}).first()),0===t.length)throw new Error(\"datetimepicker component should be placed within a non-static positioned container\");h.css({top:\"top\"===o?\"auto\":r.top+n.outerHeight(),bottom:\"top\"===o?t.outerHeight()-(t===n?0:r.top):\"auto\",left:\"left\"===s?t===n?0:r.left:\"auto\",right:\"left\"===s?\"auto\":t.outerWidth()-n.outerWidth()-(t===n?0:r.left)})},q=function(e){\"dp.change\"===e.type&&(e.date&&e.date.isSame(e.oldDate)||!e.date&&!e.oldDate)||n.trigger(e)},B=function(e){\"y\"===e&&(e=\"YYYY\"),q({type:\"dp.update\",change:e,viewDate:i.clone()})},j=function(e){h&&(e&&(p=Math.max(m,Math.min(3,p+e))),h.find(\".datepicker > div\").hide().filter(\".datepicker-\"+y[p].clsName).show())},A=function(){var t=e(\"<tr>\"),n=i.clone().startOf(\"w\").startOf(\"d\");for(!0===a.calendarWeeks&&t.append(e(\"<th>\").addClass(\"cw\").text(\"#\"));n.isBefore(i.clone().endOf(\"w\"));)t.append(e(\"<th>\").addClass(\"dow\").text(n.format(\"dd\"))),n.add(1,\"d\");h.find(\".datepicker-days thead\").append(t)},F=function(e){return!0===a.disabledDates[e.format(\"YYYY-MM-DD\")]},L=function(e){return!0===a.enabledDates[e.format(\"YYYY-MM-DD\")]},W=function(e){return!0===a.disabledHours[e.format(\"H\")]},z=function(e){return!0===a.enabledHours[e.format(\"H\")]},N=function(t,n){if(!t.isValid())return!1;if(a.disabledDates&&\"d\"===n&&F(t))return!1;if(a.enabledDates&&\"d\"===n&&!L(t))return!1;if(a.minDate&&t.isBefore(a.minDate,n))return!1;if(a.maxDate&&t.isAfter(a.maxDate,n))return!1;if(a.daysOfWeekDisabled&&\"d\"===n&&-1!==a.daysOfWeekDisabled.indexOf(t.day()))return!1;if(a.disabledHours&&(\"h\"===n||\"m\"===n||\"s\"===n)&&W(t))return!1;if(a.enabledHours&&(\"h\"===n||\"m\"===n||\"s\"===n)&&!z(t))return!1;if(a.disabledTimeIntervals&&(\"h\"===n||\"m\"===n||\"s\"===n)){var r=!1;if(e.each(a.disabledTimeIntervals,function(){if(t.isBetween(this[0],this[1]))return r=!0,!1}),r)return!1}return!0},V=function(){for(var t=[],n=i.clone().startOf(\"y\").startOf(\"d\");n.isSame(i,\"y\");)t.push(e(\"<span>\").attr(\"data-action\",\"selectMonth\").addClass(\"month\").text(n.format(\"MMM\"))),n.add(1,\"M\");h.find(\".datepicker-months td\").empty().append(t)},Z=function(){var t=h.find(\".datepicker-months\"),n=t.find(\"th\"),o=t.find(\"tbody\").find(\"span\");n.eq(0).find(\"span\").attr(\"title\",a.tooltips.prevYear),n.eq(1).attr(\"title\",a.tooltips.selectYear),n.eq(2).find(\"span\").attr(\"title\",a.tooltips.nextYear),t.find(\".disabled\").removeClass(\"disabled\"),N(i.clone().subtract(1,\"y\"),\"y\")||n.eq(0).addClass(\"disabled\"),n.eq(1).text(i.year()),N(i.clone().add(1,\"y\"),\"y\")||n.eq(2).addClass(\"disabled\"),o.removeClass(\"active\"),r.isSame(i,\"y\")&&!u&&o.eq(r.month()).addClass(\"active\"),o.each(function(t){N(i.clone().month(t),\"M\")||e(this).addClass(\"disabled\")})},R=function(){var e=h.find(\".datepicker-years\"),t=e.find(\"th\"),n=i.clone().subtract(5,\"y\"),o=i.clone().add(6,\"y\"),s=\"\";for(t.eq(0).find(\"span\").attr(\"title\",a.tooltips.prevDecade),t.eq(1).attr(\"title\",a.tooltips.selectDecade),t.eq(2).find(\"span\").attr(\"title\",a.tooltips.nextDecade),e.find(\".disabled\").removeClass(\"disabled\"),a.minDate&&a.minDate.isAfter(n,\"y\")&&t.eq(0).addClass(\"disabled\"),t.eq(1).text(n.year()+\"-\"+o.year()),a.maxDate&&a.maxDate.isBefore(o,\"y\")&&t.eq(2).addClass(\"disabled\");!n.isAfter(o,\"y\");)s+='<span data-action=\"selectYear\" class=\"year'+(n.isSame(r,\"y\")&&!u?\" active\":\"\")+(N(n,\"y\")?\"\":\" disabled\")+'\">'+n.year()+\"</span>\",n.add(1,\"y\");e.find(\"td\").html(s)},Q=function(){var e,n=h.find(\".datepicker-decades\"),o=n.find(\"th\"),s=t({y:i.year()-i.year()%100-1}),d=s.clone().add(100,\"y\"),l=s.clone(),p=!1,c=!1,u=\"\";for(o.eq(0).find(\"span\").attr(\"title\",a.tooltips.prevCentury),o.eq(2).find(\"span\").attr(\"title\",a.tooltips.nextCentury),n.find(\".disabled\").removeClass(\"disabled\"),(s.isSame(t({y:1900}))||a.minDate&&a.minDate.isAfter(s,\"y\"))&&o.eq(0).addClass(\"disabled\"),o.eq(1).text(s.year()+\"-\"+d.year()),(s.isSame(t({y:2e3}))||a.maxDate&&a.maxDate.isBefore(d,\"y\"))&&o.eq(2).addClass(\"disabled\");!s.isAfter(d,\"y\");)e=s.year()+12,p=a.minDate&&a.minDate.isAfter(s,\"y\")&&a.minDate.year()<=e,c=a.maxDate&&a.maxDate.isAfter(s,\"y\")&&a.maxDate.year()<=e,u+='<span data-action=\"selectDecade\" class=\"decade'+(r.isAfter(s)&&r.year()<=e?\" active\":\"\")+(N(s,\"y\")||p||c?\"\":\" disabled\")+'\" data-selection=\"'+(s.year()+6)+'\">'+(s.year()+1)+\" - \"+(s.year()+12)+\"</span>\",s.add(12,\"y\");u+=\"<span></span><span></span><span></span>\",n.find(\"td\").html(u),o.eq(1).text(l.year()+1+\"-\"+s.year())},U=function(){var t,n,o,s=h.find(\".datepicker-days\"),d=s.find(\"th\"),l=[],p=[];if(S()){for(d.eq(0).find(\"span\").attr(\"title\",a.tooltips.prevMonth),d.eq(1).attr(\"title\",a.tooltips.selectMonth),d.eq(2).find(\"span\").attr(\"title\",a.tooltips.nextMonth),s.find(\".disabled\").removeClass(\"disabled\"),d.eq(1).text(i.format(a.dayViewHeaderFormat)),N(i.clone().subtract(1,\"M\"),\"M\")||d.eq(0).addClass(\"disabled\"),N(i.clone().add(1,\"M\"),\"M\")||d.eq(2).addClass(\"disabled\"),t=i.clone().startOf(\"M\").startOf(\"w\").startOf(\"d\"),o=0;o<42;o++)0===t.weekday()&&(n=e(\"<tr>\"),a.calendarWeeks&&n.append('<td class=\"cw\">'+t.week()+\"</td>\"),l.push(n)),p=[\"day\"],t.isBefore(i,\"M\")&&p.push(\"old\"),t.isAfter(i,\"M\")&&p.push(\"new\"),t.isSame(r,\"d\")&&!u&&p.push(\"active\"),N(t,\"d\")||p.push(\"disabled\"),t.isSame(x(),\"d\")&&p.push(\"today\"),0!==t.day()&&6!==t.day()||p.push(\"weekend\"),q({type:\"dp.classify\",date:t,classNames:p}),n.append('<td data-action=\"selectDay\" data-day=\"'+t.format(\"L\")+'\" class=\"'+p.join(\" \")+'\">'+t.date()+\"</td>\"),t.add(1,\"d\");s.find(\"tbody\").empty().append(l),Z(),R(),Q()}},G=function(){var t=h.find(\".timepicker-hours table\"),n=i.clone().startOf(\"d\"),a=[],r=e(\"<tr>\");for(i.hour()>11&&!s&&n.hour(12);n.isSame(i,\"d\")&&(s||i.hour()<12&&n.hour()<12||i.hour()>11);)n.hour()%4==0&&(r=e(\"<tr>\"),a.push(r)),r.append('<td data-action=\"selectHour\" class=\"hour'+(N(n,\"h\")?\"\":\" disabled\")+'\">'+n.format(s?\"HH\":\"hh\")+\"</td>\"),n.add(1,\"h\");t.empty().append(a)},J=function(){for(var t=h.find(\".timepicker-minutes table\"),n=i.clone().startOf(\"h\"),r=[],o=e(\"<tr>\"),s=1===a.stepping?5:a.stepping;i.isSame(n,\"h\");)n.minute()%(4*s)==0&&(o=e(\"<tr>\"),r.push(o)),o.append('<td data-action=\"selectMinute\" class=\"minute'+(N(n,\"m\")?\"\":\" disabled\")+'\">'+n.format(\"mm\")+\"</td>\"),n.add(s,\"m\");t.empty().append(r)},K=function(){for(var t=h.find(\".timepicker-seconds table\"),n=i.clone().startOf(\"m\"),a=[],r=e(\"<tr>\");i.isSame(n,\"m\");)n.second()%20==0&&(r=e(\"<tr>\"),a.push(r)),r.append('<td data-action=\"selectSecond\" class=\"second'+(N(n,\"s\")?\"\":\" disabled\")+'\">'+n.format(\"ss\")+\"</td>\"),n.add(5,\"s\");t.empty().append(a)},X=function(){var e,t,n=h.find(\".timepicker span[data-time-component]\");s||(e=h.find(\".timepicker [data-action=togglePeriod]\"),t=r.clone().add(r.hours()>=12?-12:12,\"h\"),e.text(r.format(\"A\")),N(t,\"h\")?e.removeClass(\"disabled\"):e.addClass(\"disabled\")),n.filter(\"[data-time-component=hours]\").text(r.format(s?\"HH\":\"hh\")),n.filter(\"[data-time-component=minutes]\").text(r.format(\"mm\")),n.filter(\"[data-time-component=seconds]\").text(r.format(\"ss\")),G(),J(),K()},$=function(){h&&(U(),X())},_=function(e){var t=u?null:r;if(!e)return u=!0,o.val(\"\"),n.data(\"date\",\"\"),q({type:\"dp.change\",date:!1,oldDate:t}),void $();if(e=e.clone().locale(a.locale),C()&&e.tz(a.timeZone),1!==a.stepping)for(e.minutes(Math.round(e.minutes()/a.stepping)*a.stepping).seconds(0);a.minDate&&e.isBefore(a.minDate);)e.add(a.stepping,\"minutes\");N(e)?(r=e,i=r.clone(),o.val(r.format(d)),n.data(\"date\",r.format(d)),u=!1,$(),q({type:\"dp.change\",date:r.clone(),oldDate:t})):(a.keepInvalid?q({type:\"dp.change\",date:e,oldDate:t}):o.val(u?\"\":r.format(d)),q({type:\"dp.error\",date:e,oldDate:t}))},ee=function(){var t=!1;return h?(h.find(\".collapse\").each(function(){var n=e(this).data(\"collapse\");return!n||!n.transitioning||(t=!0,!1)}),t?c:(f&&f.hasClass(\"btn\")&&f.toggleClass(\"active\"),h.hide(),e(window).off(\"resize\",Y),h.off(\"click\",\"[data-action]\"),h.off(\"mousedown\",!1),h.remove(),h=!1,q({type:\"dp.hide\",date:r.clone()}),o.blur(),i=r.clone(),c)):c},te=function(){_(null)},ne=function(e){return void 0===a.parseInputDate?(!t.isMoment(e)||e instanceof Date)&&(e=x(e)):e=a.parseInputDate(e),e},ae={next:function(){var e=y[p].navFnc;i.add(y[p].navStep,e),U(),B(e)},previous:function(){var e=y[p].navFnc;i.subtract(y[p].navStep,e),U(),B(e)},pickerSwitch:function(){j(1)},selectMonth:function(t){var n=e(t.target).closest(\"tbody\").find(\"span\").index(e(t.target));i.month(n),p===m?(_(r.clone().year(i.year()).month(i.month())),a.inline||ee()):(j(-1),U()),B(\"M\")},selectYear:function(t){var n=parseInt(e(t.target).text(),10)||0;i.year(n),p===m?(_(r.clone().year(i.year())),a.inline||ee()):(j(-1),U()),B(\"YYYY\")},selectDecade:function(t){var n=parseInt(e(t.target).data(\"selection\"),10)||0;i.year(n),p===m?(_(r.clone().year(i.year())),a.inline||ee()):(j(-1),U()),B(\"YYYY\")},selectDay:function(t){var n=i.clone();e(t.target).is(\".old\")&&n.subtract(1,\"M\"),e(t.target).is(\".new\")&&n.add(1,\"M\"),_(n.date(parseInt(e(t.target).text(),10))),M()||a.keepOpen||a.inline||ee()},incrementHours:function(){var e=r.clone().add(1,\"h\");N(e,\"h\")&&_(e)},incrementMinutes:function(){var e=r.clone().add(a.stepping,\"m\");N(e,\"m\")&&_(e)},incrementSeconds:function(){var e=r.clone().add(1,\"s\");N(e,\"s\")&&_(e)},decrementHours:function(){var e=r.clone().subtract(1,\"h\");N(e,\"h\")&&_(e)},decrementMinutes:function(){var e=r.clone().subtract(a.stepping,\"m\");N(e,\"m\")&&_(e)},decrementSeconds:function(){var e=r.clone().subtract(1,\"s\");N(e,\"s\")&&_(e)},togglePeriod:function(){_(r.clone().add(r.hours()>=12?-12:12,\"h\"))},togglePicker:function(t){var n,r=e(t.target),i=r.closest(\"ul\"),o=i.find(\".in\"),s=i.find(\".collapse:not(.in)\");if(o&&o.length){if((n=o.data(\"collapse\"))&&n.transitioning)return;o.collapse?(o.collapse(\"hide\"),s.collapse(\"show\")):(o.removeClass(\"in\"),s.addClass(\"in\")),r.is(\"span\")?r.toggleClass(a.icons.time+\" \"+a.icons.date):r.find(\"span\").toggleClass(a.icons.time+\" \"+a.icons.date)}},showPicker:function(){h.find(\".timepicker > div:not(.timepicker-picker)\").hide(),h.find(\".timepicker .timepicker-picker\").show()},showHours:function(){h.find(\".timepicker .timepicker-picker\").hide(),h.find(\".timepicker .timepicker-hours\").show()},showMinutes:function(){h.find(\".timepicker .timepicker-picker\").hide(),h.find(\".timepicker .timepicker-minutes\").show()},showSeconds:function(){h.find(\".timepicker .timepicker-picker\").hide(),h.find(\".timepicker .timepicker-seconds\").show()},selectHour:function(t){var n=parseInt(e(t.target).text(),10);s||(r.hours()>=12?12!==n&&(n+=12):12===n&&(n=0)),_(r.clone().hours(n)),ae.showPicker.call(c)},selectMinute:function(t){_(r.clone().minutes(parseInt(e(t.target).text(),10))),ae.showPicker.call(c)},selectSecond:function(t){_(r.clone().seconds(parseInt(e(t.target).text(),10))),ae.showPicker.call(c)},clear:te,today:function(){var e=x();N(e,\"d\")&&_(e)},close:ee},re=function(t){return!e(t.currentTarget).is(\".disabled\")&&(ae[e(t.currentTarget).data(\"action\")].apply(c,arguments),!1)},ie=function(){var t,n={year:function(e){return e.month(0).date(1).hours(0).seconds(0).minutes(0)},month:function(e){return e.date(1).hours(0).seconds(0).minutes(0)},day:function(e){return e.hours(0).seconds(0).minutes(0)},hour:function(e){return e.seconds(0).minutes(0)},minute:function(e){return e.seconds(0)}};return o.prop(\"disabled\")||!a.ignoreReadonly&&o.prop(\"readonly\")||h?c:(void 0!==o.val()&&0!==o.val().trim().length?_(ne(o.val().trim())):u&&a.useCurrent&&(a.inline||o.is(\"input\")&&0===o.val().trim().length)&&(t=x(),\"string\"==typeof a.useCurrent&&(t=n[a.useCurrent](t)),_(t)),h=I(),A(),V(),h.find(\".timepicker-hours\").hide(),h.find(\".timepicker-minutes\").hide(),h.find(\".timepicker-seconds\").hide(),$(),j(),e(window).on(\"resize\",Y),h.on(\"click\",\"[data-action]\",re),h.on(\"mousedown\",!1),f&&f.hasClass(\"btn\")&&f.toggleClass(\"active\"),Y(),h.show(),a.focusOnShow&&!o.is(\":focus\")&&o.focus(),q({type:\"dp.show\"}),c)},oe=function(){return h?ee():ie()},se=function(e){var t,n,r,i,o=null,s=[],d={},l=e.which;D[l]=\"p\";for(t in D)D.hasOwnProperty(t)&&\"p\"===D[t]&&(s.push(t),parseInt(t,10)!==l&&(d[t]=!0));for(t in a.keyBinds)if(a.keyBinds.hasOwnProperty(t)&&\"function\"==typeof a.keyBinds[t]&&(r=t.split(\" \"),r.length===s.length&&k[l]===r[r.length-1])){for(i=!0,n=r.length-2;n>=0;n--)if(!(k[r[n]]in d)){i=!1;break}if(i){o=a.keyBinds[t];break}}o&&(o.call(c,h),e.stopPropagation(),e.preventDefault())},de=function(e){D[e.which]=\"r\",e.stopPropagation(),e.preventDefault()},le=function(t){var n=e(t.target).val().trim(),a=n?ne(n):null;return _(a),t.stopImmediatePropagation(),!1},pe=function(){o.off({change:le,blur:blur,keydown:se,keyup:de,focus:a.allowInputToggle?ee:\"\"}),n.is(\"input\")?o.off({focus:ie}):f&&(f.off(\"click\",oe),f.off(\"mousedown\",!1))},ce=function(t){var n={};return e.each(t,function(){var e=ne(this);e.isValid()&&(n[e.format(\"YYYY-MM-DD\")]=!0)}),!!Object.keys(n).length&&n},ue=function(t){var n={};return e.each(t,function(){n[this]=!0}),!!Object.keys(n).length&&n},fe=function(){var e=a.format||\"L LT\";d=e.replace(/(\\[[^\\[]*\\])|(\\\\)?(LTS|LT|LL?L?L?|l{1,4})/g,function(e){return(r.localeData().longDateFormat(e)||e).replace(/(\\[[^\\[]*\\])|(\\\\)?(LTS|LT|LL?L?L?|l{1,4})/g,function(e){return r.localeData().longDateFormat(e)||e})}),l=a.extraFormats?a.extraFormats.slice():[],l.indexOf(e)<0&&l.indexOf(d)<0&&l.push(d),s=d.toLowerCase().indexOf(\"a\")<1&&d.replace(/\\[.*?\\]/g,\"\").indexOf(\"h\")<1,T(\"y\")&&(m=2),T(\"M\")&&(m=1),T(\"d\")&&(m=0),p=Math.max(m,p),u||_(r)};if(c.destroy=function(){ee(),pe(),n.removeData(\"DateTimePicker\"),n.removeData(\"date\")},c.toggle=oe,c.show=ie,c.hide=ee,c.disable=function(){return ee(),f&&f.hasClass(\"btn\")&&f.addClass(\"disabled\"),o.prop(\"disabled\",!0),c},c.enable=function(){return f&&f.hasClass(\"btn\")&&f.removeClass(\"disabled\"),o.prop(\"disabled\",!1),c},c.ignoreReadonly=function(e){if(0===arguments.length)return a.ignoreReadonly;if(\"boolean\"!=typeof e)throw new TypeError(\"ignoreReadonly () expects a boolean parameter\");return a.ignoreReadonly=e,c},c.options=function(t){if(0===arguments.length)return e.extend(!0,{},a);if(!(t instanceof Object))throw new TypeError(\"options() options parameter should be an object\");return e.extend(!0,a,t),e.each(a,function(e,t){if(void 0===c[e])throw new TypeError(\"option \"+e+\" is not recognized!\");c[e](t)}),c},c.date=function(e){if(0===arguments.length)return u?null:r.clone();if(!(null===e||\"string\"==typeof e||t.isMoment(e)||e instanceof Date))throw new TypeError(\"date() parameter must be one of [null, string, moment or Date]\");return _(null===e?null:ne(e)),c},c.format=function(e){if(0===arguments.length)return a.format;if(\"string\"!=typeof e&&(\"boolean\"!=typeof e||!1!==e))throw new TypeError(\"format() expects a string or boolean:false parameter \"+e);return a.format=e,d&&fe(),c},c.timeZone=function(e){if(0===arguments.length)return a.timeZone;if(\"string\"!=typeof e)throw new TypeError(\"newZone() expects a string parameter\");return a.timeZone=e,c},c.dayViewHeaderFormat=function(e){if(0===arguments.length)return a.dayViewHeaderFormat;if(\"string\"!=typeof e)throw new TypeError(\"dayViewHeaderFormat() expects a string parameter\");return a.dayViewHeaderFormat=e,c},c.extraFormats=function(e){if(0===arguments.length)return a.extraFormats;if(!1!==e&&!(e instanceof Array))throw new TypeError(\"extraFormats() expects an array or false parameter\");return a.extraFormats=e,l&&fe(),c},c.disabledDates=function(t){if(0===arguments.length)return a.disabledDates?e.extend({},a.disabledDates):a.disabledDates;if(!t)return a.disabledDates=!1,$(),c;if(!(t instanceof Array))throw new TypeError(\"disabledDates() expects an array parameter\");return a.disabledDates=ce(t),a.enabledDates=!1,$(),c},c.enabledDates=function(t){if(0===arguments.length)return a.enabledDates?e.extend({},a.enabledDates):a.enabledDates;if(!t)return a.enabledDates=!1,$(),c;if(!(t instanceof Array))throw new TypeError(\"enabledDates() expects an array parameter\");return a.enabledDates=ce(t),a.disabledDates=!1,$(),c},c.daysOfWeekDisabled=function(e){if(0===arguments.length)return a.daysOfWeekDisabled.splice(0);if(\"boolean\"==typeof e&&!e)return a.daysOfWeekDisabled=!1,$(),c;if(!(e instanceof Array))throw new TypeError(\"daysOfWeekDisabled() expects an array parameter\");if(a.daysOfWeekDisabled=e.reduce(function(e,t){return(t=parseInt(t,10))>6||t<0||isNaN(t)?e:(-1===e.indexOf(t)&&e.push(t),e)},[]).sort(),a.useCurrent&&!a.keepInvalid){for(var t=0;!N(r,\"d\");){if(r.add(1,\"d\"),31===t)throw\"Tried 31 times to find a valid date\";t++}_(r)}return $(),c},c.maxDate=function(e){if(0===arguments.length)return a.maxDate?a.maxDate.clone():a.maxDate;if(\"boolean\"==typeof e&&!1===e)return a.maxDate=!1,$(),c;\"string\"==typeof e&&(\"now\"!==e&&\"moment\"!==e||(e=x()));var t=ne(e);if(!t.isValid())throw new TypeError(\"maxDate() Could not parse date parameter: \"+e);if(a.minDate&&t.isBefore(a.minDate))throw new TypeError(\"maxDate() date parameter is before options.minDate: \"+t.format(d));return a.maxDate=t,a.useCurrent&&!a.keepInvalid&&r.isAfter(e)&&_(a.maxDate),i.isAfter(t)&&(i=t.clone().subtract(a.stepping,\"m\")),$(),c},c.minDate=function(e){if(0===arguments.length)return a.minDate?a.minDate.clone():a.minDate;if(\"boolean\"==typeof e&&!1===e)return a.minDate=!1,$(),c;\"string\"==typeof e&&(\"now\"!==e&&\"moment\"!==e||(e=x()));var t=ne(e);if(!t.isValid())throw new TypeError(\"minDate() Could not parse date parameter: \"+e);if(a.maxDate&&t.isAfter(a.maxDate))throw new TypeError(\"minDate() date parameter is after options.maxDate: \"+t.format(d));return a.minDate=t,a.useCurrent&&!a.keepInvalid&&r.isBefore(e)&&_(a.minDate),i.isBefore(t)&&(i=t.clone().add(a.stepping,\"m\")),$(),c},c.defaultDate=function(e){if(0===arguments.length)return a.defaultDate?a.defaultDate.clone():a.defaultDate;if(!e)return a.defaultDate=!1,c;\"string\"==typeof e&&(e=\"now\"===e||\"moment\"===e?x():x(e));var t=ne(e);if(!t.isValid())throw new TypeError(\"defaultDate() Could not parse date parameter: \"+e);if(!N(t))throw new TypeError(\"defaultDate() date passed is invalid according to component setup validations\");return a.defaultDate=t,(a.defaultDate&&a.inline||\"\"===o.val().trim())&&_(a.defaultDate),c},c.locale=function(e){if(0===arguments.length)return a.locale;if(!t.localeData(e))throw new TypeError(\"locale() locale \"+e+\" is not loaded from moment locales!\");return a.locale=e,r.locale(a.locale),i.locale(a.locale),d&&fe(),h&&(ee(),ie()),c},c.stepping=function(e){return 0===arguments.length?a.stepping:(e=parseInt(e,10),(isNaN(e)||e<1)&&(e=1),a.stepping=e,c)},c.useCurrent=function(e){var t=[\"year\",\"month\",\"day\",\"hour\",\"minute\"];if(0===arguments.length)return a.useCurrent;if(\"boolean\"!=typeof e&&\"string\"!=typeof e)throw new TypeError(\"useCurrent() expects a boolean or string parameter\");if(\"string\"==typeof e&&-1===t.indexOf(e.toLowerCase()))throw new TypeError(\"useCurrent() expects a string parameter of \"+t.join(\", \"));return a.useCurrent=e,c},c.collapse=function(e){if(0===arguments.length)return a.collapse;if(\"boolean\"!=typeof e)throw new TypeError(\"collapse() expects a boolean parameter\");return a.collapse===e?c:(a.collapse=e,h&&(ee(),ie()),c)},c.icons=function(t){if(0===arguments.length)return e.extend({},a.icons);if(!(t instanceof Object))throw new TypeError(\"icons() expects parameter to be an Object\");return e.extend(a.icons,t),h&&(ee(),ie()),c},c.tooltips=function(t){if(0===arguments.length)return e.extend({},a.tooltips);if(!(t instanceof Object))throw new TypeError(\"tooltips() expects parameter to be an Object\");return e.extend(a.tooltips,t),h&&(ee(),ie()),c},c.useStrict=function(e){if(0===arguments.length)return a.useStrict;if(\"boolean\"!=typeof e)throw new TypeError(\"useStrict() expects a boolean parameter\");return a.useStrict=e,c},c.sideBySide=function(e){if(0===arguments.length)return a.sideBySide;if(\"boolean\"!=typeof e)throw new TypeError(\"sideBySide() expects a boolean parameter\");return a.sideBySide=e,h&&(ee(),ie()),c},c.viewMode=function(e){if(0===arguments.length)return a.viewMode;if(\"string\"!=typeof e)throw new TypeError(\"viewMode() expects a string parameter\");if(-1===g.indexOf(e))throw new TypeError(\"viewMode() parameter must be one of (\"+g.join(\", \")+\") value\");return a.viewMode=e,p=Math.max(g.indexOf(e),m),j(),c},c.toolbarPlacement=function(e){if(0===arguments.length)return a.toolbarPlacement;if(\"string\"!=typeof e)throw new TypeError(\"toolbarPlacement() expects a string parameter\");if(-1===v.indexOf(e))throw new TypeError(\"toolbarPlacement() parameter must be one of (\"+v.join(\", \")+\") value\");return a.toolbarPlacement=e,h&&(ee(),ie()),c},c.widgetPositioning=function(t){if(0===arguments.length)return e.extend({},a.widgetPositioning);if(\"[object Object]\"!=={}.toString.call(t))throw new TypeError(\"widgetPositioning() expects an object variable\");if(t.horizontal){if(\"string\"!=typeof t.horizontal)throw new TypeError(\"widgetPositioning() horizontal variable must be a string\");if(t.horizontal=t.horizontal.toLowerCase(),-1===w.indexOf(t.horizontal))throw new TypeError(\"widgetPositioning() expects horizontal parameter to be one of (\"+w.join(\", \")+\")\");a.widgetPositioning.horizontal=t.horizontal}if(t.vertical){if(\"string\"!=typeof t.vertical)throw new TypeError(\"widgetPositioning() vertical variable must be a string\");if(t.vertical=t.vertical.toLowerCase(),-1===b.indexOf(t.vertical))throw new TypeError(\"widgetPositioning() expects vertical parameter to be one of (\"+b.join(\", \")+\")\");a.widgetPositioning.vertical=t.vertical}return $(),c},c.calendarWeeks=function(e){if(0===arguments.length)return a.calendarWeeks;if(\"boolean\"!=typeof e)throw new TypeError(\"calendarWeeks() expects parameter to be a boolean value\");return a.calendarWeeks=e,$(),c},c.showTodayButton=function(e){if(0===arguments.length)return a.showTodayButton;if(\"boolean\"!=typeof e)throw new TypeError(\"showTodayButton() expects a boolean parameter\");return a.showTodayButton=e,h&&(ee(),ie()),c},c.showClear=function(e){if(0===arguments.length)return a.showClear;if(\"boolean\"!=typeof e)throw new TypeError(\"showClear() expects a boolean parameter\");return a.showClear=e,h&&(ee(),ie()),c},c.widgetParent=function(t){if(0===arguments.length)return a.widgetParent;if(\"string\"==typeof t&&(t=e(t)),null!==t&&\"string\"!=typeof t&&!(t instanceof e))throw new TypeError(\"widgetParent() expects a string or a jQuery object parameter\");return a.widgetParent=t,h&&(ee(),ie()),c},c.keepOpen=function(e){if(0===arguments.length)return a.keepOpen;if(\"boolean\"!=typeof e)throw new TypeError(\"keepOpen() expects a boolean parameter\");return a.keepOpen=e,c},c.focusOnShow=function(e){if(0===arguments.length)return a.focusOnShow;if(\"boolean\"!=typeof e)throw new TypeError(\"focusOnShow() expects a boolean parameter\");return a.focusOnShow=e,c},c.inline=function(e){if(0===arguments.length)return a.inline;if(\"boolean\"!=typeof e)throw new TypeError(\"inline() expects a boolean parameter\");return a.inline=e,c},c.clear=function(){return te(),c},c.keyBinds=function(e){return 0===arguments.length?a.keyBinds:(a.keyBinds=e,c)},c.getMoment=function(e){return x(e)},c.debug=function(e){if(\"boolean\"!=typeof e)throw new TypeError(\"debug() expects a boolean parameter\");return a.debug=e,c},c.allowInputToggle=function(e){if(0===arguments.length)return a.allowInputToggle;if(\"boolean\"!=typeof e)throw new TypeError(\"allowInputToggle() expects a boolean parameter\");return a.allowInputToggle=e,c},c.showClose=function(e){if(0===arguments.length)return a.showClose;if(\"boolean\"!=typeof e)throw new TypeError(\"showClose() expects a boolean parameter\");return a.showClose=e,c},c.keepInvalid=function(e){if(0===arguments.length)return a.keepInvalid;if(\"boolean\"!=typeof e)throw new TypeError(\"keepInvalid() expects a boolean parameter\");return a.keepInvalid=e,c},c.datepickerInput=function(e){if(0===arguments.length)return a.datepickerInput;if(\"string\"!=typeof e)throw new TypeError(\"datepickerInput() expects a string parameter\");return a.datepickerInput=e,c},c.parseInputDate=function(e){if(0===arguments.length)return a.parseInputDate;if(\"function\"!=typeof e)throw new TypeError(\"parseInputDate() sholud be as function\");return a.parseInputDate=e,c},c.disabledTimeIntervals=function(t){\nif(0===arguments.length)return a.disabledTimeIntervals?e.extend({},a.disabledTimeIntervals):a.disabledTimeIntervals;if(!t)return a.disabledTimeIntervals=!1,$(),c;if(!(t instanceof Array))throw new TypeError(\"disabledTimeIntervals() expects an array parameter\");return a.disabledTimeIntervals=t,$(),c},c.disabledHours=function(t){if(0===arguments.length)return a.disabledHours?e.extend({},a.disabledHours):a.disabledHours;if(!t)return a.disabledHours=!1,$(),c;if(!(t instanceof Array))throw new TypeError(\"disabledHours() expects an array parameter\");if(a.disabledHours=ue(t),a.enabledHours=!1,a.useCurrent&&!a.keepInvalid){for(var n=0;!N(r,\"h\");){if(r.add(1,\"h\"),24===n)throw\"Tried 24 times to find a valid date\";n++}_(r)}return $(),c},c.enabledHours=function(t){if(0===arguments.length)return a.enabledHours?e.extend({},a.enabledHours):a.enabledHours;if(!t)return a.enabledHours=!1,$(),c;if(!(t instanceof Array))throw new TypeError(\"enabledHours() expects an array parameter\");if(a.enabledHours=ue(t),a.disabledHours=!1,a.useCurrent&&!a.keepInvalid){for(var n=0;!N(r,\"h\");){if(r.add(1,\"h\"),24===n)throw\"Tried 24 times to find a valid date\";n++}_(r)}return $(),c},c.viewDate=function(e){if(0===arguments.length)return i.clone();if(!e)return i=r.clone(),c;if(!(\"string\"==typeof e||t.isMoment(e)||e instanceof Date))throw new TypeError(\"viewDate() parameter must be one of [string, moment or Date]\");return i=ne(e),B(),c},n.is(\"input\"))o=n;else if(o=n.find(a.datepickerInput),0===o.length)o=n.find(\"input\");else if(!o.is(\"input\"))throw new Error('CSS class \"'+a.datepickerInput+'\" cannot be applied to non input element');if(n.hasClass(\"input-group\")&&(f=0===n.find(\".datepickerbutton\").length?n.find(\".input-group-addon\"):n.find(\".datepickerbutton\")),!a.inline&&!o.is(\"input\"))throw new Error(\"Could not initialize DateTimePicker without an input element\");return r=x(),i=r.clone(),e.extend(!0,a,function(){var t,r={};return t=n.is(\"input\")||a.inline?n.data():n.find(\"input\").data(),t.dateOptions&&t.dateOptions instanceof Object&&(r=e.extend(!0,r,t.dateOptions)),e.each(a,function(e){var n=\"date\"+e.charAt(0).toUpperCase()+e.slice(1);void 0!==t[n]&&(r[e]=t[n])}),r}()),c.options(a),fe(),function(){o.on({change:le,blur:a.debug?\"\":ee,keydown:se,keyup:de,focus:a.allowInputToggle?ie:\"\"}),n.is(\"input\")?o.on({focus:ie}):f&&(f.on(\"click\",oe),f.on(\"mousedown\",!1))}(),o.prop(\"disabled\")&&c.disable(),o.is(\"input\")&&0!==o.val().trim().length?_(ne(o.val().trim())):a.defaultDate&&void 0===o.attr(\"placeholder\")&&_(a.defaultDate),a.inline&&ie(),c};return e.fn.datetimepicker=function(t){t=t||{};var a,r=Array.prototype.slice.call(arguments,1),i=!0,o=[\"destroy\",\"hide\",\"show\",\"toggle\"];if(\"object\"==typeof t)return this.each(function(){var a,r=e(this);r.data(\"DateTimePicker\")||(a=e.extend(!0,{},e.fn.datetimepicker.defaults,t),r.data(\"DateTimePicker\",n(r,a)))});if(\"string\"==typeof t)return this.each(function(){var n=e(this),o=n.data(\"DateTimePicker\");if(!o)throw new Error('bootstrap-datetimepicker(\"'+t+'\") method was called on an element that is not using DateTimePicker');a=o[t].apply(o,r),i=a===o}),i||e.inArray(t,o)>-1?this:a;throw new TypeError(\"Invalid arguments for DateTimePicker: \"+t)},e.fn.datetimepicker.defaults={timeZone:\"\",format:!1,dayViewHeaderFormat:\"MMMM YYYY\",extraFormats:!1,stepping:1,minDate:!1,maxDate:!1,useCurrent:!0,collapse:!0,locale:t.locale(),defaultDate:!1,disabledDates:!1,enabledDates:!1,icons:{time:\"glyphicon glyphicon-time\",date:\"glyphicon glyphicon-calendar\",up:\"glyphicon glyphicon-chevron-up\",down:\"glyphicon glyphicon-chevron-down\",previous:\"glyphicon glyphicon-chevron-left\",next:\"glyphicon glyphicon-chevron-right\",today:\"glyphicon glyphicon-screenshot\",clear:\"glyphicon glyphicon-trash\",close:\"glyphicon glyphicon-remove\"},tooltips:{today:\"Go to today\",clear:\"Clear selection\",close:\"Close the picker\",selectMonth:\"Select Month\",prevMonth:\"Previous Month\",nextMonth:\"Next Month\",selectYear:\"Select Year\",prevYear:\"Previous Year\",nextYear:\"Next Year\",selectDecade:\"Select Decade\",prevDecade:\"Previous Decade\",nextDecade:\"Next Decade\",prevCentury:\"Previous Century\",nextCentury:\"Next Century\",pickHour:\"Pick Hour\",incrementHour:\"Increment Hour\",decrementHour:\"Decrement Hour\",pickMinute:\"Pick Minute\",incrementMinute:\"Increment Minute\",decrementMinute:\"Decrement Minute\",pickSecond:\"Pick Second\",incrementSecond:\"Increment Second\",decrementSecond:\"Decrement Second\",togglePeriod:\"Toggle Period\",selectTime:\"Select Time\"},useStrict:!1,sideBySide:!1,daysOfWeekDisabled:!1,calendarWeeks:!1,viewMode:\"days\",toolbarPlacement:\"default\",showTodayButton:!1,showClear:!1,showClose:!1,widgetPositioning:{horizontal:\"auto\",vertical:\"auto\"},widgetParent:null,ignoreReadonly:!1,keepOpen:!1,focusOnShow:!0,inline:!1,keepInvalid:!1,datepickerInput:\".datepickerinput\",keyBinds:{up:function(e){if(e){var t=this.date()||this.getMoment();e.find(\".datepicker\").is(\":visible\")?this.date(t.clone().subtract(7,\"d\")):this.date(t.clone().add(this.stepping(),\"m\"))}},down:function(e){if(!e)return void this.show();var t=this.date()||this.getMoment();e.find(\".datepicker\").is(\":visible\")?this.date(t.clone().add(7,\"d\")):this.date(t.clone().subtract(this.stepping(),\"m\"))},\"control up\":function(e){if(e){var t=this.date()||this.getMoment();e.find(\".datepicker\").is(\":visible\")?this.date(t.clone().subtract(1,\"y\")):this.date(t.clone().add(1,\"h\"))}},\"control down\":function(e){if(e){var t=this.date()||this.getMoment();e.find(\".datepicker\").is(\":visible\")?this.date(t.clone().add(1,\"y\")):this.date(t.clone().subtract(1,\"h\"))}},left:function(e){if(e){var t=this.date()||this.getMoment();e.find(\".datepicker\").is(\":visible\")&&this.date(t.clone().subtract(1,\"d\"))}},right:function(e){if(e){var t=this.date()||this.getMoment();e.find(\".datepicker\").is(\":visible\")&&this.date(t.clone().add(1,\"d\"))}},pageUp:function(e){if(e){var t=this.date()||this.getMoment();e.find(\".datepicker\").is(\":visible\")&&this.date(t.clone().subtract(1,\"M\"))}},pageDown:function(e){if(e){var t=this.date()||this.getMoment();e.find(\".datepicker\").is(\":visible\")&&this.date(t.clone().add(1,\"M\"))}},enter:function(){this.hide()},escape:function(){this.hide()},\"control space\":function(e){e&&e.find(\".timepicker\").is(\":visible\")&&e.find('.btn[data-action=\"togglePeriod\"]').click()},t:function(){this.date(this.getMoment())},delete:function(){this.clear()}},debug:!1,allowInputToggle:!1,disabledTimeIntervals:!1,disabledHours:!1,enabledHours:!1,viewDate:!1},e.fn.datetimepicker});"

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(131))

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	module.exports = "!function(t,e){if(\"function\"==typeof define&&define.amd)define([\"moment\",\"jquery\"],function(a,i){return t.daterangepicker=e(a,i)});else if(\"object\"==typeof module&&module.exports){var a=\"undefined\"!=typeof window?window.jQuery:void 0;a||(a=require(\"jquery\"),a.fn||(a.fn={})),module.exports=e(require(\"moment\"),a)}else t.daterangepicker=e(t.moment,t.jQuery)}(this,function(t,e){var a=function(a,i,s){if(this.parentEl=\"body\",this.element=e(a),this.startDate=t().startOf(\"day\"),this.endDate=t().endOf(\"day\"),this.minDate=!1,this.maxDate=!1,this.dateLimit=!1,this.autoApply=!1,this.singleDatePicker=!1,this.showDropdowns=!1,this.showWeekNumbers=!1,this.showISOWeekNumbers=!1,this.showCustomRangeLabel=!0,this.timePicker=!1,this.timePicker24Hour=!1,this.timePickerIncrement=1,this.timePickerSeconds=!1,this.linkedCalendars=!0,this.autoUpdateInput=!0,this.alwaysShowCalendars=!1,this.ranges={},this.opens=\"right\",this.element.hasClass(\"pull-right\")&&(this.opens=\"left\"),this.drops=\"down\",this.element.hasClass(\"dropup\")&&(this.drops=\"up\"),this.buttonClasses=\"btn btn-sm\",this.applyClass=\"btn-success\",this.cancelClass=\"btn-default\",this.locale={direction:\"ltr\",format:t.localeData().longDateFormat(\"L\"),separator:\" - \",applyLabel:\"Apply\",cancelLabel:\"Cancel\",weekLabel:\"W\",customRangeLabel:\"Custom Range\",daysOfWeek:t.weekdaysMin(),monthNames:t.monthsShort(),firstDay:t.localeData().firstDayOfWeek()},this.callback=function(){},this.isShowing=!1,this.leftCalendar={},this.rightCalendar={},\"object\"==typeof i&&null!==i||(i={}),i=e.extend(this.element.data(),i),\"string\"==typeof i.template||i.template instanceof e||(i.template='<div class=\"daterangepicker dropdown-menu\"><div class=\"calendar left\"><div class=\"daterangepicker_input\"><input class=\"input-mini form-control\" type=\"text\" name=\"daterangepicker_start\" value=\"\" /><i class=\"fa fa-calendar glyphicon glyphicon-calendar\"></i><div class=\"calendar-time\"><div></div><i class=\"fa fa-clock-o glyphicon glyphicon-time\"></i></div></div><div class=\"calendar-table\"></div></div><div class=\"calendar right\"><div class=\"daterangepicker_input\"><input class=\"input-mini form-control\" type=\"text\" name=\"daterangepicker_end\" value=\"\" /><i class=\"fa fa-calendar glyphicon glyphicon-calendar\"></i><div class=\"calendar-time\"><div></div><i class=\"fa fa-clock-o glyphicon glyphicon-time\"></i></div></div><div class=\"calendar-table\"></div></div><div class=\"ranges\"><div class=\"range_inputs\"><button class=\"applyBtn\" disabled=\"disabled\" type=\"button\"></button> <button class=\"cancelBtn\" type=\"button\"></button></div></div></div>'),this.parentEl=e(i.parentEl&&e(i.parentEl).length?i.parentEl:this.parentEl),this.container=e(i.template).appendTo(this.parentEl),\"object\"==typeof i.locale&&(\"string\"==typeof i.locale.direction&&(this.locale.direction=i.locale.direction),\"string\"==typeof i.locale.format&&(this.locale.format=i.locale.format),\"string\"==typeof i.locale.separator&&(this.locale.separator=i.locale.separator),\"object\"==typeof i.locale.daysOfWeek&&(this.locale.daysOfWeek=i.locale.daysOfWeek.slice()),\"object\"==typeof i.locale.monthNames&&(this.locale.monthNames=i.locale.monthNames.slice()),\"number\"==typeof i.locale.firstDay&&(this.locale.firstDay=i.locale.firstDay),\"string\"==typeof i.locale.applyLabel&&(this.locale.applyLabel=i.locale.applyLabel),\"string\"==typeof i.locale.cancelLabel&&(this.locale.cancelLabel=i.locale.cancelLabel),\"string\"==typeof i.locale.weekLabel&&(this.locale.weekLabel=i.locale.weekLabel),\"string\"==typeof i.locale.customRangeLabel)){var n=document.createElement(\"textarea\");n.innerHTML=i.locale.customRangeLabel;var r=n.value;this.locale.customRangeLabel=r}if(this.container.addClass(this.locale.direction),\"string\"==typeof i.startDate&&(this.startDate=t(i.startDate,this.locale.format)),\"string\"==typeof i.endDate&&(this.endDate=t(i.endDate,this.locale.format)),\"string\"==typeof i.minDate&&(this.minDate=t(i.minDate,this.locale.format)),\"string\"==typeof i.maxDate&&(this.maxDate=t(i.maxDate,this.locale.format)),\"object\"==typeof i.startDate&&(this.startDate=t(i.startDate)),\"object\"==typeof i.endDate&&(this.endDate=t(i.endDate)),\"object\"==typeof i.minDate&&(this.minDate=t(i.minDate)),\"object\"==typeof i.maxDate&&(this.maxDate=t(i.maxDate)),this.minDate&&this.startDate.isBefore(this.minDate)&&(this.startDate=this.minDate.clone()),this.maxDate&&this.endDate.isAfter(this.maxDate)&&(this.endDate=this.maxDate.clone()),\"string\"==typeof i.applyClass&&(this.applyClass=i.applyClass),\"string\"==typeof i.cancelClass&&(this.cancelClass=i.cancelClass),\"object\"==typeof i.dateLimit&&(this.dateLimit=i.dateLimit),\"string\"==typeof i.opens&&(this.opens=i.opens),\"string\"==typeof i.drops&&(this.drops=i.drops),\"boolean\"==typeof i.showWeekNumbers&&(this.showWeekNumbers=i.showWeekNumbers),\"boolean\"==typeof i.showISOWeekNumbers&&(this.showISOWeekNumbers=i.showISOWeekNumbers),\"string\"==typeof i.buttonClasses&&(this.buttonClasses=i.buttonClasses),\"object\"==typeof i.buttonClasses&&(this.buttonClasses=i.buttonClasses.join(\" \")),\"boolean\"==typeof i.showDropdowns&&(this.showDropdowns=i.showDropdowns),\"boolean\"==typeof i.showCustomRangeLabel&&(this.showCustomRangeLabel=i.showCustomRangeLabel),\"boolean\"==typeof i.singleDatePicker&&(this.singleDatePicker=i.singleDatePicker,this.singleDatePicker&&(this.endDate=this.startDate.clone())),\"boolean\"==typeof i.timePicker&&(this.timePicker=i.timePicker),\"boolean\"==typeof i.timePickerSeconds&&(this.timePickerSeconds=i.timePickerSeconds),\"number\"==typeof i.timePickerIncrement&&(this.timePickerIncrement=i.timePickerIncrement),\"boolean\"==typeof i.timePicker24Hour&&(this.timePicker24Hour=i.timePicker24Hour),\"boolean\"==typeof i.autoApply&&(this.autoApply=i.autoApply),\"boolean\"==typeof i.autoUpdateInput&&(this.autoUpdateInput=i.autoUpdateInput),\"boolean\"==typeof i.linkedCalendars&&(this.linkedCalendars=i.linkedCalendars),\"function\"==typeof i.isInvalidDate&&(this.isInvalidDate=i.isInvalidDate),\"function\"==typeof i.isCustomDate&&(this.isCustomDate=i.isCustomDate),\"boolean\"==typeof i.alwaysShowCalendars&&(this.alwaysShowCalendars=i.alwaysShowCalendars),0!=this.locale.firstDay)for(var o=this.locale.firstDay;o>0;)this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift()),o--;var h,l,c;if(void 0===i.startDate&&void 0===i.endDate&&e(this.element).is(\"input[type=text]\")){var d=e(this.element).val(),m=d.split(this.locale.separator);h=l=null,2==m.length?(h=t(m[0],this.locale.format),l=t(m[1],this.locale.format)):this.singleDatePicker&&\"\"!==d&&(h=t(d,this.locale.format),l=t(d,this.locale.format)),null!==h&&null!==l&&(this.setStartDate(h),this.setEndDate(l))}if(\"object\"==typeof i.ranges){for(c in i.ranges){h=\"string\"==typeof i.ranges[c][0]?t(i.ranges[c][0],this.locale.format):t(i.ranges[c][0]),l=\"string\"==typeof i.ranges[c][1]?t(i.ranges[c][1],this.locale.format):t(i.ranges[c][1]),this.minDate&&h.isBefore(this.minDate)&&(h=this.minDate.clone());var f=this.maxDate;if(this.dateLimit&&f&&h.clone().add(this.dateLimit).isAfter(f)&&(f=h.clone().add(this.dateLimit)),f&&l.isAfter(f)&&(l=f.clone()),!(this.minDate&&l.isBefore(this.minDate,this.timepicker?\"minute\":\"day\")||f&&h.isAfter(f,this.timepicker?\"minute\":\"day\"))){var n=document.createElement(\"textarea\");n.innerHTML=c;var r=n.value;this.ranges[r]=[h,l]}}var p=\"<ul>\";for(c in this.ranges)p+='<li data-range-key=\"'+c+'\">'+c+\"</li>\";this.showCustomRangeLabel&&(p+='<li data-range-key=\"'+this.locale.customRangeLabel+'\">'+this.locale.customRangeLabel+\"</li>\"),p+=\"</ul>\",this.container.find(\".ranges\").prepend(p)}\"function\"==typeof s&&(this.callback=s),this.timePicker||(this.startDate=this.startDate.startOf(\"day\"),this.endDate=this.endDate.endOf(\"day\"),this.container.find(\".calendar-time\").hide()),this.timePicker&&this.autoApply&&(this.autoApply=!1),this.autoApply&&\"object\"!=typeof i.ranges?this.container.find(\".ranges\").hide():this.autoApply&&this.container.find(\".applyBtn, .cancelBtn\").addClass(\"hide\"),this.singleDatePicker&&(this.container.addClass(\"single\"),this.container.find(\".calendar.left\").addClass(\"single\"),this.container.find(\".calendar.left\").show(),this.container.find(\".calendar.right\").hide(),this.container.find(\".daterangepicker_input input, .daterangepicker_input > i\").hide(),this.timePicker?this.container.find(\".ranges ul\").hide():this.container.find(\".ranges\").hide()),(void 0===i.ranges&&!this.singleDatePicker||this.alwaysShowCalendars)&&this.container.addClass(\"show-calendar\"),this.container.addClass(\"opens\"+this.opens),void 0!==i.ranges&&\"right\"==this.opens&&this.container.find(\".ranges\").prependTo(this.container.find(\".calendar.left\").parent()),this.container.find(\".applyBtn, .cancelBtn\").addClass(this.buttonClasses),this.applyClass.length&&this.container.find(\".applyBtn\").addClass(this.applyClass),this.cancelClass.length&&this.container.find(\".cancelBtn\").addClass(this.cancelClass),this.container.find(\".applyBtn\").html(this.locale.applyLabel),this.container.find(\".cancelBtn\").html(this.locale.cancelLabel),this.container.find(\".calendar\").on(\"click.daterangepicker\",\".prev\",e.proxy(this.clickPrev,this)).on(\"click.daterangepicker\",\".next\",e.proxy(this.clickNext,this)).on(\"mousedown.daterangepicker\",\"td.available\",e.proxy(this.clickDate,this)).on(\"mouseenter.daterangepicker\",\"td.available\",e.proxy(this.hoverDate,this)).on(\"mouseleave.daterangepicker\",\"td.available\",e.proxy(this.updateFormInputs,this)).on(\"change.daterangepicker\",\"select.yearselect\",e.proxy(this.monthOrYearChanged,this)).on(\"change.daterangepicker\",\"select.monthselect\",e.proxy(this.monthOrYearChanged,this)).on(\"change.daterangepicker\",\"select.hourselect,select.minuteselect,select.secondselect,select.ampmselect\",e.proxy(this.timeChanged,this)).on(\"click.daterangepicker\",\".daterangepicker_input input\",e.proxy(this.showCalendars,this)).on(\"focus.daterangepicker\",\".daterangepicker_input input\",e.proxy(this.formInputsFocused,this)).on(\"blur.daterangepicker\",\".daterangepicker_input input\",e.proxy(this.formInputsBlurred,this)).on(\"change.daterangepicker\",\".daterangepicker_input input\",e.proxy(this.formInputsChanged,this)),this.container.find(\".ranges\").on(\"click.daterangepicker\",\"button.applyBtn\",e.proxy(this.clickApply,this)).on(\"click.daterangepicker\",\"button.cancelBtn\",e.proxy(this.clickCancel,this)).on(\"click.daterangepicker\",\"li\",e.proxy(this.clickRange,this)).on(\"mouseenter.daterangepicker\",\"li\",e.proxy(this.hoverRange,this)).on(\"mouseleave.daterangepicker\",\"li\",e.proxy(this.updateFormInputs,this)),this.element.is(\"input\")||this.element.is(\"button\")?this.element.on({\"click.daterangepicker\":e.proxy(this.show,this),\"focus.daterangepicker\":e.proxy(this.show,this),\"keyup.daterangepicker\":e.proxy(this.elementChanged,this),\"keydown.daterangepicker\":e.proxy(this.keydown,this)}):this.element.on(\"click.daterangepicker\",e.proxy(this.toggle,this)),this.element.is(\"input\")&&!this.singleDatePicker&&this.autoUpdateInput?(this.element.val(this.startDate.format(this.locale.format)+this.locale.separator+this.endDate.format(this.locale.format)),this.element.trigger(\"change\")):this.element.is(\"input\")&&this.autoUpdateInput&&(this.element.val(this.startDate.format(this.locale.format)),this.element.trigger(\"change\"))};return a.prototype={constructor:a,setStartDate:function(e){\"string\"==typeof e&&(this.startDate=t(e,this.locale.format)),\"object\"==typeof e&&(this.startDate=t(e)),this.timePicker||(this.startDate=this.startDate.startOf(\"day\")),this.timePicker&&this.timePickerIncrement&&this.startDate.minute(Math.round(this.startDate.minute()/this.timePickerIncrement)*this.timePickerIncrement),this.minDate&&this.startDate.isBefore(this.minDate)&&(this.startDate=this.minDate.clone(),this.timePicker&&this.timePickerIncrement&&this.startDate.minute(Math.round(this.startDate.minute()/this.timePickerIncrement)*this.timePickerIncrement)),this.maxDate&&this.startDate.isAfter(this.maxDate)&&(this.startDate=this.maxDate.clone(),this.timePicker&&this.timePickerIncrement&&this.startDate.minute(Math.floor(this.startDate.minute()/this.timePickerIncrement)*this.timePickerIncrement)),this.isShowing||this.updateElement(),this.updateMonthsInView()},setEndDate:function(e){\"string\"==typeof e&&(this.endDate=t(e,this.locale.format)),\"object\"==typeof e&&(this.endDate=t(e)),this.timePicker||(this.endDate=this.endDate.endOf(\"day\")),this.timePicker&&this.timePickerIncrement&&this.endDate.minute(Math.round(this.endDate.minute()/this.timePickerIncrement)*this.timePickerIncrement),this.endDate.isBefore(this.startDate)&&(this.endDate=this.startDate.clone()),this.maxDate&&this.endDate.isAfter(this.maxDate)&&(this.endDate=this.maxDate.clone()),this.dateLimit&&this.startDate.clone().add(this.dateLimit).isBefore(this.endDate)&&(this.endDate=this.startDate.clone().add(this.dateLimit)),this.previousRightTime=this.endDate.clone(),this.isShowing||this.updateElement(),this.updateMonthsInView()},isInvalidDate:function(){return!1},isCustomDate:function(){return!1},updateView:function(){this.timePicker&&(this.renderTimePicker(\"left\"),this.renderTimePicker(\"right\"),this.endDate?this.container.find(\".right .calendar-time select\").removeAttr(\"disabled\").removeClass(\"disabled\"):this.container.find(\".right .calendar-time select\").attr(\"disabled\",\"disabled\").addClass(\"disabled\")),this.endDate?(this.container.find('input[name=\"daterangepicker_end\"]').removeClass(\"active\"),this.container.find('input[name=\"daterangepicker_start\"]').addClass(\"active\")):(this.container.find('input[name=\"daterangepicker_end\"]').addClass(\"active\"),this.container.find('input[name=\"daterangepicker_start\"]').removeClass(\"active\")),this.updateMonthsInView(),this.updateCalendars(),this.updateFormInputs()},updateMonthsInView:function(){if(this.endDate){if(!this.singleDatePicker&&this.leftCalendar.month&&this.rightCalendar.month&&(this.startDate.format(\"YYYY-MM\")==this.leftCalendar.month.format(\"YYYY-MM\")||this.startDate.format(\"YYYY-MM\")==this.rightCalendar.month.format(\"YYYY-MM\"))&&(this.endDate.format(\"YYYY-MM\")==this.leftCalendar.month.format(\"YYYY-MM\")||this.endDate.format(\"YYYY-MM\")==this.rightCalendar.month.format(\"YYYY-MM\")))return;this.leftCalendar.month=this.startDate.clone().date(2),this.linkedCalendars||this.endDate.month()==this.startDate.month()&&this.endDate.year()==this.startDate.year()?this.rightCalendar.month=this.startDate.clone().date(2).add(1,\"month\"):this.rightCalendar.month=this.endDate.clone().date(2)}else this.leftCalendar.month.format(\"YYYY-MM\")!=this.startDate.format(\"YYYY-MM\")&&this.rightCalendar.month.format(\"YYYY-MM\")!=this.startDate.format(\"YYYY-MM\")&&(this.leftCalendar.month=this.startDate.clone().date(2),this.rightCalendar.month=this.startDate.clone().date(2).add(1,\"month\"));this.maxDate&&this.linkedCalendars&&!this.singleDatePicker&&this.rightCalendar.month>this.maxDate&&(this.rightCalendar.month=this.maxDate.clone().date(2),this.leftCalendar.month=this.maxDate.clone().date(2).subtract(1,\"month\"))},updateCalendars:function(){if(this.timePicker){var t,e,a;if(this.endDate){if(t=parseInt(this.container.find(\".left .hourselect\").val(),10),e=parseInt(this.container.find(\".left .minuteselect\").val(),10),a=this.timePickerSeconds?parseInt(this.container.find(\".left .secondselect\").val(),10):0,!this.timePicker24Hour){var i=this.container.find(\".left .ampmselect\").val();\"PM\"===i&&t<12&&(t+=12),\"AM\"===i&&12===t&&(t=0)}}else if(t=parseInt(this.container.find(\".right .hourselect\").val(),10),e=parseInt(this.container.find(\".right .minuteselect\").val(),10),a=this.timePickerSeconds?parseInt(this.container.find(\".right .secondselect\").val(),10):0,!this.timePicker24Hour){var i=this.container.find(\".right .ampmselect\").val();\"PM\"===i&&t<12&&(t+=12),\"AM\"===i&&12===t&&(t=0)}this.leftCalendar.month.hour(t).minute(e).second(a),this.rightCalendar.month.hour(t).minute(e).second(a)}this.renderCalendar(\"left\"),this.renderCalendar(\"right\"),this.container.find(\".ranges li\").removeClass(\"active\"),null!=this.endDate&&this.calculateChosenLabel()},renderCalendar:function(a){var i=\"left\"==a?this.leftCalendar:this.rightCalendar,s=i.month.month(),n=i.month.year(),r=i.month.hour(),o=i.month.minute(),h=i.month.second(),l=t([n,s]).daysInMonth(),c=t([n,s,1]),d=t([n,s,l]),m=t(c).subtract(1,\"month\").month(),f=t(c).subtract(1,\"month\").year(),p=t([f,m]).daysInMonth(),u=c.day(),i=[];i.firstDay=c,i.lastDay=d;for(var g=0;g<6;g++)i[g]=[];var D=p-u+this.locale.firstDay+1;D>p&&(D-=7),u==this.locale.firstDay&&(D=p-6);for(var k,y,v=t([f,m,D,12,o,h]),g=0,k=0,y=0;g<42;g++,k++,v=t(v).add(24,\"hour\"))g>0&&k%7==0&&(k=0,y++),i[y][k]=v.clone().hour(r).minute(o).second(h),v.hour(12),this.minDate&&i[y][k].format(\"YYYY-MM-DD\")==this.minDate.format(\"YYYY-MM-DD\")&&i[y][k].isBefore(this.minDate)&&\"left\"==a&&(i[y][k]=this.minDate.clone()),this.maxDate&&i[y][k].format(\"YYYY-MM-DD\")==this.maxDate.format(\"YYYY-MM-DD\")&&i[y][k].isAfter(this.maxDate)&&\"right\"==a&&(i[y][k]=this.maxDate.clone());\"left\"==a?this.leftCalendar.calendar=i:this.rightCalendar.calendar=i;var b=\"left\"==a?this.minDate:this.startDate,C=this.maxDate,w=(\"left\"==a?this.startDate:this.endDate,\"ltr\"==this.locale.direction?{left:\"chevron-left\",right:\"chevron-right\"}:{left:\"chevron-right\",right:\"chevron-left\"}),Y='<table class=\"table-condensed\">';Y+=\"<thead>\",Y+=\"<tr>\",(this.showWeekNumbers||this.showISOWeekNumbers)&&(Y+=\"<th></th>\"),b&&!b.isBefore(i.firstDay)||this.linkedCalendars&&\"left\"!=a?Y+=\"<th></th>\":Y+='<th class=\"prev available\"><i class=\"fa fa-'+w.left+\" glyphicon glyphicon-\"+w.left+'\"></i></th>';var P=this.locale.monthNames[i[1][1].month()]+i[1][1].format(\" YYYY\");if(this.showDropdowns){for(var M=i[1][1].month(),x=i[1][1].year(),I=C&&C.year()||x+5,L=b&&b.year()||x-50,S=x==L,A=x==I,_='<select class=\"monthselect\">',B=0;B<12;B++)(!S||B>=b.month())&&(!A||B<=C.month())?_+=\"<option value='\"+B+\"'\"+(B===M?\" selected='selected'\":\"\")+\">\"+this.locale.monthNames[B]+\"</option>\":_+=\"<option value='\"+B+\"'\"+(B===M?\" selected='selected'\":\"\")+\" disabled='disabled'>\"+this.locale.monthNames[B]+\"</option>\";_+=\"</select>\";for(var E='<select class=\"yearselect\">',W=L;W<=I;W++)E+='<option value=\"'+W+'\"'+(W===x?' selected=\"selected\"':\"\")+\">\"+W+\"</option>\";E+=\"</select>\",P=_+E}if(Y+='<th colspan=\"5\" class=\"month\">'+P+\"</th>\",C&&!C.isAfter(i.lastDay)||this.linkedCalendars&&\"right\"!=a&&!this.singleDatePicker?Y+=\"<th></th>\":Y+='<th class=\"next available\"><i class=\"fa fa-'+w.right+\" glyphicon glyphicon-\"+w.right+'\"></i></th>',Y+=\"</tr>\",Y+=\"<tr>\",(this.showWeekNumbers||this.showISOWeekNumbers)&&(Y+='<th class=\"week\">'+this.locale.weekLabel+\"</th>\"),e.each(this.locale.daysOfWeek,function(t,e){Y+=\"<th>\"+e+\"</th>\"}),Y+=\"</tr>\",Y+=\"</thead>\",Y+=\"<tbody>\",null==this.endDate&&this.dateLimit){var O=this.startDate.clone().add(this.dateLimit).endOf(\"day\");C&&!O.isBefore(C)||(C=O)}for(var y=0;y<6;y++){Y+=\"<tr>\",this.showWeekNumbers?Y+='<td class=\"week\">'+i[y][0].week()+\"</td>\":this.showISOWeekNumbers&&(Y+='<td class=\"week\">'+i[y][0].isoWeek()+\"</td>\");for(var k=0;k<7;k++){var N=[];i[y][k].isSame(new Date,\"day\")&&N.push(\"today\"),i[y][k].isoWeekday()>5&&N.push(\"weekend\"),i[y][k].month()!=i[1][1].month()&&N.push(\"off\"),this.minDate&&i[y][k].isBefore(this.minDate,\"day\")&&N.push(\"off\",\"disabled\"),C&&i[y][k].isAfter(C,\"day\")&&N.push(\"off\",\"disabled\"),this.isInvalidDate(i[y][k])&&N.push(\"off\",\"disabled\"),i[y][k].format(\"YYYY-MM-DD\")==this.startDate.format(\"YYYY-MM-DD\")&&N.push(\"active\",\"start-date\"),null!=this.endDate&&i[y][k].format(\"YYYY-MM-DD\")==this.endDate.format(\"YYYY-MM-DD\")&&N.push(\"active\",\"end-date\"),null!=this.endDate&&i[y][k]>this.startDate&&i[y][k]<this.endDate&&N.push(\"in-range\");var R=this.isCustomDate(i[y][k]);!1!==R&&(\"string\"==typeof R?N.push(R):Array.prototype.push.apply(N,R));for(var j=\"\",H=!1,g=0;g<N.length;g++)j+=N[g]+\" \",\"disabled\"==N[g]&&(H=!0);H||(j+=\"available\"),Y+='<td class=\"'+j.replace(/^\\s+|\\s+$/g,\"\")+'\" data-title=\"r'+y+\"c\"+k+'\">'+i[y][k].date()+\"</td>\"}Y+=\"</tr>\"}Y+=\"</tbody>\",Y+=\"</table>\",this.container.find(\".calendar.\"+a+\" .calendar-table\").html(Y)},renderTimePicker:function(t){if(\"right\"!=t||this.endDate){var e,a,i,s=this.maxDate;if(!this.dateLimit||this.maxDate&&!this.startDate.clone().add(this.dateLimit).isAfter(this.maxDate)||(s=this.startDate.clone().add(this.dateLimit)),\"left\"==t)a=this.startDate.clone(),i=this.minDate;else if(\"right\"==t){a=this.endDate.clone(),i=this.startDate;var n=this.container.find(\".calendar.right .calendar-time div\");if(\"\"!=n.html()&&(a.hour(n.find(\".hourselect option:selected\").val()||a.hour()),a.minute(n.find(\".minuteselect option:selected\").val()||a.minute()),a.second(n.find(\".secondselect option:selected\").val()||a.second()),!this.timePicker24Hour)){var r=n.find(\".ampmselect option:selected\").val();\"PM\"===r&&a.hour()<12&&a.hour(a.hour()+12),\"AM\"===r&&12===a.hour()&&a.hour(0)}a.isBefore(this.startDate)&&(a=this.startDate.clone()),s&&a.isAfter(s)&&(a=s.clone())}e='<select class=\"hourselect\">';for(var o=this.timePicker24Hour?0:1,h=this.timePicker24Hour?23:12,l=o;l<=h;l++){var c=l;this.timePicker24Hour||(c=a.hour()>=12?12==l?12:l+12:12==l?0:l);var d=a.clone().hour(c),m=!1;i&&d.minute(59).isBefore(i)&&(m=!0),s&&d.minute(0).isAfter(s)&&(m=!0),c!=a.hour()||m?e+=m?'<option value=\"'+l+'\" disabled=\"disabled\" class=\"disabled\">'+l+\"</option>\":'<option value=\"'+l+'\">'+l+\"</option>\":e+='<option value=\"'+l+'\" selected=\"selected\">'+l+\"</option>\"}e+=\"</select> \",e+=': <select class=\"minuteselect\">';for(var l=0;l<60;l+=this.timePickerIncrement){var f=l<10?\"0\"+l:l,d=a.clone().minute(l),m=!1;i&&d.second(59).isBefore(i)&&(m=!0),s&&d.second(0).isAfter(s)&&(m=!0),a.minute()!=l||m?e+=m?'<option value=\"'+l+'\" disabled=\"disabled\" class=\"disabled\">'+f+\"</option>\":'<option value=\"'+l+'\">'+f+\"</option>\":e+='<option value=\"'+l+'\" selected=\"selected\">'+f+\"</option>\"}if(e+=\"</select> \",this.timePickerSeconds){e+=': <select class=\"secondselect\">';for(var l=0;l<60;l++){var f=l<10?\"0\"+l:l,d=a.clone().second(l),m=!1;i&&d.isBefore(i)&&(m=!0),s&&d.isAfter(s)&&(m=!0),a.second()!=l||m?e+=m?'<option value=\"'+l+'\" disabled=\"disabled\" class=\"disabled\">'+f+\"</option>\":'<option value=\"'+l+'\">'+f+\"</option>\":e+='<option value=\"'+l+'\" selected=\"selected\">'+f+\"</option>\"}e+=\"</select> \"}if(!this.timePicker24Hour){e+='<select class=\"ampmselect\">';var p=\"\",u=\"\";i&&a.clone().hour(12).minute(0).second(0).isBefore(i)&&(p=' disabled=\"disabled\" class=\"disabled\"'),s&&a.clone().hour(0).minute(0).second(0).isAfter(s)&&(u=' disabled=\"disabled\" class=\"disabled\"'),a.hour()>=12?e+='<option value=\"AM\"'+p+'>AM</option><option value=\"PM\" selected=\"selected\"'+u+\">PM</option>\":e+='<option value=\"AM\" selected=\"selected\"'+p+'>AM</option><option value=\"PM\"'+u+\">PM</option>\",e+=\"</select>\"}this.container.find(\".calendar.\"+t+\" .calendar-time div\").html(e)}},updateFormInputs:function(){this.container.find(\"input[name=daterangepicker_start]\").is(\":focus\")||this.container.find(\"input[name=daterangepicker_end]\").is(\":focus\")||(this.container.find(\"input[name=daterangepicker_start]\").val(this.startDate.format(this.locale.format)),this.endDate&&this.container.find(\"input[name=daterangepicker_end]\").val(this.endDate.format(this.locale.format)),this.singleDatePicker||this.endDate&&(this.startDate.isBefore(this.endDate)||this.startDate.isSame(this.endDate))?this.container.find(\"button.applyBtn\").removeAttr(\"disabled\"):this.container.find(\"button.applyBtn\").attr(\"disabled\",\"disabled\"))},move:function(){var t,a={top:0,left:0},i=e(window).width();this.parentEl.is(\"body\")||(a={top:this.parentEl.offset().top-this.parentEl.scrollTop(),left:this.parentEl.offset().left-this.parentEl.scrollLeft()},i=this.parentEl[0].clientWidth+this.parentEl.offset().left),t=\"up\"==this.drops?this.element.offset().top-this.container.outerHeight()-a.top:this.element.offset().top+this.element.outerHeight()-a.top,this.container[\"up\"==this.drops?\"addClass\":\"removeClass\"](\"dropup\"),\"left\"==this.opens?(this.container.css({top:t,right:i-this.element.offset().left-this.element.outerWidth(),left:\"auto\"}),this.container.offset().left<0&&this.container.css({right:\"auto\",left:9})):\"center\"==this.opens?(this.container.css({top:t,left:this.element.offset().left-a.left+this.element.outerWidth()/2-this.container.outerWidth()/2,right:\"auto\"}),this.container.offset().left<0&&this.container.css({right:\"auto\",left:9})):(this.container.css({top:t,left:this.element.offset().left-a.left,right:\"auto\"}),this.container.offset().left+this.container.outerWidth()>e(window).width()&&this.container.css({left:\"auto\",right:0}))},show:function(t){this.isShowing||(this._outsideClickProxy=e.proxy(function(t){this.outsideClick(t)},this),e(document).on(\"mousedown.daterangepicker\",this._outsideClickProxy).on(\"touchend.daterangepicker\",this._outsideClickProxy).on(\"click.daterangepicker\",\"[data-toggle=dropdown]\",this._outsideClickProxy).on(\"focusin.daterangepicker\",this._outsideClickProxy),e(window).on(\"resize.daterangepicker\",e.proxy(function(t){this.move(t)},this)),this.oldStartDate=this.startDate.clone(),this.oldEndDate=this.endDate.clone(),this.previousRightTime=this.endDate.clone(),this.updateView(),this.container.show(),this.move(),this.element.trigger(\"show.daterangepicker\",this),this.isShowing=!0)},hide:function(t){this.isShowing&&(this.endDate||(this.startDate=this.oldStartDate.clone(),this.endDate=this.oldEndDate.clone()),this.startDate.isSame(this.oldStartDate)&&this.endDate.isSame(this.oldEndDate)||this.callback(this.startDate,this.endDate,this.chosenLabel),this.updateElement(),e(document).off(\".daterangepicker\"),e(window).off(\".daterangepicker\"),this.container.hide(),this.element.trigger(\"hide.daterangepicker\",this),this.isShowing=!1)},toggle:function(t){this.isShowing?this.hide():this.show()},outsideClick:function(t){var a=e(t.target);\"focusin\"==t.type||a.closest(this.element).length||a.closest(this.container).length||a.closest(\".calendar-table\").length||(this.hide(),this.element.trigger(\"outsideClick.daterangepicker\",this))},showCalendars:function(){this.container.addClass(\"show-calendar\"),this.move(),this.element.trigger(\"showCalendar.daterangepicker\",this)},hideCalendars:function(){this.container.removeClass(\"show-calendar\"),this.element.trigger(\"hideCalendar.daterangepicker\",this)},hoverRange:function(t){if(!this.container.find(\"input[name=daterangepicker_start]\").is(\":focus\")&&!this.container.find(\"input[name=daterangepicker_end]\").is(\":focus\")){var e=t.target.getAttribute(\"data-range-key\");if(e==this.locale.customRangeLabel)this.updateView();else{var a=this.ranges[e];this.container.find(\"input[name=daterangepicker_start]\").val(a[0].format(this.locale.format)),this.container.find(\"input[name=daterangepicker_end]\").val(a[1].format(this.locale.format))}}},clickRange:function(t){var e=t.target.getAttribute(\"data-range-key\");if(this.chosenLabel=e,e==this.locale.customRangeLabel)this.showCalendars();else{var a=this.ranges[e];this.startDate=a[0],this.endDate=a[1],this.timePicker||(this.startDate.startOf(\"day\"),this.endDate.endOf(\"day\")),this.alwaysShowCalendars||this.hideCalendars(),this.clickApply()}},clickPrev:function(t){e(t.target).parents(\".calendar\").hasClass(\"left\")?(this.leftCalendar.month.subtract(1,\"month\"),this.linkedCalendars&&this.rightCalendar.month.subtract(1,\"month\")):this.rightCalendar.month.subtract(1,\"month\"),this.updateCalendars()},clickNext:function(t){e(t.target).parents(\".calendar\").hasClass(\"left\")?this.leftCalendar.month.add(1,\"month\"):(this.rightCalendar.month.add(1,\"month\"),this.linkedCalendars&&this.leftCalendar.month.add(1,\"month\")),this.updateCalendars()},hoverDate:function(t){if(e(t.target).hasClass(\"available\")){var a=e(t.target).attr(\"data-title\"),i=a.substr(1,1),s=a.substr(3,1),n=e(t.target).parents(\".calendar\"),r=n.hasClass(\"left\")?this.leftCalendar.calendar[i][s]:this.rightCalendar.calendar[i][s];this.endDate&&!this.container.find(\"input[name=daterangepicker_start]\").is(\":focus\")?this.container.find(\"input[name=daterangepicker_start]\").val(r.format(this.locale.format)):this.endDate||this.container.find(\"input[name=daterangepicker_end]\").is(\":focus\")||this.container.find(\"input[name=daterangepicker_end]\").val(r.format(this.locale.format));var o=this.leftCalendar,h=this.rightCalendar,l=this.startDate;this.endDate||this.container.find(\".calendar tbody td\").each(function(t,a){if(!e(a).hasClass(\"week\")){var i=e(a).attr(\"data-title\"),s=i.substr(1,1),n=i.substr(3,1),c=e(a).parents(\".calendar\"),d=c.hasClass(\"left\")?o.calendar[s][n]:h.calendar[s][n];d.isAfter(l)&&d.isBefore(r)||d.isSame(r,\"day\")?e(a).addClass(\"in-range\"):e(a).removeClass(\"in-range\")}})}},clickDate:function(t){if(e(t.target).hasClass(\"available\")){var a=e(t.target).attr(\"data-title\"),i=a.substr(1,1),s=a.substr(3,1),n=e(t.target).parents(\".calendar\"),r=n.hasClass(\"left\")?this.leftCalendar.calendar[i][s]:this.rightCalendar.calendar[i][s];if(this.endDate||r.isBefore(this.startDate,\"day\")){if(this.timePicker){var o=parseInt(this.container.find(\".left .hourselect\").val(),10);if(!this.timePicker24Hour){var h=this.container.find(\".left .ampmselect\").val();\"PM\"===h&&o<12&&(o+=12),\"AM\"===h&&12===o&&(o=0)}var l=parseInt(this.container.find(\".left .minuteselect\").val(),10),c=this.timePickerSeconds?parseInt(this.container.find(\".left .secondselect\").val(),10):0;r=r.clone().hour(o).minute(l).second(c)}this.endDate=null,this.setStartDate(r.clone())}else if(!this.endDate&&r.isBefore(this.startDate))this.setEndDate(this.startDate.clone());else{if(this.timePicker){var o=parseInt(this.container.find(\".right .hourselect\").val(),10);if(!this.timePicker24Hour){var h=this.container.find(\".right .ampmselect\").val();\"PM\"===h&&o<12&&(o+=12),\"AM\"===h&&12===o&&(o=0)}var l=parseInt(this.container.find(\".right .minuteselect\").val(),10),c=this.timePickerSeconds?parseInt(this.container.find(\".right .secondselect\").val(),10):0;r=r.clone().hour(o).minute(l).second(c)}this.setEndDate(r.clone()),this.autoApply&&(this.calculateChosenLabel(),this.clickApply())}this.singleDatePicker&&(this.setEndDate(this.startDate),this.timePicker||this.clickApply()),this.updateView(),t.stopPropagation()}},calculateChosenLabel:function(){var t=!0,e=0;for(var a in this.ranges){if(this.timePicker){if(this.startDate.isSame(this.ranges[a][0])&&this.endDate.isSame(this.ranges[a][1])){t=!1,this.chosenLabel=this.container.find(\".ranges li:eq(\"+e+\")\").addClass(\"active\").html();break}}else if(this.startDate.format(\"YYYY-MM-DD\")==this.ranges[a][0].format(\"YYYY-MM-DD\")&&this.endDate.format(\"YYYY-MM-DD\")==this.ranges[a][1].format(\"YYYY-MM-DD\")){t=!1,this.chosenLabel=this.container.find(\".ranges li:eq(\"+e+\")\").addClass(\"active\").html();break}e++}t&&(this.showCustomRangeLabel?this.chosenLabel=this.container.find(\".ranges li:last\").addClass(\"active\").html():this.chosenLabel=null,this.showCalendars())},clickApply:function(t){this.hide(),this.element.trigger(\"apply.daterangepicker\",this)},clickCancel:function(t){this.startDate=this.oldStartDate,this.endDate=this.oldEndDate,this.hide(),this.element.trigger(\"cancel.daterangepicker\",this)},monthOrYearChanged:function(t){var a=e(t.target).closest(\".calendar\").hasClass(\"left\"),i=a?\"left\":\"right\",s=this.container.find(\".calendar.\"+i),n=parseInt(s.find(\".monthselect\").val(),10),r=s.find(\".yearselect\").val();a||(r<this.startDate.year()||r==this.startDate.year()&&n<this.startDate.month())&&(n=this.startDate.month(),r=this.startDate.year()),this.minDate&&(r<this.minDate.year()||r==this.minDate.year()&&n<this.minDate.month())&&(n=this.minDate.month(),r=this.minDate.year()),this.maxDate&&(r>this.maxDate.year()||r==this.maxDate.year()&&n>this.maxDate.month())&&(n=this.maxDate.month(),r=this.maxDate.year()),a?(this.leftCalendar.month.month(n).year(r),this.linkedCalendars&&(this.rightCalendar.month=this.leftCalendar.month.clone().add(1,\"month\"))):(this.rightCalendar.month.month(n).year(r),this.linkedCalendars&&(this.leftCalendar.month=this.rightCalendar.month.clone().subtract(1,\"month\"))),this.updateCalendars()},timeChanged:function(t){var a=e(t.target).closest(\".calendar\"),i=a.hasClass(\"left\"),s=parseInt(a.find(\".hourselect\").val(),10),n=parseInt(a.find(\".minuteselect\").val(),10),r=this.timePickerSeconds?parseInt(a.find(\".secondselect\").val(),10):0;if(!this.timePicker24Hour){\nvar o=a.find(\".ampmselect\").val();\"PM\"===o&&s<12&&(s+=12),\"AM\"===o&&12===s&&(s=0)}if(i){var h=this.startDate.clone();h.hour(s),h.minute(n),h.second(r),this.setStartDate(h),this.singleDatePicker?this.endDate=this.startDate.clone():this.endDate&&this.endDate.format(\"YYYY-MM-DD\")==h.format(\"YYYY-MM-DD\")&&this.endDate.isBefore(h)&&this.setEndDate(h.clone())}else if(this.endDate){var l=this.endDate.clone();l.hour(s),l.minute(n),l.second(r),this.setEndDate(l)}this.updateCalendars(),this.updateFormInputs(),this.renderTimePicker(\"left\"),this.renderTimePicker(\"right\")},formInputsChanged:function(a){var i=e(a.target).closest(\".calendar\").hasClass(\"right\"),s=t(this.container.find('input[name=\"daterangepicker_start\"]').val(),this.locale.format),n=t(this.container.find('input[name=\"daterangepicker_end\"]').val(),this.locale.format);s.isValid()&&n.isValid()&&(i&&n.isBefore(s)&&(s=n.clone()),this.setStartDate(s),this.setEndDate(n),i?this.container.find('input[name=\"daterangepicker_start\"]').val(this.startDate.format(this.locale.format)):this.container.find('input[name=\"daterangepicker_end\"]').val(this.endDate.format(this.locale.format))),this.updateView()},formInputsFocused:function(t){this.container.find('input[name=\"daterangepicker_start\"], input[name=\"daterangepicker_end\"]').removeClass(\"active\"),e(t.target).addClass(\"active\"),e(t.target).closest(\".calendar\").hasClass(\"right\")&&(this.endDate=null,this.setStartDate(this.startDate.clone()),this.updateView())},formInputsBlurred:function(e){if(!this.endDate){var a=this.container.find('input[name=\"daterangepicker_end\"]').val(),i=t(a,this.locale.format);i.isValid()&&(this.setEndDate(i),this.updateView())}},elementChanged:function(){if(this.element.is(\"input\")&&this.element.val().length&&!(this.element.val().length<this.locale.format.length)){var e=this.element.val().split(this.locale.separator),a=null,i=null;2===e.length&&(a=t(e[0],this.locale.format),i=t(e[1],this.locale.format)),(this.singleDatePicker||null===a||null===i)&&(a=t(this.element.val(),this.locale.format),i=a),a.isValid()&&i.isValid()&&(this.setStartDate(a),this.setEndDate(i),this.updateView())}},keydown:function(t){9!==t.keyCode&&13!==t.keyCode||this.hide()},updateElement:function(){this.element.is(\"input\")&&!this.singleDatePicker&&this.autoUpdateInput?(this.element.val(this.startDate.format(this.locale.format)+this.locale.separator+this.endDate.format(this.locale.format)),this.element.trigger(\"change\")):this.element.is(\"input\")&&this.autoUpdateInput&&(this.element.val(this.startDate.format(this.locale.format)),this.element.trigger(\"change\"))},remove:function(){this.container.remove(),this.element.off(\".daterangepicker\"),this.element.removeData()}},e.fn.daterangepicker=function(t,i){return this.each(function(){var s=e(this);s.data(\"daterangepicker\")&&s.data(\"daterangepicker\").remove(),s.data(\"daterangepicker\",new a(s,t,i))}),this},a});"

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */,
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(135))

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	module.exports = "\"use strict\";var _typeof=\"function\"==typeof Symbol&&\"symbol\"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&\"function\"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?\"symbol\":typeof e};!function(e,t){if(\"function\"==typeof define&&define.amd)define(function(){return t(e)});else if(\"object\"===(\"undefined\"==typeof module?\"undefined\":_typeof(module))&&\"object\"===_typeof(module.exports))module.exports=t(e);else{var n=!e.Nette||!e.Nette.noInit;e.Nette=t(e),n&&e.Nette.initOnLoad()}}(\"undefined\"!=typeof window?window:void 0,function(window){var Nette={version:\"2.3\"};return Nette.addEvent=function(e,t,n){var r=e[\"on\"+t];e[\"on\"+t]=function(){return(\"function\"!=typeof r||!1!==r.apply(e,arguments))&&n.apply(e,arguments)}},Nette.getValue=function(e){var t;if(e){if(e.tagName){if(\"radio\"===e.type){var n=e.form.elements;for(t=0;t<n.length;t++)if(n[t].name===e.name&&n[t].checked)return n[t].value;return null}if(\"file\"===e.type)return e.files||e.value;if(\"select\"===e.tagName.toLowerCase()){var r=e.selectedIndex,a=e.options,i=[];if(\"select-one\"===e.type)return r<0?null:a[r].value;for(t=0;t<a.length;t++)a[t].selected&&i.push(a[t].value);return i}if(e.name&&e.name.match(/\\[\\]$/)){var n=e.form.elements[e.name].tagName?[e]:e.form.elements[e.name],i=[];for(t=0;t<n.length;t++)(\"checkbox\"!==n[t].type||n[t].checked)&&i.push(n[t].value);return i}return\"checkbox\"===e.type?e.checked:\"textarea\"===e.tagName.toLowerCase()?e.value.replace(\"\\r\",\"\"):e.value.replace(\"\\r\",\"\").replace(/^\\s+|\\s+$/g,\"\")}return e[0]?Nette.getValue(e[0]):null}return null},Nette.getEffectiveValue=function(e){var t=Nette.getValue(e);return e.getAttribute&&t===e.getAttribute(\"data-nette-empty-value\")&&(t=\"\"),t},Nette.validateControl=function(e,t,n,r,a){e=e.tagName?e:e[0],t=t||Nette.parseJSON(e.getAttribute(\"data-nette-rules\")),r=void 0===r?{value:Nette.getEffectiveValue(e)}:r;for(var i=0,u=t.length;i<u;i++){var l=t[i],o=l.op.match(/(~)?([^?]+)/),f=l.control?e.form.elements.namedItem(l.control):e;if(l.neg=o[1],l.op=o[2],l.condition=!!l.rules,f)if(\"optional\"!==l.op){if(!a||l.condition||\":filled\"===l.op){f=f.tagName?f:f[0];var d=e===f?r:{value:Nette.getEffectiveValue(f)},c=Nette.validateRule(f,l.op,l.arg,d);if(null!==c)if(l.neg&&(c=!c),l.condition&&c){if(!Nette.validateControl(e,l.rules,n,r,\":blank\"!==l.op&&a))return!1}else if(!l.condition&&!c){if(Nette.isDisabled(f))continue;if(!n){var s=Nette.isArray(l.arg)?l.arg:[l.arg],g=l.msg.replace(/%(value|\\d+)/g,function(t,n){return Nette.getValue(\"value\"===n?f:e.form.elements.namedItem(s[n].control))});Nette.addError(f,g)}return!1}}}else a=!Nette.validateRule(e,\":filled\",null,r)}return!(\"number\"===e.type&&!e.validity.valid)||(n||Nette.addError(e,\"Please enter a valid value.\"),!1)},Nette.validateForm=function(e){var t=e.form||e,n=!1;if(t[\"nette-submittedBy\"]&&null!==t[\"nette-submittedBy\"].getAttribute(\"formnovalidate\")){var r=Nette.parseJSON(t[\"nette-submittedBy\"].getAttribute(\"data-nette-validation-scope\"));if(!r.length)return!0;n=new RegExp(\"^(\"+r.join(\"-|\")+\"-)\")}var a,i,u={};for(a=0;a<t.elements.length;a++)if(i=t.elements[a],!i.tagName||i.tagName.toLowerCase()in{input:1,select:1,textarea:1,button:1}){if(\"radio\"===i.type){if(u[i.name])continue;u[i.name]=!0}if(!(n&&!i.name.replace(/]\\[|\\[|]|$/g,\"-\").match(n)||Nette.isDisabled(i)||Nette.validateControl(i)))return!1}return!0},Nette.isDisabled=function(e){if(\"radio\"===e.type){for(var t=0,n=e.form.elements;t<n.length;t++)if(n[t].name===e.name&&!n[t].disabled)return!1;return!0}return e.disabled},Nette.addError=function(e,t){t&&alert(t),e.focus&&e.focus()},Nette.expandRuleArgument=function(e,t){return t&&t.control&&(t=Nette.getEffectiveValue(e.elements.namedItem(t.control))),t},Nette.validateRule=function(e,t,n,r){r=void 0===r?{value:Nette.getEffectiveValue(e)}:r,\":\"===t.charAt(0)&&(t=t.substr(1)),t=t.replace(\"::\",\"_\"),t=t.replace(/\\\\/g,\"\");for(var a=Nette.isArray(n)?n.slice(0):[n],i=0,u=a.length;i<u;i++)a[i]=Nette.expandRuleArgument(e.form,a[i]);return Nette.validators[t]?Nette.validators[t](e,Nette.isArray(n)?a:a[0],r.value,r):null},Nette.validators={filled:function(e,t,n){return!(\"number\"!==e.type||!e.validity.badInput)||\"\"!==n&&!1!==n&&null!==n&&(!Nette.isArray(n)||!!n.length)&&(!window.FileList||!(n instanceof window.FileList)||n.length)},blank:function(e,t,n){return!Nette.validators.filled(e,t,n)},valid:function(e,t,n){return Nette.validateControl(e,null,!0)},equal:function(e,t,n){function r(e){return\"number\"==typeof e||\"string\"==typeof e?\"\"+e:!0===e?\"1\":\"\"}if(void 0===t)return null;n=Nette.isArray(n)?n:[n],t=Nette.isArray(t)?t:[t];e:for(var a=0,i=n.length;a<i;a++){for(var u=0,l=t.length;u<l;u++)if(r(n[a])===r(t[u]))continue e;return!1}return!0},notEqual:function(e,t,n){return void 0===t?null:!Nette.validators.equal(e,t,n)},minLength:function(e,t,n){if(\"number\"===e.type){if(e.validity.tooShort)return!1;if(e.validity.badInput)return null}return n.length>=t},maxLength:function(e,t,n){if(\"number\"===e.type){if(e.validity.tooLong)return!1;if(e.validity.badInput)return null}return n.length<=t},length:function(e,t,n){if(\"number\"===e.type){if(e.validity.tooShort||e.validity.tooLong)return!1;if(e.validity.badInput)return null}return t=Nette.isArray(t)?t:[t,t],(null===t[0]||n.length>=t[0])&&(null===t[1]||n.length<=t[1])},email:function(e,t,n){return/^(\"([ !#-[\\]-~]|\\\\[ -~])+\"|[-a-z0-9!#$%&'*+\\/=?^_`{|}~]+(\\.[-a-z0-9!#$%&'*+\\/=?^_`{|}~]+)*)@([0-9a-z\\u00C0-\\u02FF\\u0370-\\u1EFF]([-0-9a-z\\u00C0-\\u02FF\\u0370-\\u1EFF]{0,61}[0-9a-z\\u00C0-\\u02FF\\u0370-\\u1EFF])?\\.)+[a-z\\u00C0-\\u02FF\\u0370-\\u1EFF]([-0-9a-z\\u00C0-\\u02FF\\u0370-\\u1EFF]{0,17}[a-z\\u00C0-\\u02FF\\u0370-\\u1EFF])?$/i.test(n)},url:function(e,t,n,r){return/^[a-z\\d+.-]+:/.test(n)||(n=\"http://\"+n),!!/^https?:\\/\\/((([-_0-9a-z\\u00C0-\\u02FF\\u0370-\\u1EFF]+\\.)*[0-9a-z\\u00C0-\\u02FF\\u0370-\\u1EFF]([-0-9a-z\\u00C0-\\u02FF\\u0370-\\u1EFF]{0,61}[0-9a-z\\u00C0-\\u02FF\\u0370-\\u1EFF])?\\.)?[a-z\\u00C0-\\u02FF\\u0370-\\u1EFF]([-0-9a-z\\u00C0-\\u02FF\\u0370-\\u1EFF]{0,17}[a-z\\u00C0-\\u02FF\\u0370-\\u1EFF])?|\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}|\\[[0-9a-f:]{3,39}\\])(:\\d{1,5})?(\\/\\S*)?$/i.test(n)&&(r.value=n,!0)},regexp:function(e,t,n){var r=\"string\"==typeof t&&t.match(/^\\/(.*)\\/([imu]*)$/);try{return r&&new RegExp(r[1],r[2].replace(\"u\",\"\")).test(n)}catch(e){}},pattern:function(e,t,n){try{return\"string\"==typeof t?new RegExp(\"^(?:\"+t+\")$\").test(n):null}catch(e){}},integer:function(e,t,n){return(\"number\"!==e.type||!e.validity.badInput)&&/^-?[0-9]+$/.test(n)},float:function(e,t,n,r){return(\"number\"!==e.type||!e.validity.badInput)&&(n=n.replace(\" \",\"\").replace(\",\",\".\"),!!/^-?[0-9]*[.,]?[0-9]+$/.test(n)&&(r.value=n,!0))},min:function(e,t,n){if(\"number\"===e.type){if(e.validity.rangeUnderflow)return!1;if(e.validity.badInput)return null}return null===t||parseFloat(n)>=t},max:function(e,t,n){if(\"number\"===e.type){if(e.validity.rangeOverflow)return!1;if(e.validity.badInput)return null}return null===t||parseFloat(n)<=t},range:function(e,t,n){if(\"number\"===e.type){if(e.validity.rangeUnderflow||e.validity.rangeOverflow)return!1;if(e.validity.badInput)return null}return Nette.isArray(t)?(null===t[0]||parseFloat(n)>=t[0])&&(null===t[1]||parseFloat(n)<=t[1]):null},submitted:function(e,t,n){return e.form[\"nette-submittedBy\"]===e},fileSize:function(e,t,n){if(window.FileList)for(var r=0;r<n.length;r++)if(n[r].size>t)return!1;return!0},image:function(e,t,n){if(window.FileList&&n instanceof window.FileList)for(var r=0;r<n.length;r++){var a=n[r].type;if(a&&\"image/gif\"!==a&&\"image/png\"!==a&&\"image/jpeg\"!==a)return!1}return!0}},Nette.toggleForm=function(e,t){var n;for(Nette.toggles={},n=0;n<e.elements.length;n++)e.elements[n].tagName.toLowerCase()in{input:1,select:1,textarea:1,button:1}&&Nette.toggleControl(e.elements[n],null,null,!t);for(n in Nette.toggles)Nette.toggle(n,Nette.toggles[n],t)},Nette.toggleControl=function(e,t,n,r,a){t=t||Nette.parseJSON(e.getAttribute(\"data-nette-rules\")),a=void 0===a?{value:Nette.getEffectiveValue(e)}:a;for(var i,u=!1,l=[],o=function(){Nette.toggleForm(e.form,e)},f=0,d=t.length;f<d;f++){var c=t[f],s=c.op.match(/(~)?([^?]+)/),g=c.control?e.form.elements.namedItem(c.control):e;if(g){if(i=n,!1!==n){c.neg=s[1],c.op=s[2];var m=e===g?a:{value:Nette.getEffectiveValue(g)};if(null===(i=Nette.validateRule(g,c.op,c.arg,m)))continue;c.neg&&(i=!i),c.rules||(n=i)}if(c.rules&&Nette.toggleControl(e,c.rules,i,r,a)||c.toggle){if(u=!0,r)for(var v=!document.addEventListener,p=g.tagName?g.name:g[0].name,N=g.tagName?g.form.elements:g,y=0;y<N.length;y++)N[y].name!==p||Nette.inArray(l,N[y])||(Nette.addEvent(N[y],v&&N[y].type in{checkbox:1,radio:1}?\"click\":\"change\",o),l.push(N[y]));for(var b in c.toggle||[])Object.prototype.hasOwnProperty.call(c.toggle,b)&&(Nette.toggles[b]=Nette.toggles[b]||(c.toggle[b]?i:!i))}}}return u},Nette.parseJSON=function(s){return s=s||\"[]\",\"{op\"===s.substr(0,3)?eval(\"[\"+s+\"]\"):window.JSON&&window.JSON.parse?JSON.parse(s):eval(s)},Nette.toggle=function(e,t,n){var r=document.getElementById(e);r&&(r.style.display=t?\"\":\"none\")},Nette.initForm=function(e){e.noValidate=\"novalidate\",Nette.addEvent(e,\"submit\",function(t){if(!Nette.validateForm(e))return t&&t.stopPropagation?t.stopPropagation():window.event&&(event.cancelBubble=!0),!1}),Nette.addEvent(e,\"click\",function(t){t=t||event;var n=t.target||t.srcElement;e[\"nette-submittedBy\"]=n.type in{submit:1,image:1}?n:null}),Nette.toggleForm(e)},Nette.initOnLoad=function(){Nette.addEvent(window,\"load\",function(){for(var e=0;e<document.forms.length;e++)for(var t=document.forms[e],n=0;n<t.elements.length;n++)if(t.elements[n].getAttribute(\"data-nette-rules\")){Nette.initForm(t);break}})},Nette.isArray=function(e){return\"[object Array]\"===Object.prototype.toString.call(e)},Nette.inArray=function(e,t){if([].indexOf)return e.indexOf(t)>-1;for(var n=0;n<e.length;n++)if(e[n]===t)return!0;return!1},Nette.webalize=function(e){e=e.toLowerCase();var t,n,r=\"\";for(t=0;t<e.length;t++)n=Nette.webalizeTable[e.charAt(t)],r+=n||e.charAt(t);return r.replace(/[^a-z0-9]+/g,\"-\").replace(/^-|-$/g,\"\")},Nette.webalizeTable={\"á\":\"a\",\"ä\":\"a\",\"č\":\"c\",\"ď\":\"d\",\"é\":\"e\",\"ě\":\"e\",\"í\":\"i\",\"ľ\":\"l\",\"ň\":\"n\",\"ó\":\"o\",\"ô\":\"o\",\"ř\":\"r\",\"š\":\"s\",\"ť\":\"t\",\"ú\":\"u\",\"ů\":\"u\",\"ý\":\"y\",\"ž\":\"z\"},Nette});"

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(137))

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	module.exports = "\"use strict\";var _typeof=\"function\"==typeof Symbol&&\"symbol\"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&\"function\"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?\"symbol\":typeof t};!function(t,e,i){if(\"function\"!=typeof e)return console.error(\"nette.ajax.js: jQuery is missing, load it please\");var n=function(){var t={self:this,initialized:!1,contexts:{},on:{init:{},load:{},prepare:{},before:{},start:{},success:{},complete:{},error:{}},fire:function(){var i=!0,n=Array.prototype.slice.call(arguments),o=n.shift(),r=\"string\"==typeof o?o:o.name,a=\"object\"===(void 0===o?\"undefined\":_typeof(o))?o.off||{}:{};return n.push(t.self),e.each(t.on[r],function(o,r){if(void 0===r||-1!==e.inArray(o,a))return!0;var f=r.apply(t.contexts[o],n);return i=void 0===f||f}),i},requestHandler:function(e){var i=t.self.ajax({},this,e);if(i&&i._returnFalse)return!1},ext:function(i,n,o){for(;!o;)o=\"ext_\"+Math.random(),t.contexts[o]&&(o=void 0);e.each(i,function(e,i){t.on[e][o]=i}),t.contexts[o]=e.extend(n||{},{name:function(){return o},ext:function(e,i){var n=t.contexts[e];if(!n&&i)throw\"Extension '\"+this.name()+\"' depends on disabled extension '\"+e+\"'.\";return n}})}};this.ext=function(i,n,o){if(\"object\"===(void 0===i?\"undefined\":_typeof(i)))t.ext(i,n);else{if(void 0===n)return t.contexts[i];if(n){if(\"string\"==typeof i&&void 0!==t.contexts[i])throw\"Cannot override already registered nette-ajax extension '\"+i+\"'.\";t.ext(n,o,i)}else e.each([\"init\",\"load\",\"prepare\",\"before\",\"start\",\"success\",\"complete\",\"error\"],function(e,n){t.on[n][i]=void 0}),t.contexts[i]=void 0}return this},this.init=function(e,i){if(t.initialized)throw\"Cannot initialize nette-ajax twice.\";if(\"function\"==typeof e)this.ext(\"init\",null),this.ext(\"init\",{load:e},i);else if(\"object\"===(void 0===e?\"undefined\":_typeof(e)))this.ext(\"init\",null),this.ext(\"init\",e,i);else if(void 0!==e)throw\"Argument of init() can be function or function-hash only.\";return t.initialized=!0,t.fire(\"init\"),this.load(),this},this.load=function(){return t.fire(\"load\",t.requestHandler),this},this.ajax=function(i,n,o){if(\"string\"===e.type(i)&&(i={url:i}),!i.nette&&n&&o){var r,a=e(n),f=i.nette={e:o,ui:n,el:a,isForm:a.is(\"form\"),isSubmit:a.is(\"input[type=submit]\")||a.is(\"button[type=submit]\"),isImage:a.is(\"input[type=image]\"),form:null};if(f.isSubmit||f.isImage?f.form=f.el.closest(\"form\"):f.isForm&&(f.form=f.el),i.url||(i.url=f.form?f.form.attr(\"action\"):n.href),i.type||(i.type=f.form?f.form.attr(\"method\"):\"get\"),a.is(\"[data-ajax-off]\")){var s=a.attr(\"data-ajax-off\");0===s.indexOf(\"[\")?i.off=a.data(\"ajaxOff\"):-1!==s.indexOf(\",\")?i.off=s.split(\",\"):-1!==s.indexOf(\" \")?i.off=s.split(\" \"):i.off=s,\"string\"==typeof i.off&&(i.off=[i.off]),i.off=e.grep(e.each(i.off,function(t){return e.trim(t)}),function(t){return t.length})}}return t.fire({name:\"prepare\",off:i.off||{}},i),i.prepare&&i.prepare(i),r=i.beforeSend,i.beforeSend=function(e,i){var n=t.fire({name:\"before\",off:i.off||{}},e,i);return(n||void 0===n)&&r&&(n=r(e,i)),n},this.handleXHR(e.ajax(i),i)},this.handleXHR=function(e,i){return i=i||{},!e||void 0!==e.statusText&&\"canceled\"===e.statusText||(e.done(function(e,n,o){t.fire({name:\"success\",off:i.off||{}},e,n,o,i)}).fail(function(e,n,o){t.fire({name:\"error\",off:i.off||{}},e,n,o,i)}).always(function(e,n){t.fire({name:\"complete\",off:i.off||{}},e,n,i)}),t.fire({name:\"start\",off:i.off||{}},e,i),i.start&&i.start(e,i)),e}};e.nette=new(e.extend(n,e.nette?e.nette:{})),e.fn.netteAjax=function(t,i){return e.nette.ajax(i||{},this[0],t)},e.fn.netteAjaxOff=function(){return this.off(\".nette\")},e.nette.ext(\"validation\",{before:function(t,i){if(!i.nette)return!0;var n=i.nette,o=n.e,r=e.extend({keys:!0,url:!0,form:!0},i.validate||function(){if(n.el.is(\"[data-ajax-validate]\")){var t=n.el.data(\"ajaxValidate\");return!1===t?{keys:!1,url:!1,form:!1}:\"object\"===(void 0===t?\"undefined\":_typeof(t))?t:void 0}}()||{}),a=!1;if(void 0!==n.el.attr(\"data-ajax-pass\")&&(a=n.el.data(\"ajaxPass\"),a=\"bool\"!=typeof a||a),r.keys){var f=o.button||o.ctrlKey||o.shiftKey||o.altKey||o.metaKey;if(n.form){if(f&&n.isSubmit)return this.explicitNoAjax=!0,!1;if(n.isForm&&this.explicitNoAjax)return this.explicitNoAjax=!1,!1}else if(f)return!1}if(r.form&&n.form&&(!n.isSubmit&&!n.isImage||void 0===n.el.attr(\"formnovalidate\"))){var s=this.ie();if(n.form.get(0).onsubmit&&!1===n.form.get(0).onsubmit(void 0!==s&&s<9?void 0:o))return o.stopImmediatePropagation(),o.preventDefault(),!1}return(!r.url||!/:|^#/.test(n.form?i.url:n.el.attr(\"href\")))&&(a||(o.stopPropagation(),o.preventDefault(),t._returnFalse=!0),!0)}},{explicitNoAjax:!1,ie:function(t){for(var e=3,i=document.createElement(\"div\"),n=i.getElementsByTagName(\"i\");i.innerHTML=\"\\x3c!--[if gt IE \"+ ++e+\"]><i></i><![endif]--\\x3e\",n[0];);return e>4?e:t}}),e.nette.ext(\"forms\",{init:function(){var e;t.Nette&&(e=this.ext(\"snippets\"))&&e.after(function(e){e.find(\"form\").each(function(){t.Nette.initForm(this)})})},prepare:function(i){var n=i.nette;if(n&&n.form){var o=n.e,r=i.data||{},a={};if(n.isSubmit)a[n.el.attr(\"name\")]=n.el.val()||\"\";else if(n.isImage){var f=n.el.offset(),s=n.el.attr(\"name\"),u=[Math.max(0,o.pageX-f.left),Math.max(0,o.pageY-f.top)];-1!==s.indexOf(\"[\",0)?a[s]=u:(a[s+\".x\"]=u[0],a[s+\".y\"]=u[1])}if(\"post\"===n.form.attr(\"method\").toLowerCase()&&\"FormData\"in t){var c=new FormData(n.form[0]);for(var l in a)c.append(l,a[l]);if(\"string\"!=typeof r)for(var l in r)c.append(l,r[l]);i.data=c,i.processData=!1,i.contentType=!1}else\"string\"!=typeof r&&(r=e.param(r)),a=e.param(a),i.data=n.form.serialize()+(a?\"&\"+a:\"\")+\"&\"+r}}}),e.nette.ext(\"snippets\",{success:function(t){t.snippets&&this.updateSnippets(t.snippets)}},{beforeQueue:e.Callbacks(),afterQueue:e.Callbacks(),completeQueue:e.Callbacks(),before:function(t){this.beforeQueue.add(t)},after:function(t){this.afterQueue.add(t)},complete:function(t){this.completeQueue.add(t)},updateSnippets:function(t,i){var n=this,o=[];for(var r in t){var a=this.getElement(r);a.get(0)&&o.push(a.get(0)),this.updateSnippet(a,t[r],i)}e(o).promise().done(function(){n.completeQueue.fire()})},updateSnippet:function(t,e,i){t.is(\"title\")?document.title=e:(this.beforeQueue.fire(t),this.applySnippet(t,e,i),this.afterQueue.fire(t))},getElement:function(t){return e(\"#\"+this.escapeSelector(t))},applySnippet:function(t,e,i){!i&&t.is(\"[data-ajax-append]\")?t.append(e):!i&&t.is(\"[data-ajax-prepend]\")?t.prepend(e):t.html()!=e&&t.html(e)},escapeSelector:function(t){return t.replace(/[\\!\"#\\$%&'\\(\\)\\*\\+,\\.\\/:;<=>\\?@\\[\\\\\\]\\^`\\{\\|\\}~]/g,\"\\\\$&\")}}),e.nette.ext(\"redirect\",{success:function(e){if(e.redirect)return t.location.href=e.redirect,!1}}),e.nette.ext(\"state\",{success:function(t){t.state&&(this.state=t.state)}},{state:null}),e.nette.ext(\"unique\",{start:function(t){this.xhr&&this.xhr.abort(),this.xhr=t},complete:function(){this.xhr=null}},{xhr:null}),e.nette.ext(\"abort\",{init:function(){e(\"body\").keydown(e.proxy(function(t){this.xhr&&\"27\"===t.keyCode.toString()&&!(t.ctrlKey||t.shiftKey||t.altKey||t.metaKey)&&this.xhr.abort()},this))},start:function(t){this.xhr=t},complete:function(){this.xhr=null}},{xhr:null}),e.nette.ext(\"load\",{success:function(){e.nette.load()}}),e.nette.ext(\"init\",{load:function(t){e(this.linkSelector).off(\"click.nette\",t).on(\"click.nette\",t),e(this.formSelector).off(\"submit.nette\",t).on(\"submit.nette\",t).off(\"click.nette\",\":image\",t).on(\"click.nette\",\":image\",t).off(\"click.nette\",\":submit\",t).on(\"click.nette\",\":submit\",t),e(this.buttonSelector).closest(\"form\").off(\"click.nette\",this.buttonSelector,t).on(\"click.nette\",this.buttonSelector,t)}},{linkSelector:\"a.ajax\",formSelector:\"form.ajax\",buttonSelector:'input.ajax[type=\"submit\"], button.ajax[type=\"submit\"], input.ajax[type=\"image\"]'})}(window,window.jQuery);"

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(139))

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	module.exports = "\"use strict\";"

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */,
/* 142 */
/***/ (function(module, exports) {

	'use strict';
	
	var Ribbon = Ribbon || {};
	exports.FSRibbon = Ribbon;
	
	/** @type String Selector for tabs holder. */
	Ribbon.tabsHolder = '.tabs-holder li';
	
	/** @type String Selector for groups holder. */
	Ribbon.groupsHolder = '.groups-holder';
	
	/** @type String Selector for groups toggle button. */
	Ribbon.toggleBtn = '#toggleBtn';
	
	/** @type String Key to session storage */
	Ribbon.buttonDropDownOpenKey = 'buttonDropDown';
	
	/** @type String Slector for components 'drop down' */
	Ribbon.dropDown = '.ribbon-buttonDropDown';
	
	/**
	 * @returns void
	 */
	exports.init = function () {
	    //add event on the newly-active just-shown tab
	    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
	        if ($(Ribbon.groupsHolder).is(':hidden')) {
	            Ribbon.toggleGroupsHolder();
	        }
	    });
	
	    //add event on click tabs
	    $(Ribbon.tabsHolder).on('click', function () {
	        if ($(this).hasClass('active')) {
	            Ribbon.toggleGroupsHolder();
	        }
	    });
	
	    //add event on click toggle button
	    $(Ribbon.toggleBtn).on('click', function () {
	        Ribbon.toggleGroupsHolder();
	    });
	
	    //add event on DropDown shown
	    $(Ribbon.dropDown).on('shown.bs.dropdown', function (e) {
	        sessionStorage.setItem(Ribbon.buttonDropDownOpenKey, true);
	    });
	
	    //add event on DropDown hide
	    $(Ribbon.dropDown).on('hide.bs.dropdown', function (e) {
	        sessionStorage.setItem(Ribbon.buttonDropDownOpenKey, false);
	    });
	
	    //add event on DropDown hover
	    $(Ribbon.dropDown).hover(function (e) {
	        if (sessionStorage.getItem(Ribbon.buttonDropDownOpenKey) === 'true') {
	            $('.ribbon-buttonDropDown').removeClass('open');
	            $(this).addClass('open');
	        }
	    });
	
	    //fallback for svg logo in IE
	    if (navigator.userAgent.match(/Trident/) && $('.fs-logo').length && $('.fs-logo').attr('src').match(/.svg$/)) {
	        $('.fs-logo').load(function () {
	            $('.fs-logo').closest('a').width($('.fs-logo').width() + 20);
	        });
	        $('.fs-logo').closest('a').width($('.fs-logo').width() + 20);
	    }
	
	    //apply ribbon state
	    var ribbon_state = JSON.parse(window.localStorage.getItem('ribbon_state')) || new Object();
	    if (typeof ribbon_state['visibility'] != 'undefined' && ribbon_state['visibility'] == false) {
	        $(Ribbon.groupsHolder).hide();
	        $(Ribbon.toggleBtn + ' span').removeClass('glyphicon-menu-up');
	        $(Ribbon.toggleBtn + ' span').addClass('glyphicon-menu-down');
	        $('body').css('padding-top', '57px');
	    }
	};
	
	/**
	 * @returns void
	 */
	Ribbon.toggleGroupsHolder = function () {
	    $(Ribbon.groupsHolder).toggle();
	    var ribbon_state = JSON.parse(window.localStorage.getItem('ribbon_state')) || new Object();
	
	    //toggle icon
	    if ($(Ribbon.toggleBtn + ' span').hasClass('glyphicon-menu-up')) {
	        $(Ribbon.toggleBtn + ' span').removeClass('glyphicon-menu-up');
	        $(Ribbon.toggleBtn + ' span').addClass('glyphicon-menu-down');
	
	        ribbon_state['visibility'] = false;
	        $('body').css('padding-top', '57px');
	    } else {
	        $(Ribbon.toggleBtn + ' span').removeClass('glyphicon-menu-down');
	        $(Ribbon.toggleBtn + ' span').addClass('glyphicon-menu-up');
	
	        ribbon_state['visibility'] = true;
	        $('body').css('padding-top', '133px');
	    }
	
	    window.localStorage.setItem('ribbon_state', JSON.stringify(ribbon_state));
	};
	
	Ribbon.updateTabsHolder = function () {
	    var totalWidth = $($('.tabs-holder')[0]).width();
	    var bodyWidth = $('#tabs-holder-cover').width();
	
	    $('#tabs-holder-cover .tabs-holder').css('left', 0);
	
	    if (totalWidth > bodyWidth && !isLayoutMobile()) {
	        if (!$('#tabs-holder-cover .tabMoveButton').length) {
	            $('#tabs-holder-cover').prepend('<a href="#" class="tabMoveButton tabLeftButton"><span class="glyphicon glyphicon-menu-right"></span></a>');
	            $('#tabs-holder-cover').prepend('<a href="#" class="tabMoveButton tabRightButton"><span class="glyphicon glyphicon-menu-left"></span></a>');
	        }
	
	        var status = JSON.parse(window.sessionStorage.getItem('ribbon-tab-holder-status'));
	        if (status) {
	            window.sessionStorage.setItem('ribbon-tab-holder-status', JSON.stringify(true));
	            $('#tabs-holder-cover .tabLeftButton').hide();
	            $('#tabs-holder-cover .tabRightButton').show();
	            $('#tabs-holder-cover .tabs-holder').css({ left: '-' + (totalWidth - bodyWidth + $('#tabs-holder-cover .tabRightButton').outerWidth()) + 'px' });
	        } else {
	            window.sessionStorage.setItem('ribbon-tab-holder-status', JSON.stringify(false));
	            $('#tabs-holder-cover .tabLeftButton').show();
	            $('#tabs-holder-cover .tabRightButton').hide();
	        }
	    } else {
	        $('#tabs-holder-cover .tabMoveButton').remove();
	    }
	};
	
	Ribbon.updateGroupsHolder = function () {
	    var id = $('.groups-holder .active').attr('id');
	    var totalWidth = 30;
	    var bodyWidth = $('body').width();
	    $('.groups-holder .active .ribbon-group').each(function () {
	        totalWidth += $(this).outerWidth();
	    });
	
	    $('.groups-holder .active').css('left', 0);
	
	    if (totalWidth > bodyWidth && !isLayoutMobile()) {
	        if (!$('.groups-holder .groupMoveButton').length) {
	            $('.groups-holder').prepend('<a href="#" class="groupMoveButton groupLeftButton"><span class="glyphicon glyphicon-menu-right"></span></a>');
	            $('.groups-holder').prepend('<a href="#" class="groupMoveButton groupRightButton"><span class="glyphicon glyphicon-menu-left"></span></a>');
	        }
	
	        var status = JSON.parse(window.sessionStorage.getItem('ribbon-group-holder-status'));
	        if (status && status.length && status[0] == id && status[1] == 1) {
	            window.sessionStorage.setItem('ribbon-group-holder-status', JSON.stringify([id, 1]));
	            $('.groupLeftButton').hide();
	            $('.groupRightButton').show();
	            $('.groups-holder .active').css({ left: '-' + (totalWidth - bodyWidth + $('.groupRightButton').outerWidth()) + 'px' });
	        } else {
	            window.sessionStorage.setItem('ribbon-group-holder-status', JSON.stringify([id, 0]));
	            $('.groupLeftButton').show();
	            $('.groupRightButton').hide();
	        }
	    } else {
	        $('.groups-holder .groupMoveButton').remove();
	    }
	};
	
	$(document).on('shown.bs.tab', '.ribbon .tabs-holder a[href]', function () {
	    window.sessionStorage.removeItem('ribbon-group-holder-status');
	    Ribbon.updateGroupsHolder();
	});
	
	$(window).resize(function () {
	    Ribbon.updateTabsHolder();
	    Ribbon.updateGroupsHolder();
	});
	
	$(document).ready(function () {
	    Ribbon.updateTabsHolder();
	    Ribbon.updateGroupsHolder();
	});
	
	$(document).on('click', '.tabLeftButton', function (event) {
	    event.preventDefault();
	
	    var totalWidth = $($('.tabs-holder')[0]).width();
	    var bodyWidth = $('#tabs-holder-cover').width();
	
	    $(this).hide();
	    $(this).parent().children('.tabRightButton').show();
	    $('#tabs-holder-cover .tabs-holder').animate({ left: '-' + (totalWidth - bodyWidth + $(this).parent().children('.tabRightButton').outerWidth()) + 'px' }, 500);
	
	    window.sessionStorage.setItem('ribbon-tab-holder-status', JSON.stringify(true));
	});
	
	$(document).on('click', '.tabRightButton', function (event) {
	    event.preventDefault();
	
	    $(this).hide();
	    $(this).parent().children('.tabLeftButton').show();
	    $('#tabs-holder-cover .tabs-holder').animate({ left: 0 }, 500);
	
	    window.sessionStorage.setItem('ribbon-tab-holder-status', JSON.stringify(false));
	});
	
	$(document).on('click', '.groupLeftButton', function (event) {
	    event.preventDefault();
	
	    var totalWidth = 30;
	    var bodyWidth = $('body').width();
	    $('.groups-holder .active .ribbon-group').each(function () {
	        totalWidth += $(this).outerWidth();
	    });
	
	    $(this).hide();
	    $('.groupRightButton').show();
	    $('.groups-holder .active').animate({ left: '-' + (totalWidth - bodyWidth + $('.groupRightButton').outerWidth()) + 'px' }, 500);
	
	    var id = $('.groups-holder .active').attr('id');
	    window.sessionStorage.setItem('ribbon-group-holder-status', JSON.stringify([id, 1]));
	});
	
	$(document).on('click', '.groupRightButton', function (event) {
	    event.preventDefault();
	
	    $(this).hide();
	    $(this).parent().children('.groupLeftButton').show();
	    $('.groups-holder .active').animate({ left: 0 }, 500);
	
	    var id = $('.groups-holder .active').attr('id');
	    window.sessionStorage.setItem('ribbon-group-holder-status', JSON.stringify([id, 0]));
	});

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var FSForms = FSForms || {};
	exports.FSForms = FSForms;
	
	var INVALID_DATE = -1;
	var LAST_DATE_RANGE_PICKER_KEY = 'dateRangePickerLastValue-4664fsdf6456$YTda#@%$@)_';
	
	exports.init = function () {
	    this.processDatePicker();
	    this.processTimePicker();
	    this.processDateTimePicker();
	    this.processDateRangePicker();
	    this.processSelectSearch();
	    this.checkValidDateTime();
	    this.checkValidDateTimePicker();
	    this.processTextInputAutocomplete();
	}.bind(FSForms);
	
	/**
	 * Init DatePicker controls.
	 */
	FSForms.processDatePicker = function () {
	    if ($('#ffs_date_format').length) {
	        var ffs_date_format = $('#ffs_date_format').val();
	    } else {
	        var ffs_date_format = 'D.M.YYYY';
	    }
	
	    $('.fs-date-picker').each(function () {
	        var id = '#' + $(this).attr('id');
	        var locale = $(this).data('locale');
	        var value = $(this).attr('value');
	
	        var datePicker = $(id).parent().datetimepicker({
	            //format: 'L',
	            format: ffs_date_format,
	            useStrict: true,
	            locale: locale
	        });
	
	        // clean cache for FSForms.parseDateTime
	        FSForms.removeDateTime(id);
	
	        // set default value after render
	        $(id).val(value);
	
	        // store current value into session
	        datePicker.on('dp.change', function (e) {
	            var id = '#' + $(this).children('input').attr('id');
	            var val = $(id).val();
	            FSForms.saveDateTime(id, val);
	        });
	
	        // Triggers 'change' after hide picker. Support for metadata logic.
	        datePicker.on('dp.hide', function (e) {
	            $(this).trigger('change');
	        });
	
	        // parse date time
	        $(id).keyup(function (e) {
	            var id = '#' + $(this).attr('id');
	            var val = $(id).val();
	
	            if (val != "") {
	                if (e.keyCode == 9) // pressed TAB
	                    {
	                        FSForms.saveDateTime(id, val);
	                    } else {
	                    var dateTime = FSForms.parseDateTime(val);
	                    FSForms.saveDateTime(id, dateTime);
	                    window.live.removeError($(id));
	                }
	            }
	        });
	
	        // refresh date time
	        $(id).focusout(function () {
	            var id = '#' + $(this).attr('id');
	            FSForms.refreshDateTimeValue(id);
	        });
	
	        // refresh date time
	        datePicker.on('dp.show', function () {
	            var id = '#' + $(this).children('input').attr('id');
	            FSForms.refreshDateTimeValue(id);
	        });
	
	        // fix tabindex
	        var tabindexEl = $(id).closest('div[tabindex]');
	        var tabindex = tabindexEl.attr('tabindex');
	        $(id).prop('tabindex', tabindex);
	        tabindexEl.removeProp('tabindex');
	    });
	};
	
	/**
	 * Init TimePicker controls.
	 */
	FSForms.processTimePicker = function () {
	    if ($('#ffs_time_format').length) {
	        var ffs_time_format = $('#ffs_time_format').val();
	    } else {
	        var ffs_time_format = 'HH:mm';
	    }
	
	    $('.fs-time-picker').each(function () {
	        var id = '#' + $(this).attr('id');
	        var locale = $(this).data('locale');
	        var value = $(this).attr('value');
	        $(id).datetimepicker({
	            format: 'LT',
	            //format: ffs_time_format,
	            useStrict: true,
	            locale: locale
	        });
	
	        // set default value after render
	        $(id).val(value);
	    });
	};
	
	/**
	 * Init DateTimePicker controls.
	 */
	FSForms.processDateTimePicker = function () {
	    if ($('#ffs_datetime_format').length) {
	        var ffs_datetime_format = $('#ffs_datetime_format').val();
	    } else {
	        var ffs_datetime_format = 'D.M.YYYY HH:mm';
	    }
	
	    $('.fs-dateTime-picker').each(function () {
	        var id = '#' + $(this).attr('id');
	        var locale = $(this).data('locale');
	        var value = $(this).attr('value');
	        var dateTimePicker = $(id).parent().datetimepicker({
	            format: ffs_datetime_format,
	            useStrict: true,
	            locale: locale
	        });
	
	        // clean cache for FSForms.parseDateTime
	        FSForms.removeDateTime(id);
	
	        // set default value after render
	        $(id).val(value);
	
	        // store current value into session
	        dateTimePicker.on('dp.change', function (e) {
	            var id = '#' + $(this).children('input').attr('id');
	            var val = $(id).val();
	            window.live.removeError($(id));
	            FSForms.saveDateTime(id, val);
	        });
	
	        // Triggers 'change' after hide picker. Support for metadata logic.
	        dateTimePicker.on('dp.hide', function (e) {
	            $(this).trigger('change');
	        });
	
	        // parse date time
	        $(id).keyup(function (e) {
	            var id = '#' + $(this).attr('id');
	            var val = $(id).val();
	
	            if (val != "") {
	                if (e.keyCode == 9) // pressed TAB
	                    {
	                        FSForms.saveDateTime(id, val);
	                    } else {
	                    window.live.removeError($(id));
	                    var dateTime = FSForms.parseDateTime(val);
	                    FSForms.saveDateTime(id, dateTime);
	                }
	            }
	        });
	
	        // refresh date time
	        $(id).focusout(function () {
	            var id = '#' + $(this).attr('id');
	            FSForms.refreshDateTimeValue(id);
	        });
	
	        // refresh date time
	        dateTimePicker.on('dp.show', function (e) {
	            var id = '#' + $(this).children('input').attr('id');
	            FSForms.refreshDateTimeValue(id);
	        });
	
	        // fix tabindex
	        var tabindexEl = $(id).closest('div[tabindex]');
	        var tabindex = tabindexEl.attr('tabindex');
	        $(id).prop('tabindex', tabindex);
	        tabindexEl.removeProp('tabindex');
	    });
	};
	
	/**
	 * Init DateRangePicker controls.
	 */
	FSForms.processDateRangePicker = function () {
	    if ($('#ffs_date_format').length) {
	        var ffs_date_format = $('#ffs_date_format').val();
	    } else {
	        var ffs_date_format = 'D.M.YYYY';
	    }
	
	    $('.fs-dateRange-picker').each(function () {
	        var _ranges;
	
	        var id = '#' + $(this).attr('id');
	        var locale = $(this).data('locale');
	        var parentEl = $(id).closest('.modal-body');
	        var dateRangePicker = $(id).parent();
	        var localizedStrings = $(this).data('localized');
	
	        if (parentEl.length == 0) {
	            parentEl = 'body';
	        }
	
	        dateRangePicker.daterangepicker({
	            parentEl: parentEl,
	            format: ffs_date_format,
	            startDate: moment().subtract(29, 'days'),
	            endDate: moment(),
	            showDropdowns: true,
	            showWeekNumbers: true,
	            timePicker: false,
	            timePickerIncrement: 1,
	            timePicker12Hour: true,
	            ranges: (_ranges = {}, _defineProperty(_ranges, localizedStrings.today, [moment(), moment()]), _defineProperty(_ranges, localizedStrings.yesterday, [moment().subtract(1, 'days'), moment().subtract(1, 'days')]), _defineProperty(_ranges, localizedStrings.last7, [moment().subtract(6, 'days'), moment()]), _defineProperty(_ranges, localizedStrings.last30, [moment().subtract(29, 'days'), moment()]), _defineProperty(_ranges, localizedStrings.thisMonth, [moment().startOf('month'), moment().endOf('month')]), _defineProperty(_ranges, localizedStrings.lastMonth, [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]), _ranges),
	            opens: 'right',
	            drops: 'down',
	            buttonClasses: ['btn', 'btn-sm'],
	            applyClass: 'btn-primary',
	            cancelClass: 'btn-default',
	            separator: ' - ',
	            linkedCalendars: false,
	            locale: {
	                format: ffs_date_format,
	                applyLabel: localizedStrings.apply,
	                cancelLabel: localizedStrings.cancel,
	                fromLabel: localizedStrings.from,
	                toLabel: localizedStrings.to,
	                customRangeLabel: localizedStrings.custom,
	                daysOfWeek: [localizedStrings.sun, localizedStrings.mon, localizedStrings.tue, localizedStrings.wed, localizedStrings.thu, localizedStrings.fri, localizedStrings.sat],
	                monthNames: [localizedStrings.jan, localizedStrings.feb, localizedStrings.mar, localizedStrings.apr, localizedStrings.may, localizedStrings.jun, localizedStrings.jul, localizedStrings.aug, localizedStrings.sep, localizedStrings.oct, localizedStrings.nov, localizedStrings.dec],
	                firstDay: 1
	            } }, function (start, end, label) {
	            switch (label) {
	                case localizedStrings.today:
	                    this.startDate = moment();this.endDate = moment();break;
	                case localizedStrings.yesterday:
	                    this.startDate = moment().subtract(1, 'days');this.endDate = moment().subtract(1, 'days');break;
	                case localizedStrings.last7:
	                    this.startDate = moment().subtract(6, 'days');this.endDate = moment();break;
	                case localizedStrings.last30:
	                    this.startDate = moment().subtract(29, 'days');this.endDate = moment();break;
	                case localizedStrings.thisMonth:
	                    this.startDate = moment().startOf('month');this.endDate = moment().endOf('month');break;
	                case localizedStrings.lastMonth:
	                    this.startDate = moment().subtract(1, 'month').startOf('month');this.endDate = moment().subtract(1, 'month').endOf('month');break;
	            }
	            $(id).val(this.startDate.format(ffs_date_format) + ' - ' + this.endDate.format(ffs_date_format));
	        });
	
	        // update size modal
	        dateRangePicker.on('show.daterangepicker hide.daterangepicker', function (ev, picker) {
	            if (parentEl != 'body' && parentEl.length == 1) {
	                $(id).closest('.modal').modal('handleUpdate');
	            }
	
	            var start = $(picker.container).find('input[name="daterangepicker_start"]');
	            start.select();
	            start.focus();
	        });
	
	        // update text input after click on OK
	        dateRangePicker.on('apply.daterangepicker', function (ev, picker) {
	            $(id).val(picker.startDate.format(ffs_date_format) + ' - ' + picker.endDate.format(ffs_date_format));
	            window.live.removeError($(id));
	        });
	
	        // update text input after click on storno
	        dateRangePicker.on('cancel.daterangepicker', function (ev, picker) {
	            $(id).val(null);
	            window.live.removeError($(id));
	        });
	    });
	
	    // parse date time
	    var dateRangePickerInputEl = $("input[name='daterangepicker_start'], input[name='daterangepicker_end']");
	
	    dateRangePickerInputEl.focus(function () {
	        $(this).select();
	    });
	
	    dateRangePickerInputEl.keyup(function (e) {
	        if (e.keyCode == 9) // pressed TAB
	            {
	                return true;
	            }
	
	        var val = $(this).val();
	        var _date = FSForms.parseDateTime(val);
	        if (_date != INVALID_DATE) {
	            var date = moment(_date, ffs_date_format).format(ffs_date_format);
	            FSForms.saveDateTime(LAST_DATE_RANGE_PICKER_KEY, date);
	        }
	    });
	
	    dateRangePickerInputEl.focusout(function () {
	        var date = FSForms.loadDateTime(LAST_DATE_RANGE_PICKER_KEY);
	        if (date != null) {
	            $(this).val(date);
	        }
	    });
	
	    dateRangePickerInputEl.change(function () {
	        var date = FSForms.loadDateTime(LAST_DATE_RANGE_PICKER_KEY);
	        if (date != null) {
	            $(this).val(date);
	        }
	    });
	};
	
	/**
	 * Init SelectSearch control.
	 */
	FSForms.processSelectSearch = function () {
	    // https://harvesthq.github.io/chosen
	    $(".chosen_select_search").each(function () {
	        var noResultsText = $(this).data('noresultstext');
	
	        $(this).chosen({
	            search_contains: true,
	            no_results_text: noResultsText
	        });
	        $(this).on('change', function (evt, params) {
	            window.live.removeError($(this));
	        });
	    });
	};
	
	/**
	 * Check valid date for dateTimePicker and timePicker before form submit.
	 */
	FSForms.checkValidDateTime = function () {
	    $('form').submit(function () {
	        var valid = true;
	        $(this).find('.fs-date-picker, .fs-dateTime-picker').each(function () {
	            var val = $(this).val();
	            //if(!moment(val, 'DD.MM.YYYY HH:mm:ss').isValid() && val != '' && val != '%IS NULL%')
	            if (!moment(val, 'D.M.YYYY HH:mm:ss').isValid() && !moment(val, 'DD-MM-YYYY HH:mm:ss').isValid() && !moment(val, 'MM-DD-YYYY HH:mm:ss').isValid() && !moment(val, 'MM/DD/YYYY HH:mm:ss').isValid() && val != '' && val != '%IS NULL%') {
	                valid = false;
	                alert('Chybný formát nebo datum.');
	                $(this).focus();
	                $(this).select();
	                return false;
	            }
	        });
	
	        if (valid == false) {
	            return false;
	        }
	    });
	};
	
	/**
	 *  Check valid date for dateRangePicker before form submit.
	 */
	FSForms.checkValidDateTimePicker = function () {
	    $('form').submit(function () {
	        var valid = true;
	        $(this).find('.fs-dateRange-picker').each(function () {
	            var val = $(this).val();
	            if (val == '' || val == '%IS NULL%') {
	                return true;
	            }
	
	            var splitVal = val.split(' - ');
	            if (!Array.isArray(splitVal) || !moment(splitVal[0], 'D.M.YYYY').isValid() || !moment(splitVal[1], 'D.M.YYYY').isValid()) {
	                valid = false;
	                alert('Chybný formát nebo datum.');
	                $(this).focus();
	                $(this).select();
	                return false;
	            }
	        });
	
	        if (valid == false) {
	            return false;
	        }
	    });
	};
	
	/**
	 * Init Text Input Autocomplete
	 */
	FSForms.processTextInputAutocomplete = function () {
	    $('input[data-textInputAutocomplete=true]').each(function () {
	        var id = '#' + $(this).attr('id');
	        var url = $(this).data('autocompleteurl');
	        var minLength = $(this).data('minlength');
	
	        $(id).autocomplete({
	            source: url,
	            minLength: minLength,
	            open: function open() {
	                setTimeout(function () {
	                    $('.ui-autocomplete').css('z-index', 999999);
	                }, 0);
	                var acData = $(this).data('ui-autocomplete');
	                acData.menu.element.find('li').each(function () {
	                    var me = $(this);
	                    var keywords = acData.term.split(' ').join('|');
	                    me.html(me.text().replace(new RegExp("(" + keywords + ")", "gi"), '<b>$1</b>'));
	                });
	            }
	        });
	    });
	};
	
	/**
	 * @param id
	 */
	FSForms.refreshDateTimeValue = function (id) {
	    var control = $(id);
	    var val = FSForms.loadDateTime(id);
	    if (val != null) {
	        if (val == INVALID_DATE) {
	            control.val('Chybný formát nebo datum.');
	        } else {
	            control.val(val);
	        }
	    }
	};
	
	/**
	 * @param string val
	 */
	FSForms.parseDateTime = function (val) {
	    var now = moment();
	    var type = 0; // 0 - day; 1 - month; 2 - year
	    var c = 0;
	
	    var day = '';
	    var month = '';
	    var year = '';
	    var hour = 0;
	    var minute = 0;
	    var second = 0;
	
	    if ($('#ffs_datetime_format').length) {
	        var ffs_datetime_format = $('#ffs_datetime_format').val();
	    } else {
	        var ffs_datetime_format = 'D.M.YYYY HH:mm:ss';
	    }
	
	    // parse input
	    for (var i = 0; i < val.length; i++) {
	        var char = val.charAt(i);
	
	        if (char.match(/\D/)) {
	            if (c != 0) {
	                if ((type == 0 || type == 1) && c == 1) {
	                    c = 0;
	                }
	                type++;
	            }
	            continue;
	        }
	
	        c++;
	
	        switch (type) {
	            case 0:
	                day += char;
	                break;
	            case 1:
	                month += char;
	                break;
	            case 2:
	                year += char;
	                break;
	        }
	
	        if ((type == 0 || type == 1) && c == 2) {
	            c = 0;
	            type++;
	        }
	
	        if (type == 2 && c == 5) {
	            break;
	        }
	    }
	
	    // fill missing values
	    if (day == '') {
	        day = now.format('D');
	    }
	    if (month == '') {
	        month = now.format('M');
	    }
	    if (year == '' || year.length < 2) {
	        year = now.format('YYYY');
	    }
	    if (day == now.format('D') && month == now.format('M') && year == now.format('YYYY')) {
	        hour = now.format('H');
	        minute = now.format('m');
	        second = now.format('s');
	    }
	
	    // validation and store into session
	    var dateTime = moment(day + '.' + month + '.' + year + ' ' + hour + ':' + minute + ':' + second, ffs_datetime_format);
	    if (dateTime.isValid()) {
	        return dateTime.format(ffs_datetime_format);
	    } else {
	        return INVALID_DATE;
	    }
	};
	
	/**
	 * @param string key
	 * @param string value
	 */
	FSForms.saveDateTime = function (key, value) {
	    sessionStorage.setItem(key, value);
	};
	
	/**
	 * @param string key
	 */
	FSForms.loadDateTime = function (key) {
	    return sessionStorage.getItem(key);
	};
	
	/**
	 * @param string key
	 */
	FSForms.removeDateTime = function (key) {
	    sessionStorage.removeItem(key);
	};

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var FSGrid = {};
	exports.default = FSGrid;
	
	/** @type {Array} */
	
	FSGrid.bulkActionRequestPool = [];
	
	FSGrid.init = function () {
	    $('.fs-grid').each(function () {
	        var id = '#' + $(this).attr('id');
	
	        // columns draggable
	        FSGrid.removeEmptyActions(id);
	
	        // columns draggable
	        FSGrid.initColumnsDraggable(id);
	
	        // columns resizable
	        FSGrid.initColumnsResizable(id);
	
	        // modal action
	        FSGrid.initModalAction(id);
	
	        // bulk action
	        FSGrid.initBulkAction(id);
	
	        // handle confirm action
	        FSGrid.initHandleConfirmAction(id);
	
	        // init filters
	        FSGrid.initFilters(id);
	
	        // bulk without dialog
	        FSGrid.initBulkActionWithoutDialog(id);
	
	        // highlighting row
	        FSGrid.highlightingRow(id);
	
	        // header and action column fixed
	        FSGrid.initTableFixer(id);
	
	        // checkboxes
	        FSGrid.initCheckboxes(id);
	    });
	};
	
	/**
	 * @param gridId
	 */
	FSGrid.removeEmptyActions = function (gridId) {
	    var actions = $($(gridId + ' .grid-action-icons > span')[0]).children();
	    var actionsCount = actions.length;
	
	    for (var action = actionsCount; action > 0; action--) {
	        if ($(actions[action - 1]).html()) continue;
	
	        if ($(gridId + ' .grid-action-icons > span > :nth-child(' + action + '):not(:empty)').length == 0) {
	            $(gridId + ' .grid-action-icons > span > :nth-child(' + action + ')').remove();
	        }
	    }
	};
	
	/**
	 * @param gridId
	 */
	FSGrid.initCheckboxes = function (gridId) {
	    $(gridId + ' table').checkboxes('range', true);
	};
	
	/**
	 * @param gridId
	 */
	FSGrid.initTableFixer = function (gridId) {
	    var config = $(gridId).data('clientsideconfig');
	    if (config && config.tableFixer) {
	        var bulkAction = config.bulkAction;
	        var otherAction = config.otherAction;
	        var opt = {};
	
	        if (bulkAction && otherAction) {
	            opt.left = 2;
	        }
	
	        if (bulkAction && !otherAction || !bulkAction && otherAction) {
	            opt.left = 1;
	        }
	
	        $(gridId + ' table').tableHeadFixer(opt);
	    }
	};
	
	/**
	 * @param gridId
	 */
	FSGrid.highlightingRow = function (gridId) {
	    var _state = sessionStorage.getItem('gridCurrentRow');
	    if (_state != null) {
	        var state = JSON.parse(_state);
	        if (state.enabled) {
	            FSGrid.removeHighlightingRow(state.idRow, state.backgroundColor);
	            FSGrid.addHighlightingRow(state.idRow);
	            state.enabled = false;
	            sessionStorage.setItem('gridCurrentRow', JSON.stringify(state));
	        } else {
	            sessionStorage.removeItem('gridCurrentRow');
	        }
	    }
	
	    $(document).on('click', gridId + " tr[class^=grid-row-] > td", function () {
	        var trEl = $(this).parents("tr[class^=grid-row]");
	        var classVal = trEl.attr('class').match(/grid-row-[\d]+/g);
	
	        if (classVal.length > 0) {
	            var primaryKey = classVal[0].replace(/grid-row-/, '');
	            var idRow = gridId + " tr[class=grid-row-" + primaryKey + "]";
	            var backgroundColor = $(idRow).css('background-color');
	            var state = {
	                idRow: idRow,
	                backgroundColor: backgroundColor,
	                enabled: true
	            };
	
	            // remove prev highlighting row
	            var _oldState = sessionStorage.getItem('gridCurrentRow');
	            if (_oldState != null) {
	                var oldState = JSON.parse(_oldState);
	                FSGrid.removeHighlightingRow(oldState.idRow, oldState.backgroundColor);
	                sessionStorage.removeItem('gridCurrentRow');
	            }
	
	            FSGrid.addHighlightingRow(state.idRow);
	            sessionStorage.setItem('gridCurrentRow', JSON.stringify(state));
	        }
	    });
	};
	
	/**
	 * @param idRow
	 */
	FSGrid.addHighlightingRow = function (idRow) {
	    $(idRow).css('background-color', '#E7F2FB');
	};
	
	/**
	 * @param idRow
	 * @param backgroundColor
	 */
	FSGrid.removeHighlightingRow = function (idRow, backgroundColor) {
	    $(idRow).css('background-color', backgroundColor);
	};
	
	/**
	 * Setup columns resizable.
	 */
	FSGrid.initColumnsResizable = function (gridId) {
	    // https://mottie.github.io/tablesorter/docs/example-widget-resizable.html
	    var config = $(gridId).data('clientsideconfig');
	
	    if (config && config.columnsResizable == true) {
	        $(gridId + ' table').tablesorter({
	            widgets: ['resizable'],
	            widgetOptions: {
	                resizable_addLastColumn: true,
	                resizable: true
	            }
	        });
	    }
	};
	
	/**
	 * Setup columns draggable.
	 */
	FSGrid.initColumnsDraggable = function (gridId) {
	    var config = $(gridId).data('clientsideconfig');
	
	    if (config && config.columnsDraggable == true) {
	        $(gridId + ' table').dragtable({
	            excludeFooter: true,
	            persistState: config.columnsDraggablePersistUrl
	        });
	    }
	};
	
	/**
	 * Action modal
	 */
	
	FSGrid.initModalAction = function (gridId) {
	    $(document).on('click', gridId + ' .grid-action-btn', function () {
	        FSGrid.processModalAction(gridId, $(this).data('handleonclick'), $(this).data('target'));
	    });
	};
	
	FSGrid.processModalAction = function (gridId, url, modalTarget) {
	    var modalFade = $(modalTarget);
	    var modalDialog = modalFade.find('.modal-dialog');
	
	    // prepare Ajax request
	    var req = {
	        url: url,
	        beforeSend: function beforeSend() {
	            modalDialog.html('<div/>');
	            waiter_open('large');
	        },
	        success: function success(data, textStatus, jqXHR) {
	            if (jqXHR.responseJSON) {
	                flashMessage(jqXHR.responseJSON.message, jqXHR.responseJSON.type);
	                modalFade.modal('hide');
	            } else {
	                modalDialog.html(data);
	                modalFade.modal('handleUpdate');
	                FSForms.init();
	            }
	        },
	        error: function error(data, textStatus, jqXHR) {
	            flashMessageWarning('Nastala chyba při načítání dat HTTP 500.');
	            modalFade.modal('hide');
	        },
	        statusCode: {
	            500: function _() {
	                flashMessageWarning('Nastala chyba při načítání dat HTTP 500.');
	            }
	        },
	        complete: function complete(jqXHR, textStatus) {
	            waiter_close();
	        }
	    };
	
	    // send Ajax request
	    $.ajax(req);
	};
	
	/** BULK ACTIONS ******************************************************************************************************/
	
	/**
	 * Inits bulk action for grid with id.
	 * @param id
	 */
	FSGrid.initBulkAction = function (gridId) {
	    if (!$(gridId + ' .grid-bulk-action-head').length) return;
	
	    $(gridId + ' .grid-bulk-action-head').click(FSGrid.onClickHeadCheckbox); // add event on head checkbox
	    $(gridId + ' .grid-bulk-action-cell').change(FSGrid.onClickCellCheckbox); // add event on cell checkbox
	    $(gridId + '-bulk-action-dialog .btn-close').click(FSGrid.onClickButtonClose); // add event on button close on dialog
	    $('#sidebarRight-sidebar .btn-close').click(FSGrid.onClickButtonClose); // add event on button close on dialog
	    $('#sidebarRight-sidebar-close-button').click(FSGrid.onClickButtonCloseSidebar); // add event on button close on dialog
	    $(gridId + '-bulk-action-dialog .btn-min').click(FSGrid.onClickButtonMin); // add event on button min on dialog
	    $(gridId + '-bulk-action-dialog .btn-link').click(FSGrid.onClickButtonLock); // add event on button lock on dialog
	    $('#sidebarRight-sidebar-unlock-button').click(FSGrid.onClickButtonUnlock); // add event on button unlock on dialog
	    $('.grid-actionBulkAction').click(FSGrid.onClickButtonActionMobile); // add event on button lock on dialog
	    $(gridId + '-bulk-action-dialog').resize(FSGrid.updateMaxHeight);
	    $(document).on('click', '.bulk_dialog_show_hide_panel_button', FSGrid.bulkDialogPanelSwitch);
	    $(document).on('click', '.grid-bulk-content .bulk-form-button .ribbon-button', FSGrid.bulkFormButtonClick);
	
	    // prepare bulk request pull
	    if (Array.isArray(FSGrid.bulkActionRequestPool[gridId]) == false) {
	        FSGrid.bulkActionRequestPool[gridId] = [];
	    }
	
	    // TODO: load state dialog after refresh
	    FSGrid.removeState(gridId);
	};
	
	/**
	 * This method open bulk dialog and send AJAX request.
	 * @param gridId
	 */
	FSGrid.processBulkAction = function (gridId) {
	    var state = this.loadState(gridId);
	
	    if (state.bulkAction.selectedRows.length > 0 && state.bulkAction.state == 'close') {
	        this.refreshDialogByDilogState('open', gridId);
	        this.sendBulkActionRequest(gridId);
	    } else if (state.bulkAction.selectedRows.length > 0 && state.bulkAction.state == 'min') {
	        this.refreshDialogByDilogState('max', gridId);
	        this.sendBulkActionRequest(gridId);
	    }
	    if (state.bulkAction.selectedRows.length > 0 && state.bulkAction.state == 'open') {
	        this.sendBulkActionRequest(gridId);
	    } else if (state.bulkAction.selectedRows.length == 0) {
	        this.refreshDialogByDilogState('close', gridId);
	        this.removeState(gridId);
	        FSGrid.abortAllBulkActionRequest(gridId);
	    }
	};
	
	/**
	 * This method open/close parts of bulk dialog.
	 * @param gridId
	 */
	FSGrid.bulkDialogPanelSwitch = function () {
	    var target = $(this).data('target');
	    var id = $(this).data('bulkstate');
	    var bulk_state = JSON.parse(window.sessionStorage.getItem('bulk_state')) || new Object();
	
	    if (target) {
	        var area = $('#' + $(this).data("target"));
	    } else {
	        var area = $(this).parent().parent().find(".panel-body");
	    }
	
	    area.toggle();
	    $(this).children('span').toggleClass('glyphicon-chevron-down');
	    $(this).children('span').toggleClass('glyphicon-chevron-up');
	
	    bulk_state[id] = area.is(':visible');
	    window.sessionStorage.setItem('bulk_state', JSON.stringify(bulk_state));
	};
	
	/**
	 * This method open/close parts of bulk dialog from memory.
	 * @param gridId
	 */
	FSGrid.bulkDialogPanelSwitchInit = function () {
	    var bulk_state = JSON.parse(window.sessionStorage.getItem('bulk_state')) || [];
	
	    $('.bulk_dialog_show_hide_panel_button').each(function () {
	        var id = $(this).data('bulkstate');
	
	        if (typeof bulk_state[id] != 'undefined' && bulk_state[id] == false) {
	            $(this).trigger('click');
	        }
	    });
	};
	
	/**
	 * @param {String} state
	 * @param {String} gridId
	 */
	FSGrid.refreshDialogByDilogState = function (stateDialog, gridId) {
	    var state = this.loadState(gridId);
	    var dialog = $(gridId + '-bulk-action-dialog');
	
	    // open dialog
	    if (stateDialog == 'open') {
	        $('.grid-actionBulkAction').removeClass('hidden');
	
	        if (this.loadSidebarState(gridId) == true) {
	            var title = dialog.find('.panel-title').text();
	            $('#vertical_right_text_sidebar strong').text(title);
	            $('#sidebarRight-sidebar-title strong').text(title);
	
	            showSidebarRight();
	            return;
	        }
	
	        dialog.css(state.bulkAction.css);
	        dialog.draggable({
	            cancel: '.draggableOff'
	        });
	        dialog.resizable({
	            handles: 'all',
	            create: function create(event, ui) {
	                $('.ui-icon-gripsmall-diagonal-se').remove();
	            }
	        });
	
	        // set icon
	        dialog.find('.btn-min').html('<span class="glyphicon glyphicon-chevron-down"></span>');
	
	        state.bulkAction.state = 'open';
	        this.saveState(gridId, state);
	
	        this.updateMaxHeightById(gridId);
	        dialog.show('slow');
	    }
	    // close dialog
	    else if (stateDialog == 'close') {
	            dialog.find('.panel-body').html('');
	            $('.grid-actionBulkAction').addClass('hidden');
	            $('#sidebarRight-sidebar').removeClass('sidebarRight-sidebar-visible');
	            $('#sidebarLeft-sidebar').removeClass('responsive-hidden');
	            $('#sidebarLeft-content').removeClass('responsive-hidden');
	
	            if (this.loadSidebarState(gridId) == true) {
	                hideSidebarRight();
	                return;
	            }
	
	            var css = {
	                'position': dialog.css('position'),
	                'bottom': dialog.css('bottom'),
	                'right': dialog.css('right'),
	                'height': dialog.css('height'),
	                'width': dialog.css('width'),
	                'min-height': dialog.css('min-height'),
	                'min-width': dialog.css('min-width'),
	                'margin-right': dialog.css('margin-right'),
	                'z-index': dialog.css('z-index')
	            };
	
	            state.bulkAction.css = css;
	            state.bulkAction.state = 'close';
	            this.saveState(gridId, state);
	
	            dialog.hide('slow');
	        }
	        // min
	        else if (stateDialog == 'min') {
	                var prevCSS = {
	                    'position': dialog.css('position'),
	                    'bottom': dialog.css('bottom'),
	                    'right': dialog.css('right'),
	                    'height': dialog.css('height'),
	                    'width': dialog.css('width'),
	                    'min-height': dialog.css('min-height'),
	                    'min-width': dialog.css('min-width'),
	                    'margin-right': dialog.css('margin-right'),
	                    'z-index': dialog.css('z-index')
	                };
	
	                // invert color
	                dialog.children('.panel-heading').addClass('panel-heading-closed');
	
	                // change icon
	                dialog.find('.btn-min').html('<span class="glyphicon glyphicon-chevron-up"></span>');
	
	                // hide panel body
	                dialog.children('.panel-body').hide();
	
	                // disable resizable
	                dialog.resizable('destroy');
	
	                // css
	                var height = dialog.children('.panel-heading').outerHeight() + 1;
	                dialog.css({
	                    'top': '',
	                    'right': 0,
	                    'bottom': 0,
	                    'left': '',
	                    'height': height,
	                    'min-height': height
	                });
	
	                state.bulkAction.css = prevCSS;
	                state.bulkAction.state = 'min';
	                this.saveState(gridId, state);
	            }
	            // max
	            else if (stateDialog == 'max') {
	                    // invert color
	                    dialog.children('.panel-heading').removeClass('panel-heading-closed');
	
	                    // change icon
	                    dialog.find('.btn-min').html('<span class="glyphicon glyphicon-chevron-down"></span>');
	
	                    // show panel body
	                    dialog.children('.panel-body').show();
	
	                    var css = state.bulkAction.css;
	                    css.right = 0; // fix
	                    css.bottom = 0; // fix
	                    dialog.css(css); // fix
	                    dialog.resizable({
	                        handles: 'all',
	                        create: function create(event, ui) {
	                            $('.ui-icon-gripsmall-diagonal-se').remove();
	                        }
	                    });
	
	                    state.bulkAction.state = 'open';
	                    this.saveState(gridId, state);
	                }
	};
	
	/** Bulk action - handles - begin *************************************************************************************/
	
	/**
	 * Callback on click head checkbox.
	 */
	FSGrid.onClickHeadCheckbox = function () {
	    var gridId = FSGrid.getGridId($(this));
	    $(gridId + ' .grid-bulk-action-cell').prop('checked', $(this).prop('checked')); // toggle checked cell checkboxs
	    FSGrid.processBulkAction(gridId);
	};
	
	/**
	 * Callback on click checkbox in cell.
	 */
	FSGrid.onClickCellCheckbox = function () {
	    FSGrid.processBulkAction(FSGrid.getGridId($(this)));
	};
	
	/**
	 * Callback on click button close in bulk dialog.
	 */
	FSGrid.onClickButtonClose = function () {
	    var gridId = FSGrid.getGridId($('.grid-bulk-action-head'));
	    FSGrid.refreshDialogByDilogState('close', gridId);
	    $(gridId + ' .grid-bulk-action-cell:checked').prop('checked', false);
	    $(gridId + ' .grid-bulk-action-head:checked').prop('checked', false);
	
	    // remove highlighting row
	    var _state = sessionStorage.getItem('gridCurrentRow');
	    if (_state != null) {
	        var state = JSON.parse(_state);
	        FSGrid.removeHighlightingRow(state.idRow, state.backgroundColor);
	        sessionStorage.removeItem('gridCurrentRow');
	    }
	};
	
	/**
	 * Callback on click button close in sidebar dialog.
	 */
	FSGrid.onClickButtonCloseSidebar = function () {
	    $('.grid-bulk-action-dialog .btn-close').trigger('click');
	};
	
	/**
	 *
	 */
	FSGrid.onClickButtonMin = function () {
	    var gridId = FSGrid.getGridId($(this));
	    var state = FSGrid.loadState(gridId);
	
	    if (state.bulkAction.state == 'open') {
	        FSGrid.refreshDialogByDilogState('min', gridId);
	    }
	
	    if (state.bulkAction.state == 'min') {
	        FSGrid.refreshDialogByDilogState('max', gridId);
	    }
	};
	
	/**
	 *
	 */
	FSGrid.onClickButtonLock = function () {
	    var gridId = FSGrid.getGridId($('.grid-bulk-action-head'));
	    var state = FSGrid.loadState(gridId);
	    FSGrid.refreshDialogByDilogState('close', gridId);
	    FSGrid.saveSidebarState(gridId, true);
	    FSGrid.refreshDialogByDilogState('open', gridId);
	    FSGrid.sendBulkActionRequest(gridId);
	};
	
	/**
	 *
	 */
	FSGrid.onClickButtonActionMobile = function () {
	    FSGrid.onClickButtonLock();
	    $('#sidebarRight-sidebar').addClass('sidebarRight-sidebar-visible');
	    $('#sidebarLeft-sidebar').addClass('responsive-hidden');
	    $('#sidebarLeft-content').addClass('responsive-hidden');
	};
	
	/**
	 *
	 */
	FSGrid.onClickButtonUnlock = function () {
	    var gridId = FSGrid.getGridId($('.grid-bulk-action-head'));
	    var state = FSGrid.loadState(gridId);
	    FSGrid.refreshDialogByDilogState('close', gridId);
	    FSGrid.saveSidebarState(gridId, false);
	    FSGrid.refreshDialogByDilogState('open', gridId);
	    FSGrid.sendBulkActionRequest(gridId);
	};
	
	/**
	 *
	 */
	FSGrid.addBulkActionsCloseButton = function () {
	    $('#sidebarRight-sidebar-title .bulk_dialog_show_hide_panel_button').remove();
	    if ($('#sidebarRight-sidebar-content #bulk_actions').length > 0) {
	        $('#sidebarRight-sidebar-title').append('<div class = "bulk_dialog_show_hide_panel_button close" data-bulkstate = "bulk_actions" data-target = "bulk_actions"><span class="bulk_edit_form bulk_dialog_show_hide_panel_glyphicon glyphicon glyphicon-chevron-up"></span></div>');
	    }
	};
	
	/**
	 *
	 */
	FSGrid.updateMaxHeight = function () {
	    FSGrid.updateMaxHeightById(FSGrid.getGridId($(this)));
	};
	
	/**
	 *
	 */
	FSGrid.updateMaxHeightById = function (gridId) {
	    $(gridId + '-bulk-action-dialog > .panel-body').css('max-height', $(gridId + '-bulk-action-dialog').height() - $('.grid-bulk-action-dialog > .panel-heading').outerHeight() + 'px');
	    $(gridId + '-bulk-action-dialog > .panel-body').css('overflow', 'auto');
	
	    if (isLayoutMobile()) {
	        $('#sidebarRight-sidebar').children('.panel-default').height('auto');
	        $('#sidebarRight-sidebar-content').css('max-height', 'none');
	    } else {
	        var height = $('#container-fluid-main').height() - 7;
	        $('#sidebarRight-sidebar').children('.panel-default').height(height - 2);
	        $('#sidebarRight-sidebar-content').css('max-height', height - $('#sidebarRight-sidebar-title').outerHeight() - 3 + 'px');
	    }
	};
	/** Bulk action - handles - end ***************************************************************************************/
	
	/**
	 * Sends Ajax request for bulk action.
	 * @param gridId
	 * @param dialogId
	 * @param primaryKeys
	 */
	FSGrid.sendBulkActionRequest = function (gridId) {
	    var state = FSGrid.loadState(gridId);
	    var target = FSGrid.loadSidebarState(gridId) == true ? '#sidebarRight-sidebar-content' : gridId + '-bulk-action-dialog .panel-body';
	    var unTarget = FSGrid.loadSidebarState(gridId) !== true ? '#sidebarRight-sidebar-content' : gridId + '-bulk-action-dialog .panel-body';
	
	    if (state.bulkAction.selectedRows.length == 0) {
	        FSGrid.refreshDialogByDilogState('close', gridId);
	        $(gridId + ' .grid-bulk-action-cell:checked').prop('checked', false);
	        $(gridId + ' .grid-bulk-action-head:checked').prop('checked', false);
	        return;
	    }
	
	    // abort all prev request
	    FSGrid.abortAllBulkActionRequest(gridId);
	
	    // prepare Ajax request
	    var req = {
	        method: 'POST',
	        url: $(gridId + '-bulk-action-dialog').data('handleonclick'),
	        data: state,
	        beforeSend: function beforeSend(jqXHR) {
	            // adds current request into pool
	            FSGrid.bulkActionRequestPool[gridId].push(jqXHR);
	
	            // spin
	            $(target).html('<div/>');
	            $(unTarget).html('<div/>');
	            waiter_open('medium', target);
	
	            FSGrid.updateMaxHeightById(gridId);
	        },
	        success: function success(data, textStatus, jqXHR) {
	            waiter_close();
	            if (jqXHR.responseJSON) {
	                flashMessage(jqXHR.responseJSON.message, jqXHR.responseJSON.type);
	                $(gridId + '-bulk-action-dialog .btn-close').click();
	            } else {
	                $(target).html(data);
	                $(target).find('form').each(function () {
	                    window.Nette.initForm(this);
	                });
	                FSGrid.bulkDialogPanelSwitchInit();
	                FSGrid.updateMaxHeightById(gridId);
	            }
	            FSGrid.addBulkActionsCloseButton();
	        },
	        error: function error(jqXHR) {
	            if (jqXHR.statusText == 'abort') {
	                return;
	            } else if ($(gridId + '-bulk-action-dialog').data('errormsg')) {
	                flashMessageWarning($(gridId + '-bulk-action-dialog').data('errormsg'));
	                $(gridId + '-bulk-action-dialog .btn-close').click();
	            }
	        },
	        statusCode: {
	            500: function _() {
	                flashMessageWarning('Nastala chyba při načítání dat HTTP 500.');
	            }
	        }
	    };
	
	    // send Ajax request
	    $.ajax(req);
	};
	
	/**
	 * Aborts all request for bulk action.
	 * @param dialogId
	 */
	FSGrid.abortAllBulkActionRequest = function (dialogId) {
	    FSGrid.bulkActionRequestPool[dialogId].forEach(function (jqXHR, index) {
	        jqXHR.abort();
	        FSGrid.bulkActionRequestPool[dialogId].splice(index, 1);
	    });
	};
	
	/** Helpers ***********************************************************************************************************/
	
	/**
	 * @param {jQuery} el
	 * @returns {string}
	 */
	FSGrid.getGridId = function (el) {
	    return '#' + el.parents('.fs-grid').attr('id');
	};
	
	/**
	 * Saves grid state in session strorage.
	 * @param gridId
	 */
	FSGrid.saveState = function (gridId, state) {
	    window.sessionStorage.setItem(gridId, JSON.stringify(state));
	};
	
	/**
	 * Saves sidebar state in session strorage.
	 * @param gridId
	 */
	FSGrid.saveSidebarState = function (gridId, state) {
	    window.sessionStorage.setItem(gridId + 'sidebar', state);
	};
	
	/**
	 * Loads sidebar state from session strorage.
	 * @param gridId
	 */
	FSGrid.loadSidebarState = function (gridId) {
	    return window.sessionStorage.getItem(gridId + 'sidebar') == 'true';
	};
	
	/**
	 * Loads grid state from session storage.
	 * @param gridId
	 * @return Object
	 */
	FSGrid.loadState = function (gridId) {
	    var stringState = window.sessionStorage.getItem(gridId);
	
	    if (stringState == null) {
	        var state = {
	            bulkAction: {
	                gridId: gridId,
	                state: 'close',
	                css: {
	                    'position': 'fixed',
	                    'bottom': 0,
	                    'right': 0,
	                    'height': $(gridId + '-bulk-action-dialog').data('height'),
	                    'width': $(gridId + '-bulk-action-dialog').data('width'),
	                    'min-height': $(gridId + '-bulk-action-dialog').data('minheight'),
	                    'min-width': $(gridId + '-bulk-action-dialog').data('minwidth'),
	                    'margin-right': '10px',
	                    'z-index': 1041
	                }
	            }
	        };
	    } else {
	        var state = JSON.parse(stringState);
	    }
	
	    // selected rows
	    state.bulkAction.selectedRows = [];
	    $(gridId + ' .grid-bulk-action-cell:checked').each(function () {
	        state.bulkAction.selectedRows.push($(this).data('primarykey'));
	    });
	
	    return state;
	};
	
	/**
	 * @param {String} gridId
	 */
	FSGrid.removeState = function (gridId) {
	    window.sessionStorage.removeItem(gridId);
	};
	
	/** HANDLE CONFIRM ACTIONS ********************************************************************************************/
	
	/**
	 * @param string gridId
	 */
	FSGrid.initHandleConfirmAction = function (gridId) {
	    var options = {};
	    $(gridId + ' .grid-cell-action-confirm-handle').popover(options);
	};
	
	/** INIT FILTERS ********************************************************************************************/
	FSGrid.initFilters = function (gridId) {
	    var config = $(gridId).data('clientsideconfig');
	    if (config && config.filterBefore == true) {
	        $('.advancedFilter').modal('show');
	    }
	};
	
	/** Bulk action without dialog - start ********************************************************************************/
	FSGrid.initBulkActionWithoutDialog = function (gridId) {
	    // toggle checked cell checkboxs
	    $(gridId + ' .action-bulk-without-dialog-head-cell').click(function () {
	        $(gridId + ' .action-bulk-without-dialog-body-cell').prop('checked', $(this).prop('checked'));
	    });
	
	    // handle button form multi actions
	    $(gridId + ' .action-bulk-without-dialog-multi-actions-send-btn').click(function () {
	        // selected rows
	        var ids = FSGrid.bulkActionWithoutDialogGetIds(gridId);
	
	        // link for action
	        var link = $(gridId + ' .action-bulk-without-dialog-multi-actions-select-action').val();
	
	        // redirect
	        if (ids.length != 0) {
	            window.location.replace(link + '&' + $.param({ ids: ids }));
	        } else {
	            alert('Není vybrán žádný řádek.');
	        }
	    });
	
	    // handle button form single action
	    $(gridId + ' .action-bulk-without-dialog-single-action').click(function () {
	        // selected rows
	        var ids = FSGrid.bulkActionWithoutDialogGetIds(gridId);
	
	        // link for action
	        var link = $(gridId + ' .action-bulk-without-dialog-single-action').data('link');
	
	        // redirect
	        if (ids.length != 0) {
	            window.location.replace(link + '&' + $.param({ ids: ids }));
	        } else {
	            alert('Není vybrán žádný řádek.');
	        }
	    });
	};
	
	/**
	 * @param gridId
	 * @return {Array}
	 */
	FSGrid.bulkActionWithoutDialogGetIds = function (gridId) {
	    var ids = [];
	    $(gridId + ' .action-bulk-without-dialog-body-cell:checked').each(function () {
	        ids.push($(this).data('primarykey'));
	    });
	
	    var memoryId = $('#rememberSelectedId').val();
	    if (memoryId) {
	        var memoryIDs = FSGrid.getRememberSelectedIDs(memoryId);
	        for (var key in memoryIDs) {
	            ids.push(key);
	        }
	    }
	
	    return ids;
	};
	/** Bulk action without dialog - end **********************************************************************************/
	
	/** Helpers ***********************************************************************************************************/
	
	/**
	 * @param string gridId
	 */
	FSGrid.showSpin = function (gridId) {
	    //$(gridId).spin();
	    waiter_open('medium', gridId + '-bulk-action-dialog .panel-body');
	    $(gridId + '-content').css('opacity', '0.5');
	};
	
	/**
	 * @param string gridId
	 */
	FSGrid.hideSpin = function (gridId) {
	    //$(gridId).spin(false);
	    waiter_close();
	    $(gridId + '-content').css('opacity', '1');
	};
	
	/**
	 *
	 */
	FSGrid.bulkFormButtonClick = function (event) {
	    event.preventDefault();
	    $(this).closest('form').submit();
	};
	
	/** REMEMBER SELECTED ROWS THROUGH ALL PAGES *************************************************************************/
	
	/**
	 * Clean memory
	 * @param gridId - gridId/parentId (eg. for different folders to have same ID)
	 */
	FSGrid.rememberSelectedClean = function (gridId) {
	    window.localStorage.removeItem(gridId + '.rememberSelected');
	};
	
	/**
	 * Init memory
	 * @param gridId - gridId/parentId (eg. for different folders to have same ID)
	 */
	FSGrid.rememberSelectedInit = function (gridId) {
	    $(window).unload(function () {
	        var items = window.localStorage.getItem(gridId + '.rememberSelected');
	        if (items) {
	            items = JSON.parse(items);
	        } else {
	            items = {};
	        }
	        $('#' + gridId + ' input[data-primarykey]').each(function () {
	            var primaryKey = $(this).data('primarykey');
	            if ($(this).is(':checked')) {
	                items[primaryKey] = primaryKey;
	            } else {
	                delete items[primaryKey];
	            }
	        });
	
	        window.localStorage.setItem(gridId + '.rememberSelected', JSON.stringify(items));
	    });
	
	    var items = window.localStorage.getItem(gridId + '.rememberSelected');
	    if (items) {
	        items = JSON.parse(items);
	        for (var primaryKey in items) {
	            $('#' + gridId + ' input[data-primarykey=' + primaryKey + ']').prop('checked', true);
	        }
	    }
	
	    var grid = $('#' + gridId + '.fs-grid').length ? $('#' + gridId + '.fs-grid') : $('#' + gridId + ' .fs-grid');
	    grid.append('<input type="hidden" id="rememberSelectedId" value="' + gridId + '">');
	};
	
	/**
	 * Get count
	 * @param gridId - gridId/parentId (eg. for different folders to have same ID)
	 * @returns count
	 */
	FSGrid.getRememberSelectedCount = function (gridId) {
	    var items = window.localStorage.getItem(gridId + '.rememberSelected');
	    if (items) {
	        items = JSON.parse(items);
	        return Object.keys(items).length;
	    } else {
	        return 0;
	    }
	};
	
	/**
	 * Get rememembered IDs
	 * @param gridId
	 * @returns {}
	 */
	FSGrid.getRememberSelectedIDs = function (gridId) {
	    var items = window.localStorage.getItem(gridId + '.rememberSelected');
	    if (items) {
	        return JSON.parse(items);
	    } else {
	        return {};
	    }
	};

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var FSGridSnippet = {};
	exports.default = FSGridSnippet;
	
	/** @type {Array} */
	
	FSGridSnippet.bulkActionRequestPool = [];
	FSGridSnippet.bulkActionRequestTimeout = null;
	FSGridSnippet.grids = {};
	FSGridSnippet.inited = false;
	
	FSGridSnippet.initAll = function () {
	    $('.fs-grid-snippet').each(function () {
	        FSGridSnippet.init('#' + $(this).attr('id'));
	    });
	};
	
	FSGridSnippet.init = function (gridId) {
	    // init logging
	    FSGridSnippet.logStart('init');
	
	    // update GUI config
	    FSGridSnippet.loadConfig(gridId);
	
	    // apply GUI config
	    FSGridSnippet.applyConfig(gridId);
	
	    // filter to ribbon
	    FSGridSnippet.filterToRibbon();
	
	    // init forms - filters etc.
	    FSGridSnippet.initForms(gridId);
	
	    // columns resizable
	    FSGridSnippet.initColumnsResizable(gridId);
	
	    // IE
	    FSGridSnippet.fixBrowserCompatibility(gridId);
	
	    // checkboxes (shift selecting etc.)
	    FSGridSnippet.initCheckboxes(gridId);
	
	    // skip other inits - they are already initialized
	    if (FSGridSnippet.grids[gridId].inited == true) {
	        FSGridSnippet.fire(gridId, 'ready');
	        FSGridSnippet.logEnd('init');
	        return;
	    }
	    FSGridSnippet.grids[gridId].inited = true;
	
	    // config save event
	    FSGridSnippet.saveConfig(gridId);
	
	    // modal action
	    FSGridSnippet.initModalAction(gridId);
	
	    // bulk action
	    FSGridSnippet.initBulkAction(gridId);
	
	    // handle confirm action
	    FSGridSnippet.initHandleConfirmAction(gridId);
	
	    // init filters
	    FSGridSnippet.initFilters(gridId);
	
	    // bulk without dialog
	    FSGridSnippet.initBulkActionWithoutDialog(gridId);
	
	    // highlighting row
	    FSGridSnippet.highlightingRow(gridId);
	
	    // init paging
	    FSGridSnippet.initLinks(gridId);
	
	    // init column sorting
	    FSGridSnippet.initSorting(gridId);
	
	    // init grid export
	    FSGridSnippet.initExport(gridId);
	
	    // fire API events
	    FSGridSnippet.fire(gridId, 'ready');
	    FSGridSnippet.inited = true;
	
	    FSGridSnippet.logEnd('init');
	};
	
	FSGridSnippet.loadGrid = function (gridId, url, data, json) {
	    FSGridSnippet.logStart('loadGridFnc');
	
	    var snippetArea = '#snippet-' + gridId.substr(6) + '-GridSnippet';
	    var config = FSGridSnippet.grids[gridId].config;
	
	    if (config.bulkAction && config.bulkAction.state != 'close') FSGridSnippet.refreshDialogByDilogState('close', gridId);
	    $('#grid_filter_to_ribbon').html($('.ribbon .tab-pane.active > ul .ribbon-grid-filter-group').detach());
	
	    $.ajax({
	        url: url,
	        type: typeof data != 'undefined' ? 'POST' : 'GET',
	        data: typeof data != 'undefined' ? data : null,
	        contentType: typeof json != 'undefined' ? 'application/json' : 'application/x-www-form-urlencoded; charset=UTF-8',
	        beforeSend: function beforeSend() {
	            waiter_close('body');waiter_open('medium', snippetArea);FSGridSnippet.logStart('loadGridAjax');
	        },
	        error: function error(jqXHR) {
	            FSGridSnippet.logEnd('loadGridAjax');waiter_close(snippetArea);if (jqXHR.readyState == 0 && jqXHR.status == 0) return;alert(FSGridSnippet.grids[gridId].config.errorMessage);
	        },
	        success: function success(payload) {
	            FSGridSnippet.logEnd('loadGridAjax');
	            waiter_close(snippetArea);
	            if (payload.snippets) {
	                FSGridSnippet.logStart('loadGridDOM');for (var id in payload.snippets) {
	                    if (payload.snippets[id].indexOf(gridId.substring(1) + '-advancedFilters') == -1) document.getElementById(id).innerHTML = payload.snippets[id];else $('#' + id).html(payload.snippets[id]);
	                }FSGridSnippet.logEnd('loadGridDOM');FSGridSnippet.init(gridId);
	            }
	            if (payload.msg) {
	                alert(payload.msg);FSGridSnippet.filterToRibbon();
	            }
	        },
	        off: ['unique']
	    });
	
	    FSGridSnippet.logEnd('loadGridFnc');
	};
	
	FSGridSnippet.loadConfig = function (gridId) {
	    FSGridSnippet.logStart('loadConfig');
	
	    // load grid settings from html page
	    var addToConfig = $(gridId).data('clientsideconfig');
	
	    if (typeof FSGridSnippet.grids[gridId] === 'undefined') {
	        FSGridSnippet.grids[gridId] = {};
	        FSGridSnippet.grids[gridId].config = {};
	    } else if (FSGridSnippet.grids[gridId].config['filterId'] != addToConfig['filterId'] || addToConfig['isFirstStateResetted'] || !addToConfig['isJsActive']) {
	        FSGridSnippet.grids[gridId].config['sorting'] = [];
	        FSGridSnippet.grids[gridId].config['columnFilters'] = [];
	    }
	
	    var config = FSGridSnippet.grids[gridId].config;
	
	    for (var key in addToConfig) {
	        config[key] = addToConfig[key];
	    }
	
	    // load grid settings from browser
	    if (FSGridSnippet.grids[gridId].inited != true) {
	        var addToConfig = window.localStorage.getItem(gridId);
	        if (addToConfig) {
	            addToConfig = JSON.parse(addToConfig);
	            if (config['filterId'] != addToConfig['filterId'] || config['isFirstStateResetted'] || !config['isJsActive']) {
	                addToConfig['sorting'] = [];
	                addToConfig['columnFilters'] = [];
	            }
	            delete addToConfig['filterId'];
	            for (var key in addToConfig) {
	                config[key] = addToConfig[key];
	            }
	        }
	    }
	
	    // fill grid data
	    config['gridData'] = $(gridId + '-body tbody tr');
	
	    // set variables to defaults if they are not set
	    config['sorting'] = config['sorting'] || [];
	    config['columnFilters'] = config['columnFilters'] || [];
	    config['columnWidths'] = config['columnWidths'] || {};
	    config['filterId'] = config['filterId'] || null;
	    config['sortingCache'] = [];
	    if (config.hasBulkAction) {
	        config['bulkAction'] = config['bulkAction'] || {
	            state: 'close',
	            sidebar: false,
	            panels: {},
	            css: {
	                'height': $(gridId + '-bulk-action-dialog').data('minheight'),
	                'width': $(gridId + '-bulk-action-dialog').data('minwidth')
	            }
	        };
	        config['bulkAction'].panels = config['bulkAction'].panels || {};
	        config['bulkAction'].state = 'close';
	    }
	
	    // set persistent variables which are saved to browser
	    config['persistent'] = ['bulkAction', 'columnWidths', 'sorting', 'filterId', 'columnFilters'];
	
	    FSGridSnippet.logEnd('loadConfig');
	};
	
	FSGridSnippet.saveConfig = function (gridId) {
	    $(window).on('beforeunload', function (event) {
	        var config = FSGridSnippet.grids[gridId].config;
	        var configToSave = {};
	        for (var i in config.persistent) {
	            configToSave[config.persistent[i]] = config[config.persistent[i]];
	        }
	        window.localStorage.setItem(gridId, JSON.stringify(configToSave));
	    });
	};
	
	FSGridSnippet.applyConfig = function (gridId) {
	    FSGridSnippet.logStart('applyConfig');
	
	    var config = FSGridSnippet.grids[gridId].config;
	
	    // sorting
	    if (config.isJsActive && config.sorting.length) {
	        FSGridSnippet.applySorting(gridId);
	    }
	
	    // column filters
	    if (config.isJsActive && config.columnFilters.length) {
	        for (var i in config.columnFilters) {
	            if (config.columnFilters[i]) {
	                var input = $(gridId + '-body thead th input[data-filter="' + config.columnFilters[i].name + '"]');
	                if (input.length) {
	                    $(gridId + '-body thead th input[data-filter="' + config.columnFilters[i].name + '"]').val(config.columnFilters[i].value);
	                } else {
	                    config.columnFilters = [];
	                    $(gridId + '-body thead th input').val('');
	                    return;
	                }
	            }
	        }
	        $(gridId + '-body thead [data-filter]').toggle();
	        FSGridSnippet.applyFilters(gridId);
	    }
	
	    FSGridSnippet.logEnd('applyConfig');
	};
	
	FSGridSnippet.initForms = function (gridId) {
	    FSGridSnippet.logStart('initForms');
	
	    $(gridId + ' form').each(function () {
	        Nette.initForm($(this)[0]);
	    });
	    $('#filterQuickFormRibbon').each(function () {
	        Nette.initForm($(this)[0]);
	    });
	    if (FSGridSnippet.grids[gridId].config['filterBefore'] == true) {
	        FSGridSnippet.fire(gridId, 'filters.ready');
	    }
	
	    FSGridSnippet.logEnd('initForms');
	};
	
	FSGridSnippet.initLinks = function (gridId) {
	    FSGridSnippet.logStart('initLinks');
	
	    // general links
	    $(document).on('click', gridId + '-content a.grid-ajax, ' + gridId + '-advancedFilters a.grid-ajax', function (event) {
	        event.preventDefault();
	        $('.advancedFilter').modal('hide');
	        FSGridSnippet.loadGrid(gridId, $(this).attr('href'));
	    });
	
	    // filter to ribbon
	    if (FSGridSnippet.inited == false) $(document).on('click', '.ribbon .grid-ajax', function (event) {
	        event.preventDefault();
	        FSGridSnippet.loadGrid(gridId, $(this).attr('href'));
	    });
	
	    // responsive links
	    $(document).on('click', gridId + '-body .details-show-switcher .glyphicon', function (event) {
	        event.preventDefault();
	        $(this).parent().parent().toggleClass('details-show');
	        $(this).toggleClass('glyphicon-chevron-down glyphicon-chevron-up');
	    });
	
	    FSGridSnippet.logEnd('initLinks');
	};
	
	/**
	 * @param gridId
	 */
	FSGridSnippet.initCheckboxes = function (gridId) {
	    FSGridSnippet.logStart('initCheckboxes');
	
	    $(gridId + '-body table').checkboxes('range', true);
	
	    FSGridSnippet.logEnd('initCheckboxes');
	};
	
	/**
	 * @param gridId
	 */
	FSGridSnippet.highlightingRow = function (gridId) {
	    FSGridSnippet.logStart('highlightingRow');
	
	    $(document).on('click', gridId + '-body tbody tr', function () {
	        if ($(this).hasClass('higlighted')) {
	            $(this).removeClass('higlighted');
	        } else {
	            $(gridId + '-body tbody tr.higlighted').removeClass('higlighted');
	            $(this).addClass('higlighted');
	        }
	    });
	
	    FSGridSnippet.logEnd('highlightingRow');
	};
	
	/**
	 * Setup columns resizable.
	 */
	FSGridSnippet.initColumnsResizable = function (gridId) {
	    FSGridSnippet.logStart('initColumnsResizable');
	
	    var config = FSGridSnippet.grids[gridId].config;
	
	    if (isLayoutMobile()) return;
	
	    $(gridId + '-body th[data-sorting_type=Icon]').each(function () {
	        var name = $(this).attr('id').replace('drag-table-', '');
	        addStylesheetRule(gridId + '-body tbody td.grid-cell-' + name + ', ' + gridId + '-body thead th.grid-header-' + name + ' { width: ' + (($(this).children('span').width() || 0) + 80) + 'px; text-align: center; flex-grow: 0 }');
	    });
	
	    if (config && config.columnsResizable == true) {
	        $(gridId + '-body th[id]').resizable({
	            handles: "e",
	            minWidth: 50,
	            aspectRatio: false,
	            start: function start(event, ui) {
	                ui.element.css('flex-grow', '0');
	            },
	            stop: function stop(event, ui) {
	                var name = ui.element.attr('id').replace('drag-table-', '');
	                var width = ui.element.outerWidth();
	                ui.element.width('');
	                addStylesheetRule(gridId + '-body tbody td.grid-cell-' + name + ', ' + gridId + '-body thead th.grid-header-' + name + ' { width: ' + width + 'px; flex-grow: 0 }');
	                FSGridSnippet.fixBrowserCompatibility(gridId);
	                config.columnWidths[name] = width;
	            }
	        });
	
	        for (var name in config.columnWidths) {
	            addStylesheetRule(gridId + '-body tbody td.grid-cell-' + name + ', ' + gridId + '-body thead th.grid-header-' + name + ' { width: ' + config.columnWidths[name] + 'px; flex-grow: 0 }');
	        }
	    }
	
	    FSGridSnippet.logEnd('initColumnsResizable');
	};
	
	/**
	 * Action modal
	 */
	
	FSGridSnippet.initModalAction = function (gridId) {
	    FSGridSnippet.logStart('initModalAction');
	
	    $(document).on('click', gridId + '-content .grid-action-btn', function () {
	        FSGridSnippet.processModalAction(gridId, $(this).data('handleonclick'), $(this).data('target'));
	    });
	
	    FSGridSnippet.logEnd('initModalAction');
	};
	
	FSGridSnippet.processModalAction = function (gridId, url, modalTarget) {
	    FSGridSnippet.logStart('processModalAction');
	
	    var modalFade = $(modalTarget);
	    var modalDialog = modalFade.find('.modal-dialog:eq(0)');
	
	    // prepare Ajax request
	    var req = {
	        url: url,
	        beforeSend: function beforeSend() {
	            FSGridSnippet.logStart('processModalActionAjax');
	            modalDialog.html('<div/>');
	            waiter_open('large');
	        },
	        success: function success(data, textStatus, jqXHR) {
	            FSGridSnippet.logEnd('processModalActionAjax');
	            FSGridSnippet.logStart('processModalActionDOM');
	            if (jqXHR.responseJSON) {
	                flashMessage(jqXHR.responseJSON.message, jqXHR.responseJSON.type);
	                modalFade.modal('hide');
	            } else {
	                modalDialog.html(data);
	                modalFade.modal('handleUpdate');
	                FSForms.init();
	            }
	            FSGridSnippet.logEnd('processModalActionDOM');
	        },
	        error: function error(data, textStatus, jqXHR) {
	            flashMessageWarning(FSGridSnippet.grids[gridId].config.errorActionMessage);
	            modalFade.modal('hide');
	        },
	        statusCode: {
	            500: function _() {
	                flashMessageWarning(FSGridSnippet.grids[gridId].config.errorActionMessage);
	            }
	        },
	        complete: function complete(jqXHR, textStatus) {
	            waiter_close();
	        }
	    };
	
	    // send Ajax request
	    $.ajax(req);
	
	    FSGridSnippet.logEnd('processModalAction');
	};
	
	/** BULK ACTIONS ******************************************************************************************************/
	
	/**
	 * Inits bulk action for grid with id.
	 * @param id
	 */
	FSGridSnippet.initBulkAction = function (gridId) {
	    FSGridSnippet.logStart('initBulkAction');
	
	    var config = FSGridSnippet.grids[gridId].config;
	    if (!config.hasBulkAction) return;
	
	    $(document).on('click', gridId + '-body .grid-bulk-action-head', FSGridSnippet.onClickHeadCheckbox); // add event on head checkbox
	    $(document).on('change', gridId + '-body .grid-bulk-action-cell', FSGridSnippet.onClickCellCheckbox); // add event on cell checkbox
	    $(document).on('click', gridId + '-bulk-action-dialog .btn-close', FSGridSnippet.onClickButtonClose); // add event on button close on dialog
	    $(document).on('click', '#sidebarRight-sidebar .btn-close', FSGridSnippet.onClickButtonClose); // add event on button close on dialog
	    $(document).on('click', '#sidebarRight-sidebar-close-button', FSGridSnippet.onClickButtonCloseSidebar); // add event on button close on dialog
	    $(document).on('click', gridId + '-bulk-action-dialog .btn-min', FSGridSnippet.onClickButtonMin); // add event on button min on dialog
	    $(document).on('click', gridId + '-bulk-action-dialog .btn-link', FSGridSnippet.onClickButtonLock); // add event on button lock on dialog
	    $(document).on('click', '#sidebarRight-sidebar-unlock-button', FSGridSnippet.onClickButtonUnlock); // add event on button unlock on dialog
	    $(document).on('click', '.grid-actionBulkAction', FSGridSnippet.onClickToggleSelectionMode); // add event on button lock on dialog
	    $(document).on('click', '.grid-actionBulkActionPanelButton', FSGridSnippet.onClickButtonActionMobile); // add event on button lock on dialog
	    $(document).on('click', '.bulk_dialog_show_hide_panel_button', FSGridSnippet.bulkDialogPanelSwitch);
	    $(document).on('click', '.grid-bulk-content .bulk-form-button .ribbon-button', FSGridSnippet.bulkFormButtonClick);
	
	    // prepare bulk request pull
	    if (Array.isArray(FSGridSnippet.bulkActionRequestPool[gridId]) == false) {
	        FSGridSnippet.bulkActionRequestPool[gridId] = [];
	    }
	
	    FSGridSnippet.logEnd('initBulkAction');
	};
	
	/**
	 * This method open bulk dialog and send AJAX request.
	 * @param gridId
	 */
	FSGridSnippet.processBulkAction = function (gridId) {
	    FSGridSnippet.logStart('processBulkAction');
	
	    var config = FSGridSnippet.grids[gridId].config;
	    var length = $(gridId + '-body .grid-bulk-action-cell:checked').length;
	
	    if (length > 0 && config.bulkAction.state == 'close') {
	        this.refreshDialogByDilogState('open', gridId);
	        this.sendBulkActionRequest(gridId);
	    } else if (length > 0 && config.bulkAction.state == 'min') {
	        this.sendBulkActionRequest(gridId);
	    } else if (length > 0 && config.bulkAction.state == 'open') {
	        this.sendBulkActionRequest(gridId);
	    } else if (length == 0) {
	        this.refreshDialogByDilogState('close', gridId);
	        FSGridSnippet.abortAllBulkActionRequest(gridId);
	    }
	
	    FSGridSnippet.logEnd('processBulkAction');
	};
	
	/**
	 * This method open/close parts of bulk dialog.
	 */
	FSGridSnippet.bulkDialogPanelSwitch = function () {
	    FSGridSnippet.logStart('bulkDialogPanelSwitch');
	
	    var gridId = FSGridSnippet.getGridId($('.grid-bulk-action-head'));
	    var target = $(this).data('target');
	    var config = FSGridSnippet.grids[gridId].config;
	    var id = $(this).data('bulkstate');
	
	    if (target) {
	        var area = $('#' + $(this).data("target"));
	    } else {
	        var area = $(this).parent().parent().find(".panel-body");
	    }
	
	    area.toggle();
	    $(this).children('span').toggleClass('glyphicon-chevron-down glyphicon-chevron-up');
	
	    config.bulkAction.panels[id] = area.is(':visible');
	
	    FSGridSnippet.logEnd('bulkDialogPanelSwitch');
	};
	
	/**
	 * This method open/close parts of bulk dialog from memory.
	 * @param gridId
	 */
	FSGridSnippet.bulkDialogPanelSwitchInit = function () {
	    FSGridSnippet.logStart('bulkDialogPanelSwitchInit');
	
	    var gridId = FSGridSnippet.getGridId($('.grid-bulk-action-head'));
	    var config = FSGridSnippet.grids[gridId].config;
	
	    $('.bulk_dialog_show_hide_panel_button').each(function () {
	        var id = $(this).data('bulkstate');
	
	        if (typeof config.bulkAction.panels[id] != 'undefined' && config.bulkAction.panels[id] == false) {
	            $(this).trigger('click');
	        }
	    });
	
	    FSGridSnippet.logEnd('bulkDialogPanelSwitchInit');
	};
	
	/**
	 * @param {String} state
	 * @param {String} gridId
	 */
	FSGridSnippet.refreshDialogByDilogState = function (stateDialog, gridId, sidebar) {
	    FSGridSnippet.logStart('refreshDialogByDilogState');
	
	    var config = FSGridSnippet.grids[gridId].config;
	    var dialog = $(gridId + '-bulk-action-dialog');
	
	    if (typeof sidebar == 'boolean') {
	        config.bulkAction.sidebar = sidebar;
	    }
	
	    // open dialog
	    if (stateDialog == 'open' || stateDialog == 'max') {
	        config.bulkAction.state = 'open';
	
	        dialog.removeClass('minimized');
	
	        $('.grid-actionBulkActionPanel').removeClass('hidden');
	
	        if (config.bulkAction.sidebar == true) {
	            if (dialog.is(':visible')) dialog.hide();
	            var title = dialog.find('.panel-title').text();
	            $('#vertical_right_text_sidebar strong, #sidebarRight-sidebar-title strong').text(title);
	
	            showSidebarRight();
	            return;
	        }
	
	        if (!$('#sidebarRight-sidebar').hasClass('hidden')) {
	            hideSidebarRight();
	        }
	
	        dialog.css(config.bulkAction.css);
	
	        var fixPosition = function fixPosition() {
	            dialog.css({
	                'top': 'auto',
	                'left': 'auto',
	                'bottom': Math.max($(window).height() - dialog.offset().top - dialog.outerHeight(), 0) + 'px',
	                'right': Math.max($(window).width() - dialog.offset().left - dialog.outerWidth(), 0) + 'px',
	                'max-height': 'calc(100vh - ' + Math.max($(window).height() - dialog.offset().top - dialog.outerHeight(), 0) + 'px)',
	                'max-width': 'calc(100vw - ' + Math.max($(window).width() - dialog.offset().left - dialog.outerWidth()) + 'px)'
	            });
	        };
	        var preparePosition = function preparePosition() {
	            dialog.css({
	                top: dialog.position().top,
	                left: dialog.position().left,
	                bottom: 'auto',
	                right: 'auto'
	            });
	        };
	        dialog.draggable({
	            cancel: '.draggableOff',
	            containment: 'document',
	            start: preparePosition,
	            stop: fixPosition
	        });
	        dialog.resizable({
	            handles: 'all',
	            containment: 'document',
	            create: function create(event, ui) {
	                $('.ui-icon-gripsmall-diagonal-se').remove();
	            },
	            start: preparePosition,
	            stop: fixPosition
	        });
	        // set icon
	        dialog.find('.btn-min').html('<span class="glyphicon glyphicon-chevron-down"></span>');
	        dialog.show('slow');
	    }
	    // close dialog
	    else if (stateDialog == 'close') {
	            config.bulkAction.state = 'close';
	
	            dialog.find('.panel-body').html('');
	            $('.grid-actionBulkActionPanel').addClass('hidden');
	            $('#sidebarRight-sidebar').removeClass('sidebarRight-sidebar-visible');
	            $('#sidebarLeft-sidebar, #sidebarLeft-content').removeClass('responsive-hidden');
	
	            if (config.bulkAction.sidebar == true || !$('#sidebarRight-sidebar').hasClass('hidden')) {
	                hideSidebarRight();
	                return;
	            }
	
	            if (dialog.is(':visible') && !dialog.hasClass('minimized')) {
	                config.bulkAction.css = {
	                    'height': dialog.css('height'),
	                    'width': dialog.css('width')
	                };
	            }
	
	            dialog.hide('slow');
	        }
	        // min
	        else if (stateDialog == 'min') {
	                var prevCSS = {
	                    'height': dialog.css('height'),
	                    'width': dialog.css('width')
	                };
	
	                // invert color
	                dialog.addClass('minimized');
	
	                // change icon
	                dialog.find('.btn-min').html('<span class="glyphicon glyphicon-chevron-up"></span>');
	
	                // disable resizable
	                dialog.resizable('destroy');
	
	                // css
	                dialog.css({
	                    'height': 'auto'
	                });
	
	                config.bulkAction.css = prevCSS;
	                config.bulkAction.state = 'min';
	            }
	
	    FSGridSnippet.logEnd('refreshDialogByDilogState');
	};
	
	/** Bulk action - handles - begin *************************************************************************************/
	
	/**
	 * Callback on click head checkbox.
	 */
	FSGridSnippet.onClickHeadCheckbox = function () {
	    FSGridSnippet.logStart('onClickHeadCheckbox');
	
	    var gridId = FSGridSnippet.getGridId($(this));
	    $(gridId + '-body .grid-bulk-action-cell').prop('checked', $(this).prop('checked')); // toggle checked cell checkboxs
	    FSGridSnippet.processBulkAction(gridId);
	
	    FSGridSnippet.logEnd('onClickHeadCheckbox');
	};
	
	/**
	 * Callback on click checkbox in cell.
	 */
	FSGridSnippet.onClickCellCheckbox = function () {
	    FSGridSnippet.logStart('onClickCellCheckbox');
	
	    FSGridSnippet.processBulkAction(FSGridSnippet.getGridId($(this)));
	
	    FSGridSnippet.logEnd('onClickCellCheckbox');
	};
	
	/**
	 * Callback on click button close in bulk dialog.
	 */
	FSGridSnippet.onClickButtonClose = function () {
	    FSGridSnippet.logStart('onClickButtonClose');
	
	    var gridId = FSGridSnippet.getGridId($('.grid-bulk-action-head'));
	    FSGridSnippet.refreshDialogByDilogState('close', gridId);
	    $(gridId + '-body .grid-bulk-action-cell:checked').prop('checked', false);
	    $(gridId + '-body .grid-bulk-action-head:checked').prop('checked', false);
	    $('.fs-grid-snippet').removeClass('selection-active');
	
	    FSGridSnippet.logEnd('onClickButtonClose');
	};
	
	/**
	 * Callback on click button close in sidebar dialog.
	 */
	FSGridSnippet.onClickButtonCloseSidebar = function () {
	    FSGridSnippet.logStart('onClickButtonCloseSidebar');
	
	    $('.grid-bulk-action-dialog .btn-close').trigger('click');
	
	    FSGridSnippet.logEnd('onClickButtonCloseSidebar');
	};
	
	/**
	 *
	 */
	FSGridSnippet.onClickButtonMin = function () {
	    FSGridSnippet.logStart('onClickButtonMin');
	
	    var gridId = FSGridSnippet.getGridId($(this));
	    var config = FSGridSnippet.grids[gridId].config;
	
	    if (config.bulkAction.state == 'open') {
	        FSGridSnippet.refreshDialogByDilogState('min', gridId);
	    } else if (config.bulkAction.state == 'min') {
	        FSGridSnippet.refreshDialogByDilogState('max', gridId);
	    }
	
	    FSGridSnippet.logEnd('onClickButtonMin');
	};
	
	/**
	 *
	 */
	FSGridSnippet.onClickButtonLock = function () {
	    FSGridSnippet.logStart('onClickButtonLock');
	
	    var gridId = FSGridSnippet.getGridId($('.grid-bulk-action-head'));
	    FSGridSnippet.refreshDialogByDilogState('open', gridId, true);
	    FSGridSnippet.sendBulkActionRequest(gridId);
	
	    FSGridSnippet.logEnd('onClickButtonLock');
	};
	
	/**
	 *
	 */
	FSGridSnippet.onClickButtonActionMobile = function () {
	    FSGridSnippet.logStart('onClickButtonActionMobile');
	
	    FSGridSnippet.onClickButtonLock();
	    $('#sidebarRight-sidebar').addClass('sidebarRight-sidebar-visible');
	    $('#sidebarLeft-sidebar, #sidebarLeft-content').addClass('responsive-hidden');
	
	    FSGridSnippet.logEnd('onClickButtonActionMobile');
	};
	
	/**
	 *
	 */
	FSGridSnippet.onClickToggleSelectionMode = function () {
	    FSGridSnippet.logStart('onClickToggleSelectionMode');
	
	    var gridId = FSGridSnippet.getGridId($(this));
	
	    $(gridId + '-content').toggleClass('selection-active');
	    if (!$(gridId + '-content').hasClass('selection-active')) {
	        $(gridId + '-body .grid-bulk-action-cell:checked').prop('checked', false);
	        $(gridId + '-body .grid-bulk-action-head:checked').prop('checked', false);
	        $('.grid-actionBulkActionPanel').addClass('hidden');
	    }
	
	    FSGridSnippet.logEnd('onClickToggleSelectionMode');
	};
	
	/**
	 *
	 */
	FSGridSnippet.onClickButtonUnlock = function () {
	    FSGridSnippet.logStart('onClickButtonUnlock');
	
	    var gridId = FSGridSnippet.getGridId($('.grid-bulk-action-head'));
	    FSGridSnippet.refreshDialogByDilogState('open', gridId, false);
	    FSGridSnippet.sendBulkActionRequest(gridId);
	
	    FSGridSnippet.logEnd('onClickButtonUnlock');
	};
	
	/**
	 *
	 */
	FSGridSnippet.addBulkActionsCloseButton = function () {
	    FSGridSnippet.logStart('addBulkActionsCloseButton');
	
	    $('#sidebarRight-sidebar-title .bulk_dialog_show_hide_panel_button').remove();
	    if ($('#sidebarRight-sidebar-content #bulk_actions').length > 0) {
	        $('#sidebarRight-sidebar-title').append('<div class = "bulk_dialog_show_hide_panel_button close" data-bulkstate = "bulk_actions" data-target = "bulk_actions"><span class="bulk_edit_form bulk_dialog_show_hide_panel_glyphicon glyphicon glyphicon-chevron-up"></span></div>');
	    }
	
	    FSGridSnippet.logEnd('addBulkActionsCloseButton');
	};
	
	/** Bulk action - handles - end ***************************************************************************************/
	
	/**
	 * Sends Ajax request for bulk action.
	 * @param gridId
	 * @param dialogId
	 * @param primaryKeys
	 */
	FSGridSnippet.sendBulkActionRequest = function (gridId) {
	    FSGridSnippet.logStart('sendBulkActionRequest');
	
	    var gridId = gridId;
	    var config = FSGridSnippet.grids[gridId].config;
	    var target = config.bulkAction.sidebar == true ? '#sidebarRight-sidebar-content' : gridId + '-bulk-action-dialog .panel-body';
	    var unTarget = config.bulkAction.sidebar != true ? '#sidebarRight-sidebar-content' : gridId + '-bulk-action-dialog .panel-body';
	
	    $(target).html('<div/>');
	    $(unTarget).html('<div/>');
	    waiter_open('medium', target);
	
	    if (FSGridSnippet.bulkActionRequestTimeout) {
	        clearTimeout(FSGridSnippet.bulkActionRequestTimeout);
	    }
	
	    FSGridSnippet.bulkActionRequestTimeout = setTimeout(function () {
	        var state = { 'bulkAction': { 'selectedRows': [] } };
	        $(gridId + '-body .grid-bulk-action-cell:checked').each(function () {
	            state.bulkAction.selectedRows.push($(this).data('primarykey'));
	        });
	
	        if (state.bulkAction.selectedRows.length == 0) {
	            FSGridSnippet.refreshDialogByDilogState('close', gridId);
	            $(gridId + '-body .grid-bulk-action-cell:checked').prop('checked', false);
	            $(gridId + '-body .grid-bulk-action-head:checked').prop('checked', false);
	            return;
	        }
	
	        // abort all prev request
	        FSGridSnippet.abortAllBulkActionRequest(gridId);
	
	        // prepare Ajax request
	        var req = {
	            method: 'POST',
	            url: $(gridId + '-bulk-action-dialog').data('handleonclick'),
	            data: state,
	            beforeSend: function beforeSend(jqXHR) {
	                // adds current request into pool
	                FSGridSnippet.bulkActionRequestPool[gridId].push(jqXHR);
	            },
	            success: function success(data, textStatus, jqXHR) {
	                waiter_close();
	                if (jqXHR.responseJSON) {
	                    flashMessage(jqXHR.responseJSON.message, jqXHR.responseJSON.type);
	                    $(gridId + '-bulk-action-dialog .btn-close').click();
	                } else {
	                    $(target).html(data);
	                    $(target).find('form').each(function () {
	                        window.Nette.initForm(this);
	                    });
	                    FSGridSnippet.bulkDialogPanelSwitchInit();
	                }
	                FSGridSnippet.addBulkActionsCloseButton();
	            },
	            error: function error(jqXHR) {
	                if (jqXHR.statusText == 'abort') {
	                    return;
	                } else if ($(gridId + '-bulk-action-dialog').data('errormsg')) {
	                    flashMessageWarning($(gridId + '-bulk-action-dialog').data('errormsg'));
	                    $(gridId + '-bulk-action-dialog .btn-close').click();
	                }
	            },
	            statusCode: {
	                500: function _() {
	                    flashMessageWarning(FSGridSnippet.grids[gridId].config.errorActionMessage);
	                }
	            }
	        };
	
	        // send Ajax request
	        $.ajax(req);
	    }, 10);
	
	    FSGridSnippet.logEnd('sendBulkActionRequest');
	};
	
	/**
	 * Aborts all request for bulk action.
	 * @param dialogId
	 */
	FSGridSnippet.abortAllBulkActionRequest = function (dialogId) {
	    FSGridSnippet.logStart('abortAllBulkActionRequest');
	
	    FSGridSnippet.bulkActionRequestPool[dialogId].forEach(function (jqXHR, index) {
	        jqXHR.abort();
	        FSGridSnippet.bulkActionRequestPool[dialogId].splice(index, 1);
	    });
	
	    FSGridSnippet.logEnd('abortAllBulkActionRequest');
	};
	
	/** HANDLE CONFIRM ACTIONS ********************************************************************************************/
	
	/**
	 * @param string gridId
	 */
	FSGridSnippet.initHandleConfirmAction = function (gridId) {
	    FSGridSnippet.logStart('initHandleConfirmAction');
	
	    var options = {};
	    $(gridId + '-body .grid-cell-action-confirm-handle').popover(options);
	
	    FSGridSnippet.logEnd('initHandleConfirmAction');
	};
	
	/** INIT FILTERS ********************************************************************************************/
	FSGridSnippet.initFilters = function (gridId) {
	    FSGridSnippet.logStart('initFilters');
	
	    var config = FSGridSnippet.grids[gridId].config;
	    if (config && config.filterBefore == true) {
	        $('.advancedFilter').modal('show');
	    }
	
	    $(document).on('click', gridId + '-body .filter_head_cell', function (event) {
	        event.preventDefault();
	        $(gridId + '-body thead [data-filter]').toggle();
	        $(this).parent().find('input').focus();
	    });
	
	    if (FSGridSnippet.inited == false) $(document).on('submit', '.filterQuickForm', function (event) {
	        event.preventDefault();
	        FSGridSnippet.loadGrid(gridId, $(this).attr('action'), $(this).serialize());
	    });
	
	    var timeout = null;
	    $(document).on('input change', gridId + '-body [data-filter]', function (event) {
	        event.preventDefault();
	        if (timeout) {
	            clearTimeout(timeout);
	        }
	        timeout = setTimeout(function () {
	            FSGridSnippet.applyFilters(gridId);
	        }, 200);
	    });
	
	    if (FSGridSnippet.inited == false) $(document).on('click', '.openFiltersModal', function (event) {
	        event.preventDefault();
	        if (!$('.advancedFilter').length) {
	            $.ajax({
	                url: $(this).attr('href'),
	                beforeSend: function beforeSend() {
	                    waiter_open('large');
	                },
	                success: function success(payload) {
	                    FSGridSnippet.logStart('initFiltersDOM');
	                    if (payload.snippets) {
	                        for (var id in payload.snippets) {
	                            $('#' + id).html(payload.snippets[id]);
	                        }
	                    }
	                    FSGridSnippet.logEnd('initFiltersDOM');
	                    FSGridSnippet.logStart('initFiltersForm');
	                    FSForms.init();
	                    FSGridSnippet.logEnd('initFiltersForm');
	                    FSGridSnippet.fire(gridId, 'filters.ready');
	                    $('.advancedFilter').modal('show');
	                },
	                complete: function complete() {
	                    waiter_close();
	                }
	            });
	        } else {
	            $('.advancedFilter').modal('show');
	        }
	    });
	
	    FSGridSnippet.logEnd('initFilters');
	};
	
	/** Bulk action without dialog - start ********************************************************************************/
	FSGridSnippet.initBulkActionWithoutDialog = function (gridId) {
	    FSGridSnippet.logStart('initBulkActionWithoutDialog');
	
	    // toggle checked cell checkboxs
	    $(document).on('click', gridId + '-content .action-bulk-without-dialog-head-cell', function () {
	        $(gridId + '-content .action-bulk-without-dialog-body-cell').prop('checked', $(this).prop('checked'));
	    });
	
	    // handle button form multi actions
	    $(document).on('click', gridId + '-content .action-bulk-without-dialog-multi-actions-send-btn', function () {
	        // selected rows
	        var ids = FSGridSnippet.bulkActionWithoutDialogGetIds(gridId);
	
	        // link for action
	        var link = $(gridId + '-content .action-bulk-without-dialog-multi-actions-select-action').val();
	
	        // redirect
	        if (ids.length != 0) {
	            window.location.replace(link + '&' + $.param({ ids: ids }));
	        } else {
	            alert('Není vybrán žádný řádek.');
	        }
	    });
	
	    // handle button form single action
	    $(document).on('click', gridId + '-content .action-bulk-without-dialog-single-action', function () {
	        // selected rows
	        var ids = FSGridSnippet.bulkActionWithoutDialogGetIds(gridId);
	
	        // link for action
	        var link = $(gridId + '-content .action-bulk-without-dialog-single-action').data('link');
	
	        // redirect
	        if (ids.length != 0) {
	            window.location.replace(link + '&' + $.param({ ids: ids }));
	        } else {
	            alert('Není vybrán žádný řádek.');
	        }
	    });
	
	    $(document).off('click', '.grid-actionBulkAction').on('click', '.grid-actionBulkAction', FSGridSnippet.onClickToggleSelectionMode); // add event on button lock on dialog
	
	    FSGridSnippet.logEnd('initBulkActionWithoutDialog');
	};
	
	/**
	 * @param gridId
	 * @return {Array}
	 */
	FSGridSnippet.bulkActionWithoutDialogGetIds = function (gridId) {
	    FSGridSnippet.logStart('bulkActionWithoutDialogGetIds');
	
	    var ids = [];
	    $(gridId + '-body .action-bulk-without-dialog-body-cell:checked').each(function () {
	        ids.push($(this).data('primarykey'));
	    });
	
	    FSGridSnippet.logEnd('bulkActionWithoutDialogGetIds');
	
	    return ids;
	};
	/** Bulk action without dialog - end **********************************************************************************/
	
	/**
	 *
	 */
	FSGridSnippet.bulkFormButtonClick = function (event) {
	    FSGridSnippet.logStart('bulkFormButtonClick');
	
	    event.preventDefault();
	    $(this).closest('form').submit();
	
	    FSGridSnippet.logEnd('bulkFormButtonClick');
	};
	
	FSGridSnippet.applyFilters = function (gridId) {
	    FSGridSnippet.logStart('applyFilters');
	
	    var i = 1;
	    var config = FSGridSnippet.grids[gridId].config;
	    config.columnFilters = [];
	
	    $(gridId + '-body thead th').each(function () {
	        var input = $(this).find('[data-filter]');
	        var filterValue = $(this).find('[data-filter]').val();
	        if (filterValue) {
	            config.columnFilters[i] = {
	                'name': input.data('filter'),
	                'value': input.val().toLowerCase(),
	                'type': $(this).data('sorting_type')
	            };
	            $(this).addClass('filtering-active');
	        } else {
	            $(this).removeClass('filtering-active');
	        }
	        i++;
	    });
	
	    if (config.columnFilters.length == 0) {
	        config.numberRowsFiltered = config.gridData.length;
	        config.gridData.removeClass('filtered');
	    } else {
	        config.numberRowsFiltered = config.gridData.addClass('filtered').filter(function () {
	            for (var i in config.columnFilters) {
	                if (config.columnFilters[i].type == 'Icon') {
	                    if (($(this.children[i - 1].querySelector('[title]')).attr('title') || '').toLowerCase() != config.columnFilters[i].value) {
	                        return false;
	                    }
	                } else {
	                    if (this.children[i - 1].innerText.toLowerCase().indexOf(config.columnFilters[i].value) == -1) {
	                        return false;
	                    }
	                }
	            }
	            return true;
	        }).removeClass('filtered').length;
	    }
	
	    $(gridId + '-content .grid-total-count').text(config.numberRowsFiltered);
	    $(gridId + '-content .grid-count-displayed').text(config.numberRowsFiltered ? '1 - ' + config.numberRowsFiltered : 0);
	
	    FSGridSnippet.logEnd('applyFilters');
	};
	
	FSGridSnippet.applySorting = function (gridId) {
	    FSGridSnippet.logStart('applySorting');
	
	    var config = FSGridSnippet.grids[gridId].config;
	    $(gridId + '-body thead th').removeClass('sorted-asc sorted-desc multiple-sorted');
	    $(gridId + '-body thead .badge').remove();
	
	    // reset sorting when no sorting is active
	    if (!config.sorting.length) {
	        config.gridData.css('order', '');
	        return;
	    }
	
	    // prepare sorting definition
	    var sortingToPrepare = [];
	    for (var i in config.sorting) {
	        var th = $(gridId + '-body thead .grid-header-' + config.sorting[i].name);
	        var index = $(gridId + '-body thead th').index(th);
	
	        if (!th.length) {
	            config.sorting = [];
	            return;
	        }
	
	        th.addClass('sorted-' + config.sorting[i].order);
	        config.sorting[i].index = index;
	        config.sorting[i].type = th.data('sorting_type');
	        config.sorting[i].settings = th.data('sorting_settings');
	
	        if (config.sorting.length > 1) {
	            $(gridId + '-body thead .grid-header-' + config.sorting[i].name + ' .sorting_head_cell.sorting_inactive[data-sorting_order=desc]').before('<span class="badge">' + (parseInt(i) + 1) + '</span>');
	            $(gridId + '-body thead .grid-header-' + config.sorting[i].name).addClass('multiple-sorted');
	        }
	
	        if (typeof config.sortingCache[index] == 'undefined') {
	            if (config.sorting[i].type == null) {
	                config.sorting[i].type = 'Number';
	            }
	            sortingToPrepare[i] = config.sorting[i];
	        } else {
	            config.sorting[i].type = config.sortingCache[index];
	        }
	        if (config.sorting[i].type == 'DateTime') {
	            config.sorting[i].settings = FSGridSnippet.convertDateFormat(config.sorting[i].settings);
	        }
	    }
	
	    // prepare data for sorting
	    if (sortingToPrepare.length) {
	        config.gridData.each(function () {
	            if (!Array.isArray(this.sortKey)) this.sortKey = [];
	            for (var i in sortingToPrepare) {
	                var index = config.sorting[i].index;
	                if (config.sorting[i].type == 'Icon') {
	                    this.sortKey[index] = $(this.children[index].querySelector('[title]')).attr('title') || '';
	                } else {
	                    this.sortKey[index] = this.children[index].innerText;
	                }
	                if (config.sorting[i].type == 'Number') {
	                    if (this.sortKey[index] != '' && parseInt(this.sortKey[index]) != this.sortKey[index]) config.sorting[i].type = 'String';
	                }
	                if (config.sorting[i].type == 'DateTime') {
	                    this.sortKey[index] = this.sortKey[index] == '' ? 0 : moment(this.sortKey[index], config.sorting[i].settings).unix();
	                }
	            }
	        });
	        for (var i in config.sorting) {
	            config.sortingCache[config.sorting[i].index] = config.sorting[i].type;
	        }
	    }
	
	    // sort data
	    config.gridData.sort(function (a, b) {
	        var result;
	        for (var i in config.sorting) {
	            var index = config.sorting[i].index;
	            if (config.sorting[i].type == 'Number' || config.sorting[i].type == 'DateTime') {
	                if (config.sorting[i].order == 'asc') {
	                    result = a.sortKey[index] - b.sortKey[index];
	                } else {
	                    result = b.sortKey[index] - a.sortKey[index];
	                }
	            } else {
	                if (config.sorting[i].order == 'asc') {
	                    result = a.sortKey[index].localeCompare(b.sortKey[index]);
	                } else {
	                    result = b.sortKey[index].localeCompare(a.sortKey[index]);
	                }
	            }
	            if (result != 0) break;
	        }
	        return result;
	    });
	
	    // update table by sorting result
	    config.gridData.each(function (index) {
	        this.style.order = index;
	    });
	
	    FSGridSnippet.logEnd('applySorting');
	};
	
	FSGridSnippet.filterToRibbon = function () {
	    FSGridSnippet.logStart('filterToRibbon');
	
	    var toRibbon = $('#grid_filter_to_ribbon .ribbon-grid-filter-group');
	
	    if (toRibbon.length) {
	        $('.ribbon .tab-pane.active > ul').append(toRibbon.detach());
	
	        FSGridSnippet.logStart('filterToRibbon-gridRender');
	        $(window).trigger('resize');
	        FSGridSnippet.logEnd('filterToRibbon-gridRender');
	    }
	
	    FSGridSnippet.logEnd('filterToRibbon');
	};
	
	FSGridSnippet.sortingByColumn = function (gridId, name, order) {
	    FSGridSnippet.logStart('sortingByColumn');
	
	    var data = {
	        name: name,
	        order: order
	    };
	    var link = FSGridSnippet.grids[gridId].config.sortUrl;
	
	    FSGridSnippet.loadGrid(gridId, link, JSON.stringify({ sendJSON: data }), true);
	
	    FSGridSnippet.logEnd('sortingByColumn');
	};
	
	FSGridSnippet.fixBrowserCompatibility = function (gridId) {
	    FSGridSnippet.logStart('fixBrowserCompatibility');
	
	    //IE fix (IE doesn't support sticky position)
	    if (!(typeof CSS != "undefined" && CSS.supports && CSS.supports("position", "sticky"))) {
	        var timeout = null;
	        var head = document.querySelector(gridId + '-body thead');
	        var icons = document.querySelectorAll(gridId + '-body .grid-action, ' + gridId + '-body thead .grid-header-actions, ' + gridId + '-body thead .grid-header-bulk-action');
	
	        $(gridId + '-body tbody').off('scroll').on('scroll', function (event) {
	            if (event.target.scrollLeft != head.scrollLeft) {
	                head.scrollLeft = event.target.scrollLeft;
	                if (timeout) clearTimeout(timeout);
	                timeout = setTimeout(function () {
	                    for (var i = 0; i < icons.length; i++) {
	                        icons[i].style.left = event.target.scrollLeft + 'px';
	                    }
	                }, 50);
	            }
	        });
	
	        var scrollWidth = 0,
	            tbody = document.querySelector(gridId + '-body tbody');
	        if (tbody) scrollWidth = tbody.scrollWidth;
	        if (scrollWidth) addStylesheetRule(gridId + '-body tr { width: ' + scrollWidth + 'px }');
	    }
	
	    FSGridSnippet.logEnd('fixBrowserCompatibility');
	};
	
	FSGridSnippet.initSorting = function (gridId) {
	    FSGridSnippet.logStart('initSorting');
	
	    $(document).on('click', gridId + '-body thead .sorting_inactive', function (event) {
	        event.preventDefault();
	        var config = FSGridSnippet.grids[gridId].config;
	
	        if (!config.isJsActive) {
	            FSGridSnippet.sortingByColumn(gridId, $(this).data('sorting_column'), $(this).data('sorting_order'));
	            return;
	        }
	
	        if (event.shiftKey == false && event.ctrlKey == false) {
	            config.sorting = [];
	        } else {
	            for (var i in config.sorting) {
	                if (config.sorting[i].name == $(this).data('sorting_column')) config.sorting.splice(i, 1);
	            }
	        }
	
	        config.sorting.push({
	            name: $(this).data('sorting_column'),
	            order: $(this).data('sorting_order')
	        });
	
	        FSGridSnippet.applySorting(gridId);
	    });
	
	    $(document).on('click', gridId + '-body thead .sorting_active', function (event) {
	        event.preventDefault();
	        var config = FSGridSnippet.grids[gridId].config;
	
	        if (!config.isJsActive) {
	            FSGridSnippet.sortingByColumn(gridId, $(this).data('sorting_column'), $(this).data('sorting_order'));
	            return;
	        }
	
	        if (event.shiftKey == false && event.ctrlKey == false) {
	            config.sorting = [];
	        } else {
	            for (var i in config.sorting) {
	                if (config.sorting[i].name == $(this).data('sorting_column')) config.sorting.splice(i, 1);
	            }
	        }
	
	        FSGridSnippet.applySorting(gridId);
	    });
	
	    FSGridSnippet.logEnd('initSorting');
	};
	
	FSGridSnippet.initExport = function (gridId) {
	    FSGridSnippet.logStart('initExport');
	
	    $(document).on("submit", gridId + '-exportForm', function (event) {
	        event.preventDefault();
	        waiter_close();
	
	        if ($(gridId + '-exportForm [name=format]').val() == 'pdf' || FSGridSnippet.grids[gridId].config.isExportEncrypted == true) {
	            $(gridId + '-exportSettings .settingsPdf').toggle($(gridId + '-exportForm [name=format]').val() == 'pdf');
	            $(gridId + '-exportSettings .settingsPsw').toggle(FSGridSnippet.grids[gridId].config.isExportEncrypted == true);
	            $(gridId + '-exportSettings').modal('toggle');
	        } else {
	            $(gridId + '-exportForm [name=password]').val('');
	            FSGridSnippet.preProcessExport(gridId);
	        }
	    });
	
	    $(document).on("click", gridId + '-exportConfirmDialog-yes', function () {
	        waiter_open('large');
	        FSGridSnippet.processExport(gridId);
	    });
	
	    $(document).on("click", gridId + '-exportSettings-yes', function () {
	        if (FSGridSnippet.grids[gridId].config.isExportEncrypted == true) {
	            var psw1 = $(gridId + '-exportSettings [name=psw1]').val();
	            var psw2 = $(gridId + '-exportSettings [name=psw2]').val();
	
	            if (psw1 != psw2 || psw1 == '' || psw2 == '') {
	                alert(FSGridSnippet.grids[gridId].config.errorPswMessage);
	                return;
	            } else {
	                $(gridId + '-exportForm [name=password]').val(psw1);
	            }
	        }
	        if ($(gridId + '-exportForm [name=format]').val() == 'pdf') {
	            $(gridId + '-exportForm [name=pdf_grid_convert_type]').val($(gridId + '-exportSettings [name=pageSize]').val());
	        }
	
	        $(gridId + '-exportSettings').modal('toggle');
	        FSGridSnippet.preProcessExport(gridId);
	    });
	
	    FSGridSnippet.logEnd('initExport');
	};
	
	FSGridSnippet.processExport = function (gridId) {
	    FSGridSnippet.logStart('processExport');
	
	    var form = $(gridId + '-exportForm > form');
	
	    $.ajax({
	        type: 'POST',
	        url: form.attr('action'),
	        data: form.serialize(),
	        success: function success(payload) {
	            waiter_close();
	            if (payload.redirect) {
	                $(gridId + ' .processKeys').val('');
	                window.location.href = payload.redirect;
	            } else if (payload.msg) {
	                alert(payload.msg);
	            } else {
	                alert(FSGridSnippet.grids[gridId].config.errorMessage);
	            }
	        }
	    });
	
	    FSGridSnippet.logEnd('processExport');
	};
	
	FSGridSnippet.preProcessExport = function (gridId) {
	    FSGridSnippet.logStart('preProcessExport');
	
	    waiter_open('large');
	
	    $.ajax({
	        url: FSGridSnippet.grids[gridId].config.exportCountUrl,
	        success: function success(payload) {
	            if (payload.count) {
	                var selected = $(gridId + ' .processKeys').val();
	                var maxCount = $(gridId + '-exportForm > form [name=format]').val() == 'zip' ? payload.maxResultSetForZipExport : payload.maxResultSetForExport;
	
	                if (selected) {
	                    payload.count = selected.split(',').length;
	                }
	
	                if (payload.count > maxCount) {
	                    waiter_close();
	                    $(gridId + '-exportConfirmDialog-count').text(maxCount);
	                    $(gridId + '-exportConfirmDialog').modal('toggle');
	                } else {
	                    FSGridSnippet.processExport(gridId);
	                }
	            }
	        },
	        error: function error() {
	            alert(FSGridSnippet.grids[gridId].config.errorMessage);
	            waiter_close();
	        }
	    });
	
	    FSGridSnippet.logEnd('preProcessExport');
	};
	
	FSGridSnippet.fire = function (gridId, eventName) {
	    $(gridId).trigger('grid.' + eventName, [gridId]);
	};
	
	/** Helpers ***********************************************************************************************************/
	
	FSGridSnippet.getGridId = function (el) {
	    return '#' + el.closest('.fs-grid-snippet').attr('id');
	};
	
	FSGridSnippet.logStart = function (logName) {
	    window.performance.mark(logName + '_start');
	};
	
	FSGridSnippet.logEnd = function (logName) {
	    window.performance.mark(logName + '_end');
	    window.performance.measure(logName, logName + '_start', logName + '_end');
	};
	
	FSGridSnippet.logEcho = function () {
	    var items = window.performance.getEntriesByType('measure');
	    for (var i = 0; i < items.length; ++i) {
	        var req = items[i];
	        console.log(req.name + ': ' + Math.round(req.duration) + 'ms');
	    }
	};
	
	FSGridSnippet.convertDateFormat = function (phpFormat) {
	    var convert = {
	        Y: 'YYYY',
	        y: 'YY',
	        m: 'MM',
	        n: 'MM',
	        d: 'DD',
	        j: 'DD',
	        H: 'HH',
	        h: 'HH',
	        G: 'HH',
	        i: 'mm',
	        s: 'ss'
	    };
	
	    var jsFormat = phpFormat;
	    for (var i in convert) {
	        jsFormat = jsFormat.replace(i, convert[i]);
	    }
	    return jsFormat;
	};
	
	FSGridSnippet.refreshMainGrid = function () {
	    var id = $(document.querySelector('.fs-grid-snippet')).attr('id');
	    if (id) {
	        FSGridSnippet.loadGrid('#' + id, FSGridSnippet.grids['#' + id].config.loadUrl);
	        return true;
	    } else {
	        return false;
	    }
	};

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */,
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(159))

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	module.exports = "\"use strict\";$(function(e,t){e(\"#header_menu_button\").click(function(){if(0==e(\"#responsive-ribbon\").children().length){e(\"#responsive-ribbon\").html(\"<ul></ul>\"),e(\".ribbon .tabs-holder li\").each(function(){var t=e(this),n=t.children(\"a\").attr(\"href\");if(n){var n=n.substr(1);e(\"#responsive-ribbon\").children(\"ul\").append(e(\"<li></li>\").attr(\"class\",t.attr(\"class\")).attr(\"id\",\"rr-\"+n).append(e(\"<a></a>\").attr(\"style\",t.attr(\"style\")).text(t.children(\"a\").attr(\"title\")?t.children(\"a\").attr(\"title\"):t.children(\"a\").text()).append('<span class=\"glyphicon glyphicon-chevron-down\"></span><span class=\"glyphicon glyphicon-chevron-up\"></span>')).append(e(\"<ul></ul>\"))),e(\"#\"+n+\" .ribbon-section > a\").each(function(){var t=e(this);if(!t.hasClass(\"ribbon-skip\")){var r=t.children(\"img\").attr(\"src\"),a=e(\"<a></a>\").attr(\"href\",t.attr(\"href\")).attr(\"style\",t.attr(\"style\")).attr(\"onclick\",t.attr(\"onclick\")).attr(\"target\",t.attr(\"target\")).attr(\"data-toggle\",t.data(\"toggle\")).attr(\"data-target\",t.data(\"target\")).attr(\"data-backdrop\",t.data(\"backdrop\")).text(t.text().trim()).attr(\"class\",\"dropdown\"==t.data(\"toggle\")?\"dropdown\":null).append((r&&r.match(/ribbon-check.svg$/)?'<span class=\"glyphicon glyphicon-ok yes_green\"></span>':\"\")+(\"dropdown\"==t.data(\"toggle\")?'<span class=\"glyphicon glyphicon-chevron-down\"></span><span class=\"glyphicon glyphicon-chevron-up\"></span>':\"\"));if(e(\"#rr-\"+n).children(\"ul\").append(e(\"<li></li>\").append(a)),\"dropdown\"==t.data(\"toggle\")){e(\"#rr-\"+n).children(\"ul\").children(\":last-child\").append(\"<ul></ul>\");var i=e(\"#rr-\"+n).children(\"ul\").children(\":last-child\").children(\"ul\");t.parent().children(\"ul\").children(\"li\").each(function(){var t=e(\"<a></a>\").attr(\"href\",e(this).find(\"a\").attr(\"href\")).attr(\"style\",e(this).find(\".ribbon-dropDownList-caption\").attr(\"style\")).attr(\"onclick\",e(this).find(\"a\").attr(\"onclick\")).attr(\"target\",e(this).find(\"a\").attr(\"target\")).text(e(this).find(\".ribbon-dropDownList-caption\").text().trim());i.append(e(\"<li></li>\").append(t))})}}})}});var t=\"user\",n=e(\"#header_settings_icon\").children(\"img\").attr(\"src\");e(\"#responsive-ribbon\").children(\"ul\").append('<li id=\"rr-'+t+'\"><a>'+(n?'<img src=\"'+n+'\" /> ':\"\")+e(\"#header_settings_button_user\").text()+(e(\"#header_settings_button_role\").text()?e(\"#header_settings_button_role\").text():\"\")+'<span class=\"glyphicon glyphicon-chevron-down\"></span><span class=\"glyphicon glyphicon-chevron-up\"></span></a><ul></ul></li>');var r=\"\",a=e(\"#header_settings_icon\").attr(\"title\"),i=\"\",l=\"\",s=\"dropdown\",o=\"\";e(\"#rr-\"+t).children(\"ul\").append(\"<li><a\"+o+(r?' style=\"'+r+'\"':\"\")+(l?' target=\"'+l+'\"':\"\")+(\"dropdown\"==s?' class=\"dropdown\"':\"\")+(i?' href=\"'+i+'\"':\"\")+\">\"+a.trim()+(\"dropdown\"==s?'<span class=\"glyphicon glyphicon-chevron-down\"></span><span class=\"glyphicon glyphicon-chevron-up\"></span>':\"\")+\"</a></li>\"),e(\"#rr-\"+t).children(\"ul\").children(\":last-child\").append(\"<ul></ul>\");var d=e(\"#rr-\"+t).children(\"ul\").children(\":last-child\").children(\"ul\");e(\"#header_settings_panel > div\").each(function(){var t=e(this).children(\"a\").attr(\"href\"),n=e(this).children(\"a\").attr(\"target\"),r=e(this).children(\"a\").text();d.append('<li><a href=\"'+t+'\"'+(n?' target=\"'+n+'\"':\"\")+\">\"+r.trim()+\"</a></li>\")});var r=\"\",a=e(\"#header_user_button\").attr(\"title\"),i=\"\",l=\"\",s=\"dropdown\",o=\"\";if(a){e(\"#rr-\"+t).children(\"ul\").append(\"<li><a\"+o+(r?' style=\"'+r+'\"':\"\")+(l?' target=\"'+l+'\"':\"\")+(\"dropdown\"==s?' class=\"dropdown\"':\"\")+(i?' href=\"'+i+'\"':\"\")+\">\"+a.trim()+(\"dropdown\"==s?'<span class=\"glyphicon glyphicon-chevron-down\"></span><span class=\"glyphicon glyphicon-chevron-up\"></span>':\"\")+\"</a></li>\"),e(\"#rr-\"+t).children(\"ul\").children(\":last-child\").append(\"<ul></ul>\");var d=e(\"#rr-\"+t).children(\"ul\").children(\":last-child\").children(\"ul\");e(\"#header_users_panel_temp > div\").each(function(){var t=e(this).children(\"a\").attr(\"href\"),n=e(this).children(\"a\").attr(\"target\"),r=e(this).children(\"a\").text();e(this).children(\"a\").length&&d.append('<li><a href=\"'+t+'\"'+(n?' target=\"'+n+'\"':\"\")+\">\"+r.trim()+\"</a></li>\")})}var r=\"\",a=e(\"#header_help_info_button\").attr(\"title\"),t=e(\"#header_help_info_button\").attr(\"id\"),n=e(\"#header_help_info_button\").children(\"img\").attr(\"src\");e(\"#responsive-ribbon\").children(\"ul\").append('<li id=\"rr-'+t+'\"><a'+(r?' style=\"'+r+'\"':\"\")+\">\"+(n?'<img src=\"'+n+'\" /> ':\"\")+a+'<span class=\"glyphicon glyphicon-chevron-down\"></span><span class=\"glyphicon glyphicon-chevron-up\"></span></a><ul></ul></li>');var d=e(\"#rr-\"+t).children(\"ul\");e(\"#header_help_info_panel > div\").each(function(){var t=e(this).children(\"a\").attr(\"href\"),n=e(this).children(\"a\").attr(\"target\"),r=e(this).children(\"a\").text();d.append('<li><a href=\"'+t+'\"'+(n?' target=\"'+n+'\"':\"\")+\">\"+r.trim()+\"</a></li>\")});var a=e(\"#header_logout_button\").attr(\"title\"),i=e(\"#header_logout_button\").attr(\"href\"),n=e(\"#header_logout_button\").children(\"img\").attr(\"src\");e(\"#responsive-ribbon\").children(\"ul\").append(\"<li><a\"+(i?' href=\"'+i+'\"':\"\")+\">\"+(n?'<img src=\"'+n+'\" /> ':\"\")+a.trim()+\"</a></li>\"),e(document).on(\"click\",\"#responsive-ribbon > ul > li > a:not([href])\",function(t){e(this).parent().hasClass(\"active\")?e(\"#responsive-ribbon > ul > li\").removeClass(\"active\"):(e(\"#responsive-ribbon > ul > li\").removeClass(\"active\"),e(this).parent().addClass(\"active\")),e(\"#responsive-ribbon .selected\").removeClass(\"selected\"),t.preventDefault()}),e(document).on(\"click\",\"#responsive-ribbon .dropdown\",function(t){e(this).parent().hasClass(\"selected\")?e(\"#responsive-ribbon .selected\").removeClass(\"selected\"):(e(\"#responsive-ribbon .selected\").removeClass(\"selected\"),e(this).parent().addClass(\"selected\")),t.preventDefault()}),e(document).on(\"click\",\"#responsive-ribbon a[data-toggle=modal]\",function(t){e(\"#responsive-ribbon\").toggleClass(\"responsive-hidden\"),e(\"body > .container-fluid\").toggleClass(\"responsive-hidden\")})}e(\"#responsive-ribbon\").toggleClass(\"responsive-hidden\"),e(\"#container-fluid-main\").toggleClass(\"responsive-hidden\"),event.preventDefault()})});var FFAdditionalStyleSheet=null;window.addStylesheetRule=function(e){if(null==FFAdditionalStyleSheet){var t=document.createElement(\"style\");document.head.appendChild(t),FFAdditionalStyleSheet=t.sheet}FFAdditionalStyleSheet.insertRule(e,FFAdditionalStyleSheet.cssRules.length)},window.isLayoutMobile=function(){return window.matchMedia(\"(max-width: 767px)\").matches},$.fn.modal.Constructor.prototype.measureScrollbar=function(){return 0};"

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78)(__webpack_require__(161))

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	module.exports = "\"use strict\";!function(e,t){if(!t.Nette)return void console.log(\"Error: Nette form validation not loaded.\");var r;t.live=r={orig:{validateControl:t.Nette.validateControl,initForm:t.Nette.initForm},events:{afterValidate:[]},on:function(e,t){return this.events[e].push(t),this},fire:function(t){var r=Array.prototype.slice.call(arguments);return r.shift(),e.each(this.events[t],function(e,t){t.apply(null,r)}),this},removeError:function(t){return e(t).removeClass(\"error\"),e(t).parent().find(\".chosen-container a\").removeClass(\"error\"),e('label[for=\"'+e(t).attr(\"id\")+'\"]').removeClass(\"error\"),this},timeout:null,message:[],nofity:[],onlyCheck:!0},t.Nette.addError=function(t,a){t.form;r.onlyCheck||(e(t).addClass(\"error\"),e(t).parent().find(\".chosen-container a\").addClass(\"error\"),e('label[for=\"'+e(t).attr(\"id\")+'\"]').addClass(\"error\"),e(t).focus(),-1===e.inArray(a,r.message)&&r.message.push(a))},t.Nette.validateControl=function(t,a,o){var n=e(t),i=r.orig.validateControl(t,a,o);return!i&&n.closest(\"form\").data(\"nette-valid\",!1),i&&r.removeError(n),i},t.Nette.validateForm=function(a,o){o=o||!1,r.onlyCheck=o;var n=a.form||a,i=!0;r.message=[],r.nofity=[];for(var s=0;s<n.elements.length;s++){var l=n.elements[s];if(l.nodeName.toLowerCase()in{input:1,select:1,textarea:1}&&!(l.type in{hidden:1,submit:1,image:1,reset:1})&&!l.disabled&&!l.readonly&&(!e(l).hasClass(\"err\")&&t.Nette.validateControl(l,null,o)||(i=!1),!o)){var d=e(l).data(\"fs-rules\");d&&!1===Nette.validators[d.replace(/\\\\/g,\"\").replace(\"::\",\"_\")](null,null,e(l).val())&&r.nofity.push(l)}}if(!o){if(0==i&&r.message.length)setTimeout(function(e){alert(e)},10,r.message.join(\"\\n\"));else if(r.nofity.length){r.message=[];var f=\"\";r.nofity.forEach(function(t){e(t).addClass(\"error\"),e(t).parent().find(\".chosen-container a\").addClass(\"error\"),e('label[for=\"'+e(t).attr(\"id\")+'\"]').addClass(\"error\"),e(t).focus(),r.message.push(e(t).data(\"fs-message\")),f=e(t).data(\"fs-alert\")}),i=confirm(f.replace(\"%s\",\"\\n\\n- \"+r.message.join(\"\\n- \")+\"\\n\\n\"))}r.onlyCheck=!0}var u=e(n);return u.data(\"nette-valid\",i),r.fire(\"afterValidate\",u),i},t.Nette.initForm=function(a){r.orig.initForm(a);for(var o=function(e){t.Nette.validateControl(e.target),t.Nette.validateForm(a,!0)},n=0;n<a.elements.length;n++)e(a.elements[n]).on(\"change.live\",o).on(\"keydown.live\",function(e){r.timeout&&t.clearTimeout(r.timeout)}).on(\"keyup.live\",function(e){r.timeout=t.setTimeout(function(){o(e)},300)})},e(document).on(\"hidden.bs.modal\",function(t){e(t.target).find(\".error\").removeClass(\"error\")}),Nette.validators.FSComponentsFormsUserValidators_validateIC=function(e,t,r){return/^[0-9]{5,}$/.test(r)},Nette.validators.FSComponentsFormsUserValidators_validateDIC=function(e,t,r){return/^[A-Z]+[0-9]{5,}$/.test(r)},Nette.validators.FSComponentsFormsUserValidators_validateEmail=function(e,t,r){return Nette.validators.email(e,t,r)},Nette.validators.FSComponentsFormsUserValidators_validatePhone=function(e,t,r){return/^\\+?[0-9 ]{5,}$/.test(r)}}(jQuery,window);"

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jQuery = __webpack_require__(163);
	
	var _jQuery2 = _interopRequireDefault(_jQuery);
	
	var _Immutable = __webpack_require__(164);
	
	var _Immutable2 = _interopRequireDefault(_Immutable);
	
	var _CreateDocumentControl = __webpack_require__(165);
	
	var _CreateDocumentControl2 = _interopRequireDefault(_CreateDocumentControl);
	
	var _SingleEditDocumentControl = __webpack_require__(167);
	
	var _SingleEditDocumentControl2 = _interopRequireDefault(_SingleEditDocumentControl);
	
	var _BulkEditDocumentsControl = __webpack_require__(168);
	
	var _BulkEditDocumentsControl2 = _interopRequireDefault(_BulkEditDocumentsControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Configurator for Metadata logic controls.
	 *
	 * @author Pavel Homolka
	 */
	var MetadataLogicConfigurator = function () {
	  function MetadataLogicConfigurator() {
	    _classCallCheck(this, MetadataLogicConfigurator);
	  }
	
	  _createClass(MetadataLogicConfigurator, null, [{
	    key: 'createDocumentControlsInit',
	
	
	    /**
	     * Inits all CreateDocumentControls
	     */
	    /*
	    static createDocumentControlsInit()
	    {
	      $('.createDocumentControl').each(function()
	      {
	        var insertFormId = $(this).data('insertformid');
	        var changeURL = $(this).data('changeurl');
	        var jsClass = $(this).data('jsclass');
	        var userLanguage = $(this).data('userlanguage');
	        var stateList = Immutable.fromJS($(this).data('statelist'));
	          var control = new CreateDocumentControl(insertFormId, changeURL, jsClass, stateList, userLanguage);
	        control.init();
	      });
	    }
	    */
	
	    /**
	     * Inits all CreateDocumentControls
	     */
	
	
	    /** @type {Array} */
	    value: function createDocumentControlsInit() {
	      (0, _jQuery2.default)('.createDocumentControl').each(function () {
	        var control = null;
	        var id = (0, _jQuery2.default)(this).parent().attr('id');
	
	        MetadataLogicConfigurator.createDcumentsControlPool.forEach(function (item) {
	          if (item.id === id) {
	            control = item.obj;
	            return false;
	          }
	        });
	
	        if (control == null) {
	          var insertFormId = (0, _jQuery2.default)(this).data('insertformid');
	          var changeURL = (0, _jQuery2.default)(this).data('changeurl');
	          var jsClass = (0, _jQuery2.default)(this).data('jsclass');
	          var userLanguage = (0, _jQuery2.default)(this).data('userlanguage');
	          var datetimeFormat = (0, _jQuery2.default)(this).data('datetimeformat');
	          var stateList = _Immutable2.default.fromJS((0, _jQuery2.default)(this).data('statelist'));
	
	          var control = new _CreateDocumentControl2.default(insertFormId, changeURL, jsClass, stateList, userLanguage, datetimeFormat);
	          control.init();
	          MetadataLogicConfigurator.createDcumentsControlPool.push({ id: id, obj: control });
	        }
	      });
	    }
	
	    /**
	     * Inits all SingleEditDocumentControls
	     */
	
	
	    /** @type {Array} */
	
	    /** @type {Array} */
	
	  }, {
	    key: 'singleEditDocumentControlsInit',
	    value: function singleEditDocumentControlsInit() {
	      (0, _jQuery2.default)('.singleEditDocumentControl').each(function () {
	
	        var control = null;
	        var id = (0, _jQuery2.default)(this).parent().attr('id');
	
	        MetadataLogicConfigurator.singleEditDocumentControlPool.forEach(function (item) {
	          if (item.id === id) {
	            control = item.obj;
	            return false;
	          }
	        });
	
	        if (control == null) {
	          var insertFormId = (0, _jQuery2.default)(this).data('editformid');
	          var changeURL = (0, _jQuery2.default)(this).data('changeurl');
	          var jsClass = (0, _jQuery2.default)(this).data('jsclass');
	          var userLanguage = (0, _jQuery2.default)(this).data('userlanguage');
	          var submitBtnId = (0, _jQuery2.default)(this).data('submitbtnid');
	          var stateList = _Immutable2.default.fromJS((0, _jQuery2.default)(this).data('statelist'));
	          var initialCaption = (0, _jQuery2.default)(this).data('initialcaption');
	          var submitBtnLabel = (0, _jQuery2.default)(this).data('submitbtnlabel');
	
	          var control = new _SingleEditDocumentControl2.default(insertFormId, changeURL, jsClass, stateList, userLanguage, submitBtnId, initialCaption, submitBtnLabel);
	          control.init();
	          MetadataLogicConfigurator.singleEditDocumentControlPool.push({ id: id, obj: control });
	        }
	      });
	    }
	
	    /**
	     * Inits all BulkEditDocumentsControls
	     */
	
	  }, {
	    key: 'bulkEditDocumentsControlsInit',
	    value: function bulkEditDocumentsControlsInit() {
	      (0, _jQuery2.default)('.bulkEditDocumentsControl').each(function () {
	        var control = null;
	        var id = (0, _jQuery2.default)(this).parent().attr('id');
	
	        MetadataLogicConfigurator.bulkEditDocumentsControlPool.forEach(function (item) {
	          if (item.id === id) {
	            control = item.obj;
	            return false;
	          }
	        });
	
	        if (control == null) {
	          var simpleEditFormId = (0, _jQuery2.default)(this).data('simpleeditformid');
	          var advancedEditFormId = (0, _jQuery2.default)(this).data('advancededitformid');
	          var changeURL = (0, _jQuery2.default)(this).data('changeurl');
	          var jsClass = (0, _jQuery2.default)(this).data('jsclass');
	          var stateList = _Immutable2.default.fromJS((0, _jQuery2.default)(this).data('statelist'));
	
	          var control = new _BulkEditDocumentsControl2.default(simpleEditFormId, advancedEditFormId, changeURL, jsClass, stateList);
	          control.init();
	          MetadataLogicConfigurator.bulkEditDocumentsControlPool.push({ id: id, obj: control });
	        }
	      });
	    }
	  }]);
	
	  return MetadataLogicConfigurator;
	}();
	
	MetadataLogicConfigurator.createDcumentsControlPool = [];
	MetadataLogicConfigurator.singleEditDocumentControlPool = [];
	MetadataLogicConfigurator.bulkEditDocumentsControlPool = [];
	exports.default = MetadataLogicConfigurator;
	;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v1.11.2
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2014-12-17T15:27Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper window is present,
			// execute the factory and get jQuery
			// For environments that do not inherently posses a window with a document
			// (such as Node.js), expose a jQuery-making factory as module.exports
			// This accentuates the need for the creation of a real window
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Can't do this because several apps including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	// Support: Firefox 18+
	//
	
	var deletedIds = [];
	
	var slice = deletedIds.slice;
	
	var concat = deletedIds.concat;
	
	var push = deletedIds.push;
	
	var indexOf = deletedIds.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		version = "1.11.2",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1, IE<9
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		// (You can seed the arguments with an array of args, but this is
		// only used internally.)
		each: function( callback, args ) {
			return jQuery.each( this, callback, args );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map(this, function( elem, i ) {
				return callback.call( elem, i, elem );
			}));
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[j] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor(null);
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: deletedIds.sort,
		splice: deletedIds.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var src, copyIsArray, copy, name, options, clone,
			target = arguments[0] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
			target = {};
		}
	
		// extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
			// Only deal with non-null/undefined values
			if ( (options = arguments[ i ]) != null ) {
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray(src) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject(src) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend({
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		// See test/unit/core.js for details concerning isFunction.
		// Since version 1.3, DOM methods and functions like alert
		// aren't supported. They return false on IE (#2968).
		isFunction: function( obj ) {
			return jQuery.type(obj) === "function";
		},
	
		isArray: Array.isArray || function( obj ) {
			return jQuery.type(obj) === "array";
		},
	
		isWindow: function( obj ) {
			/* jshint eqeqeq: false */
			return obj != null && obj == obj.window;
		},
	
		isNumeric: function( obj ) {
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			return !jQuery.isArray( obj ) && (obj - parseFloat( obj ) + 1) >= 0;
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		isPlainObject: function( obj ) {
			var key;
	
			// Must be an Object.
			// Because of IE, we also have to check the presence of the constructor property.
			// Make sure that DOM nodes and window objects don't pass through, as well
			if ( !obj || jQuery.type(obj) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			try {
				// Not own constructor property must be Object
				if ( obj.constructor &&
					!hasOwn.call(obj, "constructor") &&
					!hasOwn.call(obj.constructor.prototype, "isPrototypeOf") ) {
					return false;
				}
			} catch ( e ) {
				// IE8,9 Will throw exceptions on certain host objects #9897
				return false;
			}
	
			// Support: IE<9
			// Handle iteration over inherited properties before own properties.
			if ( support.ownLast ) {
				for ( key in obj ) {
					return hasOwn.call( obj, key );
				}
			}
	
			// Own properties are enumerated firstly, so to speed up,
			// if last one is own, then all properties are own.
			for ( key in obj ) {}
	
			return key === undefined || hasOwn.call( obj, key );
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call(obj) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		// Workarounds based on findings by Jim Driscoll
		// http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
		globalEval: function( data ) {
			if ( data && jQuery.trim( data ) ) {
				// We use execScript on Internet Explorer
				// We use an anonymous function so that context is window
				// rather than jQuery in Firefox
				( window.execScript || function( data ) {
					window[ "eval" ].call( window, data );
				} )( data );
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		// args is for internal usage only
		each: function( obj, callback, args ) {
			var value,
				i = 0,
				length = obj.length,
				isArray = isArraylike( obj );
	
			if ( args ) {
				if ( isArray ) {
					for ( ; i < length; i++ ) {
						value = callback.apply( obj[ i ], args );
	
						if ( value === false ) {
							break;
						}
					}
				} else {
					for ( i in obj ) {
						value = callback.apply( obj[ i ], args );
	
						if ( value === false ) {
							break;
						}
					}
				}
	
			// A special, fast, case for the most common use of each
			} else {
				if ( isArray ) {
					for ( ; i < length; i++ ) {
						value = callback.call( obj[ i ], i, obj[ i ] );
	
						if ( value === false ) {
							break;
						}
					}
				} else {
					for ( i in obj ) {
						value = callback.call( obj[ i ], i, obj[ i ] );
	
						if ( value === false ) {
							break;
						}
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1, IE<9
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArraylike( Object(arr) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			var len;
	
			if ( arr ) {
				if ( indexOf ) {
					return indexOf.call( arr, elem, i );
				}
	
				len = arr.length;
				i = i ? i < 0 ? Math.max( 0, len + i ) : i : 0;
	
				for ( ; i < len; i++ ) {
					// Skip accessing in sparse arrays
					if ( i in arr && arr[ i ] === elem ) {
						return i;
					}
				}
			}
	
			return -1;
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			while ( j < len ) {
				first[ i++ ] = second[ j++ ];
			}
	
			// Support: IE<9
			// Workaround casting of .length to NaN on otherwise arraylike objects (e.g., NodeLists)
			if ( len !== len ) {
				while ( second[j] !== undefined ) {
					first[ i++ ] = second[ j++ ];
				}
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var value,
				i = 0,
				length = elems.length,
				isArray = isArraylike( elems ),
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var args, proxy, tmp;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: function() {
			return +( new Date() );
		},
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	});
	
	// Populate the class2type map
	jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	});
	
	function isArraylike( obj ) {
		var length = obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		if ( obj.nodeType === 1 && length ) {
			return true;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.0-pre
	 * http://sizzlejs.com/
	 *
	 * Copyright 2008, 2014 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2014-12-16
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
		// http://www.w3.org/TR/css3-syntax/#characters
		characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Loosely modeled on CSS identifier characters
		// An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
		// Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = characterEncoding.replace( "w", "w#" ),
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + characterEncoding + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + characterEncoding + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + characterEncoding + ")" ),
			"CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
			"TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var match, elem, m, nodeType,
			// QSA vars
			i, groups, old, nid, newContext, newSelector;
	
		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
	
		context = context || document;
		results = results || [];
		nodeType = context.nodeType;
	
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		if ( !seed && documentIsHTML ) {
	
			// Try to shortcut find operations when possible (e.g., not under DocumentFragment)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
				// Speed-up: Sizzle("#ID")
				if ( (m = match[1]) ) {
					if ( nodeType === 9 ) {
						elem = context.getElementById( m );
						// Check parentNode to catch when Blackberry 4.6 returns
						// nodes that are no longer in the document (jQuery #6963)
						if ( elem && elem.parentNode ) {
							// Handle the case where IE, Opera, and Webkit return items
							// by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}
					} else {
						// Context is not a document
						if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
							contains( context, elem ) && elem.id === m ) {
							results.push( elem );
							return results;
						}
					}
	
				// Speed-up: Sizzle("TAG")
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;
	
				// Speed-up: Sizzle(".CLASS")
				} else if ( (m = match[3]) && support.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}
	
			// QSA path
			if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
				nid = old = expando;
				newContext = context;
				newSelector = nodeType !== 1 && selector;
	
				// qSA works strangely on Element-rooted queries
				// We can work around this by specifying an extra ID on the root
				// and working up from there (Thanks to Andrew Dupont for the technique)
				// IE 8 doesn't work on object elements
				if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
					groups = tokenize( selector );
	
					if ( (old = context.getAttribute("id")) ) {
						nid = old.replace( rescape, "\\$&" );
					} else {
						context.setAttribute( "id", nid );
					}
					nid = "[id='" + nid + "'] ";
	
					i = groups.length;
					while ( i-- ) {
						groups[i] = nid + toSelector( groups[i] );
					}
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) || context;
					newSelector = groups.join(",");
				}
	
				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch(qsaError) {
					} finally {
						if ( !old ) {
							context.removeAttribute("id");
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = attrs.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// If no document and documentElement is available, return
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Set our document
		document = doc;
		docElem = doc.documentElement;
		parent = doc.defaultView;
	
		// Support: IE>8
		// If iframe document is assigned to "document" variable and if iframe has been reloaded,
		// IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
		// IE6-8 do not support the defaultView property so parent will be undefined
		if ( parent && parent !== parent.top ) {
			// IE11 does not have attachEvent, so all must suffer
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Support tests
		---------------------------------------------------------------------- */
		documentIsHTML = !isXML( doc );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( doc.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( doc.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document #6963
					return m && m.parentNode ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\f]' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.2+, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.7+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = doc.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully does not implement inclusive descendent
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === doc ? -1 :
					b === doc ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return doc;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, outerCache, node, diff, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
								// Seek `elem` from a previously-cached index
								outerCache = parent[ expando ] || (parent[ expando ] = {});
								cache = outerCache[ type ] || [];
								nodeIndex = cache[0] === dirruns && cache[1];
								diff = cache[0] === dirruns && cache[2];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										outerCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							// Use previously-cached element index if available
							} else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
								diff = cache[1];
	
							// xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
							} else {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
										// Cache the index of each encountered element
										if ( useCache ) {
											(node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
										}
	
										if ( node === elem ) {
											break;
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
							if ( (oldCache = outerCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								outerCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context !== document && context;
				}
	
				// Add elements passing elementMatchers directly to results
				// Keep `i` a string if there are no elements so `matchedCount` will be "00" below
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// Apply set filters to unmatched elements
				matchedCount += i;
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is no seed and only one group
		if ( match.length === 1 ) {
	
			// Take a shortcut and set the context if the root selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[":"] = jQuery.expr.pseudos;
	jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = (/^<(\w+)\s*\/?>(?:<\/\1>|)$/);
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			});
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			});
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( jQuery.inArray( elem, qualifier ) >= 0 ) !== not;
		});
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			}));
	};
	
	jQuery.fn.extend({
		find: function( selector ) {
			var i,
				ret = [],
				self = this,
				len = self.length;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter(function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				}) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow(this, selector || [], false) );
		},
		not: function( selector ) {
			return this.pushStack( winnow(this, selector || [], true) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	});
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// Use the correct document accordingly with window argument (sandbox)
		document = window.document,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector.charAt(0) === "<" && selector.charAt( selector.length - 1 ) === ">" && selector.length >= 3 ) {
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && (match[1] || !context) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[1] ) {
						context = context instanceof jQuery ? context[0] : context;
	
						// scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[1],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[2] );
	
						// Check parentNode to catch when Blackberry 4.6 returns
						// nodes that are no longer in the document #6963
						if ( elem && elem.parentNode ) {
							// Handle the case where IE and Opera return items
							// by name instead of ID
							if ( elem.id !== match[2] ) {
								return rootjQuery.find( selector );
							}
	
							// Otherwise, we inject the element directly into the jQuery object
							this.length = 1;
							this[0] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || rootjQuery ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[0] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return typeof rootjQuery.ready !== "undefined" ?
					rootjQuery.ready( selector ) :
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
		// methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.extend({
		dir: function( elem, dir, until ) {
			var matched = [],
				cur = elem[ dir ];
	
			while ( cur && cur.nodeType !== 9 && (until === undefined || cur.nodeType !== 1 || !jQuery( cur ).is( until )) ) {
				if ( cur.nodeType === 1 ) {
					matched.push( cur );
				}
				cur = cur[dir];
			}
			return matched;
		},
	
		sibling: function( n, elem ) {
			var r = [];
	
			for ( ; n; n = n.nextSibling ) {
				if ( n.nodeType === 1 && n !== elem ) {
					r.push( n );
				}
			}
	
			return r;
		}
	});
	
	jQuery.fn.extend({
		has: function( target ) {
			var i,
				targets = jQuery( target, this ),
				len = targets.length;
	
			return this.filter(function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( this, targets[i] ) ) {
						return true;
					}
				}
			});
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[i]; cur && cur !== context; cur = cur.parentNode ) {
					// Always skip document fragments
					if ( cur.nodeType < 11 && (pos ?
						pos.index(cur) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector(cur, selectors)) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.unique( matched ) : matched );
		},
	
		// Determine the position of an element within
		// the matched set of elements
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[0] && this[0].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// index in selector
			if ( typeof elem === "string" ) {
				return jQuery.inArray( this[0], jQuery( elem ) );
			}
	
			// Locate the position of the desired element
			return jQuery.inArray(
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[0] : elem, this );
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.unique(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter(selector)
			);
		}
	});
	
	function sibling( cur, dir ) {
		do {
			cur = cur[ dir ];
		} while ( cur && cur.nodeType !== 1 );
	
		return cur;
	}
	
	jQuery.each({
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return jQuery.dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return jQuery.dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return jQuery.dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return jQuery.sibling( elem.firstChild );
		},
		contents: function( elem ) {
			return jQuery.nodeName( elem, "iframe" ) ?
				elem.contentDocument || elem.contentWindow.document :
				jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var ret = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				ret = jQuery.filter( selector, ret );
			}
	
			if ( this.length > 1 ) {
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					ret = jQuery.unique( ret );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					ret = ret.reverse();
				}
			}
	
			return this.pushStack( ret );
		};
	});
	var rnotwhite = (/\S+/g);
	
	
	
	// String to Object options format cache
	var optionsCache = {};
	
	// Convert String-formatted options into Object-formatted ones and store in cache
	function createOptions( options ) {
		var object = optionsCache[ options ] = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		});
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			( optionsCache[ options ] || createOptions( options ) ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
			// Last fire value (for non-forgettable lists)
			memory,
			// Flag to know if list was already fired
			fired,
			// End of the loop when firing
			firingLength,
			// Index of currently firing callback (modified by remove if needed)
			firingIndex,
			// First callback to fire (used internally by add and fireWith)
			firingStart,
			// Actual callback list
			list = [],
			// Stack of fire calls for repeatable lists
			stack = !options.once && [],
			// Fire callbacks
			fire = function( data ) {
				memory = options.memory && data;
				fired = true;
				firingIndex = firingStart || 0;
				firingStart = 0;
				firingLength = list.length;
				firing = true;
				for ( ; list && firingIndex < firingLength; firingIndex++ ) {
					if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
						memory = false; // To prevent further calls using add
						break;
					}
				}
				firing = false;
				if ( list ) {
					if ( stack ) {
						if ( stack.length ) {
							fire( stack.shift() );
						}
					} else if ( memory ) {
						list = [];
					} else {
						self.disable();
					}
				}
			},
			// Actual Callbacks object
			self = {
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
						// First, we save the current length
						var start = list.length;
						(function add( args ) {
							jQuery.each( args, function( _, arg ) {
								var type = jQuery.type( arg );
								if ( type === "function" ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && type !== "string" ) {
									// Inspect recursively
									add( arg );
								}
							});
						})( arguments );
						// Do we need to add the callbacks to the
						// current firing batch?
						if ( firing ) {
							firingLength = list.length;
						// With memory, if we're not firing then
						// we should call right away
						} else if ( memory ) {
							firingStart = start;
							fire( memory );
						}
					}
					return this;
				},
				// Remove a callback from the list
				remove: function() {
					if ( list ) {
						jQuery.each( arguments, function( _, arg ) {
							var index;
							while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
								list.splice( index, 1 );
								// Handle firing indexes
								if ( firing ) {
									if ( index <= firingLength ) {
										firingLength--;
									}
									if ( index <= firingIndex ) {
										firingIndex--;
									}
								}
							}
						});
					}
					return this;
				},
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ? jQuery.inArray( fn, list ) > -1 : !!( list && list.length );
				},
				// Remove all callbacks from the list
				empty: function() {
					list = [];
					firingLength = 0;
					return this;
				},
				// Have the list do nothing anymore
				disable: function() {
					list = stack = memory = undefined;
					return this;
				},
				// Is it disabled?
				disabled: function() {
					return !list;
				},
				// Lock the list in its current state
				lock: function() {
					stack = undefined;
					if ( !memory ) {
						self.disable();
					}
					return this;
				},
				// Is it locked?
				locked: function() {
					return !stack;
				},
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( list && ( !fired || stack ) ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						if ( firing ) {
							stack.push( args );
						} else {
							fire( args );
						}
					}
					return this;
				},
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend({
	
		Deferred: function( func ) {
			var tuples = [
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks("memory") ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred(function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[1] ](function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.done( newDefer.resolve )
											.fail( newDefer.reject )
											.progress( newDefer.notify );
									} else {
										newDefer[ tuple[ 0 ] + "With" ]( this === promise ? newDefer.promise() : this, fn ? [ returned ] : arguments );
									}
								});
							});
							fns = null;
						}).promise();
					},
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[1] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(function() {
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[0] ] = function() {
					deferred[ tuple[0] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[0] + "With" ] = list.fireWith;
			});
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred. If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
	
						} else if ( !(--remaining) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject )
							.progress( updateFunc( i, progressContexts, progressValues ) );
					} else {
						--remaining;
					}
				}
			}
	
			// if we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	});
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend({
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Make sure body exists, at least, in case IE gets a little overzealous (ticket #5443).
			if ( !document.body ) {
				return setTimeout( jQuery.ready );
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	});
	
	/**
	 * Clean-up method for dom ready events
	 */
	function detach() {
		if ( document.addEventListener ) {
			document.removeEventListener( "DOMContentLoaded", completed, false );
			window.removeEventListener( "load", completed, false );
	
		} else {
			document.detachEvent( "onreadystatechange", completed );
			window.detachEvent( "onload", completed );
		}
	}
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		// readyState === "complete" is good enough for us to call the dom ready in oldIE
		if ( document.addEventListener || event.type === "load" || document.readyState === "complete" ) {
			detach();
			jQuery.ready();
		}
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called after the browser event has already occurred.
			// we once tried to use readyState "interactive" here, but it caused issues like the one
			// discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
			if ( document.readyState === "complete" ) {
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				setTimeout( jQuery.ready );
	
			// Standards-based browsers support DOMContentLoaded
			} else if ( document.addEventListener ) {
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed, false );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed, false );
	
			// If IE event model is used
			} else {
				// Ensure firing before onload, maybe late but safe also for iframes
				document.attachEvent( "onreadystatechange", completed );
	
				// A fallback to window.onload, that will always work
				window.attachEvent( "onload", completed );
	
				// If IE and not a frame
				// continually check to see if the document is ready
				var top = false;
	
				try {
					top = window.frameElement == null && document.documentElement;
				} catch(e) {}
	
				if ( top && top.doScroll ) {
					(function doScrollCheck() {
						if ( !jQuery.isReady ) {
	
							try {
								// Use the trick by Diego Perini
								// http://javascript.nwbox.com/IEContentLoaded/
								top.doScroll("left");
							} catch(e) {
								return setTimeout( doScrollCheck, 50 );
							}
	
							// detach all dom ready events
							detach();
	
							// and execute any waiting functions
							jQuery.ready();
						}
					})();
				}
			}
		}
		return readyList.promise( obj );
	};
	
	
	var strundefined = typeof undefined;
	
	
	
	// Support: IE<9
	// Iteration over object's inherited properties before its own
	var i;
	for ( i in jQuery( support ) ) {
		break;
	}
	support.ownLast = i !== "0";
	
	// Note: most support tests are defined in their respective modules.
	// false until the test is run
	support.inlineBlockNeedsLayout = false;
	
	// Execute ASAP in case we need to set body.style.zoom
	jQuery(function() {
		// Minified: var a,b,c,d
		var val, div, body, container;
	
		body = document.getElementsByTagName( "body" )[ 0 ];
		if ( !body || !body.style ) {
			// Return for frameset docs that don't have a body
			return;
		}
	
		// Setup
		div = document.createElement( "div" );
		container = document.createElement( "div" );
		container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
		body.appendChild( container ).appendChild( div );
	
		if ( typeof div.style.zoom !== strundefined ) {
			// Support: IE<8
			// Check if natively block-level elements act like inline-block
			// elements when setting their display to 'inline' and giving
			// them layout
			div.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1";
	
			support.inlineBlockNeedsLayout = val = div.offsetWidth === 3;
			if ( val ) {
				// Prevent IE 6 from affecting layout for positioned elements #11048
				// Prevent IE from shrinking the body in IE 7 mode #12869
				// Support: IE<8
				body.style.zoom = 1;
			}
		}
	
		body.removeChild( container );
	});
	
	
	
	
	(function() {
		var div = document.createElement( "div" );
	
		// Execute the test only if not already executed in another module.
		if (support.deleteExpando == null) {
			// Support: IE<9
			support.deleteExpando = true;
			try {
				delete div.test;
			} catch( e ) {
				support.deleteExpando = false;
			}
		}
	
		// Null elements to avoid leaks in IE.
		div = null;
	})();
	
	
	/**
	 * Determines whether an object can have data
	 */
	jQuery.acceptData = function( elem ) {
		var noData = jQuery.noData[ (elem.nodeName + " ").toLowerCase() ],
			nodeType = +elem.nodeType || 1;
	
		// Do not set data on non-element DOM nodes because it will not be cleared (#8335).
		return nodeType !== 1 && nodeType !== 9 ?
			false :
	
			// Nodes accept data unless otherwise specified; rejection can be conditional
			!noData || noData !== true && elem.getAttribute("classid") === noData;
	};
	
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /([A-Z])/g;
	
	function dataAttr( elem, key, data ) {
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
	
			var name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
	
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch( e ) {}
	
				// Make sure we set the data so it isn't changed later
				jQuery.data( elem, key, data );
	
			} else {
				data = undefined;
			}
		}
	
		return data;
	}
	
	// checks a cache object for emptiness
	function isEmptyDataObject( obj ) {
		var name;
		for ( name in obj ) {
	
			// if the public data object is empty, the private is still empty
			if ( name === "data" && jQuery.isEmptyObject( obj[name] ) ) {
				continue;
			}
			if ( name !== "toJSON" ) {
				return false;
			}
		}
	
		return true;
	}
	
	function internalData( elem, name, data, pvt /* Internal Use Only */ ) {
		if ( !jQuery.acceptData( elem ) ) {
			return;
		}
	
		var ret, thisCache,
			internalKey = jQuery.expando,
	
			// We have to handle DOM nodes and JS objects differently because IE6-7
			// can't GC object references properly across the DOM-JS boundary
			isNode = elem.nodeType,
	
			// Only DOM nodes need the global jQuery cache; JS object data is
			// attached directly to the object so GC can occur automatically
			cache = isNode ? jQuery.cache : elem,
	
			// Only defining an ID for JS objects if its cache already exists allows
			// the code to shortcut on the same path as a DOM node with no cache
			id = isNode ? elem[ internalKey ] : elem[ internalKey ] && internalKey;
	
		// Avoid doing any more work than we need to when trying to get data on an
		// object that has no data at all
		if ( (!id || !cache[id] || (!pvt && !cache[id].data)) && data === undefined && typeof name === "string" ) {
			return;
		}
	
		if ( !id ) {
			// Only DOM nodes need a new unique ID for each element since their data
			// ends up in the global cache
			if ( isNode ) {
				id = elem[ internalKey ] = deletedIds.pop() || jQuery.guid++;
			} else {
				id = internalKey;
			}
		}
	
		if ( !cache[ id ] ) {
			// Avoid exposing jQuery metadata on plain JS objects when the object
			// is serialized using JSON.stringify
			cache[ id ] = isNode ? {} : { toJSON: jQuery.noop };
		}
	
		// An object can be passed to jQuery.data instead of a key/value pair; this gets
		// shallow copied over onto the existing cache
		if ( typeof name === "object" || typeof name === "function" ) {
			if ( pvt ) {
				cache[ id ] = jQuery.extend( cache[ id ], name );
			} else {
				cache[ id ].data = jQuery.extend( cache[ id ].data, name );
			}
		}
	
		thisCache = cache[ id ];
	
		// jQuery data() is stored in a separate object inside the object's internal data
		// cache in order to avoid key collisions between internal data and user-defined
		// data.
		if ( !pvt ) {
			if ( !thisCache.data ) {
				thisCache.data = {};
			}
	
			thisCache = thisCache.data;
		}
	
		if ( data !== undefined ) {
			thisCache[ jQuery.camelCase( name ) ] = data;
		}
	
		// Check for both converted-to-camel and non-converted data property names
		// If a data property was specified
		if ( typeof name === "string" ) {
	
			// First Try to find as-is property data
			ret = thisCache[ name ];
	
			// Test for null|undefined property data
			if ( ret == null ) {
	
				// Try to find the camelCased property
				ret = thisCache[ jQuery.camelCase( name ) ];
			}
		} else {
			ret = thisCache;
		}
	
		return ret;
	}
	
	function internalRemoveData( elem, name, pvt ) {
		if ( !jQuery.acceptData( elem ) ) {
			return;
		}
	
		var thisCache, i,
			isNode = elem.nodeType,
	
			// See jQuery.data for more information
			cache = isNode ? jQuery.cache : elem,
			id = isNode ? elem[ jQuery.expando ] : jQuery.expando;
	
		// If there is already no cache entry for this object, there is no
		// purpose in continuing
		if ( !cache[ id ] ) {
			return;
		}
	
		if ( name ) {
	
			thisCache = pvt ? cache[ id ] : cache[ id ].data;
	
			if ( thisCache ) {
	
				// Support array or space separated string names for data keys
				if ( !jQuery.isArray( name ) ) {
	
					// try the string as a key before any manipulation
					if ( name in thisCache ) {
						name = [ name ];
					} else {
	
						// split the camel cased version by spaces unless a key with the spaces exists
						name = jQuery.camelCase( name );
						if ( name in thisCache ) {
							name = [ name ];
						} else {
							name = name.split(" ");
						}
					}
				} else {
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = name.concat( jQuery.map( name, jQuery.camelCase ) );
				}
	
				i = name.length;
				while ( i-- ) {
					delete thisCache[ name[i] ];
				}
	
				// If there is no data left in the cache, we want to continue
				// and let the cache object itself get destroyed
				if ( pvt ? !isEmptyDataObject(thisCache) : !jQuery.isEmptyObject(thisCache) ) {
					return;
				}
			}
		}
	
		// See jQuery.data for more information
		if ( !pvt ) {
			delete cache[ id ].data;
	
			// Don't destroy the parent cache unless the internal data object
			// had been the only thing left in it
			if ( !isEmptyDataObject( cache[ id ] ) ) {
				return;
			}
		}
	
		// Destroy the cache
		if ( isNode ) {
			jQuery.cleanData( [ elem ], true );
	
		// Use delete when supported for expandos or `cache` is not a window per isWindow (#10080)
		/* jshint eqeqeq: false */
		} else if ( support.deleteExpando || cache != cache.window ) {
			/* jshint eqeqeq: true */
			delete cache[ id ];
	
		// When all else fails, null
		} else {
			cache[ id ] = null;
		}
	}
	
	jQuery.extend({
		cache: {},
	
		// The following elements (space-suffixed to avoid Object.prototype collisions)
		// throw uncatchable exceptions if you attempt to set expando properties
		noData: {
			"applet ": true,
			"embed ": true,
			// ...but Flash objects (which have this classid) *can* handle expandos
			"object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
		},
	
		hasData: function( elem ) {
			elem = elem.nodeType ? jQuery.cache[ elem[jQuery.expando] ] : elem[ jQuery.expando ];
			return !!elem && !isEmptyDataObject( elem );
		},
	
		data: function( elem, name, data ) {
			return internalData( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			return internalRemoveData( elem, name );
		},
	
		// For internal use only.
		_data: function( elem, name, data ) {
			return internalData( elem, name, data, true );
		},
	
		_removeData: function( elem, name ) {
			return internalRemoveData( elem, name, true );
		}
	});
	
	jQuery.fn.extend({
		data: function( key, value ) {
			var i, name, data,
				elem = this[0],
				attrs = elem && elem.attributes;
	
			// Special expections of .data basically thwart jQuery.access,
			// so implement the relevant behavior ourselves
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = jQuery.data( elem );
	
					if ( elem.nodeType === 1 && !jQuery._data( elem, "parsedAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice(5) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						jQuery._data( elem, "parsedAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each(function() {
					jQuery.data( this, key );
				});
			}
	
			return arguments.length > 1 ?
	
				// Sets one value
				this.each(function() {
					jQuery.data( this, key, value );
				}) :
	
				// Gets one value
				// Try to fetch any internally stored data first
				elem ? dataAttr( elem, key, jQuery.data( elem, key ) ) : undefined;
		},
	
		removeData: function( key ) {
			return this.each(function() {
				jQuery.removeData( this, key );
			});
		}
	});
	
	
	jQuery.extend({
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = jQuery._data( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray(data) ) {
						queue = jQuery._data( elem, type, jQuery.makeArray(data) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// not intended for public consumption - generates a queueHooks object, or returns the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return jQuery._data( elem, key ) || jQuery._data( elem, key, {
				empty: jQuery.Callbacks("once memory").add(function() {
					jQuery._removeData( elem, type + "queue" );
					jQuery._removeData( elem, key );
				})
			});
		}
	});
	
	jQuery.fn.extend({
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[0], type );
			}
	
			return data === undefined ?
				this :
				this.each(function() {
					var queue = jQuery.queue( this, type, data );
	
					// ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[0] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				});
		},
		dequeue: function( type ) {
			return this.each(function() {
				jQuery.dequeue( this, type );
			});
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = jQuery._data( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	});
	var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
		};
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = jQuery.access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			length = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				jQuery.access( elems, fn, i, key[i], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < length; i++ ) {
					fn( elems[i], key, raw ? value : value.call( elems[i], i, fn( elems[i], key ) ) );
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				length ? fn( elems[0], key ) : emptyGet;
	};
	var rcheckableType = (/^(?:checkbox|radio)$/i);
	
	
	
	(function() {
		// Minified: var a,b,c
		var input = document.createElement( "input" ),
			div = document.createElement( "div" ),
			fragment = document.createDocumentFragment();
	
		// Setup
		div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
	
		// IE strips leading whitespace when .innerHTML is used
		support.leadingWhitespace = div.firstChild.nodeType === 3;
	
		// Make sure that tbody elements aren't automatically inserted
		// IE will insert them into empty tables
		support.tbody = !div.getElementsByTagName( "tbody" ).length;
	
		// Make sure that link elements get serialized correctly by innerHTML
		// This requires a wrapper element in IE
		support.htmlSerialize = !!div.getElementsByTagName( "link" ).length;
	
		// Makes sure cloning an html5 element does not cause problems
		// Where outerHTML is undefined, this still works
		support.html5Clone =
			document.createElement( "nav" ).cloneNode( true ).outerHTML !== "<:nav></:nav>";
	
		// Check if a disconnected checkbox will retain its checked
		// value of true after appended to the DOM (IE6/7)
		input.type = "checkbox";
		input.checked = true;
		fragment.appendChild( input );
		support.appendChecked = input.checked;
	
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		// Support: IE6-IE11+
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// #11217 - WebKit loses check when the name is after the checked attribute
		fragment.appendChild( div );
		div.innerHTML = "<input type='radio' checked='checked' name='t'/>";
	
		// Support: Safari 5.1, iOS 5.1, Android 4.x, Android 2.3
		// old WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<9
		// Opera does not clone events (and typeof div.attachEvent === undefined).
		// IE9-10 clones events bound via attachEvent, but they don't trigger with .click()
		support.noCloneEvent = true;
		if ( div.attachEvent ) {
			div.attachEvent( "onclick", function() {
				support.noCloneEvent = false;
			});
	
			div.cloneNode( true ).click();
		}
	
		// Execute the test only if not already executed in another module.
		if (support.deleteExpando == null) {
			// Support: IE<9
			support.deleteExpando = true;
			try {
				delete div.test;
			} catch( e ) {
				support.deleteExpando = false;
			}
		}
	})();
	
	
	(function() {
		var i, eventName,
			div = document.createElement( "div" );
	
		// Support: IE<9 (lack submit/change bubble), Firefox 23+ (lack focusin event)
		for ( i in { submit: true, change: true, focusin: true }) {
			eventName = "on" + i;
	
			if ( !(support[ i + "Bubbles" ] = eventName in window) ) {
				// Beware of CSP restrictions (https://developer.mozilla.org/en/Security/CSP)
				div.setAttribute( eventName, "t" );
				support[ i + "Bubbles" ] = div.attributes[ eventName ].expando === false;
			}
		}
	
		// Null elements to avoid leaks in IE.
		div = null;
	})();
	
	
	var rformElems = /^(?:input|select|textarea)$/i,
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/,
		rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
			var tmp, events, t, handleObjIn,
				special, eventHandle, handleObj,
				handlers, type, namespaces, origType,
				elemData = jQuery._data( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !(events = elemData.events) ) {
				events = elemData.events = {};
			}
			if ( !(eventHandle = elemData.handle) ) {
				eventHandle = elemData.handle = function( e ) {
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== strundefined && (!e || jQuery.event.triggered !== e.type) ?
						jQuery.event.dispatch.apply( eventHandle.elem, arguments ) :
						undefined;
				};
				// Add elem as a property of the handle fn to prevent a memory leak with IE non-native events
				eventHandle.elem = elem;
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[t] ) || [];
				type = origType = tmp[1];
				namespaces = ( tmp[2] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend({
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join(".")
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !(handlers = events[ type ]) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener/attachEvent if the special events handler returns false
					if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
						// Bind the global event handler to the element
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle, false );
	
						} else if ( elem.attachEvent ) {
							elem.attachEvent( "on" + type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
			// Nullify elem to prevent memory leaks in IE
			elem = null;
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
			var j, handleObj, tmp,
				origCount, t, events,
				special, handlers, type,
				namespaces, origType,
				elemData = jQuery.hasData( elem ) && jQuery._data( elem );
	
			if ( !elemData || !(events = elemData.events) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[t] ) || [];
				type = origType = tmp[1];
				namespaces = ( tmp[2] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[2] && new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				delete elemData.handle;
	
				// removeData also checks for emptiness and clears the expando if empty
				// so use it instead of delete
				jQuery._removeData( elem, "events" );
			}
		},
	
		trigger: function( event, data, elem, onlyHandlers ) {
			var handle, ontype, cur,
				bubbleType, special, tmp, i,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split(".") : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf(".") >= 0 ) {
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split(".");
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf(":") < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join(".");
			event.namespace_re = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === (elem.ownerDocument || document) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( (cur = eventPath[i++]) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( jQuery._data( cur, "events" ) || {} )[ event.type ] && jQuery._data( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && jQuery.acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( (!special._default || special._default.apply( eventPath.pop(), data ) === false) &&
					jQuery.acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Can't use an .isFunction() check here because IE6/7 fails that test.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && elem[ type ] && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						try {
							elem[ type ]();
						} catch ( e ) {
							// IE<9 dies on focus/blur to hidden element (#1486,#12518)
							// only reproducible on winXP IE8 native, not IE9 in IE8 mode
						}
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, ret, handleObj, matched, j,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( jQuery._data( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[0] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( (matched = handlerQueue[ i++ ]) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( (handleObj = matched.handlers[ j++ ]) && !event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or
					// 2) have namespace(s) a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.namespace_re || event.namespace_re.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
								.apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( (event.result = ret) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var sel, handleObj, matches, i,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			// Avoid non-left-click bubbling in Firefox (#3861)
			if ( delegateCount && cur.nodeType && (!event.button || event.type !== "click") ) {
	
				/* jshint eqeqeq: false */
				for ( ; cur != this; cur = cur.parentNode || this ) {
					/* jshint eqeqeq: true */
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && (cur.disabled !== true || event.type !== "click") ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) >= 0 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push({ elem: cur, handlers: matches });
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push({ elem: this, handlers: handlers.slice( delegateCount ) });
			}
	
			return handlerQueue;
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: IE<9
			// Fix target property (#1925)
			if ( !event.target ) {
				event.target = originalEvent.srcElement || document;
			}
	
			// Support: Chrome 23+, Safari?
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			// Support: IE<9
			// For mouse/key events, metaKey==false if it's undefined (#3368, #11328)
			event.metaKey = !!event.metaKey;
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split(" "),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
			filter: function( event, original ) {
				var body, eventDoc, doc,
					button = original.button,
					fromElement = original.fromElement;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add relatedTarget, if necessary
				if ( !event.relatedTarget && fromElement ) {
					event.relatedTarget = fromElement === event.target ? original.toElement : fromElement;
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		special: {
			load: {
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						try {
							this.focus();
							return false;
						} catch ( e ) {
							// Support: IE<9
							// If we error on focus to hidden element (#1486, #12518),
							// let .trigger() run the handlers
						}
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( jQuery.nodeName( this, "input" ) && this.type === "checkbox" && this.click ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		},
	
		simulate: function( type, elem, event, bubble ) {
			// Piggyback on a donor event to simulate a different one.
			// Fake originalEvent to avoid donor's stopPropagation, but if the
			// simulated event prevents default then we do the same on the donor.
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true,
					originalEvent: {}
				}
			);
			if ( bubble ) {
				jQuery.event.trigger( e, null, elem );
			} else {
				jQuery.event.dispatch.call( elem, e );
			}
			if ( e.isDefaultPrevented() ) {
				event.preventDefault();
			}
		}
	};
	
	jQuery.removeEvent = document.removeEventListener ?
		function( elem, type, handle ) {
			if ( elem.removeEventListener ) {
				elem.removeEventListener( type, handle, false );
			}
		} :
		function( elem, type, handle ) {
			var name = "on" + type;
	
			if ( elem.detachEvent ) {
	
				// #8545, #7054, preventing memory leaks for custom events in IE6-8
				// detachEvent needed property on element, by name of that event, to properly expose it to GC
				if ( typeof elem[ name ] === strundefined ) {
					elem[ name ] = null;
				}
	
				elem.detachEvent( name, handle );
			}
		};
	
	jQuery.Event = function( src, props ) {
		// Allow instantiation without the 'new' keyword
		if ( !(this instanceof jQuery.Event) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
					// Support: IE < 9, Android < 4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
			if ( !e ) {
				return;
			}
	
			// If preventDefault exists, run it on the original event
			if ( e.preventDefault ) {
				e.preventDefault();
	
			// Support: IE
			// Otherwise set the returnValue property of the original event to false
			} else {
				e.returnValue = false;
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
			if ( !e ) {
				return;
			}
			// If stopPropagation exists, run it on the original event
			if ( e.stopPropagation ) {
				e.stopPropagation();
			}
	
			// Support: IE
			// Set the cancelBubble property of the original event to true
			e.cancelBubble = true;
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && e.stopImmediatePropagation ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	jQuery.each({
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mousenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	});
	
	// IE submit delegation
	if ( !support.submitBubbles ) {
	
		jQuery.event.special.submit = {
			setup: function() {
				// Only need this for delegated form submit events
				if ( jQuery.nodeName( this, "form" ) ) {
					return false;
				}
	
				// Lazy-add a submit handler when a descendant form may potentially be submitted
				jQuery.event.add( this, "click._submit keypress._submit", function( e ) {
					// Node name check avoids a VML-related crash in IE (#9807)
					var elem = e.target,
						form = jQuery.nodeName( elem, "input" ) || jQuery.nodeName( elem, "button" ) ? elem.form : undefined;
					if ( form && !jQuery._data( form, "submitBubbles" ) ) {
						jQuery.event.add( form, "submit._submit", function( event ) {
							event._submit_bubble = true;
						});
						jQuery._data( form, "submitBubbles", true );
					}
				});
				// return undefined since we don't need an event listener
			},
	
			postDispatch: function( event ) {
				// If form was submitted by the user, bubble the event up the tree
				if ( event._submit_bubble ) {
					delete event._submit_bubble;
					if ( this.parentNode && !event.isTrigger ) {
						jQuery.event.simulate( "submit", this.parentNode, event, true );
					}
				}
			},
	
			teardown: function() {
				// Only need this for delegated form submit events
				if ( jQuery.nodeName( this, "form" ) ) {
					return false;
				}
	
				// Remove delegated handlers; cleanData eventually reaps submit handlers attached above
				jQuery.event.remove( this, "._submit" );
			}
		};
	}
	
	// IE change delegation and checkbox/radio fix
	if ( !support.changeBubbles ) {
	
		jQuery.event.special.change = {
	
			setup: function() {
	
				if ( rformElems.test( this.nodeName ) ) {
					// IE doesn't fire change on a check/radio until blur; trigger it on click
					// after a propertychange. Eat the blur-change in special.change.handle.
					// This still fires onchange a second time for check/radio after blur.
					if ( this.type === "checkbox" || this.type === "radio" ) {
						jQuery.event.add( this, "propertychange._change", function( event ) {
							if ( event.originalEvent.propertyName === "checked" ) {
								this._just_changed = true;
							}
						});
						jQuery.event.add( this, "click._change", function( event ) {
							if ( this._just_changed && !event.isTrigger ) {
								this._just_changed = false;
							}
							// Allow triggered, simulated change events (#11500)
							jQuery.event.simulate( "change", this, event, true );
						});
					}
					return false;
				}
				// Delegated event; lazy-add a change handler on descendant inputs
				jQuery.event.add( this, "beforeactivate._change", function( e ) {
					var elem = e.target;
	
					if ( rformElems.test( elem.nodeName ) && !jQuery._data( elem, "changeBubbles" ) ) {
						jQuery.event.add( elem, "change._change", function( event ) {
							if ( this.parentNode && !event.isSimulated && !event.isTrigger ) {
								jQuery.event.simulate( "change", this.parentNode, event, true );
							}
						});
						jQuery._data( elem, "changeBubbles", true );
					}
				});
			},
	
			handle: function( event ) {
				var elem = event.target;
	
				// Swallow native change events from checkbox/radio, we already triggered them above
				if ( this !== elem || event.isSimulated || event.isTrigger || (elem.type !== "radio" && elem.type !== "checkbox") ) {
					return event.handleObj.handler.apply( this, arguments );
				}
			},
	
			teardown: function() {
				jQuery.event.remove( this, "._change" );
	
				return !rformElems.test( this.nodeName );
			}
		};
	}
	
	// Create "bubbling" focus and blur events
	if ( !support.focusinBubbles ) {
		jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
					jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
				};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = jQuery._data( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					jQuery._data( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = jQuery._data( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						jQuery._removeData( doc, fix );
					} else {
						jQuery._data( doc, fix, attaches );
					}
				}
			};
		});
	}
	
	jQuery.fn.extend({
	
		on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
			var type, origFn;
	
			// Types can be a map of types/handlers
			if ( typeof types === "object" ) {
				// ( types-Object, selector, data )
				if ( typeof selector !== "string" ) {
					// ( types-Object, data )
					data = data || selector;
					selector = undefined;
				}
				for ( type in types ) {
					this.on( type, selector, data, types[ type ], one );
				}
				return this;
			}
	
			if ( data == null && fn == null ) {
				// ( types, fn )
				fn = selector;
				data = selector = undefined;
			} else if ( fn == null ) {
				if ( typeof selector === "string" ) {
					// ( types, selector, fn )
					fn = data;
					data = undefined;
				} else {
					// ( types, data, fn )
					fn = data;
					data = selector;
					selector = undefined;
				}
			}
			if ( fn === false ) {
				fn = returnFalse;
			} else if ( !fn ) {
				return this;
			}
	
			if ( one === 1 ) {
				origFn = fn;
				fn = function( event ) {
					// Can use an empty set, since event contains the info
					jQuery().off( event );
					return origFn.apply( this, arguments );
				};
				// Use same guid so caller can remove using origFn
				fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
			}
			return this.each( function() {
				jQuery.event.add( this, types, fn, data, selector );
			});
		},
		one: function( types, selector, data, fn ) {
			return this.on( types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each(function() {
				jQuery.event.remove( this, types, fn, selector );
			});
		},
	
		trigger: function( type, data ) {
			return this.each(function() {
				jQuery.event.trigger( type, data, this );
			});
		},
		triggerHandler: function( type, data ) {
			var elem = this[0];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	});
	
	
	function createSafeFragment( document ) {
		var list = nodeNames.split( "|" ),
			safeFrag = document.createDocumentFragment();
	
		if ( safeFrag.createElement ) {
			while ( list.length ) {
				safeFrag.createElement(
					list.pop()
				);
			}
		}
		return safeFrag;
	}
	
	var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|" +
			"header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
		rinlinejQuery = / jQuery\d+="(?:null|\d+)"/g,
		rnoshimcache = new RegExp("<(?:" + nodeNames + ")[\\s/>]", "i"),
		rleadingWhitespace = /^\s+/,
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
		rtagName = /<([\w:]+)/,
		rtbody = /<tbody/i,
		rhtml = /<|&#?\w+;/,
		rnoInnerhtml = /<(?:script|style|link)/i,
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptType = /^$|\/(?:java|ecma)script/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
	
		// We have to close these tags to support XHTML (#13200)
		wrapMap = {
			option: [ 1, "<select multiple='multiple'>", "</select>" ],
			legend: [ 1, "<fieldset>", "</fieldset>" ],
			area: [ 1, "<map>", "</map>" ],
			param: [ 1, "<object>", "</object>" ],
			thead: [ 1, "<table>", "</table>" ],
			tr: [ 2, "<table><tbody>", "</tbody></table>" ],
			col: [ 2, "<table><tbody></tbody><colgroup>", "</colgroup></table>" ],
			td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
			// IE6-8 can't serialize link, script, style, or any html5 (NoScope) tags,
			// unless wrapped in a div with non-breaking characters in front of it.
			_default: support.htmlSerialize ? [ 0, "", "" ] : [ 1, "X<div>", "</div>"  ]
		},
		safeFragment = createSafeFragment( document ),
		fragmentDiv = safeFragment.appendChild( document.createElement("div") );
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	function getAll( context, tag ) {
		var elems, elem,
			i = 0,
			found = typeof context.getElementsByTagName !== strundefined ? context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== strundefined ? context.querySelectorAll( tag || "*" ) :
				undefined;
	
		if ( !found ) {
			for ( found = [], elems = context.childNodes || context; (elem = elems[i]) != null; i++ ) {
				if ( !tag || jQuery.nodeName( elem, tag ) ) {
					found.push( elem );
				} else {
					jQuery.merge( found, getAll( elem, tag ) );
				}
			}
		}
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], found ) :
			found;
	}
	
	// Used in buildFragment, fixes the defaultChecked property
	function fixDefaultChecked( elem ) {
		if ( rcheckableType.test( elem.type ) ) {
			elem.defaultChecked = elem.checked;
		}
	}
	
	// Support: IE<8
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName("tbody")[0] ||
				elem.appendChild( elem.ownerDocument.createElement("tbody") ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = (jQuery.find.attr( elem, "type" ) !== null) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
		if ( match ) {
			elem.type = match[1];
		} else {
			elem.removeAttribute("type");
		}
		return elem;
	}
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var elem,
			i = 0;
		for ( ; (elem = elems[i]) != null; i++ ) {
			jQuery._data( elem, "globalEval", !refElements || jQuery._data( refElements[i], "globalEval" ) );
		}
	}
	
	function cloneCopyEvent( src, dest ) {
	
		if ( dest.nodeType !== 1 || !jQuery.hasData( src ) ) {
			return;
		}
	
		var type, i, l,
			oldData = jQuery._data( src ),
			curData = jQuery._data( dest, oldData ),
			events = oldData.events;
	
		if ( events ) {
			delete curData.handle;
			curData.events = {};
	
			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	
		// make the cloned public data object a copy from the original
		if ( curData.data ) {
			curData.data = jQuery.extend( {}, curData.data );
		}
	}
	
	function fixCloneNodeIssues( src, dest ) {
		var nodeName, e, data;
	
		// We do not need to do anything for non-Elements
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		nodeName = dest.nodeName.toLowerCase();
	
		// IE6-8 copies events bound via attachEvent when using cloneNode.
		if ( !support.noCloneEvent && dest[ jQuery.expando ] ) {
			data = jQuery._data( dest );
	
			for ( e in data.events ) {
				jQuery.removeEvent( dest, e, data.handle );
			}
	
			// Event data gets referenced instead of copied if the expando gets copied too
			dest.removeAttribute( jQuery.expando );
		}
	
		// IE blanks contents when cloning scripts, and tries to evaluate newly-set text
		if ( nodeName === "script" && dest.text !== src.text ) {
			disableScript( dest ).text = src.text;
			restoreScript( dest );
	
		// IE6-10 improperly clones children of object elements using classid.
		// IE10 throws NoModificationAllowedError if parent is null, #12132.
		} else if ( nodeName === "object" ) {
			if ( dest.parentNode ) {
				dest.outerHTML = src.outerHTML;
			}
	
			// This path appears unavoidable for IE9. When cloning an object
			// element in IE9, the outerHTML strategy above is not sufficient.
			// If the src has innerHTML and the destination does not,
			// copy the src.innerHTML into the dest.innerHTML. #10324
			if ( support.html5Clone && ( src.innerHTML && !jQuery.trim(dest.innerHTML) ) ) {
				dest.innerHTML = src.innerHTML;
			}
	
		} else if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			// IE6-8 fails to persist the checked state of a cloned checkbox
			// or radio button. Worse, IE6-7 fail to give the cloned element
			// a checked appearance if the defaultChecked value isn't also set
	
			dest.defaultChecked = dest.checked = src.checked;
	
			// IE6-7 get confused and end up setting the value of a cloned
			// checkbox/radio button to an empty string instead of "on"
			if ( dest.value !== src.value ) {
				dest.value = src.value;
			}
	
		// IE6-8 fails to return the selected option to the default selected
		// state when cloning options
		} else if ( nodeName === "option" ) {
			dest.defaultSelected = dest.selected = src.defaultSelected;
	
		// IE6-8 fails to set the defaultValue to the correct value when
		// cloning other types of input fields
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	jQuery.extend({
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var destElements, node, clone, i, srcElements,
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			if ( support.html5Clone || jQuery.isXMLDoc(elem) || !rnoshimcache.test( "<" + elem.nodeName + ">" ) ) {
				clone = elem.cloneNode( true );
	
			// IE<=8 does not properly clone detached, unknown element nodes
			} else {
				fragmentDiv.innerHTML = elem.outerHTML;
				fragmentDiv.removeChild( clone = fragmentDiv.firstChild );
			}
	
			if ( (!support.noCloneEvent || !support.noCloneChecked) &&
					(elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				// Fix all IE cloning issues
				for ( i = 0; (node = srcElements[i]) != null; ++i ) {
					// Ensure that the destination node is not null; Fixes #9587
					if ( destElements[i] ) {
						fixCloneNodeIssues( node, destElements[i] );
					}
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0; (node = srcElements[i]) != null; i++ ) {
						cloneCopyEvent( node, destElements[i] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			destElements = srcElements = node = null;
	
			// Return the cloned set
			return clone;
		},
	
		buildFragment: function( elems, context, scripts, selection ) {
			var j, elem, contains,
				tmp, tag, tbody, wrap,
				l = elems.length,
	
				// Ensure a safe fragment
				safe = createSafeFragment( context ),
	
				nodes = [],
				i = 0;
	
			for ( ; i < l; i++ ) {
				elem = elems[ i ];
	
				if ( elem || elem === 0 ) {
	
					// Add nodes directly
					if ( jQuery.type( elem ) === "object" ) {
						jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
					// Convert non-html into a text node
					} else if ( !rhtml.test( elem ) ) {
						nodes.push( context.createTextNode( elem ) );
	
					// Convert html into DOM nodes
					} else {
						tmp = tmp || safe.appendChild( context.createElement("div") );
	
						// Deserialize a standard representation
						tag = (rtagName.exec( elem ) || [ "", "" ])[ 1 ].toLowerCase();
						wrap = wrapMap[ tag ] || wrapMap._default;
	
						tmp.innerHTML = wrap[1] + elem.replace( rxhtmlTag, "<$1></$2>" ) + wrap[2];
	
						// Descend through wrappers to the right content
						j = wrap[0];
						while ( j-- ) {
							tmp = tmp.lastChild;
						}
	
						// Manually add leading whitespace removed by IE
						if ( !support.leadingWhitespace && rleadingWhitespace.test( elem ) ) {
							nodes.push( context.createTextNode( rleadingWhitespace.exec( elem )[0] ) );
						}
	
						// Remove IE's autoinserted <tbody> from table fragments
						if ( !support.tbody ) {
	
							// String was a <table>, *may* have spurious <tbody>
							elem = tag === "table" && !rtbody.test( elem ) ?
								tmp.firstChild :
	
								// String was a bare <thead> or <tfoot>
								wrap[1] === "<table>" && !rtbody.test( elem ) ?
									tmp :
									0;
	
							j = elem && elem.childNodes.length;
							while ( j-- ) {
								if ( jQuery.nodeName( (tbody = elem.childNodes[j]), "tbody" ) && !tbody.childNodes.length ) {
									elem.removeChild( tbody );
								}
							}
						}
	
						jQuery.merge( nodes, tmp.childNodes );
	
						// Fix #12392 for WebKit and IE > 9
						tmp.textContent = "";
	
						// Fix #12392 for oldIE
						while ( tmp.firstChild ) {
							tmp.removeChild( tmp.firstChild );
						}
	
						// Remember the top-level container for proper cleanup
						tmp = safe.lastChild;
					}
				}
			}
	
			// Fix #11356: Clear elements from fragment
			if ( tmp ) {
				safe.removeChild( tmp );
			}
	
			// Reset defaultChecked for any radios and checkboxes
			// about to be appended to the DOM in IE 6/7 (#8060)
			if ( !support.appendChecked ) {
				jQuery.grep( getAll( nodes, "input" ), fixDefaultChecked );
			}
	
			i = 0;
			while ( (elem = nodes[ i++ ]) ) {
	
				// #4087 - If origin and destination elements are the same, and this is
				// that element, do not do anything
				if ( selection && jQuery.inArray( elem, selection ) !== -1 ) {
					continue;
				}
	
				contains = jQuery.contains( elem.ownerDocument, elem );
	
				// Append to fragment
				tmp = getAll( safe.appendChild( elem ), "script" );
	
				// Preserve script evaluation history
				if ( contains ) {
					setGlobalEval( tmp );
				}
	
				// Capture executables
				if ( scripts ) {
					j = 0;
					while ( (elem = tmp[ j++ ]) ) {
						if ( rscriptType.test( elem.type || "" ) ) {
							scripts.push( elem );
						}
					}
				}
			}
	
			tmp = null;
	
			return safe;
		},
	
		cleanData: function( elems, /* internal */ acceptData ) {
			var elem, type, id, data,
				i = 0,
				internalKey = jQuery.expando,
				cache = jQuery.cache,
				deleteExpando = support.deleteExpando,
				special = jQuery.event.special;
	
			for ( ; (elem = elems[i]) != null; i++ ) {
				if ( acceptData || jQuery.acceptData( elem ) ) {
	
					id = elem[ internalKey ];
					data = id && cache[ id ];
	
					if ( data ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Remove cache only if it was not already removed by jQuery.event.remove
						if ( cache[ id ] ) {
	
							delete cache[ id ];
	
							// IE does not allow us to delete expando properties from nodes,
							// nor does it have a removeAttribute function on Document nodes;
							// we must handle all of these cases
							if ( deleteExpando ) {
								delete elem[ internalKey ];
	
							} else if ( typeof elem.removeAttribute !== strundefined ) {
								elem.removeAttribute( internalKey );
	
							} else {
								elem[ internalKey ] = null;
							}
	
							deletedIds.push( id );
						}
					}
				}
			}
		}
	});
	
	jQuery.fn.extend({
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().append( ( this[0] && this[0].ownerDocument || document ).createTextNode( value ) );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			});
		},
	
		prepend: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			});
		},
	
		before: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			});
		},
	
		after: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			});
		},
	
		remove: function( selector, keepData /* Internal Use Only */ ) {
			var elem,
				elems = selector ? jQuery.filter( selector, this ) : this,
				i = 0;
	
			for ( ; (elem = elems[i]) != null; i++ ) {
	
				if ( !keepData && elem.nodeType === 1 ) {
					jQuery.cleanData( getAll( elem ) );
				}
	
				if ( elem.parentNode ) {
					if ( keepData && jQuery.contains( elem.ownerDocument, elem ) ) {
						setGlobalEval( getAll( elem, "script" ) );
					}
					elem.parentNode.removeChild( elem );
				}
			}
	
			return this;
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; (elem = this[i]) != null; i++ ) {
				// Remove element nodes and prevent memory leaks
				if ( elem.nodeType === 1 ) {
					jQuery.cleanData( getAll( elem, false ) );
				}
	
				// Remove any remaining nodes
				while ( elem.firstChild ) {
					elem.removeChild( elem.firstChild );
				}
	
				// If this is a select, ensure that it displays empty (#12336)
				// Support: IE<9
				if ( elem.options && jQuery.nodeName( elem, "select" ) ) {
					elem.options.length = 0;
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map(function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			});
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined ) {
					return elem.nodeType === 1 ?
						elem.innerHTML.replace( rinlinejQuery, "" ) :
						undefined;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					( support.htmlSerialize || !rnoshimcache.test( value )  ) &&
					( support.leadingWhitespace || !rleadingWhitespace.test( value ) ) &&
					!wrapMap[ (rtagName.exec( value ) || [ "", "" ])[ 1 ].toLowerCase() ] ) {
	
					value = value.replace( rxhtmlTag, "<$1></$2>" );
	
					try {
						for (; i < l; i++ ) {
							// Remove element nodes and prevent memory leaks
							elem = this[i] || {};
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch(e) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var arg = arguments[ 0 ];
	
			// Make the changes, replacing each context element with the new content
			this.domManip( arguments, function( elem ) {
				arg = this.parentNode;
	
				jQuery.cleanData( getAll( this ) );
	
				if ( arg ) {
					arg.replaceChild( elem, this );
				}
			});
	
			// Force removal if there was no new content (e.g., from empty arguments)
			return arg && (arg.length || arg.nodeType) ? this : this.remove();
		},
	
		detach: function( selector ) {
			return this.remove( selector, true );
		},
	
		domManip: function( args, callback ) {
	
			// Flatten any nested arrays
			args = concat.apply( [], args );
	
			var first, node, hasScripts,
				scripts, doc, fragment,
				i = 0,
				l = this.length,
				set = this,
				iNoClone = l - 1,
				value = args[0],
				isFunction = jQuery.isFunction( value );
	
			// We can't cloneNode fragments that contain checked, in WebKit
			if ( isFunction ||
					( l > 1 && typeof value === "string" &&
						!support.checkClone && rchecked.test( value ) ) ) {
				return this.each(function( index ) {
					var self = set.eq( index );
					if ( isFunction ) {
						args[0] = value.call( this, index, self.html() );
					}
					self.domManip( args, callback );
				});
			}
	
			if ( l ) {
				fragment = jQuery.buildFragment( args, this[ 0 ].ownerDocument, false, this );
				first = fragment.firstChild;
	
				if ( fragment.childNodes.length === 1 ) {
					fragment = first;
				}
	
				if ( first ) {
					scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
					hasScripts = scripts.length;
	
					// Use the original fragment for the last item instead of the first because it can end up
					// being emptied incorrectly in certain situations (#8070).
					for ( ; i < l; i++ ) {
						node = fragment;
	
						if ( i !== iNoClone ) {
							node = jQuery.clone( node, true, true );
	
							// Keep references to cloned scripts for later restoration
							if ( hasScripts ) {
								jQuery.merge( scripts, getAll( node, "script" ) );
							}
						}
	
						callback.call( this[i], node, i );
					}
	
					if ( hasScripts ) {
						doc = scripts[ scripts.length - 1 ].ownerDocument;
	
						// Reenable scripts
						jQuery.map( scripts, restoreScript );
	
						// Evaluate executable scripts on first document insertion
						for ( i = 0; i < hasScripts; i++ ) {
							node = scripts[ i ];
							if ( rscriptType.test( node.type || "" ) &&
								!jQuery._data( node, "globalEval" ) && jQuery.contains( doc, node ) ) {
	
								if ( node.src ) {
									// Optional AJAX dependency, but won't run scripts if not present
									if ( jQuery._evalUrl ) {
										jQuery._evalUrl( node.src );
									}
								} else {
									jQuery.globalEval( ( node.text || node.textContent || node.innerHTML || "" ).replace( rcleanScript, "" ) );
								}
							}
						}
					}
	
					// Fix #11809: Avoid leaking memory
					fragment = first = null;
				}
			}
	
			return this;
		}
	});
	
	jQuery.each({
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				i = 0,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone(true);
				jQuery( insert[i] )[ original ]( elems );
	
				// Modern browsers can apply jQuery collections as arrays, but oldIE needs a .get()
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	});
	
	
	var iframe,
		elemdisplay = {};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var style,
			elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			// getDefaultComputedStyle might be reliably used only on attached element
			display = window.getDefaultComputedStyle && ( style = window.getDefaultComputedStyle( elem[ 0 ] ) ) ?
	
				// Use of this method is a temporary fix (more like optmization) until something better comes along,
				// since it was removed from specification and supported only in FF
				style.display : jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = (iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" )).appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = ( iframe[ 0 ].contentWindow || iframe[ 0 ].contentDocument ).document;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	
	
	(function() {
		var shrinkWrapBlocksVal;
	
		support.shrinkWrapBlocks = function() {
			if ( shrinkWrapBlocksVal != null ) {
				return shrinkWrapBlocksVal;
			}
	
			// Will be changed later if needed.
			shrinkWrapBlocksVal = false;
	
			// Minified: var b,c,d
			var div, body, container;
	
			body = document.getElementsByTagName( "body" )[ 0 ];
			if ( !body || !body.style ) {
				// Test fired too early or in an unsupported environment, exit.
				return;
			}
	
			// Setup
			div = document.createElement( "div" );
			container = document.createElement( "div" );
			container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
			body.appendChild( container ).appendChild( div );
	
			// Support: IE6
			// Check if elements with layout shrink-wrap their children
			if ( typeof div.style.zoom !== strundefined ) {
				// Reset CSS: box-sizing; display; margin; border
				div.style.cssText =
					// Support: Firefox<29, Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
					"box-sizing:content-box;display:block;margin:0;border:0;" +
					"padding:1px;width:1px;zoom:1";
				div.appendChild( document.createElement( "div" ) ).style.width = "5px";
				shrinkWrapBlocksVal = div.offsetWidth !== 3;
			}
	
			body.removeChild( container );
	
			return shrinkWrapBlocksVal;
		};
	
	})();
	var rmargin = (/^margin/);
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	
	
	var getStyles, curCSS,
		rposition = /^(top|right|bottom|left)$/;
	
	if ( window.getComputedStyle ) {
		getStyles = function( elem ) {
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			if ( elem.ownerDocument.defaultView.opener ) {
				return elem.ownerDocument.defaultView.getComputedStyle( elem, null );
			}
	
			return window.getComputedStyle( elem, null );
		};
	
		curCSS = function( elem, name, computed ) {
			var width, minWidth, maxWidth, ret,
				style = elem.style;
	
			computed = computed || getStyles( elem );
	
			// getPropertyValue is only needed for .css('filter') in IE9, see #12537
			ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;
	
			if ( computed ) {
	
				if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
					ret = jQuery.style( elem, name );
				}
	
				// A tribute to the "awesome hack by Dean Edwards"
				// Chrome < 17 and Safari 5.0 uses "computed value" instead of "used value" for margin-right
				// Safari 5.1.7 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
				// this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
				if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
					// Remember the original values
					width = style.width;
					minWidth = style.minWidth;
					maxWidth = style.maxWidth;
	
					// Put in the new values to get a computed value out
					style.minWidth = style.maxWidth = style.width = ret;
					ret = computed.width;
	
					// Revert the changed values
					style.width = width;
					style.minWidth = minWidth;
					style.maxWidth = maxWidth;
				}
			}
	
			// Support: IE
			// IE returns zIndex value as an integer.
			return ret === undefined ?
				ret :
				ret + "";
		};
	} else if ( document.documentElement.currentStyle ) {
		getStyles = function( elem ) {
			return elem.currentStyle;
		};
	
		curCSS = function( elem, name, computed ) {
			var left, rs, rsLeft, ret,
				style = elem.style;
	
			computed = computed || getStyles( elem );
			ret = computed ? computed[ name ] : undefined;
	
			// Avoid setting ret to empty string here
			// so we don't default to auto
			if ( ret == null && style && style[ name ] ) {
				ret = style[ name ];
			}
	
			// From the awesome hack by Dean Edwards
			// http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	
			// If we're not dealing with a regular pixel number
			// but a number that has a weird ending, we need to convert it to pixels
			// but not position css attributes, as those are proportional to the parent element instead
			// and we can't measure the parent instead because it might trigger a "stacking dolls" problem
			if ( rnumnonpx.test( ret ) && !rposition.test( name ) ) {
	
				// Remember the original values
				left = style.left;
				rs = elem.runtimeStyle;
				rsLeft = rs && rs.left;
	
				// Put in the new values to get a computed value out
				if ( rsLeft ) {
					rs.left = elem.currentStyle.left;
				}
				style.left = name === "fontSize" ? "1em" : ret;
				ret = style.pixelLeft + "px";
	
				// Revert the changed values
				style.left = left;
				if ( rsLeft ) {
					rs.left = rsLeft;
				}
			}
	
			// Support: IE
			// IE returns zIndex value as an integer.
			return ret === undefined ?
				ret :
				ret + "" || "auto";
		};
	}
	
	
	
	
	function addGetHookIf( conditionFn, hookFn ) {
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				var condition = conditionFn();
	
				if ( condition == null ) {
					// The test was not ready at this point; screw the hook this time
					// but check again when needed next time.
					return;
				}
	
				if ( condition ) {
					// Hook not needed (or it's not possible to use it due to missing dependency),
					// remove it.
					// Since there are no other hooks for marginRight, remove the whole object.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
	
				return (this.get = hookFn).apply( this, arguments );
			}
		};
	}
	
	
	(function() {
		// Minified: var b,c,d,e,f,g, h,i
		var div, style, a, pixelPositionVal, boxSizingReliableVal,
			reliableHiddenOffsetsVal, reliableMarginRightVal;
	
		// Setup
		div = document.createElement( "div" );
		div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
		a = div.getElementsByTagName( "a" )[ 0 ];
		style = a && a.style;
	
		// Finish early in limited (non-browser) environments
		if ( !style ) {
			return;
		}
	
		style.cssText = "float:left;opacity:.5";
	
		// Support: IE<9
		// Make sure that element opacity exists (as opposed to filter)
		support.opacity = style.opacity === "0.5";
	
		// Verify style float existence
		// (IE uses styleFloat instead of cssFloat)
		support.cssFloat = !!style.cssFloat;
	
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		// Support: Firefox<29, Android 2.3
		// Vendor-prefix box-sizing
		support.boxSizing = style.boxSizing === "" || style.MozBoxSizing === "" ||
			style.WebkitBoxSizing === "";
	
		jQuery.extend(support, {
			reliableHiddenOffsets: function() {
				if ( reliableHiddenOffsetsVal == null ) {
					computeStyleTests();
				}
				return reliableHiddenOffsetsVal;
			},
	
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return boxSizingReliableVal;
			},
	
			pixelPosition: function() {
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return pixelPositionVal;
			},
	
			// Support: Android 2.3
			reliableMarginRight: function() {
				if ( reliableMarginRightVal == null ) {
					computeStyleTests();
				}
				return reliableMarginRightVal;
			}
		});
	
		function computeStyleTests() {
			// Minified: var b,c,d,j
			var div, body, container, contents;
	
			body = document.getElementsByTagName( "body" )[ 0 ];
			if ( !body || !body.style ) {
				// Test fired too early or in an unsupported environment, exit.
				return;
			}
	
			// Setup
			div = document.createElement( "div" );
			container = document.createElement( "div" );
			container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
			body.appendChild( container ).appendChild( div );
	
			div.style.cssText =
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;" +
				"box-sizing:border-box;display:block;margin-top:1%;top:1%;" +
				"border:1px;padding:1px;width:4px;position:absolute";
	
			// Support: IE<9
			// Assume reasonable values in the absence of getComputedStyle
			pixelPositionVal = boxSizingReliableVal = false;
			reliableMarginRightVal = true;
	
			// Check for getComputedStyle so that this code is not run in IE<9.
			if ( window.getComputedStyle ) {
				pixelPositionVal = ( window.getComputedStyle( div, null ) || {} ).top !== "1%";
				boxSizingReliableVal =
					( window.getComputedStyle( div, null ) || { width: "4px" } ).width === "4px";
	
				// Support: Android 2.3
				// Div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				contents = div.appendChild( document.createElement( "div" ) );
	
				// Reset CSS: box-sizing; display; margin; border; padding
				contents.style.cssText = div.style.cssText =
					// Support: Firefox<29, Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
					"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
				contents.style.marginRight = contents.style.width = "0";
				div.style.width = "1px";
	
				reliableMarginRightVal =
					!parseFloat( ( window.getComputedStyle( contents, null ) || {} ).marginRight );
	
				div.removeChild( contents );
			}
	
			// Support: IE8
			// Check if table cells still have offsetWidth/Height when they are set
			// to display:none and there are still other visible table cells in a
			// table row; if so, offsetWidth/Height are not reliable for use when
			// determining if an element has been hidden directly using
			// display:none (it is still safe to use offsets if a parent element is
			// hidden; don safety goggles and see bug #4512 for more information).
			div.innerHTML = "<table><tr><td></td><td>t</td></tr></table>";
			contents = div.getElementsByTagName( "td" );
			contents[ 0 ].style.cssText = "margin:0;border:0;padding:0;display:none";
			reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
			if ( reliableHiddenOffsetsVal ) {
				contents[ 0 ].style.display = "";
				contents[ 1 ].style.display = "none";
				reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
			}
	
			body.removeChild( container );
		}
	
	})();
	
	
	// A method for quickly swapping in/out CSS properties to get correct calculations.
	jQuery.swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var
			ralpha = /alpha\([^)]*\)/i,
		ropacity = /opacity\s*=\s*([^)]*)/,
	
		// swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
		// see here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
		rrelNum = new RegExp( "^([+-])=(" + pnum + ")", "i" ),
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ];
	
	
	// return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( style, name ) {
	
		// shortcut for names that are not vendor prefixed
		if ( name in style ) {
			return name;
		}
	
		// check for vendor prefixed names
		var capName = name.charAt(0).toUpperCase() + name.slice(1),
			origName = name,
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in style ) {
				return name;
			}
		}
	
		return origName;
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = jQuery._data( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = jQuery._data( elem, "olddisplay", defaultDisplay(elem.nodeName) );
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display && display !== "none" || !hidden ) {
					jQuery._data( elem, "olddisplay", hidden ? display : jQuery.css( elem, "display" ) );
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
		var matches = rnumsplit.exec( value );
		return matches ?
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
			// If we already have the right measurement, avoid augmentation
			4 :
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
			// both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// at this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
				// at this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// at this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = support.boxSizing && jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test(val) ) {
				return val;
			}
	
			// we need the check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox && ( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	jQuery.extend({
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			// normalize float css property
			"float": support.cssFloat ? "cssFloat" : "styleFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );
	
			// gets hook for the prefixed version
			// followed by the unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// convert relative number strings (+= or -=) to relative numbers. #7345
				if ( type === "string" && (ret = rrelNum.exec( value )) ) {
					value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set. See: #7116
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add 'px' to the (except for certain CSS properties)
				if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
					value += "px";
				}
	
				// Fixes #8908, it can be done more correctly by specifing setters in cssHooks,
				// but it would mean to define eight (for every problematic property) identical functions
				if ( !support.clearCloneStyle && value === "" && name.indexOf("background") === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {
	
					// Support: IE
					// Swallow errors from 'invalid' CSS values (#5509)
					try {
						style[ name ] = value;
					} catch(e) {}
				}
	
			} else {
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var num, val, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );
	
			// gets hook for the prefixed version
			// followed by the unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			//convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Return, converting to number if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || jQuery.isNumeric( num ) ? num || 0 : val;
			}
			return val;
		}
	});
	
	jQuery.each([ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
					// certain elements can have dimension info if we invisibly show them
					// however, it must have a current display style that would benefit from this
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) && elem.offsetWidth === 0 ?
						jQuery.swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						}) :
						getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var styles = extra && getStyles( elem );
				return setPositiveNumber( elem, value, extra ?
					augmentWidthOrHeight(
						elem,
						name,
						extra,
						support.boxSizing && jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					) : 0
				);
			}
		};
	});
	
	if ( !support.opacity ) {
		jQuery.cssHooks.opacity = {
			get: function( elem, computed ) {
				// IE uses filters for opacity
				return ropacity.test( (computed && elem.currentStyle ? elem.currentStyle.filter : elem.style.filter) || "" ) ?
					( 0.01 * parseFloat( RegExp.$1 ) ) + "" :
					computed ? "1" : "";
			},
	
			set: function( elem, value ) {
				var style = elem.style,
					currentStyle = elem.currentStyle,
					opacity = jQuery.isNumeric( value ) ? "alpha(opacity=" + value * 100 + ")" : "",
					filter = currentStyle && currentStyle.filter || style.filter || "";
	
				// IE has trouble with opacity if it does not have layout
				// Force it by setting the zoom level
				style.zoom = 1;
	
				// if setting opacity to 1, and no other filters exist - attempt to remove filter attribute #6652
				// if value === "", then remove inline opacity #12685
				if ( ( value >= 1 || value === "" ) &&
						jQuery.trim( filter.replace( ralpha, "" ) ) === "" &&
						style.removeAttribute ) {
	
					// Setting style.filter to null, "" & " " still leave "filter:" in the cssText
					// if "filter:" is present at all, clearType is disabled, we want to avoid this
					// style.removeAttribute is IE Only, but so apparently is this code path...
					style.removeAttribute( "filter" );
	
					// if there is no filter style applied in a css rule or unset inline opacity, we are done
					if ( value === "" || currentStyle && !currentStyle.filter ) {
						return;
					}
				}
	
				// otherwise, set new filter values
				style.filter = ralpha.test( filter ) ?
					filter.replace( ralpha, opacity ) :
					filter + " " + opacity;
			}
		};
	}
	
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// Work around by temporarily setting element display to inline-block
				return jQuery.swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each({
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// assumes a single number if not a string
					parts = typeof value === "string" ? value.split(" ") : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	});
	
	jQuery.fn.extend({
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each(function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			});
		}
	});
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || "swing";
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				if ( tween.elem[ tween.prop ] != null &&
					(!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
					return tween.elem[ tween.prop ];
				}
	
				// passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails
				// so, simple values such as "10px" are parsed to Float.
				// complex values such as "rotate(1rad)" are returned as is.
				result = jQuery.css( tween.elem, tween.prop, "" );
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
				// use step hook for back compat - use cssHook if its there - use .style if its
				// available and use plain properties where available
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9
	// Panic based approach to setting things on disconnected nodes
	
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		}
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rfxnum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" ),
		rrun = /queueHooks$/,
		animationPrefilters = [ defaultPrefilter ],
		tweeners = {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value ),
					target = tween.cur(),
					parts = rfxnum.exec( value ),
					unit = parts && parts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
					// Starting value computation is required for potential unit mismatches
					start = ( jQuery.cssNumber[ prop ] || unit !== "px" && +target ) &&
						rfxnum.exec( jQuery.css( tween.elem, prop ) ),
					scale = 1,
					maxIterations = 20;
	
				if ( start && start[ 3 ] !== unit ) {
					// Trust units reported by jQuery.css
					unit = unit || start[ 3 ];
	
					// Make sure we update the tween properties later on
					parts = parts || [];
	
					// Iteratively approximate from a nonzero starting point
					start = +target || 1;
	
					do {
						// If previous iteration zeroed out, double until we get *something*
						// Use a string for doubling factor so we don't accidentally see scale as unchanged below
						scale = scale || ".5";
	
						// Adjust and apply
						start = start / scale;
						jQuery.style( tween.elem, prop, start + unit );
	
					// Update scale, tolerating zero or NaN from tween.cur()
					// And breaking the loop if scale is unchanged or perfect, or if we've just had enough
					} while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
				}
	
				// Update tween properties
				if ( parts ) {
					start = tween.start = +start || +target || 0;
					tween.unit = unit;
					// If a +=/-= token was provided, we're doing a relative animation
					tween.end = parts[ 1 ] ?
						start + ( parts[ 1 ] + 1 ) * parts[ 2 ] :
						+parts[ 2 ];
				}
	
				return tween;
			} ]
		};
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		setTimeout(function() {
			fxNow = undefined;
		});
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			attrs = { height: type },
			i = 0;
	
		// if we include width, step value is 1 to do all cssExpand values,
		// if we don't include width, step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( (tween = collection[ index ].call( animation, prop, value )) ) {
	
				// we're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = jQuery._data( elem, "fxshow" );
	
		// handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always(function() {
				// doing this makes sure that the complete handler will be called
				// before this completes
				anim.always(function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				});
			});
		}
	
		// height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE does not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				jQuery._data( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
	
				// inline-level elements accept inline-block;
				// block-level elements need to be inline with layout
				if ( !support.inlineBlockNeedsLayout || defaultDisplay( elem.nodeName ) === "inline" ) {
					style.display = "inline-block";
				} else {
					style.zoom = 1;
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			if ( !support.shrinkWrapBlocks() ) {
				anim.always(function() {
					style.overflow = opts.overflow[ 0 ];
					style.overflowX = opts.overflow[ 1 ];
					style.overflowY = opts.overflow[ 2 ];
				});
			}
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = jQuery._data( elem, "fxshow", {} );
			}
	
			// store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done(function() {
					jQuery( elem ).hide();
				});
			}
			anim.done(function() {
				var prop;
				jQuery._removeData( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			});
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( (display === "none" ? defaultDisplay( elem.nodeName ) : display) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// not quite $.extend, this wont overwrite keys already present.
				// also - reusing 'index' from above because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = animationPrefilters.length,
			deferred = jQuery.Deferred().always( function() {
				// don't match elem in the :animated selector
				delete tick.elem;
			}),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
					// archaic crash bug won't allow us to use 1 - ( 0.5 || 0 ) (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ]);
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise({
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, { specialEasing: {} }, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
						// if we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// resolve when we played the last frame
					// otherwise, reject
					if ( gotoEnd ) {
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			}),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			})
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.split(" ");
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				tweeners[ prop ] = tweeners[ prop ] || [];
				tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				animationPrefilters.unshift( callback );
			} else {
				animationPrefilters.push( callback );
			}
		}
	});
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
			opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend({
		fadeTo: function( speed, to, easing, callback ) {
	
			// show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// animate to the value specified
				.end().animate({ opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || jQuery._data( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each(function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = jQuery._data( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// start the next in the queue if the last step wasn't forced
				// timers currently will call their complete callbacks, which will dequeue
				// but only if they were gotoEnd
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			});
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each(function() {
				var index,
					data = jQuery._data( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// enable finishing flag on private data
				data.finish = true;
	
				// empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// turn off finishing flag
				delete data.finish;
			});
		}
	});
	
	jQuery.each([ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	});
	
	// Generate shortcuts for custom animations
	jQuery.each({
		slideDown: genFx("show"),
		slideUp: genFx("hide"),
		slideToggle: genFx("toggle"),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	});
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			timers = jQuery.timers,
			i = 0;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		clearInterval( timerId );
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = setTimeout( next, time );
			hooks.stop = function() {
				clearTimeout( timeout );
			};
		});
	};
	
	
	(function() {
		// Minified: var a,b,c,d,e
		var input, div, select, a, opt;
	
		// Setup
		div = document.createElement( "div" );
		div.setAttribute( "className", "t" );
		div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
		a = div.getElementsByTagName("a")[ 0 ];
	
		// First batch of tests.
		select = document.createElement("select");
		opt = select.appendChild( document.createElement("option") );
		input = div.getElementsByTagName("input")[ 0 ];
	
		a.style.cssText = "top:1px";
	
		// Test setAttribute on camelCase class. If it works, we need attrFixes when doing get/setAttribute (ie6/7)
		support.getSetAttribute = div.className !== "t";
	
		// Get the style information from getAttribute
		// (IE uses .cssText instead)
		support.style = /top/.test( a.getAttribute("style") );
	
		// Make sure that URLs aren't manipulated
		// (IE normalizes it by default)
		support.hrefNormalized = a.getAttribute("href") === "/a";
	
		// Check the default checkbox/radio value ("" on WebKit; "on" elsewhere)
		support.checkOn = !!input.value;
	
		// Make sure that a selected-by-default option has a working selected property.
		// (WebKit defaults to false instead of true, IE too, if it's in an optgroup)
		support.optSelected = opt.selected;
	
		// Tests for enctype support on a form (#6743)
		support.enctype = !!document.createElement("form").enctype;
	
		// Make sure that the options inside disabled selects aren't marked as disabled
		// (WebKit marks them as disabled)
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE8 only
		// Check if we can trust getAttribute("value")
		input = document.createElement( "input" );
		input.setAttribute( "value", "" );
		support.input = input.getAttribute( "value" ) === "";
	
		// Check if an input maintains its value after becoming a radio
		input.value = "t";
		input.setAttribute( "type", "radio" );
		support.radioValue = input.value === "t";
	})();
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend({
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[0];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
						// handle most common string cases
						ret.replace(rreturn, "") :
						// handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each(function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
				} else if ( typeof val === "number" ) {
					val += "";
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					});
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			});
		}
	});
	
	jQuery.extend({
		valHooks: {
			option: {
				get: function( elem ) {
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						jQuery.trim( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// oldIE doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ? !option.disabled : option.getAttribute("disabled") === null ) &&
								( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						if ( jQuery.inArray( jQuery.valHooks.option.get( option ), values ) >= 0 ) {
	
							// Support: IE6
							// When new option element is added to select box we need to
							// force reflow of newly added node in order to workaround delay
							// of initialization properties
							try {
								option.selected = optionSet = true;
	
							} catch ( _ ) {
	
								// Will be executed only in IE6
								option.scrollHeight;
							}
	
						} else {
							option.selected = false;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
	
					return options;
				}
			}
		}
	});
	
	// Radios and checkboxes getter/setter
	jQuery.each([ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				// Support: Webkit
				// "" is returned instead of "on" if a value isn't specified
				return elem.getAttribute("value") === null ? "on" : elem.value;
			};
		}
	});
	
	
	
	
	var nodeHook, boolHook,
		attrHandle = jQuery.expr.attrHandle,
		ruseDefault = /^(?:checked|selected)$/i,
		getSetAttribute = support.getSetAttribute,
		getSetInput = support.input;
	
	jQuery.fn.extend({
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each(function() {
				jQuery.removeAttr( this, name );
			});
		}
	});
	
	jQuery.extend({
		attr: function( elem, name, value ) {
			var hooks, ret,
				nType = elem.nodeType;
	
			// don't get/set attributes on text, comment and attribute nodes
			if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === strundefined ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
			}
	
			if ( value !== undefined ) {
	
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
	
				} else if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
					return ret;
	
				} else {
					elem.setAttribute( name, value + "" );
					return value;
				}
	
			} else if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
				return ret;
	
			} else {
				ret = jQuery.find.attr( elem, name );
	
				// Non-existent attributes return null, we normalize to undefined
				return ret == null ?
					undefined :
					ret;
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( (name = attrNames[i++]) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
						// Set corresponding property to false
						if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
							elem[ propName ] = false;
						// Support: IE<9
						// Also clear defaultChecked/defaultSelected (if appropriate)
						} else {
							elem[ jQuery.camelCase( "default-" + name ) ] =
								elem[ propName ] = false;
						}
	
					// See #9699 for explanation of this approach (setting first, then removal)
					} else {
						jQuery.attr( elem, name, "" );
					}
	
					elem.removeAttribute( getSetAttribute ? name : propName );
				}
			}
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" && jQuery.nodeName(elem, "input") ) {
						// Setting the type on a radio button after the value resets the value in IE6-9
						// Reset value to default in case type is set after value during creation
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		}
	});
	
	// Hook for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
				// IE<8 needs the *property* name
				elem.setAttribute( !getSetAttribute && jQuery.propFix[ name ] || name, name );
	
			// Use defaultChecked and defaultSelected for oldIE
			} else {
				elem[ jQuery.camelCase( "default-" + name ) ] = elem[ name ] = true;
			}
	
			return name;
		}
	};
	
	// Retrieve booleans specially
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = getSetInput && getSetAttribute || !ruseDefault.test( name ) ?
			function( elem, name, isXML ) {
				var ret, handle;
				if ( !isXML ) {
					// Avoid an infinite loop by temporarily removing this function from the getter
					handle = attrHandle[ name ];
					attrHandle[ name ] = ret;
					ret = getter( elem, name, isXML ) != null ?
						name.toLowerCase() :
						null;
					attrHandle[ name ] = handle;
				}
				return ret;
			} :
			function( elem, name, isXML ) {
				if ( !isXML ) {
					return elem[ jQuery.camelCase( "default-" + name ) ] ?
						name.toLowerCase() :
						null;
				}
			};
	});
	
	// fix oldIE attroperties
	if ( !getSetInput || !getSetAttribute ) {
		jQuery.attrHooks.value = {
			set: function( elem, value, name ) {
				if ( jQuery.nodeName( elem, "input" ) ) {
					// Does not return so that setAttribute is also used
					elem.defaultValue = value;
				} else {
					// Use nodeHook if defined (#1954); otherwise setAttribute is fine
					return nodeHook && nodeHook.set( elem, value, name );
				}
			}
		};
	}
	
	// IE6/7 do not support getting/setting some attributes with get/setAttribute
	if ( !getSetAttribute ) {
	
		// Use this for any attribute in IE6/7
		// This fixes almost every IE6/7 issue
		nodeHook = {
			set: function( elem, value, name ) {
				// Set the existing or create a new attribute node
				var ret = elem.getAttributeNode( name );
				if ( !ret ) {
					elem.setAttributeNode(
						(ret = elem.ownerDocument.createAttribute( name ))
					);
				}
	
				ret.value = value += "";
	
				// Break association with cloned elements by also using setAttribute (#9646)
				if ( name === "value" || value === elem.getAttribute( name ) ) {
					return value;
				}
			}
		};
	
		// Some attributes are constructed with empty-string values when not defined
		attrHandle.id = attrHandle.name = attrHandle.coords =
			function( elem, name, isXML ) {
				var ret;
				if ( !isXML ) {
					return (ret = elem.getAttributeNode( name )) && ret.value !== "" ?
						ret.value :
						null;
				}
			};
	
		// Fixing value retrieval on a button requires this module
		jQuery.valHooks.button = {
			get: function( elem, name ) {
				var ret = elem.getAttributeNode( name );
				if ( ret && ret.specified ) {
					return ret.value;
				}
			},
			set: nodeHook.set
		};
	
		// Set contenteditable to false on removals(#10429)
		// Setting to empty string throws an error as an invalid value
		jQuery.attrHooks.contenteditable = {
			set: function( elem, value, name ) {
				nodeHook.set( elem, value === "" ? false : value, name );
			}
		};
	
		// Set width and height to auto instead of 0 on empty string( Bug #8150 )
		// This is for removals
		jQuery.each([ "width", "height" ], function( i, name ) {
			jQuery.attrHooks[ name ] = {
				set: function( elem, value ) {
					if ( value === "" ) {
						elem.setAttribute( name, "auto" );
						return value;
					}
				}
			};
		});
	}
	
	if ( !support.style ) {
		jQuery.attrHooks.style = {
			get: function( elem ) {
				// Return undefined in the case of empty string
				// Note: IE uppercases css property names, but if we were to .toLowerCase()
				// .cssText, that would destroy case senstitivity in URL's, like in "background"
				return elem.style.cssText || undefined;
			},
			set: function( elem, value ) {
				return ( elem.style.cssText = value + "" );
			}
		};
	}
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button|object)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend({
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			name = jQuery.propFix[ name ] || name;
			return this.each(function() {
				// try/catch handles cases where IE balks (such as removing a property on window)
				try {
					this[ name ] = undefined;
					delete this[ name ];
				} catch( e ) {}
			});
		}
	});
	
	jQuery.extend({
		propFix: {
			"for": "htmlFor",
			"class": "className"
		},
	
		prop: function( elem, name, value ) {
			var ret, hooks, notxml,
				nType = elem.nodeType;
	
			// don't get/set properties on text, comment and attribute nodes
			if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			notxml = nType !== 1 || !jQuery.isXMLDoc( elem );
	
			if ( notxml ) {
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				return hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ?
					ret :
					( elem[ name ] = value );
	
			} else {
				return hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ?
					ret :
					elem[ name ];
			}
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
					// elem.tabIndex doesn't always return the correct value when it hasn't been explicitly set
					// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) || rclickable.test( elem.nodeName ) && elem.href ?
							0 :
							-1;
				}
			}
		}
	});
	
	// Some attributes require a special call on IE
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !support.hrefNormalized ) {
		// href/src property should get the full normalized URL (#10299/#12915)
		jQuery.each([ "href", "src" ], function( i, name ) {
			jQuery.propHooks[ name ] = {
				get: function( elem ) {
					return elem.getAttribute( name, 4 );
				}
			};
		});
	}
	
	// Support: Safari, IE9+
	// mis-reports the default selected property of an option
	// Accessing the parent's selectedIndex property fixes it
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
	
				if ( parent ) {
					parent.selectedIndex;
	
					// Make sure that it also works with optgroups, see #5701
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
				return null;
			}
		};
	}
	
	jQuery.each([
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	});
	
	// IE6/7 call enctype encoding
	if ( !support.enctype ) {
		jQuery.propFix.enctype = "encoding";
	}
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	jQuery.fn.extend({
		addClass: function( value ) {
			var classes, elem, cur, clazz, j, finalValue,
				i = 0,
				len = this.length,
				proceed = typeof value === "string" && value;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( j ) {
					jQuery( this ).addClass( value.call( this, j, this.className ) );
				});
			}
	
			if ( proceed ) {
				// The disjunction here is for better compressibility (see removeClass)
				classes = ( value || "" ).match( rnotwhite ) || [];
	
				for ( ; i < len; i++ ) {
					elem = this[ i ];
					cur = elem.nodeType === 1 && ( elem.className ?
						( " " + elem.className + " " ).replace( rclass, " " ) :
						" "
					);
	
					if ( cur ) {
						j = 0;
						while ( (clazz = classes[j++]) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( elem.className !== finalValue ) {
							elem.className = finalValue;
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, clazz, j, finalValue,
				i = 0,
				len = this.length,
				proceed = arguments.length === 0 || typeof value === "string" && value;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( j ) {
					jQuery( this ).removeClass( value.call( this, j, this.className ) );
				});
			}
			if ( proceed ) {
				classes = ( value || "" ).match( rnotwhite ) || [];
	
				for ( ; i < len; i++ ) {
					elem = this[ i ];
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( elem.className ?
						( " " + elem.className + " " ).replace( rclass, " " ) :
						""
					);
	
					if ( cur ) {
						j = 0;
						while ( (clazz = classes[j++]) ) {
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) >= 0 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// only assign if different to avoid unneeded rendering.
						finalValue = value ? jQuery.trim( cur ) : "";
						if ( elem.className !== finalValue ) {
							elem.className = finalValue;
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( i ) {
					jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
				});
			}
	
			return this.each(function() {
				if ( type === "string" ) {
					// toggle individual class names
					var className,
						i = 0,
						self = jQuery( this ),
						classNames = value.match( rnotwhite ) || [];
	
					while ( (className = classNames[ i++ ]) ) {
						// check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( type === strundefined || type === "boolean" ) {
					if ( this.className ) {
						// store className if set
						jQuery._data( this, "__className__", this.className );
					}
	
					// If the element has a class name or if we're passed "false",
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					this.className = this.className || value === false ? "" : jQuery._data( this, "__className__" ) || "";
				}
			});
		},
	
		hasClass: function( selector ) {
			var className = " " + selector + " ",
				i = 0,
				l = this.length;
			for ( ; i < l; i++ ) {
				if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
					return true;
				}
			}
	
			return false;
		}
	});
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	});
	
	jQuery.fn.extend({
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		},
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
		}
	});
	
	
	var nonce = jQuery.now();
	
	var rquery = (/\?/);
	
	
	
	var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
	
	jQuery.parseJSON = function( data ) {
		// Attempt to parse using the native JSON parser first
		if ( window.JSON && window.JSON.parse ) {
			// Support: Android 2.3
			// Workaround failure to string-cast null input
			return window.JSON.parse( data + "" );
		}
	
		var requireNonComma,
			depth = null,
			str = jQuery.trim( data + "" );
	
		// Guard against invalid (and possibly dangerous) input by ensuring that nothing remains
		// after removing valid tokens
		return str && !jQuery.trim( str.replace( rvalidtokens, function( token, comma, open, close ) {
	
			// Force termination if we see a misplaced comma
			if ( requireNonComma && comma ) {
				depth = 0;
			}
	
			// Perform no more replacements after returning to outermost depth
			if ( depth === 0 ) {
				return token;
			}
	
			// Commas must not follow "[", "{", or ","
			requireNonComma = open || comma;
	
			// Determine new depth
			// array/object open ("[" or "{"): depth += true - false (increment)
			// array/object close ("]" or "}"): depth += false - true (decrement)
			// other cases ("," or primitive): depth += true - true (numeric cast)
			depth += !close - !open;
	
			// Remove this token
			return "";
		}) ) ?
			( Function( "return " + str ) )() :
			jQuery.error( "Invalid JSON: " + data );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, tmp;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		try {
			if ( window.DOMParser ) { // Standard
				tmp = new DOMParser();
				xml = tmp.parseFromString( data, "text/xml" );
			} else { // IE
				xml = new ActiveXObject( "Microsoft.XMLDOM" );
				xml.async = "false";
				xml.loadXML( data );
			}
		} catch( e ) {
			xml = undefined;
		}
		if ( !xml || !xml.documentElement || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		// Document location
		ajaxLocParts,
		ajaxLocation,
	
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg, // IE leaves an \r character at EOL
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
		rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat("*");
	
	// #8138, IE may throw an exception when accessing
	// a field from window.location if document.domain has been set
	try {
		ajaxLocation = location.href;
	} catch( e ) {
		// Use the href attribute of an A element
		// since IE will modify it given document.location
		ajaxLocation = document.createElement( "a" );
		ajaxLocation.href = "";
		ajaxLocation = ajaxLocation.href;
	}
	
	// Segment location into parts
	ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
				// For each dataType in the dataTypeExpression
				while ( (dataType = dataTypes[i++]) ) {
					// Prepend if requested
					if ( dataType.charAt( 0 ) === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						(structure[ dataType ] = structure[ dataType ] || []).unshift( func );
	
					// Otherwise append
					} else {
						(structure[ dataType ] = structure[ dataType ] || []).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			});
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var deep, key,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || (deep = {}) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
		var firstDataType, ct, finalDataType, type,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s[ "throws" ] ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend({
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: ajaxLocation,
			type: "GET",
			isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /xml/,
				html: /html/,
				json: /json/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var // Cross-domain detection vars
				parts,
				// Loop variable
				i,
				// URL without anti-cache param
				cacheURL,
				// Response headers as string
				responseHeadersString,
				// timeout handle
				timeoutTimer,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				transport,
				// Response headers
				responseHeaders,
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
				// Callbacks context
				callbackContext = s.context || s,
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context && ( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks("once memory"),
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
				// The jqXHR state
				state = 0,
				// Default abort message
				strAbort = "canceled",
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( (match = rheaders.exec( responseHeadersString )) ) {
									responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (#5866: IE7 issue with protocol-less urls)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || ajaxLocation ) + "" ).replace( rhash, "" ).replace( rprotocol, ajaxLocParts[ 1 ] + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when we have a protocol:host:port mismatch
			if ( s.crossDomain == null ) {
				parts = rurl.exec( s.url.toLowerCase() );
				s.crossDomain = !!( parts &&
					( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
						( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
							( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
				);
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger("ajaxStart");
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
					s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = setTimeout(function() {
						jqXHR.abort("timeout");
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader("Last-Modified");
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader("etag");
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
					// We extract error from statusText
					// then normalize statusText and status for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger("ajaxStop");
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	});
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
			// shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			return jQuery.ajax({
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			});
		};
	});
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax({
			url: url,
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		});
	};
	
	
	jQuery.fn.extend({
		wrapAll: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each(function(i) {
					jQuery(this).wrapAll( html.call(this, i) );
				});
			}
	
			if ( this[0] ) {
				// The elements to wrap the target around
				var wrap = jQuery( html, this[0].ownerDocument ).eq(0).clone(true);
	
				if ( this[0].parentNode ) {
					wrap.insertBefore( this[0] );
				}
	
				wrap.map(function() {
					var elem = this;
	
					while ( elem.firstChild && elem.firstChild.nodeType === 1 ) {
						elem = elem.firstChild;
					}
	
					return elem;
				}).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each(function(i) {
					jQuery(this).wrapInner( html.call(this, i) );
				});
			}
	
			return this.each(function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			});
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each(function(i) {
				jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
			});
		},
	
		unwrap: function() {
			return this.parent().each(function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			}).end();
		}
	});
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		return elem.offsetWidth <= 0 && elem.offsetHeight <= 0 ||
			(!support.reliableHiddenOffsets() &&
				((elem.style && elem.style.display) || jQuery.css( elem, "display" )) === "none");
	};
	
	jQuery.expr.filters.visible = function( elem ) {
		return !jQuery.expr.filters.hidden( elem );
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
				}
			});
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			});
	
		} else {
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend({
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map(function() {
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			})
			.filter(function() {
				var type = this.type;
				// Use .is(":disabled") so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			})
			.map(function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						}) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			}).get();
		}
	});
	
	
	// Create the request object
	// (This is still attached to ajaxSettings for backward compatibility)
	jQuery.ajaxSettings.xhr = window.ActiveXObject !== undefined ?
		// Support: IE6+
		function() {
	
			// XHR cannot access local files, always use ActiveX for that case
			return !this.isLocal &&
	
				// Support: IE7-8
				// oldIE XHR does not support non-RFC2616 methods (#13240)
				// See http://msdn.microsoft.com/en-us/library/ie/ms536648(v=vs.85).aspx
				// and http://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9
				// Although this check for six methods instead of eight
				// since IE also does not support "trace" and "connect"
				/^(get|post|head|put|delete|options)$/i.test( this.type ) &&
	
				createStandardXHR() || createActiveXHR();
		} :
		// For all other browsers, use the standard XMLHttpRequest object
		createStandardXHR;
	
	var xhrId = 0,
		xhrCallbacks = {},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	// Support: IE<10
	// Open requests must be manually aborted on unload (#5280)
	// See https://support.microsoft.com/kb/2856746 for more info
	if ( window.attachEvent ) {
		window.attachEvent( "onunload", function() {
			for ( var key in xhrCallbacks ) {
				xhrCallbacks[ key ]( undefined, true );
			}
		});
	}
	
	// Determine support properties
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	xhrSupported = support.ajax = !!xhrSupported;
	
	// Create transport if the browser can provide an xhr
	if ( xhrSupported ) {
	
		jQuery.ajaxTransport(function( options ) {
			// Cross domain only allowed if supported through XMLHttpRequest
			if ( !options.crossDomain || support.cors ) {
	
				var callback;
	
				return {
					send: function( headers, complete ) {
						var i,
							xhr = options.xhr(),
							id = ++xhrId;
	
						// Open the socket
						xhr.open( options.type, options.url, options.async, options.username, options.password );
	
						// Apply custom fields if provided
						if ( options.xhrFields ) {
							for ( i in options.xhrFields ) {
								xhr[ i ] = options.xhrFields[ i ];
							}
						}
	
						// Override mime type if needed
						if ( options.mimeType && xhr.overrideMimeType ) {
							xhr.overrideMimeType( options.mimeType );
						}
	
						// X-Requested-With header
						// For cross-domain requests, seeing as conditions for a preflight are
						// akin to a jigsaw puzzle, we simply never set it to be sure.
						// (it can always be set on a per-request basis or even using ajaxSetup)
						// For same-domain requests, won't change header if already provided.
						if ( !options.crossDomain && !headers["X-Requested-With"] ) {
							headers["X-Requested-With"] = "XMLHttpRequest";
						}
	
						// Set headers
						for ( i in headers ) {
							// Support: IE<9
							// IE's ActiveXObject throws a 'Type Mismatch' exception when setting
							// request header to a null-value.
							//
							// To keep consistent with other XHR implementations, cast the value
							// to string and ignore `undefined`.
							if ( headers[ i ] !== undefined ) {
								xhr.setRequestHeader( i, headers[ i ] + "" );
							}
						}
	
						// Do send the request
						// This may raise an exception which is actually
						// handled in jQuery.ajax (so no try/catch here)
						xhr.send( ( options.hasContent && options.data ) || null );
	
						// Listener
						callback = function( _, isAbort ) {
							var status, statusText, responses;
	
							// Was never called and is aborted or complete
							if ( callback && ( isAbort || xhr.readyState === 4 ) ) {
								// Clean up
								delete xhrCallbacks[ id ];
								callback = undefined;
								xhr.onreadystatechange = jQuery.noop;
	
								// Abort manually if needed
								if ( isAbort ) {
									if ( xhr.readyState !== 4 ) {
										xhr.abort();
									}
								} else {
									responses = {};
									status = xhr.status;
	
									// Support: IE<10
									// Accessing binary-data responseText throws an exception
									// (#11426)
									if ( typeof xhr.responseText === "string" ) {
										responses.text = xhr.responseText;
									}
	
									// Firefox throws an exception when accessing
									// statusText for faulty cross-domain requests
									try {
										statusText = xhr.statusText;
									} catch( e ) {
										// We normalize with Webkit giving an empty statusText
										statusText = "";
									}
	
									// Filter status for non standard behaviors
	
									// If the request is local and we have data: assume a success
									// (success with no data won't get notified, that's the best we
									// can do given current implementations)
									if ( !status && options.isLocal && !options.crossDomain ) {
										status = responses.text ? 200 : 404;
									// IE - #1450: sometimes returns 1223 when it should be 204
									} else if ( status === 1223 ) {
										status = 204;
									}
								}
							}
	
							// Call complete if needed
							if ( responses ) {
								complete( status, statusText, responses, xhr.getAllResponseHeaders() );
							}
						};
	
						if ( !options.async ) {
							// if we're in sync mode we fire the callback
							callback();
						} else if ( xhr.readyState === 4 ) {
							// (IE6 & IE7) if it's in cache and has been
							// retrieved directly we need to fire the callback
							setTimeout( callback );
						} else {
							// Add to the list of active xhr callbacks
							xhr.onreadystatechange = xhrCallbacks[ id ] = callback;
						}
					},
	
					abort: function() {
						if ( callback ) {
							callback( undefined, true );
						}
					}
				};
			}
		});
	}
	
	// Functions to create xhrs
	function createStandardXHR() {
		try {
			return new window.XMLHttpRequest();
		} catch( e ) {}
	}
	
	function createActiveXHR() {
		try {
			return new window.ActiveXObject( "Microsoft.XMLHTTP" );
		} catch( e ) {}
	}
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup({
		accepts: {
			script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /(?:java|ecma)script/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	});
	
	// Handle cache's special case and global
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
			s.global = false;
		}
	});
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function(s) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
	
			var script,
				head = document.head || jQuery("head")[0] || document.documentElement;
	
			return {
	
				send: function( _, callback ) {
	
					script = document.createElement("script");
	
					script.async = true;
	
					if ( s.scriptCharset ) {
						script.charset = s.scriptCharset;
					}
	
					script.src = s.url;
	
					// Attach handlers for all browsers
					script.onload = script.onreadystatechange = function( _, isAbort ) {
	
						if ( isAbort || !script.readyState || /loaded|complete/.test( script.readyState ) ) {
	
							// Handle memory leak in IE
							script.onload = script.onreadystatechange = null;
	
							// Remove the script
							if ( script.parentNode ) {
								script.parentNode.removeChild( script );
							}
	
							// Dereference the script
							script = null;
	
							// Callback if not abort
							if ( !isAbort ) {
								callback( 200, "success" );
							}
						}
					};
	
					// Circumvent IE6 bugs with base elements (#2709 and #4378) by prepending
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					head.insertBefore( script, head.firstChild );
				},
	
				abort: function() {
					if ( script ) {
						script.onload( undefined, true );
					}
				}
			};
		}
	});
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup({
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	});
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" && !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") && rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters["script json"] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always(function() {
				// Restore preexisting value
				window[ callbackName ] = overwritten;
	
				// Save back as free
				if ( s[ callbackName ] ) {
					// make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			});
	
			// Delegate to script
			return "script";
		}
	});
	
	
	
	
	// data: string of html
	// context (optional): If specified, the fragment will be created in this context, defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[1] ) ];
		}
	
		parsed = jQuery.buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, response, type,
			self = this,
			off = url.indexOf(" ");
	
		if ( off >= 0 ) {
			selector = jQuery.trim( url.slice( off, url.length ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax({
				url: url,
	
				// if "type" variable is undefined, then "GET" method will be used
				type: type,
				dataType: "html",
				data: params
			}).done(function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery("<div>").append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			}).complete( callback && function( jqXHR, status ) {
				self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
			});
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	});
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep(jQuery.timers, function( fn ) {
			return elem === fn.elem;
		}).length;
	};
	
	
	
	
	
	var docElem = window.document.documentElement;
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ?
			elem :
			elem.nodeType === 9 ?
				elem.defaultView || elem.parentWindow :
				false;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				jQuery.inArray("auto", [ curCSSTop, curCSSLeft ] ) > -1;
	
			// need to be able to calculate position if either top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
				options = options.call( elem, i, curOffset );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend({
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each(function( i ) {
						jQuery.offset.setOffset( this, options, i );
					});
			}
	
			var docElem, win,
				box = { top: 0, left: 0 },
				elem = this[ 0 ],
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			// If we don't have gBCR, just use 0,0 rather than error
			// BlackBerry 5, iOS 3 (original iPhone)
			if ( typeof elem.getBoundingClientRect !== strundefined ) {
				box = elem.getBoundingClientRect();
			}
			win = getWindow( doc );
			return {
				top: box.top  + ( win.pageYOffset || docElem.scrollTop )  - ( docElem.clientTop  || 0 ),
				left: box.left + ( win.pageXOffset || docElem.scrollLeft ) - ( docElem.clientLeft || 0 )
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				parentOffset = { top: 0, left: 0 },
				elem = this[ 0 ];
	
			// fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
				// we assume that getBoundingClientRect is available when computed position is fixed
				offset = elem.getBoundingClientRect();
			} else {
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top  += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			// note: when an element has margin: auto the offsetLeft and marginLeft
			// are the same in Safari causing offset.left to incorrectly be 0
			return {
				top:  offset.top  - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true)
			};
		},
	
		offsetParent: function() {
			return this.map(function() {
				var offsetParent = this.offsetParent || docElem;
	
				while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) && jQuery.css( offsetParent, "position" ) === "static" ) ) {
					offsetParent = offsetParent.offsetParent;
				}
				return offsetParent || docElem;
			});
		}
	});
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = /Y/.test( prop );
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? (prop in win) ? win[ prop ] :
						win.document.documentElement[ method ] :
						elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : jQuery( win ).scrollLeft(),
						top ? val : jQuery( win ).scrollTop()
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length, null );
		};
	});
	
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// getComputedStyle returns percent when specified for top/left/bottom/right
	// rather than make the css module depend on the offset module, we just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
					// if curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	});
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function( defaultExtra, funcName ) {
			// margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height], whichever is greatest
						// unfortunately, this causes bug #3838 in IE6/8 only, but there is currently no good, small way to fix it.
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		});
	});
	
	
	// The number of elements contained in the matched element set
	jQuery.fn.size = function() {
		return this.length;
	};
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in
	// AMD (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === strundefined ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	
	}));


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseControl2 = __webpack_require__(166);
	
	var _BaseControl3 = _interopRequireDefault(_BaseControl2);
	
	var _fsForms = __webpack_require__(143);
	
	var _fsForms2 = _interopRequireDefault(_fsForms);
	
	var _Immutable = __webpack_require__(164);
	
	var _Immutable2 = _interopRequireDefault(_Immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var uploadStarted;
	
	/**
	 * @author Pavel Homolka
	 */
	
	var CreateDocumentControl = function (_BaseControl) {
	  _inherits(CreateDocumentControl, _BaseControl);
	
	  /** Construct and init **********************************************************************************************/
	
	  /** @type String */
	
	
	  /** @type jQuery */
	
	
	  /** @type Immutable::Map*/
	
	
	  /** @type String */
	
	
	  /** @type String */
	  function CreateDocumentControl(formId, changeURL, jsClass, stateList, userLanguage, datetimeFormat) {
	    _classCallCheck(this, CreateDocumentControl);
	
	    var _this = _possibleConstructorReturn(this, (CreateDocumentControl.__proto__ || Object.getPrototypeOf(CreateDocumentControl)).call(this));
	
	    _this.changeItem = null;
	    _this.isAjax = false;
	
	    _this.formId = formId;
	    _this.changeURL = changeURL;
	    _this.jsClass = jsClass;
	    _this.stateList = stateList;
	    _this.userLanguage = userLanguage;
	    _this.datetimeFormat = datetimeFormat;
	    return _this;
	  }
	
	  /**
	   * @return void
	   */
	
	
	  /** @type String */
	
	
	  /** @type Object */
	
	
	  /** @type bool */
	
	
	  /** @type String */
	
	
	  /** @type String */
	
	  /** @type String */
	
	
	  _createClass(CreateDocumentControl, [{
	    key: 'init',
	    value: function init() {
	      this.form = $('#' + this.formId);
	      this.form.change(this.onChange.bind(this));
	      this.form.submit(this.onSubmit.bind(this));
	
	      readOnlySelectSearch();
	      readOnlyDateTime();
	
	      // init state for DateTime pickers
	      var thisForm = this;
	      this.form.find('.fs-dateTime-picker').each(function () {
	        var el = $(this);
	        el.on('focusout', thisForm.onDateTimePickerChange.bind(thisForm, el));
	      });
	
	      // init bootstrap file input
	
	      //var fileInput = this.form.find('input[name="createDocument_newBinnary"]');
	      //fileInput.fileinput({ language: this.userLanguage });
	      //fileInput.on('fileloaded', this.fileLoaded.bind(this));
	      //fileInput.on('fileclear', this.fileClear.bind(this));
	
	      var fileInput = this.form.find('input[name="createDocument_newBinnary"]');
	      fileInput.on('change', this.fileLoaded.bind(this));
	
	      var dropzone_file_remover = this.form.find('.frm-createDocument-insertForm-createDocument_newBinnaryremove');
	      dropzone_file_remover.on('click', this.fileClear.bind(this));
	
	      // init bootstrap templates input
	      var templateSelect = $('.insertForm-TemplatesModal-select');
	      var templateInput = this.form.find('[id*=createDocument_newTemplate]');
	      templateSelect.on('click', this.templateChange.bind(this, templateInput));
	
	      // create document without file upload (document is in storage)    
	      var windowObject = $(window);
	      var nameDocuWithoutInsert = this.form.find('input[name="createDocument_newBinnary_name"]');
	      if (nameDocuWithoutInsert.length > 0) {
	        windowObject.on('load', this.fileWithoutInsert.bind(this, nameDocuWithoutInsert));
	      }
	
	      // handle for submit button
	      $('#' + this.formId + ' .fileinput-upload-button').off('click').click(this.onSubmitBtnClick.bind(this));
	
	      // create JS reducer
	      if (window[this.jsClass] != undefined) {
	        this.reducer = _extends({}, window[this.jsClass]);
	
	        // call Reducer::init
	        if (typeof this.reducer.init === 'function') {
	          this.reducer.init(this, this.stateList);
	        }
	      }
	    }
	
	    /** Handles *********************************************************************************************************/
	
	    /**
	     * @param jQuery.Event event
	     */
	
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      var currentStateForEl = this.getCurrentStateForEl($(event.target));
	      // skip onChange for <input type="file">
	      if (currentStateForEl.name == 'createDocument_newBinnary' || currentStateForEl.name == 'createDocument_newTemplate') {
	        return;
	      }
	
	      // update state
	      var newState = _Immutable2.default.Map({
	        nameMeta: currentStateForEl.name,
	        value: currentStateForEl.value,
	        isRequired: currentStateForEl.isRequired,
	        isReadOnly: this.stateList.getIn([currentStateForEl.name, 'isReadOnly']),
	        metadataDefinitionEntity: this.stateList.getIn([currentStateForEl.name, 'metadataDefinitionEntity'])
	      });
	      var newStateList = this.stateList.set(currentStateForEl.name, newState);
	      this.stateList = newStateList.set('changedItem', currentStateForEl.name);
	
	      // call user reducer and refresh form
	      if (this.reducer !== undefined && typeof this.reducer.onChange === 'function') {
	        var newStateList = this.reducer.onChange(this.stateList);
	        if (!this.stateList.equals(newStateList)) {
	          this.stateList = newStateList;
	          this.refresh();
	        }
	      }
	      // call server side callback
	      if (this.canCallServer()) {
	        this.sendState();
	      }
	    }
	  }, {
	    key: 'canSubmitFormTest',
	    value: function canSubmitFormTest() {
	      return true;
	    }
	
	    /**
	     * @param jQuery.Event event
	     */
	
	  }, {
	    key: 'onSubmitBtnClick',
	    value: function onSubmitBtnClick(event) {
	      if (this.canSubmitFormTest() === true) {
	        event.preventDefault();
	        this.form.trigger('submit');
	      } else {
	        event.preventDefault();
	      }
	    }
	
	    /**
	     * @param jQuery.Event event
	     */
	
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit(event) {
	      if (!Nette.validateForm(document.getElementById(this.formId))) {
	        return false;
	      }
	
	      if (window.FormData !== undefined) // FormData may not exist for IE.
	        {
	          this.requestSingle = $.ajax({
	            type: 'POST',
	            url: this.form.attr('action'),
	            canSubmitForm: this.canSubmit,
	            data: new FormData(document.getElementById(this.formId)),
	            processData: false, // tell jQuery not to process the data
	            contentType: false, // tell jQuery not to set contentType
	            beforeSend: this.onBeforeSend.bind(this),
	            success: this.onSuccess.bind(this),
	            error: this.onError.bind(this),
	            complete: this.onComplete.bind(this),
	            xhr: function xhr(xhr) {
	              var xhr = $.ajaxSettings.xhr();
	              xhr.upload.onprogress = function (evt) {
	
	                if (Date.now() - uploadStarted > 1000) {
	                  var footer = $('#createDocument').find('.modal-footer');
	                  footer.children('.progress-cover').show();
	
	                  if (evt.lengthComputable) {
	                    var value = parseInt(evt.loaded / evt.total * 100, 10);
	                    if (value == 100) {
	                      footer.find('.progress-text').hide();
	                      footer.find('.progress-info').hide();
	                      footer.find('.progress-text-success').show();
	                      footer.find('.progress-bar').css('width', value + '%');
	                    } else {
	                      footer.find('.progress-bar').css('width', value + '%');
	                      footer.find('.progress-bar').css('width', value + '%');
	                      footer.find('.progress-info').text(value + '%');
	                    }
	                  }
	                }
	              };
	              return xhr;
	            }
	          });
	
	          event.preventDefault();
	        } else {
	        waiter_open('large', '.createDocumentControl');
	      }
	    }
	  }, {
	    key: 'onDateTimePickerChange',
	    value: function onDateTimePickerChange(el) {
	      var val = el.val();
	      var name = el.attr('name');
	      var isRequired = false;
	      var label = $('label[for=\'' + $(el).attr('id') + '\']');
	      if (label !== undefined) {
	        isRequired = label.hasClass('isRequired');
	      }
	
	      var currentStateForEl = { name: name, value: val, isRequired: isRequired };
	
	      if (currentStateForEl.name == 'createDocument_newBinnary' || currentStateForEl.name == 'createDocument_newTemplate') {
	        return;
	      }
	
	      // update state
	      var newState = _Immutable2.default.Map({
	        nameMeta: currentStateForEl.name,
	        value: currentStateForEl.value,
	        isRequired: currentStateForEl.isRequired,
	        isReadOnly: this.stateList.getIn([currentStateForEl.name, 'isReadOnly']),
	        metadataDefinitionEntity: this.stateList.getIn([currentStateForEl.name, 'metadataDefinitionEntity'])
	      });
	      var newStateList = this.stateList.set(currentStateForEl.name, newState);
	      this.stateList = newStateList.set('changedItem', currentStateForEl.name);
	
	      // call user reducer and refresh form
	      if (this.reducer !== undefined && typeof this.reducer.onChange === 'function') {
	        var newStateList = this.reducer.onChange(this.stateList);
	        if (!this.stateList.equals(newStateList)) {
	          this.stateList = newStateList;
	          this.refresh();
	        }
	      }
	
	      // call server side callback
	      if (this.canCallServer()) {
	        this.sendState();
	      }
	    }
	
	    /** Send state ******************************************************************************************************/
	
	    /**
	     * @return void
	     */
	
	  }, {
	    key: 'sendState',
	    value: function sendState() {
	      if (!this.isAjax) {
	        $.ajax({
	          method: 'POST',
	          url: this.changeURL,
	          contentType: 'application/json',
	          data: JSON.stringify({ stateList: this.stateList.toJS() }),
	          beforeSend: this.onBeforeSend.bind(this),
	          success: this.onSuccess.bind(this),
	          error: this.onError.bind(this),
	          complete: this.onComplete.bind(this)
	        });
	      }
	    }
	
	    /**
	     * @param jqXHR
	     * @param setting
	     */
	
	  }, {
	    key: 'onBeforeSend',
	    value: function onBeforeSend() {
	      this.isAjax = true;
	      uploadStarted = Date.now();
	      waiter_open('large', '.createDocumentControl');
	
	      var footer = $('#createDocument').find('.modal-footer');
	      footer.find('.progress-text').show();
	      footer.find('.progress-info').show();
	      footer.find('.progress-text-success').hide();
	    }
	
	    /**
	     * @param payload
	     * @param textStatus
	     * @param jqXHR
	     */
	
	  }, {
	    key: 'onSuccess',
	    value: function onSuccess(payload) {
	      waiter_close();
	
	      if (document.activeElement !== null) {
	        this.focused = document.activeElement.id;
	      } else {
	        this.focused = '';
	      }
	
	      if (payload.snippets) {
	        for (var id in payload.snippets) {
	          $('#' + id).html(payload.snippets[id]);
	        }
	        _fsForms2.default.init();
	      }
	
	      if (payload.redirect) {
	        $('.modal').modal('hide');
	        waiter_open('large');
	        window.location.href = payload.redirect;
	        return false;
	      }
	
	      switch (payload.stateList) {
	        case 'NO_CHANGES':
	          break;
	        case 'ERROR':
	          this.showMessage(payload.msg, 'danger');
	          break;
	        case 'GUI_FORM_SUBMIT_SUCCESS':
	          $(".create-doc-button-close").trigger('click');
	          FSGridSnippet.refreshMainGrid();
	          $("#flashMessages").empty();
	          $("#createDocument .modal-content").empty();
	          flashMessageSuccess(payload.msg);
	          break;
	        default:
	          this.stateList = _Immutable2.default.fromJS(payload.stateList);
	      }
	    }
	
	    /**
	     * @param jqXHR
	     * @param textStatus
	     * @param error
	     */
	
	  }, {
	    key: 'onError',
	    value: function onError() {
	      waiter_close();
	      this.showMessage('HTTP error', 'danger');
	    }
	
	    /**
	     * @return void
	     */
	
	  }, {
	    key: 'onComplete',
	    value: function onComplete() {
	      if (this.focused == 'createDocument' || this.focused == '') {
	        $('#' + this.getIdByName(this.stateList.get('changedItem'))).focus();
	      } else {
	        $('#' + this.focused).focus();
	        $('#' + this.focused).trigger('chosen:activate');
	      }
	      this.isAjax = false;
	      $(".chosen_select_search").each(function () {
	        if ($(this).is('[readonly]')) {
	          $(this).chosen().chosenReadonly(true);
	        }
	      });
	
	      readOnlySelectSearch();
	    }
	
	    /** File input *********************************************************************************************************/
	
	    /**
	     * @param event
	     * @param file
	     */
	
	  }, {
	    key: 'fileLoaded',
	    value: function fileLoaded(event, file) {
	      var file = this.form.find('input[name="createDocument_newBinnary"]')[0].files[0];
	
	      var needRefresh = false;
	
	      if (typeof file == "undefined") {
	        var fileName = '';
	      } else {
	        var fileName = file.name;
	      }
	
	      // fill NAME_DOCU
	      if (this.stateList.has('NAME_DOCU')) {
	        var name_docu = this.form.find('input[name="NAME_DOCU"]').val();
	        if (name_docu == '') {
	          this.stateList = this.stateList.setIn(['NAME_DOCU', 'value'], fileName);
	          needRefresh = true;
	        }
	      }
	
	      // fill CREATED_TS_DOCU
	      if (this.stateList.has('CREATED_TS_DOCU')) {
	        switch (this.datetimeFormat) {
	          case 'm/d/Y H:i:s':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('MM/DD/YYYY HH:mm:ss'));break;
	          case 'm/d/Y H:i':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('MM/DD/YYYY HH:mm'));break;
	          case 'y-m-d H:i:s':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YY-MM-DD HH:mm:ss'));break;
	          case 'y-m-d H:i':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YY-MM-DD HH:mm'));break;
	          case 'Y-m-d H:i:s':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YYYY-MM-DD HH:mm:ss'));break;
	          case 'Y-m-d H:i':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YYYY-MM-DD HH:mm'));break;
	          case 'Y-m-d G:i:s':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YYYY-MM-DD HH:mm:ss'));break;
	          case 'Y-m-d G:i':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YYYY-MM-DD HH:mm'));break;
	          case 'j.n.Y H:i:s':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('D.M.YYYY HH:mm:ss'));break;
	          case 'j.n.Y H:i':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('D.M.YYYY HH:mm'));break;
	          default:
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('DD.MM.YYYY HH:mm:ss'));
	        }
	        needRefresh = true;
	      }
	
	      // refresh
	      if (needRefresh) {
	        this.refresh();
	      }
	    }
	  }, {
	    key: 'fileClear',
	
	
	    /**
	     * @return void
	     */
	    value: function fileClear() {
	      var needRefresh = false;
	
	      // remove NAME_DOCU
	      if (this.stateList.has('NAME_DOCU')) {
	        this.stateList = this.stateList.setIn(['NAME_DOCU', 'value'], '');
	        needRefresh = true;
	      }
	
	      // fill CREATED_TS_DOCU
	      if (this.stateList.has('CREATED_TS_DOCU')) {
	        this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], '');
	        needRefresh = true;
	      }
	
	      // refresh
	      if (needRefresh) {
	        this.refresh();
	      }
	    }
	  }, {
	    key: 'templateChange',
	
	
	    /**
	     * @param event
	     * @param file
	     */
	    value: function templateChange(event, file, tem) {
	      var needRefresh = false;
	      var templateChoose = this.form.find('[id*=createDocument_newTemplate_chosen] .chosen-single');
	      var inputFileName = this.form.find(".insertForm-CreateFile .file-caption-name");
	      var inputFile = this.form.find('.insertForm-CreateFile .file-input');
	
	      if (templateChoose.text() != '---') {
	        //inputFileName.html( templateChoose.html() );
	        inputFile.removeClass('file-input-new');
	
	        // fill NAME_DOCU
	        if (this.stateList.has('NAME_DOCU')) {
	          this.stateList = this.stateList.setIn(['NAME_DOCU', 'value'], templateChoose.text());
	          needRefresh = true;
	        }
	
	        // fill CREATED_TS_DOCU
	        if (this.stateList.has('CREATED_TS_DOCU')) {
	          this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('DD.MM.YYYY HH:mm:ss'));
	          needRefresh = true;
	        }
	      }
	    }
	
	    /**
	     * @param event
	     * @param fileName
	     */
	
	  }, {
	    key: 'fileWithoutInsert',
	    value: function fileWithoutInsert(event) {
	      var needRefresh = false;
	
	      // fill NAME_DOCU
	      if (this.stateList.has('NAME_DOCU')) {
	        var fileNameEl = document.getElementsByName("createDocument_newBinnary_name");
	        if (fileNameEl.length > 0) {
	          var fileName = fileNameEl[0].value;
	        }
	        this.stateList = this.stateList.setIn(['NAME_DOCU', 'value'], fileName);
	        needRefresh = true;
	      }
	
	      // fill CREATED_TS_DOCU
	      if (this.stateList.has('CREATED_TS_DOCU')) {
	        switch (this.datetimeFormat) {
	          case 'm/d/Y H:i:s':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('MM/DD/YYYY HH:mm:ss'));break;
	          case 'm/d/Y H:i':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('MM/DD/YYYY HH:mm'));break;
	          case 'y-m-d H:i:s':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YY-MM-DD HH:mm:ss'));break;
	          case 'y-m-d H:i':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YY-MM-DD HH:mm'));break;
	          case 'Y-m-d H:i:s':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YYYY-MM-DD HH:mm:ss'));break;
	          case 'Y-m-d H:i':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YYYY-MM-DD HH:mm'));break;
	          case 'Y-m-d G:i:s':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YYYY-MM-DD HH:mm:ss'));break;
	          case 'Y-m-d G:i':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YYYY-MM-DD HH:mm'));break;
	          case 'j.n.Y H:i:s':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('D.M.YYYY HH:mm:ss'));break;
	          case 'j.n.Y H:i':
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('D.M.YYYY HH:mm'));break;
	          default:
	            this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('DD.MM.YYYY HH:mm:ss'));
	        }
	        needRefresh = true;
	      }
	
	      // refresh
	      if (needRefresh) {
	        this.refresh();
	      }
	    }
	
	    /** Helpers *********************************************************************************************************/
	    /**
	     * Update the form to the current status.
	     * @return void
	     */
	
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      var _this2 = this;
	
	      this.form.find(':input').each(function (index) {
	        var input = $(_this2.form[0][index]);
	        var label = $('label[for=\'' + $(input).attr('id') + '\']');
	        var name = input.attr('name');
	        if (name != 'BIN_ID_SFLF_DCOM') {
	          if (_this2.stateList.has(name)) {
	            var isRequired = _this2.stateList.getIn([name, 'isRequired']);
	            var isReadOnly = _this2.stateList.getIn([name, 'isReadOnly']);
	            var value = _this2.stateList.getIn([name, 'value']);
	
	            if (isReadOnly == true) {
	              input.addClass('not-active', true);
	            } else {
	              input.removeClass('not-active', true);
	            }
	
	            input.attr('readonly', isReadOnly);
	            input.prop('readonly', isReadOnly);
	
	            input.val(value);
	            if (isRequired) {
	              label.addClass('isRequired');
	            } else {
	              label.removeClass('isRequired');
	            }
	          }
	        }
	      });
	    }
	
	    /**
	     * @param String msg
	     * @param String type
	     */
	
	  }, {
	    key: 'showMessage',
	    value: function showMessage(msg, type) {
	      var alert = '<div class="alert alert-' + type + ' alert-dismissible" role="alert"><button type="button" class="close" data-dismiss="alert"><span>&times;</span></button>' + msg + '</div>';
	      if ($('#' + this.formId + ' .alert').length > 0) {
	        $('#' + this.formId + ' .alert').remove();
	      }
	      $('#' + this.formId).prepend(alert);
	    }
	
	    /**
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'canCallServer',
	    value: function canCallServer() {
	
	      if (this.reducer !== undefined && typeof this.reducer.canCallPHP === 'function') {
	        return this.reducer.canCallPHP(this.stateList);
	      }
	
	      if (['ID_STAT_DOCU', 'ID_CLAS_DOCU', 'ID_RANK_DOCU', 'FILE_MARK_DOCU', 'ID_CERT_DOCU', 'ID_SKART_REZIM_DOCU'].indexOf(this.stateList.get('changedItem')) != -1) {
	        return true;
	      }
	
	      return false;
	    }
	
	    /**
	     * @param String name
	     * @return String
	     */
	
	  }, {
	    key: 'getIdByName',
	    value: function getIdByName(name) {
	      return this.form.find(':input[name="' + name + '"]').attr('id');
	    }
	  }]);
	
	  return CreateDocumentControl;
	}(_BaseControl3.default);
	
	exports.default = CreateDocumentControl;
	;

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BaseControl = function () {
	  function BaseControl() {
	    _classCallCheck(this, BaseControl);
	  }
	
	  _createClass(BaseControl, [{
	    key: 'getCurrentStateForEl',
	
	
	    /**
	     * @param jQuery el
	     * @return Object {name: String, value: String}
	     */
	    value: function getCurrentStateForEl(el) {
	      var _el = el.find('.fs-date-picker, .fs-dateTime-picker');
	      if (_el.length != 0) {
	        el = _el;
	      }
	
	      var val = el.val();
	      var name = el.attr('name');
	      var isRequired = false;
	      var label = $('label[for=\'' + $(el).attr('id') + '\']');
	
	      if (label !== undefined) {
	        isRequired = label.hasClass('isRequired');
	      }
	
	      return { name: name, value: val, isRequired: isRequired };
	    }
	  }]);
	
	  return BaseControl;
	}();
	
	exports.default = BaseControl;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseControl2 = __webpack_require__(166);
	
	var _BaseControl3 = _interopRequireDefault(_BaseControl2);
	
	var _fsForms = __webpack_require__(143);
	
	var _fsForms2 = _interopRequireDefault(_fsForms);
	
	var _Immutable = __webpack_require__(164);
	
	var _Immutable2 = _interopRequireDefault(_Immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var submitBtnId;
	var uploadStarted;
	
	/**
	 * @author Pavel Homolka
	 */
	
	var SingleEditDocumentControl = function (_BaseControl) {
	  _inherits(SingleEditDocumentControl, _BaseControl);
	
	  /** Construct and init **********************************************************************************************/
	
	  /** @type Object */
	
	
	  /** @type bool */
	
	
	  /** @type String */
	
	
	  /** @type String */
	
	
	  /** @type String */
	
	
	  /** @type String */
	  function SingleEditDocumentControl(formId, changeURL, jsClass, stateList, userLanguage, submitBtnId, initialCaption, submitBtnLabel) {
	    _classCallCheck(this, SingleEditDocumentControl);
	
	    var _this = _possibleConstructorReturn(this, (SingleEditDocumentControl.__proto__ || Object.getPrototypeOf(SingleEditDocumentControl)).call(this));
	
	    _this.changeItem = null;
	    _this.isAjax = false;
	
	    _this.formId = formId;
	    _this.changeURL = changeURL;
	    _this.jsClass = jsClass;
	    _this.stateList = stateList;
	    _this.userLanguage = userLanguage;
	    _this.submitBtnId = submitBtnId;
	    _this.initialCaption = initialCaption;
	    _this.submitBtnLabel = submitBtnLabel;
	    return _this;
	  }
	
	  /**
	   * @return void
	   */
	
	
	  /** @type String */
	
	
	  /** @type jQuery */
	
	
	  /** @type Immutable::Map*/
	
	
	  /** @type String */
	
	
	  /** @type String */
	
	
	  /** @type String */
	
	  /** @type String */
	
	
	  _createClass(SingleEditDocumentControl, [{
	    key: 'init',
	    value: function init() {
	      // handlers for form
	      this.form = $('#' + this.formId);
	      this.form.change(this.onChange.bind(this));
	      this.form.submit(this.onSubmit.bind(this));
	
	      readOnlySelectSearch();
	      readOnlyDateTime();
	
	      // call method for detect relations count
	      if (typeof refreshInfoRelationsCount == 'function') {
	        refreshInfoRelationsCount();
	      }
	
	      // handle for submit button
	      $('#' + this.submitBtnId).click(this.onSubmitBtnClick.bind(this));
	
	      // init bootstrap file input
	      //var fileInput = this.form.find('input[name="editForm_newVersion"]');
	      //fileInput.fileinput({ language: this.userLanguage, initialCaption: this.initialCaption });
	      //fileInput.on('fileloaded', this.fileLoaded.bind(this));
	      //fileInput.on('fileclear', this.fileClear.bind(this));
	
	      var fileInput = this.form.find('input[name="editForm_newVersion"]');
	      fileInput.on('change', this.fileLoaded.bind(this));
	
	      var dropzone_file_remover = this.form.find('.dropzone_file_remover').first();
	      dropzone_file_remover.on('click', this.fileClear.bind(this));
	
	      var fileInputNote = $('.note_upload_button');
	      fileInputNote.fileinput({ language: this.userLanguage });
	
	      // init bootstrap templates input
	      var templateSelect = $('.editForm-TemplatesModal-select');
	      var templateInput = this.form.find('[id*=editDocument_newTemplate]');
	      templateSelect.on('click', this.templateChange.bind(this, templateInput));
	
	      // create JS reducer
	      if (window[this.jsClass] != undefined) {
	        this.reducer = _extends({}, window[this.jsClass]);
	
	        // call Reducer::init
	        if (typeof this.reducer.init === 'function') {
	          this.reducer.init(this, this.stateList);
	        }
	      }
	    }
	
	    /** Handles *********************************************************************************************************/
	
	    /**
	     * @param jQuery.Event event
	     */
	
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      var currentStateForEl = this.getCurrentStateForEl($(event.target));
	
	      // skip onChange for <input type="file">
	      if (currentStateForEl.name == 'editForm_newVersion') {
	        return;
	      }
	
	      // update state
	      var newState = _Immutable2.default.Map({
	        nameMeta: currentStateForEl.name,
	        value: currentStateForEl.value,
	        isRequired: currentStateForEl.isRequired,
	        isReadOnly: this.stateList.getIn([currentStateForEl.name, 'isReadOnly']),
	        metadataDefinitionEntity: this.stateList.getIn([currentStateForEl.name, 'metadataDefinitionEntity'])
	      });
	      var newStateList = this.stateList.set(currentStateForEl.name, newState);
	      this.stateList = newStateList.set('changedItem', currentStateForEl.name);
	
	      // call user reducer and refresh form
	      if (this.reducer !== undefined && typeof this.reducer.onChange === 'function') {
	        var newStateList = this.reducer.onChange(this.stateList);
	        if (!this.stateList.equals(newStateList)) {
	          this.stateList = newStateList;
	          this.refresh();
	        }
	      }
	
	      // call server side callback
	      if (this.canCallServer()) {
	        this.sendState();
	      }
	    }
	  }, {
	    key: 'canSubmitFormTest',
	    value: function canSubmitFormTest() {
	      return true;
	    }
	
	    /**
	     * @param jQuery.Event event
	     */
	
	  }, {
	    key: 'onSubmitBtnClick',
	    value: function onSubmitBtnClick(event) {
	      if (this.canSubmitFormTest() === true) {
	        this.form.trigger('submit');
	      } else {
	        event.preventDefault();
	      }
	    }
	
	    /**
	     * @param jQuery.Event event
	     */
	
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit(event) {
	      if (!Nette.validateForm(document.getElementById(this.formId))) {
	        return false;
	      }
	
	      if (window.FormData !== undefined) // FormData may not exist for IE.
	        {
	          this.requestSingle = $.ajax({
	            type: 'POST',
	            url: this.form.attr('action'),
	            canSubmitForm: this.canSubmit,
	            data: new FormData(document.getElementById(this.formId)),
	            processData: false, // tell jQuery not to process the data
	            contentType: false, // tell jQuery not to set contentType
	            beforeSend: this.onBeforeSend.bind(this),
	            success: this.onSuccess.bind(this),
	            error: this.onError.bind(this),
	            complete: this.onComplete.bind(this),
	            xhr: function xhr(xhr) {
	              var xhr = $.ajaxSettings.xhr();
	              xhr.upload.onprogress = function (evt) {
	
	                if (Date.now() - uploadStarted > 1000) {
	
	                  var footer = $('#' + submitBtnId).parent();
	
	                  footer.children('.progress-cover').show();
	
	                  if (evt.lengthComputable) {
	                    var value = parseInt(evt.loaded / evt.total * 100, 10);
	
	                    if (value == 100) {
	                      footer.find('.progress-text').hide();
	                      footer.find('.progress-info').hide();
	                      footer.find('.progress-text-success').show();
	                      footer.find('.progress-bar').css('width', value + '%');
	                    } else {
	                      footer.find('.progress-bar').css('width', value + '%');
	                      footer.find('.progress-bar').css('width', value + '%');
	                      footer.find('.progress-info').text(value + '%');
	                    }
	                  }
	                }
	              };
	              return xhr;
	            }
	          });
	
	          event.preventDefault();
	        } else {
	        this.showSpin();
	      }
	    }
	
	    /** Send state ******************************************************************************************************/
	
	    /**
	     * @return void
	     */
	
	  }, {
	    key: 'sendState',
	    value: function sendState() {
	      if (!this.isAjax) {
	        $.ajax({
	          method: 'POST',
	          url: this.changeURL,
	          contentType: 'application/json',
	          data: JSON.stringify({ stateList: this.stateList.toJS() }),
	          beforeSend: this.onBeforeSend.bind(this),
	          success: this.onSuccess.bind(this),
	          error: this.onError.bind(this),
	          complete: this.onComplete.bind(this)
	        });
	      }
	    }
	
	    /**
	     * @param jqXHR
	     * @param setting
	     */
	
	  }, {
	    key: 'onBeforeSend',
	    value: function onBeforeSend() {
	      this.isAjax = true;
	      this.showSpin();
	      uploadStarted = Date.now();
	      submitBtnId = this.submitBtnId;
	
	      var footer = $('#' + this.submitBtnId).parent();
	      footer.find('.progress-text').show();
	      footer.find('.progress-info').show();
	      footer.find('.progress-text-success').hide();
	    }
	
	    /**
	     * @param payload
	     * @param textStatus
	     * @param jqXHR
	     */
	
	  }, {
	    key: 'onSuccess',
	    value: function onSuccess(payload) {
	      this.hideSpin();
	      waiter_close();
	
	      if (document.activeElement !== null) {
	        this.focused = document.activeElement.id;
	      } else {
	        this.focused = '';
	      }
	
	      if (payload.snippets) {
	        for (var id in payload.snippets) {
	          $('#' + id).html(payload.snippets[id]);
	        }
	        _fsForms2.default.init();
	      }
	
	      if (payload.redirect) {
	        $('.modal').modal('hide');
	        waiter_open('large');
	        window.location.href = payload.redirect;
	        return false;
	      }
	
	      switch (payload.stateList) {
	        case 'NO_CHANGES':
	          break;
	        case 'ERROR':
	          this.showMessage(payload.msg, 'danger');
	          break;
	        case 'MESSAGE':
	          this.showMessage(payload.msg, 'info');
	          break;
	        case 'GUI_FORM_SUBMIT_SUCCESS':
	          $(".document_edit_form_button_close").trigger('click');
	          FSGridSnippet.refreshMainGrid();
	          $("#flashMessages").empty();
	          flashMessageSuccess(payload.msg);
	          break;
	        case 'DASHBOARD_REFRESH':
	          $(".document_edit_form_button_close").trigger('click');
	          $('#' + payload.key).trigger('click');
	          $("#flashMessages").empty();
	          flashMessageSuccess(payload.msg);
	          break;
	        default:
	          this.stateList = _Immutable2.default.fromJS(payload.stateList);
	      }
	
	      //this.hideSpin();
	    }
	
	    /**
	     * @param jqXHR
	     * @param textStatus
	     * @param error
	     */
	
	  }, {
	    key: 'onError',
	    value: function onError() {
	      this.hideSpin();
	      this.showMessage('HTTP error', 'danger');
	    }
	
	    /**
	     * @return void
	     */
	
	  }, {
	    key: 'onComplete',
	    value: function onComplete() {
	      $('#' + this.submitBtnId).parent().children('.progress-cover').hide();
	
	      try {
	        var index_of_grid = this.focused.indexOf("grid");
	      } catch (err) {
	        var index_of_grid = -1;
	      }
	
	      if (index_of_grid >= 0 || this.focused == '') {
	        $('#' + this.getIdByName(this.stateList.get('changedItem'))).focus();
	      } else {
	        $('#' + this.focused).focus();
	      }
	
	      this.isAjax = false;
	
	      readOnlySelectSearch();
	
	      if ($("#iframe_wrapper").is(':visible') == true) {
	        runResizable();
	        $(".document_edit_row").addClass("changer_row_xs");
	        $(".document_edit_row_first").addClass("changer_row_main_xs");
	      }
	    }
	
	    /** File input *********************************************************************************************************/
	
	    /**
	     * @param event
	     * @param file
	     */
	
	  }, {
	    key: 'fileLoaded',
	    value: function fileLoaded(event, file) {
	      var file = this.form.find('input[name="editForm_newVersion"]')[0].files[0];
	
	      if (typeof file == "undefined") {
	        var fileName = '';
	      } else {
	        var fileName = file.name;
	      }
	
	      var nameDocu = this.form.find('input[name="NAME_DOCU"]');
	      if (nameDocu.length == 1) {
	        nameDocu.val(fileName);
	      }
	      $('#' + this.submitBtnId).text(this.initialCaption);
	    }
	  }, {
	    key: 'fileClear',
	
	
	    /**
	     * @return void
	     */
	    value: function fileClear() {
	      var nameDocu = this.form.find('input[name="NAME_DOCU"]');
	      if (nameDocu.length == 1) {
	        nameDocu.val('');
	      }
	      $('#' + this.submitBtnId).text(this.submitBtnLabel);
	    }
	  }, {
	    key: 'templateChange',
	
	
	    /**
	     * @param event
	     * @param file
	     */
	    value: function templateChange(event, file, tem) {
	
	      var needRefresh = false;
	      var templateChoose = this.form.find('[id*=editDocument_newTemplate_chosen] .chosen-single');
	      var inputFileName = this.form.find(".editForm-EditFile .file-caption-name");
	      var inputFile = this.form.find('.editForm-EditFile .file-input');
	
	      if (templateChoose.text() != '---') {
	        //inputFileName.html( templateChoose.html() );
	        inputFile.removeClass('file-input-new');
	
	        // fill NAME_DOCU
	        if (this.stateList.has('NAME_DOCU')) {
	          this.stateList = this.stateList.setIn(['NAME_DOCU', 'value'], templateChoose.text());
	          needRefresh = true;
	        }
	
	        /*
	         // refresh
	         if(needRefresh)
	         {
	         this.refresh();
	         }*/
	      }
	    }
	
	    /** Helpers *********************************************************************************************************/
	    /**
	     * Update the form to the current status.
	     * @return void
	     */
	
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      var _this2 = this;
	
	      this.form.find(':input').each(function (index) {
	        var input = $(_this2.form[0][index]);
	        var label = $('label[for=\'' + $(input).attr('id') + '\']');
	        var name = input.attr('name');
	
	        if (_this2.stateList.has(name)) {
	          var isRequired = _this2.stateList.getIn([name, 'isRequired']);
	          var isReadOnly = _this2.stateList.getIn([name, 'isReadOnly']);
	          var value = _this2.stateList.getIn([name, 'value']);
	
	          if (isReadOnly == true) {
	            input.addClass('not-active', true);
	          } else {
	            input.removeClass('not-active', true);
	          }
	
	          input.attr('readonly', isReadOnly);
	          input.prop('readonly', isReadOnly);
	
	          input.val(value);
	          if (isRequired) {
	            label.addClass('isRequired');
	          } else {
	            label.removeClass('isRequired');
	          }
	        }
	      });
	    }
	
	    /**
	     * @param String msg
	     * @param String type
	     */
	
	  }, {
	    key: 'showMessage',
	    value: function showMessage(msg, type) {
	      var alert = '<div class="alert alert-' + type + ' alert-dismissible" role="alert"><button type="button" class="close" data-dismiss="alert"><span>&times;</span></button>' + msg + '</div>';
	      if ($('#' + this.formId + ' .alert').length > 0) {
	        $('#' + this.formId + ' .alert').remove();
	      }
	      $('#' + this.formId).prepend(alert);
	    }
	
	    /**
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'canCallServer',
	    value: function canCallServer() {
	      if (this.reducer !== undefined && typeof this.reducer.canCallPHP === 'function') {
	        return this.reducer.canCallPHP(this.stateList);
	      }
	
	      if (['ID_STAT_DOCU', 'ID_CLAS_DOCU', 'ID_RANK_DOCU', 'FILE_MARK_DOCU', 'ID_CERT_DOCU', 'ID_SKART_REZIM_DOCU'].indexOf(this.stateList.get('changedItem')) != -1) {
	        return true;
	      }
	
	      return false;
	    }
	
	    /**
	     * @param String name
	     * @return String
	     */
	
	  }, {
	    key: 'getIdByName',
	    value: function getIdByName(name) {
	      return this.form.find(':input[name="' + name + '"]').attr('id');
	    }
	
	    /**
	     * @return void
	     */
	
	  }, {
	    key: 'showSpin',
	    value: function showSpin() {
	      //$(`#${this.formId}`).parent().spin();
	
	      waiter_open('large', '#editFormParent');
	      $('#' + this.formId).css('opacity', '0.5');
	    }
	
	    /**
	     * @return void
	     */
	
	  }, {
	    key: 'hideSpin',
	    value: function hideSpin() {
	      //$(`#${this.formId}`).parent().spin(false);
	      waiter_close();
	      $('#' + this.formId).css('opacity', '1');
	    }
	  }]);
	
	  return SingleEditDocumentControl;
	}(_BaseControl3.default);
	
	exports.default = SingleEditDocumentControl;
	;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseControl2 = __webpack_require__(166);
	
	var _BaseControl3 = _interopRequireDefault(_BaseControl2);
	
	var _fsForms = __webpack_require__(143);
	
	var _fsForms2 = _interopRequireDefault(_fsForms);
	
	var _Immutable = __webpack_require__(164);
	
	var _Immutable2 = _interopRequireDefault(_Immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @author Pavel Homolka
	 */
	var BulkEditDocumentsControl = function (_BaseControl) {
	  _inherits(BulkEditDocumentsControl, _BaseControl);
	
	  /** Construct and init **********************************************************************************************/
	
	  /** @type int 0 - simple form; 1 - advanced form */
	
	
	  /** @type jQuery */
	
	
	  /** @type bool */
	
	
	  /** @type String */
	
	
	  /** @type String */
	  function BulkEditDocumentsControl(simpleEditFormId, advancedEditFormId, changeURL, jsClass, stateList) {
	    _classCallCheck(this, BulkEditDocumentsControl);
	
	    var _this = _possibleConstructorReturn(this, (BulkEditDocumentsControl.__proto__ || Object.getPrototypeOf(BulkEditDocumentsControl)).call(this));
	
	    _this.isAjax = false;
	
	    _this.simpleEditFormId = simpleEditFormId;
	    _this.changeURL = changeURL;
	    _this.jsClass = jsClass;
	    _this.stateList = stateList;
	    if (advancedEditFormId == undefined) {
	      _this.advancedEditFormId = null;
	    } else {
	      _this.advancedEditFormId = advancedEditFormId;
	    }
	    return _this;
	  }
	
	  /**
	   * @return void
	   */
	
	
	  /** @type String */
	
	
	  /** @type Object */
	
	
	  /** @type jQuery */
	
	
	  /** @type Immutable::Map*/
	
	
	  /** @type String */
	
	  /** @type String */
	
	
	  _createClass(BulkEditDocumentsControl, [{
	    key: 'init',
	    value: function init() {
	      $.nette.load();
	      _fsForms2.default.init();
	      readOnlySelectSearch();
	      readOnlyDateTime();
	
	      this.simpleEditForm = $('#' + this.simpleEditFormId);
	      this.advancedEditForm = $('#' + this.advancedEditFormId);
	
	      // handlers for simple edit form
	      this.simpleEditForm.change(function (event) {
	        this.activeForm = 0;
	        this.onChange(event);
	      }.bind(this));
	      this.simpleEditForm.submit(function (event) {
	        this.activeForm = 0;
	        this.onSubmit(event);
	      }.bind(this));
	
	      // handlers for advanced edit form
	      this.advancedEditForm.change(function (event) {
	        this.activeForm = 1;
	        this.onChange(event);
	      }.bind(this));
	      this.advancedEditForm.submit(function (event) {
	        this.activeForm = 1;
	        this.onSubmit(event);
	      }.bind(this));
	
	      // create JS reducer
	      if (window[this.jsClass] != undefined) {
	        this.reducer = _extends({}, window[this.jsClass]);
	
	        // call Reducer::init
	        if (typeof this.reducer.init === 'function') {
	          this.reducer.init(this, this.stateList);
	        }
	      }
	    }
	
	    /** Handles *********************************************************************************************************/
	
	    /**
	     * @param jQuery.Event event
	     */
	
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      var currentStateForEl = this.getCurrentStateForEl($(event.target));
	
	      // update state
	      var newState = _Immutable2.default.Map({
	        nameMeta: currentStateForEl.name,
	        value: currentStateForEl.value,
	        isRequired: currentStateForEl.isRequired,
	        isReadOnly: this.stateList.getIn([currentStateForEl.name, 'isReadOnly']),
	        metadataDefinitionEntity: this.stateList.getIn([currentStateForEl.name, 'metadataDefinitionEntity'])
	      });
	      var newStateList = this.stateList.set(currentStateForEl.name, newState);
	      this.stateList = newStateList.set('changedItem', currentStateForEl.name);
	
	      // call user reducer and refresh form
	      if (this.reducer !== undefined && typeof this.reducer.onChange === 'function') {
	        var newStateList = this.reducer.onChange(this.stateList);
	        if (!this.stateList.equals(newStateList)) {
	          this.stateList = newStateList;
	          this.refresh();
	        }
	      }
	
	      // call server side callback
	      if (this.canCallServer()) {
	        this.sendState();
	      }
	    }
	  }, {
	    key: 'canSubmitFormTest',
	    value: function canSubmitFormTest() {
	      return true;
	    }
	
	    /**
	     * @param jQuery.Event event
	     */
	
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit(event) {
	      event.preventDefault();
	
	      if (this.canSubmitFormTest() == true) {
	        if (this.activeForm == 0) {
	          var form = this.simpleEditForm;
	          var form_id = this.simpleEditFormId;
	          if (!Nette.validateForm(document.getElementById(this.simpleEditFormId))) {
	            return false;
	          }
	        } else {
	          var form = this.advancedEditForm;
	          var form_id = this.advancedEditFormId;
	          if (!Nette.validateForm(document.getElementById(this.advancedEditFormId))) {
	            return false;
	          }
	        }
	
	        $.ajax({
	          type: 'POST',
	          url: form.attr('action'),
	          data: new FormData(document.getElementById(form_id)), //form.serialize(),
	          processData: false, // tell jQuery not to process the data, protože jsem nahradil form.serialize
	          contentType: false, // tell jQuery not to set contentType, protože jsem nahradil form.serialize
	          beforeSend: this.onBeforeSend.bind(this),
	          success: this.onSuccess.bind(this),
	          error: this.onError.bind(this),
	          complete: this.onComplete.bind(this)
	        });
	
	        event.preventDefault();
	      }
	    }
	
	    /** Send state ******************************************************************************************************/
	
	    /**
	     * @return void
	     */
	
	  }, {
	    key: 'sendState',
	    value: function sendState() {
	      if (!this.isAjax) {
	        $.ajax({
	          method: 'POST',
	          url: this.changeURL,
	          contentType: 'application/json',
	          data: JSON.stringify({ stateList: this.stateList.toJS() }),
	          beforeSend: this.onBeforeSend.bind(this),
	          success: this.onSuccess.bind(this),
	          error: this.onError.bind(this),
	          complete: this.onComplete.bind(this)
	        });
	      }
	    }
	
	    /**
	     * @param jqXHR
	     * @param setting
	     */
	
	  }, {
	    key: 'onBeforeSend',
	    value: function onBeforeSend() {
	      this.isAjax = true;
	      this.showSpin();
	    }
	
	    /**
	     * @param payload
	     * @param textStatus
	     * @param jqXHR
	     */
	
	  }, {
	    key: 'onSuccess',
	    value: function onSuccess(payload) {
	      this.hideSpin();
	      waiter_close();
	
	      if (document.activeElement !== null) {
	        this.focused = document.activeElement.id;
	      } else {
	        this.focused = '';
	      }
	
	      if (payload.snippets) {
	        for (var id in payload.snippets) {
	          $('#' + id).html(payload.snippets[id]);
	        }
	        _fsForms2.default.init();
	      }
	
	      if (payload.redirect) {
	        window.location.href = payload.redirect;
	        return false;
	      }
	
	      switch (payload.stateList) {
	        case 'NO_CHANGES':
	          break;
	        case 'ERROR':
	          this.showMessage(payload.msg, 'danger');
	          break;
	        case 'MESSAGE':
	          this.showMessage(payload.msg, 'info');
	          break;
	        default:
	          this.stateList = _Immutable2.default.fromJS(payload.stateList);
	      }
	
	      //this.hideSpin();
	    }
	
	    /**
	     * @param jqXHR
	     * @param textStatus
	     * @param error
	     */
	
	  }, {
	    key: 'onError',
	    value: function onError() {
	      this.hideSpin();
	      this.showMessage('HTTP error', 'danger');
	    }
	
	    /**
	     * @return void
	     */
	
	  }, {
	    key: 'onComplete',
	    value: function onComplete() {
	      if (this.activeForm == 0) {
	        if (this.focused == '') {
	          $('#' + this.getIdByNameForSimpleForm(this.stateList.get('changedItem'))).focus();
	        } else {
	          $('#' + this.focused).focus();
	          $('#' + this.focused).trigger('chosen:activate');
	        }
	      } else {
	        $('#' + this.getIdByNameForAdvancedForm(this.stateList.get('changedItem'))).focus();
	      }
	
	      this.isAjax = false;
	
	      readOnlySelectSearch();
	    }
	
	    /** Helpers *********************************************************************************************************/
	    /**
	     * Update the form to the current status.
	     * @return void
	     */
	
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      var _this2 = this;
	
	      if (this.activeForm == 0) {
	        var form = this.simpleEditForm;
	      } else {
	        var form = this.advancedEditForm;
	      }
	
	      form.find(':input').each(function (index) {
	        var input = $(form[0][index]);
	        var label = $('label[for=\'' + $(input).attr('id') + '\']');
	        var name = input.attr('name');
	
	        if (_this2.stateList.has(name)) {
	          var isRequired = _this2.stateList.getIn([name, 'isRequired']);
	          var isReadOnly = _this2.stateList.getIn([name, 'isReadOnly']);
	          var value = _this2.stateList.getIn([name, 'value']);
	
	          if (isReadOnly == true) {
	            input.addClass('not-active', true);
	          } else {
	            input.removeClass('not-active', true);
	          }
	
	          input.attr('readonly', isReadOnly);
	          input.prop('readonly', isReadOnly);
	
	          input.val(value);
	          if (isRequired) {
	            label.addClass('isRequired');
	          } else {
	            label.removeClass('isRequired');
	          }
	        }
	      });
	    }
	
	    /**
	     * @param String msg
	     * @param String type
	     */
	
	  }, {
	    key: 'showMessage',
	    value: function showMessage(msg, type) {
	      if (this.activeForm == 0) {
	        var formId = this.simpleEditFormId;
	      } else {
	        var formId = 'advancedEditFormModalBody';
	      }
	
	      var alert = '<div class="alert alert-' + type + ' alert-dismissible" role="alert"><button type="button" class="close" data-dismiss="alert"><span>&times;</span></button>' + msg + '</div>';
	      if ($('#' + formId + ' .alert').length > 0) {
	        $('#' + formId + ' .alert').remove();
	      }
	      $('#' + formId).prepend(alert);
	    }
	
	    /**
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'canCallServer',
	    value: function canCallServer() {
	      if (this.reducer !== undefined && typeof this.reducer.canCallPHP === 'function') {
	        return this.reducer.canCallPHP(this.stateList);
	      }
	
	      if (['ID_STAT_DOCU', 'ID_CLAS_DOCU', 'ID_RANK_DOCU', 'FILE_MARK_DOCU', 'ID_CERT_DOCU', 'ID_SKART_REZIM_DOCU'].indexOf(this.stateList.get('changedItem')) != -1) {
	        return true;
	      }
	
	      return false;
	    }
	
	    /**
	     * @param String name
	     * @return String
	     */
	
	  }, {
	    key: 'getIdByNameForSimpleForm',
	    value: function getIdByNameForSimpleForm(name) {
	      return this.simpleEditForm.find(':input[name="' + name + '"]').attr('id');
	    }
	
	    /**
	     * @param String name
	     * @return String
	     */
	
	  }, {
	    key: 'getIdByNameForAdvancedForm',
	    value: function getIdByNameForAdvancedForm(name) {
	      return this.advancedEditForm.find(':input[name="' + name + '"]').attr('id');
	    }
	
	    /**
	     * @return void
	     */
	
	  }, {
	    key: 'showSpin',
	    value: function showSpin() {
	      if (this.activeForm == 0) {
	        var formId = this.simpleEditFormId;
	      } else {
	        var formId = 'advancedEditFormModalBody';
	      }
	
	      //$(`#${formId}`).parent().spin();
	
	      var formId_parent = $('#' + formId).parent();
	      var formId_parent_id = formId_parent.attr('id');
	      waiter_open('medium', '#' + formId_parent_id);
	      $('#' + formId).css('opacity', '0.5');
	    }
	
	    /**
	     * @return void
	     */
	
	  }, {
	    key: 'hideSpin',
	    value: function hideSpin() {
	
	      if (this.activeForm == 0) {
	        var formId = this.simpleEditFormId;
	      } else {
	        var formId = 'advancedEditFormModalBody';
	      }
	
	      //$(`#${formId}`).parent().spin(false);
	      waiter_close();
	      $('#' + formId).css('opacity', '1');
	    }
	  }]);
	
	  return BulkEditDocumentsControl;
	}(_BaseControl3.default);
	
	exports.default = BulkEditDocumentsControl;
	;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// 3a3345c4f5524ddfec9e.js